var chunk_917ae4714aa9022b89af =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 284);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(20);
__webpack_require__(33);

angular.module('app.currentUser', ['app.appKey', 'app.currentUser.clearSessionService']).factory('currentUser', ['$http', '$rootScope', 'appKey', 'app.currentUser.clearSessionService', '$q', '$state', '$cookies', 'PRODUCT', 'ENVIRONMENT', function ($http, $rootScope, appKey, clearSession, $q, $state, $cookies, PRODUCT, ENVIRONMENT) {
  var user = {
    data_default: {
      iuserid: null,
      first_name: null,
      last_name: null,
      username: null,
      login_name: null,
      is_admin: null,
      country: null,
      billing_error: null,
      syndication_id: null
    },
    data: {},
    last_updated_session: null,
    subscriptions: {
      recurly: [],
      roku: null,
      invalidConversions: []
    },
    subscription_err: null,
    jwt: null,

    logSessionActivity: function logSessionActivity(gameId) {
      return $http.post(window.location.api('/sessions/apikey_activity'), { 'gameId': gameId }).catch(function () {
        deferred.reject({ error: "Failed to log api activity." });
      });;
    },
    set_data: function set_data(data, callback) {
      if (data && data.iuserid) {
        user.data = data;
      } else {
        user.data = angular.copy(user.data_default);
        user.subscriptions.recurly = null;
        user.accessPasses = null;
      }

      user.data.mob = user.data.mob ? moment(user.data.mob + '-01').toDate() : user.data.mob;

      if (Array.isArray(user.data.subscriptions) && user.data.subscriptions.length) {
        _.forEach(user.data.subscriptions, function (subscription) {
          if (subscription.IsActive) {
            if (subscription.PlanType == "recurly") {
              if (!Array.isArray(user.subscriptions.recurly)) {
                user.subscriptions.recurly = [];
              }

              user.subscriptions.recurly.push({
                id: subscription.Id,
                activated_at: subscription.CreatedDate,
                plan_code: subscription.PlanCode,
                plan_type: subscription.PlanType,
                plan_id: subscription.PspId,
                expires_at: subscription.ExpirationDate,
                paused: subscription.IsPaused,
                is_future: subscription.IsFuture,
                is_renewable: subscription.IsRenewable,
                current_period_end_date: subscription.CurrentPeriodEndDate,
                season_id: subscription.SeasonId,
                type: subscription.Type,
                teams: subscription.TypeIds,
                is_active: subscription.IsActive,
                subscription_upgrades: subscription.subscription_upgrades
              });
            } else if (subscription.PlanType == "roku") {
              user.subscriptions.roku = subscription;
            }
          }
        });
      }

      if (Array.isArray(user.data.access_passes) && user.data.access_passes.length) {
        _.forEach(user.data.access_passes, function (accessPass) {
          if (accessPass.enabled) {
            if (!Array.isArray(user.accessPasses)) {
              user.accessPasses = [];
            }

            user.accessPasses.push({
              id: accessPass.id,
              enabled: accessPass.enabled,
              contentName: accessPass.contentName,
              description: accessPass.description,
              endDatetime: accessPass.endDatetime,
              startDatetime: accessPass.startDatetime,
              type: accessPass.type
            });
          }
        });
      }

      if (typeof callback === 'function') {
        callback();
      }
    },
    is_logged_in: function is_logged_in() {
      return !!user.data && !!user.data.iuserid;
    },
    sendRegistrationEmail: function sendRegistrationEmail(login_name) {
      "use strict";

      return $http.post(window.location.api('/resend_registration_email'), {
        email: login_name
      });
    },
    login: function login(login_name, password) {
      "use strict";

      var deferred = $q.defer();

      $http.post(window.location.api('sessions/api_key'), {
        email: login_name,
        password: password
      }).then(function (response) {
        var data = response.data;
        user.set_data();
        appKey.destroy();
        clearSession();

        if (response.status === 401) {
          var error = 'Invalid username or password.';
          var errorType = null;
          var email = null;

          if (data) {
            if (data.error) error = data.error;
            if (data.errorType) errorType = data.errorType;
            if (data.email) email = data.email;
          }
          deferred.reject({
            error: error,
            errorType: errorType,
            login_name: email
          });
        } else if (response.status === 403) {
          var _error = 'User account not confirmed.';
          var _errorType = 'email-confirmation';
          var _email = response.data.email;

          deferred.reject({
            error: _error,
            errorType: _errorType,
            login_name: _email
          });
        } else {
          if (data && data.api_key) {
            appKey.set_user_key(data.api_key);
          } else {
            appKey.set_user_key(null);
          }
          user.retrieve().then(function (result) {
            return deferred.resolve(result);
          }).catch(function () {
            deferred.reject({ error: "Failed to retrieve user data." });
          });
        }
      });

      return deferred.promise;
    },
    logout: function logout() {
      user.set_data();
      $cookies.remove('prerolls');
      $cookies.remove('postrolls');
      $cookies.remove('gameid');
      return $http.delete(window.location.api('sessions/apikey_activity')).then(function () {
        "use strict";

        appKey.destroy();
      });
    },
    retrieve: function retrieve() {
      var deferred = $q.defer();

      user.set_data();
      $http.get(window.location.api('sessions')).then(function (response) {
        var data = response.data;
        var status = response.status;

        if (!data || data.error || status !== 200) {

          if (data.error) {
            if (data.error.lock) {
              appKey.destroy();
              $state.go('app.locked', { obj: data.error.lock });
            }
          }

          deferred.reject();
        } else {
          user.set_data(data);

          deferred.resolve(data);
        }
      });
      return deferred.promise;
    },
    update: function update() {
      return $http.get(window.location.api('sessions')).then(function (response) {
        var data = response.data;
        if (data.error) {
          alert(data.error);
        } else {
          user.set_data(data);
          //user.checkUserInfo();

          //$rootScope.$broadcast('current_user_updated');
        }
      });
    },
    retrievePlan: function retrievePlan(name, group) {
      var deferred = $q.defer();
      var resolve_now = true;

      switch (name) {
        case 'current_plan':
          if (user.data && user.subscriptions[group] && user.subscriptions[group].plan_code) {
            resolve_now = false;
            $http.get(window.location.api('subscriptions/plans/' + user.subscriptions[group].plan_code)).then(function (response) {
              var data = response.data;
              if (data.plan) {
                user.subscriptions[group].plan = data.plan;
                $rootScope.$broadcast('current_plan_retrieved', {
                  success: true
                });
              }
              deferred.resolve(data);
            },
            /**
             * @param {HttpResponse} response
             */
            function (response) {
              deferred.reject(response.data);
            });
          } else {
            $rootScope.$broadcast('current_plan_retrieved', {
              success: false
            });
          }
      }

      if (resolve_now) {
        deferred.resolve();
      }

      return deferred.promise;
    },
    get_current_subscriptions: function get_current_subscriptions(group_name) {
      var deferred = $q.defer();
      if (user.is_logged_in()) {
        return $http.get(window.location.api('subscriptions/active/' + group_name)).then(function (response) {
          var data = response.data;

          if (data.error) {
            user.subscription_err = data.error;
            deferred.reject();
          } else if (data.subscriptions) {
            switch (group_name) {
              case "recurly":
                user.subscriptions.recurly = [];

                _.forEach(data.subscriptions, function (subscription) {
                  user.subscriptions.recurly.push({
                    id: subscription.id,
                    activated_at: subscription.activated_at,
                    plan_code: subscription.plan_code,
                    plan_type: group_name,
                    plan_id: subscription.plan.id,
                    expires_at: subscription.expires_at,
                    paused: subscription.paused,
                    is_future: subscription.state === "future",
                    is_renewable: subscription.plan.is_renewable,
                    current_period_end_date: subscription.current_period_ends_at,
                    season_id: subscription.season_id,
                    type: subscription.subscription_type,
                    teams: subscription.teams,
                    is_active: subscription.state === "active",
                    subscription_upgrades: subscription.subscription_upgrades,
                    state: subscription.state,
                    plan: subscription.plan,
                    uuid: subscription.uuid
                  });
                });
                break;
              case "roku":
                break;
            }
            deferred.resolve();
          }
        });
      } else {
        deferred.resolve();
      }
      return deferred.promise;
    },
    get_invalid_conversions: function get_invalid_conversions() {
      var deferred = $q.defer();

      if (user.is_logged_in()) {
        return $http.get(window.location.api('htv2020/subscriptions/invalid_plan_conversions')).then(function (response) {
          var data = response.data;

          if (data) {
            if (data.error) {
              deferred.reject();
            } else {
              user.subscriptions.invalidConversions = data;
              deferred.resolve(data);
            }
          }
        });
      } else {
        deferred.resolve();
      }
      return deferred.promise;
    },
    reset_password: function reset_password(email) {
      return $http.post(window.location.api('sessions/password_reset'), { email: email });
    },
    change_email: function change_email(old_email, new_email, current_password) {
      return $http.post(window.location.api('sessions/change_email_request'), {
        old_email: old_email,
        new_email: new_email,
        current_password: current_password
      });
    },
    save: function save(data) {
      if (user.data && user.data.iuserid) {
        return $http.put(window.location.api('sessions/user/' + user.data.iuserid), {
          user: data
        }).then(function (response) {
          if (!response.data.error && parseInt(response.status) === 200) {
            user.set_data(response.data);
          }
          return response;
        }, function (response) {
          return response;
        });
      } else {
        var _deferred = $q.defer();
        _deferred.reject({ data: { error: 'Missing user data' } });
        return _deferred.promise;
      }
    },
    has_active_subscription: function has_active_subscription() {
      return _.filter(user.subscriptions.recurly, function (sub) {
        return sub.is_active === true && !sub.paused && !sub.is_future;
      }).length > 0;
    },
    hasAccessPass: function hasAccessPass() {
      return _.filter(user.accessPasses, function (pass) {
        return pass.enabled === true;
      }).length > 0;
    },
    has_access: function has_access() {
      return user.data && (user.data.is_admin || user.has_active_subscription() || user.hasAccessPass());
    },
    is_pass_holder: function is_pass_holder() {
      return user.data && user.data.access && user.data.access.length;
    },
    checkUsername: function checkUsername(username) {
      return $http.get(window.location.api('check_username/' + username));
    },
    subscriptionStatus: function subscriptionStatus(subscription) {
      if (user.data) {
        if (user.data.billing_error) {
          return 'billing_error';
        } else {
          return subscription.state;
        }
      }

      return null;
    },
    isAdmin: function isAdmin() {
      return user.data && user.data.is_admin;
    },
    hasAdminFunction: function hasAdminFunction(func_id) {
      if (user.data) {
        switch (func_id) {
          case 5:
            if (user.data.is_admin) {
              return true;
            }
            break;
        }

        if (user.data.access && Array.isArray(user.data.access)) {
          var access = user.data.access;

          for (var i = 0; i < access.length; i++) {
            if (func_id === access[i].iaccessfunctionid_fk) {
              return true;
            }
          }
        }
      }

      return false;
    },
    getFbJwt: function getFbJwt(gameId) {
      "use strict";

      var deferred = $q.defer();

      $http.get(window.location.api('sessions/fbjwt/' + gameId), {}).then(function (response) {
        var data = response.data;
        if (response.status === 401) {
          deferred.reject({
            msg: 'Unable to authenticate for scoreboard control.'
          });
        } else {
          user.jwt = data.jwt;
          deferred.resolve();
        }
      });

      return deferred.promise;
    },
    removeFbJwt: function removeFbJwt() {
      user.jwt = null;
    },
    getId: function getId() {
      "use strict";

      if (!user.data) return null;
      return user.data.iuserid;
    },
    getName: function getName() {
      "use strict";

      if (!user.data) return null;
      return user.data.username || user.data.first_name;
    },
    getEmail: function getEmail() {
      "use strict";

      if (!user.data) return null;
      return user.data.login_name;
    },

    checkUserInfo: function checkUserInfo(redirect) {
      switch (PRODUCT.Code) {
        case 'ahl':
        default:
          return false;
        case 'htv':
          if (!user.data.has_all_acc_info) {
            $state.go('app.accountSettings', angular.isObject(redirect) ? redirect : null);
            return true;
          } else {
            return false;
          }
      }
    },

    serialize_user_data: function serialize_user_data() {
      var userData = angular.equals(user.data, {}) || !user.data ? null : user.data;
      var serialized = null;
      if (angular.isObject(userData)) {
        userData = angular.copy(userData);
        serialized = JSON.stringify(userData);
      }
      return serialized;
    },

    //Note moment uses 0-11 for months.
    //format Year, Month, Day, Hour, Minute

    showFreeview: function showFreeview() {
      var showFreeview = false;
      var currentTime = moment().utc();
      var startDate = void 0;
      var endDate = void 0;
      if (ENVIRONMENT.production) {
        startDate = moment.utc([2024, 0, 23, 18]); //Tue Jan 23, 1:00:00 PM
        endDate = moment.utc([2024, 0, 28, 10]); //Sun Jan 28, 5:00:00 AM
      } else {
        startDate = moment.utc([2024, 0, 1, 18]);
        endDate = moment.utc([2024, 0, 28, 10]);
      }
      if (currentTime.isAfter(startDate) && currentTime.isBefore(endDate)) {
        showFreeview = true;
      }
      return showFreeview;
    },

    showAllStars: function showAllStars() {
      var showAllStars = false;
      var currentTime = moment().utc();
      var startDate = moment.utc([2024, 1, 1, 12]); //Prod - Thu Feb 1, 7:00:00 AM
      var endDate = moment.utc([2024, 1, 6, 10]); //Prod - Tue Feb 6, 5:00:00 AM
      if (currentTime.isAfter(startDate) && currentTime.isBefore(endDate)) {
        showAllStars = true;
      }
      return showAllStars;
    },

    showPromotion: function showPromotion() {
      var showPromotion = false;
      var currentTime = moment().utc();
      //let startDate = moment.utc([2023, 11, 1, 12]); //staging
      var startDate = moment.utc([2023, 11, 13, 12]); //Prod - Wed Dec 13, 7:00:00 AM
      var endDate = moment.utc([2023, 11, 18, 10]); //Prod - Mon Dec 18, 5:00:00 AM
      if (currentTime.isAfter(startDate) && currentTime.isBefore(endDate)) {
        showPromotion = true;
      }
      return showPromotion;
    },

    showBlackFriday: function showBlackFriday() {
      var showBlackFriday = false;
      var currentTime = moment().utc();
      //let startDate = moment.utc([2023, 10, 1, 12]); //show now
      var startDate = moment.utc([2023, 10, 24, 12]); //this for prod Fri Nov 24, 7:00:00 AM
      var endDate = moment.utc([2023, 10, 28, 4, 59, 59]); // Mon Nov 27, 11:59:59 PM EST
      if (currentTime.isAfter(startDate) && currentTime.isBefore(endDate)) {
        showBlackFriday = true;
      }
      return showBlackFriday;
    },

    showSummer: function showSummer() {
      var showSummer = false;
      var currentTime = moment().utc();
      var startDate = moment.utc([2024, 6, 15, 11]); //this for prod Mon July 15, 7:00:00 AM
      //let endDate = moment.utc([2023, 7, 31, 11, 59, 59]); //Thur Aug 31 7:59:59 AM
      if (currentTime.isAfter(startDate)) {
        showSummer = true;
      }
      return showSummer;
    },

    showMidSeason: function showMidSeason() {
      var showMidSeason = false;
      var currentTime = moment().utc();
      var startDate = void 0;
      var endDate = void 0;
      if (ENVIRONMENT.production) {
        startDate = moment.utc([2024, 0, 8, 12]); //this for prod Mon Jan 8, 7:00:00 AM
        endDate = moment.utc([2024, 2, 18, 10, 59, 59]); //Mon Mar 18, 6:59:59 AM
      } else {
        startDate = moment.utc([2024, 0, 8, 12]);
        endDate = moment.utc([2024, 2, 8, 10, 59, 59]);
      }

      if (currentTime.isAfter(startDate) && currentTime.isBefore(endDate)) {
        showMidSeason = true;
      }
      return showMidSeason;
    },

    showFinalPriceDrop: function showFinalPriceDrop() {
      var showFinalPriceDrop = false;
      var currentTime = moment().utc();
      var startDate = void 0;
      var endDate = void 0;
      if (ENVIRONMENT.production) {
        startDate = moment.utc([2024, 2, 18, 11]); //this for prod Mon Mar 18, 7:00:00 AM
        endDate = moment.utc([2024, 3, 22, 10, 59, 59]); //end Mon Apr 22 7:59:59
      } else {
        startDate = moment.utc([2024, 2, 8, 11]);
        endDate = moment.utc([2024, 3, 22, 10, 59, 59]);
      }

      if (currentTime.isAfter(startDate) && currentTime.isBefore(endDate)) {
        showFinalPriceDrop = true;
      }
      return showFinalPriceDrop;
    },

    showPlayoffs: function showPlayoffs() {
      var showPlayoffs = false;
      var currentTime = moment().utc();
      var startDate = void 0;
      if (ENVIRONMENT.production) {
        startDate = moment.utc([2023, 3, 22, 12]); //this for prod Mon Apr 22, 8:00:00 AM
      } else {
        startDate = moment.utc([2024, 3, 16, 12]);
      }
      var endDate = moment.utc([2024, 6, 15, 10, 59, 59]);
      if (currentTime.isAfter(startDate) && currentTime.isBefore(endDate)) {
        showPlayoffs = true;
      }
      return showPlayoffs;
    }

  };
  return user;
}]);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(26);
__webpack_require__(9);
__webpack_require__(12);

angular.module('app.shared.singleGameService', ['app.player', 'app.transformResource', 'app.shared.dataTransformers.clipTransformer']).factory('app.shared.singleGameService', ['$http', '$httpParamSerializerJQLike', '$q', '$rootScope', 'app.transformResource', 'app.shared.dataTransformers.clipTransformer', function ($http, $httpParamSerializerJQLike, $q, $rootScope, transformResource, clipTransformer) {
  "use strict";

  /**
   * @type {SingleGameService}
   */

  var game = {
    data: null,
    clips: [],
    areMoreClips: false,
    error: null,
    clear: function clear() {
      game.data = null;
      game.error = null;
    },
    retrieve: function retrieve(game_id, params) {
      var assign_game = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;


      params = $httpParamSerializerJQLike(params);
      if (game_id) {
        return $http.get(window.location.api('games/' + game_id + '?' + params)).then(
        /**
         * @param {HttpResponse} response
         */
        function (response) {
          /**
           * @type {{game: Game, error: *}}
           */
          if (assign_game) {
            var data = response.data;
            game.data = game.load(data.game, data.error);
          } else {
            return response;
          }
        });
      }
    },
    load: function load(game_obj, error) {
      game.data = game_obj;
      game.error = error;

      $rootScope.$broadcast('singleGameReady');
      return game.data;
    },
    unload: function unload() {
      game.load(null, null);
    },
    copy: function copy(data) {
      var game_copy = void 0;
      game_copy = angular.copy(game);
      if (data) {
        game_copy.load(data);
      }
      return game_copy;
    },
    save_overlay: function save_overlay() {
      "use strict";

      if (game.data && game.data.overlay) {
        $http.put(window.location.api('admin/games/' + game.data.igameid + '/overlay'), {
          overlay: game.data.overlay
        }).then(function (response) {
          var data = response.data;

          if (data.overlay) {
            game.data.overlay = data.overlay;
          }

          if (data.error) {
            game.error = data.error;
          }
        });
      }
    },
    createInstantReplay: function createInstantReplay(clipOffset, categoryId, options) {
      if (!angular.isObject(options)) {
        options = {};
      }
      options.game_offset = game.data.istarttime;
      options.method = game.data.can_edit ? 'editor' : 'player';

      if (categoryId === null) {
        options.clip_name = 'Quick Clip';
      }

      var data = {
        clip_offset: clipOffset,
        category_id: categoryId,
        options: options
      };

      return $http({
        method: 'POST',
        url: window.location.api('games/' + game.data.igameid + '/instant_replay'),
        transformResponse: transformResource.onResponse(clipTransformer.transformToUi),
        data: data
      }).then(function (response) {
        var data = response.data;

        if (data.error) {
          game.error = data.error;
        } else {
          var index = game.clips.findIndex(function (clip) {
            return data.iclipid && data.iclipid === clip.iclipid;
          });

          if (index <= -1) {
            game.clips.push(data);
          }
        }

        return response;
      });
    },
    retrieveClips: function retrieveClips(game_id, options) {
      if (!game_id && game.data) {
        game_id = game.data.igameid;
      }

      var appendResult = false;
      if (options) {
        appendResult = options.appendResult;
        delete options.appendResult;
      }

      var params = $httpParamSerializerJQLike(options);

      return $http({
        method: 'GET',
        url: window.location.api('games/' + game_id + '/clips?' + params),
        transformResponse: transformResource.onResponse(function (data) {
          if (!data.error && Array.isArray(data)) {
            var clips = [];
            _.forEach(data, function (clip) {
              clips.push(clipTransformer.transformToUi(clip));
            });
            return clips;
          }
          return data;
        })
      }).then(function (response) {
        var data = response.data;

        if (data.error) {
          game.error = data.error;
        } else {
          game.areMoreClips = false;
          if (options && options.limit) {
            if (Array.isArray(data) && data.length >= options.limit) {
              game.areMoreClips = true;
            }
          }

          if (appendResult && Array.isArray(game.clips)) {
            game.clips = game.clips.concat(data);
          } else {
            game.clips = data;
          }
        }

        return response;
      });
    },
    getMoreClips: function getMoreClips(options) {
      if (Array.isArray(game.clips)) {
        if (!options) options = {};

        options = Object.assign({}, {
          appendResult: true,
          limit: 250
        }, options);

        options.offset = game.clips.length;

        return game.retrieveClips(null, options);
      }
    },
    logPlayed: function logPlayed(game_id, audio) {
      var deferred = $q.defer();

      _.debounce(function () {
        if (typeof game_id === 'undefined' && game.data) {
          game_id = game.data.igameid;
        }

        $http.post(window.location.api('games/' + game_id + '/played' + (audio ? '/' + audio : ''))).then(function (response) {
          deferred.resolve(response);
        });
      }, 5000)();

      return deferred.promise;
    },
    updatePlayedTime: function updatePlayedTime(watchedGameId) {
      return $http.put(window.location.api('game/mark_end_time/' + watchedGameId));
    },
    getStreamUrl: function getStreamUrl(audio) {
      if (game.data) {
        if (!audio) {
          return $http.get(window.location.api('games/' + game.data.igameid + '/stream_url'));
        } else {
          return $http.get(window.location.api('games/' + game.data.igameid + '/stream_url/' + audio));
        }
      }
    },
    transform: function transform(data) {
      if (data) {
        if (data.overlay) {
          data.overlay.splitText = game.splitOverlayText(data.overlay.stroverlayoverride);
        }
      }

      return data;
    },
    splitOverlayText: function splitOverlayText(txt) {
      var arr = ['', '', ''];
      if (txt) {
        if (txt.match(/;/)) {
          var split = txt.split(';');
          arr = [split[0], split[1], split[2]];
        }
      }
      return arr;
    },
    saveLine: function saveLine(igameid, iteamid, linenumber, data, callback) {

      $http.put(window.location.api('/games/' + igameid + "/lineup/" + iteamid + "/" + linenumber), data).then(function (response) {
        var data = response.data;

        if (typeof callback !== 'undefined' && typeof callback === 'function') {
          callback(data);
        }
      });
    }
  };

  return game;
}]);

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(9);
__webpack_require__(12);
__webpack_require__(8);

'use strict';

angular.module('app.shared.singleClipService', ['app.transformResource', 'app.shared.dataTransformers.clipTransformer', 'app.shared.clipCategoryService']).constant('CLIP_EVENTS', {
  FLAGGED_AS_INAPPROPRIATE: 'flagedAsInappropriate'
}).factory('app.shared.singleClipService', ['$rootScope', '$http', '$q', '$httpParamSerializerJQLike', 'app.transformResource', 'app.shared.dataTransformers.clipTransformer', 'app.shared.clipCategoryService', 'CLIP_EVENTS', function ($rootScope, $http, $q, $httpParamSerializerJQLike, transformResource, clipTransformer, clipCategoryService, CLIP_EVENTS) {
  "use strict";

  var service = {
    data: null,
    error: null,
    transformer: clipTransformer,
    clear: function clear() {
      service.data = null;
      service.error = null;
    },
    retrieve: function retrieve(clip_id, params) {
      if (clip_id) {
        params = $httpParamSerializerJQLike(params);

        return $http({
          method: 'GET',
          url: window.location.api('clips/' + clip_id + '?' + params),
          transformResponse: transformResource.onResponse(clipTransformer.transformToUi)
        }).then(function (response) {
          var data = response.data;

          service.data = null;
          service.error = null;
          if (data.error) {
            service.error = data.error;
          } else {
            service.load(data);
          }

          return response;
        });
      }
    },
    load: function load(data) {
      service.data = data;
    },
    toggle_like: function toggle_like(clip_id) {
      return $http.post(window.location.api('likes/clip/' + clip_id));
    },
    delete: function _delete(clip_id) {
      if (typeof clip_id === 'undefined' && service.data) {
        clip_id = service.data.iclipid;
      }
      return $http.delete(window.location.api('clips/' + clip_id));
    },
    updateClip: function updateClip(clip_id, data) {
      var clip = clipTransformer.transformToApi(angular.copy(data));
      return $http.put(window.location.api('clips/' + clip_id), clip);
    },
    getHotKeys: function getHotKeys() {
      return $http({
        method: 'GET',
        url: window.location.api('clips_overrides'),
        transformResponse: transformResource.onResponse(clipTransformer.transformToHotKey)
      }).then(function (response) {
        return response;
      });
    },
    updateUserHotKey: function updateUserHotKey(hotkey) {
      return $http.post(window.location.api('clips_overrides/' + hotkey.iclipcategoryid), hotkey);
    },
    getStreamUrl: function getStreamUrl(audio) {
      if (service.data) {
        if (!audio) {
          audio = 1;
        }

        var clip_id = service.data.iclipid;
        return $http.get(window.location.api('clips/' + clip_id + '/stream_url/' + audio));
      }
    },
    logWatched: function logWatched(clip) {
      if (!clip && service.data && service.data.iclipid) {
        clip = service.data;
      }

      if (clip) {
        return $http.post(window.location.api('clips/' + clip.iclipid + '/log_watched')).then(function (response) {
          var data = response.data;

          if (data && data.watch_count) {
            clip.watch_count = data.watch_count;
          }

          return response;
        });
      }
    },
    flagInappropriate: function flagInappropriate(clipId) {
      return $http.put(window.location.api('clips/flag/inappropriate/' + clipId)).then(function (response) {
        $rootScope.$emit(CLIP_EVENTS.FLAGGED_AS_INAPPROPRIATE, clipId);
        return response;
      });
    },
    syndicate: function syndicate(clip_id) {
      return $http.post(window.location.api('clips/' + clip_id + '/syndicate'));
    },
    toggleStarred: function toggleStarred(clip_id) {
      if (typeof clip_id === 'undefined') {
        clip_id = service.data ? service.data.iclipid : null;
      }

      return $http.put(window.location.api('clips_starred_clips/toggle/' + clip_id));
    },
    bulkDelete: function bulkDelete(clip_ids) {
      return $http.put(window.location.api('clips_bulk_delete'), { ids: clip_ids });
    }
  };

  return service;
}]);

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.shared.clipCategoryService', []).factory('app.shared.clipCategoryService', ['$http', '$q', '$httpParamSerializerJQLike', function ($http, $q, $httpParamSerializerJQLike) {
  'use strict';

  var service = {
    getCategories: function getCategories(options) {
      options = $httpParamSerializerJQLike(options);
      return $http.get(window.location.api('clips_categories?' + options));
    },
    getCategory: function getCategory(clip, categories) {
      var deferred = $q.defer();

      if (Array.isArray(categories)) {
        deferred.resolve(service.getCategoryFromList(clip, categories));
      } else {
        service.getCategories().then(function (response) {
          deferred.resolve(service.getCategoryFromList(clip, response.data));
        }, function () {
          deferred.reject({ error: 'Failed to retrieve categories' });
        });
      }

      return deferred.promise;
    },
    getCategoryFromList: function getCategoryFromList(clip, categories) {
      var foundCategory = null;

      if (Array.isArray(categories)) {
        angular.forEach(categories, function (category) {
          if (clip.iclipcategoryid_fk == category.iclipcategoryid) {
            foundCategory = category;
            return false;
          }
        });
      }

      return foundCategory;
    },
    isType: function isType(clipCategory, types) {
      var isType = false;

      if (angular.isObject(clipCategory)) {
        if (!Array.isArray(types)) {
          types = [types];
        }

        angular.forEach(types, function (type) {
          var regex = new RegExp('^' + type, 'i');
          if (clipCategory.strclipcategory.match(regex)) {
            isType = true;
            return false;
          }
        });
      }

      return isType;
    },
    isTeam: function isTeam(clipCategory, team) {
      if (angular.isObject(clipCategory)) {
        team = team.toString().toLowerCase();

        var regex = void 0;

        switch (team) {
          case 'home':
            regex = new RegExp('(for|home)$', 'i');
            break;
          case 'away':
            regex = new RegExp('(against|away)$', 'i');
            break;
        }

        return clipCategory.strclipcategory.match(regex);
      }

      return false;
    },

    getSubcategories: function getSubcategories(options) {
      options = $httpParamSerializerJQLike(options);
      return $http.get(window.location.api('clips_subcategories?' + options));
    },

    getSubcategoryStrengths: function getSubcategoryStrengths(options) {
      options = $httpParamSerializerJQLike(options);
      return $http.get(window.location.api('clips_subcategory_strengths?' + options));
    }
  };

  return service;
}]);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.transformResource', [])

/**
 * @ngdoc service
 * @name app.transformResource
 * @description
 * # transformResource
 * Handles request and reponse transformation attaching the new functions to
 * the default and global ones from $http
 * e.g.:
 * $http({
 *   url: '...',
 *   method: 'GET',
 *   transformResponse: transformResource.onResponse(SomeResponseHandlerFn)
 * });
 * $http({
 *   url: '...',
 *   method: 'GET',
 *   transformResponse: transformResource.onResponse([
 *           myResponseHandlerService.formatUrl,
 *           myResponseHandlerService.parseDate,
 *           myResponseHandlerService.camelCaseNameStr
 *       ])
 * });
 */
.factory('app.transformResource', ['$http', function ($http) {
  'use strict';

  var defaults = $http.defaults;

  function getFnArray(fnArray) {
    return _.isArray(fnArray) ? fnArray : [fnArray];
  }

  function appendTransformFnToDefaults(fnList) {
    return defaults.transformResponse.concat(getFnArray(fnList));
  }

  function appendDefaultsToTransformFn(fnList) {
    return getFnArray(fnList).concat(defaults.transformRequest);
  }

  //noinspection JSValidateJSDoc
  return {
    /**
     * Adds a function or array function to the default response transformations
     * on $http
     * @type {Array.<function(data, headersGetter)>}
     */
    onResponse: appendTransformFnToDefaults,
    /**
     * Adds a function or array function to the default request transformations
     * on $http
     * @type {Array.<function(data, headersGetter)>}
     */
    onRequest: appendDefaultsToTransformFn
  };
}]);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.appMetaService', []).factory('appMetaService', ['$http', '$filter', 'PRODUCT', function ($http, $filter, product) {
  'use strict';

  var date = new Date();
  var cYear = date.getFullYear();

  switch (product.Code) {
    case "htv":
      return {
        logoUrl: 'assets/images/hockeytv-logo.png',
        longName: 'HockeyTV',
        shortName: 'HTV',
        copyright: cYear + ' HockeyTech Inc.',
        website: 'HockeyTV.com',
        supportSite: 'http://support.hockeytv.com',
        supportEmail: 'support@hockeytv.com',
        passwordEmail: 'support@hockeytv.com'
      };
    case "ahl":
      return {
        logoUrl: 'assets/images/ahl/ahltv.png',
        longName: 'AHLTV',
        shortName: 'AHL',
        copyright: cYear + ' AHLTV',
        website: 'ahltv.com',
        supportSite: 'http://support.ahltv.com',
        supportEmail: 'ahltv@theahl.com',
        passwordEmail: 'ahltv@theahl.com'
      };
  }
}]);

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(15);

angular.module('app.shared.dataTransformers.clipTransformer', ['app.shared.dataTransformers.clockTimeTransformer']).factory('app.shared.dataTransformers.clipTransformer', ['app.shared.dataTransformers.clockTimeTransformer', '$filter', function (clockTimeTransformer, $filter) {
  "use strict";

  var service = {
    transformToUi: function transformToUi(clip) {
      if (clip) {
        if (clip.iclipcategoryid_fk) {
          clip.iclipcategoryid_fk = parseInt(clip.iclipcategoryid_fk);
        }

        var clipStart = service.getStartTime(clip);
        clip.startClockTime = service.secondsToClockTime(clipStart);

        var clipEnd = clipStart + parseInt(clip.strsourceduration);
        clip.endClockTime = service.secondsToClockTime(clipEnd);

        var time = parseInt(clip.strsourceduration);
        clip.clockTime = service.secondsToClockTime(time);

        if (typeof clip.strgoalassist !== 'undefined') {
          clip.goalAssist = JSON.parse(clip.strgoalassist);
        }

        if (clip.hasOwnProperty('game_clocktime')) {
          clip.gameClockTimeUi = {
            minute: null,
            second: null
          };

          if (clip.game_clocktime) {
            var _time = clip.game_clocktime.split(":");
            clip.gameClockTimeUi.minute = parseInt(_time[0]);
            clip.gameClockTimeUi.second = parseInt(_time[1]);
          }
        }
      }

      return clip;
    },
    transformToApi: function transformToApi(clip) {
      var preferDbFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!preferDbFields && clip.clockTime) {
        clip.itimeinseconds = service.clockTimeToSeconds(clip.clockTime);
        delete clip.clockTime;
      }

      if (!preferDbFields && clip.gameClockTimeUi) {
        if (clip.gameClockTimeUi.minute || clip.gameClockTimeUi.second) {
          if (!clip.gameClockTimeUi.minute) {
            clip.gameClockTimeUi.minute = '00';
          }
          if (!clip.gameClockTimeUi.second) {
            clip.gameClockTimeUi.second = '00';
          }
          clip.game_clocktime = clip.gameClockTimeUi.minute + ':' + clip.gameClockTimeUi.second;
        }

        delete clip.gameClockTimeUi;
      }

      if (!preferDbFields && clip.startClockTime) {
        clip.iclipstartutc = service.clockTimeToSeconds(clip.startClockTime) + parseInt(clip.game.istarttime);
        delete clip.startClockTime;
      }

      if (!preferDbFields && clip.endClockTime) {
        var endTime = service.clockTimeToSeconds(clip.endClockTime) + parseInt(clip.game.istarttime);
        clip.strsourceduration = endTime - clip.iclipstartutc;
        delete clip.endClockTime;
      }

      if (!preferDbFields && Number.isInteger(clip.iispublic)) {
        clip.iispublic = clip.iispublic > 0;
      }

      if (typeof clip.goalAssist !== 'undefined') {
        clip.strgoalassist = JSON.stringify(clip.goalAssist);
      }

      delete clip.iclipid;
      delete clip.game;
      delete clip.likes;
      delete clip.i_like;
      delete clip.watch_count;
      delete clip.can_syndicate;
      delete clip.goalAssist;
      delete clip.clip_category;
      delete clip.type;
      delete clip.sort_date;
      delete clip.lineup;
      delete clip.is_starred;
      delete clip.category;
      delete clip.subcategory;
      delete clip.subcategory_strength;
      delete clip.lines;

      return clip;
    },

    transformToHotKey: function transformToHotKey(hotkeys) {
      if (Array.isArray(hotkeys)) {
        var keys = hotkeys;

        var quick_clip_override = $filter('filter')(keys, { strclipcategory: 'Quick Clip' });

        if (!quick_clip_override.length) {
          var quickClipHotKey = {
            "iclipcategoryid": null,
            "strascii": 32,
            "strclipcategory": "Quick Clip",
            "strkeyboardshortcut": "spacebar",
            "ikeycode": 32,
            "istartclip": 10,
            "iduration": 20
          };
          keys.push(quickClipHotKey);
        }

        hotkeys = keys;
      }

      return hotkeys;
    },

    getStartTime: function getStartTime(clip, game) {
      var start = null;

      if (clip.game) {
        game = clip.game;
      }

      if (clip && game) {
        if (clip.iclipstartutc) {
          var clipStart = parseFloat(clip.iclipstartutc);
          var offset = parseFloat(game.istarttime);

          if (isNaN(clipStart)) clipStart = 0;
          if (isNaN(offset)) offset = 0;

          if (parseInt(clip.iclipcreationgamestatus) === 1) {
            if (parseInt(game.blivegameflag) === 2) {
              offset = 0;
            } else {
              offset = parseInt(game.istarttime) - offset;
            }
          } else {
            offset = parseInt(game.istarttime);
          }

          start = clipStart - offset;
        } else {
          if (clip.strsourcestartutc) {
            var source_start = parseFloat(clip.strsourcestart);

            start = isNaN(source_start) ? 0 : source_start;
          } else {
            var _source_start = parseFloat(clip.strsourcestart);

            if (isNaN(_source_start)) _source_start = 0;

            start = _source_start;
          }
        }
      }

      return Math.floor(start);
    }
  };

  angular.merge(service, clockTimeTransformer);

  return service;
}]);

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.favorites.favoritesService', []).factory('app.favorites.favoritesService', ['$http', '$httpParamSerializerJQLike', '$rootScope', '$q', 'appKey', function ($http, $httpParamSerializerJQLike, $rootScope, $q, appKey) {
  var favorites = {
    list: null,
    error: null,
    selected: null,
    retrieving: false,
    retrieving_terms: false,

    clear: function clear() {
      favorites.list = {
        personal: null,
        public: null
      };
      favorites.error = null;
      favorites.selected = [10];
    },
    retrieve: function retrieve(params) {
      if (appKey.user_key) {
        if (favorites.retrieving) {
          var deferred = $q.defer();
          deferred.reject({ error: 'Already in process of retrieving favorites' });
          return deferred.promise;
        } else {
          favorites.retrieving = true;
          favorites.error = null;
          params = $httpParamSerializerJQLike(params);
          return $http.get(window.location.api('favorites?' + params)).then(function (response) {
            var data = response.data;

            if (data.personal) {
              favorites.list.personal = data.personal;
            }
            if (data["public"]) {
              favorites.list["public"] = data["public"];
            }
            if (data.error) {
              favorites.error = data.error;
            }

            if (_.isEmpty(favorites.selected) || _.isEqual([10], favorites.selected)) {
              favorites.select(10, true);
            }

            $rootScope.$broadcast('favorites_changed');

            favorites.retrieving = false;
          });
        }
      } else {
        var _deferred = $q.defer();
        _deferred.reject({ error: 'User is not logged in' });
        return _deferred.promise;
      }
    },
    retrieve_if_empty: function retrieve_if_empty(params) {
      if (!(favorites.list["personal"] && favorites.list["public"])) {
        return favorites.retrieve(params);
      }
    },
    add: function add(type, search_id) {
      return $http.post(window.location.api('favorites'), {
        type: type,
        search_id: search_id
      }).then(function (response) {
        var data = response.data;

        if (data.id) {
          if (!Array.isArray(favorites.list.personal)) {
            favorites.list.personal = [];
          }
          favorites.list.personal.push(data);
          $rootScope.$broadcast('favorites_updated');
        }
      });
    },
    "delete": function _delete(id) {
      return $http["delete"](window.location.api('favorites/' + id)).then(function () {
        if (Array.isArray(favorites.list.personal)) {
          favorites.list.personal = favorites.list.personal.filter(
          /**
           * @param {Object} item
           * @returns {boolean}
           */
          function (item) {
            return item.id !== id;
          });
          $rootScope.$broadcast('favorites_updated');
        }
      });
    },
    find_favorite: function find_favorite(type, search_id) {
      var favorite = void 0,
          i = void 0,
          len = void 0,
          ref = void 0;
      if (Array.isArray(favorites.list.personal)) {
        ref = favorites.list.personal;
        for (i = 0, len = ref.length; i < len; i++) {
          favorite = ref[i];
          if (favorite.type === type && parseInt(favorite.search_id) === parseInt(search_id)) {
            return favorite;
          }
        }
      }
      return false;
    },
    is_favorite: function is_favorite(type, search_id) {
      return !!favorites.find_favorite(type, search_id);
    },
    toggle: function toggle(type, search_id) {
      var favorite = void 0;
      favorite = favorites.find_favorite(type, search_id);
      if (favorite) {
        return favorites["delete"](favorite.id);
      } else {
        return favorites.add(type, search_id);
      }
    },
    is_selected: function is_selected(id) {
      if (id == 10) {
        if (Array.isArray(favorites.selected)) {
          return favorites.selected.length === 0;
        }
        return true;
      }

      return favorites.selected.indexOf(id) !== -1;
    },
    select: function select(id, noBroadcastFlag) {
      if (id === 10 || favorites.is_selected(10)) {
        favorites.selected = [];
      }
      if (!favorites.is_selected(id)) {
        favorites.selected.push(id);
      }
      if (!noBroadcastFlag) {
        $rootScope.$broadcast('favorites_selected');
      } else {
        return true;
      }
    },
    deselect: function deselect(id) {
      var index = void 0;
      index = favorites.selected.indexOf(id);
      if (index !== -1) {
        favorites.selected.splice(index, 1);
      }
      $rootScope.$broadcast('favorites_selected');
    },
    toggle_selected: function toggle_selected(id) {
      if (favorites.is_selected(id)) {
        return favorites.deselect(id);
      } else {
        return favorites.select(id);
      }
    },
    _debounceGetTerms: _.debounce(function (deferred) {
      if (appKey.user_key) {
        $http.get(window.location.api('favorites/terms')).then(function (response) {
          deferred.resolve(response);
        });
      } else {
        deferred.reject({ error: 'User is not logged in' });
      }
    }, 300),
    getTerms: function getTerms() {
      var deferred = $q.defer();

      favorites._debounceGetTerms(deferred);

      return deferred.promise;
    },
    hasSelected: function hasSelected() {
      if (Array.isArray(favorites.selected) && favorites.selected.length) {
        return !(favorites.selected.length === 1 && favorites.selected[0] == 10);
      }
      return false;
    }
  };

  favorites.clear();
  return favorites;
}]);

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.shared.dataTransformers.clockTimeTransformer', []).factory('app.shared.dataTransformers.clockTimeTransformer', ['$filter', function ($filter) {
  "use strict";

  var service = {
    secondsToClockTime: function secondsToClockTime(longSeconds) {
      var hours = void 0,
          minutes = void 0,
          seconds = void 0;
      hours = Math.floor(longSeconds / 60 / 60);
      minutes = Math.floor(longSeconds / 60 - hours * 60);
      seconds = Math.floor(longSeconds - minutes * 60 - hours * 60 * 60);

      return {
        hour: hours ? hours : 0,
        minute: minutes ? minutes : 0,
        second: seconds ? seconds : 0
      };
    },
    clockTimeToSeconds: function clockTimeToSeconds(clockTime) {
      var seconds = 0;

      if (clockTime.hour) {
        seconds += clockTime.hour * 3600;
      }
      if (clockTime.minute) {
        seconds += clockTime.minute * 60;
      }
      if (clockTime.second) {
        seconds += clockTime.second * 1;
      }

      return seconds;
    },
    stringToSeconds: function stringToSeconds(stringTime) {
      var arrTime = stringTime.toString().split(':');
      var isValid = true;
      var hour = 0;
      var minute = 0;
      var second = 0;

      switch (arrTime.length) {
        case 3:
          hour = parseInt(arrTime[0]);
          minute = parseInt(arrTime[1]);
          second = parseInt(arrTime[2]);
          break;
        case 2:
          hour = 0;
          minute = parseInt(arrTime[0]);
          second = parseInt(arrTime[1]);
          break;
        default:
          isValid = false;
          break;
      }

      if (isValid) {
        if (!isNaN(hour) && !isNaN(minute) && !isNaN(second)) {
          return second + minute * 60 + hour * 3600;
        }
      }

      return null;
    },
    secondsToString: function secondsToString(seconds, format) {
      var clockTime = service.secondsToClockTime(seconds);

      switch (format) {
        case 'mm:ss':
          var minute = clockTime.hour * 60 + clockTime.minute;
          return $filter('left_pad')(minute, 2) + ':' + $filter('left_pad')(clockTime.second, 2);
          break;
        default:
          return clockTime.hour + ':' + $filter('left_pad')(clockTime.minute, 2) + ':' + $filter('left_pad')(clockTime.second, 2);
          break;
      }
    },
    clockTimeToString: function clockTimeToString(clockTime) {
      var stringTime = '';

      stringTime += clockTime.hour * 3600;
      stringTime += ':' + clockTime.minute * 60;
      stringTime += ':' + clockTime.second;

      return stringTime;
    },
    formatUnit: function formatUnit(unit) {
      if (unit || parseInt(unit) === 0) {
        return $filter('left_pad')(unit, 2);
      }
    }

  };

  return service;
}]);

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.hostnameMatchService', []).factory('hostnameMatchService', [function () {
  var service = {
    hostname: function hostname(_hostname) {
      if (!_hostname) {
        _hostname = window.location.hostname;
      }

      if (_hostname.match(/.*\.ahltv\.com/)) {
        return 'ahltv.com';
      }

      if (_hostname.match(/.*\.watchtheahl\.com/)) {
        return 'watchtheahl.com';
      }

      if (_hostname.match(/.*\.dev\.ahltv\.com/)) {
        return 'dev.ahltv.com';
      }

      if (_hostname.match(/.*\.devbox\.ahltv\.com/)) {
        return 'devbox.ahltv.com';
      }

      if (_hostname.match(/.*\.staging\.ahltv\.com/)) {
        return 'staging.ahltv.com';
      }

      if (_hostname.match(/.*\.staging\.hockeytv\.aws\.htstack\.net/)) {
        return 'staging.hockeytv.aws.htstack.net';
      }

      if (_hostname.match(/.*\.staging\.ahltv\.aws\.htstack\.net/)) {
        return 'staging.ahltv.aws.htstack.net';
      }

      if (_hostname.match(/.*\.htv\.hockeytvdev\.com/)) {
        return 'htv.hockeytvdev.com';
      }

      if (_hostname.match(/.*\.ahl\.hockeytvdev\.com/)) {
        return 'ahl.hockeytvdev.com';
      }

      if (_hostname.match(/.*\.localhost\.hockeytv\.com/)) {
        return 'localhost.hockeytv.com';
      }

      if (_hostname.match(/.*\.localhost\.ahltv\.com/)) {
        return 'localhost.ahltv.com';
      }

      if (_hostname.match(/.*\.localhost/)) {
        return 'localhost';
      }

      if (_hostname.match(/^192\.168\.\d+\.\d+/)) {
        return 'localhost';
      }

      if (_hostname.match(/.*\.dev\.hockeytv\.com/)) {
        return 'dev.hockeytv.com';
      }

      if (_hostname.match(/.*\.devbox\.hockeytv\.com/)) {
        return 'devbox.hockeytv.com';
      }

      if (_hostname.match(/.*\.staging\.hockeytv\.com/)) {
        return 'staging.hockeytv.com';
      }

      if (_hostname.match(/.*\.?hockeytv\.com/)) {
        return 'hockeytv.com';
      }

      return _hostname;
    },
    domain: function domain(hostname) {
      return service.hostname(hostname);
    },
    base_url: function base_url(subdomain, protocol) {
      var domain = service.domain();
      var port = '';

      if (!subdomain) subdomain = 'www';

      switch (domain) {
        case 'localhost':
          port = ':8080';
          break;
      }
      return (protocol ? protocol : window.location.protocol) + '//' + (subdomain ? subdomain + '.' : '') + domain + port;
    },
    is_api: function is_api(hostname) {
      var el = document.createElement('a');
      el.href = hostname;
      hostname = el.hostname + ':' + el.port;
      switch (hostname) {
        case 'localhost:63342':
        case 'api.dev.hockeytv.com':
        case 'api.staging.hockeytv.com':
        case 'api.hockeytv.com':
          return true;
      }
      return false;
    }
  };

  return service;
}]);

/***/ }),
/* 19 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(18);

'use strict';

angular.module('app.appKey', ['app.hostnameMatchService']).factory('appKey', ['$cookies', 'hostnameMatchService', function ($cookies, hostnameMatch) {
  var app_id = void 0;

  app_id = $cookies.get('appKey.app_id');

  if (!app_id) {
    app_id = Math.floor(Math.random() * 100000 + 1) + '.' + moment().unix();
    $cookies.put('appKey.app_id', app_id, { domain: hostnameMatch.domain(), samesite: 'None', secure: true });
  }

  var appKey = {
    app_key: 'e17e46c337854e54984a7f014bfcb7dd',
    app_id: app_id,
    user_key: null,
    set_user_key: function set_user_key(key) {
      appKey.user_key = key;
      return $cookies.put('appKey.user_key', key, { domain: hostnameMatch.domain(), samesite: 'None', secure: true });
    },
    set_user_key_from_cookie: function set_user_key_from_cookie() {
      return appKey.user_key = $cookies.get('appKey.user_key');
    },
    destroy: function destroy() {
      appKey.user_key = null;
      return $cookies.remove('appKey.user_key', { domain: hostnameMatch.domain() });
    }
  };

  return appKey;
}]);

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(2);
__webpack_require__(8);

angular.module('app.player.playerSharedDataService', ['app.shared.singleGameService', 'app.shared.clipCategoryService']).factory('app.player.playerSharedDataService', ['$http', 'app.shared.singleGameService', 'app.shared.clipCategoryService', function ($http, singleGame, clipCategoryService) {
  "use strict";

  var service = {
    gameClips: null,
    clipCategories: [],
    clipSubcategories: [],
    getGameClips: function getGameClips(game_id) {
      return singleGame.retrieveClips(game_id).then(function (response) {
        var data = response.data;

        if (!data.error) {
          service.gameClips = data;
        }

        return response;
      });
    },
    getClipCategories: function getClipCategories() {
      return clipCategoryService.getCategories().then(function (response) {
        var data = response.data;

        if (!data.error) {
          service.clipCategories = data;
        }

        return response;
      });
    },
    getClipSubcategories: function getClipSubcategories() {
      return clipCategoryService.getSubcategories().then(function (response) {
        var data = response.data;

        if (!data.error) {
          service.clipSubcategories = data;
        }

        return response;
      });
    },
    clear: function clear() {
      service.clipCategories = [];
      service.clipSubcategories = [];
    }
  };

  return service;
}]);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.ipAddressService', []).value('ipAddress', { address: null }).factory('app.ipAddressService', ['$http', 'ipAddress', '$q', function ($http, ipAddress, $q) {
  var service = {
    activeBreaker: null,
    getFromMaxMind: function getFromMaxMind() {
      var deferred = $q.defer();

      geoip2.insights(function (response) {
        if (response.traits && response.traits.ip_address) {
          ipAddress.address = response.traits.ip_address;
          deferred.resolve(response);
        } else {
          deferred.reject(response);
        }
      }, function (response) {
        deferred.reject(response);
      });

      return deferred.promise;
    },
    getFromUrl: function getFromUrl(url, callback) {
      return $http.get(url).then(function (response) {
        if (typeof callback === 'function') {
          callback(response);
        } else {
          if (response.data === null || typeof response.data !== 'undefined') {
            ipAddress.address = null;
          }

          ipAddress.address = response.data.ip;
        }

        return response;
      });
    },
    retrieve: function retrieve() {
      var deferred = $q.defer();
      var internalPromise = void 0;

      deferred.resolve({ ip_address: null });
      return deferred.promise;

      if (service.activeBreaker) {
        var breaker = $q.defer();
        breaker.resolve();
        internalPromise = breaker.promise;
      } else {
        internalPromise = $http.get(window.location.api('service_breakers/groups/ip_address'));
      }

      internalPromise.then(function (response) {
        var data = response.data;
        if (Array.isArray(data) && data.length) {
          var _breaker = data[0];
          if (parseInt(_breaker.status) === 0) {
            service.activeBreaker = _breaker;
          }
        } else {
          service.activeBreaker = null;
        }

        if (service.activeBreaker) {
          service.getFromUrl(service.activeBreaker.url).then(function (response) {
            var data = response.data;

            switch (service.activeBreaker.name) {
              case 'Ipify':
              case 'JsonIp':
                ipAddress.address = data.ip;
                deferred.resolve({ ip: data.ip });
                break;
              default:
                deferred.reject();
                break;
            }
          }, function () {
            deferred.reject();
          });
        } else {
          deferred.reject();
        }
      });

      return deferred.promise;
    }
  };

  return service;
}]);

/***/ }),
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(35);
__webpack_require__(36);

"use strict";

angular.module('app.player.jwPlayer.jwPlayerDirective', ['app.player.jwPlayer.jwPlayerInternalDirective', 'app.player.jwPlayer.jwPlayerController']).directive('jwPlayer', [function () {
  return {
    restrict: 'A',
    transclude: true,
    templateUrl: 'components/player/jwPlayer/jwPlayerView.html',
    controller: 'app.player.jwPlayer.jwPlayerController',
    link: function link(scope, elm, attrs) {
      scope.id = 'player-' + attrs.id;
    }
  };
}]);

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1);
__webpack_require__(10);

"use strict";

angular.module('app.mainFrame.collapsableMenu.collapsableMenuService', ['app.currentUser', 'app.appMetaService']).factory('app.mainFrame.collapsableMenu.collapsableMenuService', ['$state', 'currentUser', '$rootScope', 'appMetaService', function ($state, currentUser, $rootScope, appMeta) {
  var service = {
    items: {},
    menuExpanded: false,
    prependedGroups: null,
    buildItems: function buildItems(prepend_groups) {
      service.items = {};

      var collapsable_menu = {
        accountSettings: null
      };

      if (typeof prepend_groups === 'undefined') {
        prepend_groups = service.prependedGroups;
      } else {
        service.prependedGroups = prepend_groups;
      }

      if (prepend_groups) {
        angular.merge(service.items, prepend_groups);
      }

      angular.merge(service.items, collapsable_menu);

      if (currentUser.is_logged_in()) {
        //service.items.accountSettings = [];

        /*if(!currentUser.data.has_all_acc_info) {
          service.items.accountSettings.push({
            label: 'Log Out',
            action: function () {
              currentUser.logout();
              $state.go('welcome.default');
              $rootScope.$broadcast('collapsableMenuTriggerCollapse');
            }
          });
        } else {*/
        service.items.accountSettings = [{
          label: 'Billing Info',
          icon: 'fa fa-dollar',
          action: function action() {
            $state.go('app.purchase.billingInfo');
            $rootScope.$broadcast('collapsableMenuTriggerCollapse');
          }
        }, {
          label: 'My Account',
          icon: 'fa fa-user-circle',
          action: function action() {
            $state.go('app.accountSettings');
            $rootScope.$broadcast('collapsableMenuTriggerCollapse');
          }
        }, {

          label: 'Broadcast Status',
          icon: 'fa fa-heartbeat',
          action: function action() {
            $state.go('app.broadcastStatus');
            $rootScope.$broadcast('collapsableMenuTriggerCollapse');
          }
        }, {

          label: 'Roku Connect',
          icon: 'fa fa-registered',
          action: function action() {
            $state.go('app.rokuConnect');
            $rootScope.$broadcast('collapsableMenuTriggerCollapse');
          }
        }, {
          label: 'Support',
          icon: 'fa fa-question-circle',
          action: function action() {
            window.open(appMeta.supportSite);
          }
        }, {
          label: 'Sign Out',
          icon: 'fa fa-sign-out',
          action: function action() {
            currentUser.logout();
            $state.go('welcome');
            $rootScope.$broadcast('collapsableMenuTriggerCollapse');
          }
        }];
        // }
      } else {
        service.items.accountSettings = [{
          label: 'Sign In',
          icon: 'fa fa-sign-in',
          action: function action() {
            $state.go('app.login');
            $rootScope.$broadcast('collapsableMenuTriggerCollapse');
          }
        }, {
          label: 'Sign Up',
          icon: 'fa fa-user-plus',
          action: function action() {
            $state.go('app.registration.new');
            $rootScope.$broadcast('collapsableMenuTriggerCollapse');
          }
        }, {
          label: 'Support',
          icon: 'fa fa-question-circle',
          action: function action() {
            window.open(appMeta.supportSite);
          }
        }];
      }
    }
  };

  return service;
}]);

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(34);

__webpack_require__(24);
__webpack_require__(37);
__webpack_require__(40);

__webpack_require__(41);
__webpack_require__(42);
__webpack_require__(43);
__webpack_require__(44);
__webpack_require__(45);
__webpack_require__(47);
__webpack_require__(49);
__webpack_require__(50);

__webpack_require__(52);
__webpack_require__(54);
__webpack_require__(56);

__webpack_require__(57);

'use strict';

angular.module('app.player', ['app.player.playerController', 'app.player.jwPlayer.jwPlayerDirective', 'app.shared.leagueLookIn.leagueLookInDirective', 'app.shared.switchToggle.switchToggleDirective', 'app.player.analysisController', 'app.player.hotkeysController', 'app.player.linesController', 'app.player.tagEventController', 'app.player.timelineController', 'app.player.rosterController', 'app.player.clipsController', 'app.player.boxscoreController', 'app.player.telestrate.telestrateControlsDirective', 'app.player.telestrate.telestrateCanvasDirective', 'app.shared.clockTimeUnit.clockTimeUnitDirective', 'app.shared.clipFilter']).config(['$stateProvider', function ($stateProvider) {
  var params = {
    url: '/play/:type/:id?:audio',
    title: 'Video Player',
    views: {
      '': {
        templateUrl: 'components/player/playerView.html',
        controller: 'app.player.playerController'
      },
      'analysis@app.play': {
        templateUrl: 'components/player/analysis/analysisView.html',
        controller: 'app.player.analysisController'
      },
      'hotkeys@app.play': {
        templateUrl: 'components/player/hotkeys/hotkeysView.html',
        controller: 'app.player.hotkeysController'
      },
      'lines@app.play': {
        templateUrl: 'components/player/lines/linesView.html',
        controller: 'app.player.linesController'
      },
      'tagEvent@app.play': {
        templateUrl: 'components/player/tagEvent/tagEventView.html',
        controller: 'app.player.tagEventController'
      },
      'timeline@app.play': {
        templateUrl: 'components/player/timeline/timelineView.html',
        controller: 'app.player.timelineController'
      },
      'roster@app.play': {
        templateUrl: 'components/player/roster/rosterView.html',
        controller: 'app.player.rosterController'
      },
      'clips@app.play': {
        templateUrl: 'components/player/clips/clipsView.html',
        controller: 'app.player.clipsController'
      },
      'boxscore@app.play': {
        templateUrl: 'components/player/boxscore/boxscoreView.html',
        controller: 'app.player.boxscoreController'
      }
    },
    fullWidthMobile: true,

    params: {
      clip_edit: false
    }
  };

  $stateProvider.state('app.play', params);
}]);

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.mainErrorService', []).factory('mainError', [function () {
    return {
        set: function set(message, type) {},
        clear: function clear() {}
    };
}]);

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


window.location.platform = function (platform, siteHostname) {
  "use strict";

  // Determine where the platform ends in the URL based on the site hostname. Platform matching
  // is dependent on the URL and what comes from hostnameMatchService.

  var platformEndIndex = window.location.hostname.indexOf("." + siteHostname);
  // Get the platform based on the determined index
  var urlPlatform = platformEndIndex > 0 ? window.location.hostname.substring(0, platformEndIndex) : null;
  var hostnameSplit = window.location.hostname.split('.');

  if (typeof platform === 'undefined') {
    // If we have a platform from the URL, use that
    if (urlPlatform) {
      return urlPlatform;
    } else {
      // Otherwise return the first item from the window hostname
      return hostnameSplit[0];
    }
  } else if (platform == "api") {
    hostnameSplit[0] = platform;
    return "//" + hostnameSplit.join('.');
  } else {
    // If a platform is provided, use that. Otherwise default to www
    urlPlatform = platform ? platform : 'www';
    return '//' + urlPlatform + "." + siteHostname;
  }
};

window.location.api = function (path) {
  "use strict";

  if (!!path) path = '/' + path.replace(/^\//, '');else path = '';

  return 'https://' + window.location.platform('api') + ":443" + path;
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(14);
__webpack_require__(2);
__webpack_require__(4);

"use strict";

angular.module('app.currentUser.clearSessionService', ['app.favorites.favoritesService', 'app.shared.singleGameService', 'app.shared.singleClipService']).factory('app.currentUser.clearSessionService', ['app.favorites.favoritesService', 'app.shared.singleGameService', 'app.shared.singleClipService', function (favorites, singleGame, singleClip) {
    return function () {
        favorites.clear();
        singleGame.clear();
        singleClip.clear();
    };
}]);

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(2);
__webpack_require__(4);
__webpack_require__(21);
__webpack_require__(1);

'use strict';

angular.module('app.player.playerController', ['app.shared.singleGameService', 'app.shared.singleClipService', 'app.player.rosterService', 'app.player.playerSharedDataService', 'app.currentUser']).controller('app.player.playerController', ['$scope', '$interval', '$stateParams', 'app.shared.singleGameService', 'app.shared.singleClipService', '$state', '$sce', 'app.player.rosterService', 'app.player.playerSharedDataService', 'currentUser', '$rootScope', function ($scope, $interval, $stateParams, singleGame, singleClip, $state, $sce, roster, playerSharedDataService, currentUser, $rootScope) {
  $scope.apiActivityInterval, $scope.selectedAudio = $stateParams.audio;
  $scope.availableStreams = [{ Id: '1', Name: 'Home' }];
  $scope.type = $stateParams.type;
  $scope.state = $state;
  $scope.origGameId = $stateParams.id;
  $scope.playerGameId;
  $scope.streamLoadError;
  $scope.game = singleGame;
  $scope.clip = singleClip;
  $scope.roster = roster;
  $scope.lineup = null;
  $scope.isTaggingEvent = false;
  $scope.telestrateToolbox = {
    color: 'blue',
    colorClass: 'video-player__telestrate__color-div__color--blue',
    brush: 'x-small',
    brushClass: 'video-player__telestrate__brush-div__brush--x-small',
    eraser: 'brush',
    eraserClass: 'video-player__telestrate__eraser-div__eraser--medium',
    fillDiameter: 10,
    lastX: 0,
    lastY: 0,
    isClearing: false,
    clearCanvas: false
  };

  var init = function init() {

    $scope.apiActivityInterval = $interval(function () {
      var gameId = $scope.playerGameId.toString();
      currentUser.logSessionActivity(gameId);
    }, 60000);

    var authorizeUser = function authorizeUser(game) {
      var template = null;

      if (game) {
        if (!game.can_play) {
          if (currentUser.has_access()) {
            if (!game.has_broadcast && game.blivegameflag > 2) {
              alert("We apologize but this game has been cancelled and therefore unable to view.");
            } else {
              template = 'accessDeniedToGame';
            }
          } else {
            template = 'subscriptionRequired';
          }
        } else if (game.user_started) {
          template = 'userAlreadyStartedGame';
        }
      } else {
        if ($scope.type === 'clip') {
          template = 'accessDeniedToClip';
        } else {
          template = 'accessDeniedToGame';
        }
      }

      if (template) {
        $state.go('app.accessDenied', {
          template: template
        });
      }
    };

    switch ($stateParams.type) {
      case 'game':
        singleGame.retrieve($stateParams.id, { include: ['preroll', 'user_started', 'lineup'], audio: $stateParams.audio }).then(function () {
          authorizeUser(singleGame.data);
        });
        break;
      case 'clip':
        singleClip.retrieve($stateParams.id, { include: { game: { include: ['user_started', 'lineup'] } } }).then(function (response) {
          var data = response.data;

          if (data.error) {
            singleGame.unload();
            authorizeUser(singleGame.data);
          } else {
            if (data.game) {
              singleGame.load(data.game);
              authorizeUser(singleGame.data);
            }
            if ($stateParams.clip_edit) {
              $rootScope.$broadcast('instant_replay_created', { clip: data, show_editor: $stateParams.clip_edit });
            }
          }
        });
        break;
    }

    playerSharedDataService.getClipCategories();
    playerSharedDataService.getClipSubcategories();

    // $scope.$watch('enableHotKeys', function (enable) {
    //   $scope.$broadcast('enableHotKeys', enable)
    // });

    $scope.$watch('enableGameSpoiler', function (spoiler) {
      $scope.$broadcast('enableGameSpoiler', spoiler);
    });
  };

  $scope.changePlayerFeed = function (type, id) {
    var authorizeUser = function authorizeUser(game) {
      if (game) {
        if (!game.can_play) {
          if (!game.has_broadcast && game.blivegameflag > 2) {
            alert("We apologize but this game has been cancelled and therefore unable to view.");
            $scope.$broadcast('updateLiveLookin', { game: game });
          } else {
            $state.go('app.accessDenied', {
              template: 'accessDeniedToGame'
            });
          }
        } else if (game.user_started) {
          if (type === 'game') {
            $state.go('app.accessDenied', {
              template: 'userAlreadyStartedGame'
            });
          }
        } else {
          var audio = type === 'game' && game.pixellot_only ? 4 : null;
          $state.go('.', { id: id, audio: audio });
        }
      } else {
        $state.go('app.accessDenied', {
          template: 'accessDeniedToGame'
        });
      }
    };

    switch (type) {
      case 'game':
        singleGame.retrieve(id, { include: ['preroll', 'user_started'] }, false).then(function (response) {
          var data = response.data;
          authorizeUser(data.game);

          /*if(data.game && data.game.blivegameflag <= 2) {
            singleGame.data = singleGame.load(data.game, data.error);
          }*/
        });
        break;
      case 'clip':
        singleClip.retrieve(id, { include: { game: { include: ['user_started'] } } }).then(function (response) {
          var data = response.data;

          if (data.game) {
            //singleGame.load(data.game);
            authorizeUser(data.game);
          }
        });
        break;
    }
  };

  //$scope.enableHotKeys = true;
  $scope.enableGameSpoiler = false;

  //Watch Game and Boxscore function
  //Pause player when Boxscore clicked. Play when clicking Watch Game.
  $scope.pausePlayer = function (data) {
    var player = $scope.player;
    var playerState = player.getState();
    if (data == true && playerState == 'playing') {
      player.pause(true);
    } else if (data == false && playerState == 'paused') {
      player.play(true);
    }
  };

  // Function for testing ng-repeats in the views
  // Useful for making placeholders
  $scope.returnArrayOfLength = function (num) {
    return new Array(num);
  };

  $scope.setActiveTab = function (num) {

    if (parseInt(num) !== 3) {
      $scope.telestrateToolbox.clearCanvas = true;
    }

    $scope.activeTab = num;
  };

  $scope.playClip = function (clip) {
    var start = singleClip.transformer.getStartTime(clip);
    $scope.player.seek(start);
    singleClip.logWatched(clip);
  };

  $scope.$on("show_hide_clip_details", function (event, args) {
    $scope.isTaggingEvent = args;
    if (!args) {
      if (singleGame.data && !singleGame.data.can_edit) {
        $scope.setActiveTab(2);
      }
    }
  });

  $scope.$on("select_timeline_tab", function () {
    if (singleGame.data && singleGame.data.can_edit && $scope.activeTab !== 1) {
      $scope.tab = '4';
      $scope.setActiveTab(1);
    }
  });

  $scope.$watch(function () {
    return singleGame.data || singleClip.data;
  }, function () {
    if (singleGame.data) {
      if ($stateParams.audio) {
        $scope.selectedAudio = $stateParams.audio;
      } else {
        $scope.selectedAudio = singleGame.data.pixellot_only ? '4' : '1';
      }

      if (singleGame.data.multiple_audio_setting == 1) {
        $scope.availableStreams.push({ Id: '2', Name: 'Away' });
      } else if (singleGame.data.multiple_audio_setting == 2) {
        $scope.availableStreams.push({ Id: '5', Name: 'French' });
      }

      $scope.activeTab = $stateParams.activeTab ? $stateParams.activeTab : singleGame.data.can_edit ? 0 : 4;
      if (singleGame.data.iscoringproviderid_fk === 5 || singleGame.data.iscoringproviderid_fk === 7) {
        $scope.tab = '1';
      } else {
        $scope.tab = '2';
      }

      singleGame.getMoreClips();
      $scope.$broadcast('timelineIsAudioVisible');
    } else if (singleClip.data) {
      $scope.activeTab = $stateParams.activeTab ? $stateParams.activeTab : 0;
    }
  });

  $scope.$on('$destroy', function () {
    singleGame.unload();
    singleGame.clips = [];
    singleClip.clear();
    playerSharedDataService.clear();
    $interval.cancel($scope.apiActivityInterval);
  });

  return init();
}]);

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.player.jwPlayer.jwPlayerInternalDirective', []).directive('jwPlayerInternal', [function () {
  "use strict";

  return {
    restrict: 'A',
    template: '<div ng-attr-id="{{id}}" ng-init="$emit(\'player_dom_ready\')"></div>',
    scope: false,
    link: function link(scope, elm, attrs) {}
  };
}]);

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(10);
__webpack_require__(2);
__webpack_require__(4);

"use strict";

angular.module('app.player.jwPlayer.jwPlayerController', ['app.appMetaService', 'app.shared.singleGameService', 'app.shared.singleClipService', 'app.constants']).controller('app.player.jwPlayer.jwPlayerController', ['$scope', 'appMetaService', 'app.shared.singleGameService', 'app.shared.singleClipService', '$interval', '$timeout', '$state', 'JW_PLAYER_KEY', 'PLAYER_POSTERS', '$rootScope', '$cookies', function ($scope, appMeta, singleGame, singleClip, $interval, $timeout, $state, JW_PLAYER_KEY, playerPosters, $rootScope, $cookies) {
  var gameReady = !!(singleGame.data && singleGame.data.igameid);
  var domReady = false;
  var eventListeners = [];
  var currentGame = null;
  var playerReady = false;
  var preGameState = false;

  $scope.disableEventButtons = $scope.disableEventButtons || false;
  $scope.hideEventButtons = $scope.hideEventButtons || false;
  $scope.id = $scope.id || null;
  $scope.player = null;
  $scope.playerRenderingMode = null;
  $scope.singleClip = singleClip;
  $scope.showVideoControls = false;
  $scope.theatreMode = false;
  $scope.playerError = null;
  $scope.refreshPlayerInterval = null;

  $scope.watchedGameId = null;
  $scope.trackWatchingInterval = null;
  $scope.trackWatchingIntervalTime = 60000;

  var loadMedia = function loadMedia() {
    if (domReady && gameReady) {
      var audio = $scope.selectedAudio;
      if (!audio && singleClip && singleClip.data) {
        audio = singleClip.data.audio;
      }
      var promise = singleGame.getStreamUrl(audio);

      if (promise) {
        promise.then(function (response) {
          if (singleGame.data.igameid !== currentGame || preGameState) {
            // If the scheduled start time is within 1 hour, we will consider it starting soon
            var gameStartingSoon = false;
            var gameDateTimeUtc = moment.utc(singleGame.data.dtegametimefixed);
            var nowUTC = moment(new Date());
            var minutesDiff = moment.duration(gameDateTimeUtc.diff(nowUTC)).asMinutes();
            // Gives a 5 minute before after the scheduled game time for the stream to turn on
            if (minutesDiff >= -5 && minutesDiff <= 60) {
              gameStartingSoon = true;
            }

            var data = response.data;

            currentGame = singleGame.data.igameid;

            if ($scope.type === 'clip') {
              singleGame.data = singleClip.data.game;
            }

            window.jwplayer.key = JW_PLAYER_KEY;
            $scope.player = window.jwplayer($scope.id);
            if (typeof $scope.player.setup === 'function') {
              var playlist = [];
              var postrollPlaylist = [];

              var initialGame = {
                gameId: singleGame.data.igameid,
                audio: $scope.selectedAudio,
                playlistData: {
                  file: data.error || !data.video ? "broadcast_unavailable.mp4" : data.video
                }
              };

              if (data.error == "Game broadcast not yet available") {
                preGameState = true;
                initialGame.playlistData["image"] = playerPosters.notStarted;
                if (gameStartingSoon) {
                  initialGame.playlistData["image"] = playerPosters.startingSoon;
                }
              } else {
                if ($scope.type === 'game' && singleGame.data) {
                  var cookiePrerolls = $cookies.getObject('prerolls') || {};
                  var cookiePostrolls = $cookies.getObject('postrolls') || {};
                  var cookieGameId = $cookies.get('gameid');

                  if (cookieGameId === undefined) {
                    $cookies.put('gameid', $scope.origGameId);
                  }

                  if (!cookiePrerolls[singleGame.data.igameid]) {
                    if (Array.isArray(singleGame.data.preroll)) {

                      _.forEach(singleGame.data.preroll, function (preroll) {
                        playlist.push({
                          id: preroll.iprerollid,
                          file: preroll.preroll_inventory.strprerollurl
                        });
                      });

                      cookiePrerolls[singleGame.data.igameid] = playlist;
                      $cookies.putObject('prerolls', cookiePrerolls);
                    }

                    $cookies.put('gameid', $scope.origGameId);
                  }

                  if (!cookiePostrolls[singleGame.data.igameid]) {
                    if (Array.isArray(singleGame.data.postroll)) {
                      _.forEach(singleGame.data.postroll, function (postroll) {
                        postrollPlaylist.push({
                          id: postroll.iprerollid,
                          file: postroll.preroll_inventory.strprerollurl
                        });
                      });

                      cookiePostrolls[singleGame.data.igameid] = postrollPlaylist;
                      $cookies.putObject('postrolls', cookiePostrolls);
                    }

                    $cookies.put('gameid', $scope.origGameId);
                  }
                }
              }

              var hasPreroll = !!playlist.length;
              if (!hasPreroll) {
                playlist.push(initialGame.playlistData);
                playlist = playlist.concat(postrollPlaylist);
              }

              var initialPlaylistItem = $scope.player.getPlaylistItem(0);
              if (!initialPlaylistItem || $scope.streamLoadError || $scope.playerGameId != singleGame.data.igameid || initialPlaylistItem && initialPlaylistItem.image != initialGame.playlistData.image || initialPlaylistItem.file != initialGame.playlistData.file) {
                $scope.player.setup({
                  playlist: playlist,
                  preload: "auto",
                  hlshtml: true,
                  width: "100%",
                  aspectratio: "16:9",
                  playbackRateControls: [0.25, 0.5, 0.75, 1, 2, 4],
                  primary: "html5",
                  autostart: true,
                  cast: {}
                });

                $scope.player.setPlaybackRate(1);
              }

              if ($scope.type != 'clip') {
                $scope.player.addButton('<svg id="d5e84d87-34a2-44a7-81b7-9df63ad0a3a8" class="jw-svg-icon" data-name="theater" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M24,20.35H0V3.65H24ZM2.09,18.26H21.91V5.74H2.09Z"/><polygon points="6 12.5 4 12.5 4 7.5 9 7.5 9 9.5 6 9.5 6 12.5"/><polygon points="18 11.5 20 11.5 20 16.5 15 16.5 15 14.5 18 14.5 18 11.5"/></svg>', "Theater Mode", function () {
                  if (!$scope.theatreMode) {
                    $scope.theatreMode = true;
                    angular.element('.league-look').addClass("theatre-mode");
                    angular.element('.video-player__sidepanel').addClass("theatre-mode");
                    angular.element('.video-player__game-stats').addClass("theatre-mode");
                    angular.element('.video-player__player-lineup__lineup').addClass("theatre-mode");
                    angular.element('.video-editor__player-lineup__buttons-div').addClass("theatre-mode");
                    angular.element('.page-content').addClass("theatre-background");
                    angular.element('#d5e84d87-34a2-44a7-81b7-9df63ad0a3a8').addClass("player-icon-on");
                  } else {
                    $scope.theatreMode = false;
                    angular.element('.league-look').removeClass("theatre-mode");
                    angular.element('.video-player__sidepanel').removeClass("theatre-mode");
                    angular.element('.video-player__game-stats').removeClass("theatre-mode");
                    angular.element('.video-player__player-lineup__lineup').removeClass("theatre-mode");
                    angular.element('.video-editor__player-lineup__buttons-div').removeClass("theatre-mode");
                    angular.element('.page-content').removeClass("theatre-background");
                    angular.element('#d5e84d87-34a2-44a7-81b7-9df63ad0a3a8').removeClass("player-icon-on");
                  }
                }, "theatre");
              }

              $scope.player.addButton('<svg id="4d01687f-062a-4000-b278-6f577db3f814" class="jw-svg-icon" data-name="forward15" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><polygon points="18.11 5.54 18.11 3.23 24 6.67 18.11 10.12 18.11 7.81 2.28 7.81 2.28 18.5 9.51 18.5 9.51 20.77 0 20.77 0 5.54 18.11 5.54"/><path d="M13.38,20.65h-.92V14.71c0-.5,0-1,0-1.4l-.26.25-1.36,1.11-.5-.65,2.2-1.71h.8Z"/><path d="M18.17,15.56a3.07,3.07,0,0,1,2.07.65A2.23,2.23,0,0,1,21,18a2.57,2.57,0,0,1-.82,2,3.31,3.31,0,0,1-2.28.74,4.2,4.2,0,0,1-2.15-.45v-.91a3.47,3.47,0,0,0,1,.4,5.34,5.34,0,0,0,1.17.14,2.31,2.31,0,0,0,1.56-.47A1.71,1.71,0,0,0,20,18.11c0-1.16-.71-1.75-2.14-1.75a8.72,8.72,0,0,0-1.45.17L16,16.22l.31-3.91h4.15v.88H17.07l-.21,2.5A6.54,6.54,0,0,1,18.17,15.56Z"/></svg>', "Jump ahead 15s", function () {
                $scope.setPosition('+15');
              }, "forward15");

              $scope.player.addButton('<svg id="2e091f54-41cd-467c-88dc-bd2eee8e4b4d" class="jw-svg-icon" data-name="back15" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><polygon points="5.89 5.54 5.89 3.23 0 6.67 5.89 10.12 5.89 7.81 21.72 7.81 21.72 18.5 14.49 18.5 14.49 20.77 24 20.77 24 5.54 5.89 5.54"/><path d="M5.38,20.65H4.46V14.71c0-.5,0-1,0-1.4l-.26.25L2.88,14.67,2.38,14l2.2-1.71h.8Z"/><path d="M10.17,15.56a3.07,3.07,0,0,1,2.07.65A2.23,2.23,0,0,1,13,18a2.57,2.57,0,0,1-.82,2,3.31,3.31,0,0,1-2.28.74,4.2,4.2,0,0,1-2.15-.45v-.91a3.47,3.47,0,0,0,1,.4A5.34,5.34,0,0,0,9.91,20a2.31,2.31,0,0,0,1.56-.47A1.71,1.71,0,0,0,12,18.11c0-1.16-.71-1.75-2.14-1.75a8.72,8.72,0,0,0-1.45.17L8,16.22l.31-3.91h4.15v.88H9.07l-.21,2.5A6.54,6.54,0,0,1,10.17,15.56Z"/></svg>', "Jump back 15s", function () {
                $scope.setPosition('-15');
              }, "back15");

              if ($scope.type != 'clip') {
                $scope.player.addButton('<svg id="onOfVideoControls" class="jw-svg-icon" data-name="controls" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h24v24H0z" fill="none"/><path d="M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z"/></svg>', "Video Controls", function () {
                  if (!$scope.showVideoControls) {
                    $scope.showVideoControls = true;
                    angular.element('#videoControls').removeClass("video-controls");
                    angular.element('#onOfVideoControls').addClass("player-icon-on");
                  } else {
                    $scope.showVideoControls = false;
                    angular.element('#videoControls').addClass("video-controls");
                    angular.element('#onOfVideoControls').removeClass("player-icon-on");
                  }
                }, "video-controls");
              }

              $scope.player.on('ready', function () {
                playerReady = true;
                $scope.playerRenderingMode = $scope.player.getProvider().name;

                if ($scope.playerError) {
                  $scope.playerError = null;
                }

                if ($scope.refreshPlayerInterval) {
                  $interval.cancel($scope.refreshPlayerInterval);
                  $scope.refreshPlayerInterval = null;
                }

                if ($scope.trackWatchingInterval) {
                  $interval.cancel($scope.trackWatchingInterval);
                  $scope.trackWatchingInterval = null;
                }

                $scope.$parent.playerGameId = singleGame.data.igameid;
              });

              $scope.player.on('error', function (evt) {
                var autoRefresh = false;
                var JWPlayerErrorTitle = angular.element('.jw-error-msg .jw-title-primary')[0];
                var JWPlayerErrorDesc = angular.element('.jw-error-msg .jw-title-secondary')[0];

                var jwErrorElem = document.querySelector(".jw-error-msg");
                jwErrorElem.style.display = "block";

                if (data.error) {
                  $scope.$applyAsync(function () {
                    $scope.playerError = data.error;
                    hasPreroll = false;
                  });

                  if (data.error == "Game broadcast not yet available") {
                    // If the broadcast is not yet available, we show a placeholder
                    // image and want to hide the error HTML that overlays the player
                    jwErrorElem.style.display = "none";

                    autoRefresh = true;
                    hasPreroll = true;
                  } else {
                    JWPlayerErrorTitle.innerHTML = data.error;
                    JWPlayerErrorDesc.innerHTML = "";
                  }
                } else if (singleGame.data && (!singleGame.data.has_broadcast || singleGame.data.blivegameflag > 2)) {
                  var gameCancelledMessage = "This broadcast has been cancelled.";

                  $scope.$applyAsync(function () {
                    $scope.playerError = gameCancelledMessage;
                    hasPreroll = false;
                  });

                  JWPlayerErrorTitle.innerHTML = gameCancelledMessage;
                  JWPlayerErrorDesc.innerHTML = "";
                } else {
                  if (gameStartingSoon) {
                    $scope.$parent.streamLoadError = true;
                    autoRefresh = true;
                    preGameState = true;
                  }

                  switch (evt.message) {
                    case "Error loading player: No playable sources found":
                    case "Cannot load M3U8: 404 Not Found":
                      $scope.$applyAsync(function () {
                        $scope.playerError = evt.message;
                        hasPreroll = false;
                      });
                      break;
                  }
                }

                if (autoRefresh) {
                  if (!$scope.refreshPlayerInterval) {
                    $scope.refreshPlayerInterval = $interval(loadMedia, 30000);
                  }
                }
              });

              if (hasPreroll) {
                $scope.player.once('playlistComplete', function () {
                  //Once the game is completely loaded we need to seek to the start time (if applicable)
                  //The game is the first item after the preroll playlist is complete
                  $scope.player.once('play', function () {
                    if ($scope.type === 'game' && singleGame.data && singleGame.data.istarttime) {
                      $scope.player.seek(singleGame.data.istarttime);
                    } else if ($scope.type === 'clip' && singleClip.data) {
                      var startTime = singleClip.transformer.getStartTime(singleClip.data);
                      $scope.player.seek(startTime);
                    }
                  });
                  $scope.player.load([initialGame.playlistData].concat(postrollPlaylist));
                  if ($scope.type === 'game') {
                    // If playlistData["image"] is defined, the stream is not actually playing, so we won't call logPlayed
                    if (!initialGame.playlistData["image"]) {
                      singleGame.logPlayed(initialGame.gameId, initialGame.audio).then(function (response) {
                        if (response.status == 200) {
                          $scope.watchedGameId = response.data.id;
                          if (!$scope.trackWatchingInterval) {
                            $scope.trackWatchingInterval = $interval(trackWatching, $scope.trackWatchingIntervalTime);
                          }
                        }
                      });
                    }
                  } else if ($scope.type === 'clip') {
                    singleClip.logWatched();
                  }
                });

                $scope.player.once('error', function () {
                  $scope.player.load([initialGame.playlistData]);
                  if ($scope.type === 'clip') {
                    singleClip.logWatched();
                  }
                });
              } else {
                //Once the game is completely loaded we need to seek to the start time (if applicable)
                //The game is the first item in the player
                $scope.player.once('ready', function () {
                  if ($scope.type == 'game' && singleGame.data && singleGame.data.istarttime) {
                    $scope.player.seek(singleGame.data.istarttime);
                  } else if ($scope.type === 'clip' && singleClip.data) {
                    var startTime = singleClip.transformer.getStartTime(singleClip.data);
                    $scope.player.seek(startTime);
                  }
                });
                switch ($scope.type) {
                  case 'game':
                    // If playlistData["image"] is defined, the stream is not actually playing, so we won't call logPlayed
                    if (!initialGame.playlistData["image"]) {
                      singleGame.logPlayed(initialGame.gameId, initialGame.audio).then(function (response) {
                        if (response.status == 200) {
                          $scope.watchedGameId = response.data.id;
                          if (!$scope.trackWatchingInterval) {
                            $scope.trackWatchingInterval = $interval(trackWatching, $scope.trackWatchingIntervalTime);
                          }
                        }
                      });
                    }
                    break;
                  case 'clip':
                    singleClip.logWatched();
                    break;
                }
              }
            }
          }
        });
      }
    }
  };

  var init = function init() {
    $scope.$watch('enableHotKeys', function (enable) {
      $scope.$broadcast('enableHotKeys', enable);
    });
  };

  var playSpeedsFast = [{
    txt: '2x',
    mult: '*2'
  }, {
    txt: '4x',
    mult: '*4'
  }, {
    txt: '8x',
    mult: '*8'
  }];

  var playSpeedsSlow = [{
    txt: '0.75x',
    mult: '*0.75'
  }, {
    txt: '0.50x',
    mult: '*0.5'
  }, {
    txt: '0.25x',
    mult: '*0.25'
  }];

  $scope.playSpeed = { speed: 'normal', index: 0 }; //'normal', 'slow', 'fast'

  $scope.playSpeedsFastTxt = playSpeedsFast[0].txt;
  $scope.playSpeedsSlowTxt = playSpeedsSlow[0].txt;

  $scope.enableHotKeys = true;

  $scope.instantReplay = function (params) {
    if ($scope.player) {
      $scope.disableEventButtons = true;
      var categoryId = null;
      var options = {
        debug: {
          jwplayer_version: $scope.player.version
        }
      };

      if (angular.isObject(params)) {
        categoryId = params.category_id;
        if (angular.isObject(params.options)) options = params.options;
      } else {
        categoryId = params;
      }

      var clipOffset = void 0;

      clipOffset = window.jwPlayerMod.cursorOffset($scope.player);

      if (clipOffset !== false) {
        Object.assign(options, window.jwPlayerMod.fragPosition($scope.player));
        if ($scope.selectedAudio) {
          options["audio"] = $scope.selectedAudio;
        } else {
          options["audio"] = singleGame.data.pixellot_only ? 4 : 1;
        }

        singleGame.createInstantReplay(clipOffset, categoryId, options).then(function (response) {
          var data = response.data;

          if (!data.error) {
            var _params = {
              show_editor: false,
              clip: data
            };

            if (!singleGame.data.is_live) {
              $scope.player.seek(data.strsourcestart);
            }

            $scope.$broadcast('instant_replay_created', _params);
            $scope.$broadcast('assign_timeline_clips');
          }
        });
      }

      $timeout(function () {
        $scope.disableEventButtons = false;
      }, 1000);
    }
  };

  eventListeners.push($rootScope.$on('set_instant_replay', function (event, data) {
    $scope.instantReplay(data);
  }));

  $scope.toggleLike = function (clip) {
    switch ($scope.type) {
      case 'clip':
        singleClip.toggle_like(clip.data.iclipid).then(function (response) {
          var data = response.data;

          var likes = parseInt(data.likes);
          if (isNaN(likes)) {
            likes = 0;
          }
          clip.data.likes = likes;
          clip.data.i_like = data.i_like;
        });
        break;
    }
  };

  $scope.flagInappropriate = function (clip) {
    switch ($scope.type) {
      case 'clip':
        var confirmed = confirm('Mark this clip as inappropirate?');
        if (confirmed) {
          singleClip.flagInappropriate(clip.data.iclipid).then(function () {
            $state.reload();
          });
        }
    }
  };

  $scope.normalPlaySpeed = function () {
    $scope.playSpeed.speed = 'normal';
    $scope.playSpeed.index = 0;

    $scope.setSpeed(1);

    $scope.playSpeedsFastTxt = playSpeedsFast[0].txt;
    $scope.playSpeedsSlowTxt = playSpeedsSlow[0].txt;
  };

  $scope.increasePlaySpeed = function () {
    $scope.setSpeed(1);

    if ($scope.playSpeed.speed === 'fast') {

      if (parseInt($scope.playSpeed.index) === playSpeedsFast.length - 1) {
        $scope.playSpeed.index = 0;
      } else {
        $scope.playSpeed.index = $scope.playSpeed.index + 1;
      }
    } else {
      $scope.playSpeed.speed = 'fast';
      $scope.playSpeed.index = 0;
    }

    $scope.setSpeed(playSpeedsFast[$scope.playSpeed.index].mult);

    $scope.playSpeedsFastTxt = playSpeedsFast[$scope.playSpeed.index].txt;
    $scope.playSpeedsSlowTxt = playSpeedsSlow[0].txt;
  };

  $scope.decreasePlaySpeed = function () {
    $scope.setSpeed(1);

    if ($scope.playSpeed.speed === 'slow') {

      if (parseInt($scope.playSpeed.index) === playSpeedsSlow.length - 1) {
        $scope.playSpeed.index = 0;
      } else {
        $scope.playSpeed.index = $scope.playSpeed.index + 1;
      }
    } else {
      $scope.playSpeed.speed = 'slow';
      $scope.playSpeed.index = 0;
    }

    $scope.setSpeed(playSpeedsSlow[$scope.playSpeed.index].mult);

    $scope.playSpeedsSlowTxt = playSpeedsSlow[$scope.playSpeed.index].txt;
    $scope.playSpeedsFastTxt = playSpeedsFast[0].txt;
  };

  $scope.setSpeed = function (newRate) {
    if ($scope.playerRenderingMode === 'html5' || $scope.playerRenderingMode === 'hlsjs') {
      var videoTag = document.querySelector('video');
      var currentRate = videoTag.playbackRate;
      if (currentRate) {
        if (typeof newRate === 'string' && newRate.match(/^\*/)) {
          newRate = currentRate * parseFloat(newRate.replace(/^\*/, ''));
        } else {
          newRate = parseFloat(newRate);
        }
      } else {
        newRate = 1;
      }

      videoTag.playbackRate = newRate;
      videoTag.defaultPlaybackRate = 1;
    }
  };

  $scope.setPosition = function (newPosition) {
    if (typeof newPosition === 'string' && newPosition.match(/^[+\-]/)) {
      var currentPosition = $scope.player.getPosition();
      var operator = newPosition.substr(0, 1);
      var positionOffset = parseFloat(newPosition.replace(/^[+\-]/, ''));
      switch (operator) {
        case '+':
          newPosition = currentPosition + positionOffset;
          break;
        case '-':
          newPosition = currentPosition - positionOffset;
          break;
      }
    } else {
      newPosition = parseFloat(newPosition);
    }

    $scope.player.seek(newPosition);
  };

  var trackWatching = function trackWatching() {
    if ($scope.watchedGameId && $scope.player.getState() == "playing") {
      singleGame.updatePlayedTime($scope.watchedGameId);
    }
  };

  eventListeners.push($scope.$on('singleGameReady', function () {
    $scope.watchedGameId = null;
    gameReady = true;
  }));

  $scope.$watch(function () {
    if (!domReady) {
      domReady = !!document.getElementById($scope.id);
    }
    return domReady && gameReady;
  }, function () {
    loadMedia();
  });

  $scope.$watch(function () {
    if ($scope.type === 'clip') {
      if (singleClip.data) {
        return singleClip.data.iclipid;
      }
    }
    return null;
  }, function () {
    loadMedia();
  });

  $scope.$watch(function () {
    if ($scope.type === 'game') {
      if (singleGame.data) {
        return singleGame.data.igameid;
      }
    }
    return null;
  }, function () {
    loadMedia();
  });

  init();

  $scope.$on('$destroy', function () {
    _.invokeMap(eventListeners, _.call);
    $interval.cancel($scope.refreshPlayerInterval);
    $interval.cancel($scope.trackWatchingInterval);
  });
}]);

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(38);

"use strict";

angular.module('app.shared.leagueLookIn.leagueLookInDirective', ['app.shared.leagueLookIn.leagueLookInController']).directive('leagueLookIn', ['$window', function ($window) {
  return {
    restrict: 'E',
    templateUrl: 'components/shared/leagueLookIn/leagueLookInView.html',
    controller: 'app.shared.leagueLookIn.leagueLookInController',
    scope: {
      activeGame: '<',
      changeFeed: '<'
    },
    link: function link(scope, element) {
      var widthChanged = function widthChanged() {
        if (!element.hasClass('ng-hide')) {
          var width = element.width();

          if (width >= 974) {
            scope.gamesPerSlide = 6;
          } else if (width >= 791) {
            scope.gamesPerSlide = 5;
          } else if (width >= 737) {
            scope.gamesPerSlide = 4;
          } else if (width >= 411) {
            scope.gamesPerSlide = 3;
          } else {
            scope.gamesPerSlide = 2;
          }
        }
      };

      angular.element($window).bind('resize', function () {
        scope.$applyAsync(function () {
          widthChanged();
        });
      });

      widthChanged();
    }
  };
}]);

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(39);

angular.module('app.shared.leagueLookIn.leagueLookInController', ['app.shared.leagueLookIn.leagueLookInService']).controller('app.shared.leagueLookIn.leagueLookInController', ['$scope', '$timeout', 'app.shared.leagueLookIn.leagueLookInService', 'FIREBASE_CREDS', 'leaguestatFirebaseService', function ($scope, $timeout, leagueLookInService, fbCreds, lsFb) {
  "use strict";

  $scope.langId = 1;

  /**
   * @type {Game}
   */
  $scope.activeGame = $scope.activeGame || null;
  $scope.league = null;
  $scope.activeSlide = 0;
  $scope.gamesPerSlide = 6;
  $scope.slides = [];

  var games = null;

  var init = function init() {
    if ($scope.activeGame) {
      leagueLookInService.retrieve($scope.activeGame.igameid).then(function (response) {
        $scope.league = response.data.league;
        games = response.data.games;

        buildSlides();

        // If it's a leaguestat game, watch firebase for updates
        if ($scope.activeGame.iscoringproviderid_fk === 5 || $scope.activeGame.iscoringproviderid_fk === 7) {
          lsFb.authenticate(fbCreds.leaguestat.firebaseUrl, fbCreds.leaguestat.firebaseApiKey, fbCreds.leaguestat.firebaseToken);

          // Initialize firebase
          var updateGoalSummaryWithFbData = function updateGoalSummaryWithFbData(fbGameGoalSummaryData) {
            if (fbGameGoalSummaryData) {
              updateLookinGameScores(fbGameGoalSummaryData);
            }
          };

          angular.forEach(games, function (game) {
            lsFb.subscribeToGameGoalSummary(game.league.strleaguestatclientcode, game.iscoringprovidergameid, $scope.langId, updateGoalSummaryWithFbData);
            $scope.$on('$destroy', function () {
              lsFb.unsubscribeFromGameGoalSummary(game.league.strleaguestatclientcode, game.iscoringprovidergameid, $scope.langId, updateGoalSummaryWithFbData);
            });
          });
        }
      });
    }
  };

  // Update the live lookin scores with data from firebase
  var updateLookinGameScores = function updateLookinGameScores(fbGoalSummary) {
    $timeout(function () {
      angular.forEach(games, function (game) {
        if (game.iscoringprovidergameid === fbGoalSummary.GameId) {
          game.HomeGoals = fbGoalSummary.HomeGoalTotal;
          game.AwayGoals = fbGoalSummary.VisitorGoalTotal;
          return;
        }
      });
    });
  };

  var buildSlides = function buildSlides() {
    $scope.slides = [];
    var i = void 0;

    if (games) {
      for (i = 0; i < games.length; i += $scope.gamesPerSlide) {
        $scope.slides.push(games.slice(i, i + $scope.gamesPerSlide));
      }
    }
  };

  $scope.spoiled = false;
  $scope.$on('enableGameSpoiler', function (event, data) {
    $scope.spoiled = data;
  });

  $scope.$on('updateLiveLookin', function (event, data) {
    if (data && data.game) {
      $scope.activeGame = data.game;
    }

    init();
  });

  $scope.$watch(function () {
    if ($scope.activeGame) {
      return $scope.activeGame.ileagueid_fk;
    }
  }, function () {
    init();
  });

  $scope.$watch(function () {
    return $scope.gamesPerSlide;
  }, function () {
    buildSlides();
  });
}]);

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(9);

angular.module('app.shared.leagueLookIn.leagueLookInService', ['app.transformResource']).factory('app.shared.leagueLookIn.leagueLookInService', ['$http', 'app.transformResource', '$q', function ($http, transformResource, $q) {
  "use strict";

  var service = void 0;

  function parseDate(game) {
    var gameTime = moment(game.dtegametimefixed);

    if (moment.isMoment(gameTime)) {
      game.dtegametimefixed = gameTime.toDate();
    }
  }

  service = {
    retrieve: function retrieve(game_id) {
      var defer = $q.defer();

      if (game_id) {
        return $http({
          method: 'GET',
          url: window.location.api('games_live_lookin/game/' + game_id),
          timeout: defer.promise,
          transformResponse: transformResource.onResponse(function (data) {
            _.forEach(data.games, parseDate);

            data.games.sort(function (a, b) {
              return a.dtegametimefixed.getTime() - b.dtegametimefixed.getTime();
            });

            return data;
          })
        });
      } else {
        defer.reject({ error: 'No league ID provided.' });
      }

      return defer.promise;
    }
  };
  return service;
}]);

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.shared.switchToggle.switchToggleDirective', []).directive('switchToggle', [function () {
    return {
        restrict: 'E',
        templateUrl: 'components/shared/switchToggle/switchToggleView.html',
        scope: {
            model: '=?'
        }
    };
}]);

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.player.analysisController', []).controller('app.player.analysisController', ['$scope', function ($scope) {
  "use strict";

  // TODO: these should come from a service
  // GAME, LOCATION and PLAYER lists should prob be queried from api
  // Other arrays are non-changing

  var analysisMenuCategoriesGame = [{
    val: 'game_all',
    txt: 'all'
  }];

  var analysisMenuCategoriesEvent = [{
    val: 'evt_all',
    txt: 'all'
  }, {
    val: 'evt_uncategorized',
    txt: 'uncategorized'
  }, {
    val: 'evt_goal_for',
    txt: 'goal for'
  }, {
    val: 'evt_goal_against',
    txt: 'goal against'
  }, {
    val: 'evt_power_play',
    txt: 'power play'
  }, {
    val: 'evt_penalty_kill',
    txt: 'penalty kill'
  }, {
    val: 'evt_penalty_shot',
    txt: 'penalty shot'
  }, {
    val: 'evt_penalty_shot_against',
    txt: 'penalty shot against'
  }, {
    val: 'evt_faceoff',
    txt: 'faceoff'
  }, {
    val: 'evt_forecheck',
    txt: 'forecheck'
  }, {
    val: 'evt_neutral_zone',
    txt: 'neutral zone'
  }, {
    val: 'evt_defensive_zone',
    txt: 'defensive zone'
  }, {
    val: 'evt_hit',
    txt: 'hit'
  }, {
    val: 'evt_hit_against',
    txt: 'hit against'
  }, {
    val: 'evt_fight',
    txt: 'fight'
  }, {
    val: 'evt_breakout',
    txt: 'breakout'
  }, {
    val: 'evt_zone_entry',
    txt: 'zone entry'
  }, {
    val: 'evt_short_highlight',
    txt: 'short highlight'
  }, {
    val: 'evt_long_highlight',
    txt: 'long highlight'
  }];

  var analysisMenuCategoriesPeriod = [{
    val: 'per_all',
    txt: 'all'
  }, {
    val: 'per_1',
    txt: '1'
  }, {
    val: 'per_2',
    txt: '2'
  }, {
    val: 'per_3',
    txt: '3'
  }];

  var analysisMenuCategoriesPlayer = [{
    val: 'player_all',
    txt: 'all'
  }];

  $scope.analysisMenuSelection = {
    val: 'event'
  };

  $scope.analysisMenuCategoriesShow = analysisMenuCategoriesEvent;

  $scope.analysisMenuSelectionChange = function () {

    if ($scope.analysisMenuSelection.val === 'game') {
      $scope.analysisMenuCategoriesShow = analysisMenuCategoriesGame;
    } else if ($scope.analysisMenuSelection.val === 'event') {
      $scope.analysisMenuCategoriesShow = analysisMenuCategoriesEvent;
    } else if ($scope.analysisMenuSelection.val === 'period') {
      $scope.analysisMenuCategoriesShow = analysisMenuCategoriesPeriod;
    } else if ($scope.analysisMenuSelection.val === 'player') {
      $scope.analysisMenuCategoriesShow = analysisMenuCategoriesPlayer;
    } else if ($scope.analysisMenuSelection.val === 'location') {}
  };

  $scope.analysisCategoryClicked = function (cat) {};
}]);

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(4);

"use strict";

angular.module('app.player.hotkeysController', ['app.shared.singleClipService']).controller('app.player.hotkeysController', ['$scope', 'app.shared.singleClipService', '$document', '$rootScope', function ($scope, singleClip, $document, $rootScope) {

  $scope.enabled = true;
  var init = function init() {
    singleClip.getHotKeys().then(function (response) {
      var data = response.data;
      if (!data.error) {
        $scope.hotkeys = data;
        $scope.oldKeys = angular.copy($scope.hotkeys);
        $scope.addEventListeners();
      }
    });
  };

  $scope.addEventListeners = function () {
    $document.on('keypress.hotkeysEvents', function (key) {
      if (!keyPressing) {
        hotkeyKeyPress(key);
        keyPressing = true;
      }
    });

    $document.on('keydown.hotkeysEvents',
    /**
     * @param {*} key
     */
    function (key) {
      if (parseInt(key.keyCode) === 32 && key.target === $document.body) {
        key.preventDefault();
      }
    });

    $document.on('keyup.hotkeysEvents', function () {
      keyPressing = false;
    });
  };
  $scope.removeEventListeners = function () {
    $document.off('.hotkeysEvents');
  };

  $scope.hotkeys = null;

  // TODO: add the event to [somewhere]
  // TODO: should this only be active when some button is
  // active in view, like

  var lookupHotkeyEvent = function lookupHotkeyEvent(keyCode) {
    keyCode = parseInt(keyCode);

    var keyIndex = null;

    for (var i = 0; i < $scope.hotkeys.length; i++) {
      if (parseInt($scope.hotkeys[i].ikeycode) === keyCode) {
        keyIndex = i;
        break;
      }
    }

    if (keyIndex !== null) {
      var key = $scope.hotkeys[keyIndex];
      $rootScope.$broadcast('set_instant_replay', { category_id: key.iclipcategoryid });
    }

    return $scope.hotkeys[keyIndex];
  };

  $scope.hotkeysViewClick = function (key) {
    lookupHotkeyEvent(key.ikeycode);
  };

  $scope.enableHotkey = function (enable) {
    $scope.enabled = enable;
  };

  $scope.updateHotKey = function (key) {
    if (key.strkeyboardshortcut.length) {
      key.strkeyboardshortcut = key.strkeyboardshortcut.trim();
      key.ikeycode = key.strkeyboardshortcut.charCodeAt(key.strkeyboardshortcut.length - 1);
      key.strascii = key.strkeyboardshortcut.charCodeAt(key.strkeyboardshortcut.length - 1);

      var exisiting_shortcut = $scope.hotkeys.filter(function (hotkey) {
        return hotkey.iclipcategoryid !== key.iclipcategoryid && hotkey.strkeyboardshortcut === key.strkeyboardshortcut;
      });

      if (exisiting_shortcut.length) {
        alert("Shortcut key '" + exisiting_shortcut[0].strkeyboardshortcut + "' already in use for " + exisiting_shortcut[0].strclipcategory + ".");
        var oldkey = $scope.oldKeys.find(function (hotkey) {
          return hotkey.iclipcategoryid === key.iclipcategoryid;
        });

        var hotKeyIndex = $scope.hotkeys.findIndex(function (hotkey) {
          return hotkey.iclipcategoryid === key.iclipcategoryid;
        });

        $scope.hotkeys[hotKeyIndex] = oldkey;

        if (!$scope.enabled) {
          $scope.enabled = true;
        }
      } else {
        singleClip.updateUserHotKey(key).then(function (response) {
          var data = response.data;
          if (data.error) {
            alert(data.error);
          }
        });
      }
    }
  };

  var keyPressing = false;
  var hotkeyKeyPress = function hotkeyKeyPress(key) {
    lookupHotkeyEvent(key.which);
  };

  $scope.$on('enableHotKeys', function (event, data) {
    $scope.enabled = data;
  });

  $scope.$watch('enabled', function () {
    $scope.enabled ? $scope.addEventListeners() : $scope.removeEventListeners();
  });

  $scope.$on('$destroy', function () {
    $scope.removeEventListeners();
  });

  init();
}]);

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

angular.module('app.player.linesController', []).controller('app.player.linesController', ['$scope', function ($scope) {
  "use strict";

  $scope.isSavingLines = 0;

  var extractLinesData = function extractLinesData(lines) {

    var linesToSave = [];

    for (var team in lines) {
      if (lines.hasOwnProperty(team)) {
        if (_typeof(lines[team]) === 'object' && lines[team] !== null) {

          for (var line in lines[team]) {
            if (lines[team].hasOwnProperty(line)) {
              var hasData = false;

              var tempLine = {
                igameid: lines.igameid,
                iteamid: lines[team].iteamid,
                linenumber: line,
                data: {}
              };

              if (_typeof(lines[team][line]) === 'object') {
                for (var pos in lines[team][line]) {
                  if (lines[team][line].hasOwnProperty(pos)) {
                    // To save only non-null values, use this if statement.
                    // Turned off because have to save blanks when user
                    // deletes a value.

                    // if (lines[team][line][pos] != null) {
                    hasData = true;
                    tempLine.data[pos] = lines[team][line][pos];
                    // }
                  }
                }
              }

              if (hasData) {
                linesToSave.push(tempLine);
              }
            }
          }
        }
      }
    }

    return linesToSave;
  };

  var saveLinesLoop = function saveLinesLoop(lines) {

    var linesToSave = extractLinesData(lines);

    $scope.isSavingLines = linesToSave.length;

    for (var i = 0; i < linesToSave.length; i++) {
      //noinspection JSValidateTypes
      $scope.game.saveLine(linesToSave[i].igameid, linesToSave[i].iteamid, linesToSave[i].linenumber, linesToSave[i].data, function () {
        $scope.isSavingLines--;
      });
    }
  };

  $scope.linesSaveClick = function () {
    saveLinesLoop($scope.linesNumbers);
    $scope.linesForm.$setPristine();
  };

  $scope.linesNumbers = {};

  var populateLines = function populateLines() {

    for (var key in $scope.game.data.lineup) {
      if ($scope.game.data.lineup.hasOwnProperty(key)) {
        if (key == $scope.game.data.awayteam.iteamid) {
          $scope.linesNumbers.away = $scope.game.data.lineup[key];
          $scope.linesNumbers.away.iteamid = key;
        } else if (key == $scope.game.data.hometeam.iteamid) {
          $scope.linesNumbers.home = $scope.game.data.lineup[key];
          $scope.linesNumbers.home.iteamid = key;
        }
      }
    }

    $scope.linesNumbers.igameid = $scope.game.data.igameid;
  };

  var loadRoster = function loadRoster(max, count) {

    var loadStart = false;

    if (typeof count === 'undefined') {
      count = 0;
    } else {
      count++;
    }

    if (count <= max && !loadStart) {
      window.setTimeout(function () {

        if ($scope.game.data) {
          loadStart = true;

          $scope.roster.retrieve($scope.game.data.igameid, populateLines);
        } else {
          loadRoster(max, count);
        }
      }, 100);
    }
  };

  var init = function init() {
    loadRoster(20, 0);
  };

  init();
}]);

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(2);
__webpack_require__(4);
__webpack_require__(8);
__webpack_require__(15);
__webpack_require__(12);

angular.module('app.player.tagEventController', ['app.shared.singleGameService', 'app.shared.singleClipService', 'app.player.playerSharedDataService', 'app.shared.clipCategoryService', 'app.shared.dataTransformers.clockTimeTransformer', 'app.shared.dataTransformers.clipTransformer']).controller('app.player.tagEventController', ['$scope', 'app.shared.singleGameService', 'app.shared.singleClipService', 'app.player.playerSharedDataService', 'app.shared.clipCategoryService', 'app.shared.dataTransformers.clockTimeTransformer', 'app.shared.dataTransformers.clipTransformer', '$rootScope', function ($scope, singleGame, singleClip, playerSharedData, clipCategoryService, clockTimeTransformer, clipTransformer, $rootScope) {
  "use strict";

  $scope.selectedClip = null;
  $scope.clipCategoryMeta = {
    type: null,
    team: null
  };

  $scope.activeLine = {
    away: {
      offense: null,
      defense: null
    },
    home: {
      offense: null,
      defense: null
    }
  };

  $scope.sharedData = playerSharedData;

  $scope.error = singleClip.error;

  var tagSelectLocationCanvasProps = {
    ilocx: null,
    ilocy: null,
    fillStyle: '#7ed321',
    fillDiameter: 4,
    id: null,
    context: null
  };

  $scope.tagEventClick = function (eventName) {
    switch (eventName) {
      case 'save':
        if ($scope.selectedClip) {
          if (_.isEmpty($scope.selectedClip.strclipname)) {
            $scope.selectedClip.strclipname = _.find($scope.clipCategories, {
              iclipcategoryid: $scope.selectedClip.iclipcategoryid_fk
            }).strclipcategory;
          }

          var clipStartTime = parseInt($scope.selectedClip.startClockTime.hour * 60 * 60) + parseInt($scope.selectedClip.startClockTime.minute * 60) + parseInt($scope.selectedClip.startClockTime.second);
          var clipEndTime = parseInt($scope.selectedClip.endClockTime.hour * 60 * 60) + parseInt($scope.selectedClip.endClockTime.minute * 60) + parseInt($scope.selectedClip.endClockTime.second);

          $scope.selectedClip.strsourcestart = clipStartTime;
          $scope.selectedClip.strsourceduration = clipEndTime - clipStartTime;

          var startTime = singleClip.transformer.getStartTime($scope.selectedClip);
          var duration = clipEndTime - clipStartTime;
          $scope.selectedClip.strsourceduration = duration;

          Object.assign($scope.selectedClip, window.jwPlayerMod.fragPosition($scope.player, startTime));

          singleClip.updateClip($scope.selectedClip.iclipid, $scope.selectedClip).then(function (response) {
            var data = response.data;
            if (data.error) {
              $scope.error = data.error;
            } else {
              $scope.error = null;

              var indexToUpdate = singleGame.clips.findIndex(function (clip) {
                return $scope.selectedClip.iclipid === clip.iclipid;
              });

              singleGame.clips[indexToUpdate] = clipTransformer.transformToUi(data);
              $rootScope.$broadcast('assign_timeline_clips');
              $scope.$emit('show_hide_clip_details', false);
            }
          });
        }
        break;
      case 'delete':
        singleClip.delete($scope.selectedClip.iclipid).then(function () {
          var indexToDelete = singleGame.clips.findIndex(function (clip) {
            return $scope.selectedClip.iclipid === clip.iclipid;
          });

          singleGame.clips.splice(indexToDelete, 1);
          $rootScope.$broadcast('assign_timeline_clips');
        });
        break;
    }

    if (eventName !== 'save') {
      $scope.$emit('show_hide_clip_details', false);
      $scope.error = null;
    }
  };

  $scope.setLine = function (team_type, line_number, positionSet) {
    if ($scope.selectedClip) {
      var lineups = singleGame.data ? singleGame.data.lineup : null;
      var team = singleGame.data ? singleGame.data[team_type + 'team'] : null;

      if (team && lineups && lineups[team.iteamid] && lineups[team.iteamid][line_number]) {
        var lineup = lineups[team.iteamid][line_number];
        var prefix = 'i' + team_type.substr(0, 1);
        var offensivePositions = ['lw', 'rw', 'c'];
        var defensivePositions = ['ld', 'rd'];

        if (!$scope.selectedClip[prefix + 'g'] && lineups[team.iteamid][1]) {
          $scope.selectedClip[prefix + 'g'] = lineups[team.iteamid][1]['ig'];
        }

        var positions = positionSet === 'defense' ? defensivePositions : offensivePositions;
        _.forEach(positions, function (position) {
          $scope.selectedClip[prefix + position] = lineup['i' + position];
        });
      }
    }
  };

  $scope.tagSelectLocationClick = function (event) {
    $scope.tagSelectLocation(event.offsetX, event.offsetY);
  };

  $scope.tagSelectLocation = function (x, y) {
    if (x) {
      $scope.selectedClip.ilocx = x;
    }
    if (y) {
      $scope.selectedClip.ilocy = y;
    }

    if ($scope.selectedClip) {
      //get id & context
      tagSelectLocationCanvasProps.id = document.getElementById('selectTagLocationCanvas');
      if (tagSelectLocationCanvasProps.id) {
        tagSelectLocationCanvasProps.context = tagSelectLocationCanvasProps.id.getContext("2d");

        // clear canvas
        tagSelectLocationCanvasProps.context.clearRect(0, 0, tagSelectLocationCanvasProps.id.width, tagSelectLocationCanvasProps.id.height);

        // set ilocx & ilocy
        tagSelectLocationCanvasProps.ilocx = $scope.selectedClip.ilocx;
        tagSelectLocationCanvasProps.ilocy = $scope.selectedClip.ilocy;

        // draw dot
        if (tagSelectLocationCanvasProps.ilocx || tagSelectLocationCanvasProps.ilocy) {
          tagSelectLocationCanvasProps.context.beginPath();
          tagSelectLocationCanvasProps.context.fillStyle = tagSelectLocationCanvasProps.fillStyle;
          tagSelectLocationCanvasProps.context.arc(tagSelectLocationCanvasProps.ilocx, tagSelectLocationCanvasProps.ilocy, tagSelectLocationCanvasProps.fillDiameter, 0, 2 * Math.PI);
          tagSelectLocationCanvasProps.context.stroke();
          tagSelectLocationCanvasProps.context.lineWidth = 4;
          tagSelectLocationCanvasProps.context.fill();
        }
      }
    }
  };

  $scope.setTimeFromPlayer = function (type) {
    if ($scope.selectedClip) {
      var currentPosition = Math.round($scope.player.getPosition());
      var currentDuration = Math.round($scope.player.getDuration());
      var playerTime = void 0;

      if (currentDuration < 0) {
        playerTime = -(currentDuration - currentPosition);
      } else {
        playerTime = currentPosition;
      }

      var clockTime = singleClip.transformer.secondsToClockTime(playerTime);

      switch (type) {
        case 'startClockTime':
          $scope.selectedClip.startClockTime = clockTime;
          var fragPosition = window.jwPlayerMod.fragPosition($scope.player);
          Object.assign($scope.selectedClip, fragPosition);
          break;
        case 'endClockTime':
          $scope.selectedClip.endClockTime = clockTime;
          break;
        case 'clockTime':
          $scope.selectedClip.clockTime = clockTime;
          break;
      }
    }
  };

  $scope.selectShooter = function (teamType, playerNumber) {
    if ($scope.selectedClip) {
      $scope.selectedClip.strgoalteam = teamType;
      $scope.selectedClip.igoal = playerNumber;
    }
  };

  $scope.selectAssist = function (teamType, playerNumber, event) {
    if ($scope.selectedClip) {
      if ($scope.selectedClip.strgoalteam && $scope.selectedClip.strgoalteam === teamType && $scope.selectedClip.igoal) {
        if (!Array.isArray($scope.selectedClip.goalAssist)) {
          $scope.selectedClip.goalAssist = [];
        }

        var assistIndex = $scope.selectedClip.goalAssist.indexOf(playerNumber);
        if (assistIndex === -1) {
          $scope.selectedClip.goalAssist.push(playerNumber);
        } else {
          $scope.selectedClip.goalAssist.splice(assistIndex, 1);
        }
      } else {
        alert('Please select a shooter first.');
        if (event) {
          event.preventDefault();
        }
      }
    }
  };

  $scope.isShooterSelected = function (teamType, playerNumber) {
    playerNumber = parseInt(playerNumber);

    return $scope.selectedClip && $scope.selectedClip.strgoalteam === teamType && parseInt($scope.selectedClip.igoal) === playerNumber;
  };

  $scope.isAssistSelected = function (teamType, playerNumber) {
    if ($scope.selectedClip) {
      if ($scope.selectedClip.strgoalteam === teamType) {
        if (Array.isArray($scope.selectedClip.goalAssist)) {
          return $scope.selectedClip.goalAssist.indexOf(playerNumber) !== -1;
        }
      }
    }
    return false;
  };

  $scope.scrubPlayerToStartTime = function () {
    var seekTime = clockTimeTransformer.clockTimeToSeconds($scope.selectedClip.startClockTime);
    var fragPosition = window.jwPlayerMod.fragPosition($scope.player, seekTime);
    Object.assign($scope.selectedClip, fragPosition);
  };

  $scope.getSubcategoryStrengths = function () {
    if ($scope.selectedClip && $scope.selectedClip.subcategory_id) {
      clipCategoryService.getSubcategoryStrengths({ subcategories: $scope.selectedClip.subcategory_id }).then(function (response) {
        var data = response.data;

        if (data.error) {
          alert(data.error);
        } else {
          $scope.clipSubcategoryStrengths = data;
        }
      });
    }
  };

  var init = function init(params) {
    if (params && params.clip && params.clip.iclipid) {
      $scope.selectedClip = angular.copy(params.clip);
      $scope.tagSelectLocation();

      if (params.show_editor) {
        $scope.getSubcategoryStrengths();
        $scope.$emit('show_hide_clip_details', params.show_editor);
      } else {
        $scope.$emit("select_timeline_tab");
      }
    }
  };

  var getCategoryType = function getCategoryType(category) {
    var types = ['goal'];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = types[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var type = _step.value;

        if (clipCategoryService.isType(category, type)) {
          return type;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return null;
  };

  var getCategoryTeam = function getCategoryTeam(category) {
    var teams = ['home', 'away'];
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = teams[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var team = _step2.value;

        if (clipCategoryService.isTeam(category, team)) {
          return team;
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return null;
  };

  $scope.$on('instant_replay_created', function (evt, data) {
    init(data);
  });

  $scope.$on('assign_clip_categories', function () {});

  $scope.$watchCollection(function () {
    return $scope.selectedClip;
  }, function (newVal) {
    $scope.activeLine = {
      away: {
        offense: null,
        defense: null
      },
      home: {
        offense: null,
        defense: null
      }
    };

    if (singleGame.data) {
      var game = singleGame.data;
      var lineups = game.lineup;
      var teams = {
        away: game.awayteam.iteamid,
        home: game.hometeam.iteamid
      };

      if (lineups) {
        for (var teamType in teams) {
          var offensiveLineFound = false;
          var defensiveLineFound = false;
          var prefix = teamType === 'home' ? 'ih' : 'ia';

          if (teams.hasOwnProperty(teamType)) {
            var teamId = teams[teamType];

            for (var lineNumber in lineups[teamId]) {
              if (lineups[teamId].hasOwnProperty(lineNumber)) {
                var lineup = lineups[teamId][lineNumber];

                if (!offensiveLineFound) {
                  if (lineup.ilw || lineup.irw || lineup.ic) {
                    if (newVal[prefix + 'lw'] === lineup.ilw && newVal[prefix + 'rw'] === lineup.irw && newVal[prefix + 'c'] === lineup.ic) {
                      $scope.activeLine[teamType].offense = lineNumber;
                      offensiveLineFound = true;
                    }
                  }
                }

                if (!defensiveLineFound) {
                  if (lineup.ild || lineup.ird) {
                    if (newVal[prefix + 'ld'] === lineup.ild && newVal[prefix + 'rd'] === lineup.ird) {
                      $scope.activeLine[teamType].defense = lineNumber;
                      defensiveLineFound = true;
                    }
                  }
                }
              }
              if (offensiveLineFound && defensiveLineFound) break;
            }
          }
        }
      }
    }

    if ($scope.selectedClip && playerSharedData.clipCategories.length) {
      _.forEach(playerSharedData.clipCategories, function (category) {
        if ($scope.selectedClip.iclipcategoryid_fk === category.iclipcategoryid) {
          $scope.clipCategoryMeta = {
            type: getCategoryType(category),
            team: getCategoryTeam(category)
          };
        }
      });
    }
  });
}]);

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(21);
__webpack_require__(4);
__webpack_require__(2);
__webpack_require__(46);

angular.module('app.player.timelineController', ['app.player.playerSharedDataService', 'app.shared.singleClipService', 'app.shared.singleGameService', 'app.player.timelineService']).controller('app.player.timelineController', ['$scope', 'app.player.playerSharedDataService', 'app.shared.singleClipService', 'app.shared.singleGameService', 'app.player.timelineService', '$rootScope', '$state', '$filter', function ($scope, playerSharedData, singleClip, singleGame, timelineService, $rootScope, $state, $filter) {
  "use strict";

  var prevSelectedIndex = -1;
  $scope.timelineService = timelineService;
  $scope.dashIcon = '<i class="fa fa-minus"><i>';
  $scope.audioControlsVisible = null;
  $scope.eventsDivHeight = null;
  $scope.game = singleGame;
  $scope.timelineEvents = [];

  $scope.eventActions = [{
    title: 'Delete',
    class: 'btn btn-danger',
    action: function action(event) {
      var remove = confirm("Are you sure you want to delete this clip?");
      if (remove) {
        singleClip.delete(event.iclipid).then(function (response) {
          if (response.status === 204) {
            if (singleGame.data) {
              var eventToDeleteIndex = singleGame.clips.findIndex(function (clip) {
                return clip.iclipid === event.iclipid;
              });

              if (eventToDeleteIndex > -1) {
                event.is_collapsed = true;
                singleGame.clips.splice(eventToDeleteIndex, 1);
                assignGameClips();
              }
            }
          } else if (response.data && response.data.error) {
            alert(response.data.error);
          }
        });
      }
    },
    hide: function hide() {}
  }, {
    title: 'Edit',
    class: 'btn btn-success',
    action: function action(event) {
      $scope.playClip(event);

      var new_event = event;

      delete new_event.is_collapsed;

      $rootScope.$broadcast('instant_replay_created', { clip: new_event, editing: true, show_editor: true });
    }
  }, {
    title: 'Syndicate Clip',
    class: 'btn btn-success',
    action: function action(event) {
      singleClip.syndicate(event.iclipid).then(function (response) {
        var data = response.data;

        if (data.error) {
          alert(data.error);
        } else {
          alert('Your clip is being prepared. We will email you the clip when it is ready.');
        }
      });
    },
    hide: function hide(event) {
      return !event.can_syndicate;
    }

    /*{
      title: 'Open Video Analysis Page',
      class: 'btn btn-success',
      action: (event) => {
        $state.go('app.admin.videoAnalysis.myClips', {selected_clip: JSON.stringify(event)});
      }
    },*/
  }];

  $scope.pager = {
    items: [],
    pageSize: 10,
    currentPage: 1,
    pageChanged: function pageChanged() {
      if (Array.isArray(singleGame.clips)) {
        var start = (this.currentPage - 1) * this.pageSize;
        var end = start + this.pageSize;

        this.items = singleGame.clips.slice(start, end);
      }
    },
    reset: function reset() {
      this.currentPage = 1;
      this.pageChanged();
    }
  };

  var init = function init() {
    $scope.timelineService.sortColumnHeaders();
    $scope.timelineService.assignSelectedHeaders();
  };

  var tdStyleHelper = function tdStyleHelper(e, tr) {
    //fixes style issue of td cells not displaying correct while item is being dragged.
    var $originals = tr.children();
    var $helper = tr.clone();
    $helper.children().each(function (index) {
      $(this).width($originals.eq(index).width());
      $(this).height($originals.eq(index).height());
    });
    return $helper;
  };

  $scope.sortableOptions = {
    helper: tdStyleHelper,
    cancel: ".deselected_header"
  };

  var timeLineCanvasPoint = {
    color: '#7ed321',
    width: 10,
    height: 10
  };

  $scope.setTimeLineCanvas = function () {
    if (Array.isArray(singleGame.clips)) {
      var timeLineCanvas = document.getElementById('timeLineCanvas');

      if (timeLineCanvas) {
        var context = timeLineCanvas.getContext("2d");

        context.clearRect(0, 0, 300, 149);
        _.forEach(singleGame.clips, function (event) {
          event.ilocx = parseInt(event.ilocx) || 0;
          event.ilocy = parseInt(event.ilocy) || 0;

          if (event.ilocx || event.ilocy) {
            context.beginPath();
            context.fillStyle = timeLineCanvasPoint.color;
            context.arc(event.ilocx, event.ilocy, timeLineCanvasPoint.width / 2, 0, 2 * Math.PI);
            context.stroke();
            context.lineWidth = 4;
            context.fill();
          }
        });
      }
    }
  };

  $scope.timeLineCanvasClick = function (event) {
    var foundClip = null,
        foundIndex = null;

    var click_x = event.offsetX;
    var click_y = event.offsetY;

    _.forEach(singleGame.clips, function (clip, i) {
      var start_x = clip.ilocx;
      var end_x = clip.ilocx + timeLineCanvasPoint.width;
      var start_y = clip.ilocy;
      var end_y = clip.ilocy + timeLineCanvasPoint.height;

      if (click_x >= start_x && click_x <= end_x) {
        if (click_y >= start_y && click_y <= end_y) {
          foundIndex = i;
          foundClip = clip;
          return false;
        }
      }
    });

    if (foundClip) {
      if (prevSelectedIndex > -1) {
        singleGame.clips[prevSelectedIndex].highlight = false;
      }
      prevSelectedIndex = foundIndex;
      singleGame.clips[foundIndex].highlight = true;
      $scope.playClip(foundClip);
    }
  };

  $scope.onPlayClip = function (event) {
    if (prevSelectedIndex > -1) {
      singleGame.clips[prevSelectedIndex].highlight = false;
    }
    $scope.playClip(event);
  };

  $scope.getClipDatum = function (clip_datum, clip) {
    if (angular.isObject(clip_datum)) {
      clip_datum.position = clip_datum.position.toLowerCase();

      if (clip_datum.team === 'away') {
        return clip.lines.away[clip_datum.position];
      } else {
        return clip.lines.home[clip_datum.position];
      }
    } else {
      switch (clip_datum) {
        case 'clip_name':
          return clip.strclipname;

        case 'game_date':
          return $filter('date')(clip.game.dtegametimefixed, 'MMM. dd, yyyy');

        case 'matchup':
          return clip.game.league.strleaguenickname + ': ' + clip.game.awayteam.abbrev + ' @ ' + clip.game.hometeam.abbrev;

        case 'category':
          if (clip.category) {
            return clip.category.strclipcategory;
          } else if (clip.clip_category) {
            return clip.clip_category.strclipcategory;
          } else {
            return null;
          }
        case 'clip_time':
          return $filter('left_pad')(clip.startClockTime.hour, 2) + ':' + $filter('left_pad')(clip.startClockTime.minute, 2) + ':' + $filter('left_pad')(clip.startClockTime.second, 2);

        case 'duration':
          return $filter('left_pad')(clip.clockTime.hour, 2) + ':' + $filter('left_pad')(clip.clockTime.minute, 2) + ':' + $filter('left_pad')(clip.clockTime.second, 2);

        case 'clock_time':
          return clip.game_clocktime;

        case 'period':
          return clip.iperiod;

        case 'subcategory':
          return clip.subcategory ? clip.subcategory.subcategory : null;

        case 'strength':
          return clip.subcategory_strength ? clip.subcategory_strength.strength : null;
      }
    }
  };

  $scope.assignHeaders = function (show_table_data) {
    $scope.timelineService.assignSelectedHeaders();

    if (!show_table_data) {
      $scope.timelineService.sortColumnHeaders();
    }
  };

  $scope.getRowBackgroundColor = function (index) {
    if ((index + 1) % 2 === 0) {
      return 'even';
    } else {
      return 'odd';
    }
  };

  $scope.getClips = function () {
    if (singleGame.data) {
      singleGame.getMoreClips();
    }
  };

  var assignGameClips = function assignGameClips() {
    $scope.timelineEvents = singleGame.clips;

    _.forEach($scope.timelineEvents, function (clip) {
      clip.is_collapsed = true;
    });

    $scope.pager.pageChanged();
    $scope.setTimeLineCanvas();
  };

  $scope.$watch(function () {
    return singleGame.clips;
  }, function () {
    assignGameClips();
  });

  $scope.$on('assign_timeline_clips', function () {
    assignGameClips();
  });

  $scope.$on('timelineIsAudioVisible', function () {
    if (singleGame.data) {
      $scope.audioControlsVisible = (singleGame.data.multiple_audio_setting === 1 || singleGame.data.multiple_audio_setting === 2) && $scope.type === 'game';
    }
  });

  return init();
}]);

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.player.timelineService', []).factory('app.player.timelineService', ['$filter', function ($filter) {
  "use strict";

  var service = {
    columnHeaders: [{
      header_title: 'Clip Name',
      sorting_column: 'clip_name',
      class: 'clipName',
      selected: true
    }, {
      header_title: 'Clip Time',
      sorting_column: 'clip_time',
      class: 'clipTime',
      selected: true
    }, {
      header_title: 'Period',
      sorting_column: 'period',
      class: 'period',
      selected: false
    }, {
      header_title: 'Clock Time',
      sorting_column: 'clock_time',
      class: 'clockTime',
      selected: false
    }, {
      header_title: 'Category',
      sorting_column: 'category',
      class: 'clipCategory',
      selected: true
    }, {
      header_title: 'Subcategory',
      sorting_column: 'subcategory',
      class: 'clipSubcategory',
      selected: false
    }, {
      header_title: 'Strength',
      sorting_column: 'strength',
      class: 'clipStrength',
      selected: false
    }, {
      header_title: 'Lines',
      sorting_column: 'lines',
      class: 'linesTable',
      subheaders: [{ title: 'LW', selected: true }, { title: 'RW', selected: true }, { title: 'C', selected: true }, { title: 'LD', selected: true }, { title: 'RD', selected: true }, { title: 'G', selected: true }],
      selected: false
    }, {
      header_title: 'Game Date',
      sorting_column: 'game_date',
      class: 'gameDate',
      selected: false
    }, {
      header_title: 'Match-up',
      sorting_column: 'matchup',
      class: 'matchUp',
      selected: false
    }, {
      header_title: 'Duration',
      sorting_column: 'duration',
      class: 'duration',
      selected: true
    }],

    activeHeaders: {
      data: [],
      labels: []
    },

    table_width: 837,
    remainingWidth: 0,

    addRemoveHeader: function addRemoveHeader(index) {
      service.columnHeaders[index].selected = !service.columnHeaders[index].selected;

      var currentHeader = service.columnHeaders[index];
      service.columnHeaders.splice(index, 1);

      if (!currentHeader.selected) {
        service.columnHeaders.push(currentHeader);
      } else {
        var no_header_selected = service.columnHeaders.every(function (header) {
          return !header.selected;
        });

        if (!no_header_selected) {
          for (var i = service.columnHeaders.length - 1; i >= 0; i--) {
            if (service.columnHeaders[i].selected) {
              service.columnHeaders.splice(i + 1, 0, currentHeader);
              break;
            }
          }
        } else {
          service.columnHeaders.splice(0, 0, currentHeader);
        }
      }
    },

    assignSelectedHeaders: function assignSelectedHeaders() {
      service.activeHeaders['data'] = $filter('filter')(service.columnHeaders, { selected: true });
      service.activeHeaders['labels'] = [];

      _.forEach(service.activeHeaders['data'], function (column) {
        if (column.selected) {
          service.activeHeaders['labels'].push(column.sorting_column);
        }
      });
    },

    calcEmptyWidth: function calcEmptyWidth(element) {
      var baseClass = '.video-analysis__my-clips__grid__cell--';
      var totalColumnWidth = 0;

      _.forEach(service.activeHeaders, function (header) {
        totalColumnWidth += $(baseClass + header.class).width();
      });

      service.table_width = $(element).clientWidth;

      service.remainingWidth = service.table_width - totalColumnWidth;
    },

    emptySpaceExists: function emptySpaceExists() {
      return 0 < service.remainingWidth < service.table_width;
    },

    getEmptySpaceWidth: function getEmptySpaceWidth() {
      return service.remainingWidth;
    },

    sortColumnHeaders: function sortColumnHeaders() {
      return service.columnHeaders.sort(function (a, b) {
        if (a.selected > b.selected) {
          return -1;
        }
        if (a.selected < b.selected) {
          return 1;
        }

        return 0;
      });
    }

  };

  return service;
}]);

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(48);
__webpack_require__(2);

"use strict";

angular.module('app.player.rosterController', ['app.player.rosterService', 'app.shared.singleGameService']).controller('app.player.rosterController', ['$scope', 'app.player.rosterService', 'app.shared.singleGameService', function ($scope, roster, singleGame) {
  $scope.roster = roster;

  var init = function init() {
    if (singleGame.data) {
      roster.retrieve(singleGame.data.igameid);
    }
  };

  $scope.positionGroups = [{
    name: 'Forwards',
    positions: ['LW', 'RW', 'F', 'C']
  }, {
    name: 'Defensemen',
    positions: ['RD', 'LD', 'D']
  }, {
    name: 'Goalies',
    positions: ['G']
  }];

  $scope.statColumns = ['G', 'A', 'PTS', 'PIM', '+/-', 'SHOTS'];

  $scope.showProfile = function (player) {
    $scope.currentProfile = player;
    $scope.currentSeasonYear = roster.current_season_year;
    $scope.client_code = roster.client_code;
  };

  $scope.hideProfile = function () {
    $scope.currentProfile = null;
  };

  $scope.$watch(function () {
    return singleGame.data;
  }, function () {
    init();
  });

  init();
}]).filter('positionGroupFilter', function () {
  return function (players, positions) {
    return _.filter(players, function (player) {
      return _.includes(positions, player.strplayerposition);
    });
  };
});

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.player.rosterService', []).factory('app.player.rosterService', ['$http', '$q', function ($http, $q) {
  var service = {
    home: null,
    away: null,
    error: null,
    _debounceRetrieve: _.debounce(function (deferred, game_id, callback) {
      "use strict";

      var processData = function processData(data) {
        if (data.error) {
          service.error = data.error;
        } else if (data.roster) {
          service.home = data.roster.home;
          service.away = data.roster.away;

          if (service.current_season_year != data.roster.current_season_year) {
            service.current_season_year = data.roster.current_season_year;
          }

          if (service.client_code != data.roster.client_code) {
            service.client_code = data.roster.client_code;
          }

          angular.forEach(service.home, function (player) {
            player.dteplayerdob = moment(player.dteplayerdob).toDate();
          });

          angular.forEach(service.away, function (player) {
            player.dteplayerdob = moment(player.dteplayerdob).toDate();
          });
        }

        if (typeof callback !== 'undefined') {
          callback();
        }
      };
      $http.get(window.location.api('/games/' + game_id + '/roster')).then(
      /**
       * @param {HttpResponse} response
       */
      function (response) {
        processData(response.data);
        deferred.resolve(response);
      },
      /**
       * @param {HttpResponse} response
       */
      function (response) {
        processData(response.data);
        deferred.resolve(response);
      });
    }, 200),
    retrieve: function retrieve(game_id, callback) {
      var deferred = $q.defer();
      service._debounceRetrieve(deferred, game_id, callback);
      return deferred.promise;
    }
  };

  return service;
}]);

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(2);
__webpack_require__(4);

angular.module('app.player.clipsController', ['app.shared.singleGameService', 'app.shared.singleClipService']).controller('app.player.clipsController', ['$scope', 'app.shared.singleGameService', 'app.shared.singleClipService', '$state', function ($scope, singleGame, singleClip, $state) {
  "use strict";

  $scope.game = singleGame;

  $scope.thumbnailUrl = function (clip) {
    if (clip.thumbnail_url) {
      return clip.thumbnail_url;
    }
    return 'images/default/default.jpeg';
  };

  $scope.play = function (clip) {
    if (clip.audio != $scope.selectedAudio) {
      $state.go("app.play", { type: "clip", id: clip.iclipid, audio: clip.audio });
    } else {
      var start = singleClip.transformer.getStartTime(clip);
      $scope.player.seek(start);
    }
  };

  $scope.getClips = function () {
    if (singleGame.data) {
      singleGame.getMoreClips();
    }
  };
}]);

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(51);

angular.module('app.player.boxscoreController', ['leaguestatFirebaseService']).controller('app.player.boxscoreController', ['$scope', '$http', '$timeout', 'app.shared.singleGameService', 'LEAGUESTAT_API', 'FIREBASE_CREDS', 'leaguestatFirebaseService', '$rootScope', function ($scope, $http, $timeout, singleGame, lsapi, fbCreds, lsFb, $rootScope) {
	$scope.leaguestatGame = true;
	$scope.gameSummary;
	var gsUrl = "";
	var timerRunning = false;

	var fbGoalSummary = void 0;
	var fbShotSummary = void 0;
	var fbPenaltySummary = void 0;
	var fbPenalties = void 0;
	var fbScoring = void 0;

	$scope.spoiled = false;
	$scope.$on('enableGameSpoiler', function (event, data) {
		$scope.spoiled = data;
	});

	var getLsGameSummary = function getLsGameSummary() {
		return $http.jsonp(gsUrl, { jsonpCallbackParam: 'callback' });
	};

	// This will be called to refresh the lineup stats after we
	// get firebase data for a goal or penalty. We need to provide
	// a bit of a timeout/buffer for stat update to finish on LS.
	var queueGameSummaryRefresh = function queueGameSummaryRefresh() {
		if (!timerRunning) {
			timerRunning = true;
			setTimeout(function () {
				getLsGameSummary().then(function (response) {
					populateGameSummary(response.data);
					timerRunning = false;
				});
			}, 90000);
		}
	};

	var init = function init() {
		if (singleGame.data) {
			var lsClientCode = singleGame.data.league.strleaguestatclientcode;
			var lsGameId = singleGame.data.iscoringprovidergameid;

			// Verify this is a leaguestat game
			if (singleGame.data.iscoringproviderid_fk !== 5 && singleGame.data.iscoringproviderid_fk !== 7) {
				return;
			}

			$scope.language = "en";
			$scope.langId = 1;

			// Set Game Summary URL and load data
			gsUrl = lsapi.clusterUrl + '/feed/index.php?feed=statviewfeed&view=gameSummary' + '&game_id=' + lsGameId + '&key=' + lsapi.clusterKey + '&client_code=' + lsClientCode + '&lang=' + $scope.language;

			getLsGameSummary().then(function (response) {
				if (!response.data) {
					$scope.gameSummary = null;
					return;
				}

				populateGameSummary(response.data);

				lsFb.authenticate(fbCreds.leaguestat.firebaseUrl, fbCreds.leaguestat.firebaseApiKey, fbCreds.leaguestat.firebaseToken);

				// Initialize firebase 
				var updateGoalSummaryWithFbData = function updateGoalSummaryWithFbData(fbGameGoalSummaryData) {
					if (fbGameGoalSummaryData) {
						fbGoalSummary = fbGameGoalSummaryData;
						updateSummaryWithFbData();
						updateSummaryArea();
					}
				};

				lsFb.subscribeToGameGoalSummary(lsClientCode, lsGameId, $scope.langId, updateGoalSummaryWithFbData);
				$scope.$on('$destroy', function () {
					lsFb.unsubscribeFromGameGoalSummary(lsClientCode, lsGameId, $scope.langId, updateGoalSummaryWithFbData);
				});

				var updatePenaltySummaryWithFbData = function updatePenaltySummaryWithFbData(fbGamePenaltySummaryData) {
					if (fbGamePenaltySummaryData) {
						fbPenaltySummary = fbGamePenaltySummaryData;
						updateSummaryWithFbData();
						updateSummaryArea();
					}
				};

				lsFb.subscribeToGamePenaltySummary(lsClientCode, lsGameId, $scope.langId, updatePenaltySummaryWithFbData);
				$scope.$on('$destroy', function () {
					lsFb.unsubscribeFromGamePenaltySummary(lsClientCode, lsGameId, $scope.langId, updatePenaltySummaryWithFbData);
				});

				var updateShotSummaryWithFbData = function updateShotSummaryWithFbData(fbGameShotSummaryData) {
					if (fbGameShotSummaryData) {
						fbShotSummary = fbGameShotSummaryData;
						updateSummaryWithFbData();
						updateSummaryArea();
					}
				};

				lsFb.subscribeToGameShotSummary(lsClientCode, lsGameId, $scope.langId, updateShotSummaryWithFbData);
				$scope.$on('$destroy', function () {
					lsFb.unsubscribeFromGameShotSummary(lsClientCode, lsGameId, $scope.langId, updateShotSummaryWithFbData);
				});

				var updatePenaltiesWithFbData = function updatePenaltiesWithFbData(fbPenaltiesData) {
					if (fbPenaltiesData) {
						fbPenalties = fbPenaltiesData.GamePenalties;
						updatePenalties();
						queueGameSummaryRefresh();
					}
				};

				lsFb.subscribeToGamePenalties(lsClientCode, lsGameId, $scope.langId, updatePenaltiesWithFbData);
				$scope.$on('$destroy', function () {
					lsFb.unsubscribeFromGamePenalties(lsClientCode, lsGameId, $scope.langId, updatePenaltiesWithFbData);
				});

				var updateScoringWithFbData = function updateScoringWithFbData(fbScoringData) {
					if (fbScoringData) {
						fbScoring = fbScoringData;
						updateScoring();
						queueGameSummaryRefresh();
					}
				};

				lsFb.subscribeToGameScoring(lsClientCode, lsGameId, $scope.langId, updateScoringWithFbData);
				$scope.$on('$destroy', function () {
					lsFb.unsubscribeFromGameScoring(lsClientCode, lsGameId, $scope.langId, updateScoringWithFbData);
				});

				var updateMVPsWithFbData = function updateMVPsWithFbData(fbMVPData) {
					if (fbMVPData) {
						queueGameSummaryRefresh();
					}
				};

				lsFb.subscribeToGameMVPs(lsClientCode, lsGameId, $scope.langId, updateMVPsWithFbData);
				$scope.$on('$destroy', function () {
					lsFb.unsubscribeFromGameMVPs(lsClientCode, lsGameId, $scope.langId, updateMVPsWithFbData);
				});
			}, function error(response) {
				console.log("Error Status: " + response.statusText);
			});
		}
	};

	var populateGameSummary = function populateGameSummary(gameData) {
		$scope.gameSummary = gameData;

		// build boxscore tables

		// Scoring
		$scope.scoreSummaryHeadings = [];
		for (var period = 0; period < $scope.gameSummary.periods.length; period++) {
			$scope.scoreSummaryHeadings.push($scope.gameSummary.periods[period].info.shortName);
		}
		if ($scope.gameSummary.hasShootout) $scope.scoreSummaryHeadings.push("SO");
		$scope.scoreSummaryHeadings.push("T");

		// visiting team scoring
		$scope.visitingScoreSummary = [];
		for (var _period = 0; _period < $scope.gameSummary.periods.length; _period++) {
			$scope.visitingScoreSummary.push($scope.gameSummary.periods[_period].stats.visitingGoals);
		}
		if ($scope.gameSummary.hasShootout) {
			// If there was a shootout, we need to artificially insert a goal
			if ($scope.gameSummary.visitingTeam.stats.goals > $scope.gameSummary.homeTeam.stats.goals) {
				$scope.visitingScoreSummary.push(1);
			} else {
				$scope.visitingScoreSummary.push(0);
			}
		}
		$scope.visitingScoreSummary.push($scope.gameSummary.visitingTeam.stats.goals);
		$rootScope.awayGoals = $scope.gameSummary.visitingTeam.stats.goals;

		// home team scoring
		$scope.homeScoreSummary = [];
		for (var _period2 = 0; _period2 < $scope.gameSummary.periods.length; _period2++) {
			$scope.homeScoreSummary.push($scope.gameSummary.periods[_period2].stats.homeGoals);
		}
		if ($scope.gameSummary.hasShootout) {
			// If there was a shootout, we need to artificially insert a goal
			if ($scope.gameSummary.visitingTeam.stats.goals > $scope.gameSummary.homeTeam.stats.goals) {
				$scope.homeScoreSummary.push(0);
			} else {
				$scope.homeScoreSummary.push(1);
			}
		}
		$scope.homeScoreSummary.push($scope.gameSummary.homeTeam.stats.goals);
		$rootScope.homeGoals = $scope.gameSummary.homeTeam.stats.goals;

		// Create Shots box info
		// headers
		$scope.shotSummaryHeadings = [];
		for (var _period3 = 0; _period3 < $scope.gameSummary.periods.length; _period3++) {
			$scope.shotSummaryHeadings.push($scope.gameSummary.periods[_period3].info.shortName);
		}
		$scope.shotSummaryHeadings.push("T");
		// visiting shots
		$scope.visitingShotSummary = [];
		for (var _period4 = 0; _period4 < $scope.gameSummary.periods.length; _period4++) {
			$scope.visitingShotSummary.push($scope.gameSummary.periods[_period4].stats.visitingShots);
		}
		$scope.visitingShotSummary.push($scope.gameSummary.visitingTeam.stats.shots);
		// home shots
		$scope.homeShotSummary = [];
		for (var _period5 = 0; _period5 < $scope.gameSummary.periods.length; _period5++) {
			$scope.homeShotSummary.push($scope.gameSummary.periods[_period5].stats.homeShots);
		}
		$scope.homeShotSummary.push($scope.gameSummary.homeTeam.stats.shots);

		for (var _period6 = 0; _period6 < $scope.gameSummary.periods.length; _period6++) {
			for (var goalIndex = 0; goalIndex < $scope.gameSummary.periods[_period6].goals.length; goalIndex++) {
				var props = $scope.gameSummary.periods[_period6].goals[goalIndex].properties;
				var allGoalPropertiesOb = [];
				if (props.isPowerPlay == '1') {
					allGoalPropertiesOb.push("PP");
				}
				if (props.isEmptyNet == '1') {
					allGoalPropertiesOb.push("EN");
				}
				if (props.isShortHanded == '1') {
					allGoalPropertiesOb.push("SH");
				}
				if (props.isPenaltyShot == '1') {
					allGoalPropertiesOb.push("PS");
				}
				$scope.gameSummary.periods[_period6].goals[goalIndex].properties.allGoalProperties = allGoalPropertiesOb.join(', ');
			}
		}
	};

	var updateSummaryWithFbData = function updateSummaryWithFbData() {
		if ($scope.gameSummary) {
			var svGameId = parseInt($scope.gameSummary.details.id);
			var svGame = $scope.gameSummary;

			$timeout(function () {

				if (fbGoalSummary) {
					// Update total goals for game summary and gameSpolierScore section
					$scope.gameSummary.homeTeam.stats.goals = $rootScope.homeGoals = fbGoalSummary.HomeGoalTotal;
					$scope.gameSummary.visitingTeam.stats.goals = $rootScope.awayGoals = fbGoalSummary.VisitorGoalTotal;

					// Update shootout status
					$scope.gameSummary.hasShootout = fbGoalSummary.Shootout;

					// Update powerplay data
					$scope.gameSummary.homeTeam.stats.powerPlayGoals = fbGoalSummary.HomePowerPlayGoals;
					$scope.gameSummary.visitingTeam.stats.powerPlayGoals = fbGoalSummary.VisitorPowerPlayGoals;
					$scope.gameSummary.homeTeam.stats.powerPlayOpportunities = fbGoalSummary.HomePowerPlayAttempts;
					$scope.gameSummary.visitingTeam.stats.powerPlayOpportunities = fbGoalSummary.VisitorPowerPlayAttempts;

					// Update powerplay data
					$scope.gameSummary.homeTeam.stats.powerPlayGoals = fbGoalSummary.HomePowerPlayGoals;
					$scope.gameSummary.visitingTeam.stats.powerPlayGoals = fbGoalSummary.VisitorPowerPlayGoals;
					$scope.gameSummary.homeTeam.stats.powerPlayOpportunities = fbGoalSummary.HomePowerPlayAttempts;
					$scope.gameSummary.visitingTeam.stats.powerPlayOpportunities = fbGoalSummary.VisitorPowerPlayAttempts;

					// Update goal and assist counts
					$scope.gameSummary.homeTeam.stats.goalCount = fbGoalSummary.HomeGoalTotal;
					$scope.gameSummary.visitingTeam.stats.goalCount = fbGoalSummary.VisitorGoalTotal;
					$scope.gameSummary.homeTeam.stats.assistCount = fbGoalSummary.HomeAssistPoints;
					$scope.gameSummary.visitingTeam.stats.assistCount = fbGoalSummary.VisitorAssistPoints;
				}

				if (fbShotSummary) {
					// Update shot totals
					$scope.gameSummary.homeTeam.stats.shots = fbShotSummary.HomeShotTotal;
					$scope.gameSummary.visitingTeam.stats.shots = fbShotSummary.VisitorShotTotal;
				}

				if (fbPenaltySummary) {
					$scope.gameSummary.homeTeam.stats.infractionCount = fbPenaltySummary.HomeInfractionsTotal;
					$scope.gameSummary.visitingTeam.stats.infractionCount = fbPenaltySummary.VisitorInfractionsTotal;
					$scope.gameSummary.homeTeam.stats.penaltyMinuteCount = fbPenaltySummary.HomePIMTotal;
					$scope.gameSummary.visitingTeam.stats.penaltyMinuteCount = fbPenaltySummary.VisitorPIMTotal;
				}

				// Update period specific data
				if (fbGoalSummary && fbGoalSummary.PeriodsInfo) {

					angular.forEach($scope.gameSummary.periods, function (svPeriod) {
						svPeriod.dirty = true; // Set each period to 'dirty' so we can remove the 'dirty' ones after the FB update
					});

					// Update period specific info
					angular.forEach(fbGoalSummary.PeriodsInfo, function (periodInfo, periodId) {

						if (periodId) {
							// Needs to be here because sometimes firebase will give back undefined keys (the 'array problem')

							var periodExists = false;

							for (var key in $scope.gameSummary.periods) {
								var gameSummaryPeriodId = parseInt($scope.gameSummary.periods[key].info.id);

								if (parseInt(periodId) === gameSummaryPeriodId) {
									$scope.gameSummary.periods[key].stats.homeGoals = fbGoalSummary.HomeGoalsByPeriod[periodId].toString();
									$scope.gameSummary.periods[key].stats.visitingGoals = fbGoalSummary.VisitorGoalsByPeriod[periodId].toString();

									if (fbShotSummary && fbShotSummary.PeriodsInfo && fbShotSummary.PeriodsInfo[periodId]) {
										// Update the shots for this period if they are available
										$scope.gameSummary.periods[key].stats.homeShots = fbShotSummary.HomeShotsByPeriod[periodId].toString();
										$scope.gameSummary.periods[key].stats.visitingShots = fbShotSummary.VisitorShotsByPeriod[periodId].toString();
									}

									$scope.gameSummary.periods[key].dirty = false;
									periodExists = true;
									break;
								}
							}

							if (!periodExists) {

								var newGameDataPeriod = {
									info: { shortName: periodInfo.ShortName, longName: periodInfo.LongName },
									stats: {
										homeGoals: fbGoalSummary.HomeGoalsByPeriod[periodId].toString(),
										visitingGoals: fbGoalSummary.VisitorGoalsByPeriod[periodId].toString()
									},
									goals: [], // TODO: when we want to add Firebase goals, do this here.
									penalties: [] // TODO: when we want to add Firebase penalties, do this here.
								};

								if (fbShotSummary.PeriodInfo && fbShotSummary.PeriodInfo[periodId]) {
									// Update the shots for this period if they are available
									newGameDataPeriod.stats.homeShots = fbShotSummary.HomeShotsByPeriod[periodId].toString();
									newGameDataPeriod.stats.visitingShots = fbShotSummary.VisitorShotsByPeriod[periodId].toString();
								}

								$scope.gameSummary.periods.push(newGameDataPeriod);
							}
						}
					});

					// Remove all the 'dirty' periods (ie. periods we don't want anymore)
					$scope.gameSummary.periods = $scope.gameSummary.periods.filter(function (svPeriod) {
						return !svPeriod.dirty;
					});
				}
			});
		}
	};

	// Updates the 'summary area' of the game center (ie. scoring summary, shots on goal summary and penalty/points summary)
	var updateSummaryArea = function updateSummaryArea() {

		// Update goal summary
		if ($scope.gameSummary) {

			$timeout(function () {

				// Create Scoring box info
				// headers
				$scope.scoreSummaryHeadings = [];
				for (var period = 0; period < $scope.gameSummary.periods.length; period++) {
					$scope.scoreSummaryHeadings.push($scope.gameSummary.periods[period].info.shortName);
				}
				if ($scope.gameSummary.hasShootout) $scope.scoreSummaryHeadings.push("SO");
				$scope.scoreSummaryHeadings.push("T");

				// visiting team scoring
				$scope.visitingScoreSummary = [];
				for (var period = 0; period < $scope.gameSummary.periods.length; period++) {
					$scope.visitingScoreSummary.push($scope.gameSummary.periods[period].stats.visitingGoals);
				}
				if ($scope.gameSummary.hasShootout) {
					// If there was a shootout, we need to artificially insert a goal
					if ($scope.gameSummary.visitingTeam.stats.goals > $scope.gameSummary.homeTeam.stats.goals) {
						$scope.visitingScoreSummary.push(1);
					} else {
						$scope.visitingScoreSummary.push(0);
					}
				}
				$scope.visitingScoreSummary.push($scope.gameSummary.visitingTeam.stats.goals);

				// home team scoring
				$scope.homeScoreSummary = [];
				for (var period = 0; period < $scope.gameSummary.periods.length; period++) {
					$scope.homeScoreSummary.push($scope.gameSummary.periods[period].stats.homeGoals);
				}
				if ($scope.gameSummary.hasShootout) {
					// If there was a shootout, we need to artificially insert a goal
					if ($scope.gameSummary.visitingTeam.stats.goals > $scope.gameSummary.homeTeam.stats.goals) {
						$scope.homeScoreSummary.push(0);
					} else {
						$scope.homeScoreSummary.push(1);
					}
				}
				$scope.homeScoreSummary.push($scope.gameSummary.homeTeam.stats.goals);

				// Update shot summary
				// Create Shots box info
				// headers
				$scope.shotSummaryHeadings = [];
				for (var period = 0; period < $scope.gameSummary.periods.length; period++) {
					$scope.shotSummaryHeadings.push($scope.gameSummary.periods[period].info.shortName);
				}
				$scope.shotSummaryHeadings.push("T");
				// visiting shots
				$scope.visitingShotSummary = [];
				for (var period = 0; period < $scope.gameSummary.periods.length; period++) {
					$scope.visitingShotSummary.push($scope.gameSummary.periods[period].stats.visitingShots);
				}
				$scope.visitingShotSummary.push($scope.gameSummary.visitingTeam.stats.shots);
				// home shots
				$scope.homeShotSummary = [];
				for (var period = 0; period < $scope.gameSummary.periods.length; period++) {
					$scope.homeShotSummary.push($scope.gameSummary.periods[period].stats.homeShots);
				}
				$scope.homeShotSummary.push($scope.gameSummary.homeTeam.stats.shots);

				// Update penalty and points summary


				// Doing this thing... should probably be somewhere else?
				for (var period = 0; period < $scope.gameSummary.periods.length; period++) {
					for (var goalIndex = 0; goalIndex < $scope.gameSummary.periods[period].goals.length; goalIndex++) {
						var props = $scope.gameSummary.periods[period].goals[goalIndex].properties;
						var allGoalPropertiesOb = [];
						if (props.isPowerPlay == '1') {
							allGoalPropertiesOb.push('PP');
						}
						if (props.isEmptyNet == '1') {
							allGoalPropertiesOb.push('EN');
						}
						if (props.isShortHanded == '1') {
							allGoalPropertiesOb.push('SH');
						}
						if (props.isPenaltyShot == '1') {
							allGoalPropertiesOb.push('PS');
						}
						$scope.gameSummary.periods[period].goals[goalIndex].properties.allGoalProperties = allGoalPropertiesOb.join(', ');
					}
				}
			});
		}
	};

	var updateScoring = function updateScoring() {
		if ($scope.gameSummary && fbScoring) {
			$timeout(function () {

				var newSvGoals = [];

				angular.forEach(fbScoring, function (fbGoal) {
					if (!(fbGoal.Period in newSvGoals)) {
						newSvGoals[fbGoal.Period] = [];
					}

					// goal seconds used for sorting later on
					var timeSplit = fbGoal.Time.split(":");
					var goalSeconds = parseInt(timeSplit[0]) * 60 + parseInt(timeSplit[1]);

					var newSVGoal = {
						period: fbGoal.PeriodLongName,
						periodNum: fbGoal.Period,
						properties: {
							isPowerPlay: fbGoal.PowerPlay,
							isShortHanded: fbGoal.ShortHanded,
							isEmptyNet: fbGoal.EmptyNet,
							isPenaltyShot: fbGoal.PenaltyShot
						},
						time: fbGoal.Time,
						seconds: goalSeconds,
						scoredBy: {
							id: fbGoal.ScorerPlayerId,
							firstName: fbGoal.ScorerPlayerFirstName,
							lastName: fbGoal.ScorerPlayerLastName,
							jerseyNumber: fbGoal.ScorerJerseyNumber
						},
						assists: [],
						plus_players: [],
						minus_players: [],
						team: fbGoal.IsHome ? $scope.gameSummary.homeTeam.info : $scope.gameSummary.visitingTeam.info
					};

					// Check for assisting player
					if (fbGoal.Assist1PlayerId > 0) {
						var assistingPlayer = {
							id: fbGoal.Assist1PlayerId,
							firstName: fbGoal.Assist1PlayerFirstName,
							lastName: fbGoal.Assist1PlayerLastName,
							jerseyNumber: fbGoal.Assist1PlayerJerseyNumber
						};

						newSVGoal.assists.push(assistingPlayer);

						// Check for second assisting player
						if (fbGoal.Assist2PlayerId > 0) {
							var _assistingPlayer = {
								id: fbGoal.Assist2PlayerId,
								firstName: fbGoal.Assist2PlayerFirstName,
								lastName: fbGoal.Assist2PlayerLastName,
								jerseyNumber: fbGoal.Assist2PlayerJerseyNumber
							};

							newSVGoal.assists.push(_assistingPlayer);
						}
					}

					// Check for +/-
					if (fbGoal.PlusPlayers) {
						angular.forEach(fbGoal.PlusPlayers, function (plusPlayer) {
							newSVGoal.plus_players.push({
								id: plusPlayer.Id,
								firstName: plusPlayer.FirstName,
								lastName: plusPlayer.LastName,
								jerseyNumber: plusPlayer.Jersey
							});
						});
					}

					if (fbGoal.MinusPlayers) {
						angular.forEach(fbGoal.MinusPlayers, function (minusPlayer) {
							newSVGoal.minus_players.push({
								id: minusPlayer.Id,
								firstName: minusPlayer.FirstName,
								lastName: minusPlayer.LastName,
								jerseyNumber: minusPlayer.Jersey
							});
						});
					}

					newSvGoals[fbGoal.Period].push(newSVGoal);
				});

				// Assign each array of goals to the proper game summary period goals
				angular.forEach($scope.gameSummary.periods, function (periodSummary) {
					angular.forEach(newSvGoals, function (svPeriodGoals) {
						if (periodSummary.info.id == svPeriodGoals[0].periodNum) {
							periodSummary.goals = svPeriodGoals;
							periodSummary.goals.sort(sortOnAttributes(scoringSortAttrs));
							return;
						}
					});
				});
			});
		}
	};

	var updatePenalties = function updatePenalties() {
		if ($scope.gameSummary && fbPenalties) {
			$timeout(function () {

				var newSvPenalties = [];

				angular.forEach(fbPenalties, function (fbPenalty) {
					if (!(fbPenalty.Period in newSvPenalties)) {
						newSvPenalties[fbPenalty.Period] = [];
					}

					// penalty seconds used for sorting later on
					var timeSplit = fbPenalty.Time.split(":");
					var penaltySeconds = parseInt(timeSplit[0]) * 60 + parseInt(timeSplit[1]);

					var newSVPenalty = {
						againstTeam: fbPenalty.Home ? $scope.gameSummary.homeTeam.info : $scope.gameSummary.visitingTeam.info,
						description: fbPenalty.OffenceDescription,
						isPowerPlay: fbPenalty.PowerPlay,
						period: {
							id: fbPenalty.Period
						},
						periodNum: fbPenalty.Period,
						seconds: penaltySeconds,
						servedBy: {
							id: fbPenalty.ServedPlayerId,
							firstName: fbPenalty.ServedPlayerFirstName,
							lastName: fbPenalty.ServedPlayerLastName,
							jerseyNumber: fbPenalty.ServedPlayerJerseyNumber
						},
						time: fbPenalty.Time,
						minutes: fbPenalty.Minutes,
						takenBy: {
							id: fbPenalty.PenalizedPlayerId,
							firstName: fbPenalty.PenalizedPlayerFirstName,
							lastName: fbPenalty.PenalizedPlayerLastName,
							jerseyNumber: fbPenalty.PenalizedPlayerJerseyNumber
						}
					};

					newSvPenalties[fbPenalty.Period].push(newSVPenalty);
				});

				// Assign each array of periods to the proper game summary period periods
				angular.forEach($scope.gameSummary.periods, function (periodSummary) {
					angular.forEach(newSvPenalties, function (svPeriodPenalties) {
						if (periodSummary.info.id == svPeriodPenalties[0].period.id) {
							periodSummary.penalties = svPeriodPenalties;
							periodSummary.penalties.sort(sortOnAttributes(scoringSortAttrs));
							return;
						}
					});
				});
			});
		}
	};

	var scoringSortAttrs = [{ field: 'periodNum', direction: 'asc' }, { field: 'seconds', direction: 'asc' }];

	var sortOnAttributes = function sortOnAttributes(attrs) {
		return function (a, b) {
			for (var i = 0; i < attrs.length; i++) {
				var retval = a[attrs[i].field] < b[attrs[i].field] ? -1 : a[attrs[i].field] > b[attrs[i].field] ? 1 : 0;
				if (attrs[i].direction == "desc") {
					retval = retval * -1;
				}
				if (retval !== 0) {
					return retval;
				}
			}
		};
	};

	$scope.$watch(function () {
		return singleGame.data;
	}, function () {
		init();
	});

	init();
}]).config(['$sceDelegateProvider', 'LEAGUESTAT_API', function ($sceDelegateProvider, LEAGUESTAT_API) {
	$sceDelegateProvider.resourceUrlWhitelist(['self', LEAGUESTAT_API.clusterUrl + '/**']);
}]);

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('Firebase', []).factory('Firebase', [function () {
    return {
        authenticate: function authenticate(firebaseUrl, firebaseApiKey, firebaseToken) {
            if (firebaseUrl == "" || typeof firebaseUrl === "undefined" || firebaseApiKey == "" || typeof firebaseApiKey === "undefined" || firebaseToken == "" || typeof firebaseToken === "undefined") return;
            if (!firebase.apps.length) {
                firebase.initializeApp({
                    apiKey: firebaseApiKey,
                    databaseURL: firebaseUrl
                });
            }
        }
    };
}]);

angular.module('leaguestatFirebaseService', ['Firebase']).factory('leaguestatFirebaseService', ['Firebase', '$rootScope', function (Firebase, $rootScope) {

    var databaseRef;

    // Collection of callbacks and data for game clocks
    var gameClockCallbacks = {
        /*
        // MODEL FORMAT:
                 // Unique game identifier form: clientCode-langId-gameId
        lhjmq-1-1234: {
            publishedClockData: {...},
            runningClockData: {...},
            listenerCallbacks: []
        },
        ...
                 */
    };

    // Collection of callbacks and data for game goal summary
    var gameGoalSummaryCallbacks = {
        /*
        // MODEL FORMAT:
                 // Unique game identifier form: clientCode-langId-gameId
        lhjmq-1-1234: {
            goalSummaryData: {...},
            listenerCallbacks: []
        },
        ...
                 */
    };

    // Collection of callbacks and data for game shot summary
    var gamePenaltySummaryCallbacks = {
        /*
        // MODEL FORMAT:
                 // Unique game identifier form: clientCode-langId-gameId
        lhjmq-1-1234: {
            penaltySummaryData: {...},
            listenerCallbacks: []
        },
        ...
                 */
    };

    // Collection of callbacks and data for game shot summary
    var gameShotSummaryCallbacks = {
        /*
        // MODEL FORMAT:
                 // Unique game identifier form: clientCode-langId-gameId
        lhjmq-1-1234: {
            shotSummaryData: {...},
            listenerCallbacks: []
        },
        ...
                 */
    };

    // Collection of callbacks and data for game penalties
    var gamePenaltiesCallbacks = {
        /*
        // MODEL FORMAT:
                 // Unique game identifier form: clientCode-langId-gameId
        lhjmq-1-1234: {
            penaltiesData: {...},
            listenerCallbacks: []
        },
        ...
                 */
    };

    // Collection of callbacks and data for game scoring
    var gameScoringCallbacks = {
        /*
        // MODEL FORMAT:
                 // Unique game identifier form: clientCode-langId-gameId
        lhjmq-1-1234: {
            scoringData: {...},
            listenerCallbacks: []
        },
        ...
                 */
    };

    // Collection of callbacks and data for game scoring
    var gameMVPsCallbacks = {
        /*
        // MODEL FORMAT:
                 // Unique game identifier form: clientCode-langId-gameId
        lhjmq-1-1234: {
            mvpsData: {...},
            listenerCallbacks: []
        },
        ...
                 */
    };

    var addToGameClockCallbacks = function addToGameClockCallbacks(clientCode, gameId, langId, listenerCallback) {
        var gameUid = createGameUid(clientCode, gameId, langId);

        if (!gameClockCallbacks[gameUid]) {
            gameClockCallbacks[gameUid] = {
                listenerCallbacks: []
            };
        }

        gameClockCallbacks[gameUid].listenerCallbacks.push(listenerCallback);
    };

    var addToGameGoalSummaryCallbacks = function addToGameGoalSummaryCallbacks(clientCode, gameId, langId, listenerCallback) {
        var gameUid = createGameUid(clientCode, gameId, langId);

        if (!gameGoalSummaryCallbacks[gameUid]) {
            gameGoalSummaryCallbacks[gameUid] = {
                listenerCallbacks: []
            };
        }

        gameGoalSummaryCallbacks[gameUid].listenerCallbacks.push(listenerCallback);
    };

    var addToGamePenaltySummaryCallbacks = function addToGamePenaltySummaryCallbacks(clientCode, gameId, langId, listenerCallback) {
        var gameUid = createGameUid(clientCode, gameId, langId);

        if (!gamePenaltySummaryCallbacks[gameUid]) {
            gamePenaltySummaryCallbacks[gameUid] = {
                listenerCallbacks: []
            };
        }

        gamePenaltySummaryCallbacks[gameUid].listenerCallbacks.push(listenerCallback);
    };

    var addToGameShotSummaryCallbacks = function addToGameShotSummaryCallbacks(clientCode, gameId, langId, listenerCallback) {
        var gameUid = createGameUid(clientCode, gameId, langId);

        if (!gameShotSummaryCallbacks[gameUid]) {
            gameShotSummaryCallbacks[gameUid] = {
                listenerCallbacks: []
            };
        }

        gameShotSummaryCallbacks[gameUid].listenerCallbacks.push(listenerCallback);
    };

    var addToGamePenaltiesCallbacks = function addToGamePenaltiesCallbacks(clientCode, gameId, langId, listenerCallback) {
        var gameUid = createGameUid(clientCode, gameId, langId);

        if (!gamePenaltiesCallbacks[gameUid]) {
            gamePenaltiesCallbacks[gameUid] = {
                listenerCallbacks: []
            };
        }

        gamePenaltiesCallbacks[gameUid].listenerCallbacks.push(listenerCallback);
    };

    var addToGameScoringCallbacks = function addToGameScoringCallbacks(clientCode, gameId, langId, listenerCallback) {
        var gameUid = createGameUid(clientCode, gameId, langId);

        if (!gameScoringCallbacks[gameUid]) {
            gameScoringCallbacks[gameUid] = {
                listenerCallbacks: []
            };
        }

        gameScoringCallbacks[gameUid].listenerCallbacks.push(listenerCallback);
    };

    var addToGameMVPsCallbacks = function addToGameMVPsCallbacks(clientCode, gameId, langId, listenerCallback) {
        var gameUid = createGameUid(clientCode, gameId, langId);

        if (!gameMVPsCallbacks[gameUid]) {
            gameMVPsCallbacks[gameUid] = {
                listenerCallbacks: []
            };
        }

        gameMVPsCallbacks[gameUid].listenerCallbacks.push(listenerCallback);
    };

    var authenticate = function authenticate(dbUrl, apiKey, token) {
        Firebase.authenticate(dbUrl, apiKey, token);
        databaseRef = firebase.database().ref();
        return true;
    };

    var combineClocks = function combineClocks(gamePublishedClock, gameRunningClock) {
        /*
            Methodology
            A 'combined' clock is the union of information from both the 'published' clock and 'running' clock.
            This logically consistent way to combine these two clocks is to:
                1. If we don't have a 'published' clock => do nothing (we dont have enough information yet)
                2. If we don't have a 'running' clock => use the 'published' clock's data
                3. Otherwise, use all the data from the 'published' clock with the minutes and seconds overwritten
                    by the 'running clock'
        */
        if (!gamePublishedClock) {
            return null; // Case 1 (above)
        }

        var combinedClock = angular.copy(gamePublishedClock);

        if (!gameRunningClock) return combinedClock; // Case 2 (above)

        combinedClock.ClockMinutes = parseInt(gameRunningClock.Clock.Minutes);
        combinedClock.ClockSeconds = parseInt(gameRunningClock.Clock.Seconds);

        return combinedClock;
    };

    var createGameUid = function createGameUid(clientCode, gameId, langId) {
        if (!clientCode) {
            console.log("ERROR: svfFb::createGameUid saw an invalid clientCode - ", clientCode);
            return undefined;
        }
        if (!gameId) {
            console.log("ERROR: svfFb::createGameUid saw an invalid gameId - ", gameId);
            return undefined;
        }
        if (!langId) {
            console.log("ERROR: svfFb::createGameUid saw an invalid langId - ", langId);
            return undefined;
        }

        return clientCode + '-' + gameId + '-' + langId;
    };

    var getGameIdFromGameUid = function getGameIdFromGameUid(gameUid) {
        if (!gameUid) {
            return undefined;
        }

        var splitUid = gameUid.split("-");

        if (splitUid.length !== 3) {
            console.log("ERROR: svfFb::getGameIdFromGameUid saw an invalid gameUid - ", gameUid);
            return undefined;
        }

        return splitUid[1];
    };

    var gameClockCallbacksEmpty = function gameClockCallbacksEmpty(gameUid) {
        if (!gameUid) {
            console.log("ERROR: svfFb::gameClockCallbacksEmpty got an invalid gameUid param - ", gameUid);
        }

        if (!gameClockCallbacks[gameUid]) return true;

        if (!gameClockCallbacks[gameUid].listenerCallbacks) return true;

        if (!gameClockCallbacks[gameUid].listenerCallbacks.length) return true;

        return false;
    };

    var gameGoalSummaryCallbacksEmpty = function gameGoalSummaryCallbacksEmpty(gameUid) {
        if (!gameUid) {
            console.log("ERROR: svfFb::gameGoalSummaryCallbacksEmpty got an invalid gameUid param - ", gameUid);
        }

        if (!gameGoalSummaryCallbacks[gameUid]) return true;

        if (!gameGoalSummaryCallbacks[gameUid].listenerCallbacks) return true;

        if (!gameGoalSummaryCallbacks[gameUid].listenerCallbacks.length) return true;

        return false;
    };

    var gamePenaltySummaryCallbacksEmpty = function gamePenaltySummaryCallbacksEmpty(gameUid) {
        if (!gameUid) {
            console.log("ERROR: svfFb::gamePenaltySummaryCallbacksEmpty got an invalid gameUid param - ", gameUid);
        }

        if (!gamePenaltySummaryCallbacks[gameUid]) return true;

        if (!gamePenaltySummaryCallbacks[gameUid].listenerCallbacks) return true;

        if (!gamePenaltySummaryCallbacks[gameUid].listenerCallbacks.length) return true;

        return false;
    };

    var gameShotSummaryCallbacksEmpty = function gameShotSummaryCallbacksEmpty(gameUid) {
        if (!gameUid) {
            console.log("ERROR: svfFb::gameShotSummaryCallbacksEmpty got an invalid gameUid param - ", gameUid);
        }

        if (!gameShotSummaryCallbacks[gameUid]) return true;

        if (!gameShotSummaryCallbacks[gameUid].listenerCallbacks) return true;

        if (!gameShotSummaryCallbacks[gameUid].listenerCallbacks.length) return true;

        return false;
    };

    var gamePenaltiesCallbacksEmpty = function gamePenaltiesCallbacksEmpty(gameUid) {
        if (!gameUid) {
            console.log("ERROR: svfFb::gamePenaltiesCallbacksEmpty got an invalid gameUid param - ", gameUid);
        }

        if (!gamePenaltiesCallbacks[gameUid]) return true;

        if (!gamePenaltiesCallbacks[gameUid].listenerCallbacks) return true;

        if (!gamePenaltiesCallbacks[gameUid].listenerCallbacks.length) return true;

        return false;
    };

    var gameScoringCallbacksEmpty = function gameScoringCallbacksEmpty(gameUid) {
        if (!gameUid) {
            console.log("ERROR: svfFb::gameScoringCallbacksEmpty got an invalid gameUid param - ", gameUid);
        }

        if (!gameScoringCallbacks[gameUid]) return true;

        if (!gameScoringCallbacks[gameUid].listenerCallbacks) return true;

        if (!gameScoringCallbacks[gameUid].listenerCallbacks.length) return true;

        return false;
    };

    var gameMVPsCallbacksEmpty = function gameMVPsCallbacksEmpty(gameUid) {
        if (!gameUid) {
            console.log("ERROR: svfFb::gameMVPsCallbacksEmpty got an invalid gameUid param - ", gameUid);
        }

        if (!gameMVPsCallbacks[gameUid]) return true;

        if (!gameMVPsCallbacks[gameUid].listenerCallbacks) return true;

        if (!gameMVPsCallbacks[gameUid].listenerCallbacks.length) return true;

        return false;
    };

    var handleGamePenaltiesUpdate = function handleGamePenaltiesUpdate(snapshot) {
        // Get clientCode, langId and gameId
        var snapshotUrl = snapshot.ref.toString();
        var splitUrl = snapshotUrl.split("/");

        var gameId = parseInt(splitUrl[splitUrl.length - 1]);
        var langId = parseInt(splitUrl[splitUrl.length - 3]);
        var clientCode = splitUrl[splitUrl.length - 5];

        var gameUid = createGameUid(clientCode, gameId, langId);

        gamePenaltiesCallbacks[gameUid].penaltiesData = snapshot.val();

        notifyGamePenaltiesListeners(gameUid);
    };

    var handleGameGoalSummaryUpdate = function handleGameGoalSummaryUpdate(snapshot) {
        // Get clientCode, langId and gameId
        var snapshotUrl = snapshot.ref.toString();
        var splitUrl = snapshotUrl.split("/");

        var gameId = parseInt(splitUrl[splitUrl.length - 1]);
        var langId = parseInt(splitUrl[splitUrl.length - 3]);
        var clientCode = splitUrl[splitUrl.length - 5];

        var gameUid = createGameUid(clientCode, gameId, langId);

        gameGoalSummaryCallbacks[gameUid].goalSummaryData = snapshot.val();

        notifyGameGoalSummaryListeners(gameUid);
    };

    var handleGamePenaltySummaryUpdate = function handleGamePenaltySummaryUpdate(snapshot) {
        // Get clientCode, langId and gameId
        var snapshotUrl = snapshot.ref.toString();
        var splitUrl = snapshotUrl.split("/");

        var gameId = parseInt(splitUrl[splitUrl.length - 1]);
        var langId = parseInt(splitUrl[splitUrl.length - 3]);
        var clientCode = splitUrl[splitUrl.length - 5];

        var gameUid = createGameUid(clientCode, gameId, langId);

        gamePenaltySummaryCallbacks[gameUid].penaltySummaryData = snapshot.val();

        notifyGamePenaltySummaryListeners(gameUid);
    };

    var handleGameShotSummaryUpdate = function handleGameShotSummaryUpdate(snapshot) {
        // Get clientCode, langId and gameId
        var snapshotUrl = snapshot.ref.toString();
        var splitUrl = snapshotUrl.split("/");

        var gameId = parseInt(splitUrl[splitUrl.length - 1]);
        var langId = parseInt(splitUrl[splitUrl.length - 3]);
        var clientCode = splitUrl[splitUrl.length - 5];

        var gameUid = createGameUid(clientCode, gameId, langId);

        gameShotSummaryCallbacks[gameUid].shotSummaryData = snapshot.val();

        notifyGameShotSummaryListeners(gameUid);
    };

    var handlePublishedClockUpdate = function handlePublishedClockUpdate(snapshot) {
        // Get clientCode, langId and gameId
        var snapshotUrl = snapshot.ref.toString();
        var splitUrl = snapshotUrl.split("/");

        var gameId = parseInt(splitUrl[splitUrl.length - 1]);
        var langId = parseInt(splitUrl[splitUrl.length - 3]);
        var clientCode = splitUrl[splitUrl.length - 5];

        var gameUid = createGameUid(clientCode, gameId, langId);

        gameClockCallbacks[gameUid].publishedClockData = snapshot.val();

        notifyGameClockListeners(gameUid);
    };

    var handleRunningClockUpdate = function handleRunningClockUpdate(snapshot) {
        // Get clientCode, langId and gameId
        var snapshotUrl = snapshot.ref.toString();
        var splitUrl = snapshotUrl.split("/");

        var gameId = parseInt(splitUrl[splitUrl.length - 1]);
        var clientCode = splitUrl[splitUrl.length - 4];

        var enGameUid = createGameUid(clientCode, gameId, 1);
        var frGameUid = createGameUid(clientCode, gameId, 2);

        if (gameClockCallbacks[enGameUid]) {
            // Update english clocks
            gameClockCallbacks[enGameUid].runningClockData = snapshot.val();
            notifyGameClockListeners(enGameUid);
        }

        if (gameClockCallbacks[frGameUid]) {
            // Update french clocks
            gameClockCallbacks[frGameUid].runningClockData = snapshot.val();
            notifyGameClockListeners(frGameUid);
        }
    };

    var handleGameScoringUpdate = function handleGameScoringUpdate(snapshot) {
        // Get clientCode, langId and gameId
        var snapshotUrl = snapshot.ref.toString();
        var splitUrl = snapshotUrl.split("/");

        var gameId = parseInt(splitUrl[8]);
        var langId = parseInt(splitUrl[6]);
        var clientCode = splitUrl[4];

        var gameUid = createGameUid(clientCode, gameId, langId);

        gameScoringCallbacks[gameUid].scoringData = snapshot.val();

        notifyGameScoringListeners(gameUid);
    };

    var handleGameMVPsUpdate = function handleGameMVPsUpdate(snapshot) {
        // Get clientCode, langId and gameId
        var snapshotUrl = snapshot.ref.toString();
        var splitUrl = snapshotUrl.split("/");

        var gameId = parseInt(splitUrl[8]);
        var langId = parseInt(splitUrl[6]);
        var clientCode = splitUrl[4];

        var gameUid = createGameUid(clientCode, gameId, langId);

        gameMVPsCallbacks[gameUid].mvpsData = snapshot.val();

        notifyGameMVPsListeners(gameUid);
    };

    var notifyGameClockListeners = function notifyGameClockListeners(gameUid) {
        if (!gameClockCallbacksEmpty(gameUid)) {
            angular.forEach(gameClockCallbacks[gameUid].listenerCallbacks, function (listenerCallback) {
                listenerCallback(combineClocks(gameClockCallbacks[gameUid].publishedClockData, gameClockCallbacks[gameUid].runningClockData));
            });
        }
    };

    var notifyGameGoalSummaryListeners = function notifyGameGoalSummaryListeners(gameUid) {
        if (!gameGoalSummaryCallbacksEmpty(gameUid)) {
            angular.forEach(gameGoalSummaryCallbacks[gameUid].listenerCallbacks, function (listenerCallback) {
                var lsGameId = getGameIdFromGameUid(gameUid);

                if (gameGoalSummaryCallbacks[gameUid].goalSummaryData) {
                    gameGoalSummaryCallbacks[gameUid].goalSummaryData.GameId = parseInt(lsGameId);
                }
                listenerCallback(gameGoalSummaryCallbacks[gameUid].goalSummaryData);
            });
        }
    };

    var notifyGamePenaltySummaryListeners = function notifyGamePenaltySummaryListeners(gameUid) {
        if (!gamePenaltySummaryCallbacksEmpty(gameUid)) {
            angular.forEach(gamePenaltySummaryCallbacks[gameUid].listenerCallbacks, function (listenerCallback) {
                listenerCallback(gamePenaltySummaryCallbacks[gameUid].penaltySummaryData);
            });
        }
    };

    var notifyGameShotSummaryListeners = function notifyGameShotSummaryListeners(gameUid) {
        if (!gameShotSummaryCallbacksEmpty(gameUid)) {
            angular.forEach(gameShotSummaryCallbacks[gameUid].listenerCallbacks, function (listenerCallback) {
                listenerCallback(gameShotSummaryCallbacks[gameUid].shotSummaryData);
            });
        }
    };

    var notifyGamePenaltiesListeners = function notifyGamePenaltiesListeners(gameUid) {
        if (!gamePenaltiesCallbacksEmpty(gameUid)) {
            angular.forEach(gamePenaltiesCallbacks[gameUid].listenerCallbacks, function (listenerCallback) {
                listenerCallback(gamePenaltiesCallbacks[gameUid].penaltiesData);
            });
        }
    };

    var notifyGameScoringListeners = function notifyGameScoringListeners(gameUid) {
        if (!gameScoringCallbacksEmpty(gameUid)) {
            angular.forEach(gameScoringCallbacks[gameUid].listenerCallbacks, function (listenerCallback) {
                listenerCallback(gameScoringCallbacks[gameUid].scoringData);
            });
        }
    };

    var notifyGameMVPsListeners = function notifyGameMVPsListeners(gameUid) {
        if (!gameMVPsCallbacksEmpty(gameUid)) {
            angular.forEach(gameMVPsCallbacks[gameUid].listenerCallbacks, function (listenerCallback) {
                listenerCallback(gameMVPsCallbacks[gameUid].scoringData);
            });
        }
    };

    var removeFromGameClockCallbacks = function removeFromGameClockCallbacks(clientCode, gameId, langId, listenerCallback) {
        var gameUid = createGameUid(clientCode, gameId, langId);

        if (!gameClockCallbacks[gameUid]) {
            console.log("ERROR: removeFromGameClockCallbacks called on callback that is not in our collection of callbacks (place 1)", gameClockCallbacks, gameUid);
            return;
        }

        if (!gameClockCallbacks[gameUid].listenerCallbacks) {
            console.log("ERROR: removeFromGameClockCallbacks called on callback that is not in our collection of callbacks (place 2)", gameClockCallbacks, gameUid);
            return;
        }

        if (!gameClockCallbacks[gameUid].listenerCallbacks.length) {
            console.log("ERROR: removeFromGameClockCallbacks called on callback that is not in our collection of callbacks (place 3)", gameClockCallbacks, gameUid);
            return;
        }

        for (var i = 0; i < gameClockCallbacks[gameUid].listenerCallbacks.length; i++) {
            if (gameClockCallbacks[gameUid].listenerCallbacks[i] == listenerCallback) {
                gameClockCallbacks[gameUid].listenerCallbacks.splice(i, 1);
                return;
            }
        }

        console.log("ERROR: removeFromGameClockCallbacks called on callback that is not in our collection of callbacks (place 4)", gameClockCallbacks, gameUid);
    };

    var removeFromGameGoalSummaryCallbacks = function removeFromGameGoalSummaryCallbacks(clientCode, gameId, langId, listenerCallback) {
        var gameUid = createGameUid(clientCode, gameId, langId);

        if (!gameGoalSummaryCallbacks[gameUid]) {
            console.log("ERROR: removeFromGameGoalSummaryCallbacks called on callback that is not in our collection of callbacks (place 1)", gameGoalSummaryCallbacks, gameUid);
            return;
        }

        if (!gameGoalSummaryCallbacks[gameUid].listenerCallbacks) {
            console.log("ERROR: removeFromGameGoalSummaryCallbacks called on callback that is not in our collection of callbacks (place 2)", gameGoalSummaryCallbacks, gameUid);
            return;
        }

        if (!gameGoalSummaryCallbacks[gameUid].listenerCallbacks.length) {
            console.log("ERROR: removeFromGameGoalSummaryCallbacks called on callback that is not in our collection of callbacks (place 3)", gameGoalSummaryCallbacks, gameUid);
            return;
        }

        for (var i = 0; i < gameGoalSummaryCallbacks[gameUid].listenerCallbacks.length; i++) {
            if (gameGoalSummaryCallbacks[gameUid].listenerCallbacks[i] == listenerCallback) {
                gameGoalSummaryCallbacks[gameUid].listenerCallbacks.splice(i, 1);
                return;
            }
        }

        console.log("ERROR: removeFromGameGoalSummaryCallbacks called on callback that is not in our collection of callbacks (place 4)", gameGoalSummaryCallbacks, gameUid);
    };

    var removeFromGamePenaltySummaryCallbacks = function removeFromGamePenaltySummaryCallbacks(clientCode, gameId, langId, listenerCallback) {
        var gameUid = createGameUid(clientCode, gameId, langId);

        if (!gamePenaltySummaryCallbacks[gameUid]) {
            console.log("ERROR: removeFromGamePenaltySummaryCallbacks called on callback that is not in our collection of callbacks (place 1)", gamePenaltySummaryCallbacks, gameUid);
            return;
        }

        if (!gamePenaltySummaryCallbacks[gameUid].listenerCallbacks) {
            console.log("ERROR: removeFromGamePenaltySummaryCallbacks called on callback that is not in our collection of callbacks (place 2)", gamePenaltySummaryCallbacks, gameUid);
            return;
        }

        if (!gamePenaltySummaryCallbacks[gameUid].listenerCallbacks.length) {
            console.log("ERROR: removeFromGamePenaltySummaryCallbacks called on callback that is not in our collection of callbacks (place 3)", gamePenaltySummaryCallbacks, gameUid);
            return;
        }

        for (var i = 0; i < gamePenaltySummaryCallbacks[gameUid].listenerCallbacks.length; i++) {
            if (gamePenaltySummaryCallbacks[gameUid].listenerCallbacks[i] == listenerCallback) {
                gamePenaltySummaryCallbacks[gameUid].listenerCallbacks.splice(i, 1);
                return;
            }
        }

        console.log("ERROR: removeFromGamePenaltySummaryCallbacks called on callback that is not in our collection of callbacks (place 4)", gamePenaltySummaryCallbacks, gameUid);
    };

    var removeFromGameShotSummaryCallbacks = function removeFromGameShotSummaryCallbacks(clientCode, gameId, langId, listenerCallback) {
        var gameUid = createGameUid(clientCode, gameId, langId);

        if (!gameShotSummaryCallbacks[gameUid]) {
            console.log("ERROR: removeFromGameShotSummaryCallbacks called on callback that is not in our collection of callbacks (place 1)", gameShotSummaryCallbacks, gameUid);
            return;
        }

        if (!gameShotSummaryCallbacks[gameUid].listenerCallbacks) {
            console.log("ERROR: removeFromGameShotSummaryCallbacks called on callback that is not in our collection of callbacks (place 2)", gameShotSummaryCallbacks, gameUid);
            return;
        }

        if (!gameShotSummaryCallbacks[gameUid].listenerCallbacks.length) {
            console.log("ERROR: removeFromGameShotSummaryCallbacks called on callback that is not in our collection of callbacks (place 3)", gameShotSummaryCallbacks, gameUid);
            return;
        }

        for (var i = 0; i < gameShotSummaryCallbacks[gameUid].listenerCallbacks.length; i++) {
            if (gameShotSummaryCallbacks[gameUid].listenerCallbacks[i] == listenerCallback) {
                gameShotSummaryCallbacks[gameUid].listenerCallbacks.splice(i, 1);
                return;
            }
        }

        console.log("ERROR: removeFromGameShotSummaryCallbacks called on callback that is not in our collection of callbacks (place 4)", gameShotSummaryCallbacks, gameUid);
    };

    var removeFromGameScoringCallbacks = function removeFromGameScoringCallbacks(clientCode, gameId, langId, listenerCallback) {
        var gameUid = createGameUid(clientCode, gameId, langId);

        if (!gameScoringCallbacks[gameUid]) {
            console.log("ERROR: removeFromgameScoringCallbacks called on callback that is not in our collection of callbacks (place 1)", gameScoringCallbacks, gameUid);
            return;
        }

        if (!gameScoringCallbacks[gameUid].listenerCallbacks) {
            console.log("ERROR: removeFromgameScoringCallbacks called on callback that is not in our collection of callbacks (place 2)", gameScoringCallbacks, gameUid);
            return;
        }

        if (!gameScoringCallbacks[gameUid].listenerCallbacks.length) {
            console.log("ERROR: removeFromgameScoringCallbacks called on callback that is not in our collection of callbacks (place 3)", gameScoringCallbacks, gameUid);
            return;
        }

        for (var i = 0; i < gameScoringCallbacks[gameUid].listenerCallbacks.length; i++) {
            if (gameScoringCallbacks[gameUid].listenerCallbacks[i] == listenerCallback) {
                gameScoringCallbacks[gameUid].listenerCallbacks.splice(i, 1);
                return;
            }
        }

        console.log("ERROR: removeFromGameScoringCallbacks called on callback that is not in our collection of callbacks (place 4)", gameScoringCallbacks, gameUid);
    };

    var removeFromGamePenaltiesCallbacks = function removeFromGamePenaltiesCallbacks(clientCode, gameId, langId, listenerCallback) {
        var gameUid = createGameUid(clientCode, gameId, langId);

        if (!gamePenaltiesCallbacks[gameUid]) {
            console.log("ERROR: removeFromGamePenaltiesCallbacks called on callback that is not in our collection of callbacks (place 1)", gamePenaltiesCallbacks, gameUid);
            return;
        }

        if (!gamePenaltiesCallbacks[gameUid].listenerCallbacks) {
            console.log("ERROR: removeFromGamePenaltiesCallbacks called on callback that is not in our collection of callbacks (place 2)", gamePenaltiesCallbacks, gameUid);
            return;
        }

        if (!gamePenaltiesCallbacks[gameUid].listenerCallbacks.length) {
            console.log("ERROR: removeFromGamePenaltiesCallbacks called on callback that is not in our collection of callbacks (place 3)", gamePenaltiesCallbacks, gameUid);
            return;
        }

        for (var i = 0; i < gamePenaltiesCallbacks[gameUid].listenerCallbacks.length; i++) {
            if (gamePenaltiesCallbacks[gameUid].listenerCallbacks[i] == listenerCallback) {
                gamePenaltiesCallbacks[gameUid].listenerCallbacks.splice(i, 1);
                return;
            }
        }

        console.log("ERROR: removeFromGameShotSummaryCallbacks called on callback that is not in our collection of callbacks (place 4)", gamePenaltiesCallbacks, gameUid);
    };

    var removeFromGameMVPsCallbacks = function removeFromGameMVPsCallbacks(clientCode, gameId, langId, listenerCallback) {
        var gameUid = createGameUid(clientCode, gameId, langId);

        if (!gameMVPsCallbacks[gameUid]) {
            console.log("ERROR: removeFromgameMVPsCallbacks called on callback that is not in our collection of callbacks (place 1)", gameMVPsCallbacks, gameUid);
            return;
        }

        if (!gameMVPsCallbacks[gameUid].listenerCallbacks) {
            console.log("ERROR: removeFromgameMVPsCallbacks called on callback that is not in our collection of callbacks (place 2)", gameMVPsCallbacks, gameUid);
            return;
        }

        if (!gameMVPsCallbacks[gameUid].listenerCallbacks.length) {
            console.log("ERROR: removeFromgameMVPsCallbacks called on callback that is not in our collection of callbacks (place 3)", gameMVPsCallbacks, gameUid);
            return;
        }

        for (var i = 0; i < gameMVPsCallbacks[gameUid].listenerCallbacks.length; i++) {
            if (gameMVPsCallbacks[gameUid].listenerCallbacks[i] == listenerCallback) {
                gameMVPsCallbacks[gameUid].listenerCallbacks.splice(i, 1);
                return;
            }
        }

        console.log("ERROR: removeFromGameShotSummaryCallbacks called on callback that is not in our collection of callbacks (place 4)", gameMVPsCallbacks, gameUid);
    };

    // TODO: Subscribe to the game clocks by date (used in the daily schedule)
    var subscribeToDateClock = function subscribeToDateClock(clientCode, subscribeDate, langId) {
        if (!clientCode) console.log("ERROR: svfFb::openDateClockSubscription got a bad clientCode param - ", clientCode);
        if (!subscribeDate) console.log("ERROR: svfFb::openDateClockSubscription got a bad subscribeDate param - ", subscribeDate);
        if (!langId || langId > 2) console.log("ERROR: svfFb::openDateClockSubscription got a bad langId param - ", langId);

        // ...
    };

    var subscribeToGameClock = function subscribeToGameClock(clientCode, gameId, langId, listenerCallback) {
        if (!gameId) console.log("ERROR: svfFb::subscribeToGameClock saw an invalid gameId ", gameId);
        if (!langId || langId > 1) console.log("ERROR: svfFb::subscribeToGameClock saw an invalid langId param ", langId);
        if (!listenerCallback) console.log("ERROR: svfFb::subscribeToGameClock saw an invalid listenerCallback param ", listenerCallback);

        var subscribeToFb = false;

        if (gameClockCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
            // Determine if this is the first subscription.
            subscribeToFb = true;
        }

        addToGameClockCallbacks(clientCode, gameId, langId, listenerCallback);
        if (gameClockCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
            console.log("ERROR: svfFb::subscribeToGameClock saw an inconsistency where the callbacks are empty after adding to the callbacks", gameClockCallbacks, clientCode, gameId, langId, listenerCallback);
        }

        if (subscribeToFb) {
            // Open up the firebase listeners.
            databaseRef.child("/svf/" + clientCode + "/publishedclock/" + langId + "/games/" + gameId).on('value', handlePublishedClockUpdate);
            databaseRef.child("/svf/" + clientCode + "/runningclock/games/" + gameId).on('value', handleRunningClockUpdate);
        }

        return;
    };

    var subscribeToGameGoalSummary = function subscribeToGameGoalSummary(clientCode, gameId, langId, listenerCallback) {

        if (!gameId) console.log("ERROR: svfFb::subscribeToGameGoalSummary saw an invalid gameId ", gameId);
        if (!langId || langId > 1) console.log("ERROR: svfFb::subscribeToGameGoalSummary saw an invalid langId param ", langId);
        if (!listenerCallback) console.log("ERROR: svfFb::subscribeToGameGoalSummary saw an invalid listenerCallback param ", listenerCallback);

        var subscribeToFb = false;

        if (gameGoalSummaryCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
            subscribeToFb = true;
        }

        addToGameGoalSummaryCallbacks(clientCode, gameId, langId, listenerCallback);
        if (gameGoalSummaryCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
            console.log("ERROR: svfFb::subscribeToGameGoalSummary saw an inconsistency where the callbacks are empty after adding to it", gameGoalSummaryCallbacks);
        }

        if (subscribeToFb) {
            databaseRef.child("/svf/" + clientCode + "/goalssummary/" + langId + "/games/" + gameId).on('value', handleGameGoalSummaryUpdate);
        }

        return;
    };

    var subscribeToGamePenaltySummary = function subscribeToGamePenaltySummary(clientCode, gameId, langId, listenerCallback) {

        if (!gameId) console.log("ERROR: svfFb::subscribeToGamePenaltySummary saw an invalid gameId ", gameId);
        if (!langId || langId > 1) console.log("ERROR: svfFb::subscribeToGamePenaltySummary saw an invalid langId param ", langId);
        if (!listenerCallback) console.log("ERROR: svfFb::subscribeToGamePenaltySummary saw an invalid listenerCallback param ", listenerCallback);

        var subscribeToFb = false;

        if (gamePenaltySummaryCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
            subscribeToFb = true;
        }

        addToGamePenaltySummaryCallbacks(clientCode, gameId, langId, listenerCallback);
        if (gamePenaltySummaryCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
            console.log("ERROR: svfFb::subscribeToGamePenaltySummary saw an inconsistency where the callbacks are empty after adding to it", gamePenaltySummaryCallbacks);
        }

        if (subscribeToFb) {
            databaseRef.child("/svf/" + clientCode + "/penaltiessummary/" + langId + "/games/" + gameId).on('value', handleGamePenaltySummaryUpdate);
        }

        return;
    };

    var subscribeToGameShotSummary = function subscribeToGameShotSummary(clientCode, gameId, langId, listenerCallback) {

        if (!gameId) console.log("ERROR: svfFb::subscribeToGameShotSummary saw an invalid gameId ", gameId);
        if (!langId || langId > 1) console.log("ERROR: svfFb::subscribeToGameShotSummary saw an invalid langId param ", langId);
        if (!listenerCallback) console.log("ERROR: svfFb::subscribeToGameShotSummary saw an invalid listenerCallback param ", listenerCallback);

        var subscribeToFb = false;

        if (gameShotSummaryCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
            subscribeToFb = true;
        }

        addToGameShotSummaryCallbacks(clientCode, gameId, langId, listenerCallback);
        if (gameShotSummaryCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
            console.log("ERROR: svfFb::subscribeToGameShotSummary saw an inconsistency where the callbacks are empty after adding to it", gameShotSummaryCallbacks);
        }

        if (subscribeToFb) {
            databaseRef.child("/svf/" + clientCode + "/shotssummary/" + langId + "/games/" + gameId).on('value', handleGameShotSummaryUpdate);
        }

        return;
    };

    var subscribeToGamePenalties = function subscribeToGamePenalties(clientCode, gameId, langId, listenerCallback) {
        if (!gameId) console.log("ERROR: svfFb::subscribeToGamePenalties saw an invalid gameId ", gameId);
        if (!langId || langId > 1) console.log("ERROR: svfFb::subscribeToGamePenalties saw an invalid langId param ", langId);
        if (!listenerCallback) console.log("ERROR: svfFb::subscribeToGamePenalties saw an invalid listenerCallback param ", listenerCallback);

        var subscribeToFb = false;

        if (gamePenaltiesCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
            subscribeToFb = true;
        }

        addToGamePenaltiesCallbacks(clientCode, gameId, langId, listenerCallback);
        if (gamePenaltiesCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
            console.log("ERROR: svfFb::subscribeToGamePenalties saw an inconsistency where the callbacks are empty after adding to it", gamePenaltiesCallbacks);
        }

        if (subscribeToFb) {
            databaseRef.child("/svf/" + clientCode + "/penalties/" + langId + "/games/" + gameId).on('value', handleGamePenaltiesUpdate);
        }

        return;
    };

    var subscribeToGameScoring = function subscribeToGameScoring(clientCode, gameId, langId, listenerCallback) {
        if (!gameId) console.log("ERROR: svfFb::subscribeToGameScoring saw an invalid gameId ", gameId);
        if (!langId || langId > 1) console.log("ERROR: svfFb::subscribeToGameScoring saw an invalid langId param ", langId);
        if (!listenerCallback) console.log("ERROR: svfFb::subscribeToGameScoring saw an invalid listenerCallback param ", listenerCallback);

        var subscribeToFb = false;
        var gameUid = createGameUid(clientCode, gameId, langId);

        if (gameScoringCallbacksEmpty(gameUid)) {
            subscribeToFb = true;
        }

        addToGameScoringCallbacks(clientCode, gameId, langId, listenerCallback);
        if (gameScoringCallbacksEmpty(gameUid)) {
            console.log("ERROR: svfFb::subscribeToGameScoring saw an inconsistency where the callbacks are empty after adding to it", gameShotSummaryCallbacks);
        }

        if (subscribeToFb) {
            var fbPath = "/svf/" + clientCode + "/goals/" + langId + "/games/" + gameId + "/GameGoals";
            databaseRef.child(fbPath).on('value', handleGameScoringUpdate);
        }

        return;
    };

    var subscribeToGameMVPs = function subscribeToGameMVPs(clientCode, gameId, langId, listenerCallback) {
        if (!gameId) console.log("ERROR: svfFb::subscribeToGameMVPs saw an invalid gameId ", gameId);
        if (!langId || langId > 1) console.log("ERROR: svfFb::subscribeToGameMVPs saw an invalid langId param ", langId);
        if (!listenerCallback) console.log("ERROR: svfFb::subscribeToGameMVPs saw an invalid listenerCallback param ", listenerCallback);

        var subscribeToFb = false;
        var gameUid = createGameUid(clientCode, gameId, langId);

        if (gameMVPsCallbacksEmpty(gameUid)) {
            subscribeToFb = true;
        }

        addToGameMVPsCallbacks(clientCode, gameId, langId, listenerCallback);
        if (gameMVPsCallbacksEmpty(gameUid)) {
            console.log("ERROR: svfFb::subscribeToGameMVPs saw an inconsistency where the callbacks are empty after adding to it", gameMVPsCallbacks);
        }

        if (subscribeToFb) {
            var fbPath = "/svf/" + clientCode + "/mvps/" + langId + "/games/" + gameId;
            databaseRef.child(fbPath).on('value', handleGameMVPsUpdate);
        }

        return;
    };

    var unsubscribeFromGameClock = function unsubscribeFromGameClock(clientCode, gameId, langId, listenerCallback) {

        removeFromGameClockCallbacks(clientCode, gameId, langId, listenerCallback);

        if (gameClockCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
            // Close down the firebase listeners
            databaseRef.child("/svf/" + clientCode + "/publishedclock/" + langId + "/games/" + gameId).off('value', handlePublishedClockUpdate);
            databaseRef.child("/svf/" + clientCode + "/runningclock/games/" + gameId).off('value', handleRunningClockUpdate);
        }
    };

    var unsubscribeFromGameGoalSummary = function unsubscribeFromGameGoalSummary(clientCode, gameId, langId, listenerCallback) {

        removeFromGameGoalSummaryCallbacks(clientCode, gameId, langId, listenerCallback);

        if (gameGoalSummaryCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
            databaseRef.child("/svf/" + clientCode + "/goalssummary/" + langId + "/games/" + gameId).off('value', handleGameGoalSummaryUpdate);
        }
    };

    var unsubscribeFromGamePenaltySummary = function unsubscribeFromGamePenaltySummary(clientCode, gameId, langId, listenerCallback) {

        removeFromGamePenaltySummaryCallbacks(clientCode, gameId, langId, listenerCallback);

        if (gamePenaltySummaryCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
            databaseRef.child("/svf/" + clientCode + "/penaltiessummary/" + langId + "/games/" + gameId).off('value', handleGamePenaltySummaryUpdate);
        }
    };

    var unsubscribeFromGameShotSummary = function unsubscribeFromGameShotSummary(clientCode, gameId, langId, listenerCallback) {

        removeFromGameShotSummaryCallbacks(clientCode, gameId, langId, listenerCallback);

        if (gameShotSummaryCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
            databaseRef.child("/svf/" + clientCode + "/shotssummary/" + langId + "/games/" + gameId).off('value', handleGameShotSummaryUpdate);
        }
    };

    var unsubscribeFromGamePenalties = function unsubscribeFromGamePenalties(clientCode, gameId, langId, listenerCallback) {

        removeFromGamePenaltiesCallbacks(clientCode, gameId, langId, listenerCallback);

        if (gamePenaltiesCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
            databaseRef.child("/svf/" + clientCode + "/penalties/" + langId + "/games/" + gameId).off('value', handleGamePenaltiesUpdate);
        }
    };

    var unsubscribeFromGameScoring = function unsubscribeFromGameScoring(clientCode, gameId, langId, listenerCallback) {

        removeFromGameScoringCallbacks(clientCode, gameId, langId, listenerCallback);

        if (gameScoringCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
            databaseRef.child("/svf/" + clientCode + "/goals/" + langId + "/games/" + gameId + "/GameGoals").off('value', handleGameShotSummaryUpdate);
        }
    };

    var unsubscribeFromGameMVPs = function unsubscribeFromGameMVPs(clientCode, gameId, langId, listenerCallback) {

        removeFromGameMVPsCallbacks(clientCode, gameId, langId, listenerCallback);

        if (gameMVPsCallbacksEmpty(createGameUid(clientCode, gameId, langId))) {
            databaseRef.child("/svf/" + clientCode + "/goals/" + langId + "/games/" + gameId).off('value', handleGameMVPsUpdate);
        }
    };

    return {
        authenticate: authenticate,
        subscribeToGameClock: subscribeToGameClock,
        subscribeToGamePenalties: subscribeToGamePenalties,
        subscribeToGameGoalSummary: subscribeToGameGoalSummary,
        subscribeToGamePenaltySummary: subscribeToGamePenaltySummary,
        subscribeToGameShotSummary: subscribeToGameShotSummary,
        subscribeToGameScoring: subscribeToGameScoring,
        subscribeToGameMVPs: subscribeToGameMVPs,
        unsubscribeFromGameClock: unsubscribeFromGameClock,
        unsubscribeFromGameGoalSummary: unsubscribeFromGameGoalSummary,
        unsubscribeFromGamePenaltySummary: unsubscribeFromGamePenaltySummary,
        unsubscribeFromGameShotSummary: unsubscribeFromGameShotSummary,
        unsubscribeFromGameScoring: unsubscribeFromGameScoring,
        unsubscribeFromGamePenalties: unsubscribeFromGamePenalties,
        unsubscribeFromGameMVPs: unsubscribeFromGameMVPs
    };
}]);

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(53);

angular.module('app.player.telestrate.telestrateControlsDirective', ['app.player.telestrate.telestrateControlsController']).directive('telestrateControls', [function () {
  "use strict";

  return {
    restrict: 'EA',
    templateUrl: 'components/player/telestrate/telestrateControls/telestrateControlsView.html',
    controller: 'app.player.telestrate.telestrateControlsController',
    scope: {
      toolbox: '='
    }
  };
}]);

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.player.telestrate.telestrateControlsController', []).controller('app.player.telestrate.telestrateControlsController', ['$scope', function ($scope) {
  "use strict";

  $scope.toolbox = $scope.toolbox || null;
  $scope.colorClassSuffix = $scope.toolbox.color;

  var setFillDiameter = function setFillDiameter(size, type) {
    switch (size) {
      case 'x-small':
        if (type == 'eraser') {
          $scope.toolbox.fillDiameter = 4;
        } else {
          $scope.toolbox.fillDiameter = 2;
        }
        break;
      case 'small':
        if (type == 'eraser') {
          $scope.toolbox.fillDiameter = 12;
        } else {
          $scope.toolbox.fillDiameter = 6;
        }
        break;
      case 'medium':
        if (type == 'eraser') {
          $scope.toolbox.fillDiameter = 20;
        } else {
          $scope.toolbox.fillDiameter = 10;
        }
        break;
      case 'large':
        if (type == 'eraser') {
          $scope.toolbox.fillDiameter = 28;
        } else {
          $scope.toolbox.fillDiameter = 14;
        }
        break;
      default:
        $scope.toolbox.fillDiameter = 10;
    }
  };

  $scope.telestrateReturnColorClass = function (color) {
    return 'video-player__telestrate__color-div__color--' + color;
  };

  $scope.telestrateReturnBrushClass = function (size) {
    return 'video-player__telestrate__brush-div__brush--' + size;
  };

  $scope.telestrateReturnEraserClass = function (size) {
    return 'video-player__telestrate__eraser-div__eraser--' + size;
  };

  $scope.telestrateColorClick = function (color) {

    var colors = {
      blue: '#0076ff',
      red: '#e92a25',
      yellow: '#f8e71c',
      green: '#7ed321',
      orange: '#f5a623',
      white: '#fff',
      gray: '#999',
      black: '#383838'
    };

    $scope.colorClassSuffix = color;
    $scope.toolbox.color = colors[color] || '#0076ff';
  };

  $scope.telestrateBrushClick = function (size) {
    $scope.toolbox.isClearing = false;

    $scope.toolbox.brush = size;
    $scope.toolbox.eraser = 'brush';

    setFillDiameter(size, 'brush');
  };

  $scope.telestrateEraserClick = function (size) {
    $scope.toolbox.isClearing = true;

    $scope.toolbox.eraser = size;
    $scope.toolbox.brush = 'eraser';

    setFillDiameter(size, 'eraser');
  };

  $scope.telestrateClearAllClick = function () {
    $scope.toolbox.clearCanvas = true;
  };

  var init = function init() {};

  init();
}]);

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(55);

angular.module('app.player.telestrate.telestrateCanvasDirective', ['app.player.telestrate.telestrateCanvasController']).directive('telestrateCanvas', [function () {
  "use strict";

  return {
    restrict: 'A',
    controller: 'app.player.telestrate.telestrateCanvasController',
    scope: {
      toolbox: '=',
      activeTab: '=',
      telestrateTab: '='
    },
    link: function link(scope, elm) {
      elm.on('mousedown', scope.teleStrateStartDraw);
      elm.on('mouseup', scope.telestrateEndDraw);
      elm.on('mouseleave', scope.telestrateEndDraw);
      elm.on('mousemove', scope.telestrateDraw);

      scope.canvas = elm[0];
      scope.canvasContext = scope.canvas.getContext("2d");
    }
  };
}]);

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.player.telestrate.telestrateCanvasController', []).controller('app.player.telestrate.telestrateCanvasController', ['$scope', function ($scope) {
  "use strict";

  $scope.canvasContext = $scope.canvasContext || null;
  $scope.telestrateIsDrawing = false;
  //$scope.telestrateSmall = false;
  $scope.toolbox = $scope.toolbox || null;

  $scope.teleStrateStartDraw = function (evt) {
    //only start drawing if telestrate tab is active
    if ($scope.activeTab == $scope.telestrateTab) {

      //start of drawing, so flip to drawing mode
      $scope.telestrateIsDrawing = true;

      //setup the lastX and lastY here
      //used as origin in line drawing
      $scope.toolbox.lastX = evt.offsetX;
      $scope.toolbox.lastY = evt.offsetY;

      //bounce event to main draw function
      $scope.telestrateDraw(evt);
    }
  };

  $scope.telestrateEndDraw = function () {
    $scope.telestrateIsDrawing = false;
  };

  $scope.telestrateDraw = function (evt) {

    //mousemove calls this function, which means that many calls must be ignored
    //if user is not actively drawing on telestrator, therefore do nothing if
    //not in drawing mode
    if ($scope.telestrateIsDrawing) {

      if ($scope.toolbox.isClearing) {
        //clearRect used for eraser tool
        $scope.canvasContext.clearRect(evt.offsetX, evt.offsetY, $scope.toolbox.fillDiameter, $scope.toolbox.fillDiameter);
      } else {
        //set stroke & fill colouring
        $scope.canvasContext.fillStyle = $scope.toolbox.color;
        $scope.canvasContext.strokeStyle = $scope.toolbox.color;

        if ($scope.toolbox.lastX != evt.offsetX || $scope.toolbox.lastY != evt.offsetY) {

          //lineTo used for 2..n points that are to be drawn on telestrator mouse stroke
          $scope.canvasContext.beginPath();
          $scope.canvasContext.moveTo($scope.toolbox.lastX, $scope.toolbox.lastY);
          $scope.canvasContext.lineTo(evt.offsetX, evt.offsetY);
          $scope.canvasContext.lineWidth = $scope.toolbox.fillDiameter;
          $scope.canvasContext.stroke();

          //copy last mouse position for use in next line stroke
          $scope.toolbox.lastX = evt.offsetX;
          $scope.toolbox.lastY = evt.offsetY;
        } else {
          //fillRect used for 1st point drawn on telestrator brush stroke
          $scope.canvasContext.fillRect(evt.offsetX, evt.offsetY, $scope.toolbox.fillDiameter, $scope.toolbox.fillDiameter);
        }
      }

      // stop clicks from bubbling down to the player
      // but only if we're drawing - else pass through
      evt.stopPropagation();
    }
  };

  // let setSmallcanvas = function () {
  //   if (!$scope.telestrateSmall) {
  //     if($scope.canvas) {
  //       $scope.canvasContext.clearRect(0, 0, $scope.canvas.width, $scope.canvas.height);
  //       $scope.telestrateSmall = true;
  //       $scope.canvas.width = 320;
  //       $scope.canvas.height = 240;
  //     }
  //   }
  // };

  // let setLargeCanvas = function () {
  //   if ($scope.telestrateSmall) {
  //     if($scope.canvas) {
  //       $scope.canvasContext.clearRect(0, 0, $scope.canvas.width, $scope.canvas.height);
  //       $scope.telestrateSmall = false;
  //       $scope.canvas.width = 640;
  //       $scope.canvas.height = 440;
  //     }
  //   }
  // };

  var canvasResize = function canvasResize() {
    //canvas container use since canvas does not exist yet
    var getCanvas = document.getElementById('tele-canvas');
    var playerWidth = getCanvas.offsetWidth;
    var playerHeight = playerWidth / 1.77777777778; //16:9 format
    //canvas element
    getCanvas.children["0"].width = playerWidth;
    getCanvas.children["0"].height = playerHeight;
  };

  var init = function init() {

    canvasResize();

    // if ($(window).width() <= 660) {
    //   setSmallcanvas();
    // }
  };

  $(window).on("resize.doResize", _.debounce(function () {

    canvasResize();

    // let windowWidth = $(window).width();

    // if (windowWidth <= 660) {
    //   setSmallcanvas();
    // } else {
    //   setLargeCanvas();
    // }
  }, 100)); //debounce resolution 100ms

  $scope.$on("$destroy", function () {
    $(window).off("resize.doResize");
  });

  $scope.$watch(function () {
    return $scope.toolbox.clearCanvas;
  }, function () {
    if ($scope.toolbox.clearCanvas && $scope.canvasContext) {
      $scope.canvasContext.clearRect(0, 0, $scope.canvas.width, $scope.canvas.height);
      $scope.toolbox.clearCanvas = false;
    }
  });

  init();
}]);

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(15);

angular.module('app.shared.clockTimeUnit.clockTimeUnitDirective', ['app.shared.dataTransformers.clockTimeTransformer']).directive('clockTimeUnit', ['$filter', '$browser', 'app.shared.dataTransformers.clockTimeTransformer', function ($filter, $browser, clockTimeTransformer) {
  "use strict";

  return {
    require: 'ngModel',
    restrict: 'A',
    scope: {
      clockTime: '=?',
      unit: '@?'
    },
    link: function link($scope, $el, $attrs, ngModelCtrl) {
      var formatValue = function formatValue() {
        var value = ngModelCtrl.$viewValue;
        value = $filter('number')(value, 0);
        if (value > 60) {
          value = 60;
        }
        value = clockTimeTransformer.formatUnit(value);
        return value;
      };

      var listener = function listener() {
        $el.val(formatValue());
      };

      ngModelCtrl.$render = function () {
        listener();
      };

      $el.bind('change', listener);
      $el.bind('keydown', function (event) {
        var key = parseInt(event.keyCode);

        if (key === 91 || 15 < key && key < 19 || 37 <= key && key <= 40) return;
        $browser.defer(listener);
      });
      $el.bind('paste cut', function () {
        $browser.defer(listener);
      });
    }
  };
}]);

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

'use strict';

angular.module('app.shared.clipFilter', ['app.shared.clipCategoryService']).filter('clipIsCategoryType', ['app.shared.clipCategoryService', function (clipCategoryService) {
  return function (clipCategory, types) {
    return clipCategoryService.isType(clipCategory, types);
  };
}]).filter('clipIsCategoryTeam', ['app.shared.clipCategoryService', function (clipCategoryService) {
  return function (clipCategory, team) {
    return clipCategoryService.isTeam(clipCategory, team);
  };
}]);

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(27);
__webpack_require__(59);
__webpack_require__(22);
__webpack_require__(1);

angular.module('app.httpInterceptors', ['app.mainErrorService', 'app.serverTimeService', 'app.ipAddressService', 'app.currentUser']).config(['$httpProvider', function ($httpProvider) {
  'use strict';

  return $httpProvider.interceptors.push('countHttpConnections', 'appendHeaders', 'updateSession', 'errorHandler', 'checkUserLoginStatus');
}]).factory('httpConnectionCounter', [function () {
  'use strict';

  var counter = void 0;
  return counter = {
    count: 0,
    increment: function increment() {
      if (counter.count < 0) {
        counter.count = 0;
      }
      return counter.count += 1;
    },
    decrement: function decrement() {
      if (counter.count < 0) {
        counter.count = 0;
      }
      return counter.count -= 1;
    }
  };
}]).factory('countHttpConnections', ['httpConnectionCounter', function (httpConnectionCounter) {
  'use strict';

  return {
    request: function request(config) {
      httpConnectionCounter.increment();
      return config;
    },
    response: function response(config) {
      httpConnectionCounter.decrement();
      return config;
    },
    responseError: function responseError(config) {
      httpConnectionCounter.decrement();
      return config;
    }
  };
}]).factory('appendHeaders', ['appKey', 'ipAddress', 'PRODUCT', 'hostnameMatchService', function (appKey, ipAddress, product, hostnameMatchService) {
  'use strict';

  return {
    request: function request(config) {
      if (config.url.match(/.+\.[hockeytv].+/) || config.url.match(/.+\.[ahltv].+/) || config.url.match(/:\/\/localhost/)) {

        config.headers['APP_KEY'] = appKey.app_key;
        config.headers['API_KEY'] = appKey.user_key;
        config.headers['APP_ID'] = appKey.app_id;
        config.headers['PLATFORM'] = window.location.platform(undefined, hostnameMatchService.hostname());
        config.headers['UI_VERSION'] = window.uiVersion;
        config.headers['PRODUCT_ID'] = product.Id;
        // config.headers['IP_ADDRESS'] = ipAddress.address ? ipAddress.address : '';

        if (config.url.match(/.+\.dev\.hockeytv\.com/)) {
          config.headers['Authorization'] = 'Basic c3RhZmY6b3ZlcnR1cmU=';
        }
      }
      return config;
    }
  };
}]).factory('updateSession', ['$injector', function ($injector) {
  'use strict';

  return {
    last_update: null,
    request: function request(config) {
      var currentUser = void 0;

      if (config.url.match(/.+\.hockeytv\.com/) || config.url.match(/:\/\/localhost:8081/)) {
        if (!currentUser) {
          currentUser = $injector.get('currentUser');
        }

        if (!currentUser.last_updated_session) {
          currentUser.last_updated_session = new Date().getTime();
        }

        var currentTime = new Date().getTime();

        if (currentTime - currentUser.last_updated_session >= 300000) {
          config.headers['session_data'] = 'update_session';
          currentUser.last_updated_session = new Date().getTime();
        }
      }
      return config;
    },

    response: function response(config) {
      var currentUser = void 0;

      if (config.config.url.match(/api(\.[a-zA-Z0-9_-]+)?\.hockeytv\.com/) || config.config.url.match(/:\/\/localhost:8081/)) {
        var headers = config.headers();
        if (!currentUser) {
          currentUser = $injector.get('currentUser');
        }

        if (typeof headers['session_data'] !== 'undefined') {
          var sessionDataJson = headers['session_data'];
          var session_data = sessionDataJson === 'null' ? null : sessionDataJson ? JSON.parse(sessionDataJson) : null;
          currentUser.set_data(session_data, null);
        }
      }
      return config;
    }
  };
}]).factory('errorHandler', ['mainError', 'serverTime', function (mainError, serverTime) {
  'use strict';

  return {
    response: function response(config) {
      var server_time = void 0;
      server_time = config.headers('SERVER_TIME');
      if (server_time) {
        serverTime.set(server_time);
      }
      if (config.data && config.data.error) {
        mainError.set(config.data.error, 'warning');
      }
      return config;
    },
    responseError: function responseError(config) {
      if (config.data && config.data.error) {
        mainError.set(config.data.error, 'error');
      }
      return config;
    }
  };
}]).factory('checkUserLoginStatus', ['hostnameMatchService', '$rootScope', function (hostnameMatch, $rootScope) {
  'use strict';

  return {
    response: function response(config) {
      if (hostnameMatch.is_api(config.config.url)) {
        if (config.headers('USER_LOGGED_IN') !== null) {
          var user_logged_in = parseInt(config.headers('USER_LOGGED_IN'));
          if (user_logged_in !== 1) {
            $rootScope.$broadcast('logout_user');
          }
        }
      }
      return config;
    },
    responseError: function responseError(config) {
      return config;
    }
  };
}]);

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.serverTimeService', []).factory('serverTime', [function () {
    return {
        value: null,
        unix: null,
        set: function set(time) {
            this.unix = time;
            return this.value = moment.unix(time);
        }
    };
}]);

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1);

angular.module('app.pricing.plans.plansService', ['app.currentUser']).factory('app.pricing.plans.plansService', ['$http', '$httpParamSerializerJQLike', '$q', 'currentUser', '$rootScope', function ($http, $httpParamSerializerJQLike, $q, currentUser, $rootScope) {
  'use strict';

  var plans = {
    list: null,
    error: null,
    retrieve: function retrieve(params, options) {
      if (plans.list) {
        plans.list = null;
      }

      if (typeof options === 'undefined') {
        options = {};
      }
      options = angular.extend({
        sort: true
      }, options);
      params = $httpParamSerializerJQLike(params);

      var deferred = $q.defer();

      $http.get(window.location.api('subscriptions/plans?' + params)).then(function (response) {
        var data = response.data;
        var resolve_now = true;

        if (data) {
          if (data.plans) {
            plans.list = data.plans;

            plans.list.sort(function (a, b) {
              if (a.unit_price > b.unit_price) return -1;
              if (a.unit_price < b.unit_price) return 1;
              return 0;
            });
          }

          if (data.error) {
            resolve_now = false;

            plans.error = data.error;
            deferred.reject(data.error);
          } else {
            plans.error = null;
          }
        }

        if (resolve_now) {
          deferred.resolve(data);
        }
      });

      return deferred.promise;
    }
  };
  return plans;
}]);

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.shared.teamService', []).factory('app.shared.teamService', ['$http', '$httpParamSerializerJQLike', function ($http, $httpParamSerializerJQLike) {
  return {
    getTeam: function getTeam(teamId) {
      return $http.get(window.location.api('teams/' + teamId));
    },
    getTeams: function getTeams(filter) {
      if (filter) {
        filter = '?filter=' + filter;
      } else {
        filter = '';
      }

      return $http.get(window.location.api('teams' + filter));
    },
    getByAccess: function getByAccess(options) {
      options = $httpParamSerializerJQLike(options);
      return $http.get(window.location.api('teams_by_access?' + options));
    },
    getOpponents: function getOpponents(team_id, options) {
      options = $httpParamSerializerJQLike(options);
      return $http.get(window.location.api('teams/' + team_id + '/opponents?' + options));
    },
    getTeamsOpponents: function getTeamsOpponents(options) {
      options = $httpParamSerializerJQLike(options);
      return $http.get(window.location.api('teams_opponents?' + options));
    },
    getPlayers: function getPlayers(team_id, options) {
      options = $httpParamSerializerJQLike(options);
      return $http.get(window.location.api('teams/' + team_id + '/players?' + options));
    },
    getTeamsPlayers: function getTeamsPlayers(options) {
      options = $httpParamSerializerJQLike(options);
      return $http.get(window.location.api('teams_players?' + options));
    }
  };
}]);

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.productService', []).factory('app.productService', ['PRODUCT', function (PRODUCT) {
  "use strict";

  var service = {
    useTeamSubscriptions: function useTeamSubscriptions() {
      switch (PRODUCT.Code) {
        case 'ahl':
          return true;
        case 'htv':
        default:
          return false;
      }
    },

    isSubscriptionPauseEnabled: function isSubscriptionPauseEnabled() {
      switch (PRODUCT.Code) {
        case 'ahl':
          return false;
        case 'htv':
        default:
          return true;
      }
    },

    isSubscriptionUpgradeableIfCancelled: function isSubscriptionUpgradeableIfCancelled() {
      switch (PRODUCT.Code) {
        case 'ahl':
          return true;
        case 'htv':
        default:
          return false;
      }
    },

    planUsesTeams: function planUsesTeams(plan) {
      switch (PRODUCT.Code) {
        case 'ahl':
          switch (plan.type) {
            case 'league':
            case 'global':
            default:
              return false;
            case 'team_all':
            case 'team_home':
            case 'team_away':
              return true;
          }
          break;
        case 'htv':
          switch (plan.type) {
            case 'global':
            default:
              return false;
          }
      }
    }
  };

  return service;
}]);

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.shared.leaguesService', []).factory('app.shared.leaguesService', ['$http', '$httpParamSerializerJQLike', 'hostnameMatchService', function ($http, $httpParamSerializerJQLike, hostnameMatchService) {
  return {
    getList: function getList(platform, includes, only) {

      var query = {};

      query.platform = platform ? platform : window.location.platform(undefined, hostnameMatchService.hostname());

      if (includes) {
        query.includes = includes;
      }

      if (only) {
        query.only = only;
      }

      query = $httpParamSerializerJQLike(query);
      return $http.get(window.location.api('leagues?' + query));
    },
    getLeague: function getLeague(league_id) {
      return $http.get(window.location.api('leagues/' + league_id));
    },
    getTeams: function getTeams(league_id) {
      return $http.get(window.location.api('leagues/' + league_id + '/teams'));
    },
    getListByAccess: function getListByAccess() {
      return $http.get(window.location.api('leagues/by_access'));
    },
    getTeamsByAccess: function getTeamsByAccess(league_id) {
      return $http.get(window.location.api('leagues/' + league_id + '/teams/by_access'));
    }
  };
}]);

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(14);

angular.module('app.schedule.scheduleService', ['app.favorites.favoritesService']).factory('app.schedule.scheduleService', ['$http', '$httpParamSerializerJQLike', 'app.favorites.favoritesService', '$q', '$location', function ($http, $httpParamSerializerJQLike, favorites, $q, $location) {
  var service = {
    schedule: {
      list: null,
      count: null,
      current_page: null,
      page_count: null,
      error: null,
      default_params: {
        search_id: null,
        type: null,
        date_disabled: false,
        start_date: moment().format('YYYY-MM-DD'),
        end_date: null,
        limit: 10,
        limit_favorites: true,
        sort: "asc",
        use_current_time: true,
        current_date_time: null,
        search_term: null
      },
      current_params: null,
      searcher: null,
      search_name: null,
      retrieving: false,
      upcoming_schedule: null,

      reset_params: function reset_params() {
        return service.schedule.current_params = angular.copy(service.schedule.default_params);
      },
      merge_params: function merge_params(params) {
        service.schedule.current_params = angular.merge({}, service.schedule.current_params, params);
      },
      _debounceRetrieve: _.debounce(function (deferred, params, options) {
        if (!options) {
          options = {};
        }

        if (service.schedule.retrieving) {
          deferred.reject({ error: 'Already retrieving schedule' });
        } else {
          service.schedule.retrieving = true;

          if (service.schedule.searcher) {
            service.schedule.searcher.resolve();
          }
          service.schedule.searcher = $q.defer();
          if (service.schedule.current_params === null) {
            service.schedule.current_params = service.schedule.default_params;
          }
          if (typeof params === 'undefined') {
            params = service.schedule.current_params;
          } else {
            params = angular.merge({}, service.schedule.current_params, params);
            service.schedule.current_params = params;
          }

          if (service.schedule.current_page) {
            params.offset = (service.schedule.current_page - 1) * params.limit;
          }

          if (favorites.hasSelected()) {
            params.favorites = favorites.selected;
          } else {
            if (params.favorites) {
              delete params.favorites;
            }
          }

          if (!service.upcoming_schedule) {
            params.limit_favorites = !!favorites.hasSelected();
          }

          if (typeof params.start_date === "string") {
            params.start_date = moment(params.start_date);
          }
          if (typeof params.end_date === "string") {
            params.end_date = moment(params.end_date);
          }

          params.start_date = momentToDate(params.start_date);
          params.end_date = momentToDate(params.end_date);

          if (params.start_date) {
            var today = new Date();
            params.use_current_time = params.use_current_time && params.start_date.toDateString() === today.toDateString() && !params.limit_favorites && !params.search_id && !params.date_disabled && !service.upcoming_schedule;

            params.start_date = params.start_date.getFullYear() + "-" + _.padStart(params.start_date.getMonth() + 1, 2, "0") + "-" + _.padStart(params.start_date.getDate(), 2, "0") + " 00:00:00";

            if (params.use_current_time) {
              params.current_date_time = today;

              params.current_date_time = params.current_date_time.getFullYear() + "-" + _.padStart(params.current_date_time.getMonth() + 1, 2, "0") + "-" + _.padStart(params.current_date_time.getDate(), 2, "0") + " " + _.padStart(params.current_date_time.getHours(), 2, "0") + ":" + _.padStart(params.current_date_time.getMinutes(), 2, "0") + ":00";
            } /*else {
              params.current_date_time = null;
              }*/
          }
          if (params.end_date) {
            params.end_date = params.end_date.getFullYear() + "-" + _.padStart(params.end_date.getMonth() + 1, 2, "0") + "-" + _.padStart(params.end_date.getDate(), 2, "0") + " 23:59:59";
          }

          params.omit_count = service.schedule.current_page > 1 ? params.omit_count : null; //fixes the display of correct number of pages

          var query_params = $httpParamSerializerJQLike(params);
          $http.get(window.location.api('schedule/search?' + query_params)).then(function (response) {
            var data = response.data;
            var prop = void 0;

            service.schedule.list = {};
            service.schedule.error = null;

            if (_.isInteger(data.current_time_games_offset)) {
              service.schedule.current_params.offset = data.current_time_games_offset;
            }

            service.schedule.current_page = Math.floor(service.schedule.current_params.offset / service.schedule.current_params.limit) + 1;

            if (data.results) {
              var results_keys = [];

              if (params.hasOwnProperty("sort")) {
                switch (params.sort) {
                  case "desc":
                    results_keys = Object.keys(data.results).sort(function (a, b) {
                      if (moment(b).toDate().valueOf() > moment(a).toDate().valueOf()) {
                        return 1;
                      } else if (moment(b).toDate().valueOf() == moment(a).toDate().valueOf()) {
                        return 0;
                      } else {
                        return -1;
                      }
                    });
                    break;
                  case "asc":
                  default:
                    results_keys = Object.keys(data.results).sort(function (a, b) {
                      if (moment(a).toDate().valueOf() > moment(b).toDate().valueOf()) {
                        return 1;
                      } else if (moment(a).toDate().valueOf() == moment(b).toDate().valueOf()) {
                        return 0;
                      } else {
                        return -1;
                      }
                    });
                    break;
                }
              }

              // The results come back from the API keyed by date.
              results_keys.forEach(function (dateKey) {
                // The games themselves are in UTC time. We'll need to adjust those to show in the users timezone.
                angular.forEach(data.results[dateKey], function (result) {
                  var localDt = new Date(result.dtegametimefixed);
                  result.dtegametimefixed = localDt;

                  // Get the localized date key
                  var md = moment(localDt);
                  var localDateKey = md.format("YYYY-MM-DD");
                  if (!service.schedule.list.hasOwnProperty(localDateKey)) {
                    service.schedule.list[localDateKey] = [];
                  }

                  service.schedule.list[localDateKey].push(result);
                });
              });
            }
            if (data.count) {
              service.schedule.count = data.count;
            }
            if (data.error) {
              service.schedule.error = data.error;
            }
            if (data.start_date) {
              service.schedule.current_params.start_date = data.start_date;
            }
            if (data.end_date) {
              service.schedule.current_params.end_date = data.end_date;
            }
            if (data.search_name) {
              service.schedule.search_name = data.search_name;
            }

            service.schedule.page_count = service.schedule.count / service.schedule.current_params.limit;

            if (!service.schedule.error) {
              service.schedule.error = 'No results found.';
              if (service.schedule.list) {
                for (prop in service.schedule.list) {
                  if (service.schedule.list.hasOwnProperty(prop)) {
                    service.schedule.error = null;
                    break;
                  }
                }
              }
            }
            service.schedule.searcher = null;

            deferred.resolve(response);
            service.schedule.retrieving = false;
          }, function () {
            service.schedule.searcher = null;
            deferred.reject(response);
            service.schedule.retrieving = false;
          });
        }

        if (options.saveToHistory && !_.isEmpty(params)) {
          $location.search("scheduleSearch=" + JSON.stringify(params));
        }
      }, 200),
      retrieve: function retrieve(params, options) {
        var deferred = $q.defer();

        service.schedule._debounceRetrieve(deferred, params, options);

        return deferred.promise;
      },
      retrievePage: function retrievePage() {
        return service.schedule.retrieve({ omit_count: true, use_current_time: false });
      },
      isUpcomingSchedule: function isUpcomingSchedule(param) {
        service.upcoming_schedule = param;
      }
    }
  };

  return service;
}]);

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.serviceBreakerService', []).factory('app.serviceBreakerService', ['$http', function ($http) {
  'use strict';

  var service = {
    breakers: {},
    retrieveByGroup: function retrieveByGroup(group) {
      return $http.get(window.location.api('/service_breakers/groups/' + group));
    },
    checkRecurly: function checkRecurly() {
      return service.retrieveByGroup('recurly').then(function (response) {
        var data = response.data;

        if (Array.isArray(data) && data.length) {
          service.breakers.recurly = data[0];
        }

        return response;
      });
    }
  };

  return service;
}]);

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.shared.resize.RESIZE_CONFIG', []).constant('RESIZE_CONFIG', {
    DEBOUNCE_MILLIS: 400,
    EVENT_NAME: 'resizeDirective::resize',
    TARGET_SIZES: {
        xs: 0,
        sm: 768,
        md: 992,
        lg: 1200
    }
});

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(12);

angular.module('app.shared.clipSearchService', []).factory('app.shared.clipSearchService', ['$http', '$httpParamSerializerJQLike', 'app.shared.dataTransformers.clipTransformer', function ($http, $httpParamSerializerJQLike, clipTransformer) {
  "use strict";

  return {
    retrieve: function retrieve(params) {
      params = $httpParamSerializerJQLike(params);
      return $http.get(window.location.api('/clips_my_clips?' + params)).then(function (response) {
        var data = response.data;

        if (Array.isArray(data.clips)) {
          for (var i = 0; i < data.clips.length; i++) {
            var clip = data.clips[i];
            clip = clipTransformer.transformToUi(clip);
            data.clips[i] = clip;
          }
          response.data.clips = data.clips;
        }

        return response;
      });
    },
    retrieveFilters: function retrieveFilters() {
      return $http.get(window.location.api('/clips_filters/user'));
    },

    retrieveSeasons: function retrieveSeasons(params) {
      params = $httpParamSerializerJQLike(params);
      return $http.get(window.location.api('/clips/my_seasons?' + params));
    }
  };
}]);

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.shared.clipSearch.clipFilterService', []).factory('app.shared.clipSearch.clipFilterService', ['$http', function ($http) {
  "use strict";

  return {
    getFilterLabels: function getFilterLabels(filters) {
      return $http.post(window.location.api('clips_filters/convert_to_labels'), filters);
    },
    createFilter: function createFilter(name, filters) {
      return $http.post(window.location.api('clips_filters/user'), { name: name, filters: filters });
    },
    updateFilter: function updateFilter(filter) {
      return $http.put(window.location.api('clips_filters/user/' + filter.id), filter);
    },
    deleteFilter: function deleteFilter(filterId) {
      return $http.delete(window.location.api('clips_filters/user/' + filterId));
    }
  };
}]);

/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.currentPlatform.currentPlatformDetailService', []).factory('app.currentPlatform.currentPlatformDetailService', ['$http', 'hostnameMatchService', function ($http, hostnameMatchService) {
  "use strict";

  /**
   * @type {{platform: Platform|null, retrieve: retrieve, isBranded: isBranded}}
   */

  var service = {
    platform: null,
    retrieve: function retrieve() {
      return $http.get(window.location.api('platforms/current')).then(function (response) {
        service.platform = response.data;
        var siteHostname = hostnameMatchService.hostname();

        if (window.location.platform(undefined, siteHostname) && service.platform.strplatformid !== window.location.platform(undefined, siteHostname)) {
          var platform = service.platform.strplatformid ? service.platform.strplatformid : null;
          var location = window.location.platform(platform, siteHostname);
          if (location !== '//' + window.location.hostname) {
            window.location = window.location.platform(service.platform.strplatformid, siteHostname);
          }
        }
      });
    },
    isBranded: function isBranded() {
      return !!(service.platform && service.platform.strplatformid !== 'www');
    }
  };

  return service;
}]);

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.mainFrame.searchMenu.searchMenuService', []).factory('app.mainFrame.searchMenu.searchMenuService', [function () {
    return {
        isExpanded: false
    };
}]);

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1);
__webpack_require__(10);
__webpack_require__(18);

"use strict";

angular.module('app.mainFrame.sidebarMenu.sidebarMenuService', ['app.currentUser', 'app.appMetaService', 'app.hostnameMatchService']).factory('app.mainFrame.sidebarMenu.sidebarMenuService', ['$state', 'currentUser', 'appMetaService', 'hostnameMatchService', 'PRODUCT', function ($state, currentUser, appMeta, hostnameMatchService, product) {

  var items = [];

  var init = function init() {

    items = [{
      label: 'Home',
      action: function action() {
        $state.go('app.home', null, { inherit: false, reload: true });
      },
      state: 'app.home',
      icon: 'fa fa-home'
    }];

    var access = currentUser.data.access;
    if (access && Array.isArray(access)) {
      access.sort();

      var used_functions = [];
      var used_function_ids = [];
      var prefix = 'func-';

      for (var i = 0; i < access.length; i++) {
        var access_item = access[i];
        var key = prefix + access_item.iaccessfunctionid_fk;

        if (used_functions.hasOwnProperty(key)) {
          continue;
        }

        if (used_function_ids.indexOf(access_item.iaccessfunctionid_fk) !== -1) {
          continue;
        }

        used_function_ids.push(access_item.iaccessfunctionid_fk);

        switch (access_item.iaccessfunctionid_fk) {
          case 100:
            used_functions.push({
              label: 'Roster Manager',
              action: function action() {
                $state.go('app.admin.rosters', null, { inherit: false, reload: true });
              },
              state: 'app.admin.rosters'
            });
            break;
          case 101:
            used_functions.push({
              label: "Reporting",
              icon: "fa fa-file-excel-o",
              action: function action() {
                $state.go('app.admin.reports', null, { inherit: false, reload: true });
              },
              state: 'app.admin.reports'
            });
            break;
          case 102:
            used_functions.push({
              label: "Team Manager",
              icon: "fa fa-users",
              action: function action() {
                $state.go('app.admin.teamInfoManager', null, { inherit: false, reload: true });
              },
              state: 'app.admin.teamInfoManager'
            });
            break;
          case 200:
            used_functions.push({
              label: "Syndication",
              icon: "fa fa-clone",
              action: function action() {
                var url = hostnameMatchService.base_url(null, 'https:');
                window.open(url + '/popup/syndication', 'syndication_popup', "height=700,width=1000");
                // $state.go('app.admin.syndication', null, {inherit: false, reload: true});
              }
              // state: 'app.admin.syndication'
            });
            break;
          case 2:
            used_functions.push({
              label: "Video Analysis",
              //icon: "fa fa-clone",
              action: function action() {
                $state.go('app.admin.videoAnalysis.myClips', null, { inherit: false, reload: true });
              },
              state: 'app.admin.videoAnalysis.myClips'
            });
        }
      }

      if (used_functions.length) {
        items.push({
          label: 'Admin Controls',
          action: function action() {
            return false;
          },
          state: 'app.admin',
          icon: 'fa fa-bar-chart-o',
          children: used_functions
        });
      }
    }

    var menuItems = getMenuByProductName();
    if (Array.isArray(menuItems)) {
      for (var _i = 0; _i < menuItems.length; _i++) {
        items.push(menuItems[_i]);
      }
    }
  };

  var getMenuByProductName = function getMenuByProductName() {
    switch (product.Code) {
      case "ahl":
        return [{
          label: 'Subscribe',
          action: function action() {
            $state.go('app.pricing', null, { inherit: false, reload: true });
          },
          state: 'app.pricing',
          icon: 'fa fa-dollar'
        }, {
          label: 'Redeem Code',
          action: function action() {
            $state.go('app.redeemPromo', null, { inherit: false, reload: true });
          },
          state: 'app.redeemPromo',
          icon: 'fa fa-gift'
        }, {
          label: 'Schedule',
          action: function action() {
            $state.go('app.schedule', null, { inherit: false, reload: true });
          },
          state: 'app.schedule',
          icon: 'fa fa-calendar'
        }, {
          label: 'My ' + product.Name,
          action: function action() {
            return false;
          },
          icon: 'fa fa-user',
          state: 'app.myHockeyTv',
          children: [{
            label: 'My Feed',
            action: function action() {
              $state.go('app.myHockeyTv.myFeed', {}, { reload: true });
            },
            state: 'app.myHockeyTv.myFeed'
          }, {
            label: 'My Games',
            action: function action() {
              $state.go('app.myHockeyTv.myGames', {}, { reload: true });
            },
            state: 'app.myHockeyTv.myGames'
          }, {
            label: 'My Clips',
            action: function action() {
              $state.go('app.myHockeyTv.myClips', {}, { reload: true });
            },
            state: 'app.myHockeyTv.myClips'
          }, {
            label: 'Following/Followers',
            action: function action() {
              $state.go('app.myHockeyTv.followersFollowing', {}, { reload: true });
            },
            state: 'app.myHockeyTv.followersFollowing'
          }, {
            label: 'Upcoming schedule',
            action: function action() {
              $state.go('app.myHockeyTv.upcomingSchedule', {}, { reload: true });
            },
            state: 'app.myHockeyTv.upcomingSchedule'
          }, {
            label: 'Watch Clips',
            action: function action() {
              $state.go('app.myHockeyTv.watchClips', {}, { reload: true });
            },
            state: 'app.myHockeyTv.watchClips',
            icon: 'fa fa-certificate'
          }]
        }, {
          label: 'Favorites',
          action: function action() {
            $state.go('app.favorites', null, { inherit: false, reload: true });
          },
          state: 'app.favorites',
          icon: 'fa fa-star'
        }, {
          label: 'Support',
          action: function action() {
            window.open(appMeta.supportSite);
          },
          icon: 'fa fa-question-circle'
        }, {
          label: 'How To Watch',
          action: function action() {
            $state.go('app.howToWatch', null, { inherit: false, reload: true });
          },
          state: 'app.howToWatch',
          icon: 'fa fa-tv'
        }, {
          label: 'Info Center',
          action: function action() {
            return false;
          },
          icon: 'fa fa-info-circle',
          state: 'app.information',
          children: [{
            label: 'About',
            action: function action() {
              $state.go('app.information.about', null, { inherit: false, reload: true });
            },
            state: 'app.information.about'
          }, {
            label: 'Terms',
            action: function action() {
              $state.go('app.information.terms', null, { inherit: false, reload: true });
            },
            state: ['app.information.terms', {}]
          }, {
            label: 'Privacy',
            action: function action() {
              $state.go('app.information.privacy', null, { inherit: false, reload: true });
            },
            state: ['app.information.privacy', {}]
          }, {
            label: 'FAQ',
            action: function action() {
              $state.go('app.information.faq', null, { inherit: false, reload: true });
            },
            state: 'app.information.faq'
          }]
        }];

      default:
        return [{
          label: 'Schedule',
          action: function action() {
            $state.go('app.schedule', null, { inherit: false, reload: true });
          },
          state: 'app.schedule',
          icon: 'fa fa-calendar'
        }, {
          label: 'My ' + product.Name,
          action: function action() {
            return false;
          },
          icon: 'fa fa-user',
          state: 'app.myHockeyTv',
          children: [{
            label: 'My Feed',
            action: function action() {
              $state.go('app.myHockeyTv.myFeed', {}, { reload: true });
            },
            state: 'app.myHockeyTv.myFeed'
          }, {
            label: 'My Games',
            action: function action() {
              $state.go('app.myHockeyTv.myGames', {}, { reload: true });
            },
            state: 'app.myHockeyTv.myGames'
          }, {
            label: 'My Clips',
            action: function action() {
              $state.go('app.myHockeyTv.myClips', {}, { reload: true });
            },
            state: 'app.myHockeyTv.myClips'
          }, {
            label: 'Following/Followers',
            action: function action() {
              $state.go('app.myHockeyTv.followersFollowing', {}, { reload: true });
            },
            state: 'app.myHockeyTv.followersFollowing'
          }, {
            label: 'Upcoming schedule',
            action: function action() {
              $state.go('app.myHockeyTv.upcomingSchedule', {}, { reload: true });
            },
            state: 'app.myHockeyTv.upcomingSchedule'
          }, {
            label: 'Watch Clips',
            action: function action() {
              $state.go('app.myHockeyTv.watchClips', {}, { reload: true });
            },
            state: 'app.myHockeyTv.watchClips',
            icon: 'fa fa-certificate'
          }, {
            label: 'College Commitments',
            action: function action() {
              $state.go('app.myHockeyTv.collegeCommitments', {}, { reload: true });
            },
            state: 'app.myHockeyTv.collegeCommitments'
          }, {
            label: 'Manage Reminders',
            action: function action() {
              $state.go('app.myHockeyTv.manageReminders', {}, { reload: true });
            },
            state: 'app.myHockeyTv.manageReminders'
          }]
        }, {
          label: 'Favorites',
          action: function action() {
            $state.go('app.favorites', null, { inherit: false, reload: true });
          },
          state: 'app.favorites',
          icon: 'fa fa-star'
        }, {
          label: 'Channels',
          action: function action() {
            $state.go('app.coverage.channels', null, { inherit: false, reload: true });
          },
          state: 'app.coverage.channels',
          icon: 'fa fa-th'
        }, {
          label: 'Events',
          action: function action() {
            $state.go('app.coverage.events', null, { inherit: false, reload: true });
          },
          state: 'app.coverage.events',
          icon: 'fa fa-trophy'
        }, {
          label: 'Games of the week',
          action: function action() {
            $state.go('app.gotw', null, { inherit: false, reload: true });
          },
          state: 'app.gotw',
          icon: 'fa fa-bullseye'
        }, {
          label: 'Pricing',
          action: function action() {
            $state.go('app.pricing', null, { inherit: false, reload: true });
          },
          state: 'app.pricing',
          icon: 'fa fa-dollar'
        }, {
          label: 'Redeem Code',
          action: function action() {
            $state.go('app.redeemPromo', null, { inherit: false, reload: true });
          },
          state: 'app.redeemPromo',
          icon: 'fa fa-gift'
        }, {
          label: 'Support',
          action: function action() {
            window.open(appMeta.supportSite);
          },
          icon: 'fa fa-question-circle'
        }, {
          label: 'Info Center',
          action: function action() {
            return false;
          },
          icon: 'fa fa-info-circle',
          state: 'app.information',
          children: [{
            label: 'About',
            action: function action() {
              $state.go('app.information.about', null, { inherit: false, reload: true });
            },
            state: 'app.information.about'
          }, {
            label: 'Terms',
            action: function action() {
              $state.go('app.information.terms', null, { inherit: false, reload: true });
            },
            state: ['app.information.terms', {}]
          }, {
            label: 'Privacy',
            action: function action() {
              $state.go('app.information.privacy', null, { inherit: false, reload: true });
            },
            state: ['app.information.privacy', {}]
          }, {
            label: 'FAQ',
            action: function action() {
              $state.go('app.information.faq', null, { inherit: false, reload: true });
            },
            state: 'app.information.faq'
          }]
        }];
    }
  };

  init();

  var service = {
    items: items,

    reinit: function reinit() {
      init();
      service.items = items;
    },

    manageExpanded: function manageExpanded(item, items) {
      if (item.expanded) {
        item.expanded = false;
      } else {
        for (var i = 0; i < items.length; i++) {
          items[i].expanded = false;
        }
        item.expanded = true;
      }
    },

    isItemActive: function isItemActive(item, exact) {
      if (item.state) {
        var match_state = null;
        var match_state_params = null;

        if (Array.isArray(item.state)) {
          match_state = item.state[0];

          if (item.state[1]) {
            match_state_params = item.state[1];
          }
        } else {
          match_state = item.state;
          match_state_params = null;
        }

        if (exact) {
          return $state.is(match_state, match_state_params);
        } else {
          return $state.includes(match_state, match_state_params);
        }
      }
      return false;
    }
  };

  return service;
}]);

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1);
__webpack_require__(25);

"use strict";

angular.module('app.login.loginController', ['app.mainFrame.collapsableMenu.collapsableMenuService']).controller('app.login.loginController', ['$scope', 'currentUser', '$state', '$stateParams', 'app.mainFrame.collapsableMenu.collapsableMenuService', function ($scope, currentUser, $state, $stateParams, collapsableMenu) {
  $scope.error = $stateParams.error;
  $scope.errorType = $stateParams.errorType;
  $scope.login_name = $stateParams.login_name;
  $scope.password = null;
  $scope.email = null;
  $scope.showPassword = false;
  $scope.passwordType = 'password';

  var init = function init() {
    if ($stateParams.autoLogin === true) {
      if ($stateParams.login_name && $stateParams.password) {
        $scope.password = $stateParams.password;
        $scope.login();
      }
    }
  };

  $scope.login = function () {
    currentUser.loginClicked = true;

    var callback = function callback() {
      collapsableMenu.buildItems();

      if ($stateParams.redirect) {
        $state.go($stateParams.redirect, $stateParams.redirectParams);
      } else if (typeof $state.current.goBack === 'function') {
        $state.current.goBack(true);
      } else {
        $state.go('app.home');
      }
    };

    currentUser.login($scope.login_name, $scope.password).then(callback).catch(function (result) {
      $state.go('app.login', result);
    });
  };

  $scope.resendRegistrationEmail = function () {
    if ($scope.login_name) {
      currentUser.sendRegistrationEmail($scope.login_name).then(function () {
        alert("Your confirmation email has been re-sent");
      }).catch(function (response) {
        alert("There was an error sending the confirmation email. Please try again later.");
      });
    } else {
      alert("We are unable to re-send the confirmation email at this time. Please try again later.");
    }
  };

  $scope.showPasswordClick = function () {
    $scope.showPassword = !$scope.showPassword;
    if ($scope.showPassword) {
      $scope.passwordType = "text";
    } else {
      $scope.passwordType = "password";
    }
  };

  init();
}]);

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(312);

'use strict';

angular.module('app.cdnUrl', ['app.cdnUrl.cdnUrlFilter']).value('cdnUrl', {
    0: 'https://ddde457d3b16a8614480-1c5b19b429ddb017fc420c330826ace8.ssl.cf2.rackcdn.com',
    1: 'https://89c7411cb39bfc3efca4-508d46d50606e2835a5b5ad46a3dc2a0.ssl.cf1.rackcdn.com',
    2: 'https://assets.leaguestat.com'
});

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.coverage.events.eventsService', []).factory('app.coverage.events.eventsService', ['$q', '$http', '$httpParamSerializerJQLike', function ($q, $http, $httpParamSerializerJQLike) {

  var events = void 0;
  events = {
    list: null,
    error: null,
    typeList: {
      limit: 100,
      itemsPerPage: 20,
      upcoming: {
        count: null,
        list: null,
        current_page: 0,
        page_count: null
      },
      current: {
        count: null,
        list: null,
        current_page: 0,
        page_count: null
      },
      past: {
        count: null,
        list: null,
        current_page: 0,
        page_count: null
      }
    },
    retrieve: function retrieve(params) {
      params = $httpParamSerializerJQLike(params);
      return $http.get(window.location.api('events/?' + params)).then(function (response) {
        var data = response.data;

        if (data.error) {
          events.error = data.error;
        } else {
          events.error = null;
          events.list = data;
        }
      });
    },
    get_teams_for: function get_teams_for(event_id) {
      if (event_id) {
        return $http.get(window.location.api('/events/' + event_id + '/teams'));
      }
    },
    getEventsByType: function getEventsByType(type) {
      var eventType = type ? type : 'upcoming';
      var params = $httpParamSerializerJQLike({
        limit: events.typeList.limit
      });

      if (events.typeList[eventType].list && events.typeList[eventType].list.length) {
        return $q.when(events.typeList[eventType]);
      }
      return $http.get(window.location.api('events_' + eventType + '?' + params)).then(function (response) {
        var data = response.data;

        if (data.error) {
          return events.error = data.error;
        }
        if (data.results) {
          events.typeList[eventType].list = data.results;
          events.typeList[eventType].count = data.results.length;
          events.typeList[eventType].current_page = 0;
          events.typeList[eventType].page_count = Math.ceil(data.results.length / 3);
          return events.error = null;
        }
        return data;
      });
    }
  };

  return events;
}]);

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(326);
__webpack_require__(327);
__webpack_require__(330);
__webpack_require__(331);
__webpack_require__(105);
__webpack_require__(334);
__webpack_require__(335);

"use strict";

angular.module('app.schedule.scheduleDirective', ['app.schedule.scheduleController', 'app.schedule.scheduleSearch.scheduleSearchDirective', 'app.schedule.noBroadcastDirective', 'app.schedule.gameActions.gameActionsDirective', 'app.schedule.favoriteGame.favoriteGameDirective', 'app.schedule.scheduleGame.scheduleGameDirective', 'app.shared.favoritesCarousel.favoritesCarouselDirective']).directive('schedule', [function () {
  return {
    restrict: 'E',
    templateUrl: 'components/schedule/scheduleDirectiveView.html',
    controller: 'app.schedule.scheduleController',
    scope: {
      searchInclude: '<',
      searchHideDateSelector: '<',
      searchHide: '<',
      searchHideTerm: '<?',
      searchTerm: '<',
      searchName: '<?',
      scheduleType: '@',
      broadcastActive: '<',
      limitToFavorites: '<'
    },
    link: function link(scope, elm) {
      elm.addClass('schedule-directive');
    }
  };
}]);

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(106);

"use strict";

angular.module('app.schedule.scheduleGame.scheduleGameDirective', ['app.schedule.scheduleGame.scheduleGameController']).directive('scheduleGame', [function () {
    return {
        restrict: 'E',
        templateUrl: 'components/schedule/scheduleGame/scheduleGameView.html',
        controller: 'app.schedule.scheduleGame.scheduleGameController',
        scope: {
            game: '=',
            layout: '@?',
            isCollapsed: '=?'
        },
        link: function link(scope, elm) {
            if (!scope.layout) {
                scope.layout = 'default';
            }
            elm.addClass('layout-' + scope.layout);
        }
    };
}]);

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.schedule.scheduleGame.scheduleGameController', []).controller('app.schedule.scheduleGame.scheduleGameController', ['$scope', 'PRODUCT', function ($scope, product) {
    $scope.game = $scope.game || null;
    $scope.layout = $scope.layout || null;
    $scope.isCollapsed = !!$scope.isCollapsed;
    $scope.productId = product.Id;

    $scope.game_status_icon_class = function (game) {
        if (game.is_blacked_out) {
            return 'schedule-vod-div-class-red';
        } else {
            if (game.blivegameflag === 2) {
                if (game.currently_streaming === true) {
                    return 'schedule-vod-div-class-green';
                } else {
                    return 'schedule-vod-div-class-none';
                }
            } else if (game.blivegameflag > 2) {
                return 'schedule-vod-div-class-red';
            } else {
                return 'schedule-vod-div-class-blue';
            }
        }
    };
    $scope.game_status_message = function (game) {
        if (game.is_blacked_out) {
            return 'Blacked out in your area';
        } else {
            switch (game.blivegameflag) {
                case 2:
                    return 'Scheduled to be live';
                case 3:
                    return 'Venue canceled broadcast';
                case 4:
                    return 'Venue does not broadcast';
                case 5:
                    return 'Game not broadcast on HockeyTV';
                case 6:
                    return 'Game canceled by team';
                case 7:
                    return 'Available on TSN or TSN2';
                case 8:
                    return 'No Internet available';
                case 9:
                    return 'Game postponed';
                default:
                    return '';
            }
        }
    };
    $scope.game_status_label = function (game) {
        if (game.is_blacked_out) {
            return 'blacked-out';
        } else if (game.blivegameflag === 2 && game.currently_streaming === true) {
            return 'live';
        } else if (game.blivegameflag > 2) {
            return 'cancelled';
        } else if (game.blivegameflag <= 0) {
            return 'vod';
        }
    };
}]);

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(337);

'use strict';

angular.module('app.shared.teamLineup.teamLineupDirective', ['app.shared.teamLineup.teamLineupController']).directive('teamLineup', [function () {
    return {
        restrict: 'E',
        template: '<div ng-include src="get_template_url()"></div>',
        controller: 'app.shared.teamLineup.teamLineupController',
        scope: {
            game: '<',
            layout: '@',
            version: '<'
        },
        link: function link(scope, elm) {
            elm.addClass('team-lineup');

            if (!scope.version) {
                scope.version = 1;
            }
            elm.addClass('version-' + scope.version);
        }
    };
}]);

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(343);
__webpack_require__(110);

'use strict';

angular.module('app.pricing.plans.planCardDirective', ['app.pricing.plans.planCardController', 'app.shared.searchdDropDown.searchDropDownDirective']).directive('planCard', ['PRODUCT', function (product) {
  return {
    restrict: 'EA',
    templateUrl: 'components/pricing/plans/' + product.Code + '/planCardView.html',
    controller: 'app.pricing.plans.planCardController',
    scope: {
      plan: '<?',
      currentSubscription: '<?',
      cardType: '<',
      plans: '<?',
      useTeams: '<?',
      planTeams: '<?',
      commonPlanAttrs: '<?'
    }
  };
}]);

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1);

"use strict";

angular.module('app.purchase.purchasePlanService', ['app.currentUser']).factory('app.purchase.purchasePlanService', ['$http', 'currentUser', '$q', function ($http, currentUser, $q) {
  return {
    purchase: function purchase(plan, billing_token, team, upgrade) {
      var uuid = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      var deferred = $q.defer();

      var params = {
        plan_code: plan.plan_code,
        currency: plan.currency,
        billing_info: billing_token,
        coupon_code: plan.promotion && plan.promotion.coupon_code ? plan.promotion.coupon_code : ""
      };

      if (team) {
        if (team.hasOwnProperty('iteamid')) {
          params.team_id = team.iteamid;
        } else if (team > 0) {
          params.team_id = parseInt(team);
        }
      }

      if (!upgrade) {
        $http.post(window.location.api('subscriptions'), params).then(
        /**
         * @param {HttpResponse} response
         */
        function (response) {
          /**
           * @type {{subscription: Subscription}}
           */
          var data = response.data;

          if (data.subscription) {
            if (plan.currency !== data.subscription.currency) {
              alert("The plan currency and the subscription currency didn't match. The suscription has been bought with the following currency: " + data.subscription.currency);
            }

            currentUser.get_current_subscriptions("recurly");
            currentUser.subscription_err = null;
          }

          deferred.resolve(data);
        },
        /**
         * @param {HttpResponse} response
         */
        function (response) {
          deferred.reject(response.data);
        });
      } else {
        params.action = "upgrade";
        params.subscription_uuid = uuid;

        $http.put(window.location.api('subscriptions/active'), params).then(
        /**
         * @param {HttpResponse} response
         */
        function (response) {
          /**
           * @type {{subscription: Subscription}}
           */
          var data = response.data;

          if (data.subscription) {
            if (plan.currency !== data.subscription.currency) {
              alert("The plan currency and the subscription currency didn't match. The suscription has been bought with the following currency: " + data.subscription.currency);
            }

            currentUser.get_current_subscriptions("recurly");
            currentUser.subscription_err = null;
          }

          deferred.resolve(data);
        },
        /**
         * @param {HttpResponse} response
         */
        function (response) {
          deferred.reject(response.data);
        });
      }

      return deferred.promise;
    },
    update_subscription: function update_subscription(action, plan, subscription) {
      var params = { action: action };
      if (plan) {
        params.plan_code = plan.plan_code;
      }

      if (subscription && subscription.uuid) {
        params.subscription_uuid = subscription.uuid;
      }

      return $http.put(window.location.api('subscriptions/active'), params).then(function (response) {
        var data = response.data;

        if (data.subscriptions) {
          if (data.subscriptions.length > 1) {
            currentUser.subscription_err = currentUser.multi_subscriptions_message;
          } else if (data.subscriptions.length === 1) {
            currentUser.update_current_subscription(data.subscriptions[0], "recurly");
            currentUser.subscription_err = null;
          }
        }

        return response;
      });
    },
    activate_subscription: function activate_subscription(subscription_uuid) {
      var params = {};

      if (subscription_uuid) {
        params.subscription_uuid = subscription_uuid;
      }

      return $http.post(window.location.api('subscriptions/active'), params).then(function (response) {
        var data = response.data;

        if (data.subscriptions) {
          if (data.subscriptions.length > 1) {
            currentUser.subscription_err = currentUser.multi_subscriptions_message;
          } else if (data.subscriptions.length === 1) {
            currentUser.update_current_subscription(data.subscriptions[0], "recurly");
            currentUser.subscription_err = null;
          }
        }

        return response;
      });
    },
    upgrade: function upgrade(plan, billing_token, team) {
      var deferred = $q.defer();

      var params = {
        plan_code: plan.plan_code,
        currency: plan.currency,
        billing_info: billing_token,
        plan_type: plan.type,
        subscription_uuid: currentUser.subscriptions.recurly.uuid
      };

      if (team && team.hasOwnProperty('iteamid')) {
        params.team_id = team.iteamid;
      }

      $http.put(window.location.api('subscriptions'), params).then(
      /**
       * @param {HttpResponse} response
       */
      function (response) {
        /**
         * @type {{subscription: Subscription}}
         */
        var data = response.data;

        if (data.subscription) {
          if (plan.currency !== data.subscription.currency) {
            alert("The plan currency and the subscription currency didn't match. The suscription has been bought with the following currency: " + data.subscription.currency);
          }

          currentUser.update_current_subscription(data.subscription, "recurly");
          currentUser.subscription_err = null;
        }

        deferred.resolve(data);
      },
      /**
       * @param {HttpResponse} response
       */
      function (response) {
        deferred.reject(response.data);
      });

      return deferred.promise;
    }
  };
}]);

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(344);

"use strict";

angular.module('app.shared.searchdDropDown.searchDropDownDirective', ['app.shared.searchDropdown.searchDropdownController']).directive('searchDropdown', [function () {
  return {
    templateUrl: 'components/shared/searchDropDown/searchDropDownView.html',
    restrict: 'AE',
    controller: 'app.shared.searchDropdown.searchDropdownController',
    controllerAs: 'controller',
    scope: {
      displayAttr: '@',
      selectedItems: '=',
      allItems: '=',
      readOnly: '=',
      idType: '=',
      addItem: '&?',
      removeItem: '&?',
      removeAll: '&?',
      dropdownWidth: '@?',
      selectAllOption: '=?',
      grouping: '=?',
      groupingLabel: '@?',
      sortDirection: '@?',
      sortBy: '@?',
      callBack: '&?',
      singleOption: '@?'
    },
    link: function link(scope, element, attrs) {
      element.bind('click', function (e) {
        e.stopPropagation();
      });
    }
  };
}]);

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(347);

'use strict';

angular.module('app.currentUser.subscriptionStatus.subscriptionStatusDirective', ['app.currentUser.subscriptionStatus.subscriptionStatusController']).directive('subscriptionStatus', [function () {
    return {
        restrict: 'EA',
        templateUrl: 'components/fhApp/currentUser/subscriptionStatus/subscriptionStatusView.html',
        controller: 'app.currentUser.subscriptionStatus.subscriptionStatusController',
        scope: {
            hideProgress: '<',
            hideIfNotExists: '<',
            hideManage: '<',
            autoRenew: '<',
            subscription: '<'
        }
    };
}]);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.shared.dobSelectorService', []).factory('app.shared.dobSelectorService', [function () {
  "use strict";

  return {
    new: function _new() {
      var today = moment();

      var months = [];
      for (var i = 0; i < 12; i++) {
        var month = today.month(i);
        months.push({
          label: month.format('MMMM'),
          value: i + 1
        });
      }

      var years = [];
      for (var _i = today.year(); _i >= today.year() - 100; _i--) {
        years.push(_i);
      }

      return {
        month: null,
        day: null,
        year: null,
        months: months,
        years: years,
        days: function days() {
          var strDate = this.year + '-' + this.month,
              length = this.year && this.month ? moment(strDate, "YYYY-MM").daysInMonth() : 31;
          return _.range(1, length + 1);
        },
        getDate: function getDate() {
          if (this.year && this.month && this.day) {
            return moment(this.year + '-' + this.month + '-' + this.day, "YYYY-MM-DD");
          } else if (this.year && this.month && !this.day) {
            this.day = 1;
            return moment(this.year + '-' + this.month + '-' + this.day, "YYYY-MM-DD");
          }
        }
      };
    }
  };
}]);

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.shared.selectWithDisabledOption.selectWithDisabledOptionDirective', []).directive('selectWithDisabledOption', [function () {
    return {
        restrict: 'A',
        link: function link(scope, elm) {
            angular.forEach(elm.find('option'), function (option) {
                if (option.selected && option.disabled) {
                    elm.addClass('disabled-selected');
                    elm.on('change', function () {
                        elm.removeClass('disabled-selected');
                    });
                }
            });
        }
    };
}]);

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.registration.confirmation.confirmationService', []).factory('app.registration.confirmation.confirmationService', ['$http', function ($http) {
    return {
        confirm: function confirm(user_id, confirmation_code) {
            return $http.put(window.location.api('users_confirm'), {
                user_id: user_id,
                confirmation_code: confirmation_code
            });
        }
    };
}]);

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(359);

angular.module('app.shared.password.passwordDirective', ['app.shared.password.passwordController']).directive('passwordChecker', [function () {
  "use strict";

  return {
    restrict: 'E',
    controller: 'app.shared.password.passwordController',
    templateUrl: 'components/shared/password/passwordView.html',
    scope: {
      password: '=',
      passwordPass: '='
    }
  };
}]);

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(363);

'use strict';

angular.module('app.myProfile.myProfileController', ['app.myProfile.myProfileService']).controller('app.myProfile.myProfileController', ['$scope', 'app.myProfile.myProfileService', '$filter', '$state', '$timeout', '$stateParams', function ($scope, myProfile, $filter, $state, $timeout, $stateParams) {
  $scope.myProfile = myProfile;
  $scope.bio_expanded = false;
  $scope.stateParams = $stateParams;

  $scope.editting = {
    user_name: false,
    bio: false,
    address: false,
    is_profile_public: false
  };

  $scope.maxBioLength = 190;
  $scope.bioInputLength = 0;

  $scope.updateBioInputCounter = function (dat) {
    if (typeof dat === 'string') {
      $scope.bioInputLength = dat.length;
    } else {
      $scope.bioInputLength = 0;
    }
  };

  $scope.publicPrivateRadioOptions = [{ value: true, text: 'public' }, { value: false, text: 'private' }];

  $scope.bioEformEditing = false;

  $scope.saveXeditable = function (field) {
    myProfile.save(field).then(function (response) {
      var data = response.data;
      if (data.error) {
        alert(data.error);
      }
    });
  };

  $scope.toggleForm = function (form) {
    if (form.$visible) {
      form.$submit();
    } else {
      form.$show();
    }
  };

  $scope.upload = function (file) {
    myProfile.save_image(file);
  };

  var init = function init() {
    return myProfile.retrieve($scope.stateParams.username);
  };

  return init();
}]);

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(18);

"use strict";

angular.module('app.shared.profileService', ['app.hostnameMatchService']).factory('app.shared.profileService', ['hostnameMatchService', '$state', function (hostnameMatch, $state) {
  return {
    buildProfileUrl: function buildProfileUrl(username) {
      return hostnameMatch.base_url() + '/#/profiles/' + username;
    },
    gotoProfileState: function gotoProfileState(username) {
      $state.go('app.userProfile.feed', { username: username });
    }
  };
}]);

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.shared.userPhoto.userPhotoDirective', []).directive('userPhoto', [function () {
    return {
        restrict: 'E',
        templateUrl: 'components/shared/userPhoto/userPhotoView.html',
        scope: {
            user: '=?'
        }
    };
}]);

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(76);

angular.module('app.shared.resize.resizeService', ['app.shared.resize.RESIZE_CONFIG']).service('app.shared.resize.resizeService', ['$window', '$document', 'RESIZE_CONFIG', function ($window, $document, RESIZE_CONFIG) {
  "use strict";

  function getTarget(width) {
    var target = void 0;
    for (var k in RESIZE_CONFIG.TARGET_SIZES) {
      if (RESIZE_CONFIG.TARGET_SIZES.hasOwnProperty(k)) {
        if (width < RESIZE_CONFIG.TARGET_SIZES[k]) {
          target = k;
        }
      }
    }
    return target;
  }

  return {
    getSize: function getSize(element) {
      return {
        width: element.width(),
        height: element.height(),
        target: getTarget($window.innerWidth || $document[0].body.clientWidth)
      };
    }
  };
}]);

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(9);

angular.module('app.myHockeyTv.manageReminders.remindersListService', ['app.transformResource']).factory('app.myHockeyTv.manageReminders.remindersListService', ['$http', 'app.transformResource', function ($http, transformResource) {
  "use strict";

  var reminders = {
    list: null,
    error: null,
    retrieve: function retrieve() {
      return $http({
        method: 'GET',
        url: window.location.api('reminders'),
        transformResponse: transformResource.onResponse(function (data) {
          if (data.results) {}
          return data;
        })
      }).then(
      /**
       * @param {HttpResponse} response
       */
      function (response) {
        var data = response.data;

        if (data.results) {
          reminders.list = data.results;

          _.forEach(reminders.list, function (reminder) {
            reminder.calendar.calstartdate = moment(reminder.calendar.calstartdate).toDate();
            reminder.calendar.calenddate = moment(reminder.calendar.calenddate).toDate();
          });
        }
        if (data.error) {
          return reminders.error = data.error;
        }
      },
      /**
       * @param {HttpResponse} response
       */
      function (response) {
        var data = response.data;
        var message = void 0;
        if (data.error) {
          message = data.error;
        } else {
          message = 'Failed to retrieve reminders';
        }
        return reminders.error = message;
      });
    }
  };
  return reminders;
}]);

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.userProfile.userProfileService', []).factory('app.userProfile.userProfileService', ['$http', function ($http) {
  "use strict";

  var profile = {
    retrieve: function retrieve(username) {
      if (username) {
        return $http.get(window.location.api('users/' + username + '/profile'));
      } else {
        return false;
      }
    },
    getFollow: function getFollow() {
      return $http.get(window.location.api('user_profiles/follow_all')).then(function (response) {
        return response.data && response.data.feed;
      });
    },
    toggleFollow: function toggleFollow(iuserid) {
      return $http.put(window.location.api('users/' + iuserid + '/follow')).then(function (response) {
        var data = response.data;

        if (typeof data.following !== 'undefined') {
          profile.current_user_following = data.following;
        }
        return data;
      });
    }
  };
  return profile;
}]);

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(106);

"use strict";

angular.module('app.shared.gameInfo.gameInfoDirective', ['app.schedule.scheduleGame.scheduleGameController']).directive('gameInfo', [function () {
    return {
        restrict: 'E',
        templateUrl: 'components/shared/gameInfo/gameInfoView.html',
        controller: 'app.schedule.scheduleGame.scheduleGameController',
        scope: {
            game: '=?'
        }
    };
}]);

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(114);

angular.module('app.passwordReset.passwordResetService', ['app.registration.confirmation.confirmationService']).factory('app.passwordReset.passwordResetService', ['$http', function ($http) {
  "use strict";

  return {
    sendResetRequest: function sendResetRequest(email) {
      return $http.post(window.location.api('sessions/password_reset'), {
        email: email
      });
    },
    getUserByToken: function getUserByToken(token) {
      return $http.get(window.location.api('users_confirm/' + token));
    },
    savePassword: function savePassword(email, password, token) {
      return $http.put(window.location.api('users_password'), {
        email: email,
        token: token,
        password: password
      });
    }
  };
}]);

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.admin.broadcastManager.broadcastManagerService', []).factory('app.admin.broadcastManager.broadcastManagerService', ['$http', 'ADMIN_API_URL', function ($http, ADMIN_API_URL) {
  return {
    getLeagues: function getLeagues() {
      return $http.get(window.location.api('/broadcast_leagues'));
    },
    getTeams: function getTeams(league_id) {
      return $http.get(window.location.api('broadcast_teams?league=' + league_id));
    },
    getGames: function getGames(team_id) {
      return $http.get(window.location.api('broadcast_games?team=' + team_id));
    },
    getOverlayModifiers: function getOverlayModifiers(game_id, audio_id) {
      return $http.get(ADMIN_API_URL + '/broadcastManager/overlay_modifiers/' + game_id + '/' + audio_id);
    },

    getStreams: function getStreams(game_id) {
      return $http.get(window.location.api('broadcast_games?team=' + team_id));
    },
    retrieveGame: function retrieveGame(game_id) {
      return $http.get(window.location.api('broadcast/' + game_id));
    },
    retrieveScoringProviders: function retrieveScoringProviders() {
      return $http.get(window.location.api('scoring_providers'));
    },
    retrieveLayouts: function retrieveLayouts(game_id, stream_id) {
      return $http.get(ADMIN_API_URL + '/broadcastManager/overlay_types/' + game_id + '/' + stream_id);
    },
    saveProvider: function saveProvider(game) {
      return $http.put(window.location.api('broadcast/' + game.igameid + '/publish_scoreboard'), {
        iscoringproviderid: game.iscoringproviderid,
        iscoringprovidergameid: game.iscoringprovidergameid
      });
    },
    publishScoreboard: function publishScoreboard(game_id, scoreboard) {
      return $http.put(window.location.api('broadcast/' + game_id + '/publish_scoreboard'), scoreboard);
    },
    setGameStreamOverlayModifier: function setGameStreamOverlayModifier(game_id, stream_id, modifier) {
      return $http.put(ADMIN_API_URL + '/broadcastManager/games/' + game_id + '/overlay_modifier/' + stream_id, {
        modifierOn: modifier.isOn,
        modifierId: modifier.id
      });
    },
    setGameStreamPowerPlayClock: function setGameStreamPowerPlayClock(game_id, stream_id, enablePowerPlayClock) {
      return $http.put(ADMIN_API_URL + '/broadcastManager/games/' + game_id + '/powerplay_clock/' + stream_id, {
        enablePowerPlayClock: enablePowerPlayClock
      });
    },
    toggleLiveScoring: function toggleLiveScoring(game_id, status) {
      return $http.put(window.location.api('broadcast/' + game_id + '/publish_scoreboard'), {
        uselivescoring: status
      });
    },
    toggleOverlay: function toggleOverlay(game, stream, enable, sponsor_id) {
      return $http.put(window.location.api('broadcast/' + game.igameid + '/overlay/' + stream.iaudiostreamid_fk), {
        ioverlayformatid_fk: stream.ioverlayformatid_fk,
        ioverlayon: enable,
        overlaysponsorid: sponsor_id
      });
    },

    getLeagueWatermarkImages: function getLeagueWatermarkImages(leagueId) {
      var queryUrl = window.location.api("/broadcastManager/watermarkImages?league_id=" + leagueId);
      return $http.get(queryUrl);
    },
    getTeamSponsorImages: function getTeamSponsorImages(teamId) {
      var queryUrl = window.location.api("/broadcastManager/sponsor_images?team_id=" + teamId);
      return $http.get(queryUrl);
    }
  };
}]);

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.shared.dateService', []).factory('app.shared.dateService', ['CURRENT_SEASON', function (CURRENT_SEASON) {
  "use strict";

  var service = {

    seasonList: [],
    seasonObject: {},

    startseasonId: 1,
    startseasonYear: '1799/1800',

    generateSeasonList: function generateSeasonList(start_season, start_season_year, end_season) {
      if (service.seasonList.length) {
        service.seasonList = [];
      }

      if (!end_season || _.isUndefined(end_season)) {
        end_season = CURRENT_SEASON;
      }

      service.startseasonId = start_season;
      service.startseasonYear = start_season_year;

      for (var i = start_season; i <= end_season; i++) {
        service.seasonObject.id = i;
        service.seasonObject.year = service.calculateSeasonYear(i, start_season);
        service.seasonList.push(service.seasonObject);

        service.seasonObject = {};
      }

      return service.seasonList;
    },

    getSeasonId: function getSeasonId(date) {
      service.startseasonYear.split(service.startseasonYear.substr(4, 1));

      var seasonId = null;

      var format = 'MM/DD/YYYY';

      date = moment(date, format);

      if (moment.isMoment(date)) {
        var currentYear = date.toDate().getFullYear();
        var startSeasonDate = moment('09/01/' + currentYear, format);
        var diff = Number(currentYear) - Number(service.startseasonYear[0]);

        if (Number(currentYear) < Number(service.startseasonYear[0])) {
          return service.startseasonId;
        } else {
          seasonId = date.isBefore(startSeasonDate) ? service.startseasonId + diff : service.startseasonId + diff + 1;
          return seasonId;
        }
      }
    },

    calculateSeasonYear: function calculateSeasonYear(season_index) {
      var split_char = service.startseasonYear.substr(4, 1);
      var array = service.startseasonYear.split(service.startseasonYear.substr(4, 1));

      var diff = season_index - service.startseasonId + 1;

      var start = moment(array[0]);

      if (moment.isMoment(start)) {
        start.add(diff, 'years');
      }

      var end = moment(array[1]);

      if (moment.isMoment(end)) {
        end.add(diff, 'years');
      }

      return start.format('Y') + split_char + end.format('Y');
    },

    clearList: function clearList() {
      service.seasonList = [];
    }
  };

  return service;
}]);

/***/ }),
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(285);


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if ("ahl".length) {
  __webpack_require__(286);
}

__webpack_require__(287);

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.constants', []).constant('DATE_FORMAT', {
  moment: {
    date: 'M/DD/YY',
    time: 'h:mm a'
  },
  angular: {
    date: 'M/dd/yy',
    time: 'h:mm a'
  }
}).constant('DEFAULT_PROFILE_IMAGE', 'assets/images/user_profile_placeholder.jpg').constant('RECURLY_API_KEY', 'ewr1-65dt862ZxyPyho5vYGG35D').constant('GOOGLE_CLIENT_ID', '76399356767.apps.googleusercontent.com').constant('JW_PLAYER_KEY', "NkPuGDODe1q+hm5P59a4amDej8jVjRnaaUYNE7Cs489xR7Ch").constant('PLAYER_POSTERS', {
  'notStarted': "assets/images/player/ahltv/ahltv_stream_has_not_started.png",
  'startingSoon': "assets/images/player/ahltv/ahltv_stream_starting_soon.png"
}).constant('FIREBASE_CREDS', {
  'live-scoring': {
    connection: {
      apiKey: "AIzaSyAjLkdlvcEPyyGeaBUrDn-zknTPehGfnF4",
      authDomain: "htv-staging-realtimeclock2.firebaseapp.com",
      databaseURL: "https://htv-staging-realtimeclock2-default-rtdb.firebaseio.com",
      projectId: "htv-staging-realtimeclock2",
      storageBucket: "htv-staging-realtimeclock2.appspot.com",
      messagingSenderId: "196292062868"
    }
  },
  'chat': {
    connection: {
      apiKey: "AIzaSyBANT1vNIqoKw9saOz3WnIoN4pIqYTljPk",
      authDomain: "htv-dev-2.firebaseapp.com",
      databaseURL: "https://htv-dev-2.firebaseio.com",
      projectId: "htv-dev-2",
      storageBucket: "htv-dev-2.appspot.com",
      messagingSenderId: "194373651147"
    }
  },
  'leaguestat': {
    firebaseUrl: 'leaguestat-staging.firebaseio.com',
    firebaseApiKey: 'AIzaSyDiVf2xYgmTlohuJMGJVHLnyNek-oEpBK4',
    firebaseToken: 'DIN13azYJqHGpWrohj04Jz37kn5GLNIGoWec5Ql2'
  },
  'singular': {
    firebaseUrl: 'htv-staging-realtimeclock2-default-rtdb.firebaseio.com',
    firebaseApiKey: 'AIzaSyAjLkdlvcEPyyGeaBUrDn-zknTPehGfnF4',
    firebaseToken: 'Gc3VR5H6Fi3PJKKiP4npPnJu5UQitq4rNIPGceL9'
  }
}).constant('CURRENT_SEASON', 35).constant('SYNDICATION_URL', "https://syndicate.hockeytv.com/login/ahl.php").constant('LEAGUESTAT_API', {
  'clusterUrl': "https://lscluster.hockeytech.com",
  'clusterKey': "f048f7ce7c422906"
}).constant('PRODUCT', {
  'Id': 2,
  'Code': "ahl",
  'Name': "AHLTV",
  'StorageBucket': "https://s3.amazonaws.com/assets.ahltv.com"
}).constant('ADMIN_API_URL', "https://admin.htvstaging.com/api").constant('ENVIRONMENT', {
  production: false
});

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


window.recurly = window.recurly || {};
window.google = window.google || {};

if (window.location.protocol !== 'https:') {
  console.log('Redirect to SSL');
  window.location = 'https://' + window.location.hostname;
}

console.log('App Version: ' + window.appVersion);

__webpack_require__(32);
__webpack_require__(288);
__webpack_require__(289);

__webpack_require__(290);
__webpack_require__(20);
__webpack_require__(1);
__webpack_require__(292);
__webpack_require__(58);
__webpack_require__(9);
__webpack_require__(22);
__webpack_require__(293);
__webpack_require__(294);

__webpack_require__(295);
__webpack_require__(299);
__webpack_require__(18);
__webpack_require__(484);
__webpack_require__(485);

"use strict";

angular.module('app', ['ui.bootstrap', 'ui.router', 'ngAnimate', 'ngSanitize', 'ngCookies', 'ngInflection', 'toggle-switch', 'xeditable', 'luegg.directives', 'ui.bootstrap.contextMenu', 'ui.sortable', 'app.appController', 'app.appKey', 'app.currentUser', 'app.currentUser.authentication.constant', 'app.httpInterceptors', 'app.transformResource', 'app.constants', 'app.ipAddressService', 'app.convertToNumberDirective', 'app.errSrcDirective', 'app.hostnameMatchService', 'app.stickyHeightDirective', 'app.doubleHorizontalScrollDirective', 'app.welcome', 'app.mainFrame']).config(['$urlRouterProvider', '$compileProvider', '$locationProvider', '$qProvider', function ($urlRouterProvider, $compileProvider, $locationProvider, $qProvider) {
  $locationProvider.html5Mode(false).hashPrefix('');
  $qProvider.errorOnUnhandledRejections(false);

  $urlRouterProvider.otherwise('/');

  if (window.environmentConfig) {
    window.environmentConfig.onConfig($compileProvider);
  }
}]).run(['$rootScope', '$state', '$stateParams', '$window', '$location', 'appKey', 'currentUser', 'RECURLY_API_KEY', 'AUTHENTICATION', 'app.ipAddressService', 'editableOptions', 'hostnameMatchService', '$interval', '$transitions', 'PRODUCT', function ($rootScope, $state, $stateParams, $window, $location, appKey, currentUser, RECURLY_API_KEY, AUTHENTICATION, ipAddressService, editableOptions, hostnameMatch, $interval, $transitions, product) {

  function bootstrapApplication() {
    // Validate Authentication Routing
    $transitions.onStart({}, validateAuthenticationAndSubscription);

    $transitions.onStart({}, hideUI);

    // Add global goBack function to every state transition
    $transitions.onSuccess({}, addGoBackFn);

    var bootstrapTimer = $interval(function () {
      if ($state.current.name) {
        $rootScope.$applyAsync(function () {
          $rootScope.bootstrapped = true;
          $interval.cancel(bootstrapTimer);
          if ($state.includes('welcome') && currentUser.is_logged_in()) {
            $state.go('app.home');
          } else {
            $state.transitionTo($state.current, $stateParams, {
              reload: true, inherit: false, notify: true
            });
          }
        });
      }
    }, 100, 0, false);
    $scope.$on('$destroy', function () {
      if (bootstrapTimer) {
        $interval.cancel(bootstrapTimer);
      }
    });
  }

  function validateStateNameBySite(stateName) {
    switch (product.Code) {
      case "ahl":
        for (var i in AUTHENTICATION.NON_AHL_STATES) {
          var regex = new RegExp('^' + AUTHENTICATION.NON_AHL_STATES[i]);
          if (stateName.match(regex)) {
            return currentUser.is_logged_in() ? { toStateName: 'app.schedule', changeState: false } : { toStateName: 'app.welcome', changeState: false };
          }
        }
        return { toStateName: stateName, changeState: true };
      default:
        return { toStateName: stateName, changeState: true };
    }
  }

  function validateAuthenticationAndSubscription($transition) {
    var toState = $transition.$to();
    var logged = currentUser.is_logged_in();
    var requiresAuth = !_.includes(AUTHENTICATION.NON_AUTH_STATES, toState.name);
    var validStateBySite = validateStateNameBySite(toState.name);

    if (!validStateBySite.changeState) {
      if ($state.hasOwnProperty("current")) {
        $state.target(validStateBySite.toStateName);
      } else {
        $state.go(validStateBySite.toStateName);
      }

      return false;
    }

    if (!logged) {
      for (var i in AUTHENTICATION.NON_AUTH_TO_LOGIN) {
        var value = AUTHENTICATION.NON_AUTH_TO_LOGIN[i];
        var regex = new RegExp('^' + value);
        if (toState.name.match(regex)) {
          $state.go('app.login', { redirect: toState.name, redirectParams: toState.params }, { reload: true });
          return false;
        }
      }

      requiresAuth = true;
      for (var _i in AUTHENTICATION.NON_AUTH_STATES) {
        var _value = AUTHENTICATION.NON_AUTH_STATES[_i];
        var _regex = new RegExp('^' + _value);
        if (toState.name.match(_regex)) {
          requiresAuth = false;
          break;
        }
      }
      if (requiresAuth) {
        $state.go(AUTHENTICATION.DEFAULT_AUTH_STATE);
        return false;
      }
    }

    if (logged && !currentUser.data.is_admin && (toState.name === 'app.sessionTimeout' || toState.name === 'app.login')) {
      $state.go('app.home');
      return false;
    }

    return true;
  }

  function hideUI() {
    var hostname = hostnameMatch.hostname();
    if (hostname === 'localhost' || hostname === 'localhost.hockeytv.com') {
      return;
    }

    var protocol = void 0;

    if ($window.location.protocol !== 'https:') {
      protocol = 'https:';
    }

    $rootScope.hideUI = !!protocol;
  }

  function addGoBackFn($transition) {
    var to = $transition.$to();
    var from = $transition.$from();

    if (to.name.match(/^app\.login$/) && from.name.match(/^app\.login$/) || to.name.match(/^app\.mobileLogin$/) && from.name.match(/^app\.mobileLogin$/)) {
      if (from.previous_state) {
        if (from.previous_state.name.match(/^app\.login$/)) {
          from.previous_state = null;
        } else {
          from = from.previous_state;
        }
      } else {
        from = null;
      }
    }

    $state.current.previous_state = from;
    $state.current.goBack = function (force) {
      var options = force ? { reload: true } : {};
      if (to.previous_state && to.previous_state.name) {
        if (to.previous_state.name.match(/^welcome/) || to.previous_state.name === 'app.locked' || to.previous_state.name === 'app.sessionTimeout' || to.previous_state.name === 'app.passwordReset.save' || to.previous_state.name === 'app.passwordReset.sent') {
          $state.go('app.home', {}, options);
        } else if ((to.name === "app.login" || to.name === "app.mobileLogin") && (to.previous_state.name === "app.registration.new" || to.previous_state.name === "app.registration")) {
          $state.go('app.home');
        } else if (to.previous_state.name === "app.login" || to.previous_state.name === "app.mobileLogin" || to.previous_state.name === "app.registration.new" || to.previous_state.name === "app.registration" || to.previous_state.name === "app.registration.confirmation") {
          $state.go('app.home');
        } else {
          $state.go(to.previous_state.name, to.previous_state.params, options);
        }
      } else {
        $state.go('app.home');
      }
    };
  }

  $rootScope.hideUI = false;

  appKey.set_user_key_from_cookie();

  editableOptions.theme = 'bs3';

  try {
    window.recurly.configure(RECURLY_API_KEY);
  } catch (err) {
    console.log(err);
  }

  if (window.environmentConfig) {
    window.environmentConfig.onRun($window, $transitions, $location);
  }

  var stateChangeStart = function stateChangeStart() {
    if (!$rootScope.bootstrapped) {
      ipAddressService.retrieve().then(function () {
        // Check if the user was logged to bootstrap the App
        if (appKey.user_key) {
          return currentUser.retrieve().then(bootstrapApplication, function () {
            appKey.destroy();
            $state.go('app.login').then(bootstrapApplication);
          });
        } else {
          bootstrapApplication();
        }
      });
    }
  };

  $transitions.onStart({}, stateChangeStart);
}]);

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 */
;(function(){function n(n,t,r){switch(r.length){case 0:return n.call(t);case 1:return n.call(t,r[0]);case 2:return n.call(t,r[0],r[1]);case 3:return n.call(t,r[0],r[1],r[2])}return n.apply(t,r)}function t(n,t,r,e){for(var u=-1,i=null==n?0:n.length;++u<i;){var o=n[u];t(e,o,r(o),n)}return e}function r(n,t){for(var r=-1,e=null==n?0:n.length;++r<e&&false!==t(n[r],r,n););return n}function e(n,t){for(var r=null==n?0:n.length;r--&&false!==t(n[r],r,n););return n}function u(n,t){for(var r=-1,e=null==n?0:n.length;++r<e;)if(!t(n[r],r,n))return false;
return true}function i(n,t){for(var r=-1,e=null==n?0:n.length,u=0,i=[];++r<e;){var o=n[r];t(o,r,n)&&(i[u++]=o)}return i}function o(n,t){return!(null==n||!n.length)&&-1<v(n,t,0)}function f(n,t,r){for(var e=-1,u=null==n?0:n.length;++e<u;)if(r(t,n[e]))return true;return false}function c(n,t){for(var r=-1,e=null==n?0:n.length,u=Array(e);++r<e;)u[r]=t(n[r],r,n);return u}function a(n,t){for(var r=-1,e=t.length,u=n.length;++r<e;)n[u+r]=t[r];return n}function l(n,t,r,e){var u=-1,i=null==n?0:n.length;for(e&&i&&(r=n[++u]);++u<i;)r=t(r,n[u],u,n);
return r}function s(n,t,r,e){var u=null==n?0:n.length;for(e&&u&&(r=n[--u]);u--;)r=t(r,n[u],u,n);return r}function h(n,t){for(var r=-1,e=null==n?0:n.length;++r<e;)if(t(n[r],r,n))return true;return false}function p(n,t,r){var e;return r(n,function(n,r,u){if(t(n,r,u))return e=r,false}),e}function _(n,t,r,e){var u=n.length;for(r+=e?1:-1;e?r--:++r<u;)if(t(n[r],r,n))return r;return-1}function v(n,t,r){if(t===t)n:{--r;for(var e=n.length;++r<e;)if(n[r]===t){n=r;break n}n=-1}else n=_(n,d,r);return n}function g(n,t,r,e){
--r;for(var u=n.length;++r<u;)if(e(n[r],t))return r;return-1}function d(n){return n!==n}function y(n,t){var r=null==n?0:n.length;return r?m(n,t)/r:F}function b(n){return function(t){return null==t?T:t[n]}}function x(n){return function(t){return null==n?T:n[t]}}function j(n,t,r,e,u){return u(n,function(n,u,i){r=e?(e=false,n):t(r,n,u,i)}),r}function w(n,t){var r=n.length;for(n.sort(t);r--;)n[r]=n[r].c;return n}function m(n,t){for(var r,e=-1,u=n.length;++e<u;){var i=t(n[e]);i!==T&&(r=r===T?i:r+i)}return r;
}function A(n,t){for(var r=-1,e=Array(n);++r<n;)e[r]=t(r);return e}function k(n,t){return c(t,function(t){return[t,n[t]]})}function E(n){return function(t){return n(t)}}function S(n,t){return c(t,function(t){return n[t]})}function O(n,t){return n.has(t)}function I(n,t){for(var r=-1,e=n.length;++r<e&&-1<v(t,n[r],0););return r}function R(n,t){for(var r=n.length;r--&&-1<v(t,n[r],0););return r}function z(n){return"\\"+Ln[n]}function W(n){var t=-1,r=Array(n.size);return n.forEach(function(n,e){r[++t]=[e,n];
}),r}function U(n,t){return function(r){return n(t(r))}}function B(n,t){for(var r=-1,e=n.length,u=0,i=[];++r<e;){var o=n[r];o!==t&&"__lodash_placeholder__"!==o||(n[r]="__lodash_placeholder__",i[u++]=r)}return i}function L(n){var t=-1,r=Array(n.size);return n.forEach(function(n){r[++t]=n}),r}function C(n){var t=-1,r=Array(n.size);return n.forEach(function(n){r[++t]=[n,n]}),r}function D(n){if(Rn.test(n)){for(var t=On.lastIndex=0;On.test(n);)++t;n=t}else n=Qn(n);return n}function M(n){return Rn.test(n)?n.match(On)||[]:n.split("");
}var T,$=1/0,F=NaN,N=[["ary",128],["bind",1],["bindKey",2],["curry",8],["curryRight",16],["flip",512],["partial",32],["partialRight",64],["rearg",256]],P=/\b__p\+='';/g,Z=/\b(__p\+=)''\+/g,q=/(__e\(.*?\)|\b__t\))\+'';/g,V=/&(?:amp|lt|gt|quot|#39);/g,K=/[&<>"']/g,G=RegExp(V.source),H=RegExp(K.source),J=/<%-([\s\S]+?)%>/g,Y=/<%([\s\S]+?)%>/g,Q=/<%=([\s\S]+?)%>/g,X=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,nn=/^\w*$/,tn=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,rn=/[\\^$.*+?()[\]{}|]/g,en=RegExp(rn.source),un=/^\s+|\s+$/g,on=/^\s+/,fn=/\s+$/,cn=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,an=/\{\n\/\* \[wrapped with (.+)\] \*/,ln=/,? & /,sn=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,hn=/\\(\\)?/g,pn=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,_n=/\w*$/,vn=/^[-+]0x[0-9a-f]+$/i,gn=/^0b[01]+$/i,dn=/^\[object .+?Constructor\]$/,yn=/^0o[0-7]+$/i,bn=/^(?:0|[1-9]\d*)$/,xn=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,jn=/($^)/,wn=/['\n\r\u2028\u2029\\]/g,mn="[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?(?:\\u200d(?:[^\\ud800-\\udfff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])[\\ufe0e\\ufe0f]?(?:[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|\\ud83c[\\udffb-\\udfff])?)*",An="(?:[\\u2700-\\u27bf]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff])"+mn,kn="(?:[^\\ud800-\\udfff][\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]?|[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]|(?:\\ud83c[\\udde6-\\uddff]){2}|[\\ud800-\\udbff][\\udc00-\\udfff]|[\\ud800-\\udfff])",En=RegExp("['\u2019]","g"),Sn=RegExp("[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]","g"),On=RegExp("\\ud83c[\\udffb-\\udfff](?=\\ud83c[\\udffb-\\udfff])|"+kn+mn,"g"),In=RegExp(["[A-Z\\xc0-\\xd6\\xd8-\\xde]?[a-z\\xdf-\\xf6\\xf8-\\xff]+(?:['\u2019](?:d|ll|m|re|s|t|ve))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde]|$)|(?:[A-Z\\xc0-\\xd6\\xd8-\\xde]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?(?=[\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000]|[A-Z\\xc0-\\xd6\\xd8-\\xde](?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])|$)|[A-Z\\xc0-\\xd6\\xd8-\\xde]?(?:[a-z\\xdf-\\xf6\\xf8-\\xff]|[^\\ud800-\\udfff\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000\\d+\\u2700-\\u27bfa-z\\xdf-\\xf6\\xf8-\\xffA-Z\\xc0-\\xd6\\xd8-\\xde])+(?:['\u2019](?:d|ll|m|re|s|t|ve))?|[A-Z\\xc0-\\xd6\\xd8-\\xde]+(?:['\u2019](?:D|LL|M|RE|S|T|VE))?|\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])|\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])|\\d+",An].join("|"),"g"),Rn=RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]"),zn=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,Wn="Array Buffer DataView Date Error Float32Array Float64Array Function Int8Array Int16Array Int32Array Map Math Object Promise RegExp Set String Symbol TypeError Uint8Array Uint8ClampedArray Uint16Array Uint32Array WeakMap _ clearTimeout isFinite parseInt setTimeout".split(" "),Un={};
Un["[object Float32Array]"]=Un["[object Float64Array]"]=Un["[object Int8Array]"]=Un["[object Int16Array]"]=Un["[object Int32Array]"]=Un["[object Uint8Array]"]=Un["[object Uint8ClampedArray]"]=Un["[object Uint16Array]"]=Un["[object Uint32Array]"]=true,Un["[object Arguments]"]=Un["[object Array]"]=Un["[object ArrayBuffer]"]=Un["[object Boolean]"]=Un["[object DataView]"]=Un["[object Date]"]=Un["[object Error]"]=Un["[object Function]"]=Un["[object Map]"]=Un["[object Number]"]=Un["[object Object]"]=Un["[object RegExp]"]=Un["[object Set]"]=Un["[object String]"]=Un["[object WeakMap]"]=false;
var Bn={};Bn["[object Arguments]"]=Bn["[object Array]"]=Bn["[object ArrayBuffer]"]=Bn["[object DataView]"]=Bn["[object Boolean]"]=Bn["[object Date]"]=Bn["[object Float32Array]"]=Bn["[object Float64Array]"]=Bn["[object Int8Array]"]=Bn["[object Int16Array]"]=Bn["[object Int32Array]"]=Bn["[object Map]"]=Bn["[object Number]"]=Bn["[object Object]"]=Bn["[object RegExp]"]=Bn["[object Set]"]=Bn["[object String]"]=Bn["[object Symbol]"]=Bn["[object Uint8Array]"]=Bn["[object Uint8ClampedArray]"]=Bn["[object Uint16Array]"]=Bn["[object Uint32Array]"]=true,
Bn["[object Error]"]=Bn["[object Function]"]=Bn["[object WeakMap]"]=false;var Ln={"\\":"\\","'":"'","\n":"n","\r":"r","\u2028":"u2028","\u2029":"u2029"},Cn=parseFloat,Dn=parseInt,Mn=typeof global=="object"&&global&&global.Object===Object&&global,Tn=typeof self=="object"&&self&&self.Object===Object&&self,$n=Mn||Tn||Function("return this")(),Fn=typeof exports=="object"&&exports&&!exports.nodeType&&exports,Nn=Fn&&typeof module=="object"&&module&&!module.nodeType&&module,Pn=Nn&&Nn.exports===Fn,Zn=Pn&&Mn.process,qn=function(){
try{var n=Nn&&Nn.require&&Nn.require("util").types;return n?n:Zn&&Zn.binding&&Zn.binding("util")}catch(n){}}(),Vn=qn&&qn.isArrayBuffer,Kn=qn&&qn.isDate,Gn=qn&&qn.isMap,Hn=qn&&qn.isRegExp,Jn=qn&&qn.isSet,Yn=qn&&qn.isTypedArray,Qn=b("length"),Xn=x({"\xc0":"A","\xc1":"A","\xc2":"A","\xc3":"A","\xc4":"A","\xc5":"A","\xe0":"a","\xe1":"a","\xe2":"a","\xe3":"a","\xe4":"a","\xe5":"a","\xc7":"C","\xe7":"c","\xd0":"D","\xf0":"d","\xc8":"E","\xc9":"E","\xca":"E","\xcb":"E","\xe8":"e","\xe9":"e","\xea":"e","\xeb":"e",
"\xcc":"I","\xcd":"I","\xce":"I","\xcf":"I","\xec":"i","\xed":"i","\xee":"i","\xef":"i","\xd1":"N","\xf1":"n","\xd2":"O","\xd3":"O","\xd4":"O","\xd5":"O","\xd6":"O","\xd8":"O","\xf2":"o","\xf3":"o","\xf4":"o","\xf5":"o","\xf6":"o","\xf8":"o","\xd9":"U","\xda":"U","\xdb":"U","\xdc":"U","\xf9":"u","\xfa":"u","\xfb":"u","\xfc":"u","\xdd":"Y","\xfd":"y","\xff":"y","\xc6":"Ae","\xe6":"ae","\xde":"Th","\xfe":"th","\xdf":"ss","\u0100":"A","\u0102":"A","\u0104":"A","\u0101":"a","\u0103":"a","\u0105":"a",
"\u0106":"C","\u0108":"C","\u010a":"C","\u010c":"C","\u0107":"c","\u0109":"c","\u010b":"c","\u010d":"c","\u010e":"D","\u0110":"D","\u010f":"d","\u0111":"d","\u0112":"E","\u0114":"E","\u0116":"E","\u0118":"E","\u011a":"E","\u0113":"e","\u0115":"e","\u0117":"e","\u0119":"e","\u011b":"e","\u011c":"G","\u011e":"G","\u0120":"G","\u0122":"G","\u011d":"g","\u011f":"g","\u0121":"g","\u0123":"g","\u0124":"H","\u0126":"H","\u0125":"h","\u0127":"h","\u0128":"I","\u012a":"I","\u012c":"I","\u012e":"I","\u0130":"I",
"\u0129":"i","\u012b":"i","\u012d":"i","\u012f":"i","\u0131":"i","\u0134":"J","\u0135":"j","\u0136":"K","\u0137":"k","\u0138":"k","\u0139":"L","\u013b":"L","\u013d":"L","\u013f":"L","\u0141":"L","\u013a":"l","\u013c":"l","\u013e":"l","\u0140":"l","\u0142":"l","\u0143":"N","\u0145":"N","\u0147":"N","\u014a":"N","\u0144":"n","\u0146":"n","\u0148":"n","\u014b":"n","\u014c":"O","\u014e":"O","\u0150":"O","\u014d":"o","\u014f":"o","\u0151":"o","\u0154":"R","\u0156":"R","\u0158":"R","\u0155":"r","\u0157":"r",
"\u0159":"r","\u015a":"S","\u015c":"S","\u015e":"S","\u0160":"S","\u015b":"s","\u015d":"s","\u015f":"s","\u0161":"s","\u0162":"T","\u0164":"T","\u0166":"T","\u0163":"t","\u0165":"t","\u0167":"t","\u0168":"U","\u016a":"U","\u016c":"U","\u016e":"U","\u0170":"U","\u0172":"U","\u0169":"u","\u016b":"u","\u016d":"u","\u016f":"u","\u0171":"u","\u0173":"u","\u0174":"W","\u0175":"w","\u0176":"Y","\u0177":"y","\u0178":"Y","\u0179":"Z","\u017b":"Z","\u017d":"Z","\u017a":"z","\u017c":"z","\u017e":"z","\u0132":"IJ",
"\u0133":"ij","\u0152":"Oe","\u0153":"oe","\u0149":"'n","\u017f":"s"}),nt=x({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}),tt=x({"&amp;":"&","&lt;":"<","&gt;":">","&quot;":'"',"&#39;":"'"}),rt=function x(mn){function An(n){if(yu(n)&&!ff(n)&&!(n instanceof Ln)){if(n instanceof On)return n;if(oi.call(n,"__wrapped__"))return Fe(n)}return new On(n)}function kn(){}function On(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t,this.__index__=0,this.__values__=T}function Ln(n){
this.__wrapped__=n,this.__actions__=[],this.__dir__=1,this.__filtered__=false,this.__iteratees__=[],this.__takeCount__=4294967295,this.__views__=[]}function Mn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function Tn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function Fn(n){var t=-1,r=null==n?0:n.length;for(this.clear();++t<r;){var e=n[t];this.set(e[0],e[1])}}function Nn(n){var t=-1,r=null==n?0:n.length;for(this.__data__=new Fn;++t<r;)this.add(n[t]);
}function Zn(n){this.size=(this.__data__=new Tn(n)).size}function qn(n,t){var r,e=ff(n),u=!e&&of(n),i=!e&&!u&&af(n),o=!e&&!u&&!i&&_f(n),u=(e=e||u||i||o)?A(n.length,ni):[],f=u.length;for(r in n)!t&&!oi.call(n,r)||e&&("length"==r||i&&("offset"==r||"parent"==r)||o&&("buffer"==r||"byteLength"==r||"byteOffset"==r)||Se(r,f))||u.push(r);return u}function Qn(n){var t=n.length;return t?n[ir(0,t-1)]:T}function et(n,t){return De(Lr(n),pt(t,0,n.length))}function ut(n){return De(Lr(n))}function it(n,t,r){(r===T||lu(n[t],r))&&(r!==T||t in n)||st(n,t,r);
}function ot(n,t,r){var e=n[t];oi.call(n,t)&&lu(e,r)&&(r!==T||t in n)||st(n,t,r)}function ft(n,t){for(var r=n.length;r--;)if(lu(n[r][0],t))return r;return-1}function ct(n,t,r,e){return uo(n,function(n,u,i){t(e,n,r(n),i)}),e}function at(n,t){return n&&Cr(t,Wu(t),n)}function lt(n,t){return n&&Cr(t,Uu(t),n)}function st(n,t,r){"__proto__"==t&&Ai?Ai(n,t,{configurable:true,enumerable:true,value:r,writable:true}):n[t]=r}function ht(n,t){for(var r=-1,e=t.length,u=Ku(e),i=null==n;++r<e;)u[r]=i?T:Ru(n,t[r]);return u;
}function pt(n,t,r){return n===n&&(r!==T&&(n=n<=r?n:r),t!==T&&(n=n>=t?n:t)),n}function _t(n,t,e,u,i,o){var f,c=1&t,a=2&t,l=4&t;if(e&&(f=i?e(n,u,i,o):e(n)),f!==T)return f;if(!du(n))return n;if(u=ff(n)){if(f=me(n),!c)return Lr(n,f)}else{var s=vo(n),h="[object Function]"==s||"[object GeneratorFunction]"==s;if(af(n))return Ir(n,c);if("[object Object]"==s||"[object Arguments]"==s||h&&!i){if(f=a||h?{}:Ae(n),!c)return a?Mr(n,lt(f,n)):Dr(n,at(f,n))}else{if(!Bn[s])return i?n:{};f=ke(n,s,c)}}if(o||(o=new Zn),
i=o.get(n))return i;if(o.set(n,f),pf(n))return n.forEach(function(r){f.add(_t(r,t,e,r,n,o))}),f;if(sf(n))return n.forEach(function(r,u){f.set(u,_t(r,t,e,u,n,o))}),f;var a=l?a?ve:_e:a?Uu:Wu,p=u?T:a(n);return r(p||n,function(r,u){p&&(u=r,r=n[u]),ot(f,u,_t(r,t,e,u,n,o))}),f}function vt(n){var t=Wu(n);return function(r){return gt(r,n,t)}}function gt(n,t,r){var e=r.length;if(null==n)return!e;for(n=Qu(n);e--;){var u=r[e],i=t[u],o=n[u];if(o===T&&!(u in n)||!i(o))return false}return true}function dt(n,t,r){if(typeof n!="function")throw new ti("Expected a function");
return bo(function(){n.apply(T,r)},t)}function yt(n,t,r,e){var u=-1,i=o,a=true,l=n.length,s=[],h=t.length;if(!l)return s;r&&(t=c(t,E(r))),e?(i=f,a=false):200<=t.length&&(i=O,a=false,t=new Nn(t));n:for(;++u<l;){var p=n[u],_=null==r?p:r(p),p=e||0!==p?p:0;if(a&&_===_){for(var v=h;v--;)if(t[v]===_)continue n;s.push(p)}else i(t,_,e)||s.push(p)}return s}function bt(n,t){var r=true;return uo(n,function(n,e,u){return r=!!t(n,e,u)}),r}function xt(n,t,r){for(var e=-1,u=n.length;++e<u;){var i=n[e],o=t(i);if(null!=o&&(f===T?o===o&&!wu(o):r(o,f)))var f=o,c=i;
}return c}function jt(n,t){var r=[];return uo(n,function(n,e,u){t(n,e,u)&&r.push(n)}),r}function wt(n,t,r,e,u){var i=-1,o=n.length;for(r||(r=Ee),u||(u=[]);++i<o;){var f=n[i];0<t&&r(f)?1<t?wt(f,t-1,r,e,u):a(u,f):e||(u[u.length]=f)}return u}function mt(n,t){return n&&oo(n,t,Wu)}function At(n,t){return n&&fo(n,t,Wu)}function kt(n,t){return i(t,function(t){return _u(n[t])})}function Et(n,t){t=Sr(t,n);for(var r=0,e=t.length;null!=n&&r<e;)n=n[Me(t[r++])];return r&&r==e?n:T}function St(n,t,r){return t=t(n),
ff(n)?t:a(t,r(n))}function Ot(n){if(null==n)return n===T?"[object Undefined]":"[object Null]";if(mi&&mi in Qu(n)){var t=oi.call(n,mi),r=n[mi];try{n[mi]=T;var e=true}catch(n){}var u=ai.call(n);e&&(t?n[mi]=r:delete n[mi]),n=u}else n=ai.call(n);return n}function It(n,t){return n>t}function Rt(n,t){return null!=n&&oi.call(n,t)}function zt(n,t){return null!=n&&t in Qu(n)}function Wt(n,t,r){for(var e=r?f:o,u=n[0].length,i=n.length,a=i,l=Ku(i),s=1/0,h=[];a--;){var p=n[a];a&&t&&(p=c(p,E(t))),s=Ci(p.length,s),
l[a]=!r&&(t||120<=u&&120<=p.length)?new Nn(a&&p):T}var p=n[0],_=-1,v=l[0];n:for(;++_<u&&h.length<s;){var g=p[_],d=t?t(g):g,g=r||0!==g?g:0;if(v?!O(v,d):!e(h,d,r)){for(a=i;--a;){var y=l[a];if(y?!O(y,d):!e(n[a],d,r))continue n}v&&v.push(d),h.push(g)}}return h}function Ut(n,t,r,e){return mt(n,function(n,u,i){t(e,r(n),u,i)}),e}function Bt(t,r,e){return r=Sr(r,t),t=2>r.length?t:Et(t,hr(r,0,-1)),r=null==t?t:t[Me(Ve(r))],null==r?T:n(r,t,e)}function Lt(n){return yu(n)&&"[object Arguments]"==Ot(n)}function Ct(n){
return yu(n)&&"[object ArrayBuffer]"==Ot(n)}function Dt(n){return yu(n)&&"[object Date]"==Ot(n)}function Mt(n,t,r,e,u){if(n===t)return true;if(null==n||null==t||!yu(n)&&!yu(t))return n!==n&&t!==t;n:{var i=ff(n),o=ff(t),f=i?"[object Array]":vo(n),c=o?"[object Array]":vo(t),f="[object Arguments]"==f?"[object Object]":f,c="[object Arguments]"==c?"[object Object]":c,a="[object Object]"==f,o="[object Object]"==c;if((c=f==c)&&af(n)){if(!af(t)){t=false;break n}i=true,a=false}if(c&&!a)u||(u=new Zn),t=i||_f(n)?se(n,t,r,e,Mt,u):he(n,t,f,r,e,Mt,u);else{
if(!(1&r)&&(i=a&&oi.call(n,"__wrapped__"),f=o&&oi.call(t,"__wrapped__"),i||f)){n=i?n.value():n,t=f?t.value():t,u||(u=new Zn),t=Mt(n,t,r,e,u);break n}if(c)t:if(u||(u=new Zn),i=1&r,f=_e(n),o=f.length,c=_e(t).length,o==c||i){for(a=o;a--;){var l=f[a];if(!(i?l in t:oi.call(t,l))){t=false;break t}}if((c=u.get(n))&&u.get(t))t=c==t;else{c=true,u.set(n,t),u.set(t,n);for(var s=i;++a<o;){var l=f[a],h=n[l],p=t[l];if(e)var _=i?e(p,h,l,t,n,u):e(h,p,l,n,t,u);if(_===T?h!==p&&!Mt(h,p,r,e,u):!_){c=false;break}s||(s="constructor"==l);
}c&&!s&&(r=n.constructor,e=t.constructor,r!=e&&"constructor"in n&&"constructor"in t&&!(typeof r=="function"&&r instanceof r&&typeof e=="function"&&e instanceof e)&&(c=false)),u.delete(n),u.delete(t),t=c}}else t=false;else t=false}}return t}function Tt(n){return yu(n)&&"[object Map]"==vo(n)}function $t(n,t,r,e){var u=r.length,i=u,o=!e;if(null==n)return!i;for(n=Qu(n);u--;){var f=r[u];if(o&&f[2]?f[1]!==n[f[0]]:!(f[0]in n))return false}for(;++u<i;){var f=r[u],c=f[0],a=n[c],l=f[1];if(o&&f[2]){if(a===T&&!(c in n))return false;
}else{if(f=new Zn,e)var s=e(a,l,c,n,t,f);if(s===T?!Mt(l,a,3,e,f):!s)return false}}return true}function Ft(n){return!(!du(n)||ci&&ci in n)&&(_u(n)?hi:dn).test(Te(n))}function Nt(n){return yu(n)&&"[object RegExp]"==Ot(n)}function Pt(n){return yu(n)&&"[object Set]"==vo(n)}function Zt(n){return yu(n)&&gu(n.length)&&!!Un[Ot(n)]}function qt(n){return typeof n=="function"?n:null==n?$u:typeof n=="object"?ff(n)?Jt(n[0],n[1]):Ht(n):Zu(n)}function Vt(n){if(!ze(n))return Bi(n);var t,r=[];for(t in Qu(n))oi.call(n,t)&&"constructor"!=t&&r.push(t);
return r}function Kt(n,t){return n<t}function Gt(n,t){var r=-1,e=su(n)?Ku(n.length):[];return uo(n,function(n,u,i){e[++r]=t(n,u,i)}),e}function Ht(n){var t=xe(n);return 1==t.length&&t[0][2]?We(t[0][0],t[0][1]):function(r){return r===n||$t(r,n,t)}}function Jt(n,t){return Ie(n)&&t===t&&!du(t)?We(Me(n),t):function(r){var e=Ru(r,n);return e===T&&e===t?zu(r,n):Mt(t,e,3)}}function Yt(n,t,r,e,u){n!==t&&oo(t,function(i,o){if(du(i)){u||(u=new Zn);var f=u,c=Be(n,o),a=Be(t,o),l=f.get(a);if(!l){var l=e?e(c,a,o+"",n,t,f):T,s=l===T;
if(s){var h=ff(a),p=!h&&af(a),_=!h&&!p&&_f(a),l=a;h||p||_?ff(c)?l=c:hu(c)?l=Lr(c):p?(s=false,l=Ir(a,true)):_?(s=false,l=zr(a,true)):l=[]:xu(a)||of(a)?(l=c,of(c)?l=Ou(c):du(c)&&!_u(c)||(l=Ae(a))):s=false}s&&(f.set(a,l),Yt(l,a,r,e,f),f.delete(a))}it(n,o,l)}else f=e?e(Be(n,o),i,o+"",n,t,u):T,f===T&&(f=i),it(n,o,f)},Uu)}function Qt(n,t){var r=n.length;if(r)return t+=0>t?r:0,Se(t,r)?n[t]:T}function Xt(n,t,r){var e=-1;return t=c(t.length?t:[$u],E(ye())),n=Gt(n,function(n,r,u){return{a:c(t,function(t){return t(n)}),
b:++e,c:n}}),w(n,function(n,t){var e;n:{e=-1;for(var u=n.a,i=t.a,o=u.length,f=r.length;++e<o;){var c=Wr(u[e],i[e]);if(c){if(e>=f){e=c;break n}e=c*("desc"==r[e]?-1:1);break n}}e=n.b-t.b}return e})}function nr(n,t){return tr(n,t,function(t,r){return zu(n,r)})}function tr(n,t,r){for(var e=-1,u=t.length,i={};++e<u;){var o=t[e],f=Et(n,o);r(f,o)&&lr(i,Sr(o,n),f)}return i}function rr(n){return function(t){return Et(t,n)}}function er(n,t,r,e){var u=e?g:v,i=-1,o=t.length,f=n;for(n===t&&(t=Lr(t)),r&&(f=c(n,E(r)));++i<o;)for(var a=0,l=t[i],l=r?r(l):l;-1<(a=u(f,l,a,e));)f!==n&&xi.call(f,a,1),
xi.call(n,a,1);return n}function ur(n,t){for(var r=n?t.length:0,e=r-1;r--;){var u=t[r];if(r==e||u!==i){var i=u;Se(u)?xi.call(n,u,1):xr(n,u)}}return n}function ir(n,t){return n+Ii(Ti()*(t-n+1))}function or(n,t){var r="";if(!n||1>t||9007199254740991<t)return r;do t%2&&(r+=n),(t=Ii(t/2))&&(n+=n);while(t);return r}function fr(n,t){return xo(Ue(n,t,$u),n+"")}function cr(n){return Qn(Lu(n))}function ar(n,t){var r=Lu(n);return De(r,pt(t,0,r.length))}function lr(n,t,r,e){if(!du(n))return n;t=Sr(t,n);for(var u=-1,i=t.length,o=i-1,f=n;null!=f&&++u<i;){
var c=Me(t[u]),a=r;if(u!=o){var l=f[c],a=e?e(l,c,f):T;a===T&&(a=du(l)?l:Se(t[u+1])?[]:{})}ot(f,c,a),f=f[c]}return n}function sr(n){return De(Lu(n))}function hr(n,t,r){var e=-1,u=n.length;for(0>t&&(t=-t>u?0:u+t),r=r>u?u:r,0>r&&(r+=u),u=t>r?0:r-t>>>0,t>>>=0,r=Ku(u);++e<u;)r[e]=n[e+t];return r}function pr(n,t){var r;return uo(n,function(n,e,u){return r=t(n,e,u),!r}),!!r}function _r(n,t,r){var e=0,u=null==n?e:n.length;if(typeof t=="number"&&t===t&&2147483647>=u){for(;e<u;){var i=e+u>>>1,o=n[i];null!==o&&!wu(o)&&(r?o<=t:o<t)?e=i+1:u=i;
}return u}return vr(n,t,$u,r)}function vr(n,t,r,e){t=r(t);for(var u=0,i=null==n?0:n.length,o=t!==t,f=null===t,c=wu(t),a=t===T;u<i;){var l=Ii((u+i)/2),s=r(n[l]),h=s!==T,p=null===s,_=s===s,v=wu(s);(o?e||_:a?_&&(e||h):f?_&&h&&(e||!p):c?_&&h&&!p&&(e||!v):p||v?0:e?s<=t:s<t)?u=l+1:i=l}return Ci(i,4294967294)}function gr(n,t){for(var r=-1,e=n.length,u=0,i=[];++r<e;){var o=n[r],f=t?t(o):o;if(!r||!lu(f,c)){var c=f;i[u++]=0===o?0:o}}return i}function dr(n){return typeof n=="number"?n:wu(n)?F:+n}function yr(n){
if(typeof n=="string")return n;if(ff(n))return c(n,yr)+"";if(wu(n))return ro?ro.call(n):"";var t=n+"";return"0"==t&&1/n==-$?"-0":t}function br(n,t,r){var e=-1,u=o,i=n.length,c=true,a=[],l=a;if(r)c=false,u=f;else if(200<=i){if(u=t?null:so(n))return L(u);c=false,u=O,l=new Nn}else l=t?[]:a;n:for(;++e<i;){var s=n[e],h=t?t(s):s,s=r||0!==s?s:0;if(c&&h===h){for(var p=l.length;p--;)if(l[p]===h)continue n;t&&l.push(h),a.push(s)}else u(l,h,r)||(l!==a&&l.push(h),a.push(s))}return a}function xr(n,t){return t=Sr(t,n),
n=2>t.length?n:Et(n,hr(t,0,-1)),null==n||delete n[Me(Ve(t))]}function jr(n,t,r,e){for(var u=n.length,i=e?u:-1;(e?i--:++i<u)&&t(n[i],i,n););return r?hr(n,e?0:i,e?i+1:u):hr(n,e?i+1:0,e?u:i)}function wr(n,t){var r=n;return r instanceof Ln&&(r=r.value()),l(t,function(n,t){return t.func.apply(t.thisArg,a([n],t.args))},r)}function mr(n,t,r){var e=n.length;if(2>e)return e?br(n[0]):[];for(var u=-1,i=Ku(e);++u<e;)for(var o=n[u],f=-1;++f<e;)f!=u&&(i[u]=yt(i[u]||o,n[f],t,r));return br(wt(i,1),t,r)}function Ar(n,t,r){
for(var e=-1,u=n.length,i=t.length,o={};++e<u;)r(o,n[e],e<i?t[e]:T);return o}function kr(n){return hu(n)?n:[]}function Er(n){return typeof n=="function"?n:$u}function Sr(n,t){return ff(n)?n:Ie(n,t)?[n]:jo(Iu(n))}function Or(n,t,r){var e=n.length;return r=r===T?e:r,!t&&r>=e?n:hr(n,t,r)}function Ir(n,t){if(t)return n.slice();var r=n.length,r=gi?gi(r):new n.constructor(r);return n.copy(r),r}function Rr(n){var t=new n.constructor(n.byteLength);return new vi(t).set(new vi(n)),t}function zr(n,t){return new n.constructor(t?Rr(n.buffer):n.buffer,n.byteOffset,n.length);
}function Wr(n,t){if(n!==t){var r=n!==T,e=null===n,u=n===n,i=wu(n),o=t!==T,f=null===t,c=t===t,a=wu(t);if(!f&&!a&&!i&&n>t||i&&o&&c&&!f&&!a||e&&o&&c||!r&&c||!u)return 1;if(!e&&!i&&!a&&n<t||a&&r&&u&&!e&&!i||f&&r&&u||!o&&u||!c)return-1}return 0}function Ur(n,t,r,e){var u=-1,i=n.length,o=r.length,f=-1,c=t.length,a=Li(i-o,0),l=Ku(c+a);for(e=!e;++f<c;)l[f]=t[f];for(;++u<o;)(e||u<i)&&(l[r[u]]=n[u]);for(;a--;)l[f++]=n[u++];return l}function Br(n,t,r,e){var u=-1,i=n.length,o=-1,f=r.length,c=-1,a=t.length,l=Li(i-f,0),s=Ku(l+a);
for(e=!e;++u<l;)s[u]=n[u];for(l=u;++c<a;)s[l+c]=t[c];for(;++o<f;)(e||u<i)&&(s[l+r[o]]=n[u++]);return s}function Lr(n,t){var r=-1,e=n.length;for(t||(t=Ku(e));++r<e;)t[r]=n[r];return t}function Cr(n,t,r,e){var u=!r;r||(r={});for(var i=-1,o=t.length;++i<o;){var f=t[i],c=e?e(r[f],n[f],f,r,n):T;c===T&&(c=n[f]),u?st(r,f,c):ot(r,f,c)}return r}function Dr(n,t){return Cr(n,po(n),t)}function Mr(n,t){return Cr(n,_o(n),t)}function Tr(n,r){return function(e,u){var i=ff(e)?t:ct,o=r?r():{};return i(e,n,ye(u,2),o);
}}function $r(n){return fr(function(t,r){var e=-1,u=r.length,i=1<u?r[u-1]:T,o=2<u?r[2]:T,i=3<n.length&&typeof i=="function"?(u--,i):T;for(o&&Oe(r[0],r[1],o)&&(i=3>u?T:i,u=1),t=Qu(t);++e<u;)(o=r[e])&&n(t,o,e,i);return t})}function Fr(n,t){return function(r,e){if(null==r)return r;if(!su(r))return n(r,e);for(var u=r.length,i=t?u:-1,o=Qu(r);(t?i--:++i<u)&&false!==e(o[i],i,o););return r}}function Nr(n){return function(t,r,e){var u=-1,i=Qu(t);e=e(t);for(var o=e.length;o--;){var f=e[n?o:++u];if(false===r(i[f],f,i))break;
}return t}}function Pr(n,t,r){function e(){return(this&&this!==$n&&this instanceof e?i:n).apply(u?r:this,arguments)}var u=1&t,i=Vr(n);return e}function Zr(n){return function(t){t=Iu(t);var r=Rn.test(t)?M(t):T,e=r?r[0]:t.charAt(0);return t=r?Or(r,1).join(""):t.slice(1),e[n]()+t}}function qr(n){return function(t){return l(Mu(Du(t).replace(En,"")),n,"")}}function Vr(n){return function(){var t=arguments;switch(t.length){case 0:return new n;case 1:return new n(t[0]);case 2:return new n(t[0],t[1]);case 3:
return new n(t[0],t[1],t[2]);case 4:return new n(t[0],t[1],t[2],t[3]);case 5:return new n(t[0],t[1],t[2],t[3],t[4]);case 6:return new n(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new n(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var r=eo(n.prototype),t=n.apply(r,t);return du(t)?t:r}}function Kr(t,r,e){function u(){for(var o=arguments.length,f=Ku(o),c=o,a=de(u);c--;)f[c]=arguments[c];return c=3>o&&f[0]!==a&&f[o-1]!==a?[]:B(f,a),o-=c.length,o<e?ue(t,r,Jr,u.placeholder,T,f,c,T,T,e-o):n(this&&this!==$n&&this instanceof u?i:t,this,f);
}var i=Vr(t);return u}function Gr(n){return function(t,r,e){var u=Qu(t);if(!su(t)){var i=ye(r,3);t=Wu(t),r=function(n){return i(u[n],n,u)}}return r=n(t,r,e),-1<r?u[i?t[r]:r]:T}}function Hr(n){return pe(function(t){var r=t.length,e=r,u=On.prototype.thru;for(n&&t.reverse();e--;){var i=t[e];if(typeof i!="function")throw new ti("Expected a function");if(u&&!o&&"wrapper"==ge(i))var o=new On([],true)}for(e=o?e:r;++e<r;)var i=t[e],u=ge(i),f="wrapper"==u?ho(i):T,o=f&&Re(f[0])&&424==f[1]&&!f[4].length&&1==f[9]?o[ge(f[0])].apply(o,f[3]):1==i.length&&Re(i)?o[u]():o.thru(i);
return function(){var n=arguments,e=n[0];if(o&&1==n.length&&ff(e))return o.plant(e).value();for(var u=0,n=r?t[u].apply(this,n):e;++u<r;)n=t[u].call(this,n);return n}})}function Jr(n,t,r,e,u,i,o,f,c,a){function l(){for(var d=arguments.length,y=Ku(d),b=d;b--;)y[b]=arguments[b];if(_){var x,j=de(l),b=y.length;for(x=0;b--;)y[b]===j&&++x}if(e&&(y=Ur(y,e,u,_)),i&&(y=Br(y,i,o,_)),d-=x,_&&d<a)return j=B(y,j),ue(n,t,Jr,l.placeholder,r,y,j,f,c,a-d);if(j=h?r:this,b=p?j[n]:n,d=y.length,f){x=y.length;for(var w=Ci(f.length,x),m=Lr(y);w--;){
var A=f[w];y[w]=Se(A,x)?m[A]:T}}else v&&1<d&&y.reverse();return s&&c<d&&(y.length=c),this&&this!==$n&&this instanceof l&&(b=g||Vr(b)),b.apply(j,y)}var s=128&t,h=1&t,p=2&t,_=24&t,v=512&t,g=p?T:Vr(n);return l}function Yr(n,t){return function(r,e){return Ut(r,n,t(e),{})}}function Qr(n,t){return function(r,e){var u;if(r===T&&e===T)return t;if(r!==T&&(u=r),e!==T){if(u===T)return e;typeof r=="string"||typeof e=="string"?(r=yr(r),e=yr(e)):(r=dr(r),e=dr(e)),u=n(r,e)}return u}}function Xr(t){return pe(function(r){
return r=c(r,E(ye())),fr(function(e){var u=this;return t(r,function(t){return n(t,u,e)})})})}function ne(n,t){t=t===T?" ":yr(t);var r=t.length;return 2>r?r?or(t,n):t:(r=or(t,Oi(n/D(t))),Rn.test(t)?Or(M(r),0,n).join(""):r.slice(0,n))}function te(t,r,e,u){function i(){for(var r=-1,c=arguments.length,a=-1,l=u.length,s=Ku(l+c),h=this&&this!==$n&&this instanceof i?f:t;++a<l;)s[a]=u[a];for(;c--;)s[a++]=arguments[++r];return n(h,o?e:this,s)}var o=1&r,f=Vr(t);return i}function re(n){return function(t,r,e){
e&&typeof e!="number"&&Oe(t,r,e)&&(r=e=T),t=Au(t),r===T?(r=t,t=0):r=Au(r),e=e===T?t<r?1:-1:Au(e);var u=-1;r=Li(Oi((r-t)/(e||1)),0);for(var i=Ku(r);r--;)i[n?r:++u]=t,t+=e;return i}}function ee(n){return function(t,r){return typeof t=="string"&&typeof r=="string"||(t=Su(t),r=Su(r)),n(t,r)}}function ue(n,t,r,e,u,i,o,f,c,a){var l=8&t,s=l?o:T;o=l?T:o;var h=l?i:T;return i=l?T:i,t=(t|(l?32:64))&~(l?64:32),4&t||(t&=-4),u=[n,t,u,h,s,i,o,f,c,a],r=r.apply(T,u),Re(n)&&yo(r,u),r.placeholder=e,Le(r,n,t)}function ie(n){
var t=Yu[n];return function(n,r){if(n=Su(n),r=null==r?0:Ci(ku(r),292)){var e=(Iu(n)+"e").split("e"),e=t(e[0]+"e"+(+e[1]+r)),e=(Iu(e)+"e").split("e");return+(e[0]+"e"+(+e[1]-r))}return t(n)}}function oe(n){return function(t){var r=vo(t);return"[object Map]"==r?W(t):"[object Set]"==r?C(t):k(t,n(t))}}function fe(n,t,r,e,u,i,o,f){var c=2&t;if(!c&&typeof n!="function")throw new ti("Expected a function");var a=e?e.length:0;if(a||(t&=-97,e=u=T),o=o===T?o:Li(ku(o),0),f=f===T?f:ku(f),a-=u?u.length:0,64&t){
var l=e,s=u;e=u=T}var h=c?T:ho(n);return i=[n,t,r,e,u,l,s,i,o,f],h&&(r=i[1],n=h[1],t=r|n,e=128==n&&8==r||128==n&&256==r&&i[7].length<=h[8]||384==n&&h[7].length<=h[8]&&8==r,131>t||e)&&(1&n&&(i[2]=h[2],t|=1&r?0:4),(r=h[3])&&(e=i[3],i[3]=e?Ur(e,r,h[4]):r,i[4]=e?B(i[3],"__lodash_placeholder__"):h[4]),(r=h[5])&&(e=i[5],i[5]=e?Br(e,r,h[6]):r,i[6]=e?B(i[5],"__lodash_placeholder__"):h[6]),(r=h[7])&&(i[7]=r),128&n&&(i[8]=null==i[8]?h[8]:Ci(i[8],h[8])),null==i[9]&&(i[9]=h[9]),i[0]=h[0],i[1]=t),n=i[0],t=i[1],
r=i[2],e=i[3],u=i[4],f=i[9]=i[9]===T?c?0:n.length:Li(i[9]-a,0),!f&&24&t&&(t&=-25),c=t&&1!=t?8==t||16==t?Kr(n,t,f):32!=t&&33!=t||u.length?Jr.apply(T,i):te(n,t,r,e):Pr(n,t,r),Le((h?co:yo)(c,i),n,t)}function ce(n,t,r,e){return n===T||lu(n,ei[r])&&!oi.call(e,r)?t:n}function ae(n,t,r,e,u,i){return du(n)&&du(t)&&(i.set(t,n),Yt(n,t,T,ae,i),i.delete(t)),n}function le(n){return xu(n)?T:n}function se(n,t,r,e,u,i){var o=1&r,f=n.length,c=t.length;if(f!=c&&!(o&&c>f))return false;if((c=i.get(n))&&i.get(t))return c==t;
var c=-1,a=true,l=2&r?new Nn:T;for(i.set(n,t),i.set(t,n);++c<f;){var s=n[c],p=t[c];if(e)var _=o?e(p,s,c,t,n,i):e(s,p,c,n,t,i);if(_!==T){if(_)continue;a=false;break}if(l){if(!h(t,function(n,t){if(!O(l,t)&&(s===n||u(s,n,r,e,i)))return l.push(t)})){a=false;break}}else if(s!==p&&!u(s,p,r,e,i)){a=false;break}}return i.delete(n),i.delete(t),a}function he(n,t,r,e,u,i,o){switch(r){case"[object DataView]":if(n.byteLength!=t.byteLength||n.byteOffset!=t.byteOffset)break;n=n.buffer,t=t.buffer;case"[object ArrayBuffer]":
if(n.byteLength!=t.byteLength||!i(new vi(n),new vi(t)))break;return true;case"[object Boolean]":case"[object Date]":case"[object Number]":return lu(+n,+t);case"[object Error]":return n.name==t.name&&n.message==t.message;case"[object RegExp]":case"[object String]":return n==t+"";case"[object Map]":var f=W;case"[object Set]":if(f||(f=L),n.size!=t.size&&!(1&e))break;return(r=o.get(n))?r==t:(e|=2,o.set(n,t),t=se(f(n),f(t),e,u,i,o),o.delete(n),t);case"[object Symbol]":if(to)return to.call(n)==to.call(t)}
return false}function pe(n){return xo(Ue(n,T,Ze),n+"")}function _e(n){return St(n,Wu,po)}function ve(n){return St(n,Uu,_o)}function ge(n){for(var t=n.name+"",r=Gi[t],e=oi.call(Gi,t)?r.length:0;e--;){var u=r[e],i=u.func;if(null==i||i==n)return u.name}return t}function de(n){return(oi.call(An,"placeholder")?An:n).placeholder}function ye(){var n=An.iteratee||Fu,n=n===Fu?qt:n;return arguments.length?n(arguments[0],arguments[1]):n}function be(n,t){var r=n.__data__,e=typeof t;return("string"==e||"number"==e||"symbol"==e||"boolean"==e?"__proto__"!==t:null===t)?r[typeof t=="string"?"string":"hash"]:r.map;
}function xe(n){for(var t=Wu(n),r=t.length;r--;){var e=t[r],u=n[e];t[r]=[e,u,u===u&&!du(u)]}return t}function je(n,t){var r=null==n?T:n[t];return Ft(r)?r:T}function we(n,t,r){t=Sr(t,n);for(var e=-1,u=t.length,i=false;++e<u;){var o=Me(t[e]);if(!(i=null!=n&&r(n,o)))break;n=n[o]}return i||++e!=u?i:(u=null==n?0:n.length,!!u&&gu(u)&&Se(o,u)&&(ff(n)||of(n)))}function me(n){var t=n.length,r=new n.constructor(t);return t&&"string"==typeof n[0]&&oi.call(n,"index")&&(r.index=n.index,r.input=n.input),r}function Ae(n){
return typeof n.constructor!="function"||ze(n)?{}:eo(di(n))}function ke(n,t,r){var e=n.constructor;switch(t){case"[object ArrayBuffer]":return Rr(n);case"[object Boolean]":case"[object Date]":return new e(+n);case"[object DataView]":return t=r?Rr(n.buffer):n.buffer,new n.constructor(t,n.byteOffset,n.byteLength);case"[object Float32Array]":case"[object Float64Array]":case"[object Int8Array]":case"[object Int16Array]":case"[object Int32Array]":case"[object Uint8Array]":case"[object Uint8ClampedArray]":
case"[object Uint16Array]":case"[object Uint32Array]":return zr(n,r);case"[object Map]":return new e;case"[object Number]":case"[object String]":return new e(n);case"[object RegExp]":return t=new n.constructor(n.source,_n.exec(n)),t.lastIndex=n.lastIndex,t;case"[object Set]":return new e;case"[object Symbol]":return to?Qu(to.call(n)):{}}}function Ee(n){return ff(n)||of(n)||!!(ji&&n&&n[ji])}function Se(n,t){var r=typeof n;return t=null==t?9007199254740991:t,!!t&&("number"==r||"symbol"!=r&&bn.test(n))&&-1<n&&0==n%1&&n<t;
}function Oe(n,t,r){if(!du(r))return false;var e=typeof t;return!!("number"==e?su(r)&&Se(t,r.length):"string"==e&&t in r)&&lu(r[t],n)}function Ie(n,t){if(ff(n))return false;var r=typeof n;return!("number"!=r&&"symbol"!=r&&"boolean"!=r&&null!=n&&!wu(n))||(nn.test(n)||!X.test(n)||null!=t&&n in Qu(t))}function Re(n){var t=ge(n),r=An[t];return typeof r=="function"&&t in Ln.prototype&&(n===r||(t=ho(r),!!t&&n===t[0]))}function ze(n){var t=n&&n.constructor;return n===(typeof t=="function"&&t.prototype||ei)}function We(n,t){
return function(r){return null!=r&&(r[n]===t&&(t!==T||n in Qu(r)))}}function Ue(t,r,e){return r=Li(r===T?t.length-1:r,0),function(){for(var u=arguments,i=-1,o=Li(u.length-r,0),f=Ku(o);++i<o;)f[i]=u[r+i];for(i=-1,o=Ku(r+1);++i<r;)o[i]=u[i];return o[r]=e(f),n(t,this,o)}}function Be(n,t){if("__proto__"!=t)return n[t]}function Le(n,t,r){var e=t+"";t=xo;var u,i=$e;return u=(u=e.match(an))?u[1].split(ln):[],r=i(u,r),(i=r.length)&&(u=i-1,r[u]=(1<i?"& ":"")+r[u],r=r.join(2<i?", ":" "),e=e.replace(cn,"{\n/* [wrapped with "+r+"] */\n")),
t(n,e)}function Ce(n){var t=0,r=0;return function(){var e=Di(),u=16-(e-r);if(r=e,0<u){if(800<=++t)return arguments[0]}else t=0;return n.apply(T,arguments)}}function De(n,t){var r=-1,e=n.length,u=e-1;for(t=t===T?e:t;++r<t;){var e=ir(r,u),i=n[e];n[e]=n[r],n[r]=i}return n.length=t,n}function Me(n){if(typeof n=="string"||wu(n))return n;var t=n+"";return"0"==t&&1/n==-$?"-0":t}function Te(n){if(null!=n){try{return ii.call(n)}catch(n){}return n+""}return""}function $e(n,t){return r(N,function(r){var e="_."+r[0];
t&r[1]&&!o(n,e)&&n.push(e)}),n.sort()}function Fe(n){if(n instanceof Ln)return n.clone();var t=new On(n.__wrapped__,n.__chain__);return t.__actions__=Lr(n.__actions__),t.__index__=n.__index__,t.__values__=n.__values__,t}function Ne(n,t,r){var e=null==n?0:n.length;return e?(r=null==r?0:ku(r),0>r&&(r=Li(e+r,0)),_(n,ye(t,3),r)):-1}function Pe(n,t,r){var e=null==n?0:n.length;if(!e)return-1;var u=e-1;return r!==T&&(u=ku(r),u=0>r?Li(e+u,0):Ci(u,e-1)),_(n,ye(t,3),u,true)}function Ze(n){return(null==n?0:n.length)?wt(n,1):[];
}function qe(n){return n&&n.length?n[0]:T}function Ve(n){var t=null==n?0:n.length;return t?n[t-1]:T}function Ke(n,t){return n&&n.length&&t&&t.length?er(n,t):n}function Ge(n){return null==n?n:$i.call(n)}function He(n){if(!n||!n.length)return[];var t=0;return n=i(n,function(n){if(hu(n))return t=Li(n.length,t),true}),A(t,function(t){return c(n,b(t))})}function Je(t,r){if(!t||!t.length)return[];var e=He(t);return null==r?e:c(e,function(t){return n(r,T,t)})}function Ye(n){return n=An(n),n.__chain__=true,n;
}function Qe(n,t){return t(n)}function Xe(){return this}function nu(n,t){return(ff(n)?r:uo)(n,ye(t,3))}function tu(n,t){return(ff(n)?e:io)(n,ye(t,3))}function ru(n,t){return(ff(n)?c:Gt)(n,ye(t,3))}function eu(n,t,r){return t=r?T:t,t=n&&null==t?n.length:t,fe(n,128,T,T,T,T,t)}function uu(n,t){var r;if(typeof t!="function")throw new ti("Expected a function");return n=ku(n),function(){return 0<--n&&(r=t.apply(this,arguments)),1>=n&&(t=T),r}}function iu(n,t,r){return t=r?T:t,n=fe(n,8,T,T,T,T,T,t),n.placeholder=iu.placeholder,
n}function ou(n,t,r){return t=r?T:t,n=fe(n,16,T,T,T,T,T,t),n.placeholder=ou.placeholder,n}function fu(n,t,r){function e(t){var r=c,e=a;return c=a=T,_=t,s=n.apply(e,r)}function u(n){var r=n-p;return n-=_,p===T||r>=t||0>r||g&&n>=l}function i(){var n=Go();if(u(n))return o(n);var r,e=bo;r=n-_,n=t-(n-p),r=g?Ci(n,l-r):n,h=e(i,r)}function o(n){return h=T,d&&c?e(n):(c=a=T,s)}function f(){var n=Go(),r=u(n);if(c=arguments,a=this,p=n,r){if(h===T)return _=n=p,h=bo(i,t),v?e(n):s;if(g)return h=bo(i,t),e(p)}return h===T&&(h=bo(i,t)),
s}var c,a,l,s,h,p,_=0,v=false,g=false,d=true;if(typeof n!="function")throw new ti("Expected a function");return t=Su(t)||0,du(r)&&(v=!!r.leading,l=(g="maxWait"in r)?Li(Su(r.maxWait)||0,t):l,d="trailing"in r?!!r.trailing:d),f.cancel=function(){h!==T&&lo(h),_=0,c=p=a=h=T},f.flush=function(){return h===T?s:o(Go())},f}function cu(n,t){if(typeof n!="function"||null!=t&&typeof t!="function")throw new ti("Expected a function");var r=function(){var e=arguments,u=t?t.apply(this,e):e[0],i=r.cache;return i.has(u)?i.get(u):(e=n.apply(this,e),
r.cache=i.set(u,e)||i,e)};return r.cache=new(cu.Cache||Fn),r}function au(n){if(typeof n!="function")throw new ti("Expected a function");return function(){var t=arguments;switch(t.length){case 0:return!n.call(this);case 1:return!n.call(this,t[0]);case 2:return!n.call(this,t[0],t[1]);case 3:return!n.call(this,t[0],t[1],t[2])}return!n.apply(this,t)}}function lu(n,t){return n===t||n!==n&&t!==t}function su(n){return null!=n&&gu(n.length)&&!_u(n)}function hu(n){return yu(n)&&su(n)}function pu(n){if(!yu(n))return false;
var t=Ot(n);return"[object Error]"==t||"[object DOMException]"==t||typeof n.message=="string"&&typeof n.name=="string"&&!xu(n)}function _u(n){return!!du(n)&&(n=Ot(n),"[object Function]"==n||"[object GeneratorFunction]"==n||"[object AsyncFunction]"==n||"[object Proxy]"==n)}function vu(n){return typeof n=="number"&&n==ku(n)}function gu(n){return typeof n=="number"&&-1<n&&0==n%1&&9007199254740991>=n}function du(n){var t=typeof n;return null!=n&&("object"==t||"function"==t)}function yu(n){return null!=n&&typeof n=="object";
}function bu(n){return typeof n=="number"||yu(n)&&"[object Number]"==Ot(n)}function xu(n){return!(!yu(n)||"[object Object]"!=Ot(n))&&(n=di(n),null===n||(n=oi.call(n,"constructor")&&n.constructor,typeof n=="function"&&n instanceof n&&ii.call(n)==li))}function ju(n){return typeof n=="string"||!ff(n)&&yu(n)&&"[object String]"==Ot(n)}function wu(n){return typeof n=="symbol"||yu(n)&&"[object Symbol]"==Ot(n)}function mu(n){if(!n)return[];if(su(n))return ju(n)?M(n):Lr(n);if(wi&&n[wi]){n=n[wi]();for(var t,r=[];!(t=n.next()).done;)r.push(t.value);
return r}return t=vo(n),("[object Map]"==t?W:"[object Set]"==t?L:Lu)(n)}function Au(n){return n?(n=Su(n),n===$||n===-$?1.7976931348623157e308*(0>n?-1:1):n===n?n:0):0===n?n:0}function ku(n){n=Au(n);var t=n%1;return n===n?t?n-t:n:0}function Eu(n){return n?pt(ku(n),0,4294967295):0}function Su(n){if(typeof n=="number")return n;if(wu(n))return F;if(du(n)&&(n=typeof n.valueOf=="function"?n.valueOf():n,n=du(n)?n+"":n),typeof n!="string")return 0===n?n:+n;n=n.replace(un,"");var t=gn.test(n);return t||yn.test(n)?Dn(n.slice(2),t?2:8):vn.test(n)?F:+n;
}function Ou(n){return Cr(n,Uu(n))}function Iu(n){return null==n?"":yr(n)}function Ru(n,t,r){return n=null==n?T:Et(n,t),n===T?r:n}function zu(n,t){return null!=n&&we(n,t,zt)}function Wu(n){return su(n)?qn(n):Vt(n)}function Uu(n){if(su(n))n=qn(n,true);else if(du(n)){var t,r=ze(n),e=[];for(t in n)("constructor"!=t||!r&&oi.call(n,t))&&e.push(t);n=e}else{if(t=[],null!=n)for(r in Qu(n))t.push(r);n=t}return n}function Bu(n,t){if(null==n)return{};var r=c(ve(n),function(n){return[n]});return t=ye(t),tr(n,r,function(n,r){
return t(n,r[0])})}function Lu(n){return null==n?[]:S(n,Wu(n))}function Cu(n){return $f(Iu(n).toLowerCase())}function Du(n){return(n=Iu(n))&&n.replace(xn,Xn).replace(Sn,"")}function Mu(n,t,r){return n=Iu(n),t=r?T:t,t===T?zn.test(n)?n.match(In)||[]:n.match(sn)||[]:n.match(t)||[]}function Tu(n){return function(){return n}}function $u(n){return n}function Fu(n){return qt(typeof n=="function"?n:_t(n,1))}function Nu(n,t,e){var u=Wu(t),i=kt(t,u);null!=e||du(t)&&(i.length||!u.length)||(e=t,t=n,n=this,i=kt(t,Wu(t)));
var o=!(du(e)&&"chain"in e&&!e.chain),f=_u(n);return r(i,function(r){var e=t[r];n[r]=e,f&&(n.prototype[r]=function(){var t=this.__chain__;if(o||t){var r=n(this.__wrapped__);return(r.__actions__=Lr(this.__actions__)).push({func:e,args:arguments,thisArg:n}),r.__chain__=t,r}return e.apply(n,a([this.value()],arguments))})}),n}function Pu(){}function Zu(n){return Ie(n)?b(Me(n)):rr(n)}function qu(){return[]}function Vu(){return false}mn=null==mn?$n:rt.defaults($n.Object(),mn,rt.pick($n,Wn));var Ku=mn.Array,Gu=mn.Date,Hu=mn.Error,Ju=mn.Function,Yu=mn.Math,Qu=mn.Object,Xu=mn.RegExp,ni=mn.String,ti=mn.TypeError,ri=Ku.prototype,ei=Qu.prototype,ui=mn["__core-js_shared__"],ii=Ju.prototype.toString,oi=ei.hasOwnProperty,fi=0,ci=function(){
var n=/[^.]+$/.exec(ui&&ui.keys&&ui.keys.IE_PROTO||"");return n?"Symbol(src)_1."+n:""}(),ai=ei.toString,li=ii.call(Qu),si=$n._,hi=Xu("^"+ii.call(oi).replace(rn,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),pi=Pn?mn.Buffer:T,_i=mn.Symbol,vi=mn.Uint8Array,gi=pi?pi.allocUnsafe:T,di=U(Qu.getPrototypeOf,Qu),yi=Qu.create,bi=ei.propertyIsEnumerable,xi=ri.splice,ji=_i?_i.isConcatSpreadable:T,wi=_i?_i.iterator:T,mi=_i?_i.toStringTag:T,Ai=function(){try{var n=je(Qu,"defineProperty");
return n({},"",{}),n}catch(n){}}(),ki=mn.clearTimeout!==$n.clearTimeout&&mn.clearTimeout,Ei=Gu&&Gu.now!==$n.Date.now&&Gu.now,Si=mn.setTimeout!==$n.setTimeout&&mn.setTimeout,Oi=Yu.ceil,Ii=Yu.floor,Ri=Qu.getOwnPropertySymbols,zi=pi?pi.isBuffer:T,Wi=mn.isFinite,Ui=ri.join,Bi=U(Qu.keys,Qu),Li=Yu.max,Ci=Yu.min,Di=Gu.now,Mi=mn.parseInt,Ti=Yu.random,$i=ri.reverse,Fi=je(mn,"DataView"),Ni=je(mn,"Map"),Pi=je(mn,"Promise"),Zi=je(mn,"Set"),qi=je(mn,"WeakMap"),Vi=je(Qu,"create"),Ki=qi&&new qi,Gi={},Hi=Te(Fi),Ji=Te(Ni),Yi=Te(Pi),Qi=Te(Zi),Xi=Te(qi),no=_i?_i.prototype:T,to=no?no.valueOf:T,ro=no?no.toString:T,eo=function(){
function n(){}return function(t){return du(t)?yi?yi(t):(n.prototype=t,t=new n,n.prototype=T,t):{}}}();An.templateSettings={escape:J,evaluate:Y,interpolate:Q,variable:"",imports:{_:An}},An.prototype=kn.prototype,An.prototype.constructor=An,On.prototype=eo(kn.prototype),On.prototype.constructor=On,Ln.prototype=eo(kn.prototype),Ln.prototype.constructor=Ln,Mn.prototype.clear=function(){this.__data__=Vi?Vi(null):{},this.size=0},Mn.prototype.delete=function(n){return n=this.has(n)&&delete this.__data__[n],
this.size-=n?1:0,n},Mn.prototype.get=function(n){var t=this.__data__;return Vi?(n=t[n],"__lodash_hash_undefined__"===n?T:n):oi.call(t,n)?t[n]:T},Mn.prototype.has=function(n){var t=this.__data__;return Vi?t[n]!==T:oi.call(t,n)},Mn.prototype.set=function(n,t){var r=this.__data__;return this.size+=this.has(n)?0:1,r[n]=Vi&&t===T?"__lodash_hash_undefined__":t,this},Tn.prototype.clear=function(){this.__data__=[],this.size=0},Tn.prototype.delete=function(n){var t=this.__data__;return n=ft(t,n),!(0>n)&&(n==t.length-1?t.pop():xi.call(t,n,1),
--this.size,true)},Tn.prototype.get=function(n){var t=this.__data__;return n=ft(t,n),0>n?T:t[n][1]},Tn.prototype.has=function(n){return-1<ft(this.__data__,n)},Tn.prototype.set=function(n,t){var r=this.__data__,e=ft(r,n);return 0>e?(++this.size,r.push([n,t])):r[e][1]=t,this},Fn.prototype.clear=function(){this.size=0,this.__data__={hash:new Mn,map:new(Ni||Tn),string:new Mn}},Fn.prototype.delete=function(n){return n=be(this,n).delete(n),this.size-=n?1:0,n},Fn.prototype.get=function(n){return be(this,n).get(n);
},Fn.prototype.has=function(n){return be(this,n).has(n)},Fn.prototype.set=function(n,t){var r=be(this,n),e=r.size;return r.set(n,t),this.size+=r.size==e?0:1,this},Nn.prototype.add=Nn.prototype.push=function(n){return this.__data__.set(n,"__lodash_hash_undefined__"),this},Nn.prototype.has=function(n){return this.__data__.has(n)},Zn.prototype.clear=function(){this.__data__=new Tn,this.size=0},Zn.prototype.delete=function(n){var t=this.__data__;return n=t.delete(n),this.size=t.size,n},Zn.prototype.get=function(n){
return this.__data__.get(n)},Zn.prototype.has=function(n){return this.__data__.has(n)},Zn.prototype.set=function(n,t){var r=this.__data__;if(r instanceof Tn){var e=r.__data__;if(!Ni||199>e.length)return e.push([n,t]),this.size=++r.size,this;r=this.__data__=new Fn(e)}return r.set(n,t),this.size=r.size,this};var uo=Fr(mt),io=Fr(At,true),oo=Nr(),fo=Nr(true),co=Ki?function(n,t){return Ki.set(n,t),n}:$u,ao=Ai?function(n,t){return Ai(n,"toString",{configurable:true,enumerable:false,value:Tu(t),writable:true})}:$u,lo=ki||function(n){
return $n.clearTimeout(n)},so=Zi&&1/L(new Zi([,-0]))[1]==$?function(n){return new Zi(n)}:Pu,ho=Ki?function(n){return Ki.get(n)}:Pu,po=Ri?function(n){return null==n?[]:(n=Qu(n),i(Ri(n),function(t){return bi.call(n,t)}))}:qu,_o=Ri?function(n){for(var t=[];n;)a(t,po(n)),n=di(n);return t}:qu,vo=Ot;(Fi&&"[object DataView]"!=vo(new Fi(new ArrayBuffer(1)))||Ni&&"[object Map]"!=vo(new Ni)||Pi&&"[object Promise]"!=vo(Pi.resolve())||Zi&&"[object Set]"!=vo(new Zi)||qi&&"[object WeakMap]"!=vo(new qi))&&(vo=function(n){
var t=Ot(n);if(n=(n="[object Object]"==t?n.constructor:T)?Te(n):"")switch(n){case Hi:return"[object DataView]";case Ji:return"[object Map]";case Yi:return"[object Promise]";case Qi:return"[object Set]";case Xi:return"[object WeakMap]"}return t});var go=ui?_u:Vu,yo=Ce(co),bo=Si||function(n,t){return $n.setTimeout(n,t)},xo=Ce(ao),jo=function(n){n=cu(n,function(n){return 500===t.size&&t.clear(),n});var t=n.cache;return n}(function(n){var t=[];return 46===n.charCodeAt(0)&&t.push(""),n.replace(tn,function(n,r,e,u){
t.push(e?u.replace(hn,"$1"):r||n)}),t}),wo=fr(function(n,t){return hu(n)?yt(n,wt(t,1,hu,true)):[]}),mo=fr(function(n,t){var r=Ve(t);return hu(r)&&(r=T),hu(n)?yt(n,wt(t,1,hu,true),ye(r,2)):[]}),Ao=fr(function(n,t){var r=Ve(t);return hu(r)&&(r=T),hu(n)?yt(n,wt(t,1,hu,true),T,r):[]}),ko=fr(function(n){var t=c(n,kr);return t.length&&t[0]===n[0]?Wt(t):[]}),Eo=fr(function(n){var t=Ve(n),r=c(n,kr);return t===Ve(r)?t=T:r.pop(),r.length&&r[0]===n[0]?Wt(r,ye(t,2)):[]}),So=fr(function(n){var t=Ve(n),r=c(n,kr);return(t=typeof t=="function"?t:T)&&r.pop(),
r.length&&r[0]===n[0]?Wt(r,T,t):[]}),Oo=fr(Ke),Io=pe(function(n,t){var r=null==n?0:n.length,e=ht(n,t);return ur(n,c(t,function(n){return Se(n,r)?+n:n}).sort(Wr)),e}),Ro=fr(function(n){return br(wt(n,1,hu,true))}),zo=fr(function(n){var t=Ve(n);return hu(t)&&(t=T),br(wt(n,1,hu,true),ye(t,2))}),Wo=fr(function(n){var t=Ve(n),t=typeof t=="function"?t:T;return br(wt(n,1,hu,true),T,t)}),Uo=fr(function(n,t){return hu(n)?yt(n,t):[]}),Bo=fr(function(n){return mr(i(n,hu))}),Lo=fr(function(n){var t=Ve(n);return hu(t)&&(t=T),
mr(i(n,hu),ye(t,2))}),Co=fr(function(n){var t=Ve(n),t=typeof t=="function"?t:T;return mr(i(n,hu),T,t)}),Do=fr(He),Mo=fr(function(n){var t=n.length,t=1<t?n[t-1]:T,t=typeof t=="function"?(n.pop(),t):T;return Je(n,t)}),To=pe(function(n){var t=n.length,r=t?n[0]:0,e=this.__wrapped__,u=function(t){return ht(t,n)};return!(1<t||this.__actions__.length)&&e instanceof Ln&&Se(r)?(e=e.slice(r,+r+(t?1:0)),e.__actions__.push({func:Qe,args:[u],thisArg:T}),new On(e,this.__chain__).thru(function(n){return t&&!n.length&&n.push(T),
n})):this.thru(u)}),$o=Tr(function(n,t,r){oi.call(n,r)?++n[r]:st(n,r,1)}),Fo=Gr(Ne),No=Gr(Pe),Po=Tr(function(n,t,r){oi.call(n,r)?n[r].push(t):st(n,r,[t])}),Zo=fr(function(t,r,e){var u=-1,i=typeof r=="function",o=su(t)?Ku(t.length):[];return uo(t,function(t){o[++u]=i?n(r,t,e):Bt(t,r,e)}),o}),qo=Tr(function(n,t,r){st(n,r,t)}),Vo=Tr(function(n,t,r){n[r?0:1].push(t)},function(){return[[],[]]}),Ko=fr(function(n,t){if(null==n)return[];var r=t.length;return 1<r&&Oe(n,t[0],t[1])?t=[]:2<r&&Oe(t[0],t[1],t[2])&&(t=[t[0]]),
Xt(n,wt(t,1),[])}),Go=Ei||function(){return $n.Date.now()},Ho=fr(function(n,t,r){var e=1;if(r.length)var u=B(r,de(Ho)),e=32|e;return fe(n,e,t,r,u)}),Jo=fr(function(n,t,r){var e=3;if(r.length)var u=B(r,de(Jo)),e=32|e;return fe(t,e,n,r,u)}),Yo=fr(function(n,t){return dt(n,1,t)}),Qo=fr(function(n,t,r){return dt(n,Su(t)||0,r)});cu.Cache=Fn;var Xo=fr(function(t,r){r=1==r.length&&ff(r[0])?c(r[0],E(ye())):c(wt(r,1),E(ye()));var e=r.length;return fr(function(u){for(var i=-1,o=Ci(u.length,e);++i<o;)u[i]=r[i].call(this,u[i]);
return n(t,this,u)})}),nf=fr(function(n,t){return fe(n,32,T,t,B(t,de(nf)))}),tf=fr(function(n,t){return fe(n,64,T,t,B(t,de(tf)))}),rf=pe(function(n,t){return fe(n,256,T,T,T,t)}),ef=ee(It),uf=ee(function(n,t){return n>=t}),of=Lt(function(){return arguments}())?Lt:function(n){return yu(n)&&oi.call(n,"callee")&&!bi.call(n,"callee")},ff=Ku.isArray,cf=Vn?E(Vn):Ct,af=zi||Vu,lf=Kn?E(Kn):Dt,sf=Gn?E(Gn):Tt,hf=Hn?E(Hn):Nt,pf=Jn?E(Jn):Pt,_f=Yn?E(Yn):Zt,vf=ee(Kt),gf=ee(function(n,t){return n<=t}),df=$r(function(n,t){
if(ze(t)||su(t))Cr(t,Wu(t),n);else for(var r in t)oi.call(t,r)&&ot(n,r,t[r])}),yf=$r(function(n,t){Cr(t,Uu(t),n)}),bf=$r(function(n,t,r,e){Cr(t,Uu(t),n,e)}),xf=$r(function(n,t,r,e){Cr(t,Wu(t),n,e)}),jf=pe(ht),wf=fr(function(n,t){n=Qu(n);var r=-1,e=t.length,u=2<e?t[2]:T;for(u&&Oe(t[0],t[1],u)&&(e=1);++r<e;)for(var u=t[r],i=Uu(u),o=-1,f=i.length;++o<f;){var c=i[o],a=n[c];(a===T||lu(a,ei[c])&&!oi.call(n,c))&&(n[c]=u[c])}return n}),mf=fr(function(t){return t.push(T,ae),n(Of,T,t)}),Af=Yr(function(n,t,r){
null!=t&&typeof t.toString!="function"&&(t=ai.call(t)),n[t]=r},Tu($u)),kf=Yr(function(n,t,r){null!=t&&typeof t.toString!="function"&&(t=ai.call(t)),oi.call(n,t)?n[t].push(r):n[t]=[r]},ye),Ef=fr(Bt),Sf=$r(function(n,t,r){Yt(n,t,r)}),Of=$r(function(n,t,r,e){Yt(n,t,r,e)}),If=pe(function(n,t){var r={};if(null==n)return r;var e=false;t=c(t,function(t){return t=Sr(t,n),e||(e=1<t.length),t}),Cr(n,ve(n),r),e&&(r=_t(r,7,le));for(var u=t.length;u--;)xr(r,t[u]);return r}),Rf=pe(function(n,t){return null==n?{}:nr(n,t);
}),zf=oe(Wu),Wf=oe(Uu),Uf=qr(function(n,t,r){return t=t.toLowerCase(),n+(r?Cu(t):t)}),Bf=qr(function(n,t,r){return n+(r?"-":"")+t.toLowerCase()}),Lf=qr(function(n,t,r){return n+(r?" ":"")+t.toLowerCase()}),Cf=Zr("toLowerCase"),Df=qr(function(n,t,r){return n+(r?"_":"")+t.toLowerCase()}),Mf=qr(function(n,t,r){return n+(r?" ":"")+$f(t)}),Tf=qr(function(n,t,r){return n+(r?" ":"")+t.toUpperCase()}),$f=Zr("toUpperCase"),Ff=fr(function(t,r){try{return n(t,T,r)}catch(n){return pu(n)?n:new Hu(n)}}),Nf=pe(function(n,t){
return r(t,function(t){t=Me(t),st(n,t,Ho(n[t],n))}),n}),Pf=Hr(),Zf=Hr(true),qf=fr(function(n,t){return function(r){return Bt(r,n,t)}}),Vf=fr(function(n,t){return function(r){return Bt(n,r,t)}}),Kf=Xr(c),Gf=Xr(u),Hf=Xr(h),Jf=re(),Yf=re(true),Qf=Qr(function(n,t){return n+t},0),Xf=ie("ceil"),nc=Qr(function(n,t){return n/t},1),tc=ie("floor"),rc=Qr(function(n,t){return n*t},1),ec=ie("round"),uc=Qr(function(n,t){return n-t},0);return An.after=function(n,t){if(typeof t!="function")throw new ti("Expected a function");
return n=ku(n),function(){if(1>--n)return t.apply(this,arguments)}},An.ary=eu,An.assign=df,An.assignIn=yf,An.assignInWith=bf,An.assignWith=xf,An.at=jf,An.before=uu,An.bind=Ho,An.bindAll=Nf,An.bindKey=Jo,An.castArray=function(){if(!arguments.length)return[];var n=arguments[0];return ff(n)?n:[n]},An.chain=Ye,An.chunk=function(n,t,r){if(t=(r?Oe(n,t,r):t===T)?1:Li(ku(t),0),r=null==n?0:n.length,!r||1>t)return[];for(var e=0,u=0,i=Ku(Oi(r/t));e<r;)i[u++]=hr(n,e,e+=t);return i},An.compact=function(n){for(var t=-1,r=null==n?0:n.length,e=0,u=[];++t<r;){
var i=n[t];i&&(u[e++]=i)}return u},An.concat=function(){var n=arguments.length;if(!n)return[];for(var t=Ku(n-1),r=arguments[0];n--;)t[n-1]=arguments[n];return a(ff(r)?Lr(r):[r],wt(t,1))},An.cond=function(t){var r=null==t?0:t.length,e=ye();return t=r?c(t,function(n){if("function"!=typeof n[1])throw new ti("Expected a function");return[e(n[0]),n[1]]}):[],fr(function(e){for(var u=-1;++u<r;){var i=t[u];if(n(i[0],this,e))return n(i[1],this,e)}})},An.conforms=function(n){return vt(_t(n,1))},An.constant=Tu,
An.countBy=$o,An.create=function(n,t){var r=eo(n);return null==t?r:at(r,t)},An.curry=iu,An.curryRight=ou,An.debounce=fu,An.defaults=wf,An.defaultsDeep=mf,An.defer=Yo,An.delay=Qo,An.difference=wo,An.differenceBy=mo,An.differenceWith=Ao,An.drop=function(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===T?1:ku(t),hr(n,0>t?0:t,e)):[]},An.dropRight=function(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===T?1:ku(t),t=e-t,hr(n,0,0>t?0:t)):[]},An.dropRightWhile=function(n,t){return n&&n.length?jr(n,ye(t,3),true,true):[];
},An.dropWhile=function(n,t){return n&&n.length?jr(n,ye(t,3),true):[]},An.fill=function(n,t,r,e){var u=null==n?0:n.length;if(!u)return[];for(r&&typeof r!="number"&&Oe(n,t,r)&&(r=0,e=u),u=n.length,r=ku(r),0>r&&(r=-r>u?0:u+r),e=e===T||e>u?u:ku(e),0>e&&(e+=u),e=r>e?0:Eu(e);r<e;)n[r++]=t;return n},An.filter=function(n,t){return(ff(n)?i:jt)(n,ye(t,3))},An.flatMap=function(n,t){return wt(ru(n,t),1)},An.flatMapDeep=function(n,t){return wt(ru(n,t),$)},An.flatMapDepth=function(n,t,r){return r=r===T?1:ku(r),
wt(ru(n,t),r)},An.flatten=Ze,An.flattenDeep=function(n){return(null==n?0:n.length)?wt(n,$):[]},An.flattenDepth=function(n,t){return null!=n&&n.length?(t=t===T?1:ku(t),wt(n,t)):[]},An.flip=function(n){return fe(n,512)},An.flow=Pf,An.flowRight=Zf,An.fromPairs=function(n){for(var t=-1,r=null==n?0:n.length,e={};++t<r;){var u=n[t];e[u[0]]=u[1]}return e},An.functions=function(n){return null==n?[]:kt(n,Wu(n))},An.functionsIn=function(n){return null==n?[]:kt(n,Uu(n))},An.groupBy=Po,An.initial=function(n){
return(null==n?0:n.length)?hr(n,0,-1):[]},An.intersection=ko,An.intersectionBy=Eo,An.intersectionWith=So,An.invert=Af,An.invertBy=kf,An.invokeMap=Zo,An.iteratee=Fu,An.keyBy=qo,An.keys=Wu,An.keysIn=Uu,An.map=ru,An.mapKeys=function(n,t){var r={};return t=ye(t,3),mt(n,function(n,e,u){st(r,t(n,e,u),n)}),r},An.mapValues=function(n,t){var r={};return t=ye(t,3),mt(n,function(n,e,u){st(r,e,t(n,e,u))}),r},An.matches=function(n){return Ht(_t(n,1))},An.matchesProperty=function(n,t){return Jt(n,_t(t,1))},An.memoize=cu,
An.merge=Sf,An.mergeWith=Of,An.method=qf,An.methodOf=Vf,An.mixin=Nu,An.negate=au,An.nthArg=function(n){return n=ku(n),fr(function(t){return Qt(t,n)})},An.omit=If,An.omitBy=function(n,t){return Bu(n,au(ye(t)))},An.once=function(n){return uu(2,n)},An.orderBy=function(n,t,r,e){return null==n?[]:(ff(t)||(t=null==t?[]:[t]),r=e?T:r,ff(r)||(r=null==r?[]:[r]),Xt(n,t,r))},An.over=Kf,An.overArgs=Xo,An.overEvery=Gf,An.overSome=Hf,An.partial=nf,An.partialRight=tf,An.partition=Vo,An.pick=Rf,An.pickBy=Bu,An.property=Zu,
An.propertyOf=function(n){return function(t){return null==n?T:Et(n,t)}},An.pull=Oo,An.pullAll=Ke,An.pullAllBy=function(n,t,r){return n&&n.length&&t&&t.length?er(n,t,ye(r,2)):n},An.pullAllWith=function(n,t,r){return n&&n.length&&t&&t.length?er(n,t,T,r):n},An.pullAt=Io,An.range=Jf,An.rangeRight=Yf,An.rearg=rf,An.reject=function(n,t){return(ff(n)?i:jt)(n,au(ye(t,3)))},An.remove=function(n,t){var r=[];if(!n||!n.length)return r;var e=-1,u=[],i=n.length;for(t=ye(t,3);++e<i;){var o=n[e];t(o,e,n)&&(r.push(o),
u.push(e))}return ur(n,u),r},An.rest=function(n,t){if(typeof n!="function")throw new ti("Expected a function");return t=t===T?t:ku(t),fr(n,t)},An.reverse=Ge,An.sampleSize=function(n,t,r){return t=(r?Oe(n,t,r):t===T)?1:ku(t),(ff(n)?et:ar)(n,t)},An.set=function(n,t,r){return null==n?n:lr(n,t,r)},An.setWith=function(n,t,r,e){return e=typeof e=="function"?e:T,null==n?n:lr(n,t,r,e)},An.shuffle=function(n){return(ff(n)?ut:sr)(n)},An.slice=function(n,t,r){var e=null==n?0:n.length;return e?(r&&typeof r!="number"&&Oe(n,t,r)?(t=0,
r=e):(t=null==t?0:ku(t),r=r===T?e:ku(r)),hr(n,t,r)):[]},An.sortBy=Ko,An.sortedUniq=function(n){return n&&n.length?gr(n):[]},An.sortedUniqBy=function(n,t){return n&&n.length?gr(n,ye(t,2)):[]},An.split=function(n,t,r){return r&&typeof r!="number"&&Oe(n,t,r)&&(t=r=T),r=r===T?4294967295:r>>>0,r?(n=Iu(n))&&(typeof t=="string"||null!=t&&!hf(t))&&(t=yr(t),!t&&Rn.test(n))?Or(M(n),0,r):n.split(t,r):[]},An.spread=function(t,r){if(typeof t!="function")throw new ti("Expected a function");return r=null==r?0:Li(ku(r),0),
fr(function(e){var u=e[r];return e=Or(e,0,r),u&&a(e,u),n(t,this,e)})},An.tail=function(n){var t=null==n?0:n.length;return t?hr(n,1,t):[]},An.take=function(n,t,r){return n&&n.length?(t=r||t===T?1:ku(t),hr(n,0,0>t?0:t)):[]},An.takeRight=function(n,t,r){var e=null==n?0:n.length;return e?(t=r||t===T?1:ku(t),t=e-t,hr(n,0>t?0:t,e)):[]},An.takeRightWhile=function(n,t){return n&&n.length?jr(n,ye(t,3),false,true):[]},An.takeWhile=function(n,t){return n&&n.length?jr(n,ye(t,3)):[]},An.tap=function(n,t){return t(n),
n},An.throttle=function(n,t,r){var e=true,u=true;if(typeof n!="function")throw new ti("Expected a function");return du(r)&&(e="leading"in r?!!r.leading:e,u="trailing"in r?!!r.trailing:u),fu(n,t,{leading:e,maxWait:t,trailing:u})},An.thru=Qe,An.toArray=mu,An.toPairs=zf,An.toPairsIn=Wf,An.toPath=function(n){return ff(n)?c(n,Me):wu(n)?[n]:Lr(jo(Iu(n)))},An.toPlainObject=Ou,An.transform=function(n,t,e){var u=ff(n),i=u||af(n)||_f(n);if(t=ye(t,4),null==e){var o=n&&n.constructor;e=i?u?new o:[]:du(n)&&_u(o)?eo(di(n)):{};
}return(i?r:mt)(n,function(n,r,u){return t(e,n,r,u)}),e},An.unary=function(n){return eu(n,1)},An.union=Ro,An.unionBy=zo,An.unionWith=Wo,An.uniq=function(n){return n&&n.length?br(n):[]},An.uniqBy=function(n,t){return n&&n.length?br(n,ye(t,2)):[]},An.uniqWith=function(n,t){return t=typeof t=="function"?t:T,n&&n.length?br(n,T,t):[]},An.unset=function(n,t){return null==n||xr(n,t)},An.unzip=He,An.unzipWith=Je,An.update=function(n,t,r){return null!=n&&(r=Er(r),n=lr(n,t,r(Et(n,t)),void 0)),n},An.updateWith=function(n,t,r,e){
return e=typeof e=="function"?e:T,null!=n&&(r=Er(r),n=lr(n,t,r(Et(n,t)),e)),n},An.values=Lu,An.valuesIn=function(n){return null==n?[]:S(n,Uu(n))},An.without=Uo,An.words=Mu,An.wrap=function(n,t){return nf(Er(t),n)},An.xor=Bo,An.xorBy=Lo,An.xorWith=Co,An.zip=Do,An.zipObject=function(n,t){return Ar(n||[],t||[],ot)},An.zipObjectDeep=function(n,t){return Ar(n||[],t||[],lr)},An.zipWith=Mo,An.entries=zf,An.entriesIn=Wf,An.extend=yf,An.extendWith=bf,Nu(An,An),An.add=Qf,An.attempt=Ff,An.camelCase=Uf,An.capitalize=Cu,
An.ceil=Xf,An.clamp=function(n,t,r){return r===T&&(r=t,t=T),r!==T&&(r=Su(r),r=r===r?r:0),t!==T&&(t=Su(t),t=t===t?t:0),pt(Su(n),t,r)},An.clone=function(n){return _t(n,4)},An.cloneDeep=function(n){return _t(n,5)},An.cloneDeepWith=function(n,t){return t=typeof t=="function"?t:T,_t(n,5,t)},An.cloneWith=function(n,t){return t=typeof t=="function"?t:T,_t(n,4,t)},An.conformsTo=function(n,t){return null==t||gt(n,t,Wu(t))},An.deburr=Du,An.defaultTo=function(n,t){return null==n||n!==n?t:n},An.divide=nc,An.endsWith=function(n,t,r){
n=Iu(n),t=yr(t);var e=n.length,e=r=r===T?e:pt(ku(r),0,e);return r-=t.length,0<=r&&n.slice(r,e)==t},An.eq=lu,An.escape=function(n){return(n=Iu(n))&&H.test(n)?n.replace(K,nt):n},An.escapeRegExp=function(n){return(n=Iu(n))&&en.test(n)?n.replace(rn,"\\$&"):n},An.every=function(n,t,r){var e=ff(n)?u:bt;return r&&Oe(n,t,r)&&(t=T),e(n,ye(t,3))},An.find=Fo,An.findIndex=Ne,An.findKey=function(n,t){return p(n,ye(t,3),mt)},An.findLast=No,An.findLastIndex=Pe,An.findLastKey=function(n,t){return p(n,ye(t,3),At);
},An.floor=tc,An.forEach=nu,An.forEachRight=tu,An.forIn=function(n,t){return null==n?n:oo(n,ye(t,3),Uu)},An.forInRight=function(n,t){return null==n?n:fo(n,ye(t,3),Uu)},An.forOwn=function(n,t){return n&&mt(n,ye(t,3))},An.forOwnRight=function(n,t){return n&&At(n,ye(t,3))},An.get=Ru,An.gt=ef,An.gte=uf,An.has=function(n,t){return null!=n&&we(n,t,Rt)},An.hasIn=zu,An.head=qe,An.identity=$u,An.includes=function(n,t,r,e){return n=su(n)?n:Lu(n),r=r&&!e?ku(r):0,e=n.length,0>r&&(r=Li(e+r,0)),ju(n)?r<=e&&-1<n.indexOf(t,r):!!e&&-1<v(n,t,r);
},An.indexOf=function(n,t,r){var e=null==n?0:n.length;return e?(r=null==r?0:ku(r),0>r&&(r=Li(e+r,0)),v(n,t,r)):-1},An.inRange=function(n,t,r){return t=Au(t),r===T?(r=t,t=0):r=Au(r),n=Su(n),n>=Ci(t,r)&&n<Li(t,r)},An.invoke=Ef,An.isArguments=of,An.isArray=ff,An.isArrayBuffer=cf,An.isArrayLike=su,An.isArrayLikeObject=hu,An.isBoolean=function(n){return true===n||false===n||yu(n)&&"[object Boolean]"==Ot(n)},An.isBuffer=af,An.isDate=lf,An.isElement=function(n){return yu(n)&&1===n.nodeType&&!xu(n)},An.isEmpty=function(n){
if(null==n)return true;if(su(n)&&(ff(n)||typeof n=="string"||typeof n.splice=="function"||af(n)||_f(n)||of(n)))return!n.length;var t=vo(n);if("[object Map]"==t||"[object Set]"==t)return!n.size;if(ze(n))return!Vt(n).length;for(var r in n)if(oi.call(n,r))return false;return true},An.isEqual=function(n,t){return Mt(n,t)},An.isEqualWith=function(n,t,r){var e=(r=typeof r=="function"?r:T)?r(n,t):T;return e===T?Mt(n,t,T,r):!!e},An.isError=pu,An.isFinite=function(n){return typeof n=="number"&&Wi(n)},An.isFunction=_u,
An.isInteger=vu,An.isLength=gu,An.isMap=sf,An.isMatch=function(n,t){return n===t||$t(n,t,xe(t))},An.isMatchWith=function(n,t,r){return r=typeof r=="function"?r:T,$t(n,t,xe(t),r)},An.isNaN=function(n){return bu(n)&&n!=+n},An.isNative=function(n){if(go(n))throw new Hu("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");return Ft(n)},An.isNil=function(n){return null==n},An.isNull=function(n){return null===n},An.isNumber=bu,An.isObject=du,An.isObjectLike=yu,An.isPlainObject=xu,An.isRegExp=hf,
An.isSafeInteger=function(n){return vu(n)&&-9007199254740991<=n&&9007199254740991>=n},An.isSet=pf,An.isString=ju,An.isSymbol=wu,An.isTypedArray=_f,An.isUndefined=function(n){return n===T},An.isWeakMap=function(n){return yu(n)&&"[object WeakMap]"==vo(n)},An.isWeakSet=function(n){return yu(n)&&"[object WeakSet]"==Ot(n)},An.join=function(n,t){return null==n?"":Ui.call(n,t)},An.kebabCase=Bf,An.last=Ve,An.lastIndexOf=function(n,t,r){var e=null==n?0:n.length;if(!e)return-1;var u=e;if(r!==T&&(u=ku(r),u=0>u?Li(e+u,0):Ci(u,e-1)),
t===t)n:{for(r=u+1;r--;)if(n[r]===t){n=r;break n}n=r}else n=_(n,d,u,true);return n},An.lowerCase=Lf,An.lowerFirst=Cf,An.lt=vf,An.lte=gf,An.max=function(n){return n&&n.length?xt(n,$u,It):T},An.maxBy=function(n,t){return n&&n.length?xt(n,ye(t,2),It):T},An.mean=function(n){return y(n,$u)},An.meanBy=function(n,t){return y(n,ye(t,2))},An.min=function(n){return n&&n.length?xt(n,$u,Kt):T},An.minBy=function(n,t){return n&&n.length?xt(n,ye(t,2),Kt):T},An.stubArray=qu,An.stubFalse=Vu,An.stubObject=function(){
return{}},An.stubString=function(){return""},An.stubTrue=function(){return true},An.multiply=rc,An.nth=function(n,t){return n&&n.length?Qt(n,ku(t)):T},An.noConflict=function(){return $n._===this&&($n._=si),this},An.noop=Pu,An.now=Go,An.pad=function(n,t,r){n=Iu(n);var e=(t=ku(t))?D(n):0;return!t||e>=t?n:(t=(t-e)/2,ne(Ii(t),r)+n+ne(Oi(t),r))},An.padEnd=function(n,t,r){n=Iu(n);var e=(t=ku(t))?D(n):0;return t&&e<t?n+ne(t-e,r):n},An.padStart=function(n,t,r){n=Iu(n);var e=(t=ku(t))?D(n):0;return t&&e<t?ne(t-e,r)+n:n;
},An.parseInt=function(n,t,r){return r||null==t?t=0:t&&(t=+t),Mi(Iu(n).replace(on,""),t||0)},An.random=function(n,t,r){if(r&&typeof r!="boolean"&&Oe(n,t,r)&&(t=r=T),r===T&&(typeof t=="boolean"?(r=t,t=T):typeof n=="boolean"&&(r=n,n=T)),n===T&&t===T?(n=0,t=1):(n=Au(n),t===T?(t=n,n=0):t=Au(t)),n>t){var e=n;n=t,t=e}return r||n%1||t%1?(r=Ti(),Ci(n+r*(t-n+Cn("1e-"+((r+"").length-1))),t)):ir(n,t)},An.reduce=function(n,t,r){var e=ff(n)?l:j,u=3>arguments.length;return e(n,ye(t,4),r,u,uo)},An.reduceRight=function(n,t,r){
var e=ff(n)?s:j,u=3>arguments.length;return e(n,ye(t,4),r,u,io)},An.repeat=function(n,t,r){return t=(r?Oe(n,t,r):t===T)?1:ku(t),or(Iu(n),t)},An.replace=function(){var n=arguments,t=Iu(n[0]);return 3>n.length?t:t.replace(n[1],n[2])},An.result=function(n,t,r){t=Sr(t,n);var e=-1,u=t.length;for(u||(u=1,n=T);++e<u;){var i=null==n?T:n[Me(t[e])];i===T&&(e=u,i=r),n=_u(i)?i.call(n):i}return n},An.round=ec,An.runInContext=x,An.sample=function(n){return(ff(n)?Qn:cr)(n)},An.size=function(n){if(null==n)return 0;
if(su(n))return ju(n)?D(n):n.length;var t=vo(n);return"[object Map]"==t||"[object Set]"==t?n.size:Vt(n).length},An.snakeCase=Df,An.some=function(n,t,r){var e=ff(n)?h:pr;return r&&Oe(n,t,r)&&(t=T),e(n,ye(t,3))},An.sortedIndex=function(n,t){return _r(n,t)},An.sortedIndexBy=function(n,t,r){return vr(n,t,ye(r,2))},An.sortedIndexOf=function(n,t){var r=null==n?0:n.length;if(r){var e=_r(n,t);if(e<r&&lu(n[e],t))return e}return-1},An.sortedLastIndex=function(n,t){return _r(n,t,true)},An.sortedLastIndexBy=function(n,t,r){
return vr(n,t,ye(r,2),true)},An.sortedLastIndexOf=function(n,t){if(null==n?0:n.length){var r=_r(n,t,true)-1;if(lu(n[r],t))return r}return-1},An.startCase=Mf,An.startsWith=function(n,t,r){return n=Iu(n),r=null==r?0:pt(ku(r),0,n.length),t=yr(t),n.slice(r,r+t.length)==t},An.subtract=uc,An.sum=function(n){return n&&n.length?m(n,$u):0},An.sumBy=function(n,t){return n&&n.length?m(n,ye(t,2)):0},An.template=function(n,t,r){var e=An.templateSettings;r&&Oe(n,t,r)&&(t=T),n=Iu(n),t=bf({},t,e,ce),r=bf({},t.imports,e.imports,ce);
var u,i,o=Wu(r),f=S(r,o),c=0;r=t.interpolate||jn;var a="__p+='";r=Xu((t.escape||jn).source+"|"+r.source+"|"+(r===Q?pn:jn).source+"|"+(t.evaluate||jn).source+"|$","g");var l="sourceURL"in t?"//# sourceURL="+t.sourceURL+"\n":"";if(n.replace(r,function(t,r,e,o,f,l){return e||(e=o),a+=n.slice(c,l).replace(wn,z),r&&(u=true,a+="'+__e("+r+")+'"),f&&(i=true,a+="';"+f+";\n__p+='"),e&&(a+="'+((__t=("+e+"))==null?'':__t)+'"),c=l+t.length,t}),a+="';",(t=t.variable)||(a="with(obj){"+a+"}"),a=(i?a.replace(P,""):a).replace(Z,"$1").replace(q,"$1;"),
a="function("+(t||"obj")+"){"+(t?"":"obj||(obj={});")+"var __t,__p=''"+(u?",__e=_.escape":"")+(i?",__j=Array.prototype.join;function print(){__p+=__j.call(arguments,'')}":";")+a+"return __p}",t=Ff(function(){return Ju(o,l+"return "+a).apply(T,f)}),t.source=a,pu(t))throw t;return t},An.times=function(n,t){if(n=ku(n),1>n||9007199254740991<n)return[];var r=4294967295,e=Ci(n,4294967295);for(t=ye(t),n-=4294967295,e=A(e,t);++r<n;)t(r);return e},An.toFinite=Au,An.toInteger=ku,An.toLength=Eu,An.toLower=function(n){
return Iu(n).toLowerCase()},An.toNumber=Su,An.toSafeInteger=function(n){return n?pt(ku(n),-9007199254740991,9007199254740991):0===n?n:0},An.toString=Iu,An.toUpper=function(n){return Iu(n).toUpperCase()},An.trim=function(n,t,r){return(n=Iu(n))&&(r||t===T)?n.replace(un,""):n&&(t=yr(t))?(n=M(n),r=M(t),t=I(n,r),r=R(n,r)+1,Or(n,t,r).join("")):n},An.trimEnd=function(n,t,r){return(n=Iu(n))&&(r||t===T)?n.replace(fn,""):n&&(t=yr(t))?(n=M(n),t=R(n,M(t))+1,Or(n,0,t).join("")):n},An.trimStart=function(n,t,r){
return(n=Iu(n))&&(r||t===T)?n.replace(on,""):n&&(t=yr(t))?(n=M(n),t=I(n,M(t)),Or(n,t).join("")):n},An.truncate=function(n,t){var r=30,e="...";if(du(t))var u="separator"in t?t.separator:u,r="length"in t?ku(t.length):r,e="omission"in t?yr(t.omission):e;n=Iu(n);var i=n.length;if(Rn.test(n))var o=M(n),i=o.length;if(r>=i)return n;if(i=r-D(e),1>i)return e;if(r=o?Or(o,0,i).join(""):n.slice(0,i),u===T)return r+e;if(o&&(i+=r.length-i),hf(u)){if(n.slice(i).search(u)){var f=r;for(u.global||(u=Xu(u.source,Iu(_n.exec(u))+"g")),
u.lastIndex=0;o=u.exec(f);)var c=o.index;r=r.slice(0,c===T?i:c)}}else n.indexOf(yr(u),i)!=i&&(u=r.lastIndexOf(u),-1<u&&(r=r.slice(0,u)));return r+e},An.unescape=function(n){return(n=Iu(n))&&G.test(n)?n.replace(V,tt):n},An.uniqueId=function(n){var t=++fi;return Iu(n)+t},An.upperCase=Tf,An.upperFirst=$f,An.each=nu,An.eachRight=tu,An.first=qe,Nu(An,function(){var n={};return mt(An,function(t,r){oi.call(An.prototype,r)||(n[r]=t)}),n}(),{chain:false}),An.VERSION="4.17.11",r("bind bindKey curry curryRight partial partialRight".split(" "),function(n){
An[n].placeholder=An}),r(["drop","take"],function(n,t){Ln.prototype[n]=function(r){r=r===T?1:Li(ku(r),0);var e=this.__filtered__&&!t?new Ln(this):this.clone();return e.__filtered__?e.__takeCount__=Ci(r,e.__takeCount__):e.__views__.push({size:Ci(r,4294967295),type:n+(0>e.__dir__?"Right":"")}),e},Ln.prototype[n+"Right"]=function(t){return this.reverse()[n](t).reverse()}}),r(["filter","map","takeWhile"],function(n,t){var r=t+1,e=1==r||3==r;Ln.prototype[n]=function(n){var t=this.clone();return t.__iteratees__.push({
iteratee:ye(n,3),type:r}),t.__filtered__=t.__filtered__||e,t}}),r(["head","last"],function(n,t){var r="take"+(t?"Right":"");Ln.prototype[n]=function(){return this[r](1).value()[0]}}),r(["initial","tail"],function(n,t){var r="drop"+(t?"":"Right");Ln.prototype[n]=function(){return this.__filtered__?new Ln(this):this[r](1)}}),Ln.prototype.compact=function(){return this.filter($u)},Ln.prototype.find=function(n){return this.filter(n).head()},Ln.prototype.findLast=function(n){return this.reverse().find(n);
},Ln.prototype.invokeMap=fr(function(n,t){return typeof n=="function"?new Ln(this):this.map(function(r){return Bt(r,n,t)})}),Ln.prototype.reject=function(n){return this.filter(au(ye(n)))},Ln.prototype.slice=function(n,t){n=ku(n);var r=this;return r.__filtered__&&(0<n||0>t)?new Ln(r):(0>n?r=r.takeRight(-n):n&&(r=r.drop(n)),t!==T&&(t=ku(t),r=0>t?r.dropRight(-t):r.take(t-n)),r)},Ln.prototype.takeRightWhile=function(n){return this.reverse().takeWhile(n).reverse()},Ln.prototype.toArray=function(){return this.take(4294967295);
},mt(Ln.prototype,function(n,t){var r=/^(?:filter|find|map|reject)|While$/.test(t),e=/^(?:head|last)$/.test(t),u=An[e?"take"+("last"==t?"Right":""):t],i=e||/^find/.test(t);u&&(An.prototype[t]=function(){var t=this.__wrapped__,o=e?[1]:arguments,f=t instanceof Ln,c=o[0],l=f||ff(t),s=function(n){return n=u.apply(An,a([n],o)),e&&h?n[0]:n};l&&r&&typeof c=="function"&&1!=c.length&&(f=l=false);var h=this.__chain__,p=!!this.__actions__.length,c=i&&!h,f=f&&!p;return!i&&l?(t=f?t:new Ln(this),t=n.apply(t,o),t.__actions__.push({
func:Qe,args:[s],thisArg:T}),new On(t,h)):c&&f?n.apply(this,o):(t=this.thru(s),c?e?t.value()[0]:t.value():t)})}),r("pop push shift sort splice unshift".split(" "),function(n){var t=ri[n],r=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",e=/^(?:pop|shift)$/.test(n);An.prototype[n]=function(){var n=arguments;if(e&&!this.__chain__){var u=this.value();return t.apply(ff(u)?u:[],n)}return this[r](function(r){return t.apply(ff(r)?r:[],n)})}}),mt(Ln.prototype,function(n,t){var r=An[t];if(r){var e=r.name+"";
(Gi[e]||(Gi[e]=[])).push({name:t,func:r})}}),Gi[Jr(T,2).name]=[{name:"wrapper",func:T}],Ln.prototype.clone=function(){var n=new Ln(this.__wrapped__);return n.__actions__=Lr(this.__actions__),n.__dir__=this.__dir__,n.__filtered__=this.__filtered__,n.__iteratees__=Lr(this.__iteratees__),n.__takeCount__=this.__takeCount__,n.__views__=Lr(this.__views__),n},Ln.prototype.reverse=function(){if(this.__filtered__){var n=new Ln(this);n.__dir__=-1,n.__filtered__=true}else n=this.clone(),n.__dir__*=-1;return n;
},Ln.prototype.value=function(){var n,t=this.__wrapped__.value(),r=this.__dir__,e=ff(t),u=0>r,i=e?t.length:0;n=0;for(var o=i,f=this.__views__,c=-1,a=f.length;++c<a;){var l=f[c],s=l.size;switch(l.type){case"drop":n+=s;break;case"dropRight":o-=s;break;case"take":o=Ci(o,n+s);break;case"takeRight":n=Li(n,o-s)}}if(n={start:n,end:o},o=n.start,f=n.end,n=f-o,o=u?f:o-1,f=this.__iteratees__,c=f.length,a=0,l=Ci(n,this.__takeCount__),!e||!u&&i==n&&l==n)return wr(t,this.__actions__);e=[];n:for(;n--&&a<l;){for(o+=r,
u=-1,i=t[o];++u<c;){var h=f[u],s=h.type,h=(0,h.iteratee)(i);if(2==s)i=h;else if(!h){if(1==s)continue n;break n}}e[a++]=i}return e},An.prototype.at=To,An.prototype.chain=function(){return Ye(this)},An.prototype.commit=function(){return new On(this.value(),this.__chain__)},An.prototype.next=function(){this.__values__===T&&(this.__values__=mu(this.value()));var n=this.__index__>=this.__values__.length;return{done:n,value:n?T:this.__values__[this.__index__++]}},An.prototype.plant=function(n){for(var t,r=this;r instanceof kn;){
var e=Fe(r);e.__index__=0,e.__values__=T,t?u.__wrapped__=e:t=e;var u=e,r=r.__wrapped__}return u.__wrapped__=n,t},An.prototype.reverse=function(){var n=this.__wrapped__;return n instanceof Ln?(this.__actions__.length&&(n=new Ln(this)),n=n.reverse(),n.__actions__.push({func:Qe,args:[Ge],thisArg:T}),new On(n,this.__chain__)):this.thru(Ge)},An.prototype.toJSON=An.prototype.valueOf=An.prototype.value=function(){return wr(this.__wrapped__,this.__actions__)},An.prototype.first=An.prototype.head,wi&&(An.prototype[wi]=Xe),
An}(); true?($n._=rt, !(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return rt}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))):Nn?((Nn.exports=rt)._=rt,Fn._=rt):$n._=rt}).call(this);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19), __webpack_require__(66)(module)))

/***/ }),
/* 289 */
/***/ (function(module, exports) {

angular.module('ui.bootstrap.contextMenu', [])

.service('CustomService', function () {
    "use strict";

    return {
        initialize: function (item) {
            console.log("got here", item);
        }
    }

})
.directive('contextMenu', ["$parse", "$q", "CustomService", "$sce", function ($parse, $q, custom, $sce) {

    var contextMenus = [];
    var $currentContextMenu = null;
    var defaultItemText = "New Item";

    var removeContextMenus = function (level) {
        /// <summary>Remove context menu.</summary>
        while (contextMenus.length && (!level || contextMenus.length > level)) {
            contextMenus.pop().remove();
        }
        if (contextMenus.length == 0 && $currentContextMenu) {
            $currentContextMenu.remove();
        }
    };


    var processTextItem = function ($scope, item, text, event, modelValue, $promises, nestedMenu, $) {
        "use strict";

        var $a = $('<a>');
        $a.css("padding-right", "8px");
        $a.attr({ tabindex: '-1', href: '#' });

        if (typeof item[0] === 'string') {
            text = item[0];
        }
        else if (typeof item[0] === "function") {
            text = item[0].call($scope, $scope, event, modelValue);
        } else if (typeof item.text !== "undefined") {
            text = item.text;
        }

        var $promise = $q.when(text);
        $promises.push($promise);
        $promise.then(function (text) {
            if (nestedMenu) {
                $a.css("cursor", "default");
                $a.append($('<strong style="font-family:monospace;font-weight:bold;float:right;">&gt;</strong>'));
            }
            $a.append(text);
        });

        return $a;

    };

    var processItem = function ($scope, event, modelValue, item, $ul, $li, $promises, $q, $, level) {
        /// <summary>Process individual item</summary>
        "use strict";
        // nestedMenu is either an Array or a Promise that will return that array.
        var nestedMenu = angular.isArray(item[1]) || (item[1] && angular.isFunction(item[1].then))
          ? item[1] : angular.isArray(item[2]) || (item[2] && angular.isFunction(item[2].then))
          ? item[2] : angular.isArray(item[3]) || (item[3] && angular.isFunction(item[3].then))
          ? item[3] : null;

        // if html property is not defined, fallback to text, otherwise use default text
        // if first item in the item array is a function then invoke .call()
        // if first item is a string, then text should be the string.

        var text = defaultItemText;
        if (typeof item[0] === 'function' || typeof item[0] === 'string' || typeof item.text !== "undefined") {
            text = processTextItem($scope, item, text, event, modelValue, $promises, nestedMenu, $);
        }
        else if (typeof item.html === 'function') {
            // leave styling open to dev
            text = item.html($scope);
        }
        else if (typeof item.html !== "undefined") {
            // leave styling open to dev
            text = item.html;
        }

        $li.append(text);




        // if item is object, and has enabled prop invoke the prop
        // els if fallback to item[2]

        var isEnabled = function () {
            if (typeof item.enabled !== "undefined") {
                return item.enabled.call($scope, $scope, event, modelValue, text);
            } else if (typeof item[2] === "function") {
                return item[2].call($scope, $scope, event, modelValue, text);
            } else {
                return true;
            }
        };

        registerEnabledEvents($scope, isEnabled(), item, $ul, $li, nestedMenu, modelValue, text, event, $, level);
    };

    var handlePromises = function ($ul, level, event, $promises) {
        /// <summary>
        /// calculate if drop down menu would go out of screen at left or bottom
        /// calculation need to be done after element has been added (and all texts are set; thus thepromises)
        /// to the DOM the get the actual height
        /// </summary>
        "use strict";
        $q.all($promises).then(function () {
            var topCoordinate = event.pageY;
            var menuHeight = angular.element($ul[0]).prop('offsetHeight');
            var winHeight = event.view.innerHeight;
            if (topCoordinate > menuHeight && winHeight - topCoordinate < menuHeight) {
                topCoordinate = event.pageY - menuHeight;
            } else if(winHeight <= menuHeight) {
                // If it really can't fit, reset the height of the menu to one that will fit
                angular.element($ul[0]).css({"height": winHeight - 5, "overflow-y": "scroll"});
                // ...then set the topCoordinate height to 0 so the menu starts from the top
                topCoordinate = 0;
            } else if(winHeight - topCoordinate < menuHeight) {
                var reduceThreshold = 5;
                if(topCoordinate < reduceThreshold) {
                    reduceThreshold = topCoordinate;
                }
                topCoordinate = winHeight - menuHeight - reduceThreshold;
            }

            var leftCoordinate = event.pageX;
            var menuWidth = angular.element($ul[0]).prop('offsetWidth');
            var winWidth = event.view.innerWidth;
            var rightPadding = 5;
            if (leftCoordinate > menuWidth && winWidth - leftCoordinate - rightPadding < menuWidth) {
                leftCoordinate = winWidth - menuWidth - rightPadding;
            } else if(winWidth - leftCoordinate < menuWidth) {
                var reduceThreshold = 5;
                if(leftCoordinate < reduceThreshold + rightPadding) {
                    reduceThreshold = leftCoordinate + rightPadding;
                }
                leftCoordinate = winWidth - menuWidth - reduceThreshold - rightPadding;
            }

            $ul.css({
                display: 'block',
                position: 'absolute',
                left: leftCoordinate + 'px',
                top: topCoordinate + 'px'
            });
        });

    };

    var registerEnabledEvents = function ($scope, enabled, item, $ul, $li, nestedMenu, modelValue, text, event, $, level) {
        /// <summary>If item is enabled, register various mouse events.</summary>
        if (enabled) {
            var openNestedMenu = function ($event) {
                removeContextMenus(level + 1);
                /*
                 * The object here needs to be constructed and filled with data
                 * on an "as needed" basis. Copying the data from event directly
                 * or cloning the event results in unpredictable behavior.
                 */
                var ev = {
                    pageX: event.pageX + $ul[0].offsetWidth - 1,
                    pageY: $ul[0].offsetTop + $li[0].offsetTop - 3,
                    view: event.view || window
                };

                /*
                 * At this point, nestedMenu can only either be an Array or a promise.
                 * Regardless, passing them to when makes the implementation singular.
                 */
                $q.when(nestedMenu).then(function(promisedNestedMenu) {
                    renderContextMenu($scope, ev, promisedNestedMenu, modelValue, level + 1);
                });
            };

            $li.on('click', function ($event) {
                $event.preventDefault();
                $scope.$apply(function () {
                    if (nestedMenu) {
                        openNestedMenu($event);
                    } else {
                        $(event.currentTarget).removeClass('context');
                        removeContextMenus();

                        if (angular.isFunction(item[1])) {
                            item[1].call($scope, $scope, event, modelValue, text, $li)
                        } else {
                            item.click.call($scope, $scope, event, modelValue, text, $li);
                        }
                    }
                });
            });

            $li.on('mouseover', function ($event) {
                $scope.$apply(function () {
                    if (nestedMenu) {
                        openNestedMenu($event);
                    }
                });
            });
        } else {
            $li.on('click', function ($event) {
                $event.preventDefault();
            });
            $li.addClass('disabled');
        }

    };


    var renderContextMenu = function ($scope, event, options, modelValue, level, customClass) {
        /// <summary>Render context menu recursively.</summary>
        if (!level) { level = 0; }
        if (!$) { var $ = angular.element; }
        $(event.currentTarget).addClass('context');
        var $contextMenu = $('<div>');
        if ($currentContextMenu) {
            $contextMenu = $currentContextMenu;
        } else {
            $currentContextMenu = $contextMenu;
            $contextMenu.addClass('angular-bootstrap-contextmenu dropdown clearfix');
        }
        if (customClass) {
            $contextMenu.addClass(customClass);
        }
        var $ul = $('<ul>');
        $ul.addClass('dropdown-menu');
        $ul.attr({ 'role': 'menu' });
        $ul.css({
            display: 'block',
            position: 'absolute',
            left: event.pageX + 'px',
            top: event.pageY + 'px',
            "z-index": 10000
        });

        var $promises = [];

        angular.forEach(options, function (item) {

            var $li = $('<li>');
            if (item === null) {
                $li.addClass('divider');
            } else if (typeof item[0] === "object") {
                custom.initialize($li, item);
            } else {
                processItem($scope, event, modelValue, item, $ul, $li, $promises, $q, $, level);
            }
            $ul.append($li);
        });
        $contextMenu.append($ul);
        var height = Math.max(
            document.body.scrollHeight, document.documentElement.scrollHeight,
            document.body.offsetHeight, document.documentElement.offsetHeight,
            document.body.clientHeight, document.documentElement.clientHeight
        );
        $contextMenu.css({
            width: '100%',
            height: height + 'px',
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 9999,
            "max-height" : window.innerHeight - 3,
        });
        $(document).find('body').append($contextMenu);

        handlePromises($ul, level, event, $promises);

        function removeAllContextMenus(e) {
            if ($(e.target).hasClass('angular-bootstrap-contextmenu')) {
                $(event.currentTarget).removeClass('context');
                removeContextMenus();
            }
        }

        $(document.body).on('mousedown', removeAllContextMenus);

        $contextMenu.on('contextmenu', function (event) {
            $(event.currentTarget).removeClass('context');
            event.preventDefault();
            removeContextMenus(level);
        });

        $scope.$on("$destroy", function () {
            removeContextMenus();
            $(document.body).off('mousedown', removeAllContextMenus);
        });

        contextMenus.push($ul);
    };

    function isTouchDevice() {
      return 'ontouchstart' in window        // works on most browsers
          || navigator.maxTouchPoints;       // works on IE10/11 and Surface
    };

    return function ($scope, element, attrs) {
        var openMenuEvent = "contextmenu";
        if(attrs.contextMenuOn && typeof(attrs.contextMenuOn) === "string"){
            openMenuEvent = attrs.contextMenuOn;
        }
        element.on(openMenuEvent, function (event) {
            if(!attrs.allowEventPropagation) {
              event.stopPropagation();
              event.preventDefault();
            }
            
            // Don't show context menu if on touch device and element is draggable
            if(isTouchDevice() && element.attr('draggable') === 'true') {
              return false;
            }

            $scope.$apply(function () {
                var options = $scope.$eval(attrs.contextMenu);
                var customClass = attrs.contextMenuClass;
                var modelValue = $scope.$eval(attrs.model);
                if (options instanceof Array) {
                    if (options.length === 0) { return; }
                    renderContextMenu($scope, event, options, modelValue, undefined, customClass);
                } else {
                    throw '"' + attrs.contextMenu + '" not an array';
                }
            });
        });
    };
}]);


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(10);
__webpack_require__(98);
__webpack_require__(1);
__webpack_require__(291);

"use strict";

angular.module('app.appController', ['app.appMetaService', 'app.currentPlatform.currentPlatformDetailService', 'app.currentUser', 'app.sessionTimeout.sessionTimeoutService']).controller('app.appController', ['$scope', 'appMetaService', 'app.currentPlatform.currentPlatformDetailService', 'currentUser', '$state', '$rootScope', '$document', 'sessionTimeoutService', function ($scope, appMeta, currentPlatformDetail, currentUser, $state, $rootScope, $document, sessionTimeout) {
    $scope.appMeta = appMeta;
    $scope.currentPlatformDetail = currentPlatformDetail;
    $scope.state = $state;
    $scope.pageTitle = $scope.appMeta.longName;

    var init = function init() {
        currentPlatformDetail.retrieve();
    };

    // Update page title when state changes
    $scope.$watch(function () {
        return $scope.state.current.title;
    }, function () {
        if ($scope.state.current.title) {
            $scope.pageTitle = $scope.state.current.title;
        } else {
            $scope.pageTitle = $scope.appMeta.longName;
        }
    });

    $scope.$watch(function () {
        return currentUser.is_logged_in();
    }, function () {
        var d = new Date();
        var n = d.getTime(); //n in ms

        $rootScope.idleEndTime = n + 360 * 60 * 1000; //set end time to 360 min or 6 hrs from now
        $document.find('body').on('mousemove keydown DOMMouseScroll mousewheel mousedown touchstart', sessionTimeout.checkAndResetIdle);
    });

    init();
}]);

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1);

"use strict";

angular.module('app.sessionTimeout.sessionTimeoutService', ['app.currentUser']).factory('sessionTimeoutService', ['$rootScope', '$document', 'currentUser', '$state', function ($rootScope, $document, currentUser, $state) {
    var service = void 0;

    service = {
        checkAndResetIdle: function checkAndResetIdle() //user did something
        {
            var d = new Date();
            var n = d.getTime(); //n in ms

            if (currentUser.is_logged_in() && n <= $rootScope.idleEndTime) {
                $rootScope.idleEndTime = n + 360 * 60 * 1000; //reset end time
            } else if (currentUser.is_logged_in() && n > $rootScope.idleEndTime) {
                $document.find('body').off('mousemove keydown DOMMouseScroll mousewheel mousedown touchstart'); //un-monitor events

                currentUser.logout();
                $state.go('app.sessionTimeout');
                $rootScope.$broadcast('collapsableMenuTriggerCollapse');
            }
        }
    };
    return service;
}]);

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.currentUser.authentication.constant', []).constant('AUTHENTICATION', {
  NON_AUTH_STATES: ['welcome', 'app\.information', 'app\.login', 'app\.mobileLogin', 'app\.registration', 'app\.passwordReset', 'app\.locked', 'app\.gotw', 'app\.brand', 'app\.changeEmail.verify', 'app\.sessionTimeout', 'app\.pricing', 'app\.promo'],
  DEFAULT_AUTH_STATE: 'welcome',
  NON_AUTH_TO_LOGIN: ['app\.purchase'],
  REQUIRE_SUBSCRIPTION: ['app\.myHockeyTv'],
  NO_SUBSCRIPTION_STATE: 'app.pricing',

  NON_AHL_STATES: ['app\.myHockeyTv\.collegeCommitments', 'app\.myHockeyTv\.playersToWatch']
});

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.convertToNumberDirective', []).directive('convertToNumber', [function () {
    return {
        require: 'ngModel',
        link: function link(scope, element, attrs, ngModel) {
            ngModel.$parsers.push(function (val) {
                return val !== null ? parseInt(val, 10) : null;
            });
            ngModel.$formatters.push(function (val) {
                return val !== null ? '' + val : null;
            });
        }
    };
}]);

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.errSrcDirective', []).directive('errSrc', function () {
  return {
    link: function link(scope, element, attrs) {
      element.bind('error', function () {
        if (attrs.src != attrs.errSrc) {
          attrs.$set('src', attrs.errSrc);
        }
      });
    }
  };
});

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(296);
__webpack_require__(297);

"use strict";

angular.module('app.welcome', ['app.welcome.welcomeController', 'app.shared.featuredImage.featuredImageDirective']).config(['$stateProvider', 'PRODUCT', function ($stateProvider, product) {

    var welTemplate = 'components/welcome/welcomeView.html';
    if (product.Code != 'htv') {
        welTemplate = 'assets/templates/' + product.Code + '/welcome/welcomeView.html';
    }

    $stateProvider.state('welcome', {
        url: '/',
        templateUrl: welTemplate,
        controller: 'app.welcome.welcomeController'
    });
}]);

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(10);
__webpack_require__(60);
__webpack_require__(73);
__webpack_require__(1);
__webpack_require__(25);

"use strict";

angular.module('app.welcome.welcomeController', ['app.appMetaService', 'app.pricing.plans.plansService', 'app.shared.leaguesService', 'app.mainFrame.collapsableMenu.collapsableMenuService']).controller('app.welcome.welcomeController', ['$scope', 'appMetaService', 'app.pricing.plans.plansService', 'app.shared.leaguesService', 'currentUser', '$state', '$stateParams', 'app.mainFrame.collapsableMenu.collapsableMenuService', 'hostnameMatchService', function ($scope, appMeta, plans, leaguesService, currentUser, $state, $stateParams, collapsableMenu, hostnameMatchService) {
  $scope.appMeta = appMeta;
  $scope.activeSliderIndex = 0;
  $scope.sliderSpeed = 3000;
  $scope.plan = null;
  $scope.plans = null;
  $scope.leagues = null;
  $scope.currentLeagueIndex = 0;
  $scope.currentLeague = null;
  $scope.loadingTeams = false;
  $scope.error = null;
  $scope.login_name = $stateParams.login_name;
  $scope.password = null;
  $scope.show2021Freeview = false;

  var init = function init() {
    /*let promise = plans.retrieve({plans: ['30dp', '365dp']});
    if (promise) {
      promise.then(
        function () {
          if (Array.isArray(plans.list) && plans.list.length) {
            $scope.plans = plans.list;
            if (Array.isArray(plans.list)) {
              if (typeof plans.list[0] !== 'undefined') {
                $scope.plan = plans.list[0];
              }
              plans.list.forEach((plan) => {
                if (plan.level === Math.max($scope.plan.level, plan.level)) {
                  $scope.plan = plan;
                }
              });
            }
          }
        }
      );
    }*/

    leaguesService.getList(window.location.platform(undefined, hostnameMatchService.hostname()), 'teams', 'logos').then(function (response) {
      var shuffle = function shuffle(a) {
        for (var i = a.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var _ref = [a[j], a[i]];
          a[i] = _ref[0];
          a[j] = _ref[1];
        }
        return a;
      };
      $scope.leagues = response.data; //shuffle(response.data);
    });

    if ($stateParams.autoLogin === true) {
      if ($stateParams.login_name && $stateParams.password) {
        $scope.password = $stateParams.password;
        $scope.login();
      }
    }
  };

  $scope.login = function () {
    currentUser.loginClicked = true;

    var callback = function callback() {
      collapsableMenu.buildItems();
      $state.go('app.home');
    };

    currentUser.login($scope.login_name, $scope.password).then(callback).catch(function (result) {
      $scope.error = {
        message: result.error,
        type: result.errorType
      };
    });
  };

  /*$scope.resendRegistrationEmail = () => {
    if ($scope.login_name && $scope.password) {
      currentUser.sendRegistrationEmail($scope.login_name, $scope.password)
        .then(response => {
          let data = response.data;
          if (data) {
            if (data.message) {
              alert(data.message);
            }
          }
        })
        .catch(response => {
          let data = response.data;
          if (data) {
            if (data.error) {
              alert(data.error);
            }
          }
        });
    } else {
      alert('Please provide your email address and password');
    }
  };
   let fetchTeams = function (league_index) {
    if (Array.isArray($scope.leagues) && $scope.leagues[league_index]) {
      if (!$scope.leagues[league_index].teams) {
        $scope.loadingTeams = true;
        return leaguesService.getLeague($scope.leagues[league_index].ileagueid).then(
          function (response) {
            $scope.leagues[league_index] = response.data;
            $scope.loadingTeams = false;
          }
        );
      }
    }
    return false;
  };
   let setCurrentLeague = function () {
    if ($scope.leagues) {
      $scope.currentLeague = $scope.leagues[$scope.currentLeagueIndex];
      let promise = fetchTeams($scope.currentLeagueIndex);
      if (promise) {
        promise.then(
          function () {
            $scope.currentLeague = $scope.leagues[$scope.currentLeagueIndex];
          }
        )
      }
    }
  };
   $scope.nextLeague = function () {
    if (Array.isArray($scope.leagues)) {
      let next_league_index = $scope.currentLeagueIndex + 1;
      if (next_league_index >= $scope.leagues.length) {
        next_league_index = 0;
      }
      $scope.currentLeagueIndex = next_league_index;
      setCurrentLeague();
    }
  };
   $scope.previousLeague = function () {
    if (Array.isArray($scope.leagues)) {
      let previous_league_index = $scope.currentLeagueIndex - 1;
      if (previous_league_index < 0) {
        previous_league_index = $scope.leagues.length - 1;
      }
      $scope.currentLeagueIndex = previous_league_index;
      setCurrentLeague();
    }
  };
   $scope.random = function () {
    return 0.5 - Math.random();
  };*/

  //AHL Freeview
  $scope.showFreeview = currentUser.showFreeview();

  //AHl All-Star Classic
  $scope.showAllStars = currentUser.showAllStars();

  //AHL Promotion
  $scope.showPromotion = currentUser.showPromotion();

  //AHL Black Friday
  $scope.showBlackFriday = currentUser.showBlackFriday();

  //AHL Summer
  $scope.showSummer = currentUser.showSummer();

  //AHL MidSeason
  $scope.showMidSeason = currentUser.showMidSeason();

  //AHL Final Price Drop
  $scope.showFinalPriceDrop = currentUser.showFinalPriceDrop();

  //AHL Playoffs 2023
  $scope.showPlayoffs = currentUser.showPlayoffs();

  init();
}]);

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(298);

"use strict";

angular.module('app.shared.featuredImage.featuredImageDirective', ['app.shared.featuredImage.featuredImageController']).directive('featuredImage', [function () {
    return {
        restrict: 'E',
        templateUrl: 'components/shared/featuredImage/featuredImageView.html',
        controller: 'app.shared.featuredImage.featuredImageController',
        scope: {}
    };
}]);

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.shared.featuredImage.featuredImageController', []).controller('app.shared.featuredImage.featuredImageController', ['$scope', '$http', 'PRODUCT', function ($scope, $http, product) {
  "use strict";

  $scope.featuredImage = null;

  var init = function init() {
    getRandomFeaturedImage();
  };

  var getRandomFeaturedImage = function getRandomFeaturedImage() {
    if (!product.StorageBucket) {
      console.error("Missing product StorageBucket config");
      setDefaultFeaturedImage();
      return;
    }

    return $http.get(product.StorageBucket + '/homepage/featured/featured.json').then(function (response) {
      var data = response.data;

      if (data && Array.isArray(data.images)) {
        var numImages = data.images.length;
        var randNum = Math.floor(Math.random() * numImages);

        $scope.featuredImage = data.images[randNum];
      } else {
        setDefaultFeaturedImage();
      }
    },
    /**
     * @param {HttpResponse} response
     */
    function (data) {
      // error.. set the default
      setDefaultFeaturedImage();
    });
  };

  var setDefaultFeaturedImage = function setDefaultFeaturedImage() {
    $scope.featuredImage = '/assets/images/ahl/featured/head-image-1.jpg';
  };

  init();
}]);

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(300);
__webpack_require__(301);
__webpack_require__(304);
__webpack_require__(307);
__webpack_require__(308);

__webpack_require__(311);
__webpack_require__(313);
__webpack_require__(314);
__webpack_require__(315);
__webpack_require__(320);
__webpack_require__(325);
__webpack_require__(339);
__webpack_require__(348);
__webpack_require__(354);
__webpack_require__(361);
__webpack_require__(362);
__webpack_require__(375);
__webpack_require__(26);
__webpack_require__(402);
__webpack_require__(406);
__webpack_require__(407);
__webpack_require__(412);
__webpack_require__(416);
__webpack_require__(422);
__webpack_require__(426);
__webpack_require__(427);
__webpack_require__(466);
__webpack_require__(469);
__webpack_require__(470);
__webpack_require__(474);
__webpack_require__(475);
__webpack_require__(478);
__webpack_require__(479);
__webpack_require__(481);

"use strict";

angular.module('app.mainFrame', ['app.mainFrame.mainFrameController', 'app.mainFrame.topFrameController', 'app.mainFrame.sidebarContentController', 'app.mainFrame.sidebarFooterController', 'app.mainFrame.collapsableMenu', 'app.login', 'app.mobileLogin', 'app.locked', 'app.home', 'app.coverage', 'app.schedule', 'app.pricing', 'app.information', 'app.registration', 'app.purchase', 'app.myProfile', 'app.myHockeyTv', 'app.player', 'app.userProfile', 'app.favorites', 'app.gamesOfTheWeek', 'app.passwordReset', 'app.purchase.billingInfo', 'app.accountSettings', 'app.accessDenied', 'app.admin', 'app.rokuConnect', 'app.brand', 'app.changeEmail', 'app.sessionTimeout', 'app.broadcastStatus', 'app.howToWatch', 'app.promo', 'app.redeemPromo']).config(['$stateProvider', 'PRODUCT', function ($stateProvider, product) {

  var sidebarFooterTemplate = 'components/mainFrame/sidebar/sidebarFooterView.html';
  if (product.Code != 'htv') {
    sidebarFooterTemplate = 'assets/templates/' + product.Code + '/mainFrame/sidebar/sidebarFooterView.html';
  }

  $stateProvider.state('app', {
    abstract: true,
    views: {
      '': {
        templateUrl: 'components/mainFrame/mainFrameView.html',
        controller: 'app.mainFrame.mainFrameController'
      },
      'topFrame@app': {
        templateUrl: 'components/mainFrame/topFrame/topFrameView.html',
        controller: 'app.mainFrame.topFrameController'
      },
      'sidebarContent@app': {
        templateUrl: 'components/mainFrame/sidebar/sidebarContentView.html',
        controller: 'app.mainFrame.sidebarContentController'
      },
      'sidebarFooter@app': {
        templateUrl: sidebarFooterTemplate,
        controller: 'app.mainFrame.sidebarFooterController'
      }
    }
  });
}]);

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(25);
__webpack_require__(99);

"use strict";

angular.module('app.mainFrame.mainFrameController', ['app.mainFrame.collapsableMenu.collapsableMenuService', 'app.mainFrame.searchMenu.searchMenuService']).controller('app.mainFrame.mainFrameController', ['$scope', '$state', 'app.mainFrame.collapsableMenu.collapsableMenuService', 'app.mainFrame.searchMenu.searchMenuService',
/**
 * @param $scope
 * @param {ApplicationStateService} $state
 * @param collapsableMenu
 * @param searchMenu
 */
function ($scope, $state, collapsableMenu, searchMenu) {
    $scope.state = $state;

    $scope.hideContent = function () {
        return collapsableMenu.menuExpanded || searchMenu.isExpanded;
    };

    $scope.stateTitle = function () {
        if ($state.current.isChildState) {
            return $state.$current.parent.title;
        } else {
            return $state.current.title;
        }
    };
}]);

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(10);
__webpack_require__(1);
__webpack_require__(25);
__webpack_require__(302);
__webpack_require__(18);

"use strict";

angular.module('app.mainFrame.topFrameController', ['app.appMetaService', 'app.currentUser', 'app.mainFrame.collapsableMenu.collapsableMenuService', 'app.mainFrame.searchMenu.searchMenuDirective', 'app.hostnameMatchService']).controller('app.mainFrame.topFrameController', ['$scope', 'appMetaService', 'app.mainFrame.collapsableMenu.collapsableMenuService', 'currentUser', 'hostnameMatchService', '$state', function ($scope, appMeta, collapsableMenu, currentUser, hostnameMatchService, $state) {
    $scope.appMeta = appMeta;
    $scope.collapsableMenu = collapsableMenu;
    $scope.currentUser = currentUser;
    $scope.logoLink = hostnameMatchService.base_url();
    $scope.state = $state;
}]);

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(303);

"use strict";

angular.module('app.mainFrame.searchMenu.searchMenuDirective', ['app.mainFrame.searchMenu.searchMenuController']).directive('searchMenu', [function () {
    return {
        restrict: 'E',
        templateUrl: 'components/mainFrame/searchMenu/searchMenuView.html',
        controller: 'app.mainFrame.searchMenu.searchMenuController',
        link: function link(scope, elm) {
            elm.addClass('search-menu');
        }
    };
}]);

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(99);
__webpack_require__(74);

angular.module('app.mainFrame.searchMenu.searchMenuController', ['app.mainFrame.searchMenu.searchMenuService', 'app.schedule.scheduleService']).controller('app.mainFrame.searchMenu.searchMenuController', ['$scope', 'app.mainFrame.searchMenu.searchMenuService', function ($scope, searchMenu) {
  "use strict";

  $scope.searchMenu = searchMenu;

  $scope.onSearchSelected = function () {
    searchMenu.isExpanded = false;
  };
}]);

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(305);

"use strict";

angular.module('app.mainFrame.sidebarContentController', ['app.mainFrame.sidebarMenu.sidebarMenuDirective']).controller('app.mainFrame.sidebarContentController', ['$scope', function () {}]);

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(306);

"use strict";

angular.module('app.mainFrame.sidebarMenu.sidebarMenuDirective', ['app.mainFrame.sidebarMenu.sidebarMenuController']).directive('sidebarMenu', [function () {
    return {
        restrict: 'EA',
        templateUrl: 'components/mainFrame/sidebarMenu/sidebarMenuView.html',
        controller: 'app.mainFrame.sidebarMenu.sidebarMenuController',
        link: function link(scope, elm, attr) {
            if (!attr.class) {
                elm.addClass('sidebar-menu');
            }
        }
    };
}]);

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(100);
__webpack_require__(1);

"use strict";

angular.module('app.mainFrame.sidebarMenu.sidebarMenuController', ['app.mainFrame.sidebarMenu.sidebarMenuService', 'app.currentUser']).controller('app.mainFrame.sidebarMenu.sidebarMenuController', ['$scope', 'app.mainFrame.sidebarMenu.sidebarMenuService', '$state', '$stateParams', 'currentUser', function ($scope, sidebarMenu, $state, $stateParams, currentUser) {
    $scope.sidebarMenu = sidebarMenu;
    $scope.currentUser = currentUser;

    $scope.$watch(function () {
        return currentUser.data.access;
    }, function () {
        sidebarMenu.reinit();
    });
}]);

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(10);

"use strict";

angular.module('app.mainFrame.sidebarFooterController', ['app.appMetaService']).controller('app.mainFrame.sidebarFooterController', ['$scope', 'appMetaService', function ($scope, appMeta) {
    $scope.appMeta = appMeta;
}]);

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(309);

"use strict";

angular.module('app.mainFrame.collapsableMenu', ['app.mainFrame.collapsableMenu.collapsableMenuDirective']);

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(310);
__webpack_require__(25);

"use strict";

angular.module('app.mainFrame.collapsableMenu.collapsableMenuDirective', ['app.mainFrame.collapsableMenuController', 'app.mainFrame.collapsableMenu.collapsableMenuService']).directive('collapsableMenu', ['$document', 'app.mainFrame.collapsableMenu.collapsableMenuService', function ($document, collapsableMenu) {
    return {
        restrict: 'AE',
        templateUrl: 'components/mainFrame/collapsableMenu/collapsableMenuView.html',
        controller: 'app.mainFrame.collapsableMenuController',
        link: function link(scope, elm) {
            scope.$watch(function () {
                return collapsableMenu.menuExpanded;
            }, function () {
                if (collapsableMenu.menuExpanded) {
                    elm.addClass('open');
                } else {
                    elm.removeClass('open');
                }
            });
        }
    };
}]);

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1);
__webpack_require__(25);
__webpack_require__(100);

"use strict";

angular.module('app.mainFrame.collapsableMenuController', ['app.mainFrame.collapsableMenu.collapsableMenuService', 'app.mainFrame.sidebarMenu.sidebarMenuService']).controller('app.mainFrame.collapsableMenuController', ['$scope', 'app.mainFrame.collapsableMenu.collapsableMenuService', 'app.mainFrame.sidebarMenu.sidebarMenuService', 'currentUser', function ($scope, collapsableMenu, sidebarMenu, currentUser) {
  var sidebarMenuItems = { 'mainMenu': sidebarMenu.items };

  $scope.collapsableMenu = collapsableMenu;
  $scope.collapsed = [];
  $scope.appendMenuToElement = angular.element(document.querySelector('#collapsable-menu'));
  $scope.currentUser = currentUser;

  $scope.isItemActive = function (group, item) {
    if (group === 'mainMenu') {
      return sidebarMenu.isItemActive(item);
    }
    return false;
  };

  $scope.selectItem = function (item, item_index) {
    if (item.action() === false) {
      if (item_index && item.children) {
        $scope.collapsed[item_index] = !$scope.collapsed[item_index];
      }
    } else {
      collapsableMenu.menuExpanded = false;
    }
  };

  /*$scope.$watch(function() {
   return currentUser.data.has_all_acc_info;
  }, function() {
    collapsableMenu.buildItems(sidebarMenuItems);
  });*/

  collapsableMenu.buildItems(sidebarMenuItems);
}]);

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(101);
__webpack_require__(102);

"use strict";

angular.module('app.login', ['app.login.loginController', 'app.cdnUrl']).config(['$stateProvider', 'PRODUCT', function ($stateProvider, product) {

  var logTemplate = 'components/login/loginView.html';
  if (product.Code != 'htv') {
    logTemplate = 'assets/templates/' + product.Code + '/login/loginView.html';
  }

  $stateProvider.state('app.login', {
    url: '/login',
    templateUrl: logTemplate,
    controller: 'app.login.loginController',
    params: {
      error: null,
      errorType: null,
      redirect: null,
      redirectParams: null,
      autoLogin: false,
      login_name: null,
      password: null
    },
    title: 'Sign In',
    noSidebar: true,
    noTitleBar: true
  });
}]);

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.cdnUrl.cdnUrlFilter', []).filter('cdn_url', ['cdnUrl', function (cdnUrl) {
    return function (input, index) {
        if (input && !input.match(/^http/)) {
            input = input.replace(/^\//, '');

            index = parseInt(index);
            if (isNaN(index)) {
                index = 0;
            }

            return cdnUrl[index] + '/' + input;
        } else {
            return input;
        }
    };
}]);

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(101);
__webpack_require__(102);

"use strict";

angular.module('app.mobileLogin', ['app.login.loginController', 'app.cdnUrl']).config(['$stateProvider', 'PRODUCT', function ($stateProvider, product) {

  var logTemplate = 'components/mobileLogin/mobileLoginView.html';
  if (product.Code != 'htv') {
    logTemplate = 'assets/templates/' + product.Code + '/mobileLogin/mobileLoginView.html';
  }

  $stateProvider.state('app.mobileLogin', {
    url: '/mobile-login',
    templateUrl: logTemplate,
    controller: 'app.login.loginController',
    params: {
      error: null,
      errorType: null,
      redirect: null,
      redirectParams: null,
      autoLogin: false,
      login_name: null,
      password: null
    },
    title: 'Mobile Sign In',
    noSidebar: true,
    noTitleBar: true
  });
}]);

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.locked', []).config(['$stateProvider', function ($stateProvider) {
  return $stateProvider.state('app.locked', {
    templateUrl: 'components/locked/lockedView.html',

    controller: ['$stateParams', '$scope', '$window', function ($stateParams, $scope, $window) {
      $scope.stateParams = $stateParams;
      $scope.openUrl = function (url) {
        $window.open(url);
      };
    }],

    title: 'Locked Out',
    noSidebar: true,
    noTopControls: true,
    params: { obj: null }
  });
}]);

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(316);
__webpack_require__(318);

"use strict";

angular.module('app.home', ['app.home.homeController', 'app.home.subscribeNow']).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.home', {
        url: '/home',
        template: '<div ui-view=""></div>',
        controller: 'app.home.homeController',
        title: 'Home'
    });
}]);

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(317);

'use strict';

angular.module('app.home.homeController', ['app.home.homeResolverService']).controller('app.home.homeController', ['$scope', 'app.home.homeResolverService', function ($scope, homeResolverService) {
    homeResolverService.resolve();
}]);

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.home.homeResolverService', []).factory('app.home.homeResolverService', ['$state', 'currentUser',
/**
 * @param $state
 * @param {CurrentUserService} currentUser
 * @returns {{resolve: app.home.homeResolverService.resolve}}
 */
function ($state, currentUser) {
  'use strict';

  function getStrategy() {
    if (isAdmin(currentUser.data)) {
      return strategy.default;
    }
    if (isPassHolder(currentUser.data)) {
      return strategy.default;
    }
    if (hasActiveSubscription(currentUser.data)) {
      return strategy.currentSubscriber;
    }
    if (currentUser.hasAccessPass()) {
      // We'll treat users witha access passes as though they are subscribers
      return strategy.currentSubscriber;
    }
    if (neverHadASubscription(currentUser.data)) {
      return strategy.newSubscriber;
    }
    if (formerSubscriber(currentUser.data)) {
      return strategy.formerSubscriber;
    }

    return strategy.default;
  }

  function isAdmin(user) {
    return user.is_admin;
  }

  function isPassHolder(user) {
    return user.access && user.access.length;
  }

  function hasActiveSubscription(user) {
    var hasActiveSubscription = false;
    if (user.subscriptions && user.subscriptions.recurly) {
      _.forEach(user.subscriptions.recurly, function (sub) {
        if (!sub.paused && !sub.is_future) {
          hasActiveSubscription = true;
        }
      });
    }
    return hasActiveSubscription;
  }

  function neverHadASubscription(user) {
    return !user.subscriptions || !Array.isArray(user.subscriptions) || user.subscriptions.length == 0;
  }

  function formerSubscriber(user) {
    return user.last_expired_subscription;
  }

  var strategy = {
    newSubscriber: function newSubscriber() {
      $state.go('app.home.subscribeNow');
    },
    formerSubscriber: function formerSubscriber() {
      $state.go('app.pricing');
    },
    failedPayment: function failedPayment() {
      $state.go('app.pricing');
    },
    currentSubscriber: function currentSubscriber() {
      $state.go('app.schedule');
    },
    adminUser: function adminUser() {
      $state.go('app.schedule');
    },
    default: function _default() {
      $state.go('app.schedule');
    }
  };

  return {
    resolve: function resolve() {
      var homeStrategy = getStrategy();
      homeStrategy();
    }
  };
}]);

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(319);
"use strict";

angular.module('app.home.subscribeNow', ['app.home.subscribeNow.subscribeNowController']).config(['$stateProvider', 'PRODUCT', function ($stateProvider, product) {

    var subTemplate = 'components/home/subscribeNow/subscribeNowView.html';
    if (product.Code != 'htv') {
        subTemplate = 'assets/templates/' + product.Code + '/subscribeNow/subscribeNowView.html';
    }

    $stateProvider.state('app.home.subscribeNow', {
        url: '/subscribe_now',
        templateUrl: subTemplate,
        controller: 'app.home.subscribeNow.subscribeNowController',
        title: 'Welcome'
    });
}]);

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.home.subscribeNow.subscribeNowController', []).controller('app.home.subscribeNow.subscribeNowController', ['$scope', function ($scope) {}]);

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(321);
__webpack_require__(323);
__webpack_require__(324);

"use strict";

angular.module('app.coverage', ['app.coverage.channels.channelsController', 'app.coverage.events.eventsController', 'app.dateDirective']).config(['$stateProvider', function ($stateProvider) {
    return $stateProvider.state('app.coverage', {
        url: '/coverage',
        templateUrl: 'components/coverage/coverageView.html',
        controller: ['$state', function ($state) {

            if ($state.is('app.coverage')) {
                return $state.go('app.coverage.channels');
            }
        }],
        title: 'Coverage'
    }).state('app.coverage.channels', {
        url: '/channels',
        templateUrl: 'components/coverage/channels/channelsView.html',
        controller: 'app.coverage.channels.channelsController',
        title: 'Channels'
    }).state('app.coverage.events', {
        url: '/events',
        templateUrl: 'components/coverage/events/eventsView.html',
        controller: 'app.coverage.events.eventsController',
        title: 'Events'
    });
}]);

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(322);

'use strict';

angular.module('app.coverage.channels.channelsController', ['app.coverage.channels.channelsService']).controller('app.coverage.channels.channelsController', ['$scope', 'app.coverage.channels.channelsService', 'hostnameMatchService', function ($scope, channels, hostnameMatchService) {
  channels.retrieve();

  $scope.channels = channels;

  $scope.currentPlatform = window.location.platform(undefined, hostnameMatchService.hostname());

  $scope.gotoChannel = function (platform) {
    window.location = window.location.platform(platform, hostnameMatchService.hostname());
  };
}]);

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.coverage.channels.channelsService', []).factory('app.coverage.channels.channelsService', ['$http', function ($http) {
  var channels = void 0;
  channels = {
    list: null,
    error: null,
    retrieve: function retrieve() {
      return $http.get(window.location.api('platforms')).then(function (response) {
        var data = response.data;

        if (data.error) {
          channels.error = data.error;
        } else {
          channels.error = null;
          channels.list = data;
        }
      });
    }
  };
  return channels;
}]);

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(103);
__webpack_require__(14);

angular.module('app.coverage.events.eventsController', ['app.coverage.events.eventsService', 'app.favorites.favoritesService']).controller('app.coverage.events.eventsController', ['$scope', '$state', 'app.coverage.events.eventsService', 'app.favorites.favoritesService', function ($scope, $state, eventsService, favorites) {
  'use strict';

  $scope.eventFilter = 'upcoming';
  $scope.pager = {
    items: [],
    pageSize: 20,
    totalItems: null,
    currentPage: 1,
    currentList: 'upcoming',
    pageChanged: function pageChanged() {
      var selectedEvent = eventsService.typeList[this.currentList],
          start = (this.currentPage - 1) * this.pageSize,
          end = start + this.pageSize;
      this.totalItems = selectedEvent.list.length;
      this.items = selectedEvent.list.slice(start, end);
    },
    reset: function reset(eventType) {
      this.currentPage = 1;
      if (eventType) {
        this.currentList = eventType;
      }
      this.pageChanged();
    }
  };

  $scope.favorites = favorites;

  $scope.filterEvents = function (eventType) {
    eventsService.getEventsByType(eventType).then(function () {
      $scope.pager.reset(eventType);
    });
  };

  $scope.goToSchedule = function (event) {
    $state.go('app.schedule', { type: 'event', id: event.calid });
  };

  /**
   * @param {Event} event
   * @returns {string}
   */
  $scope.eventDate = function (event) {
    var start_date = moment(event.calstartdate);
    var end_date = moment(event.calenddate);

    return start_date.format('MMMM DD-') + end_date.format('DD, YYYY');
  };

  eventsService.getEventsByType().then(function () {
    $scope.pager.reset($scope.eventFilter);
  });

  favorites.retrieve_if_empty();
}]);

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.dateDirective', []).directive('date', ['DATE_FORMAT',
/**
 * @param DATE_FORMAT
 * @returns {{
 * restrict: string,
 * link: (function(*, *, {parseFormat: string, date: string, format: string, showDate: string, showTime: string}))
 * }}
 */
function (DATE_FORMAT) {
  'use strict';

  return {
    restrict: 'A',
    link: function link(scope, elm, attrs) {
      var date = void 0,
          format = void 0,
          show_date = void 0,
          show_time = void 0;
      if (attrs.date) {
        if (attrs.parseFormat) {
          date = moment(attrs.date, attrs.parseFormat);
        } else {
          date = moment(new Date(attrs.date));
        }
        if (attrs.format) {
          format = attrs.format;
        } else {
          if (typeof attrs.showDate !== 'undefined') {
            show_date = parseBoolean(attrs.showDate);
          } else {
            show_date = true;
          }
          if (typeof attrs.showTime !== 'undefined') {
            show_time = parseBoolean(attrs.showTime);
          } else {
            show_time = true;
          }
          format = '';
          if (show_date) {
            format += DATE_FORMAT.moment.date;
          }
          if (show_time) {
            if (show_date) {
              format += ' ';
            }
            format += DATE_FORMAT.moment.time;
          }
        }
        return elm.text(date.format(format));
      }
    }
  };
}]);

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(104);
__webpack_require__(107);

'use strict';

angular.module('app.schedule', ['app.schedule.scheduleDirective', 'app.shared.teamLineup.teamLineupDirective']).config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('app.schedule', {
    url: '/schedule?:type&:id&:scheduleSearch',
    templateUrl: 'components/schedule/scheduleView.html',
    reloadOnSearch: false,
    resolve: {
      searchTerm: ['$stateParams', function ($stateParams) {
        var term = void 0;
        if ($stateParams.type && $stateParams.id) {
          term = {
            type: $stateParams.type,
            search_id: $stateParams.id
          };
        }
        return term;
      }]
    },
    params: {
      type: null,
      id: null,
      search: null,
      selected_favorites: null
    },
    controller: ['$scope', 'searchTerm', function ($scope, searchTerm) {
      $scope.searchTerm = searchTerm;
    }],
    title: 'Schedule'
  });
}]);

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(74);
__webpack_require__(14);

angular.module('app.schedule.scheduleController', ['app.schedule.scheduleService', 'app.favorites.favoritesService']).controller('app.schedule.scheduleController', ['$scope', 'app.schedule.scheduleService', '$stateParams', '$rootScope', 'app.favorites.favoritesService', function ($scope, scheduleService, $stateParams, $rootScope, favoritesService) {
  'use strict';

  $scope.searchInclude = $scope.searchInclude || false;
  $scope.searchHideDateSelector = $scope.searchHideDateSelector || false;
  $scope.searchHide = $scope.searchHide || false;
  $scope.searchHideTerm = $scope.searchHideTerm || false;
  $scope.searchName = $scope.searchName || null;
  $scope.broadcastActive = $scope.broadcastActive || false;
  $scope.limitToFavorites = typeof $scope.limitToFavorites === 'undefined' || false;
  $scope.favoritesService = favoritesService;

  var schedule_params = {
    limit_favorites: $scope.limitToFavorites
  };

  if ($stateParams.search) {
    schedule_params.type = $stateParams.search.type;
    schedule_params.search_id = $stateParams.search.search_id;
  }

  if ($stateParams.type && $stateParams.id) {
    schedule_params.type = $stateParams.type;
    schedule_params.search_id = $stateParams.id;
    $scope.searchInclude = false;
  }

  $scope.active_favorite = null;
  $scope.isScheduleHidden = false;

  var init = function init() {
    var params = void 0;

    $scope.schedule = scheduleService.schedule;
    $scope.schedule.reset_params();

    $scope.scheduleType = $scope.scheduleType || null;
    if ($scope.scheduleType === 'my_games') {
      $scope.schedule.merge_params({
        date_disabled: true,
        my_games: true,
        limit_favorites: false,
        sort: "desc"
      });
    }

    $scope.schedule.isUpcomingSchedule($scope.scheduleType === 'upcoming_schedule');

    $scope.schedule.current_page = 1;

    if ($stateParams.scheduleSearch) {
      var _params = JSON.parse($stateParams.scheduleSearch);
      if (!_.isEmpty(_params.favorites)) {
        favoritesService.selected = _params.favorites;
      }

      $scope.schedule.retrieve(_params).then(function () {
        $scope.$broadcast('reinit_schedule_search');
      });
    } else {
      if ($scope.searchTerm) {
        params = angular.merge({ date_disabled: true }, $scope.searchTerm);
      } else {
        params = null;
      }

      if (!$scope.searchInclude) {
        favoritesService.clear();
        $scope.schedule.retrieve(params);
      } else if ($stateParams.selected_favorites) {
        var serviceFavorite = parseInt(favoritesService.selected[0]);
        var selectedFavorite = parseInt($stateParams.selected_favorites.id);
        if (serviceFavorite !== 10 || serviceFavorite !== selectedFavorite) {
          favoritesService.selected.splice(0, 1);
        }

        favoritesService.toggle_selected($stateParams.selected_favorites.id);
      } else {
        $scope.schedule.retrieve();
      }
    }
  };

  $scope.is_expandable = function (game) {
    return !game.is_blacked_out;
  };
  $scope.toggle_collapsed = function (game, is_collapsed) {
    if (!$scope.is_expandable(game)) {
      is_collapsed = true;
    } else {
      is_collapsed = !is_collapsed;
    }
    return is_collapsed;
  };

  $scope.onShowFavorites = function (game) {
    game.favoritesOpen = !game.favoritesOpen;
  };

  $scope.gamePeriodSuffix = function (period, time) {
    period = period.toLowerCase();

    switch (period) {
      case 'pre':
        period = 'pregame';
        break;
      case '1':
        period = period + 'st';
        break;

      case '2':
        period = period + 'nd';
        break;

      case '3':
        period = period + 'rd';
        break;

      case '4':
        period = period + 'th';
        break;

      case 'final':
        break;
    }

    if (period !== 'pregame' && period !== 'final') {
      period = period + ' ' + time;
    }

    return period;
  };

  $scope.get_game_timeperiod = function (game) {
    if (game.overlay) {
      game.overlay.timeperiod = $scope.gamePeriodSuffix(game.overlay.strperiod, game.overlay.strtime);

      return game.overlay.timeperiod;
    }
  };

  $scope.$on('favorites_selected', function () {
    var params = {};

    if ($scope.schedule.current_params && $scope.schedule.current_params.type) {
      params.search_id = null;
      params.type = null;
      params.search_term = null;
    }

    $scope.schedule.current_page = 1;
    $scope.schedule.retrieve(params, { saveToHistory: true });
  });

  $rootScope.$on('schedule_search_select_term', function () {
    $scope.schedule.current_page = 1;
  });

  $scope.$on('scheduleSearchTermVisibilityChanged',
  /**
   * @param event
   * @param {*} data
   */
  function (event, data) {
    $scope.isScheduleHidden = data.isVisible;
  });

  $scope.$on('$destroy', function () {
    $scope.schedule.reset_params();
  });

  return init();
}]);

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(328);

'use strict';

angular.module('app.schedule.scheduleSearch.scheduleSearchDirective', ['app.schedule.scheduleSearch.scheduleSearchController']).directive('scheduleSearch', [function () {
  return {
    restrict: 'E',
    templateUrl: 'components/schedule/scheduleSearch/scheduleSearchView.html',
    controller: 'app.schedule.scheduleSearch.scheduleSearchController',
    scope: {
      hideDateSelector: '<?',
      hideFavoritesSelector: '<?',
      hideTerm: '<?',
      showTermResults: '=?',
      onSelected: '=?',
      showInstructions: '<?',
      termListTitle: '<?',
      alwaysOpen: '<?',
      name: '<?',
      isFavouritesManager: '<?'
    },
    link: function link(scope, elm) {
      elm.addClass('schedule-search-directive');
    }
  };
}]);

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(329);
__webpack_require__(14);

'use strict';

angular.module('app.schedule.scheduleSearch.scheduleSearchController', ['app.schedule.scheduleSearch.scheduleSearchService', 'app.favorites.favoritesService', 'daterangepicker']).controller('app.schedule.scheduleSearch.scheduleSearchController', ['$scope', 'app.schedule.scheduleSearch.scheduleSearchService', 'app.favorites.favoritesService', '$rootScope', '$state', 'PRODUCT', function ($scope, scheduleSearchService, favorites, $rootScope, $state, product) {
  var ignoreTermChange = false; //used to avoid triggering watch when manually setting search term

  $scope.name = $scope.name || null;
  $scope.scheduleSearch = scheduleSearchService.scheduleSearch;
  $scope.group = 'teams';

  $scope.showTermResults = $scope.showTermResults || false;
  $scope.hideDateSelector = $scope.hideDateSelector || false;
  $scope.hideFavoritesSelector = $scope.hideFavoritesSelector || false;
  $scope.hideTerm = $scope.hideTerm || false;
  $scope.onSelected = $scope.onSelected || false;
  $scope.showInstructions = $scope.showInstructions || false;
  $scope.termListTitle = $scope.termListTitle || 'Search Results';
  $scope.alwaysOpen = $scope.alwaysOpen || false;

  $scope.favorites = favorites;
  $scope.favoriteTerms = null;
  $scope.userSelected = false;
  $scope.displayDateText = moment().toDate();

  $scope.productName = product.Name;
  $scope.productId = product.Id;

  $scope.isFavouritesManager = $scope.isFavouritesManager || false;

  $scope.scheduleSearch.custom_date = {};

  $scope.datePicker = {};
  $scope.datePicker.date = { startDate: $scope.scheduleSearch.custom_date.start, endDate: $scope.scheduleSearch.custom_date.end };
  $scope.datePicker.opts = {
    showDropdowns: true,
    minDate: moment("2012-08-01"), // oldest game date with video in htv
    linkedCalendars: false,
    opens: "center",
    parentEl: ".selection-calendar",
    alwaysShowCalendars: true,
    ranges: {
      'Today': [moment(), moment()],
      'This Week': [moment().startOf('week'), moment().endOf('week')],
      'Last 7 Days': [moment().subtract(6, 'days'), moment()],
      'Next 7 Days': [moment(), moment().add(6, 'days')]
    },
    eventHandlers: {
      'apply.daterangepicker': function applyDaterangepicker() {
        $scope.scheduleSearch.custom_date.start = $scope.datePicker.date.startDate;
        $scope.scheduleSearch.custom_date.end = $scope.datePicker.date.endDate;
        $scope.search_custom_date_range();
      },
      'cancel.daterangepicker': function cancelDaterangepicker() {
        $scope.cancel_custom_search();
      }
    }
  };

  var getFavoriteTerms = function getFavoriteTerms() {
    if (favorites.list && Array.isArray(favorites.list.personal)) {
      $scope.favoriteTerms = [];
      for (var i in favorites.list.personal) {
        if (favorites.list.personal.hasOwnProperty(i)) {
          var favorite = favorites.list.personal[i];
          if (favorite.term) {
            $scope.favoriteTerms.push(favorite.term);
          }
        }
      }
    }
  };

  $scope.clear_term = function (ignoreOnSelected) {
    if ($scope.scheduleSearch.term) {
      $scope.scheduleSearch.clear_term();
      if (!$scope.isFavouritesManager) {
        $scope.scheduleSearch.search_schedule();
      }
    }

    $scope.showTermResults = false;

    if (!ignoreOnSelected) {
      if (typeof $scope.onSelected === 'function') {
        $scope.onSelected();
      }
    }
  };

  $scope.outerSearchPanelClicked = function (type, searchId, evt) {
    if ($scope.isFavouritesManager) {
      favorites.toggle(type, searchId);
      $scope.clear_term();
      evt.stopPropagation();
    }
  };

  $scope.manually_set_search_term = function (term) {
    ignoreTermChange = true;
    $scope.scheduleSearch.term = term;
  };

  $scope.select_term = function (term, sort_direction) {
    if ($scope.isFavouritesManager && favorites.is_favorite(term.type, term.search_id)) {
      $state.go('app.schedule', { selected_favorites: favorites.find_favorite(term.type, term.search_id) }, {
        inherit: false,
        reload: false
      });
    } else {
      $rootScope.$broadcast("favorites_reset_all_leagues");
      $rootScope.$broadcast("schedule_search_select_term");

      $scope.scheduleSearch.set_term(term.type, term.search_id, term.term ? term.term : term.label);

      if (!$scope.isFavouritesManager) {
        $scope.scheduleSearch.use_custom_date = true;
        $scope.scheduleSearch.set_custom_date_sort_direction();
        $scope.scheduleSearch.search_schedule();
      }

      $scope.showTermResults = false;

      $scope.manually_set_search_term(term.term ? term.term : term.label);

      if (typeof $scope.onSelected === 'function') {
        $scope.onSelected(term);
      }
    }
  };

  $scope.change_day = function (days_to_move) {
    var start = void 0;
    if ($scope.scheduleSearch.custom_date.start != null) {
      start = moment($scope.scheduleSearch.custom_date.start);
    } else {
      start = moment();
    }

    start = start.add(days_to_move, 'days').toDate();
    $scope.scheduleSearch.set_custom_date(start, start);
    $rootScope.$broadcast('schedule_search_select_term');
    $scope.scheduleSearch.use_current_time = true;
    $scope.scheduleSearch.search_schedule();
  };

  $scope.toggle_custom_date_display = function () {
    $scope.scheduleSearch.use_custom_date = true;
    $scope.scheduleSearch.show_custom_date_selector = !$scope.scheduleSearch.show_custom_date_selector;
  };

  $scope.open_custom_search = function () {
    var start = $scope.scheduleSearch.get_date().start,
        end = $scope.scheduleSearch.get_date().end;

    $scope.scheduleSearch.custom_date.start = start ? moment(start) : undefined;
    $scope.scheduleSearch.custom_date.end = end ? moment(end) : undefined;
    $scope.toggle_custom_date_display();
  };

  $scope.cancel_custom_search = function () {
    $scope.toggle_custom_date_display();
  };

  $scope.search_custom_date_range = function () {
    $scope.toggle_custom_date_display();
    $scope.scheduleSearch.custom_date_title = null;
    $scope.scheduleSearch.schedule_params.status = null; //fixes issue where if user searches by past games then custom date it retains the status value.
    $scope.scheduleSearch.schedule_params.sort = null; //fixes sorting issue when searching by past games then custom dates
    $rootScope.$broadcast('schedule_search_select_term'); //reset page to 1 when switching between dates/days
    $scope.scheduleSearch.use_current_time = false;
    $scope.scheduleSearch.search_schedule();
  };

  $scope.search_all_future_dates = function () {
    $scope.toggle_custom_date_display();
    $scope.scheduleSearch.set_custom_date(moment(), null);
    $rootScope.$broadcast('schedule_search_select_term');
    $scope.scheduleSearch.use_current_time = true;
    $scope.scheduleSearch.search_schedule('asc');
  };

  $scope.search_all_past_dates = function () {
    $scope.toggle_custom_date_display();
    $scope.scheduleSearch.set_custom_date(null, moment());
    $rootScope.$broadcast('schedule_search_select_term');
    $scope.scheduleSearch.use_current_time = false;
    $scope.scheduleSearch.search_schedule('desc');
  };

  $scope.searchResults = function () {
    if ($scope.scheduleSearch && $scope.scheduleSearch.term) {
      return $scope.scheduleSearch.results[$scope.group];
    } else if (favorites.list) {
      if (!$scope.favoriteTerms) {
        getFavoriteTerms();
      }
      return $scope.favoriteTerms;
    }
  };

  $scope.toggleFavorite = function (type, search_id, event) {
    $scope.favorites.toggle(type, search_id);
    if ($scope.isFavouritesManager) {
      $scope.clear_term();
      event.stopPropagation();
    }
  };

  $scope.termChanged = function () {
    if (!ignoreTermChange) {
      ignoreTermChange = $scope.scheduleSearch.schedule_params && $scope.scheduleSearch.schedule_params.search_term && $scope.scheduleSearch.schedule_params.search_term === $scope.scheduleSearch.term;
    }

    if (!ignoreTermChange) {
      if ($scope.scheduleSearch.term && $scope.scheduleSearch.term.length >= 3) {

        $scope.scheduleSearch.search_terms([$scope.group]);
        if ($scope.scheduleSearch.term) {
          return $scope.showTermResults = true;
        } else {
          return $scope.showTermResults = false;
        }
      } else {
        return $scope.showTermResults = false;
      }
    } else {
      ignoreTermChange = false;
    }
  };

  $scope.$watch(function () {
    return $scope.showTermResults;
  }, function () {
    $scope.$emit('scheduleSearchTermVisibilityChanged', {
      isVisible: $scope.showTermResults
    });
  });

  $scope.$watchGroup(['scheduleSearch.use_custom_date', 'scheduleSearch.date_offset.start', 'scheduleSearch.date_offset.end', 'scheduleSearch.custom_date.start', 'scheduleSearch.custom_date.end'], function () {
    $scope.scheduleSearch.set_custom_date_text();
  });

  $scope.$on('favorites_selected', function () {
    $scope.scheduleSearch.clear_term();
  });

  $scope.$on('favorites_changed', function () {
    getFavoriteTerms();
  });

  $scope.$on('favorites_updated', function () {
    getFavoriteTerms();
  });

  $scope.$on('reinit_schedule_search', function () {
    $scope.scheduleSearch.init();
  });

  $scope.$on('assign_schedule_search_group', function () {
    if ($scope.scheduleSearch.schedule_params && $scope.scheduleSearch.schedule_params.hasOwnProperty('type')) {
      switch ($scope.scheduleSearch.schedule_params.type) {
        case 'team':
        default:
          $scope.group = 'teams';
          break;
        case 'league':
          $scope.group = 'leagues';
          break;
        case 'event':
          $scope.group = 'events';
          break;
      }
    }
  });

  var promise = favorites.retrieve_if_empty();
  if (!promise) {
    getFavoriteTerms();
  }

  $scope.scheduleSearch.init();

  $scope.$on('$destroy', function () {
    $scope.scheduleSearch.show_custom_date_selector = false;
    $scope.scheduleSearch.custom_date.start = null;
    $scope.scheduleSearch.custom_date.end = null;
    $scope.scheduleSearch.custom_date_title = null;
    $scope.scheduleSearch.schedule_params = null;
    $scope.scheduleSearch.term = null;
  });
}]);

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(74);
__webpack_require__(98);

'use strict';

angular.module('app.schedule.scheduleSearch.scheduleSearchService', ['app.schedule.scheduleService', 'app.currentPlatform.currentPlatformDetailService']).factory('app.schedule.scheduleSearch.scheduleSearchService', ['$http', '$q', '$rootScope', 'app.schedule.scheduleService', 'app.currentPlatform.currentPlatformDetailService', function ($http, $q, $rootScope, scheduleService, currentPlatformDetails) {
  var service = {
    last_search: {},
    scheduleSearch: {
      initialized: false,
      term: null,
      date_offset: null,
      custom_date: null,
      use_custom_date: true,
      use_current_time: true,
      show_custom_date_selector: false,
      date_disabled: false,
      custom_date_title: '',
      userSelected: false,
      searcher: {
        teams: null,
        leagues: null,
        events: null
      },
      results: {
        teams: null,
        leagues: null,
        events: null
      },
      schedule_params: null,
      toggleShowDateSelector: function toggleShowDateSelector() {
        service.scheduleSearch.use_custom_date = true;
        service.scheduleSearch.show_custom_date_selector = !service.scheduleSearch.show_custom_date_selector;
      },
      openCustomDateSelector: function openCustomDateSelector() {
        service.scheduleSearch.custom_date.start = moment();
        service.scheduleSearch.custom_date.end = moment();
        service.scheduleSearch.toggleShowDateSelector();
      },
      selectAllUpcomingGames: function selectAllUpcomingGames() {
        service.scheduleSearch.set_custom_date(moment(), null);
        service.scheduleSearch.toggleShowDateSelector();
      },
      selectAllPastGames: function selectAllPastGames() {
        service.scheduleSearch.set_custom_date(null, moment());
        service.scheduleSearch.toggleShowDateSelector();
      },
      get_date: function get_date() {
        var date = void 0;

        if (service.scheduleSearch.use_custom_date) {
          date = service.scheduleSearch.custom_date;
        } else {
          date = service.scheduleSearch.calc_date();
        }

        if (moment.isMoment(date)) {
          date = date.toDate();
        }

        return date;
      },
      search_terms: function search_terms(groups) {
        if (service.scheduleSearch.initialized) {

          var ref = service.scheduleSearch.searcher;
          var results = [];
          for (var group in ref) {
            if (ref.hasOwnProperty(group)) {
              if (Array.isArray(groups)) {
                if (groups.indexOf(group) === -1) {
                  continue;
                }
              }

              var params = {
                term: service.scheduleSearch.term,
                group: group,
                platform_leagues: currentPlatformDetails.platform.strleague_nicknames ? currentPlatformDetails.platform.strleague_nicknames.toString() : null //assign platform leagues as a search param
              };
              results.push(service.scheduleSearch.send_search_terms_request(group, params));
            }
          }

          return results;
        }
      },
      clearResults: function clearResults() {
        service.scheduleSearch.results = {
          teams: null,
          leagues: null,
          events: null
        };
      },
      send_search_terms_request: function send_search_terms_request(group, params) {
        var promise = void 0;
        if (service.scheduleSearch.searcher[group]) {
          service.scheduleSearch.searcher[group].resolve();
        }
        service.scheduleSearch.searcher[group] = $q.defer();
        promise = service.scheduleSearch.searcher[group].promise;

        return $http.get(window.location.api('/schedule/search_terms'), {
          timeout: promise,
          params: params
        }).then(function (response) {
          var data = response.data;

          if (data && data.results) {
            if (typeof data.results.teams !== 'undefined') {
              service.scheduleSearch.results.teams = data.results.teams;
            }
            if (typeof data.results.leagues !== 'undefined') {
              service.scheduleSearch.results.leagues = data.results.leagues;
            }
            if (typeof data.results.events !== 'undefined') {
              service.scheduleSearch.results.events = data.results.events;
            }
          }
          return service.scheduleSearch.searcher[group] = null;
        }, function () {
          return service.scheduleSearch.searcher[group] = null;
        });
      },
      set_custom_date_text: function set_custom_date_text(title) {

        if (typeof title === 'undefined') {
          if (typeof service.scheduleSearch.custom_date !== 'undefined') {
            if (service.scheduleSearch.custom_date.start && !service.scheduleSearch.custom_date.end) {
              service.scheduleSearch.custom_date_title = 'All Upcoming Games';
            } else if (!service.scheduleSearch.custom_date.start && service.scheduleSearch.custom_date.end) {
              service.scheduleSearch.custom_date_title = 'All Past Games';
            } else {
              var dateTitle = void 0;
              if (moment(service.scheduleSearch.custom_date.start).isSame(moment(service.scheduleSearch.custom_date.end), 'day')) {
                dateTitle = moment(service.scheduleSearch.custom_date.start).format('dddd MMMM D, YYYY');
              } else {
                dateTitle = moment(service.scheduleSearch.custom_date.start).format('ddd. MMMM D, YYYY') + ' - ' + moment(service.scheduleSearch.custom_date.end).format('ddd. MMMM D, YYYY');
              }
              service.scheduleSearch.custom_date_title = dateTitle;
            }
          }
        } else {
          service.scheduleSearch.custom_date_title = title;
        }
      },
      set_custom_date_sort_direction: function set_custom_date_sort_direction(title) {
        service.scheduleSearch.schedule_params.status = null;
        if (typeof title === 'undefined' && service.scheduleSearch.custom_date) {
          if (service.scheduleSearch.custom_date.start && !service.scheduleSearch.custom_date.end) {
            service.scheduleSearch.schedule_params.sort = 'asc';
          } else if (!service.scheduleSearch.custom_date.start && service.scheduleSearch.custom_date.end) {
            service.scheduleSearch.schedule_params.status = 'vod';
            service.scheduleSearch.schedule_params.sort = 'desc';
          }
        }
      },
      set_custom_date: function set_custom_date(start_date, end_date, title) {
        if (service.scheduleSearch.custom_date) {
          service.scheduleSearch.custom_date.start = start_date;
          service.scheduleSearch.custom_date.end = end_date;
          service.scheduleSearch.use_custom_date = true;

          service.scheduleSearch.set_custom_date_text(title);
          service.scheduleSearch.set_custom_date_sort_direction(title);
        }
      },
      calc_date: function calc_date() {
        var offset = void 0;
        offset = service.scheduleSearch.date_offset;
        if (!offset) {
          offset = {};
        }
        if (!offset.start) {
          offset.start = 0;
        }
        if (!offset.end) {
          offset.end = 0;
        }
        return {
          start: moment().add(offset.start, 'days').toDate(),
          end: moment().add(offset.end, 'days').toDate()
        };
      },
      set_date_offset: function set_date_offset(offset) {
        if (!offset) {
          offset = {};
        }
        if (!offset.start) {
          offset.start = 0;
        }
        if (!offset.end) {
          offset.end = 0;
        }
        service.scheduleSearch.use_custom_date = false;
        return service.scheduleSearch.date_offset = offset;
      },
      active_offset: function active_offset() {
        if (service.scheduleSearch.date_offset) {
          if (service.scheduleSearch.date_offset.start === -30 && service.scheduleSearch.date_offset.end === 0) {
            return '-30';
          }
          if (service.scheduleSearch.date_offset.start === -7 && service.scheduleSearch.date_offset.end === 0) {
            return '-7';
          }
          if (service.scheduleSearch.date_offset.start === 0 && service.scheduleSearch.date_offset.end === 0) {
            return 'today';
          }
          if (service.scheduleSearch.date_offset.start === 0 && service.scheduleSearch.date_offset.end === 7) {
            return '+7';
          }
          if (service.scheduleSearch.date_offset.start === 0 && service.scheduleSearch.date_offset.end === 30) {
            return '+30';
          }
        }
        return 'custom';
      },
      is_active_offset: function is_active_offset(name) {
        return service.scheduleSearch.active_offset() === name;
      },
      evaluate_date: function evaluate_date(range) {
        var end = void 0,
            format_str = void 0,
            g30 = void 0,
            g7 = void 0,
            l30 = void 0,
            l7 = void 0,
            start = void 0,
            today = void 0;
        if (!range) {
          return false;
        }
        if (!range.start) {
          return false;
        }
        if (!range.end) {
          return false;
        }
        start = range.start;
        end = range.end;
        format_str = 'YYYY-MM-DD';
        if (!moment.isMoment(start)) {
          if (!moment.isDate(start)) {
            start = new Date(start);
          }
          start = moment(start);
        }
        start = start.format(format_str);
        if (!moment.isMoment(end)) {
          if (!moment.isDate(end)) {
            end = new Date(end);
          }
          end = moment(end);
        }
        end = end.format(format_str);
        today = moment().format(format_str);
        l30 = moment().subtract(30, 'days').format(format_str);
        l7 = moment().subtract(7, 'days').format(format_str);
        g7 = moment().add(7, 'days').format(format_str);
        g30 = moment().add(30, 'days').format(format_str);
        if (start === l30 && end === today) {
          return '-30';
        }
        if (start === l7 && end === today) {
          return '-7';
        }
        if (start === today && end === today) {
          return 'today';
        }
        if (start === today && end === g7) {
          return '+7';
        }
        if (start === today && end === g30) {
          return '+30';
        }
        return 'custom';
      },
      clear_term: function clear_term() {
        service.scheduleSearch.term = null;
        if (service.scheduleSearch.schedule_params) {
          service.scheduleSearch.schedule_params.search_id = null;
          service.scheduleSearch.schedule_params.type = null;
          service.scheduleSearch.schedule_params.search_term = null;
        }
        service.scheduleSearch.clearResults();
      },
      set_term: function set_term(type, search_id, search_term) {
        if (service.scheduleSearch.schedule_params) {
          service.scheduleSearch.schedule_params.search_id = search_id;
          service.scheduleSearch.schedule_params.type = type;
          service.scheduleSearch.schedule_params.search_term = search_term;
        }
      },
      search_schedule: function search_schedule(sort_direction, last_search_name) {
        if (scheduleService.schedule) {
          service.scheduleSearch.use_custom_date = true;

          if (service.scheduleSearch.initialized) {
            var date = service.scheduleSearch.get_date();
            service.scheduleSearch.schedule_params.start_date = date.start;
            service.scheduleSearch.schedule_params.end_date = date.end;

            if (sort_direction) {
              service.scheduleSearch.schedule_params.sort = sort_direction;
            }
            service.scheduleSearch.schedule_params.date_disabled = service.scheduleSearch.date_disabled;
            service.scheduleSearch.schedule_params.use_current_time = service.scheduleSearch.use_current_time;

            return scheduleService.schedule.retrieve(service.scheduleSearch.schedule_params, { saveToHistory: true }).then(function () {
              if (last_search_name) {
                service.last_search[last_search_name] = {
                  term: service.scheduleSearch.term,
                  date_offset: service.scheduleSearch.date_offset,
                  custom_date: service.scheduleSearch.custom_date,
                  schedule_params: service.scheduleSearch.schedule_params
                };
              }

              if (scheduleService.schedule.current_params) {
                service.scheduleSearch.schedule_params = angular.copy(scheduleService.schedule.current_params);
                service.scheduleSearch.set_custom_date(service.scheduleSearch.schedule_params.start_date, service.scheduleSearch.schedule_params.end_date);
                service.scheduleSearch.use_custom_date = true;
              }
            });
          }
        }
      },
      init: function init(last_search_name) {
        if (last_search_name && service.last_search[last_search_name]) {
          var last_search = service.last_search[last_search_name];

          service.scheduleSearch.term = last_search.term;
          service.scheduleSearch.date_offset = last_search.date_offset;
          service.scheduleSearch.custom_date = last_search.custom_date;
          service.scheduleSearch.schedule_params = angular.copy(last_search.schedule_params);
        } else {
          service.scheduleSearch.date_offset = {
            start: 0,
            end: 0
          };
          if (scheduleService.schedule.current_params) {
            service.scheduleSearch.custom_date = {
              start: scheduleService.schedule.current_params.start_date,
              end: scheduleService.schedule.current_params.end_date
            };
          } else {
            service.scheduleSearch.custom_date = {
              start: null,
              end: null
            };
          }

          service.scheduleSearch.schedule_params = scheduleService.schedule.current_params ? angular.copy(scheduleService.schedule.current_params) : angular.copy(scheduleService.schedule.default_params);

          service.scheduleSearch.term = service.scheduleSearch.schedule_params && service.scheduleSearch.schedule_params.search_term ? service.scheduleSearch.schedule_params.search_term : null;
        }

        service.scheduleSearch.initialized = true;
        $rootScope.$broadcast('assign_schedule_search_group');
      }
    }
  };

  return service;
}]);

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.schedule.noBroadcastDirective', []).directive('noBroadcast', [function () {
    return {
        restrict: 'E',
        templateUrl: 'components/schedule/noBroadcast/noBroadcastView.html',
        link: function link(scope, elm) {
            return elm.addClass('no-broadcast-directive');
        }
    };
}]);

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(332);

"use strict";

angular.module('app.schedule.gameActions.gameActionsDirective', ['app.schedule.gameActions.gameActionsController']).directive('gameActions', [function () {
    return {
        restrict: 'E',
        templateUrl: 'components/schedule/gameActions/gameActionsView.html',
        controller: 'app.schedule.gameActions.gameActionsController',
        link: function link(scope, elm) {
            elm.addClass('game-actions');
        }
    };
}]);

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(333);
__webpack_require__(1);

angular.module('app.schedule.gameActions.gameActionsController', ['app.schedule.gameActions.gameActionsService', 'app.currentUser']).controller('app.schedule.gameActions.gameActionsController', ['$scope', 'app.schedule.gameActions.gameActionsService', 'currentUser', function ($scope, gameActions, currentUser) {
  "use strict";

  $scope.currentUser = currentUser;
  $scope.downloadLinks = {};
  $scope.retrievingDownloads = {};

  /**
   * @param {Game} game
   * @param {boolean} secondary
   * @returns {*}
   */
  $scope.playIconClass = function (game, secondary) {
    if (typeof secondary === 'undefined') {
      secondary = false;
    }

    if (game.can_play) {
      var icon = 'fa-play-circle';

      if (game.multiple_audio === 1) {
        if (game.multiple_audio_override === 0) {
          icon = 'fa-play-circle-o';
        } else {
          if (secondary) {
            icon = 'fa-play-circle-o';
          }
        }
      } else {
        if (game.multiple_audio_override === 2) {
          if (secondary) {
            icon = 'fa-play-circle-o';
          }
        }
      }
      return icon;
    }
    return false;
  };

  $scope.playMessage = function (game, secondary) {
    if (typeof secondary === 'undefined') {
      secondary = false;
    }

    if (game.can_play) {
      var message = 'Play';

      if (game.pixellot_only) {
        return message;
      }

      // Start by checking the multiple audio setting (the override) to see what the message should be
      // After these checks depending on the games multiple audio (usually the leagues audio setting) display the correct message
      if (game.multiple_audio_setting === 1) {
        if (secondary) {
          message = 'Play w/ away audio';
        } else {
          message = 'Play w/ home audio';
        }
      } else if (game.multiple_audio_setting === 2) {
        if (secondary) {
          message = 'Play w/ French audio';
        } else {
          message = 'Play w/ English audio';
        }
      } else if (game.multiple_audio === 1) {
        if (secondary) {
          message = 'Play w/ away audio';
        } else {
          message = 'Play w/ home audio';
        }
      } else if (game.multiple_audio === 2) {
        if (secondary) {
          message = 'Play w/ French audio';
        } else {
          message = 'Play w/ English audio';
        }
      }
      return message;
    }
    return false;
  };

  $scope.downloadIconClass = function (game) {
    var class_name = null;

    switch (game.bdownloadgameflag) {
      case 2:
        class_name = null;
        break;
      case 1:
        class_name = 'preparing';
        break;
      case 0:
        class_name = 'prepare';
        break;
      case -1:
        class_name = 'not-available';
        break;
      default:
        if (game.blivegameflag <= 2 && game.barchivegameflag > 0) {
          class_name = 'disabled';
        } else {
          class_name = 'ready';
        }
        break;
    }

    return class_name;
  };

  $scope.downloadMessage = function (game, download) {
    var message = download.name + ": ";

    // Be sure to initalize the array for each game.
    if (!(game.igameid in $scope.retrievingDownloads)) {
      $scope.retrievingDownloads[game.igameid] = {};
    }

    if ($scope.retrievingDownloads[game.igameid][download.audio_stream]) {
      message += "Retrieving Download...";
    } else {
      switch (download.status) {
        case 3:
          message += 'Download Ready';
          break;
        case 2:
        case 1:
          message += 'Processing';
          break;
        case 0:
          message += 'Prepare Download';
          break;
        case -1:
          message += 'Not Available';
          break;
        default:
          if (game.blivegameflag <= 2 && game.barchivegameflag > 0) {
            message += 'No Download';
          } else {
            message += 'Download Ready';
          }
      }
    }

    return message;
  };

  $scope.downloadGame = function (game, download) {
    $scope.downloadLinks[game.igameid] = null;
    if (download != undefined) {
      $scope.retrievingDownloads[game.igameid][download.audio_stream] = true;

      return gameActions.downloadGame(game, download).then(function (response) {
        $scope.downloadLinks[game.igameid] = response;
        $scope.retrievingDownloads[game.igameid][download.audio_stream] = false;
      }).catch(function (response) {
        $scope.downloadLinks[game.igameid] = null;
        $scope.retrievingDownloads[game.igameid][download.audio_stream] = false;
      });
    }
  };

  $scope.toggleFavorites = function () {
    $scope.favoritesOpen = !$scope.favoritesOpen;
    $scope.onShowFavorites();
  };
}]);

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.schedule.gameActions.gameActionsService', []).factory('app.schedule.gameActions.gameActionsService', ['$http', function ($http) {
  "use strict";

  return {
    downloadGame: function downloadGame(game, download) {
      var processResponse = function processResponse(data) {
        return new Promise(function (resolve, reject) {
          if (data.error) {
            alert(data.error);
            reject({ message: data.error });
          } else {
            var linkUrl = null;

            if (data.url) {
              if (window.navigator.userAgent.match(/Firefox/) || window.navigator.userAgent.match(/Chrome/)) {
                linkUrl = data.url;
              } else {
                var link = document.createElement('a');
                link.href = data.url;
                link.target = '_blank';

                if (typeof link.download !== 'undefined') {
                  link.download = game.igameid + '.mp4';
                }

                if (document.createEvent) {
                  var e = document.createEvent('MouseEvents');
                  e.initEvent('click', true, true);
                  link.dispatchEvent(e);
                }
              }
            }

            if (data.download) {
              download.status = data.download.status;
            }

            if (data.message) {
              alert(data.message);
            }

            resolve(linkUrl);
          }
        });
      };

      return new Promise(function (resolve, reject) {
        $http.get(window.location.api('games/' + game.igameid + '/download/' + download.audio_stream)).then(
        /**
         * @param {HttpResponse} response
         */
        function (response) {
          processResponse(response.data).then(function (response) {
            return resolve(response);
          }).catch(function (response) {
            return reject(response);
          });
        },
        /**
         * @param {HttpResponse} response
         */
        function (response) {
          processResponse(response.data).then(function (response) {
            return resolve(response);
          }).catch(function (response) {
            return reject(response);
          });
        });
      });
    },
    updateGames: function updateGames(games) {
      // TODO Update games
      return $http.get(window.location.api('games?'));
    }
  };
}]);

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.schedule.favoriteGame.favoriteGameDirective', []).directive('favoriteGame', [function () {
    return {
        restrict: 'E',
        templateUrl: 'components/schedule/favoriteGame/favoriteGameView.html' };
}]);

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(336);

angular.module('app.shared.favoritesCarousel.favoritesCarouselDirective', ['app.shared.favoritesCarousel.favoritesCarouselController']).directive('favoritesCarousel', ['$window', function ($window) {
  "use strict";

  return {
    restrict: 'E',
    templateUrl: 'components/shared/favoritesCarousel/favoritesCarouselView.html',
    controller: 'app.shared.favoritesCarousel.favoritesCarouselController',
    scope: {
      allGamesIcon: '@'
    },
    link: function link(scope, element) {
      var widthChanged = function widthChanged() {
        if (!element.hasClass('ng-hide')) {
          var width = element.width();

          if (width > 1190) {
            scope.favoritesPerSlide = 10;
          } else if (width > 1070) {
            scope.favoritesPerSlide = 9;
          } else if (width > 950) {
            scope.favoritesPerSlide = 8;
          } else if (width > 830) {
            scope.favoritesPerSlide = 7;
          } else if (width > 730) {
            scope.favoritesPerSlide = 6;
          } else if (width > 650) {
            scope.favoritesPerSlide = 5;
          } else if (width > 530) {
            scope.favoritesPerSlide = 4;
          } else if (width > 410) {
            scope.favoritesPerSlide = 3;
          } else {
            scope.favoritesPerSlide = 2;
          }
        }
      };

      angular.element($window).bind('resize', function () {
        scope.$applyAsync(function () {
          widthChanged();
        });
      });

      widthChanged();
    }
  };
}]);

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(14);

angular.module('app.shared.favoritesCarousel.favoritesCarouselController', ['app.favorites.favoritesService']).controller('app.shared.favoritesCarousel.favoritesCarouselController', ['$scope', 'app.favorites.favoritesService', '$filter', '$state', 'PRODUCT', function ($scope, favoritesService, $filter, $state, product) {
  "use strict";

  $scope.title = null;
  $scope.favoritesPerSlide = 5;
  $scope.activeSlide = 0;
  $scope.slides = [{
    src: 'http://a.deviantart.net/avatars/f/u/funnythingsarefunny.jpg?1'
  }, {
    src: 'http://a.deviantart.net/avatars/t/r/tremasy.gif?4'
  }, {
    src: 'https://new1.fjcdn.com/avatars/49117f_614824_big.gif'
  }];
  $scope.allGamesIcon = $scope.allGamesIcon || null;

  var init = function init() {
    buildSlides();
  };

  var buildSlides = function buildSlides(favorites, title) {
    if (!favorites) {
      if (favoritesService.list) {
        favorites = angular.copy(favoritesService.list);
      } else {
        favorites = {};
      }

      favorites.append = [{
        icon_url: '',
        icon_svg: 'fa-plus-circle',
        icon_txt: 'Add Favorite',
        action: function action() {
          $state.go('app.favorites');
        }
      }];
    }

    if (!title && favorites && Array.isArray(favorites.personal) && !favorites.personal.length) {
      if (product.Id === 1) {
        title = 'Add a favorite team, league, or event';
      } else {
        title = 'Add a favorite team or event';
      }
    }
    $scope.title = title || null;

    var slides = [];
    var slide = [];

    var groups = ['public', 'personal', 'append'];
    for (var group_i in groups) {
      if (groups.hasOwnProperty(group_i)) {
        var group = groups[group_i];
        if (Array.isArray(favorites[group])) {
          for (var i in favorites[group]) {
            if (favorites[group].hasOwnProperty(i)) {
              var favorite = favorites[group][i];

              switch (favorite.id) {
                case 10:
                  if ($scope.allGamesIcon) {
                    favorite.icon_url = "";
                    favorite.icon_svg = "fa-star";
                    favorite.icon_txt = "View All";
                  } else {
                    favorite.icon_url = "";
                    favorite.icon_svg = "fa-list-alt";
                    favorite.icon_txt = "All Games";
                  }
              }

              if (slide.length >= $scope.favoritesPerSlide) {
                slides.push(slide);
                slide = [favorite];
              } else {
                slide.push(favorite);
              }
            }
          }
        }
      }
    }

    if (slide.length) {
      slides.push(slide);
    }

    $scope.slides = slides;
  };

  $scope.isSelected = function (favorite) {
    if (favorite.id) {
      return favoritesService.is_selected(favorite.id);
    }
    return false;
  };

  $scope.favoriteClicked = function (favorite) {
    if (typeof favorite.action === 'function') {
      favorite.action();
    } else {
      favoritesService.toggle_selected(favorite.id);
    }
  };

  $scope.clearFavoriteSelection = function () {
    favoritesService.toggle_selected(10);
  };

  $scope.removeFavoriteClicked = function (favorite) {
    buildSlides({
      append: [{
        icon_url: favorite.icon_url
      }, {
        class: 'favorite-keep',
        text: 'Keep',
        action: function action() {
          buildSlides();
        }
      }, {
        class: 'favorite-delete',
        text: 'Delete',
        action: function action() {
          if (favoritesService.is_favorite(favorite.type, favorite.search_id)) {
            favoritesService.toggle(favorite.type, favorite.search_id);
          }
        }
      }]
    }, 'Are you sure you want to delete?');
  };

  // select 'all leagues' on favourites bar
  $scope.selectAllLeagues = function (noBroadcast) {
    if (!favoritesService.is_selected(10)) {
      favoritesService.select(10, noBroadcast);
    }
  };

  $scope.$watch(function () {
    if (Array.isArray(favoritesService.list.personal)) {
      return favoritesService.list.personal.length;
    } else return false;
  }, function () {
    buildSlides();
  });

  $scope.$watch(function () {
    return $scope.favoritesPerSlide;
  }, function () {
    buildSlides();
  });

  // reset to select only 'all games' (formerly all leagues) when this received
  $scope.$on("favorites_reset_all_leagues", function () {
    $scope.selectAllLeagues(true);
  });

  init();
}]);

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(338);

angular.module('app.shared.teamLineup.teamLineupController', ['app.leftPad.leftPadFilter']).controller('app.shared.teamLineup.teamLineupController', ['$scope', '$filter', '$interval', '$rootScope', function ($scope, $filter, $interval, $rootScope) {
  'use strict';

  var init = void 0,
      time_to_start = void 0;

  $scope.game = $scope.game || null;
  $scope.layout = $scope.layout || null;
  $scope.version = $scope.version || 1;
  $scope.countdown = null;
  $scope.countdown_timer = null;

  $scope.$on('enableGameSpoiler', function (event, data) {
    $scope.spoiled = data;
  });

  time_to_start = function time_to_start() {
    var abs_minutes = void 0,
        game_time = void 0,
        hours = void 0,
        minutes = void 0,
        total_minutes = void 0;
    if ($scope.game) {
      game_time = moment($scope.game.dtegametimefixed);
      total_minutes = moment().diff(game_time, 'minutes');
      abs_minutes = Math.abs(total_minutes);
      hours = Math.floor(abs_minutes / 60);
      minutes = Math.floor(abs_minutes - hours * 60);
      if ($scope.game.currently_streaming === true) {
        total_minutes = 0;
        hours = 0;
        minutes = 0;
      }
      return {
        total_minutes: total_minutes,
        hours: hours,
        minutes: minutes
      };
    }
  };
  init = function init() {
    $scope.countdown = $scope.counter();
    if ($scope.countdown_timer) {
      $interval.cancel($scope.countdown_timer);
    }
    return $scope.countdown_timer = $interval(function () {
      return $scope.countdown = $scope.counter();
    }, 15000);
  };
  $scope.get_template_url = function () {
    var base_name = void 0;
    base_name = 'components/shared/teamLineup/views/teamLineupView-';
    if ($scope.layout) {
      return base_name + $scope.layout + '.html';
    } else {
      return base_name + 'default.html';
    }
  };
  $scope.counter = function () {
    var countdown = void 0;
    countdown = {
      tts: time_to_start()
    };
    if (countdown.tts) {
      if (countdown.tts.total_minutes < 0) {
        countdown.message = $filter('left_pad')(countdown.tts.hours, 2) + ' hrs ' + $filter('left_pad')(countdown.tts.minutes, 2) + ' mins';
      } else {
        countdown.message = 'Live Now!';
      }
    }
    return countdown;
  };
  $scope.is_live = function () {
    if ($scope.countdown && $scope.countdown.tts) {
      return $scope.countdown.tts.total_minutes >= 0;
    }
    return false;
  };
  $scope.$on('$destroy', function () {
    if ($scope.countdown_timer) {
      $interval.cancel($scope.countdown_timer);
    }
  });
  return $scope.$watch('$scope.game', function () {
    if ($scope.game) {
      return init();
    }
  });
}]);

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.leftPad.leftPadFilter', []).filter('left_pad', [function () {
  'use strict';

  return function (input, length, char) {
    if (typeof input === "undefined") return "";
    var output = void 0;
    output = input.toString();
    if (!length || isNaN(parseInt(length))) {
      length = 0;
    }
    if (!char) {
      char = '0';
    }
    while (!(output.length >= length)) {
      output = char + input;
    }
    return output;
  };
}]);

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(340);
__webpack_require__(341);
__webpack_require__(345);
__webpack_require__(111);

"use strict";

angular.module('app.pricing', ['app.pricing.pricingController', 'app.purchase.purchaseForm.purchaseFormDirective', 'app.purchase.purchaseForm.teamPurchaseFormDirective', 'app.currentUser.subscriptionStatus.subscriptionStatusDirective']).config(['$stateProvider', 'PRODUCT', function ($stateProvider, product) {

    var priceTemplate = 'components/pricing/pricingView.html';
    if (product.Code != 'htv') {
        priceTemplate = 'assets/templates/' + product.Code + '/pricing/pricingView.html';
    }

    $stateProvider.state('app.pricing', {
        url: '/pricing',
        templateUrl: priceTemplate,
        controller: 'app.pricing.pricingController',
        title: 'Pricing',

        noSidebar: false,
        noTopControls: false
    });
}]);

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1);
__webpack_require__(60);
__webpack_require__(67);
__webpack_require__(75);

"use strict";

angular.module('app.pricing.pricingController', ['app.currentUser', 'app.pricing.plans.plansService', 'app.appMetaService', 'app.productService', 'app.serviceBreakerService']).controller('app.pricing.pricingController', ['$scope', 'currentUser', '$state', 'app.pricing.plans.plansService', 'app.productService', 'PRODUCT', 'app.serviceBreakerService', '$timeout', function ($scope, currentUser, $state, pricingPlans, productService, PRODUCT, serviceBreakerService, $timeout) {
  $scope.currentUser = currentUser;
  $scope.pricingPlans = pricingPlans;
  $scope.displayTeamSubscriptions = productService.useTeamSubscriptions();
  $scope.allAccessPlans = [];
  $scope.teamPlans = [];
  $scope.breakers = serviceBreakerService.breakers;
  $scope.groupedPlans = { commonPlanAttrs: {}, plans: [] };
  var timer = void 0;

  var init = function init() {
    if (!currentUser.is_logged_in()) {
      $state.current.noTopControls = true;
      $state.current.noSidebar = true;
    } else {
      $state.current.noTopControls = false;
      $state.current.noSidebar = false;
    }

    currentUser.get_current_subscriptions('recurly').then(function () {
      currentUser.get_invalid_conversions().then(function () {
        pricingPlans.retrieve(null, { sort: 'active' }).then(function () {
          if (pricingPlans.list) {
            switch (PRODUCT.Code) {
              case 'ahl':
                // sort the plans by price from highest to lowest
                pricingPlans.list.sort(function (a, b) {
                  return a.total_price < b.total_price ? 1 : b.total_price < a.total_price ? -1 : 0;
                });

                _.forEach(pricingPlans.list, function (plan) {
                  var invalidConversion = false;
                  var invalidConversionPlanId = null;

                  // If the user already is subscribed to the plan, don't include it
                  var userSubscribedToPlan = _.filter(currentUser.subscriptions.recurly, function (rs) {
                    return rs.plan_id == plan.id;
                  }).length > 0;

                  // Check against the users subscriptions and invalid conversions
                  var planInvalidConversions = _.filter(currentUser.subscriptions.invalidConversions, function (ics) {
                    return ics.to_psp_id == plan.product_subscription_plan_id;
                  });
                  // Loop through the invalid conversions and check if the user is subscribed to the *from* plans
                  _.forEach(planInvalidConversions, function (ic) {
                    // There is always a from plan 1
                    var fp1Sub = _.filter(currentUser.subscriptions.recurly, function (rs) {
                      return rs.plan.product_subscription_plan_id == ic.from_psp_id_1;
                    });
                    // If user is subscribed to first from...
                    if (fp1Sub.length > 0) {
                      // If there is a second plan, check if the user is subscribed to that plan
                      if (ic.from_psp_id_2) {
                        var fp2Sub = _.filter(currentUser.subscriptions.recurly, function (rs) {
                          return rs.plan.product_subscription_plan_id == ic.from_psp_id_2;
                        });
                        if (fp2Sub.length > 0) {
                          invalidConversion = true;
                          invalidConversionPlanId = ic.to_psp_id;
                        }
                      } else {
                        invalidConversion = true;
                        invalidConversionPlanId = ic.to_psp_id;
                      }
                    }
                  });

                  switch (plan.type) {
                    case 'team_home':
                    case 'team_away':
                      if (_.isEmpty($scope.groupedPlans.commonPlanAttrs)) {
                        $scope.groupedPlans.commonPlanAttrs = {
                          name: 'Home OR Away Single Team Pass',
                          description: plan.description,
                          total_price: plan.total_price,
                          currency_symbol: plan.currency_symbol
                        };
                      }
                      if (!userSubscribedToPlan && !invalidConversion) {
                        $scope.groupedPlans.plans.push(plan);
                      }
                      break;
                    case 'global':
                    case 'league':
                      if (!userSubscribedToPlan && !invalidConversion) {
                        $scope.allAccessPlans.push(plan);
                      } else if (invalidConversion) {
                        // With an invalid conversion, remove the plan in case it has already been added
                        $scope.allAccessPlans = $scope.allAccessPlans.filter(function (obj) {
                          return obj.product_subscription_plan_id !== invalidConversionPlanId;
                        });
                      }
                      break;
                    case 'team_all':
                    case 'team_home':
                    case 'team_away':
                      if (!userSubscribedToPlan && !invalidConversion) {
                        $scope.teamPlans.push(plan);
                      } else if (invalidConversion) {
                        // With an invalid conversion, remove the plan in case it has already been added
                        $scope.teamPlans = $scope.teamPlans.filter(function (obj) {
                          return obj.product_subscription_plan_id !== invalidConversionPlanId;
                        });
                      }
                      break;
                  }
                });

                // The below shouldn't do anything in theory, but without it there were cases where the UI would not update and
                // would show blank rather than the available plans
                $scope.allAccessPlans = _.filter($scope.allAccessPlans, function (plan) {
                  return plan.type === 'global' || plan.type === 'league';
                });
                $scope.teamPlans = _.filter($scope.teamPlans, function (plan) {
                  return plan.type === 'team_all' || plan.type === 'team_home' || plan.type === 'team_away';
                });
                break;
              case 'htv':
                $scope.allAccessPlans = _.filter(pricingPlans.list, function (plan) {
                  return plan.type === 'global';
                });
            }
          }
        });
      });
    });

    checkBreaker();
  };

  var checkBreaker = function checkBreaker() {
    serviceBreakerService.checkRecurly().then(function () {
      timer = $timeout(function () {
        checkBreaker();
      }, 60000);
    });
  };

  $scope.hasSubscription = function () {
    return currentUser.subscriptions.recurly && currentUser.subscriptions.recurly.length > 0;
  };

  $scope.$on('$destroy', function () {
    $timeout.cancel(timer);
  });

  init();
}]);

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(342);
__webpack_require__(108);

"use strict";

angular.module('app.purchase.purchaseForm.purchaseFormDirective', ['app.purchase.purchaseForm.purchaseFormController', 'app.pricing.plans.planCardDirective']).directive('purchaseForm', [function () {
  return {
    restrict: 'EA',
    templateUrl: 'components/purchase/purchaseForm/purchaseFormView.html',
    controller: 'app.purchase.purchaseForm.purchaseFormController',
    scope: {
      showManage: '<?',
      plans: '<',
      currentSubscription: '<?',
      fetchSubscription: '<?',
      fetchPlans: '<?',
      useServiceBreaker: '<?',
      groupedPlans: '<?'
    }
  };
}]);

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(60);
__webpack_require__(1);
__webpack_require__(75);
__webpack_require__(61);
__webpack_require__(67);

"use strict";

angular.module('app.purchase.purchaseForm.purchaseFormController', ['app.pricing.plans.plansService', 'app.currentUser', 'app.serviceBreakerService', 'app.shared.teamService', 'app.productService']).controller('app.purchase.purchaseForm.purchaseFormController', ['$scope', 'app.pricing.plans.plansService', 'currentUser', 'app.serviceBreakerService', 'app.shared.teamService', '$timeout', '$filter', '$rootScope', 'app.productService', 'PRODUCT', function ($scope, pricingPlans, currentUser, serviceBreakerService, teamService, $timeout, $filter, $rootScope, productService, PRODUCT) {
  //$scope variables assigned through directive
  $scope.showManage = $scope.showManage || false;
  $scope.currentSubscription = $scope.currentSubscription || null;
  $scope.plans = $scope.plans || null;
  $scope.fetchPlans = $scope.fetchPlans || false;
  $scope.fetchSubscription = $scope.fetchSubscription || false;
  $scope.useServiceBreaker = $scope.useServiceBreaker || false;
  $scope.groupedPlans = $scope.groupedPlans || { commonPlanAttrs: {}, plans: [] };

  //$scope variables used primarily for html view
  $scope.breakers = serviceBreakerService.breakers;
  $scope.planCards = [];

  var teams = [];
  var currentSubscriptionWatcher = null;
  var plansWatcher = null;
  var timer = void 0;

  var buildPlanCards = function buildPlanCards() {
    var planCards = [];

    sortPlans();

    if ($scope.currentSubscription) {
      if ($scope.currentSubscription.subscription_upgrades && $scope.currentSubscription.state === 'active' && !$scope.currentSubscription.pause_scheduled && !$scope.currentSubscription.is_future || $scope.currentSubscription.state === 'canceled' && productService.isSubscriptionUpgradeableIfCancelled()) {
        var plans = [];
        var upgradeablePlanCodes = $scope.currentSubscription.subscription_upgrades;

        if ($scope.currentSubscription.state === 'active' && upgradeablePlanCodes) {
          _.forEach($scope.plans, function (plan) {
            if (upgradeablePlanCodes.indexOf(plan.plan_code) > -1) {
              plans.push(plan);
            }
          });
        } else if ($scope.currentSubscription.state === 'canceled' && productService.isSubscriptionUpgradeableIfCancelled()) {
          _.forEach($scope.plans, function (plan) {
            if ($scope.currentSubscription.plan.plan_code !== plan.plan_code) {
              plans.push(plan);
            }
          });
        }

        planCards.push({
          cardType: 'upgrade',
          currentSubscription: $scope.currentSubscription,
          planTeams: teams,
          plans: plans
        });
      }

      if ($scope.currentSubscription.state === 'paused') {
        planCards.push({
          currentSubscription: $scope.currentSubscription,
          cardType: 'resume'
        });
      }

      if ($scope.currentSubscription.state === 'canceled') {
        planCards.push({
          currentSubscription: $scope.currentSubscription,
          cardType: 'renew'
        });
      }

      /*if (!$scope.currentSubscription.subscription_upgrades && productService.cannotUpgradeSubscription()) {
        let invalidUpgradeIndex = planCards.findIndex((subscription_plan) => {
          return subscription_plan.cardType === 'cannot-upgrade'
        });
         if (invalidUpgradeIndex <= -1) {
          planCards.push({
            plan: $scope.currentSubscription.plan,
            cardType: 'cannot-upgrade'
          });
        }
      }*/

      if ($scope.currentSubscription.state === 'active' && !$scope.currentSubscription.paused && $scope.currentSubscription.plan_code != "access_pass") {
        planCards.push({
          currentSubscription: $scope.currentSubscription,
          cardType: 'cancel'
        });
      }

      if ($scope.currentSubscription.state === 'active' && !$scope.currentSubscription.paused && !$scope.currentSubscription.is_future && $scope.currentSubscription.can_be_paused && !$scope.currentSubscription.pause_scheduled) {
        planCards.push({
          currentSubscription: $scope.currentSubscription,
          cardType: 'pause'
        });
      }

      if ($scope.currentSubscription.state === 'active' && $scope.currentSubscription.pause_scheduled) {
        planCards.push({
          currentSubscription: $scope.currentSubscription,
          cardType: 'scheduled_pause'
        });
      }
    } else {
      if ($scope.groupedPlans.plans.length) {
        var singlePlans = $scope.plans.filter(function (plan) {
          return !$scope.groupedPlans.plans.some(function (other) {
            return plan.plan_code === other.plan_code;
          });
        });

        _.forEach(singlePlans, function (plan) {
          planCards.push({
            plan: plan,
            cardType: 'singlePlan',
            useTeams: productService.planUsesTeams(plan),
            planTeams: teams
          });
        });

        planCards.push({
          cardType: 'multiPlan',
          useTeams: productService.planUsesTeams($scope.groupedPlans.plans[0]),
          planTeams: teams,
          commonPlanAttrs: $scope.groupedPlans.commonPlanAttrs,
          plans: $scope.groupedPlans.plans
        });
      } else {
        _.forEach($scope.plans, function (plan) {
          planCards.push({
            plan: plan,
            cardType: 'singlePlan',
            useTeams: productService.planUsesTeams(plan),
            planTeams: teams
          });
        });
      }
    }

    if ($scope.showManage && $scope.currentSubscription && $scope.currentSubscription.plan_code != "access_pass") {
      planCards.push({
        cardType: 'manageBilling',
        currentSubscription: $scope.currentSubscription
      });
    }

    $scope.planCards = planCards;
  };

  var sortPlans = function sortPlans() {
    return _.sortBy($scope.plans, ['type', 'unit_price']);
  };

  var init = function init() {
    if (productService.useTeamSubscriptions()) {
      teamService.getTeams().then(function (response) {
        var data = response.data;

        if (data) {
          if (data.error) {
            alert(data.error);
          } else {
            teams = data;
            startWatchers();
          }
        }
      });
    } else {
      startWatchers();
    }

    checkBreaker();
  };

  var checkBreaker = function checkBreaker() {
    if ($scope.useServiceBreaker) {
      serviceBreakerService.checkRecurly().then(function () {
        timer = $timeout(function () {
          checkBreaker();
        }, 60000);
      });
    }
  };

  var startWatchers = function startWatchers() {
    currentSubscriptionWatcher = $scope.$watch(function () {
      return $scope.currentSubscription;
    }, function () {
      var alreadyPrepped = false;

      if ($scope.fetchSubscription && !$scope.currentSubscription) {
        currentUser.get_current_subscriptions('recurly').then(function () {
          buildPlanCards();
          alreadyPrepped = true;
        });
      }

      if (!alreadyPrepped) {
        buildPlanCards();
      } else {
        alreadyPrepped = false;
      }
    });

    plansWatcher = $scope.$watch(function () {
      return $scope.plans;
    }, function () {
      var alreadyPrepped = false;

      if ($scope.fetchPlans && !$scope.plans) {
        pricingPlans.retrieve(null, { sort: 'active' }).then(function () {
          $scope.plans = pricingPlans.list;
          buildPlanCards();
          alreadyPrepped = true;
        });
      }

      if ($scope.plans && !alreadyPrepped) {
        buildPlanCards();
      }

      if (alreadyPrepped) {
        alreadyPrepped = false;
      }
    });
  };

  $scope.$on('$destroy', function () {
    $timeout.cancel(timer);
  });

  init();
}]);

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1);
__webpack_require__(10);
__webpack_require__(109);
__webpack_require__(67);

angular.module('app.pricing.plans.planCardController', ['app.currentUser', 'app.appMetaService', 'app.purchase.purchasePlanService', 'app.productService']).controller('app.pricing.plans.planCardController', ['$scope', '$window', 'currentUser', 'appMetaService', 'app.purchase.purchasePlanService', 'app.productService', '$state', 'PRODUCT', function ($scope, $window, currentUser, appMeta, purchasePlan, productService, $state, PRODUCT) {
  "use strict";
  //directive variables

  $scope.currentSubscription = $scope.currentSubscription || null;
  $scope.cardType = $scope.cardType || null;
  $scope.plans = $scope.plans || [];
  $scope.commonPlanAttrs = $scope.commonPlanAttrs || null;
  $scope.planTeams = $scope.planTeams || null;
  $scope.useTeams = $scope.useTeams || null;
  $scope.plan = $scope.plan || null;

  //scope variables used for subscription and team selections
  $scope.planTeam = { team: null };
  $scope.Subscription = { plan: $scope.plan ? $scope.plan : $scope.plans ? $scope.plans[0] : null };

  //scope variables for use of service functions and variable in html view
  $scope.appMeta = appMeta;
  $scope.showAuthButtons = false;
  $scope.subscriptionPauseAllowed = productService.isSubscriptionPauseEnabled();
  $scope.userLoggedIn = currentUser.is_logged_in();
  $scope.planGroups = {};
  $scope.productService = productService;

  var init = function init() {
    switch ($scope.cardType) {
      case 'upgrade':
        // If the user has more than one subscription, we don't allow upgrades on the single day plan
        if ($scope.currentSubscription.plan_code === "ahl-single-day-all-access" && currentUser.subscriptions.recurly.length > 1) {
          return;
        }
        // If the subscription is not active, upgrades are not available for it
        if (!$scope.currentSubscription.is_active) {
          return;
        }

        _.forEach($scope.plans, function (plan) {
          switch (PRODUCT.Code) {
            case 'ahl':
              switch (plan.type) {
                case 'league':
                case 'global':
                  if (!$scope.planGroups.hasOwnProperty('unlimitedAccess')) {
                    $scope.planGroups.unlimitedAccess = { title: 'Unlimited Access', plans: [], sortOrder: 1, hasTeams: false };
                  }

                  $scope.planGroups.unlimitedAccess.plans.push(plan);
                  break;
                case 'team_all':
                case 'team_home':
                case 'team_away':
                  if (!$scope.planGroups.hasOwnProperty('teamAccess')) {
                    $scope.planGroups.teamAccess = { title: 'Single Team Access', plans: [], sortOrder: 2, hasTeams: true };
                  }

                  $scope.planGroups.teamAccess.plans.push(plan);
                  break;
              }
              break;
            case 'htv':
              switch (plan.type) {
                case 'global':
                  if (!$scope.planGroups.hasOwnProperty('unlimitedAccess')) {
                    $scope.planGroups.unlimitedAccess = { title: 'Unlimited Access', plans: [], sortOrder: 1, hasTeams: false };
                  }

                  $scope.planGroups.unlimitedAccess.plans.push(plan);
                  break;
              }
              break;
          }
        });

        $scope.planGroups = _.values($scope.planGroups);
        _.sortBy($scope.planGroups, ['sortOrder']);

        if (Array.isArray($scope.currentSubscription.teams) && $scope.planTeams) {
          _.forEach($scope.planTeams, function (team) {
            if (team.iteamid === $scope.currentSubscription.teams[0]) {
              $scope.planTeam.team = team;
              return;
            }
          });
        }
        break;
    }
  };

  //function takes care of assigning params needed for purchasing subscriptions and displaying necessary alert messages for missing params
  var getRedirectParams = function getRedirectParams(plan) {
    var params = { plan: plan ? plan : $scope.Subscription.plan };

    if (!params.plan) {
      alert('A subscription plan must be selected for purchase.');
      return null;
    }

    if (productService.planUsesTeams(params.plan)) {
      if (!$scope.planTeam.team) {
        alert('A team must be selected if purchasing a team subscription.');
        return null;
      } else {
        params.team = $scope.planTeam.team;
      }
    }

    return params;
  };

  $scope.upgradeOrSubscribeText = function () {
    if ($scope.currentSubscription && $scope.currentSubscription.state === 'canceled') {
      return 'Subscribe';
    }

    return 'Upgrade';
  };

  $scope.cancel = function () {
    var cancelSubscription = confirm("You are about to cancel your " + $scope.currentSubscription.plan.name + " subscription. Are you sure you want to disable your auto-renewal?");
    if (cancelSubscription === true) {
      purchasePlan.update_subscription('cancel', null, $scope.currentSubscription).then(function (response) {
        $state.reload();
      });
    }
  };

  $scope.pause = function () {
    var suspendSubscription = confirm("You are about to pause your " + $scope.currentSubscription.plan.name + " subscription. Are you sure you want to pause?");
    if (suspendSubscription === true) {
      purchasePlan.update_subscription('pause', null, $scope.currentSubscription).then(function (response) {
        var data = response.data;

        if (data.error) {
          alert(data.error);
        } else {
          $state.reload();
        }
      });
    }
  };

  $scope.cancelPause = function () {
    var cancelPause = confirm("You are about to cancel the schedule pause of your " + $scope.currentSubscription.plan.name + " subscription. Are you sure you want to continue?");
    if (cancelPause === true) {
      purchasePlan.update_subscription('cancel_pause', null, $scope.currentSubscription).then(function (response) {
        var data = response.data;
        $state.reload();

        if (data.error) {
          alert(data.error);
        }
      });
    }
  };

  $scope.resume = function () {
    var resumeSubscription = confirm("You are about to resume your " + $scope.currentSubscription.plan.name + " subscription. Do you wish to continue?");
    if (resumeSubscription === true) {
      purchasePlan.update_subscription('resume', null, $scope.currentSubscription).then(function () {
        $state.reload();
      });
    }
  };

  $scope.renew = function () {
    var renewSubscription = confirm("You are about to re-activate your " + $scope.currentSubscription.plan.name + " subscription. Do you wish to continue?");
    if (renewSubscription === true) {
      purchasePlan.activate_subscription($scope.currentSubscription.uuid).then(function () {
        $state.reload();
      });;
    }
  };

  $scope.subscribe = function (plan, upgrade) {
    if (currentUser.is_logged_in()) {
      var params = getRedirectParams(plan);

      if (params && upgrade) {
        params.upgrade = true;
        params.uuid = $scope.currentSubscription.uuid;
      }

      var redirect_info = {
        redirect_url: 'app.purchase.billingInfo',
        redirect_params: params
      };

      if (params) {
        if (!currentUser.checkUserInfo(redirect_info)) {
          $state.go('app.purchase.billingInfo', redirect_info.redirect_params);
        }
      }
    } else {
      $scope.showAuthButtons = true;
    }
  };

  $scope.upgrade = function (plan, uuid) {
    if (currentUser.is_logged_in()) {
      var params = getRedirectParams(plan);

      params.upgrade = true;
      params.uuid = $scope.currentSubscription.uuid;

      var redirect_info = {
        redirect_url: 'app.purchase.billingInfo',
        redirect_params: params
      };

      if (params) {
        if (!currentUser.checkUserInfo(redirect_info)) {
          $state.go('app.purchase.billingInfo', redirect_info.redirect_params);
        }
      }
    } else {
      $scope.showAuthButtons = true;
    }
  };

  $scope.login = function (plan) {
    var params = getRedirectParams(plan);

    if (params) {
      $state.go('app.login', { redirect: 'app.purchase.billingInfo', redirectParams: params });
    }
  };

  $scope.register = function (plan) {
    var params = getRedirectParams(plan);

    if (params) {
      $state.go('app.registration.new', {
        plan_code: params.plan.plan_code,
        team: params.team ? params.team.iteamid : null
      });
    }
  };

  //AHL Promotion
  $scope.showPromotion = currentUser.showPromotion();

  //AHL Black Friday
  $scope.showBlackFriday = currentUser.showBlackFriday();

  //AHL MidSeason
  $scope.showMidSeason = currentUser.showMidSeason();

  //AHL Final Price Drop
  $scope.showFinalPriceDrop = currentUser.showFinalPriceDrop();

  //AHL Playoffs 2023
  $scope.showPlayoffs = currentUser.showPlayoffs();

  init();
}]);

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.shared.searchDropdown.searchDropdownController', []).controller('app.shared.searchDropdown.searchDropdownController', ['$scope', function ($scope) {
  $scope.displayAttr = $scope.displayAttr || null;
  $scope.selectedItems = $scope.selectedItems || null;
  $scope.allItems = $scope.allItems || null;
  $scope.readOnly = $scope.readOnly || null;
  $scope.idType = $scope.idType || null;
  $scope.selectAllOption = $scope.selectAllOption || null;
  $scope.grouping = $scope.grouping || null;
  $scope.groupingLabel = $scope.groupingLabel || null;
  $scope.sortDirection = $scope.sortDirection || null;
  $scope.sortBy = $scope.sortBy || null;
  $scope.singleOption = $scope.singleOption || false;

  $scope.filteredItems = [];
  $scope.search = {};

  var groupNames = [];

  $scope.selectItem = function (obj) {
    if (obj[$scope.idType] === 'all') {
      _.forEach($scope.allItems, function (item) {
        updateSelectedItems(item);
      });
    } else {
      updateSelectedItems(obj);
    }
  };

  $scope.selectGroup = function (group) {
    groupNames.indexOf(group) > -1 ? groupNames.splice(groupNames.indexOf(group), 1) : groupNames.push(group);

    var group_index = groupNames.indexOf(group);

    _.forEach($scope.allItems, function (item) {
      if (item[$scope.groupingLabel] === group) {
        var selectedId = Array.isArray($scope.selectedItems) ? $scope.selectedItems.find(function (id) {
          return id === item[$scope.idType];
        }) : undefined;

        if (group_index > -1) {
          if (_.isUndefined(selectedId)) {
            $scope.addItem({ item: item });
          }
        } else {
          if (!_.isUndefined(selectedId)) {
            $scope.removeItem({ item: item });
          }
        }
      }
    });
  };

  $scope.isGroupSelected = function (group) {
    return groupNames.indexOf(group) > -1;
  };

  $scope.isItemSelected = function (item) {
    if (typeof $scope.selectedItems === 'undefined') return false;

    var tmpItem = void 0;

    if (Array.isArray($scope.selectedItems)) {
      tmpItem = $scope.selectedItems.find(function (id) {
        return id == item[$scope.idType];
      });

      if (tmpItem == 0) {
        return true;
      }

      return typeof $scope.selectedItems !== 'undefined' || tmpItem ? tmpItem : false;
    }

    return false;
  };

  $scope.commaDelimitedSelected = function () {
    if ($scope.grouping && (!Array.isArray($scope.selectedItems) || !$scope.selectedItems.length)) {
      groupNames = [];
    }

    if ($scope.singleOption) {
      return Array.isArray($scope.selectedItems) && $scope.selectedItems.length ? $scope.selectedItems[0][$scope.displayAttr] : "Select";
    }

    return Array.isArray($scope.selectedItems) && $scope.selectedItems.length ? $scope.selectedItems.length + ' Selected' : "Select";
  };

  var updateSelectedItems = function updateSelectedItems(obj) {
    var selectedId = void 0;

    if (!Array.isArray($scope.selectedItems)) {
      $scope.selectedItems = [];
    }

    selectedId = $scope.selectedItems.find(function (id) {
      return id === obj[$scope.idType];
    });

    if (!selectedId) {
      if ($scope.singleOption && $scope.selectedItems.length) {
        console.log('hit1');
        $scope.selectedItems = [];
      }

      $scope.addItem({ item: obj });
    } else {
      $scope.removeItem({ item: obj });
      if ($scope.singleOption && $scope.selectedItems.length) {
        console.log('hit2');
        $scope.selectedItems = [];
      }

      if ($scope.grouping) {
        var group_index = groupNames.indexOf(obj[$scope.groupingLabel]);

        if (group_index > -1) {
          groupNames.splice(group_index, 1);
        }
      }
    }
  };

  $scope.toggled = function (open) {
    if (typeof $scope.callBack === "function") {
      $scope.callBack();
    }

    /*if(!open && $scope.search.query) {
      console.log($scope.search.query);
      $scope.search.query = '';
    }*/
  };

  var orgData = function orgData() {
    var attribute = $scope.grouping ? $scope.groupingLabel : $scope.displayAttr;

    $scope.allItems.sort(function (a, b) {
      var nameA = Number.isInteger(a[attribute]) ? a[attribute] : a[attribute].toUpperCase();
      var nameB = Number.isInteger(b[attribute]) ? b[attribute] : b[attribute].toUpperCase();

      if (nameA === nameB) {
        if ($scope.grouping) {
          if ($scope.sortBy) {
            nameA = Number.isInteger(a[$scope.sortBy]) ? a[$scope.sortBy] : a[$scope.sortBy].toUpperCase();
            nameB = Number.isInteger(b[$scope.sortBy]) ? b[$scope.sortBy] : b[$scope.sortBy].toUpperCase();
          } else {
            nameA = Number.isInteger(a[$scope.displayAttr]) ? a[$scope.displayAttr] : a[$scope.displayAttr].toUpperCase();
            nameB = Number.isInteger(b[$scope.displayAttr]) ? b[$scope.displayAttr] : b[$scope.displayAttr].toUpperCase();
          }

          if (nameA === nameB) {
            return 0;
          }

          return nameA < nameB ? -1 : 1;
        }

        return 0;
      }

      if ($scope.sortDirection === 'desc') {
        return nameA < nameB ? 1 : -1;
      } else {
        return nameA < nameB ? -1 : 1;
      }
    });
  };

  $scope.$watch(function () {
    return Array.isArray($scope.allItems) && $scope.allItems.length;
  }, function () {
    if (Array.isArray($scope.allItems) && $scope.allItems.length) {
      if ($scope.sortDirection) {
        orgData();
      }
    }
  });
}]);

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(346);
__webpack_require__(108);

"use strict";

angular.module('app.purchase.purchaseForm.teamPurchaseFormDirective', ['app.purchase.teamSubscriptionPurchaseForm.teamSubscriptionFormController', 'app.pricing.plans.planCardDirective']).directive('teamPurchaseForm', [function () {
  return {
    restrict: 'EA',
    templateUrl: 'components/purchase/teamSubscriptionPurchaseForm/teamSubscriptionPurchaseView.html',
    controller: 'app.purchase.teamSubscriptionPurchaseForm.teamSubscriptionFormController',
    scope: {
      showManage: '<?',
      plans: '<',
      currentSubscription: '<?',
      fetchSubscription: '<?',
      fetchPlans: '<?',
      useServiceBreaker: '<?'
    }
  };
}]);

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(60);
__webpack_require__(1);
__webpack_require__(75);
__webpack_require__(61);
__webpack_require__(67);

"use strict";

angular.module('app.purchase.teamSubscriptionPurchaseForm.teamSubscriptionFormController', ['app.pricing.plans.plansService', 'app.currentUser', 'app.serviceBreakerService', 'app.shared.teamService', 'app.productService']).controller('app.purchase.teamSubscriptionPurchaseForm.teamSubscriptionFormController', ['$scope', 'app.pricing.plans.plansService', 'currentUser', 'app.serviceBreakerService', 'app.shared.teamService', '$timeout', '$filter', '$rootScope', 'app.productService', 'PRODUCT', function ($scope, pricingPlans, currentUser, serviceBreakerService, teamService, $timeout, $filter, $rootScope, productService, PRODUCT) {
  //$scope variables assigned through directive
  $scope.showManage = $scope.showManage || false;
  $scope.currentSubscription = $scope.currentSubscription || null;
  $scope.plans = $scope.plans || null;
  $scope.fetchPlans = $scope.fetchPlans || false;
  $scope.fetchSubscription = $scope.fetchSubscription || false;
  $scope.useServiceBreaker = $scope.useServiceBreaker || false;

  //$scope variables used primarily for html view
  $scope.breakers = serviceBreakerService.breakers;
  $scope.planCards = [];

  var teams = [];
  var currentSubscriptionWatcher = null;
  var plansWatcher = null;
  var timer = void 0;

  var buildPlanCards = function buildPlanCards() {
    var planCards = [];

    sortPlans();

    if ($scope.currentSubscription) {
      if ($scope.currentSubscription.subscription_upgrades && $scope.currentSubscription.state === 'active' || $scope.currentSubscription.state === 'canceled' && productService.isSubscriptionUpgradeableIfCancelled()) {

        planCards.push({
          cardType: 'upgrade',
          currentSubscription: $scope.currentSubscription,
          planTeams: teams,
          planGroups: getPlanGroups()
        });
      }

      if ($scope.currentSubscription.state === 'active' && $scope.currentSubscription.is_suspended) {
        planCards.push({
          plan: $scope.currentSubscription.plan,
          cardType: 'resume'
        });
      }

      if ($scope.currentSubscription.state === 'canceled') {
        planCards.push({
          plan: $scope.currentSubscription.plan,
          cardType: 'renew'
        });
      }

      /*if (!$scope.currentSubscription.subscription_upgrades && productService.cannotUpgradeSubscription()) {
        let invalidUpgradeIndex = planCards.findIndex((subscription_plan) => {
          return subscription_plan.cardType === 'cannot-upgrade'
        });
         if (invalidUpgradeIndex <= -1) {
          planCards.push({
            plan: $scope.currentSubscription.plan,
            cardType: 'cannot-upgrade'
          });
        }
      }*/

      if ($scope.currentSubscription.state === 'active' && !$scope.currentSubscription.is_suspended) {
        planCards.push({
          plan: $scope.currentSubscription.plan,
          cardType: 'cancel'
        });
      }

      if ($scope.currentSubscription.state === 'active' && !$scope.currentSubscription.is_suspended && $scope.currentSubscription.is_suspendable) {
        planCards.push({
          plan: $scope.currentSubscription.plan,
          cardType: 'suspend'
        });
      }
    } else {
      var multiPlans = [];

      _.forEach($scope.plans, function (plan) {
        switch (PRODUCT.Code) {
          case 'ahl':
            switch (plan.type) {
              case 'league':
              case 'global':
              case 'team_all':
                planCards.push({
                  plan: plan,
                  cardType: 'singlePlan',
                  useTeams: planUsesTeams(plan),
                  planTeams: teams
                });
                break;
              case 'team_home':
              case 'team_away':
                var planObj = angular.copy(plan);
                planObj.multiPlanType = 'teams';
                planObj.commonPlanAttrs = {
                  name: 'Home OR Away Single Team Pass',
                  description: planObj.description,
                  total_price: planObj.total_price,
                  currency_symbol: planObj.currency_symbol
                };

                multiPlans.push(planObj);
                break;
            }
            break;
          case 'htv':
            switch (plan.type) {
              case 'global':
                planCards.push({
                  plan: plan,
                  cardType: 'singlePlan',
                  useTeams: planUsesTeams(plan),
                  planTeams: teams
                });
                break;
            }
            break;
        }
      });

      if (multiPlans.length) {
        multiPlans = _.groupBy(multiPlans, 'multiPlanType');

        _.forEach(multiPlans, function (multiPlan) {
          var plans = [];

          _.forEach(multiPlan, function (plan) {
            plans.push(plan);
          });

          planCards.push({
            cardType: 'multiPlan',
            useTeams: planUsesTeams(multiPlan[0]),
            planTeams: teams,
            commonPlanAttrs: multiPlan[0].commonPlanAttrs,
            plans: plans
          });
        });
      }
    }

    if ($scope.showManage && $scope.currentSubscription) {
      planCards.push({
        cardType: 'manageBilling',
        currentSubscription: $scope.currentSubscription
      });
    }

    $scope.planCards = planCards;
  };

  var sortPlans = function sortPlans() {
    return _.sortBy($scope.plans, ['type', 'unit_price']);
  };

  var planUsesTeams = function planUsesTeams(plan) {
    switch (PRODUCT.Code) {
      case 'ahl':
        switch (plan.type) {
          case 'league':
          case 'global':
          default:
            return false;
          case 'team_all':
          case 'team_home':
          case 'team_away':
            return true;
        }
        break;
      case 'htv':
        switch (plan.type) {
          case 'global':
          default:
            return false;
        }
    }
  };

  var getPlanGroups = function getPlanGroups() {
    var planGroups = {
      unlimitedAccess: { title: null, plans: [], sortOrder: 0, hasTeams: false },
      teamAccess: { title: null, plans: [], sortOrder: 0, hasTeams: false }
    };
    var plans = [];
    var upgradeablePlanCodes = $scope.currentSubscription.subscription_upgrades;

    if ($scope.currentSubscription.state === 'active' && upgradeablePlanCodes) {
      _.forEach($scope.plans, function (plan) {
        if (upgradeablePlanCodes.indexOf(plan.plan_code) > -1) {
          plans.push(plan);
        }
      });
    } else if ($scope.currentSubscription.state === 'canceled' && productService.isSubscriptionUpgradeableIfCancelled()) {
      _.forEach($scope.plans, function (plan) {
        if ($scope.currentSubscription.plan.plan_code !== plan.plan_code) {
          plans.push(plan);
        }
      });
    } else {
      plans = $scope.plans;
    }

    _.forEach(plans, function (plan) {
      switch (PRODUCT.Code) {
        case 'ahl':
          switch (plan.type) {
            case 'league':
            case 'global':
              if (!planGroups.unlimitedAccess.title) {
                planGroups.unlimitedAccess.title = 'Unlimited Access';
              }

              if (!planGroups.unlimitedAccess.sortOrder) {
                planGroups.unlimitedAccess.sortOrder = 1;
              }

              planGroups.unlimitedAccess.plans.push(plan);
              break;
            case 'team_all':
            case 'team_home':
            case 'team_away':
              if (!planGroups.teamAccess.title) {
                planGroups.teamAccess.title = 'Single Team Access';
              }

              if (!planGroups.teamAccess.sortOrder) {
                planGroups.teamAccess.sortOrder = 2;
              }

              if (!planGroups.teamAccess.hasTeams) {
                planGroups.teamAccess.hasTeams = true;
              }

              planGroups.teamAccess.plans.push(plan);
              break;
          }
          break;
        case 'htv':
          switch (plan.type) {
            case 'global':
              if (!planGroups.unlimitedAccess.title) {
                planGroups.unlimitedAccess.title = 'Unlimited Access';
              }

              if (!planGroups.unlimitedAccess.sortOrder) {
                planGroups.unlimitedAccess.sortOrder = 1;
              }

              planGroups.unlimitedAccess.plans.push(plan);
              break;
          }
          break;
      }
    });

    planGroups = _.values(planGroups);

    console.log(planGroups);

    return planGroups;
  };

  var init = function init() {
    if (productService.useTeamSubscriptions()) {
      teamService.getTeams().then(function (response) {
        var data = response.data;

        if (data) {
          if (data.error) {
            alert(data.error);
          } else {
            teams = data;
            startWatchers();
          }
        }
      });
    } else {
      startWatchers();
    }

    checkBreaker();
  };

  var checkBreaker = function checkBreaker() {
    if ($scope.useServiceBreaker) {
      serviceBreakerService.checkRecurly().then(function () {
        timer = $timeout(function () {
          checkBreaker();
        }, 60000);
      });
    }
  };

  var startWatchers = function startWatchers() {
    currentSubscriptionWatcher = $scope.$watch(function () {
      return $scope.currentSubscription;
    }, function () {
      var alreadyPrepped = false;

      if ($scope.fetchSubscription && !$scope.currentSubscription) {
        currentUser.get_current_subscriptions('recurly').then(function () {
          $scope.currentSubscription = currentUser.subscriptions.recurly;
          buildPlanCards();
          alreadyPrepped = true;
        });
      }

      if (!alreadyPrepped) {
        buildPlanCards();
      } else {
        alreadyPrepped = false;
      }
    });

    plansWatcher = $scope.$watch(function () {
      return $scope.plans;
    }, function () {
      var alreadyPrepped = false;

      if ($scope.fetchPlans && !$scope.plans) {
        pricingPlans.retrieve(null, { sort: 'active' }).then(function () {
          $scope.plans = pricingPlans.list;
          buildPlanCards();
          alreadyPrepped = true;
        });
      }

      if ($scope.plans && !alreadyPrepped) {
        buildPlanCards();
      }

      if (alreadyPrepped) {
        alreadyPrepped = false;
      }
    });
  };

  $scope.$on('$destroy', function () {
    $timeout.cancel(timer);
  });

  init();
}]);

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1);
__webpack_require__(10);

angular.module('app.currentUser.subscriptionStatus.subscriptionStatusController', ['app.currentUser', 'app.appMetaService']).controller('app.currentUser.subscriptionStatus.subscriptionStatusController', ['$scope', 'currentUser', 'serverTime', 'appMetaService', function ($scope, currentUser, serverTime, appMetaService) {
  "use strict";

  $scope.current_user = currentUser;
  $scope.hideProgress = $scope.hideProgress || false;
  $scope.hideIfNotExists = $scope.hideIfNotExists || false;
  $scope.activeStatus = null;
  $scope.metaService = appMetaService;
  $scope.subscription = $scope.subscription;

  var getSubscription = function getSubscription() {
    var subscription = $scope.subscription;

    processSubscription(subscription);

    return subscription;
  };

  var init = function init() {
    getSubscription();
  };

  var processSubscription = function processSubscription(subscription) {
    if (subscription) {
      var period_start = moment(subscription.current_period_started_at);
      var period_end = moment(subscription.current_period_end_date);
      var period_start_unix = period_start.unix();
      var period_end_unix = period_end.unix();
      var period_length = period_end_unix - period_start_unix;
      var current_used_time = serverTime.unix - period_start_unix;
      var remaining_time = period_length - current_used_time;
      var expires_at = moment(subscription.expires_at);
      var auto_resumes = moment(subscription.pause_auto_resumes);
      var activates_at = moment(subscription.activated_at);

      var displayName = "";
      if (subscription.plan) {
        displayName = subscription.plan.name;
      };

      if (subscription.teams && subscription.teams.length > 0) {
        var teamNameArray = subscription.teams.map(function (t) {
          return t.TeamName;
        });
        var subTeams = teamNameArray.join(", ");
        displayName += " " + subTeams;
      }

      $scope.subscriptionState = currentUser.subscriptionStatus(subscription);
      $scope.remaining_percent = Math.floor(remaining_time / period_length * 100);
      switch ($scope.subscriptionState) {
        case 'active':
          var paused = subscription.paused === true;
          if (subscription.pause_scheduled) {
            $scope.expiry_message = 'Your ' + displayName + ' subscription will pause ' + period_end.format('M/D/YYYY') + ' by ' + period_end.format('h:mm a');
          } else if (subscription.is_future) {
            $scope.expiry_message = 'Your ' + displayName + ' subscription will start ' + activates_at.format('M/D/YYYY');
          } else if (subscription.plan.is_renewable) {
            if (paused) {
              $scope.expiry_message = 'Your ' + displayName + ' subscription will renew ' + auto_resumes.format('M/D/YYYY');
            } else {
              $scope.expiry_message = 'Your ' + displayName + ' subscription will renew ' + period_end.format('M/D/YYYY') + ' before ' + period_end.format('h:mm a');
            }
            $scope.activeStatus = paused ? 'Paused' : 'Auto-renew Active';
          } else {
            $scope.expiry_message = 'Your ' + displayName + ' subscription will end ' + period_end.format('M/D/YYYY') + ' by ' + period_end.format('h:mm a');
            $scope.activeStatus = paused ? 'Paused' : 'Active';
          }
          $scope.remaining_class = paused ? 'warning' : 'success';
          break;
        case 'canceled':
          if (subscription.plan.is_renewable) {
            $scope.expiry_message = 'Your auto renew policy has been canceled but your ' + displayName + ' subscription will not expire until ' + period_end.format('M/D/YYYY') + ' by ' + period_end.format('h:mm a') + '. Re-activate your auto renew policy to extend your ' + appMetaService.longName + ' subscription';
            $scope.activeStatus = 'Auto-renew Inactive';
          } else {
            $scope.expiry_message = '';
            $scope.activeStatus = 'Subscription Inactive';
          }
          $scope.remaining_class = 'danger';
          break;
        case 'expired':
          $scope.expiry_message = 'Your ' + displayName + ' expired on ' + expires_at.format('M/D/YYYY');

          $scope.remaining_class = 'danger';
          $scope.remaining_percent = 0;
          break;
        case 'billing_error':
          $scope.price_message = subscription.plan.currency_symbol + subscription.plan.unit_price;
          $scope.remaining_class = 'danger';
          $scope.remaining_percent = 0;
          break;
        case 'paused':
          $scope.expiry_message = 'Your paused ' + displayName + ' subscription will resume on ' + auto_resumes.format('M/D/YYYY');
          break;
        case 'future':
          $scope.expiry_message = 'Your ' + displayName + ' subscription will start on ' + activates_at.format('M/D/YYYY');
          break;
        default:
          $scope.remaining_class = 'info';
          break;
      }
    } else {
      $scope.remaining_percent = 0;
      $scope.remaining_class = 'info';
      $scope.expiry_message = null;
    }
  };

  $scope.isActive = function () {
    var subscription = getSubscription();

    if (subscription) {
      switch (subscription.state) {
        case 'active':
        case 'canceled':
          return true;
      }
    }
    return false;
  };

  $scope.hasSubscription = function () {
    return currentUser.subscriptions.recurly.length > 0;
  };

  init();

  $scope.$on('current_plan_retrieved', function () {
    init();
  });
}]);

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(349);
__webpack_require__(350);
__webpack_require__(351);
__webpack_require__(353);

'use strict';

angular.module('app.information', ['app.information.about', 'app.information.terms', 'app.information.faq', 'app.information.privacy_page']).config(['$stateProvider', function ($stateProvider) {
  return $stateProvider.state('app.information', {
    template: '<div class="information" ui-view></div>'
  });
}]);

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.information.about', []).config(['$stateProvider', 'PRODUCT', function ($stateProvider, product) {
  return $stateProvider.state('app.information.about', {
    url: '/information/about',
    templateUrl: 'assets/templates/' + product.Code + '/information/aboutView.html',
    title: 'About'
  });
}]);

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.information.terms', []).config(['$stateProvider', 'PRODUCT', function ($stateProvider, product) {
    return $stateProvider.state('app.information.terms', {
        url: '/information/terms?:section',
        templateUrl: 'assets/templates/' + product.Code + '/information/termsView.html',
        controller: ['$scope', '$location', '$stateParams', '$anchorScroll', '$transitions', function ($scope, $location, $stateParams, $anchorScroll, $transitions) {
            $anchorScroll($stateParams.section);
            $transitions.onSuccess({}, function () {
                if ($stateParams.section) {
                    $anchorScroll($stateParams.section);
                }
            });
        }],
        title: 'Terms of Service'
    });
}]);

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(352);

angular.module('app.information.faq', ['app.information.faqService']).config(['$stateProvider', 'PRODUCT', function ($stateProvider, product) {

    var logTemplate = 'components/information/faq/faqView.html';
    if (product.Code != 'htv') {
        logTemplate = 'assets/templates/' + product.Code + '/information/faqView.html';
    }

    $stateProvider.state('app.information.faq', {
        url: '/information/faq',
        templateUrl: logTemplate,
        controller: ['$scope', 'app.information.faqService', function ($scope, faqService) {
            return $scope.questions = faqService.questions;
        }],
        title: 'FAQ'
    });
}]);

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.information.faqService', []).service('app.information.faqService', ['PRODUCT', function (product) {
  var service = { questions: [] };
  switch (product.Code) {
    case 'ahl':
      service.questions = [];
      break;
    case 'htv':
      service.questions = [{
        question: 'Why are some streams great while others struggle to stay live?',
        answer: ['In the HockeyTV system, the quality of video delivered to you depends on two main factors: the available bandwidth speed at the venue and your bandwidth where you are watching the game.', 'Through our partnership with the worlds leading content delivery provider, Akamai, HockeyTV can ensure the best quality delivery is reaching you.  This does not always mean that the feed will stream perfectly-- if there are connection or bandwidth issues either at the venue or on your local connection, you may experience some difficulty watching the game.', 'HockeyTV works with all of our partners (national governing bodies, conferences, leagues, teams, and tournaments) to ensure they are aware of any issues that arise and they are addressed.']
      }, {
        question: 'Why do you not stream in High Definition?',
        answer: ['High Definition broadcasts are supported on the HockeyTV Platform and can be seen in crystal clear quality without buffering or streaming issues.  This is accomplished through our partnership with Akamai and use of their HD network.  HockeyTV has delivered quite a few streams in High Definition with incredible feedback from our users.', 'Unfortunately, due to bandwidth limitations at the venues (and with our world-wide audience), as well as the higher cost of acquiring a good quality High Definition camera that can handle the high speed of a hockey game as well as the environmental factors (like temperature and low lighting) in a hockey rink, most teams have opted for Standard Definition broadcasts.', 'We think that High Definition is coming as the technology behind it becomes less expensive and the implementation of broadband networks around the world increases.']
      }, {
        question: 'Do you limit the quality teams can deliver?',
        answer: ['Absolutely not!  HockeyTV works with our teams to set up their webcasts to be of the highest quality that their venue can handle.  This takes in to account the ability to deliver multiple simultaneous streams (called adaptive bitrate) so that users at home are not forced to try and watch a high quality stream when their personal internet connection is not fast enough.', 'We do use our expertise to tweak the streaming settings to ensure the highest quality stream the venues bandwidth can handle will be sent over the internet.']
      }, {
        question: 'Why are some productions better than others?',
        answer: ['Every production is up to the individual team doing the game.  Some teams have multiple cameras, graphics, and instant replay while others may have a single camera at center ice following the play.', 'HockeyTV monitors each and every game on our platform for overall stream and production quality.  We often send feedback directly to the team so they can improve their productions.  Additionally, we share customer feedback directly with the teams so that they can use that information as well.']
      }, {
        question: 'How come some games have audio talent and others do not?',
        answer: ['Much like the video production, each team owns their own broadcast.  While some choose to add play-by-play and color commentary, others do not.  Each team makes their own decisions on the quality of the production they want to stream over the internet.']
      }, {
        question: 'Is there any quality control in place?',
        answer: ['Human beings watch and listen to all of our live broadcasts for any issues that arise.  From internet bandwidth issues, to camera issues (like icons on the screen), to audio talent issues (like a microphone where a battery has died), we report and take action on each and every issue.  Often, before the teams themselves even know they have a problem.', 'The moment an issue arises, somebody from one of our multiple Broadcast Operations Centers works to contact the team producing the event and advise them of the issue.']
      }, {
        question: 'What about customer support.  Who can I contact if there is an issue?',
        answer: ['HockeyTV has a fully staffed Broadcast Operations Center during any live event.  Customers who experience issues can submit a Support Request (often called a ticket).  Our average response time is less than three minutes and will come via email.', 'When we are not broadcasting live, all tickets are responded to in less than one business day.']
      }, {
        question: 'I want to broadcast my games on HockeyTV.  Is there a cost?',
        answer: ['HockeyTV has a variety of business models that can be built in to your contract.  From pay-per-view to free-for view we work with each of our partners to server their unique business needs.  Under most agreements, there are no out-of-pocket expenses to partner with HockeyTV and take advantage of all the features of our platform.']
      }, {
        question: 'What if I want to edit or download a game?',
        answer: ['Each of our partners has access to a wide array of tools on the HockeyTV platform ranging from our proprietary online editing suite to the ability to download full game files.  Working together to define the security model for all of your content, HockeyTV can ensure your digital rights are protected where you want them to be and your content is shared in accordance with your wishes.']
      }, {
        question: 'There are other streaming companies out there.  Why should I work with HockeyTV?',
        answer: ['HockeyTV is unique in our business model in that we are not only a streaming company but your complete digital media partner in our venture.  Our goal is to understand your need and build a partnership that meets each and every one of your goals.', 'Our platform, built to support the specific needs of hockey organizations, has a unique array of features not found elsewhere.  We integrate live and on-demand video, online editing and sharing, digital media marketing including integration with Facebook, Youtube, and others.', 'Lastly, we provide all the hardware and software you need to effectively broadcast your games on the worlds leading network-- Akamai.  You have access to live online reporting with geolocation analytics and access to a growing list of advanced digital media functions.  Partners get access to over 30,000 live games annually and 150,000 hours of on demand content.  There are almost never any out of pocket expenses for you!']
      }];

      break;
  }

  return service;
}]);

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.information.privacy_page', []).config(['$stateProvider', 'PRODUCT', function ($stateProvider, product) {
  return $stateProvider.state('app.information.privacy', {
    url: '/information/privacy',
    templateUrl: 'assets/templates/' + product.Code + '/information/privacyView.html',
    title: 'Privacy'
  });
}]);

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(355);
__webpack_require__(113);
__webpack_require__(358);
__webpack_require__(115);

/**
 * @typedef {{
 * confirmation: string,
 * plan_code: string
 * }} RegistrationParams
 */

angular.module('app.registration', ['app.registration.registrationController', 'app.shared.selectWithDisabledOption.selectWithDisabledOptionDirective', 'app.registration.confirmation.confirmationController', 'app.shared.password.passwordDirective']).config(['$stateProvider', 'PRODUCT', function ($stateProvider, product) {
  'use strict';

  var regTemplate = 'components/registration/registrationView.html';
  if (product.Code != 'htv') {
    regTemplate = 'assets/templates/' + product.Code + '/registration/registrationView.html';
  }

  $stateProvider.state('app.registration', {
    abstract: true,
    url: '/registration',
    template: '<ui-view></ui-view>'
  }).state('app.registration.new', {
    url: '/new',
    templateUrl: regTemplate,
    controller: 'app.registration.registrationController',
    title: ' ',
    subTitle: 'Registration',
    isChildState: false,
    noSidebar: true,
    noTitleBar: true,
    params: {
      loginRedirect: null,
      loginRedirectParams: null,
      plan_code: null,
      team: null
    }
  }).state('app.registration.confirmation', {
    url: '/confirm/:userId/:confirmation?:plan_code&:team',
    templateUrl: 'components/registration/confirmation/confirmationView.html',
    controller: 'app.registration.confirmation.confirmationController',
    title: 'Registration Confirmation',
    noSidebar: true
  });
}]);

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(356);
__webpack_require__(357);
__webpack_require__(112);
__webpack_require__(1);

angular.module('app.registration.registrationController', ['app.registration.profileTypesService', 'app.registration.registrationService', 'app.shared.dobSelectorService', 'app.currentUser']).controller('app.registration.registrationController', ['$scope', 'app.registration.profileTypesService', 'app.registration.registrationService', 'app.shared.dobSelectorService', 'currentUser', '$stateParams', function ($scope, profileTypes, registration, dobSelector, currentUser, $stateParams) {
  "use strict";

  var reg_defaults = {
    first_name: null,
    last_name: null,
    email: null,
    password: null,
    mob: dobSelector.new(),
    gender: null,
    phone: null,
    profile_type: null,
    username: null
  };

  $scope.loginRedirect = $stateParams.loginRedirect;
  $scope.loginRedirectParams = $stateParams.loginRedirectParams;
  $scope.passwordPass = false;
  $scope.showPassword = false;
  $scope.passwordType = 'password';

  var init = function init() {
    profileTypes.retrieve();
  };

  var setError = function setError(field, message) {
    if (message) {
      $scope.errors[field] = message;
    } else {
      delete $scope.errors[field];
    }
  };

  var hasError = function hasError() {
    for (var i in $scope.errors) {
      if ($scope.errors.hasOwnProperty(i)) {
        if ($scope.errors[i]) {
          return true;
        }
      }
    }
    return false;
  };

  var clearErrors = function clearErrors() {
    for (var i in $scope.errors) {
      if ($scope.errors.hasOwnProperty(i)) {
        delete $scope.errors[i];
      }
    }
    return false;
  };

  var validateForm = function validateForm(form) {
    var reg_info = $scope.reg_info;

    clearErrors();

    if (form) {
      var elements = form.elements;

      for (var i in elements) {
        if (elements.hasOwnProperty(i)) {
          var el = elements[i];
          if (typeof el.value !== 'undefined') {
            var is_valid = el.checkValidity();
            if (!is_valid) {
              setError(el.dataset.field, el.validationMessage);
            }
          }
        }
      }
      if (hasError()) {
        return false;
      }
    }

    if (reg_info.email !== $scope.email_confirm) {
      setError('email_confirm', 'Your email addresses do not match');
    }

    if (reg_info.password === $scope.confirm_password) {
      if (!$scope.passwordPass) {
        setError('password', 'Your password is too easy to guess');
      }
    } else {
      setError('password_confirm', 'Passwords do not match');
    }

    if (reg_info.username.length < 6) {
      setError('username', 'Username must contain at least 6 characters');
    }

    return !hasError();
  };

  var processRegistrationRequest = function processRegistrationRequest(data) {
    if (data.messages) {
      setError('messages', data.messages);
    }

    if (data.error) {
      alert(data.error);
    } else {
      $scope.registration_successful = true;
      $scope.reg_info = angular.copy(reg_defaults);
    }
  };

  $scope.reg_info = angular.copy(reg_defaults);
  $scope.email_confirm = null;
  $scope.confirm_password = null;
  $scope.profileTypes = profileTypes;
  $scope.errors = {};
  $scope.registration_successful = false;

  $scope.register = function (event) {
    if (validateForm(event.target)) {
      var reg_info = {
        first_name: $scope.reg_info.first_name,
        last_name: $scope.reg_info.last_name,
        email: $scope.reg_info.email,
        password: $scope.reg_info.password,
        mob: $scope.reg_info.mob.getDate().format('YYYY-MM'),
        gender: $scope.reg_info.gender,
        phone: $scope.reg_info.phone,
        profile_type: $scope.reg_info.profile_type,
        username: $scope.reg_info.username
      };
      var options = { plan_code: $stateParams.plan_code, team_id: $stateParams.team };
      registration.register({ user: reg_info, options: options }).then(
      /**
       * @param {HttpResponse} response
       */
      function (response) {
        processRegistrationRequest(response.data);
      },
      /**
       * @param {HttpResponse} response
       */
      function (response) {
        processRegistrationRequest(response.data);
      });
    }
  };

  $scope.checkUsername = function () {
    currentUser.checkUsername($scope.reg_info.username).then(function (response) {
      if (response.data) {
        $scope.errors.username = response.data.message;
      } else {
        $scope.errors.username = null;
      }
    });
  };

  $scope.showPasswordClick = function () {
    $scope.showPassword = !$scope.showPassword;
    if ($scope.showPassword) {
      $scope.passwordType = "text";
    } else {
      $scope.passwordType = "password";
    }
  };

  init();
}]);

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.registration.profileTypesService', []).factory('app.registration.profileTypesService', ['$http', function ($http) {
  "use strict";

  var service = {
    list: null,
    error: null,
    retrieve: function retrieve() {
      return $http.get(window.location.api('userprofiles/types')).then(function (response) {
        var data = response.data;

        service.list = null;
        service.error = null;

        if (data.error) {
          service.error = data.error;
        } else {
          service.list = data;
        }
      });
    }
  };

  return service;
}]);

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.registration.registrationService', []).factory('app.registration.registrationService', ['$http', function ($http) {
    return {
        register: function register(reg_info) {
            return $http.post(window.location.api('users'), reg_info);
        }
    };
}]);

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(114);
__webpack_require__(1);
__webpack_require__(25);
__webpack_require__(60);

angular.module('app.registration.confirmation.confirmationController', ['app.registration.confirmation.confirmationService', 'app.currentUser', 'app.mainFrame.collapsableMenu.collapsableMenuService']).controller('app.registration.confirmation.confirmationController', ['$scope', '$stateParams', 'app.registration.confirmation.confirmationService', 'currentUser', '$state', 'app.mainFrame.collapsableMenu.collapsableMenuService', 'app.pricing.plans.plansService',
/**
 * @param $scope
 * @param {RegistrationParams} $stateParams
 * @param confirmation
 * @param currentUser
 * @param $state
 * @param collapsableMenu
 * @param plansService
 */
function ($scope, $stateParams, confirmation, currentUser, $state, collapsableMenu, plansService) {
  "use strict";

  $scope.username = null;
  $scope.password = null;
  $scope.ready = false;
  $scope.confirming = true;
  $scope.error = null;

  var init = function init() {
    $scope.confirm();
  };

  $scope.confirm = function () {
    if ($stateParams.userId && $stateParams.confirmation) {
      var userId = parseInt($stateParams.userId);
      confirmation.confirm(userId, $stateParams.confirmation).then(
      /**
       * @param {HttpResponse} response
       */
      function (response) {
        $scope.confirming = false;

        if (response.status === 204) {
          $scope.ready = true;
        } else {
          $scope.error = response.data.error;
        }
      },
      /**
       * @param {HttpResponse} response
       */
      function (response) {
        $scope.error = response.data.error;
      });
    }
  };

  $scope.login = function () {
    currentUser.login($scope.username, $scope.password).then(function () {
      collapsableMenu.buildItems();
      if ($stateParams.plan_code) {
        plansService.retrieve({ plans: [$stateParams.plan_code] }).then(function (data) {
          var plan = _.find(data.plans, { plan_code: $stateParams.plan_code });
          $state.go('app.purchase.billingInfo', { plan: plan, team: $stateParams.team });
        });
      } else {
        $state.go('app.favorites');
      }
    }).catch(function (result) {
      $state.go('app.login', result);
    });
  };

  init();
}]);

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(360);

angular.module('app.shared.password.passwordController', ['app.shared.password.passwordService']).controller('app.shared.password.passwordController', ['$scope', 'app.shared.password.passwordService', function ($scope, passwordService) {
  "use strict";

  $scope.passwordChecker = passwordService.new();

  $scope.$watch(function () {
    return $scope.password;
  }, function () {
    $scope.passwordPass = $scope.passwordChecker.validate($scope.password);
  });
}]);

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.shared.password.passwordService', []).factory('app.shared.password.passwordService', [function () {
  "use strict";

  return {
    new: function _new() {
      var checker = {
        requirements: {
          passwordRequired: {
            description: 'Password is required. / Mot de passe requis',
            value: true,
            passed: false
          },
          minLength: {
            description: 'Password must be at least 8 characters. / Mot de passe doit contenir 8 caractères',
            value: 8,
            passed: false
          },
          lowerCase: {
            description: 'Password must contain at least one lower case letter. / Mot de passe doit contenir au moins une lettre minuscule',
            value: true,
            passed: false
          },
          upperCase: {
            description: 'Password must contain at least one upper case letter. / Mot de passe doit contenir au moins une lettre majuscule',
            value: true,
            passed: false
          },
          number: {
            description: 'Password must contain at least one number. / Mot de passe doit contenir au moins 1 chiffre',
            value: true,
            passed: false
          },
          symbol: {
            description: 'Password must contain at least one symbol. / Mot de passe doit contenir au moins 1 symbole',
            value: true,
            passed: false
          }
        },
        passwordStrength: function passwordStrength(password) {
          if (checker.validate(password)) {
            return 1;
          } else {
            var strength = 0;
            var maxStrength = 0;

            _.forEach(checker.requirements, function (requirement) {
              if (requirement.value) {
                maxStrength++;

                if (requirement.passed) {
                  strength++;
                }
              }
            });

            return strength / maxStrength;
          }
        },
        validate: function validate(password) {
          if (!password) {
            password = '';
          }

          checker.requirements.passwordRequired.passed = !(checker.requirements.passwordRequired.value && !password);

          checker.requirements.minLength.passed = password.length >= checker.requirements.minLength.value;

          checker.requirements.lowerCase.passed = true;
          if (checker.requirements.lowerCase.value) {
            if (!password.match(/[a-z]/)) {
              checker.requirements.lowerCase.passed = false;
            }
          }

          checker.requirements.upperCase.passed = true;
          if (checker.requirements.upperCase.value) {
            if (!password.match(/[A-Z]/)) {
              checker.requirements.upperCase.passed = false;
            }
          }

          checker.requirements.number.passed = true;
          if (checker.requirements.number.value) {
            if (!password.match(/[0-9]/)) {
              checker.requirements.number.passed = false;
            }
          }

          checker.requirements.symbol.passed = true;
          if (checker.requirements.symbol.value) {
            var regex = new RegExp(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/);
            if (!password.match(regex)) {
              checker.requirements.symbol.passed = false;
            }
          }

          var isValid = true;
          _.forEach(checker.requirements, function (requirement) {
            if (requirement.value && !requirement.passed) {
              isValid = false;
              return false;
            }
          });
          return isValid;
        }
      };

      return checker;
    }
  };
}]);

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.purchase', []).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.purchase', {
        abstract: true,
        template: '<ui-view></ui-view>'
    });
}]);

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(116);
__webpack_require__(366);
__webpack_require__(367);
__webpack_require__(371);

'use strict';

angular.module('app.myProfile', ['app.myProfile.myProfileDirective', 'app.myProfile.subscriptionHistory', 'app.myProfile.transactionHistory', 'app.myProfile.myProfileController']).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.myProfile', {
        url: '/my_profile',
        templateUrl: 'components/myProfile/myProfileView.html'
    });
}]);

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(364);
__webpack_require__(117);

'use strict';

angular.module('app.myProfile.myProfileService', ['ngFileUpload', 'app.shared.profileService']).factory('app.myProfile.myProfileService', ['$http', 'currentUser', 'DEFAULT_PROFILE_IMAGE', 'Upload', 'app.shared.profileService', function ($http, currentUser, DEFAULT_PROFILE_IMAGE, Upload, profileService) {
  var profile = void 0;
  return profile = {
    data: null,
    process_data: function process_data(data, notEditable) {
      if (data.user) {
        profile.data = data.user;
        if (!profile.data.profile_image) {
          profile.data.profile_image = DEFAULT_PROFILE_IMAGE;
        }
        profile.data.live_watched_count = parseInt(profile.data.live_watched_count);
        profile.data.archived_watched_count = parseInt(profile.data.archived_watched_count);
        profile.data.clips_count = parseInt(profile.data.clips_count);
        profile.data.is_profile_public = !!parseInt(profile.data.is_profile_public);
        profile.data.following = parseInt(profile.data.following);
        profile.data.followers = parseInt(profile.data.followers);
        profile.data.membership_date = momentToDate(moment(profile.data.membership_date));
        profile.data.notEditable = !!notEditable === true;
        profile.data.client_profile_url = profileService.buildProfileUrl(profile.data.username);
      }
    },
    retrieve: function retrieve(customIuserid) {

      var idToRetrieve = customIuserid ? customIuserid : currentUser.data.iuserid;
      var notEditable = !!customIuserid;

      return $http.get(window.location.api('users/' + idToRetrieve + '/profile')).then(function (response) {
        var data = response.data;
        profile.process_data(data, notEditable);
        return response;
      });
    },
    /**
     * @param {string} field
     * @param {{firstName: string, lastName: string, city: string, state: string}} value
     */
    save: function save(field, value) {
      var params = {};
      if (field) {
        switch (field) {
          case 'name':
            if (value && typeof value.firstName !== 'undefined') {
              params.first_name = value.firstName;
            } else if (profile.data) {
              params.first_name = profile.data.first_name;
            }

            if (value && typeof value.lastName !== 'undefined') {
              params.last_name = value.lastName;
            } else if (profile.data) {
              params.last_name = profile.data.last_name;
            }
            break;
          case 'address':
            if (value && typeof value.city !== 'undefined') {
              params.city = value.city;
            } else if (profile.data) {
              params.city = profile.data.city;
            }

            if (value && typeof value.state !== 'undefined') {
              params.state = value.state;
            } else if (profile.data) {
              params.state = profile.data.state;
            }
            break;
          case 'is_profile_public':
            if (typeof profile.data.username !== 'undefined') {
              params.username = profile.data.username;
            }
            params[field] = profile.data[field];
            break;
          default:
            if (typeof value === 'undefined' && profile.data) {
              params[field] = profile.data[field];
            } else {
              params[field] = value;
            }
            break;
        }

        return $http.put(window.location.api('users/' + currentUser.data.iuserid + '/profile'), params).then(function (response) {
          var data = response.data;
          if (!response.data.error && parseInt(response.status) === 200) {
            currentUser.update();
            profile.process_data(data);
          }
          return response;
        });
      }
    },
    save_image: function save_image(file) {
      if (file) {
        var promise = false;
        Upload.base64DataUrl(file).then(function (url) {
          promise = $http.put(window.location.api('users/' + currentUser.data.iuserid + '/profile/image'), {
            image: url
          }).then(function (response) {
            if (response.data.url) {
              profile.data.profile_image = response.data.url;
            }
          });
        });
        return promise;
      }
      return false;
    },
    games_watched_count: function games_watched_count() {
      if (profile.data) {
        return profile.data.live_watched_count + profile.data.archived_watched_count;
      } else {
        return 0;
      }
    }
  };
}]);

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(365);
module.exports = 'ngFileUpload';

/***/ }),
/* 365 */
/***/ (function(module, exports) {

/**!
 * AngularJS file upload directives and services. Supports: file upload/drop/paste, resume, cancel/abort,
 * progress, resize, thumbnail, preview, validation and CORS
 * FileAPI Flash shim for old browsers not supporting FormData
 * @author  Danial  <danial.farid@gmail.com>
 * @version 12.2.13
 */

(function () {
  /** @namespace FileAPI.noContentTimeout */

  function patchXHR(fnName, newFn) {
    window.XMLHttpRequest.prototype[fnName] = newFn(window.XMLHttpRequest.prototype[fnName]);
  }

  function redefineProp(xhr, prop, fn) {
    try {
      Object.defineProperty(xhr, prop, {get: fn});
    } catch (e) {/*ignore*/
    }
  }

  if (!window.FileAPI) {
    window.FileAPI = {};
  }

  if (!window.XMLHttpRequest) {
    throw 'AJAX is not supported. XMLHttpRequest is not defined.';
  }

  FileAPI.shouldLoad = !window.FormData || FileAPI.forceLoad;
  if (FileAPI.shouldLoad) {
    var initializeUploadListener = function (xhr) {
      if (!xhr.__listeners) {
        if (!xhr.upload) xhr.upload = {};
        xhr.__listeners = [];
        var origAddEventListener = xhr.upload.addEventListener;
        xhr.upload.addEventListener = function (t, fn) {
          xhr.__listeners[t] = fn;
          if (origAddEventListener) origAddEventListener.apply(this, arguments);
        };
      }
    };

    patchXHR('open', function (orig) {
      return function (m, url, b) {
        initializeUploadListener(this);
        this.__url = url;
        try {
          orig.apply(this, [m, url, b]);
        } catch (e) {
          if (e.message.indexOf('Access is denied') > -1) {
            this.__origError = e;
            orig.apply(this, [m, '_fix_for_ie_crossdomain__', b]);
          }
        }
      };
    });

    patchXHR('getResponseHeader', function (orig) {
      return function (h) {
        return this.__fileApiXHR && this.__fileApiXHR.getResponseHeader ? this.__fileApiXHR.getResponseHeader(h) : (orig == null ? null : orig.apply(this, [h]));
      };
    });

    patchXHR('getAllResponseHeaders', function (orig) {
      return function () {
        return this.__fileApiXHR && this.__fileApiXHR.getAllResponseHeaders ? this.__fileApiXHR.getAllResponseHeaders() : (orig == null ? null : orig.apply(this));
      };
    });

    patchXHR('abort', function (orig) {
      return function () {
        return this.__fileApiXHR && this.__fileApiXHR.abort ? this.__fileApiXHR.abort() : (orig == null ? null : orig.apply(this));
      };
    });

    patchXHR('setRequestHeader', function (orig) {
      return function (header, value) {
        if (header === '__setXHR_') {
          initializeUploadListener(this);
          var val = value(this);
          // fix for angular < 1.2.0
          if (val instanceof Function) {
            val(this);
          }
        } else {
          this.__requestHeaders = this.__requestHeaders || {};
          this.__requestHeaders[header] = value;
          orig.apply(this, arguments);
        }
      };
    });

    patchXHR('send', function (orig) {
      return function () {
        var xhr = this;
        if (arguments[0] && arguments[0].__isFileAPIShim) {
          var formData = arguments[0];
          var config = {
            url: xhr.__url,
            jsonp: false, //removes the callback form param
            cache: true, //removes the ?fileapiXXX in the url
            complete: function (err, fileApiXHR) {
              if (err && angular.isString(err) && err.indexOf('#2174') !== -1) {
                // this error seems to be fine the file is being uploaded properly.
                err = null;
              }
              xhr.__completed = true;
              if (!err && xhr.__listeners.load)
                xhr.__listeners.load({
                  type: 'load',
                  loaded: xhr.__loaded,
                  total: xhr.__total,
                  target: xhr,
                  lengthComputable: true
                });
              if (!err && xhr.__listeners.loadend)
                xhr.__listeners.loadend({
                  type: 'loadend',
                  loaded: xhr.__loaded,
                  total: xhr.__total,
                  target: xhr,
                  lengthComputable: true
                });
              if (err === 'abort' && xhr.__listeners.abort)
                xhr.__listeners.abort({
                  type: 'abort',
                  loaded: xhr.__loaded,
                  total: xhr.__total,
                  target: xhr,
                  lengthComputable: true
                });
              if (fileApiXHR.status !== undefined) redefineProp(xhr, 'status', function () {
                return (fileApiXHR.status === 0 && err && err !== 'abort') ? 500 : fileApiXHR.status;
              });
              if (fileApiXHR.statusText !== undefined) redefineProp(xhr, 'statusText', function () {
                return fileApiXHR.statusText;
              });
              redefineProp(xhr, 'readyState', function () {
                return 4;
              });
              if (fileApiXHR.response !== undefined) redefineProp(xhr, 'response', function () {
                return fileApiXHR.response;
              });
              var resp = fileApiXHR.responseText || (err && fileApiXHR.status === 0 && err !== 'abort' ? err : undefined);
              redefineProp(xhr, 'responseText', function () {
                return resp;
              });
              redefineProp(xhr, 'response', function () {
                return resp;
              });
              if (err) redefineProp(xhr, 'err', function () {
                return err;
              });
              xhr.__fileApiXHR = fileApiXHR;
              if (xhr.onreadystatechange) xhr.onreadystatechange();
              if (xhr.onload) xhr.onload();
            },
            progress: function (e) {
              e.target = xhr;
              if (xhr.__listeners.progress) xhr.__listeners.progress(e);
              xhr.__total = e.total;
              xhr.__loaded = e.loaded;
              if (e.total === e.loaded) {
                // fix flash issue that doesn't call complete if there is no response text from the server
                var _this = this;
                setTimeout(function () {
                  if (!xhr.__completed) {
                    xhr.getAllResponseHeaders = function () {
                    };
                    _this.complete(null, {status: 204, statusText: 'No Content'});
                  }
                }, FileAPI.noContentTimeout || 10000);
              }
            },
            headers: xhr.__requestHeaders
          };
          config.data = {};
          config.files = {};
          for (var i = 0; i < formData.data.length; i++) {
            var item = formData.data[i];
            if (item.val != null && item.val.name != null && item.val.size != null && item.val.type != null) {
              config.files[item.key] = item.val;
            } else {
              config.data[item.key] = item.val;
            }
          }

          setTimeout(function () {
            if (!FileAPI.hasFlash) {
              throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
            }
            xhr.__fileApiXHR = FileAPI.upload(config);
          }, 1);
        } else {
          if (this.__origError) {
            throw this.__origError;
          }
          orig.apply(xhr, arguments);
        }
      };
    });
    window.XMLHttpRequest.__isFileAPIShim = true;
    window.FormData = FormData = function () {
      return {
        append: function (key, val, name) {
          if (val.__isFileAPIBlobShim) {
            val = val.data[0];
          }
          this.data.push({
            key: key,
            val: val,
            name: name
          });
        },
        data: [],
        __isFileAPIShim: true
      };
    };

    window.Blob = Blob = function (b) {
      return {
        data: b,
        __isFileAPIBlobShim: true
      };
    };
  }

})();

(function () {
  /** @namespace FileAPI.forceLoad */
  /** @namespace window.FileAPI.jsUrl */
  /** @namespace window.FileAPI.jsPath */

  function isInputTypeFile(elem) {
    return elem[0].tagName.toLowerCase() === 'input' && elem.attr('type') && elem.attr('type').toLowerCase() === 'file';
  }

  function hasFlash() {
    try {
      var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
      if (fo) return true;
    } catch (e) {
      if (navigator.mimeTypes['application/x-shockwave-flash'] !== undefined) return true;
    }
    return false;
  }

  function getOffset(obj) {
    var left = 0, top = 0;

    if (window.jQuery) {
      return jQuery(obj).offset();
    }

    if (obj.offsetParent) {
      do {
        left += (obj.offsetLeft - obj.scrollLeft);
        top += (obj.offsetTop - obj.scrollTop);
        obj = obj.offsetParent;
      } while (obj);
    }
    return {
      left: left,
      top: top
    };
  }

  if (FileAPI.shouldLoad) {
    FileAPI.hasFlash = hasFlash();

    //load FileAPI
    if (FileAPI.forceLoad) {
      FileAPI.html5 = false;
    }

    if (!FileAPI.upload) {
      var jsUrl, basePath, script = document.createElement('script'), allScripts = document.getElementsByTagName('script'), i, index, src;
      if (window.FileAPI.jsUrl) {
        jsUrl = window.FileAPI.jsUrl;
      } else if (window.FileAPI.jsPath) {
        basePath = window.FileAPI.jsPath;
      } else {
        for (i = 0; i < allScripts.length; i++) {
          src = allScripts[i].src;
          index = src.search(/\/ng\-file\-upload[\-a-zA-z0-9\.]*\.js/);
          if (index > -1) {
            basePath = src.substring(0, index + 1);
            break;
          }
        }
      }

      if (FileAPI.staticPath == null) FileAPI.staticPath = basePath;
      script.setAttribute('src', jsUrl || basePath + 'FileAPI.min.js');
      document.getElementsByTagName('head')[0].appendChild(script);
    }

    FileAPI.ngfFixIE = function (elem, fileElem, changeFn) {
      if (!hasFlash()) {
        throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
      }
      var fixInputStyle = function () {
        var label = fileElem.parent();
        if (elem.attr('disabled')) {
          if (label) label.removeClass('js-fileapi-wrapper');
        } else {
          if (!fileElem.attr('__ngf_flash_')) {
            fileElem.unbind('change');
            fileElem.unbind('click');
            fileElem.bind('change', function (evt) {
              fileApiChangeFn.apply(this, [evt]);
              changeFn.apply(this, [evt]);
            });
            fileElem.attr('__ngf_flash_', 'true');
          }
          label.addClass('js-fileapi-wrapper');
          if (!isInputTypeFile(elem)) {
            label.css('position', 'absolute')
              .css('top', getOffset(elem[0]).top + 'px').css('left', getOffset(elem[0]).left + 'px')
              .css('width', elem[0].offsetWidth + 'px').css('height', elem[0].offsetHeight + 'px')
              .css('filter', 'alpha(opacity=0)').css('display', elem.css('display'))
              .css('overflow', 'hidden').css('z-index', '900000')
              .css('visibility', 'visible');
            fileElem.css('width', elem[0].offsetWidth + 'px').css('height', elem[0].offsetHeight + 'px')
              .css('position', 'absolute').css('top', '0px').css('left', '0px');
          }
        }
      };

      elem.bind('mouseenter', fixInputStyle);

      var fileApiChangeFn = function (evt) {
        var files = FileAPI.getFiles(evt);
        //just a double check for #233
        for (var i = 0; i < files.length; i++) {
          if (files[i].size === undefined) files[i].size = 0;
          if (files[i].name === undefined) files[i].name = 'file';
          if (files[i].type === undefined) files[i].type = 'undefined';
        }
        if (!evt.target) {
          evt.target = {};
        }
        evt.target.files = files;
        // if evt.target.files is not writable use helper field
        if (evt.target.files !== files) {
          evt.__files_ = files;
        }
        (evt.__files_ || evt.target.files).item = function (i) {
          return (evt.__files_ || evt.target.files)[i] || null;
        };
      };
    };

    FileAPI.disableFileInput = function (elem, disable) {
      if (disable) {
        elem.removeClass('js-fileapi-wrapper');
      } else {
        elem.addClass('js-fileapi-wrapper');
      }
    };
  }
})();

if (!window.FileReader) {
  window.FileReader = function () {
    var _this = this, loadStarted = false;
    this.listeners = {};
    this.addEventListener = function (type, fn) {
      _this.listeners[type] = _this.listeners[type] || [];
      _this.listeners[type].push(fn);
    };
    this.removeEventListener = function (type, fn) {
      if (_this.listeners[type]) _this.listeners[type].splice(_this.listeners[type].indexOf(fn), 1);
    };
    this.dispatchEvent = function (evt) {
      var list = _this.listeners[evt.type];
      if (list) {
        for (var i = 0; i < list.length; i++) {
          list[i].call(_this, evt);
        }
      }
    };
    this.onabort = this.onerror = this.onload = this.onloadstart = this.onloadend = this.onprogress = null;

    var constructEvent = function (type, evt) {
      var e = {type: type, target: _this, loaded: evt.loaded, total: evt.total, error: evt.error};
      if (evt.result != null) e.target.result = evt.result;
      return e;
    };
    var listener = function (evt) {
      if (!loadStarted) {
        loadStarted = true;
        if (_this.onloadstart) _this.onloadstart(constructEvent('loadstart', evt));
      }
      var e;
      if (evt.type === 'load') {
        if (_this.onloadend) _this.onloadend(constructEvent('loadend', evt));
        e = constructEvent('load', evt);
        if (_this.onload) _this.onload(e);
        _this.dispatchEvent(e);
      } else if (evt.type === 'progress') {
        e = constructEvent('progress', evt);
        if (_this.onprogress) _this.onprogress(e);
        _this.dispatchEvent(e);
      } else {
        e = constructEvent('error', evt);
        if (_this.onerror) _this.onerror(e);
        _this.dispatchEvent(e);
      }
    };
    this.readAsDataURL = function (file) {
      FileAPI.readAsDataURL(file, listener);
    };
    this.readAsText = function (file) {
      FileAPI.readAsText(file, listener);
    };
  };
}

/**!
 * AngularJS file upload directives and services. Supoorts: file upload/drop/paste, resume, cancel/abort,
 * progress, resize, thumbnail, preview, validation and CORS
 * @author  Danial  <danial.farid@gmail.com>
 * @version 12.2.13
 */

if (window.XMLHttpRequest && !(window.FileAPI && FileAPI.shouldLoad)) {
  window.XMLHttpRequest.prototype.setRequestHeader = (function (orig) {
    return function (header, value) {
      if (header === '__setXHR_') {
        var val = value(this);
        // fix for angular < 1.2.0
        if (val instanceof Function) {
          val(this);
        }
      } else {
        orig.apply(this, arguments);
      }
    };
  })(window.XMLHttpRequest.prototype.setRequestHeader);
}

var ngFileUpload = angular.module('ngFileUpload', []);

ngFileUpload.version = '12.2.13';

ngFileUpload.service('UploadBase', ['$http', '$q', '$timeout', function ($http, $q, $timeout) {
  var upload = this;
  upload.promisesCount = 0;

  this.isResumeSupported = function () {
    return window.Blob && window.Blob.prototype.slice;
  };

  var resumeSupported = this.isResumeSupported();

  function sendHttp(config) {
    config.method = config.method || 'POST';
    config.headers = config.headers || {};

    var deferred = config._deferred = config._deferred || $q.defer();
    var promise = deferred.promise;

    function notifyProgress(e) {
      if (deferred.notify) {
        deferred.notify(e);
      }
      if (promise.progressFunc) {
        $timeout(function () {
          promise.progressFunc(e);
        });
      }
    }

    function getNotifyEvent(n) {
      if (config._start != null && resumeSupported) {
        return {
          loaded: n.loaded + config._start,
          total: (config._file && config._file.size) || n.total,
          type: n.type, config: config,
          lengthComputable: true, target: n.target
        };
      } else {
        return n;
      }
    }

    if (!config.disableProgress) {
      config.headers.__setXHR_ = function () {
        return function (xhr) {
          if (!xhr || !xhr.upload || !xhr.upload.addEventListener) return;
          config.__XHR = xhr;
          if (config.xhrFn) config.xhrFn(xhr);
          xhr.upload.addEventListener('progress', function (e) {
            e.config = config;
            notifyProgress(getNotifyEvent(e));
          }, false);
          //fix for firefox not firing upload progress end, also IE8-9
          xhr.upload.addEventListener('load', function (e) {
            if (e.lengthComputable) {
              e.config = config;
              notifyProgress(getNotifyEvent(e));
            }
          }, false);
        };
      };
    }

    function uploadWithAngular() {
      $http(config).then(function (r) {
          if (resumeSupported && config._chunkSize && !config._finished && config._file) {
            var fileSize = config._file && config._file.size || 0;
            notifyProgress({
                loaded: Math.min(config._end, fileSize),
                total: fileSize,
                config: config,
                type: 'progress'
              }
            );
            upload.upload(config, true);
          } else {
            if (config._finished) delete config._finished;
            deferred.resolve(r);
          }
        }, function (e) {
          deferred.reject(e);
        }, function (n) {
          deferred.notify(n);
        }
      );
    }

    if (!resumeSupported) {
      uploadWithAngular();
    } else if (config._chunkSize && config._end && !config._finished) {
      config._start = config._end;
      config._end += config._chunkSize;
      uploadWithAngular();
    } else if (config.resumeSizeUrl) {
      $http.get(config.resumeSizeUrl).then(function (resp) {
        if (config.resumeSizeResponseReader) {
          config._start = config.resumeSizeResponseReader(resp.data);
        } else {
          config._start = parseInt((resp.data.size == null ? resp.data : resp.data.size).toString());
        }
        if (config._chunkSize) {
          config._end = config._start + config._chunkSize;
        }
        uploadWithAngular();
      }, function (e) {
        throw e;
      });
    } else if (config.resumeSize) {
      config.resumeSize().then(function (size) {
        config._start = size;
        if (config._chunkSize) {
          config._end = config._start + config._chunkSize;
        }
        uploadWithAngular();
      }, function (e) {
        throw e;
      });
    } else {
      if (config._chunkSize) {
        config._start = 0;
        config._end = config._start + config._chunkSize;
      }
      uploadWithAngular();
    }


    promise.success = function (fn) {
      promise.then(function (response) {
        fn(response.data, response.status, response.headers, config);
      });
      return promise;
    };

    promise.error = function (fn) {
      promise.then(null, function (response) {
        fn(response.data, response.status, response.headers, config);
      });
      return promise;
    };

    promise.progress = function (fn) {
      promise.progressFunc = fn;
      promise.then(null, null, function (n) {
        fn(n);
      });
      return promise;
    };
    promise.abort = promise.pause = function () {
      if (config.__XHR) {
        $timeout(function () {
          config.__XHR.abort();
        });
      }
      return promise;
    };
    promise.xhr = function (fn) {
      config.xhrFn = (function (origXhrFn) {
        return function () {
          if (origXhrFn) origXhrFn.apply(promise, arguments);
          fn.apply(promise, arguments);
        };
      })(config.xhrFn);
      return promise;
    };

    upload.promisesCount++;
    if (promise['finally'] && promise['finally'] instanceof Function) {
      promise['finally'](function () {
        upload.promisesCount--;
      });
    }
    return promise;
  }

  this.isUploadInProgress = function () {
    return upload.promisesCount > 0;
  };

  this.rename = function (file, name) {
    file.ngfName = name;
    return file;
  };

  this.jsonBlob = function (val) {
    if (val != null && !angular.isString(val)) {
      val = JSON.stringify(val);
    }
    var blob = new window.Blob([val], {type: 'application/json'});
    blob._ngfBlob = true;
    return blob;
  };

  this.json = function (val) {
    return angular.toJson(val);
  };

  function copy(obj) {
    var clone = {};
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        clone[key] = obj[key];
      }
    }
    return clone;
  }

  this.isFile = function (file) {
    return file != null && (file instanceof window.Blob || (file.flashId && file.name && file.size));
  };

  this.upload = function (config, internal) {
    function toResumeFile(file, formData) {
      if (file._ngfBlob) return file;
      config._file = config._file || file;
      if (config._start != null && resumeSupported) {
        if (config._end && config._end >= file.size) {
          config._finished = true;
          config._end = file.size;
        }
        var slice = file.slice(config._start, config._end || file.size);
        slice.name = file.name;
        slice.ngfName = file.ngfName;
        if (config._chunkSize) {
          formData.append('_chunkSize', config._chunkSize);
          formData.append('_currentChunkSize', config._end - config._start);
          formData.append('_chunkNumber', Math.floor(config._start / config._chunkSize));
          formData.append('_totalSize', config._file.size);
        }
        return slice;
      }
      return file;
    }

    function addFieldToFormData(formData, val, key) {
      if (val !== undefined) {
        if (angular.isDate(val)) {
          val = val.toISOString();
        }
        if (angular.isString(val)) {
          formData.append(key, val);
        } else if (upload.isFile(val)) {
          var file = toResumeFile(val, formData);
          var split = key.split(',');
          if (split[1]) {
            file.ngfName = split[1].replace(/^\s+|\s+$/g, '');
            key = split[0];
          }
          config._fileKey = config._fileKey || key;
          formData.append(key, file, file.ngfName || file.name);
        } else {
          if (angular.isObject(val)) {
            if (val.$$ngfCircularDetection) throw 'ngFileUpload: Circular reference in config.data. Make sure specified data for Upload.upload() has no circular reference: ' + key;

            val.$$ngfCircularDetection = true;
            try {
              for (var k in val) {
                if (val.hasOwnProperty(k) && k !== '$$ngfCircularDetection') {
                  var objectKey = config.objectKey == null ? '[i]' : config.objectKey;
                  if (val.length && parseInt(k) > -1) {
                    objectKey = config.arrayKey == null ? objectKey : config.arrayKey;
                  }
                  addFieldToFormData(formData, val[k], key + objectKey.replace(/[ik]/g, k));
                }
              }
            } finally {
              delete val.$$ngfCircularDetection;
            }
          } else {
            formData.append(key, val);
          }
        }
      }
    }

    function digestConfig() {
      config._chunkSize = upload.translateScalars(config.resumeChunkSize);
      config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;

      config.headers = config.headers || {};
      config.headers['Content-Type'] = undefined;
      config.transformRequest = config.transformRequest ?
        (angular.isArray(config.transformRequest) ?
          config.transformRequest : [config.transformRequest]) : [];
      config.transformRequest.push(function (data) {
        var formData = new window.FormData(), key;
        data = data || config.fields || {};
        if (config.file) {
          data.file = config.file;
        }
        for (key in data) {
          if (data.hasOwnProperty(key)) {
            var val = data[key];
            if (config.formDataAppender) {
              config.formDataAppender(formData, key, val);
            } else {
              addFieldToFormData(formData, val, key);
            }
          }
        }

        return formData;
      });
    }

    if (!internal) config = copy(config);
    if (!config._isDigested) {
      config._isDigested = true;
      digestConfig();
    }

    return sendHttp(config);
  };

  this.http = function (config) {
    config = copy(config);
    config.transformRequest = config.transformRequest || function (data) {
        if ((window.ArrayBuffer && data instanceof window.ArrayBuffer) || data instanceof window.Blob) {
          return data;
        }
        return $http.defaults.transformRequest[0].apply(this, arguments);
      };
    config._chunkSize = upload.translateScalars(config.resumeChunkSize);
    config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;

    return sendHttp(config);
  };

  this.translateScalars = function (str) {
    if (angular.isString(str)) {
      if (str.search(/kb/i) === str.length - 2) {
        return parseFloat(str.substring(0, str.length - 2) * 1024);
      } else if (str.search(/mb/i) === str.length - 2) {
        return parseFloat(str.substring(0, str.length - 2) * 1048576);
      } else if (str.search(/gb/i) === str.length - 2) {
        return parseFloat(str.substring(0, str.length - 2) * 1073741824);
      } else if (str.search(/b/i) === str.length - 1) {
        return parseFloat(str.substring(0, str.length - 1));
      } else if (str.search(/s/i) === str.length - 1) {
        return parseFloat(str.substring(0, str.length - 1));
      } else if (str.search(/m/i) === str.length - 1) {
        return parseFloat(str.substring(0, str.length - 1) * 60);
      } else if (str.search(/h/i) === str.length - 1) {
        return parseFloat(str.substring(0, str.length - 1) * 3600);
      }
    }
    return str;
  };

  this.urlToBlob = function(url) {
    var defer = $q.defer();
    $http({url: url, method: 'get', responseType: 'arraybuffer'}).then(function (resp) {
      var arrayBufferView = new Uint8Array(resp.data);
      var type = resp.headers('content-type') || 'image/WebP';
      var blob = new window.Blob([arrayBufferView], {type: type});
      var matches = url.match(/.*\/(.+?)(\?.*)?$/);
      if (matches.length > 1) {
        blob.name = matches[1];
      }
      defer.resolve(blob);
    }, function (e) {
      defer.reject(e);
    });
    return defer.promise;
  };

  this.setDefaults = function (defaults) {
    this.defaults = defaults || {};
  };

  this.defaults = {};
  this.version = ngFileUpload.version;
}

]);

ngFileUpload.service('Upload', ['$parse', '$timeout', '$compile', '$q', 'UploadExif', function ($parse, $timeout, $compile, $q, UploadExif) {
  var upload = UploadExif;
  upload.getAttrWithDefaults = function (attr, name) {
    if (attr[name] != null) return attr[name];
    var def = upload.defaults[name];
    return (def == null ? def : (angular.isString(def) ? def : JSON.stringify(def)));
  };

  upload.attrGetter = function (name, attr, scope, params) {
    var attrVal = this.getAttrWithDefaults(attr, name);
    if (scope) {
      try {
        if (params) {
          return $parse(attrVal)(scope, params);
        } else {
          return $parse(attrVal)(scope);
        }
      } catch (e) {
        // hangle string value without single qoute
        if (name.search(/min|max|pattern/i)) {
          return attrVal;
        } else {
          throw e;
        }
      }
    } else {
      return attrVal;
    }
  };

  upload.shouldUpdateOn = function (type, attr, scope) {
    var modelOptions = upload.attrGetter('ngfModelOptions', attr, scope);
    if (modelOptions && modelOptions.updateOn) {
      return modelOptions.updateOn.split(' ').indexOf(type) > -1;
    }
    return true;
  };

  upload.emptyPromise = function () {
    var d = $q.defer();
    var args = arguments;
    $timeout(function () {
      d.resolve.apply(d, args);
    });
    return d.promise;
  };

  upload.rejectPromise = function () {
    var d = $q.defer();
    var args = arguments;
    $timeout(function () {
      d.reject.apply(d, args);
    });
    return d.promise;
  };

  upload.happyPromise = function (promise, data) {
    var d = $q.defer();
    promise.then(function (result) {
      d.resolve(result);
    }, function (error) {
      $timeout(function () {
        throw error;
      });
      d.resolve(data);
    });
    return d.promise;
  };

  function applyExifRotations(files, attr, scope) {
    var promises = [upload.emptyPromise()];
    angular.forEach(files, function (f, i) {
      if (f.type.indexOf('image/jpeg') === 0 && upload.attrGetter('ngfFixOrientation', attr, scope, {$file: f})) {
        promises.push(upload.happyPromise(upload.applyExifRotation(f), f).then(function (fixedFile) {
          files.splice(i, 1, fixedFile);
        }));
      }
    });
    return $q.all(promises);
  }

  function resizeFile(files, attr, scope, ngModel) {
    var resizeVal = upload.attrGetter('ngfResize', attr, scope);
    if (!resizeVal || !upload.isResizeSupported() || !files.length) return upload.emptyPromise();
    if (resizeVal instanceof Function) {
      var defer = $q.defer();
      return resizeVal(files).then(function (p) {
        resizeWithParams(p, files, attr, scope, ngModel).then(function (r) {
          defer.resolve(r);
        }, function (e) {
          defer.reject(e);
        });
      }, function (e) {
        defer.reject(e);
      });
    } else {
      return resizeWithParams(resizeVal, files, attr, scope, ngModel);
    }
  }

  function resizeWithParams(params, files, attr, scope, ngModel) {
    var promises = [upload.emptyPromise()];

    function handleFile(f, i) {
      if (f.type.indexOf('image') === 0) {
        if (params.pattern && !upload.validatePattern(f, params.pattern)) return;
        params.resizeIf = function (width, height) {
          return upload.attrGetter('ngfResizeIf', attr, scope,
            {$width: width, $height: height, $file: f});
        };
        var promise = upload.resize(f, params);
        promises.push(promise);
        promise.then(function (resizedFile) {
          files.splice(i, 1, resizedFile);
        }, function (e) {
          f.$error = 'resize';
          (f.$errorMessages = (f.$errorMessages || {})).resize = true;
          f.$errorParam = (e ? (e.message ? e.message : e) + ': ' : '') + (f && f.name);
          ngModel.$ngfValidations.push({name: 'resize', valid: false});
          upload.applyModelValidation(ngModel, files);
        });
      }
    }

    for (var i = 0; i < files.length; i++) {
      handleFile(files[i], i);
    }
    return $q.all(promises);
  }

  upload.updateModel = function (ngModel, attr, scope, fileChange, files, evt, noDelay) {
    function update(files, invalidFiles, newFiles, dupFiles, isSingleModel) {
      attr.$$ngfPrevValidFiles = files;
      attr.$$ngfPrevInvalidFiles = invalidFiles;
      var file = files && files.length ? files[0] : null;
      var invalidFile = invalidFiles && invalidFiles.length ? invalidFiles[0] : null;

      if (ngModel) {
        upload.applyModelValidation(ngModel, files);
        ngModel.$setViewValue(isSingleModel ? file : files);
      }

      if (fileChange) {
        $parse(fileChange)(scope, {
          $files: files,
          $file: file,
          $newFiles: newFiles,
          $duplicateFiles: dupFiles,
          $invalidFiles: invalidFiles,
          $invalidFile: invalidFile,
          $event: evt
        });
      }

      var invalidModel = upload.attrGetter('ngfModelInvalid', attr);
      if (invalidModel) {
        $timeout(function () {
          $parse(invalidModel).assign(scope, isSingleModel ? invalidFile : invalidFiles);
        });
      }
      $timeout(function () {
        // scope apply changes
      });
    }

    var allNewFiles, dupFiles = [], prevValidFiles, prevInvalidFiles,
      invalids = [], valids = [];

    function removeDuplicates() {
      function equals(f1, f2) {
        return f1.name === f2.name && (f1.$ngfOrigSize || f1.size) === (f2.$ngfOrigSize || f2.size) &&
          f1.type === f2.type;
      }

      function isInPrevFiles(f) {
        var j;
        for (j = 0; j < prevValidFiles.length; j++) {
          if (equals(f, prevValidFiles[j])) {
            return true;
          }
        }
        for (j = 0; j < prevInvalidFiles.length; j++) {
          if (equals(f, prevInvalidFiles[j])) {
            return true;
          }
        }
        return false;
      }

      if (files) {
        allNewFiles = [];
        dupFiles = [];
        for (var i = 0; i < files.length; i++) {
          if (isInPrevFiles(files[i])) {
            dupFiles.push(files[i]);
          } else {
            allNewFiles.push(files[i]);
          }
        }
      }
    }

    function toArray(v) {
      return angular.isArray(v) ? v : [v];
    }

    function resizeAndUpdate() {
      function updateModel() {
        $timeout(function () {
          update(keep ? prevValidFiles.concat(valids) : valids,
            keep ? prevInvalidFiles.concat(invalids) : invalids,
            files, dupFiles, isSingleModel);
        }, options && options.debounce ? options.debounce.change || options.debounce : 0);
      }

      var resizingFiles = validateAfterResize ? allNewFiles : valids;
      resizeFile(resizingFiles, attr, scope, ngModel).then(function () {
        if (validateAfterResize) {
          upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope)
            .then(function (validationResult) {
              valids = validationResult.validsFiles;
              invalids = validationResult.invalidsFiles;
              updateModel();
            });
        } else {
          updateModel();
        }
      }, function () {
        for (var i = 0; i < resizingFiles.length; i++) {
          var f = resizingFiles[i];
          if (f.$error === 'resize') {
            var index = valids.indexOf(f);
            if (index > -1) {
              valids.splice(index, 1);
              invalids.push(f);
            }
            updateModel();
          }
        }
      });
    }

    prevValidFiles = attr.$$ngfPrevValidFiles || [];
    prevInvalidFiles = attr.$$ngfPrevInvalidFiles || [];
    if (ngModel && ngModel.$modelValue) {
      prevValidFiles = toArray(ngModel.$modelValue);
    }

    var keep = upload.attrGetter('ngfKeep', attr, scope);
    allNewFiles = (files || []).slice(0);
    if (keep === 'distinct' || upload.attrGetter('ngfKeepDistinct', attr, scope) === true) {
      removeDuplicates(attr, scope);
    }

    var isSingleModel = !keep && !upload.attrGetter('ngfMultiple', attr, scope) && !upload.attrGetter('multiple', attr);

    if (keep && !allNewFiles.length) return;

    upload.attrGetter('ngfBeforeModelChange', attr, scope, {
      $files: files,
      $file: files && files.length ? files[0] : null,
      $newFiles: allNewFiles,
      $duplicateFiles: dupFiles,
      $event: evt
    });

    var validateAfterResize = upload.attrGetter('ngfValidateAfterResize', attr, scope);

    var options = upload.attrGetter('ngfModelOptions', attr, scope);
    upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope)
      .then(function (validationResult) {
      if (noDelay) {
        update(allNewFiles, [], files, dupFiles, isSingleModel);
      } else {
        if ((!options || !options.allowInvalid) && !validateAfterResize) {
          valids = validationResult.validFiles;
          invalids = validationResult.invalidFiles;
        } else {
          valids = allNewFiles;
        }
        if (upload.attrGetter('ngfFixOrientation', attr, scope) && upload.isExifSupported()) {
          applyExifRotations(valids, attr, scope).then(function () {
            resizeAndUpdate();
          });
        } else {
          resizeAndUpdate();
        }
      }
    });
  };

  return upload;
}]);

ngFileUpload.directive('ngfSelect', ['$parse', '$timeout', '$compile', 'Upload', function ($parse, $timeout, $compile, Upload) {
  var generatedElems = [];

  function isDelayedClickSupported(ua) {
    // fix for android native browser < 4.4 and safari windows
    var m = ua.match(/Android[^\d]*(\d+)\.(\d+)/);
    if (m && m.length > 2) {
      var v = Upload.defaults.androidFixMinorVersion || 4;
      return parseInt(m[1]) < 4 || (parseInt(m[1]) === v && parseInt(m[2]) < v);
    }

    // safari on windows
    return ua.indexOf('Chrome') === -1 && /.*Windows.*Safari.*/.test(ua);
  }

  function linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, upload) {
    /** @namespace attr.ngfSelect */
    /** @namespace attr.ngfChange */
    /** @namespace attr.ngModel */
    /** @namespace attr.ngfModelOptions */
    /** @namespace attr.ngfMultiple */
    /** @namespace attr.ngfCapture */
    /** @namespace attr.ngfValidate */
    /** @namespace attr.ngfKeep */
    var attrGetter = function (name, scope) {
      return upload.attrGetter(name, attr, scope);
    };

    function isInputTypeFile() {
      return elem[0].tagName.toLowerCase() === 'input' && attr.type && attr.type.toLowerCase() === 'file';
    }

    function fileChangeAttr() {
      return attrGetter('ngfChange') || attrGetter('ngfSelect');
    }

    function changeFn(evt) {
      if (upload.shouldUpdateOn('change', attr, scope)) {
        var fileList = evt.__files_ || (evt.target && evt.target.files), files = [];
        /* Handle duplicate call in  IE11 */
        if (!fileList) return;
        for (var i = 0; i < fileList.length; i++) {
          files.push(fileList[i]);
        }
        upload.updateModel(ngModel, attr, scope, fileChangeAttr(),
          files.length ? files : null, evt);
      }
    }

    upload.registerModelChangeValidator(ngModel, attr, scope);

    var unwatches = [];
    if (attrGetter('ngfMultiple')) {
      unwatches.push(scope.$watch(attrGetter('ngfMultiple'), function () {
        fileElem.attr('multiple', attrGetter('ngfMultiple', scope));
      }));
    }
    if (attrGetter('ngfCapture')) {
      unwatches.push(scope.$watch(attrGetter('ngfCapture'), function () {
        fileElem.attr('capture', attrGetter('ngfCapture', scope));
      }));
    }
    if (attrGetter('ngfAccept')) {
      unwatches.push(scope.$watch(attrGetter('ngfAccept'), function () {
        fileElem.attr('accept', attrGetter('ngfAccept', scope));
      }));
    }
    unwatches.push(attr.$observe('accept', function () {
      fileElem.attr('accept', attrGetter('accept'));
    }));
    function bindAttrToFileInput(fileElem, label) {
      function updateId(val) {
        fileElem.attr('id', 'ngf-' + val);
        label.attr('id', 'ngf-label-' + val);
      }

      for (var i = 0; i < elem[0].attributes.length; i++) {
        var attribute = elem[0].attributes[i];
        if (attribute.name !== 'type' && attribute.name !== 'class' && attribute.name !== 'style') {
          if (attribute.name === 'id') {
            updateId(attribute.value);
            unwatches.push(attr.$observe('id', updateId));
          } else {
            fileElem.attr(attribute.name, (!attribute.value && (attribute.name === 'required' ||
            attribute.name === 'multiple')) ? attribute.name : attribute.value);
          }
        }
      }
    }

    function createFileInput() {
      if (isInputTypeFile()) {
        return elem;
      }

      var fileElem = angular.element('<input type="file">');

      var label = angular.element('<label>upload</label>');
      label.css('visibility', 'hidden').css('position', 'absolute').css('overflow', 'hidden')
        .css('width', '0px').css('height', '0px').css('border', 'none')
        .css('margin', '0px').css('padding', '0px').attr('tabindex', '-1');
      bindAttrToFileInput(fileElem, label);

      generatedElems.push({el: elem, ref: label});

      document.body.appendChild(label.append(fileElem)[0]);

      return fileElem;
    }

    function clickHandler(evt) {
      if (elem.attr('disabled')) return false;
      if (attrGetter('ngfSelectDisabled', scope)) return;

      var r = detectSwipe(evt);
      // prevent the click if it is a swipe
      if (r != null) return r;

      resetModel(evt);

      // fix for md when the element is removed from the DOM and added back #460
      try {
        if (!isInputTypeFile() && !document.body.contains(fileElem[0])) {
          generatedElems.push({el: elem, ref: fileElem.parent()});
          document.body.appendChild(fileElem.parent()[0]);
          fileElem.bind('change', changeFn);
        }
      } catch (e) {/*ignore*/
      }

      if (isDelayedClickSupported(navigator.userAgent)) {
        setTimeout(function () {
          fileElem[0].click();
        }, 0);
      } else {
        fileElem[0].click();
      }

      return false;
    }


    var initialTouchStartY = 0;
    var initialTouchStartX = 0;

    function detectSwipe(evt) {
      var touches = evt.changedTouches || (evt.originalEvent && evt.originalEvent.changedTouches);
      if (touches) {
        if (evt.type === 'touchstart') {
          initialTouchStartX = touches[0].clientX;
          initialTouchStartY = touches[0].clientY;
          return true; // don't block event default
        } else {
          // prevent scroll from triggering event
          if (evt.type === 'touchend') {
            var currentX = touches[0].clientX;
            var currentY = touches[0].clientY;
            if ((Math.abs(currentX - initialTouchStartX) > 20) ||
              (Math.abs(currentY - initialTouchStartY) > 20)) {
              evt.stopPropagation();
              evt.preventDefault();
              return false;
            }
          }
          return true;
        }
      }
    }

    var fileElem = elem;

    function resetModel(evt) {
      if (upload.shouldUpdateOn('click', attr, scope) && fileElem.val()) {
        fileElem.val(null);
        upload.updateModel(ngModel, attr, scope, fileChangeAttr(), null, evt, true);
      }
    }

    if (!isInputTypeFile()) {
      fileElem = createFileInput();
    }
    fileElem.bind('change', changeFn);

    if (!isInputTypeFile()) {
      elem.bind('click touchstart touchend', clickHandler);
    } else {
      elem.bind('click', resetModel);
    }

    function ie10SameFileSelectFix(evt) {
      if (fileElem && !fileElem.attr('__ngf_ie10_Fix_')) {
        if (!fileElem[0].parentNode) {
          fileElem = null;
          return;
        }
        evt.preventDefault();
        evt.stopPropagation();
        fileElem.unbind('click');
        var clone = fileElem.clone();
        fileElem.replaceWith(clone);
        fileElem = clone;
        fileElem.attr('__ngf_ie10_Fix_', 'true');
        fileElem.bind('change', changeFn);
        fileElem.bind('click', ie10SameFileSelectFix);
        fileElem[0].click();
        return false;
      } else {
        fileElem.removeAttr('__ngf_ie10_Fix_');
      }
    }

    if (navigator.appVersion.indexOf('MSIE 10') !== -1) {
      fileElem.bind('click', ie10SameFileSelectFix);
    }

    if (ngModel) ngModel.$formatters.push(function (val) {
      if (val == null || val.length === 0) {
        if (fileElem.val()) {
          fileElem.val(null);
        }
      }
      return val;
    });

    scope.$on('$destroy', function () {
      if (!isInputTypeFile()) fileElem.parent().remove();
      angular.forEach(unwatches, function (unwatch) {
        unwatch();
      });
    });

    $timeout(function () {
      for (var i = 0; i < generatedElems.length; i++) {
        var g = generatedElems[i];
        if (!document.body.contains(g.el[0])) {
          generatedElems.splice(i, 1);
          g.ref.remove();
        }
      }
    });

    if (window.FileAPI && window.FileAPI.ngfFixIE) {
      window.FileAPI.ngfFixIE(elem, fileElem, changeFn);
    }
  }

  return {
    restrict: 'AEC',
    require: '?ngModel',
    link: function (scope, elem, attr, ngModel) {
      linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, Upload);
    }
  };
}]);

(function () {

  ngFileUpload.service('UploadDataUrl', ['UploadBase', '$timeout', '$q', function (UploadBase, $timeout, $q) {
    var upload = UploadBase;
    upload.base64DataUrl = function (file) {
      if (angular.isArray(file)) {
        var d = $q.defer(), count = 0;
        angular.forEach(file, function (f) {
          upload.dataUrl(f, true)['finally'](function () {
            count++;
            if (count === file.length) {
              var urls = [];
              angular.forEach(file, function (ff) {
                urls.push(ff.$ngfDataUrl);
              });
              d.resolve(urls, file);
            }
          });
        });
        return d.promise;
      } else {
        return upload.dataUrl(file, true);
      }
    };
    upload.dataUrl = function (file, disallowObjectUrl) {
      if (!file) return upload.emptyPromise(file, file);
      if ((disallowObjectUrl && file.$ngfDataUrl != null) || (!disallowObjectUrl && file.$ngfBlobUrl != null)) {
        return upload.emptyPromise(disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl, file);
      }
      var p = disallowObjectUrl ? file.$$ngfDataUrlPromise : file.$$ngfBlobUrlPromise;
      if (p) return p;

      var deferred = $q.defer();
      $timeout(function () {
        if (window.FileReader && file &&
          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 8') === -1 || file.size < 20000) &&
          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 9') === -1 || file.size < 4000000)) {
          //prefer URL.createObjectURL for handling refrences to files of all sizes
          //since it doesn´t build a large string in memory
          var URL = window.URL || window.webkitURL;
          if (URL && URL.createObjectURL && !disallowObjectUrl) {
            var url;
            try {
              url = URL.createObjectURL(file);
            } catch (e) {
              $timeout(function () {
                file.$ngfBlobUrl = '';
                deferred.reject();
              });
              return;
            }
            $timeout(function () {
              file.$ngfBlobUrl = url;
              if (url) {
                deferred.resolve(url, file);
                upload.blobUrls = upload.blobUrls || [];
                upload.blobUrlsTotalSize = upload.blobUrlsTotalSize || 0;
                upload.blobUrls.push({url: url, size: file.size});
                upload.blobUrlsTotalSize += file.size || 0;
                var maxMemory = upload.defaults.blobUrlsMaxMemory || 268435456;
                var maxLength = upload.defaults.blobUrlsMaxQueueSize || 200;
                while ((upload.blobUrlsTotalSize > maxMemory || upload.blobUrls.length > maxLength) && upload.blobUrls.length > 1) {
                  var obj = upload.blobUrls.splice(0, 1)[0];
                  URL.revokeObjectURL(obj.url);
                  upload.blobUrlsTotalSize -= obj.size;
                }
              }
            });
          } else {
            var fileReader = new FileReader();
            fileReader.onload = function (e) {
              $timeout(function () {
                file.$ngfDataUrl = e.target.result;
                deferred.resolve(e.target.result, file);
                $timeout(function () {
                  delete file.$ngfDataUrl;
                }, 1000);
              });
            };
            fileReader.onerror = function () {
              $timeout(function () {
                file.$ngfDataUrl = '';
                deferred.reject();
              });
            };
            fileReader.readAsDataURL(file);
          }
        } else {
          $timeout(function () {
            file[disallowObjectUrl ? '$ngfDataUrl' : '$ngfBlobUrl'] = '';
            deferred.reject();
          });
        }
      });

      if (disallowObjectUrl) {
        p = file.$$ngfDataUrlPromise = deferred.promise;
      } else {
        p = file.$$ngfBlobUrlPromise = deferred.promise;
      }
      p['finally'](function () {
        delete file[disallowObjectUrl ? '$$ngfDataUrlPromise' : '$$ngfBlobUrlPromise'];
      });
      return p;
    };
    return upload;
  }]);

  function getTagType(el) {
    if (el.tagName.toLowerCase() === 'img') return 'image';
    if (el.tagName.toLowerCase() === 'audio') return 'audio';
    if (el.tagName.toLowerCase() === 'video') return 'video';
    return /./;
  }

  function linkFileDirective(Upload, $timeout, scope, elem, attr, directiveName, resizeParams, isBackground) {
    function constructDataUrl(file) {
      var disallowObjectUrl = Upload.attrGetter('ngfNoObjectUrl', attr, scope);
      Upload.dataUrl(file, disallowObjectUrl)['finally'](function () {
        $timeout(function () {
          var src = (disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl;
          if (isBackground) {
            elem.css('background-image', 'url(\'' + (src || '') + '\')');
          } else {
            elem.attr('src', src);
          }
          if (src) {
            elem.removeClass('ng-hide');
          } else {
            elem.addClass('ng-hide');
          }
        });
      });
    }

    $timeout(function () {
      var unwatch = scope.$watch(attr[directiveName], function (file) {
        var size = resizeParams;
        if (directiveName === 'ngfThumbnail') {
          if (!size) {
            size = {
              width: elem[0].naturalWidth || elem[0].clientWidth,
              height: elem[0].naturalHeight || elem[0].clientHeight
            };
          }
          if (size.width === 0 && window.getComputedStyle) {
            var style = getComputedStyle(elem[0]);
            if (style.width && style.width.indexOf('px') > -1 && style.height && style.height.indexOf('px') > -1) {
              size = {
                width: parseInt(style.width.slice(0, -2)),
                height: parseInt(style.height.slice(0, -2))
              };
            }
          }
        }

        if (angular.isString(file)) {
          elem.removeClass('ng-hide');
          if (isBackground) {
            return elem.css('background-image', 'url(\'' + file + '\')');
          } else {
            return elem.attr('src', file);
          }
        }
        if (file && file.type && file.type.search(getTagType(elem[0])) === 0 &&
          (!isBackground || file.type.indexOf('image') === 0)) {
          if (size && Upload.isResizeSupported()) {
            size.resizeIf = function (width, height) {
              return Upload.attrGetter('ngfResizeIf', attr, scope,
                {$width: width, $height: height, $file: file});
            };
            Upload.resize(file, size).then(
              function (f) {
                constructDataUrl(f);
              }, function (e) {
                throw e;
              }
            );
          } else {
            constructDataUrl(file);
          }
        } else {
          elem.addClass('ng-hide');
        }
      });

      scope.$on('$destroy', function () {
        unwatch();
      });
    });
  }


  /** @namespace attr.ngfSrc */
  /** @namespace attr.ngfNoObjectUrl */
  ngFileUpload.directive('ngfSrc', ['Upload', '$timeout', function (Upload, $timeout) {
    return {
      restrict: 'AE',
      link: function (scope, elem, attr) {
        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfSrc',
          Upload.attrGetter('ngfResize', attr, scope), false);
      }
    };
  }]);

  /** @namespace attr.ngfBackground */
  /** @namespace attr.ngfNoObjectUrl */
  ngFileUpload.directive('ngfBackground', ['Upload', '$timeout', function (Upload, $timeout) {
    return {
      restrict: 'AE',
      link: function (scope, elem, attr) {
        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfBackground',
          Upload.attrGetter('ngfResize', attr, scope), true);
      }
    };
  }]);

  /** @namespace attr.ngfThumbnail */
  /** @namespace attr.ngfAsBackground */
  /** @namespace attr.ngfSize */
  /** @namespace attr.ngfNoObjectUrl */
  ngFileUpload.directive('ngfThumbnail', ['Upload', '$timeout', function (Upload, $timeout) {
    return {
      restrict: 'AE',
      link: function (scope, elem, attr) {
        var size = Upload.attrGetter('ngfSize', attr, scope);
        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfThumbnail', size,
          Upload.attrGetter('ngfAsBackground', attr, scope));
      }
    };
  }]);

  ngFileUpload.config(['$compileProvider', function ($compileProvider) {
    if ($compileProvider.imgSrcSanitizationWhitelist) $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
    if ($compileProvider.aHrefSanitizationWhitelist) $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
  }]);

  ngFileUpload.filter('ngfDataUrl', ['UploadDataUrl', '$sce', function (UploadDataUrl, $sce) {
    return function (file, disallowObjectUrl, trustedUrl) {
      if (angular.isString(file)) {
        return $sce.trustAsResourceUrl(file);
      }
      var src = file && ((disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl);
      if (file && !src) {
        if (!file.$ngfDataUrlFilterInProgress && angular.isObject(file)) {
          file.$ngfDataUrlFilterInProgress = true;
          UploadDataUrl.dataUrl(file, disallowObjectUrl);
        }
        return '';
      }
      if (file) delete file.$ngfDataUrlFilterInProgress;
      return (file && src ? (trustedUrl ? $sce.trustAsResourceUrl(src) : src) : file) || '';
    };
  }]);

})();

ngFileUpload.service('UploadValidate', ['UploadDataUrl', '$q', '$timeout', function (UploadDataUrl, $q, $timeout) {
  var upload = UploadDataUrl;

  function globStringToRegex(str) {
    var regexp = '', excludes = [];
    if (str.length > 2 && str[0] === '/' && str[str.length - 1] === '/') {
      regexp = str.substring(1, str.length - 1);
    } else {
      var split = str.split(',');
      if (split.length > 1) {
        for (var i = 0; i < split.length; i++) {
          var r = globStringToRegex(split[i]);
          if (r.regexp) {
            regexp += '(' + r.regexp + ')';
            if (i < split.length - 1) {
              regexp += '|';
            }
          } else {
            excludes = excludes.concat(r.excludes);
          }
        }
      } else {
        if (str.indexOf('!') === 0) {
          excludes.push('^((?!' + globStringToRegex(str.substring(1)).regexp + ').)*$');
        } else {
          if (str.indexOf('.') === 0) {
            str = '*' + str;
          }
          regexp = '^' + str.replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-]', 'g'), '\\$&') + '$';
          regexp = regexp.replace(/\\\*/g, '.*').replace(/\\\?/g, '.');
        }
      }
    }
    return {regexp: regexp, excludes: excludes};
  }

  upload.validatePattern = function (file, val) {
    if (!val) {
      return true;
    }
    var pattern = globStringToRegex(val), valid = true;
    if (pattern.regexp && pattern.regexp.length) {
      var regexp = new RegExp(pattern.regexp, 'i');
      valid = (file.type != null && regexp.test(file.type)) ||
        (file.name != null && regexp.test(file.name));
    }
    var len = pattern.excludes.length;
    while (len--) {
      var exclude = new RegExp(pattern.excludes[len], 'i');
      valid = valid && (file.type == null || exclude.test(file.type)) &&
        (file.name == null || exclude.test(file.name));
    }
    return valid;
  };

  upload.ratioToFloat = function (val) {
    var r = val.toString(), xIndex = r.search(/[x:]/i);
    if (xIndex > -1) {
      r = parseFloat(r.substring(0, xIndex)) / parseFloat(r.substring(xIndex + 1));
    } else {
      r = parseFloat(r);
    }
    return r;
  };

  upload.registerModelChangeValidator = function (ngModel, attr, scope) {
    if (ngModel) {
      ngModel.$formatters.push(function (files) {
        if (ngModel.$dirty) {
          var filesArray = files;
          if (files && !angular.isArray(files)) {
            filesArray = [files];
          }
          upload.validate(filesArray, 0, ngModel, attr, scope).then(function () {
            upload.applyModelValidation(ngModel, filesArray);
          });
        }
        return files;
      });
    }
  };

  function markModelAsDirty(ngModel, files) {
    if (files != null && !ngModel.$dirty) {
      if (ngModel.$setDirty) {
        ngModel.$setDirty();
      } else {
        ngModel.$dirty = true;
      }
    }
  }

  upload.applyModelValidation = function (ngModel, files) {
    markModelAsDirty(ngModel, files);
    angular.forEach(ngModel.$ngfValidations, function (validation) {
      ngModel.$setValidity(validation.name, validation.valid);
    });
  };

  upload.getValidationAttr = function (attr, scope, name, validationName, file) {
    var dName = 'ngf' + name[0].toUpperCase() + name.substr(1);
    var val = upload.attrGetter(dName, attr, scope, {$file: file});
    if (val == null) {
      val = upload.attrGetter('ngfValidate', attr, scope, {$file: file});
      if (val) {
        var split = (validationName || name).split('.');
        val = val[split[0]];
        if (split.length > 1) {
          val = val && val[split[1]];
        }
      }
    }
    return val;
  };

  upload.validate = function (files, prevLength, ngModel, attr, scope) {
    ngModel = ngModel || {};
    ngModel.$ngfValidations = ngModel.$ngfValidations || [];

    angular.forEach(ngModel.$ngfValidations, function (v) {
      v.valid = true;
    });

    var attrGetter = function (name, params) {
      return upload.attrGetter(name, attr, scope, params);
    };

    var ignoredErrors = (upload.attrGetter('ngfIgnoreInvalid', attr, scope) || '').split(' ');
    var runAllValidation = upload.attrGetter('ngfRunAllValidations', attr, scope);

    if (files == null || files.length === 0) {
      return upload.emptyPromise({'validFiles': files, 'invalidFiles': []});
    }

    files = files.length === undefined ? [files] : files.slice(0);
    var invalidFiles = [];

    function validateSync(name, validationName, fn) {
      if (files) {
        var i = files.length, valid = null;
        while (i--) {
          var file = files[i];
          if (file) {
            var val = upload.getValidationAttr(attr, scope, name, validationName, file);
            if (val != null) {
              if (!fn(file, val, i)) {
                if (ignoredErrors.indexOf(name) === -1) {
                  file.$error = name;
                  (file.$errorMessages = (file.$errorMessages || {}))[name] = true;
                  file.$errorParam = val;
                  if (invalidFiles.indexOf(file) === -1) {
                    invalidFiles.push(file);
                  }
                  if (!runAllValidation) {
                    files.splice(i, 1);
                  }
                  valid = false;
                } else {
                  files.splice(i, 1);
                }
              }
            }
          }
        }
        if (valid !== null) {
          ngModel.$ngfValidations.push({name: name, valid: valid});
        }
      }
    }

    validateSync('pattern', null, upload.validatePattern);
    validateSync('minSize', 'size.min', function (file, val) {
      return file.size + 0.1 >= upload.translateScalars(val);
    });
    validateSync('maxSize', 'size.max', function (file, val) {
      return file.size - 0.1 <= upload.translateScalars(val);
    });
    var totalSize = 0;
    validateSync('maxTotalSize', null, function (file, val) {
      totalSize += file.size;
      if (totalSize > upload.translateScalars(val)) {
        files.splice(0, files.length);
        return false;
      }
      return true;
    });

    validateSync('validateFn', null, function (file, r) {
      return r === true || r === null || r === '';
    });

    if (!files.length) {
      return upload.emptyPromise({'validFiles': [], 'invalidFiles': invalidFiles});
    }

    function validateAsync(name, validationName, type, asyncFn, fn) {
      function resolveResult(defer, file, val) {
        function resolveInternal(fn) {
          if (fn()) {
            if (ignoredErrors.indexOf(name) === -1) {
              file.$error = name;
              (file.$errorMessages = (file.$errorMessages || {}))[name] = true;
              file.$errorParam = val;
              if (invalidFiles.indexOf(file) === -1) {
                invalidFiles.push(file);
              }
              if (!runAllValidation) {
                var i = files.indexOf(file);
                if (i > -1) files.splice(i, 1);
              }
              defer.resolve(false);
            } else {
              var j = files.indexOf(file);
              if (j > -1) files.splice(j, 1);
              defer.resolve(true);
            }
          } else {
            defer.resolve(true);
          }
        }

        if (val != null) {
          asyncFn(file, val).then(function (d) {
            resolveInternal(function () {
              return !fn(d, val);
            });
          }, function () {
            resolveInternal(function () {
              return attrGetter('ngfValidateForce', {$file: file});
            });
          });
        } else {
          defer.resolve(true);
        }
      }

      var promises = [upload.emptyPromise(true)];
      if (files) {
        files = files.length === undefined ? [files] : files;
        angular.forEach(files, function (file) {
          var defer = $q.defer();
          promises.push(defer.promise);
          if (type && (file.type == null || file.type.search(type) !== 0)) {
            defer.resolve(true);
            return;
          }
          if (name === 'dimensions' && upload.attrGetter('ngfDimensions', attr) != null) {
            upload.imageDimensions(file).then(function (d) {
              resolveResult(defer, file,
                attrGetter('ngfDimensions', {$file: file, $width: d.width, $height: d.height}));
            }, function () {
              defer.resolve(false);
            });
          } else if (name === 'duration' && upload.attrGetter('ngfDuration', attr) != null) {
            upload.mediaDuration(file).then(function (d) {
              resolveResult(defer, file,
                attrGetter('ngfDuration', {$file: file, $duration: d}));
            }, function () {
              defer.resolve(false);
            });
          } else {
            resolveResult(defer, file,
              upload.getValidationAttr(attr, scope, name, validationName, file));
          }
        });
      }
      var deffer = $q.defer();
      $q.all(promises).then(function (values) {
        var isValid = true;
        for (var i = 0; i < values.length; i++) {
          if (!values[i]) {
            isValid = false;
            break;
          }
        }
        ngModel.$ngfValidations.push({name: name, valid: isValid});
        deffer.resolve(isValid);
      });
      return deffer.promise;
    }

    var deffer = $q.defer();
    var promises = [];

    promises.push(validateAsync('maxHeight', 'height.max', /image/,
      this.imageDimensions, function (d, val) {
        return d.height <= val;
      }));
    promises.push(validateAsync('minHeight', 'height.min', /image/,
      this.imageDimensions, function (d, val) {
        return d.height >= val;
      }));
    promises.push(validateAsync('maxWidth', 'width.max', /image/,
      this.imageDimensions, function (d, val) {
        return d.width <= val;
      }));
    promises.push(validateAsync('minWidth', 'width.min', /image/,
      this.imageDimensions, function (d, val) {
        return d.width >= val;
      }));
    promises.push(validateAsync('dimensions', null, /image/,
      function (file, val) {
        return upload.emptyPromise(val);
      }, function (r) {
        return r;
      }));
    promises.push(validateAsync('ratio', null, /image/,
      this.imageDimensions, function (d, val) {
        var split = val.toString().split(','), valid = false;
        for (var i = 0; i < split.length; i++) {
          if (Math.abs((d.width / d.height) - upload.ratioToFloat(split[i])) < 0.01) {
            valid = true;
          }
        }
        return valid;
      }));
    promises.push(validateAsync('maxRatio', 'ratio.max', /image/,
      this.imageDimensions, function (d, val) {
        return (d.width / d.height) - upload.ratioToFloat(val) < 0.0001;
      }));
    promises.push(validateAsync('minRatio', 'ratio.min', /image/,
      this.imageDimensions, function (d, val) {
        return (d.width / d.height) - upload.ratioToFloat(val) > -0.0001;
      }));
    promises.push(validateAsync('maxDuration', 'duration.max', /audio|video/,
      this.mediaDuration, function (d, val) {
        return d <= upload.translateScalars(val);
      }));
    promises.push(validateAsync('minDuration', 'duration.min', /audio|video/,
      this.mediaDuration, function (d, val) {
        return d >= upload.translateScalars(val);
      }));
    promises.push(validateAsync('duration', null, /audio|video/,
      function (file, val) {
        return upload.emptyPromise(val);
      }, function (r) {
        return r;
      }));

    promises.push(validateAsync('validateAsyncFn', null, null,
      function (file, val) {
        return val;
      }, function (r) {
        return r === true || r === null || r === '';
      }));

    $q.all(promises).then(function () {

      if (runAllValidation) {
        for (var i = 0; i < files.length; i++) {
          var file = files[i];
          if (file.$error) {
            files.splice(i--, 1);
          }
        }
      }

      runAllValidation = false;
      validateSync('maxFiles', null, function (file, val, i) {
        return prevLength + i < val;
      });

      deffer.resolve({'validFiles': files, 'invalidFiles': invalidFiles});
    });
    return deffer.promise;
  };

  upload.imageDimensions = function (file) {
    if (file.$ngfWidth && file.$ngfHeight) {
      var d = $q.defer();
      $timeout(function () {
        d.resolve({width: file.$ngfWidth, height: file.$ngfHeight});
      });
      return d.promise;
    }
    if (file.$ngfDimensionPromise) return file.$ngfDimensionPromise;

    var deferred = $q.defer();
    $timeout(function () {
      if (file.type.indexOf('image') !== 0) {
        deferred.reject('not image');
        return;
      }
      upload.dataUrl(file).then(function (dataUrl) {
        var img = angular.element('<img>').attr('src', dataUrl)
          .css('visibility', 'hidden').css('position', 'fixed')
          .css('max-width', 'none !important').css('max-height', 'none !important');

        function success() {
          var width = img[0].naturalWidth || img[0].clientWidth;
          var height = img[0].naturalHeight || img[0].clientHeight;
          img.remove();
          file.$ngfWidth = width;
          file.$ngfHeight = height;
          deferred.resolve({width: width, height: height});
        }

        function error() {
          img.remove();
          deferred.reject('load error');
        }

        img.on('load', success);
        img.on('error', error);

        var secondsCounter = 0;
        function checkLoadErrorInCaseOfNoCallback() {
          $timeout(function () {
            if (img[0].parentNode) {
              if (img[0].clientWidth) {
                success();
              } else if (secondsCounter++ > 10) {
                error();
              } else {
                checkLoadErrorInCaseOfNoCallback();
              }
            }
          }, 1000);
        }

        checkLoadErrorInCaseOfNoCallback();

        angular.element(document.getElementsByTagName('body')[0]).append(img);
      }, function () {
        deferred.reject('load error');
      });
    });

    file.$ngfDimensionPromise = deferred.promise;
    file.$ngfDimensionPromise['finally'](function () {
      delete file.$ngfDimensionPromise;
    });
    return file.$ngfDimensionPromise;
  };

  upload.mediaDuration = function (file) {
    if (file.$ngfDuration) {
      var d = $q.defer();
      $timeout(function () {
        d.resolve(file.$ngfDuration);
      });
      return d.promise;
    }
    if (file.$ngfDurationPromise) return file.$ngfDurationPromise;

    var deferred = $q.defer();
    $timeout(function () {
      if (file.type.indexOf('audio') !== 0 && file.type.indexOf('video') !== 0) {
        deferred.reject('not media');
        return;
      }
      upload.dataUrl(file).then(function (dataUrl) {
        var el = angular.element(file.type.indexOf('audio') === 0 ? '<audio>' : '<video>')
          .attr('src', dataUrl).css('visibility', 'none').css('position', 'fixed');

        function success() {
          var duration = el[0].duration;
          file.$ngfDuration = duration;
          el.remove();
          deferred.resolve(duration);
        }

        function error() {
          el.remove();
          deferred.reject('load error');
        }

        el.on('loadedmetadata', success);
        el.on('error', error);
        var count = 0;

        function checkLoadError() {
          $timeout(function () {
            if (el[0].parentNode) {
              if (el[0].duration) {
                success();
              } else if (count > 10) {
                error();
              } else {
                checkLoadError();
              }
            }
          }, 1000);
        }

        checkLoadError();

        angular.element(document.body).append(el);
      }, function () {
        deferred.reject('load error');
      });
    });

    file.$ngfDurationPromise = deferred.promise;
    file.$ngfDurationPromise['finally'](function () {
      delete file.$ngfDurationPromise;
    });
    return file.$ngfDurationPromise;
  };
  return upload;
}
]);

ngFileUpload.service('UploadResize', ['UploadValidate', '$q', function (UploadValidate, $q) {
  var upload = UploadValidate;

  /**
   * Conserve aspect ratio of the original region. Useful when shrinking/enlarging
   * images to fit into a certain area.
   * Source:  http://stackoverflow.com/a/14731922
   *
   * @param {Number} srcWidth Source area width
   * @param {Number} srcHeight Source area height
   * @param {Number} maxWidth Nestable area maximum available width
   * @param {Number} maxHeight Nestable area maximum available height
   * @return {Object} { width, height }
   */
  var calculateAspectRatioFit = function (srcWidth, srcHeight, maxWidth, maxHeight, centerCrop) {
    var ratio = centerCrop ? Math.max(maxWidth / srcWidth, maxHeight / srcHeight) :
      Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
    return {
      width: srcWidth * ratio, height: srcHeight * ratio,
      marginX: srcWidth * ratio - maxWidth, marginY: srcHeight * ratio - maxHeight
    };
  };

  // Extracted from https://github.com/romelgomez/angular-firebase-image-upload/blob/master/app/scripts/fileUpload.js#L89
  var resize = function (imagen, width, height, quality, type, ratio, centerCrop, resizeIf) {
    var deferred = $q.defer();
    var canvasElement = document.createElement('canvas');
    var imageElement = document.createElement('img');
    imageElement.setAttribute('style', 'visibility:hidden;position:fixed;z-index:-100000');
    document.body.appendChild(imageElement);

    imageElement.onload = function () {
      var imgWidth = imageElement.width, imgHeight = imageElement.height;
      imageElement.parentNode.removeChild(imageElement);
      if (resizeIf != null && resizeIf(imgWidth, imgHeight) === false) {
        deferred.reject('resizeIf');
        return;
      }
      try {
        if (ratio) {
          var ratioFloat = upload.ratioToFloat(ratio);
          var imgRatio = imgWidth / imgHeight;
          if (imgRatio < ratioFloat) {
            width = imgWidth;
            height = width / ratioFloat;
          } else {
            height = imgHeight;
            width = height * ratioFloat;
          }
        }
        if (!width) {
          width = imgWidth;
        }
        if (!height) {
          height = imgHeight;
        }
        var dimensions = calculateAspectRatioFit(imgWidth, imgHeight, width, height, centerCrop);
        canvasElement.width = Math.min(dimensions.width, width);
        canvasElement.height = Math.min(dimensions.height, height);
        var context = canvasElement.getContext('2d');
        context.drawImage(imageElement,
          Math.min(0, -dimensions.marginX / 2), Math.min(0, -dimensions.marginY / 2),
          dimensions.width, dimensions.height);
        deferred.resolve(canvasElement.toDataURL(type || 'image/WebP', quality || 0.934));
      } catch (e) {
        deferred.reject(e);
      }
    };
    imageElement.onerror = function () {
      imageElement.parentNode.removeChild(imageElement);
      deferred.reject();
    };
    imageElement.src = imagen;
    return deferred.promise;
  };

  upload.dataUrltoBlob = function (dataurl, name, origSize) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    var blob = new window.Blob([u8arr], {type: mime});
    blob.name = name;
    blob.$ngfOrigSize = origSize;
    return blob;
  };

  upload.isResizeSupported = function () {
    var elem = document.createElement('canvas');
    return window.atob && elem.getContext && elem.getContext('2d') && window.Blob;
  };

  if (upload.isResizeSupported()) {
    // add name getter to the blob constructor prototype
    Object.defineProperty(window.Blob.prototype, 'name', {
      get: function () {
        return this.$ngfName;
      },
      set: function (v) {
        this.$ngfName = v;
      },
      configurable: true
    });
  }

  upload.resize = function (file, options) {
    if (file.type.indexOf('image') !== 0) return upload.emptyPromise(file);

    var deferred = $q.defer();
    upload.dataUrl(file, true).then(function (url) {
      resize(url, options.width, options.height, options.quality, options.type || file.type,
        options.ratio, options.centerCrop, options.resizeIf)
        .then(function (dataUrl) {
          if (file.type === 'image/jpeg' && options.restoreExif !== false) {
            try {
              dataUrl = upload.restoreExif(url, dataUrl);
            } catch (e) {
              setTimeout(function () {throw e;}, 1);
            }
          }
          try {
            var blob = upload.dataUrltoBlob(dataUrl, file.name, file.size);
            deferred.resolve(blob);
          } catch (e) {
            deferred.reject(e);
          }
        }, function (r) {
          if (r === 'resizeIf') {
            deferred.resolve(file);
          }
          deferred.reject(r);
        });
    }, function (e) {
      deferred.reject(e);
    });
    return deferred.promise;
  };

  return upload;
}]);

(function () {
  ngFileUpload.directive('ngfDrop', ['$parse', '$timeout', '$window', 'Upload', '$http', '$q',
    function ($parse, $timeout, $window, Upload, $http, $q) {
      return {
        restrict: 'AEC',
        require: '?ngModel',
        link: function (scope, elem, attr, ngModel) {
          linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, Upload, $http, $q);
        }
      };
    }]);

  ngFileUpload.directive('ngfNoFileDrop', function () {
    return function (scope, elem) {
      if (dropAvailable()) elem.css('display', 'none');
    };
  });

  ngFileUpload.directive('ngfDropAvailable', ['$parse', '$timeout', 'Upload', function ($parse, $timeout, Upload) {
    return function (scope, elem, attr) {
      if (dropAvailable()) {
        var model = $parse(Upload.attrGetter('ngfDropAvailable', attr));
        $timeout(function () {
          model(scope);
          if (model.assign) {
            model.assign(scope, true);
          }
        });
      }
    };
  }]);

  function linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, upload, $http, $q) {
    var available = dropAvailable();

    var attrGetter = function (name, scope, params) {
      return upload.attrGetter(name, attr, scope, params);
    };

    if (attrGetter('dropAvailable')) {
      $timeout(function () {
        if (scope[attrGetter('dropAvailable')]) {
          scope[attrGetter('dropAvailable')].value = available;
        } else {
          scope[attrGetter('dropAvailable')] = available;
        }
      });
    }
    if (!available) {
      if (attrGetter('ngfHideOnDropNotAvailable', scope) === true) {
        elem.css('display', 'none');
      }
      return;
    }

    function isDisabled() {
      return elem.attr('disabled') || attrGetter('ngfDropDisabled', scope);
    }

    if (attrGetter('ngfSelect') == null) {
      upload.registerModelChangeValidator(ngModel, attr, scope);
    }

    var leaveTimeout = null;
    var stopPropagation = $parse(attrGetter('ngfStopPropagation'));
    var dragOverDelay = 1;
    var actualDragOverClass;

    elem[0].addEventListener('dragover', function (evt) {
      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
      evt.preventDefault();
      if (stopPropagation(scope)) evt.stopPropagation();
      // handling dragover events from the Chrome download bar
      if (navigator.userAgent.indexOf('Chrome') > -1) {
        var b = evt.dataTransfer.effectAllowed;
        evt.dataTransfer.dropEffect = ('move' === b || 'linkMove' === b) ? 'move' : 'copy';
      }
      $timeout.cancel(leaveTimeout);
      if (!actualDragOverClass) {
        actualDragOverClass = 'C';
        calculateDragOverClass(scope, attr, evt, function (clazz) {
          actualDragOverClass = clazz;
          elem.addClass(actualDragOverClass);
          attrGetter('ngfDrag', scope, {$isDragging: true, $class: actualDragOverClass, $event: evt});
        });
      }
    }, false);
    elem[0].addEventListener('dragenter', function (evt) {
      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
      evt.preventDefault();
      if (stopPropagation(scope)) evt.stopPropagation();
    }, false);
    elem[0].addEventListener('dragleave', function (evt) {
      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
      evt.preventDefault();
      if (stopPropagation(scope)) evt.stopPropagation();
      leaveTimeout = $timeout(function () {
        if (actualDragOverClass) elem.removeClass(actualDragOverClass);
        actualDragOverClass = null;
        attrGetter('ngfDrag', scope, {$isDragging: false, $event: evt});
      }, dragOverDelay || 100);
    }, false);
    elem[0].addEventListener('drop', function (evt) {
      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
      evt.preventDefault();
      if (stopPropagation(scope)) evt.stopPropagation();
      if (actualDragOverClass) elem.removeClass(actualDragOverClass);
      actualDragOverClass = null;
      extractFilesAndUpdateModel(evt.dataTransfer, evt, 'dropUrl');
    }, false);
    elem[0].addEventListener('paste', function (evt) {
      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
        attrGetter('ngfEnableFirefoxPaste', scope)) {
        evt.preventDefault();
      }
      if (isDisabled() || !upload.shouldUpdateOn('paste', attr, scope)) return;
      extractFilesAndUpdateModel(evt.clipboardData || evt.originalEvent.clipboardData, evt, 'pasteUrl');
    }, false);

    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
      attrGetter('ngfEnableFirefoxPaste', scope)) {
      elem.attr('contenteditable', true);
      elem.on('keypress', function (e) {
        if (!e.metaKey && !e.ctrlKey) {
          e.preventDefault();
        }
      });
    }

    function extractFilesAndUpdateModel(source, evt, updateOnType) {
      if (!source) return;
      // html needs to be calculated on the same process otherwise the data will be wiped
      // after promise resolve or setTimeout.
      var html;
      try {
        html = source && source.getData && source.getData('text/html');
      } catch (e) {/* Fix IE11 that throw error calling getData */
      }
      extractFiles(source.items, source.files, attrGetter('ngfAllowDir', scope) !== false,
        attrGetter('multiple') || attrGetter('ngfMultiple', scope)).then(function (files) {
        if (files.length) {
          updateModel(files, evt);
        } else {
          extractFilesFromHtml(updateOnType, html).then(function (files) {
            updateModel(files, evt);
          });
        }
      });
    }

    function updateModel(files, evt) {
      upload.updateModel(ngModel, attr, scope, attrGetter('ngfChange') || attrGetter('ngfDrop'), files, evt);
    }

    function extractFilesFromHtml(updateOn, html) {
      if (!upload.shouldUpdateOn(updateOn, attr, scope) || typeof html !== 'string') return upload.rejectPromise([]);
      var urls = [];
      html.replace(/<(img src|img [^>]* src) *=\"([^\"]*)\"/gi, function (m, n, src) {
        urls.push(src);
      });
      var promises = [], files = [];
      if (urls.length) {
        angular.forEach(urls, function (url) {
          promises.push(upload.urlToBlob(url).then(function (blob) {
            files.push(blob);
          }));
        });
        var defer = $q.defer();
        $q.all(promises).then(function () {
          defer.resolve(files);
        }, function (e) {
          defer.reject(e);
        });
        return defer.promise;
      }
      return upload.emptyPromise();
    }

    function calculateDragOverClass(scope, attr, evt, callback) {
      var obj = attrGetter('ngfDragOverClass', scope, {$event: evt}), dClass = 'dragover';
      if (angular.isString(obj)) {
        dClass = obj;
      } else if (obj) {
        if (obj.delay) dragOverDelay = obj.delay;
        if (obj.accept || obj.reject) {
          var items = evt.dataTransfer.items;
          if (items == null || !items.length) {
            dClass = obj.accept;
          } else {
            var pattern = obj.pattern || attrGetter('ngfPattern', scope, {$event: evt});
            var len = items.length;
            while (len--) {
              if (!upload.validatePattern(items[len], pattern)) {
                dClass = obj.reject;
                break;
              } else {
                dClass = obj.accept;
              }
            }
          }
        }
      }
      callback(dClass);
    }

    function extractFiles(items, fileList, allowDir, multiple) {
      var maxFiles = upload.getValidationAttr(attr, scope, 'maxFiles');
      if (maxFiles == null) {
        maxFiles = Number.MAX_VALUE;
      }
      var maxTotalSize = upload.getValidationAttr(attr, scope, 'maxTotalSize');
      if (maxTotalSize == null) {
        maxTotalSize = Number.MAX_VALUE;
      }
      var includeDir = attrGetter('ngfIncludeDir', scope);
      var files = [], totalSize = 0;

      function traverseFileTree(entry, path) {
        var defer = $q.defer();
        if (entry != null) {
          if (entry.isDirectory) {
            var promises = [upload.emptyPromise()];
            if (includeDir) {
              var file = {type: 'directory'};
              file.name = file.path = (path || '') + entry.name;
              files.push(file);
            }
            var dirReader = entry.createReader();
            var entries = [];
            var readEntries = function () {
              dirReader.readEntries(function (results) {
                try {
                  if (!results.length) {
                    angular.forEach(entries.slice(0), function (e) {
                      if (files.length <= maxFiles && totalSize <= maxTotalSize) {
                        promises.push(traverseFileTree(e, (path ? path : '') + entry.name + '/'));
                      }
                    });
                    $q.all(promises).then(function () {
                      defer.resolve();
                    }, function (e) {
                      defer.reject(e);
                    });
                  } else {
                    entries = entries.concat(Array.prototype.slice.call(results || [], 0));
                    readEntries();
                  }
                } catch (e) {
                  defer.reject(e);
                }
              }, function (e) {
                defer.reject(e);
              });
            };
            readEntries();
          } else {
            entry.file(function (file) {
              try {
                file.path = (path ? path : '') + file.name;
                if (includeDir) {
                  file = upload.rename(file, file.path);
                }
                files.push(file);
                totalSize += file.size;
                defer.resolve();
              } catch (e) {
                defer.reject(e);
              }
            }, function (e) {
              defer.reject(e);
            });
          }
        }
        return defer.promise;
      }

      var promises = [upload.emptyPromise()];

      if (items && items.length > 0 && $window.location.protocol !== 'file:') {
        for (var i = 0; i < items.length; i++) {
          if (items[i].webkitGetAsEntry && items[i].webkitGetAsEntry() && items[i].webkitGetAsEntry().isDirectory) {
            var entry = items[i].webkitGetAsEntry();
            if (entry.isDirectory && !allowDir) {
              continue;
            }
            if (entry != null) {
              promises.push(traverseFileTree(entry));
            }
          } else {
            var f = items[i].getAsFile();
            if (f != null) {
              files.push(f);
              totalSize += f.size;
            }
          }
          if (files.length > maxFiles || totalSize > maxTotalSize ||
            (!multiple && files.length > 0)) break;
        }
      } else {
        if (fileList != null) {
          for (var j = 0; j < fileList.length; j++) {
            var file = fileList.item(j);
            if (file.type || file.size > 0) {
              files.push(file);
              totalSize += file.size;
            }
            if (files.length > maxFiles || totalSize > maxTotalSize ||
              (!multiple && files.length > 0)) break;
          }
        }
      }

      var defer = $q.defer();
      $q.all(promises).then(function () {
        if (!multiple && !includeDir && files.length) {
          var i = 0;
          while (files[i] && files[i].type === 'directory') i++;
          defer.resolve([files[i]]);
        } else {
          defer.resolve(files);
        }
      }, function (e) {
        defer.reject(e);
      });

      return defer.promise;
    }
  }

  function dropAvailable() {
    var div = document.createElement('div');
    return ('draggable' in div) && ('ondrop' in div) && !/Edge\/12./i.test(navigator.userAgent);
  }

})();

// customized version of https://github.com/exif-js/exif-js
ngFileUpload.service('UploadExif', ['UploadResize', '$q', function (UploadResize, $q) {
  var upload = UploadResize;

  upload.isExifSupported = function () {
    return window.FileReader && new FileReader().readAsArrayBuffer && upload.isResizeSupported();
  };

  function applyTransform(ctx, orientation, width, height) {
    switch (orientation) {
      case 2:
        return ctx.transform(-1, 0, 0, 1, width, 0);
      case 3:
        return ctx.transform(-1, 0, 0, -1, width, height);
      case 4:
        return ctx.transform(1, 0, 0, -1, 0, height);
      case 5:
        return ctx.transform(0, 1, 1, 0, 0, 0);
      case 6:
        return ctx.transform(0, 1, -1, 0, height, 0);
      case 7:
        return ctx.transform(0, -1, -1, 0, height, width);
      case 8:
        return ctx.transform(0, -1, 1, 0, 0, width);
    }
  }

  upload.readOrientation = function (file) {
    var defer = $q.defer();
    var reader = new FileReader();
    var slicedFile = file.slice ? file.slice(0, 64 * 1024) : file;
    reader.readAsArrayBuffer(slicedFile);
    reader.onerror = function (e) {
      return defer.reject(e);
    };
    reader.onload = function (e) {
      var result = {orientation: 1};
      var view = new DataView(this.result);
      if (view.getUint16(0, false) !== 0xFFD8) return defer.resolve(result);

      var length = view.byteLength,
        offset = 2;
      while (offset < length) {
        var marker = view.getUint16(offset, false);
        offset += 2;
        if (marker === 0xFFE1) {
          if (view.getUint32(offset += 2, false) !== 0x45786966) return defer.resolve(result);

          var little = view.getUint16(offset += 6, false) === 0x4949;
          offset += view.getUint32(offset + 4, little);
          var tags = view.getUint16(offset, little);
          offset += 2;
          for (var i = 0; i < tags; i++)
            if (view.getUint16(offset + (i * 12), little) === 0x0112) {
              var orientation = view.getUint16(offset + (i * 12) + 8, little);
              if (orientation >= 2 && orientation <= 8) {
                view.setUint16(offset + (i * 12) + 8, 1, little);
                result.fixedArrayBuffer = e.target.result;
              }
              result.orientation = orientation;
              return defer.resolve(result);
            }
        } else if ((marker & 0xFF00) !== 0xFF00) break;
        else offset += view.getUint16(offset, false);
      }
      return defer.resolve(result);
    };
    return defer.promise;
  };

  function arrayBufferToBase64(buffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  upload.applyExifRotation = function (file) {
    if (file.type.indexOf('image/jpeg') !== 0) {
      return upload.emptyPromise(file);
    }

    var deferred = $q.defer();
    upload.readOrientation(file).then(function (result) {
      if (result.orientation < 2 || result.orientation > 8) {
        return deferred.resolve(file);
      }
      upload.dataUrl(file, true).then(function (url) {
        var canvas = document.createElement('canvas');
        var img = document.createElement('img');

        img.onload = function () {
          try {
            canvas.width = result.orientation > 4 ? img.height : img.width;
            canvas.height = result.orientation > 4 ? img.width : img.height;
            var ctx = canvas.getContext('2d');
            applyTransform(ctx, result.orientation, img.width, img.height);
            ctx.drawImage(img, 0, 0);
            var dataUrl = canvas.toDataURL(file.type || 'image/WebP', 0.934);
            dataUrl = upload.restoreExif(arrayBufferToBase64(result.fixedArrayBuffer), dataUrl);
            var blob = upload.dataUrltoBlob(dataUrl, file.name);
            deferred.resolve(blob);
          } catch (e) {
            return deferred.reject(e);
          }
        };
        img.onerror = function () {
          deferred.reject();
        };
        img.src = url;
      }, function (e) {
        deferred.reject(e);
      });
    }, function (e) {
      deferred.reject(e);
    });
    return deferred.promise;
  };

  upload.restoreExif = function (orig, resized) {
    var ExifRestorer = {};

    ExifRestorer.KEY_STR = 'ABCDEFGHIJKLMNOP' +
      'QRSTUVWXYZabcdef' +
      'ghijklmnopqrstuv' +
      'wxyz0123456789+/' +
      '=';

    ExifRestorer.encode64 = function (input) {
      var output = '',
        chr1, chr2, chr3 = '',
        enc1, enc2, enc3, enc4 = '',
        i = 0;

      do {
        chr1 = input[i++];
        chr2 = input[i++];
        chr3 = input[i++];

        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;

        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }

        output = output +
          this.KEY_STR.charAt(enc1) +
          this.KEY_STR.charAt(enc2) +
          this.KEY_STR.charAt(enc3) +
          this.KEY_STR.charAt(enc4);
        chr1 = chr2 = chr3 = '';
        enc1 = enc2 = enc3 = enc4 = '';
      } while (i < input.length);

      return output;
    };

    ExifRestorer.restore = function (origFileBase64, resizedFileBase64) {
      if (origFileBase64.match('data:image/jpeg;base64,')) {
        origFileBase64 = origFileBase64.replace('data:image/jpeg;base64,', '');
      }

      var rawImage = this.decode64(origFileBase64);
      var segments = this.slice2Segments(rawImage);

      var image = this.exifManipulation(resizedFileBase64, segments);

      return 'data:image/jpeg;base64,' + this.encode64(image);
    };


    ExifRestorer.exifManipulation = function (resizedFileBase64, segments) {
      var exifArray = this.getExifArray(segments),
        newImageArray = this.insertExif(resizedFileBase64, exifArray);
      return new Uint8Array(newImageArray);
    };


    ExifRestorer.getExifArray = function (segments) {
      var seg;
      for (var x = 0; x < segments.length; x++) {
        seg = segments[x];
        if (seg[0] === 255 & seg[1] === 225) //(ff e1)
        {
          return seg;
        }
      }
      return [];
    };


    ExifRestorer.insertExif = function (resizedFileBase64, exifArray) {
      var imageData = resizedFileBase64.replace('data:image/jpeg;base64,', ''),
        buf = this.decode64(imageData),
        separatePoint = buf.indexOf(255, 3),
        mae = buf.slice(0, separatePoint),
        ato = buf.slice(separatePoint),
        array = mae;

      array = array.concat(exifArray);
      array = array.concat(ato);
      return array;
    };


    ExifRestorer.slice2Segments = function (rawImageArray) {
      var head = 0,
        segments = [];

      while (1) {
        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 218) {
          break;
        }
        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 216) {
          head += 2;
        }
        else {
          var length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3],
            endPoint = head + length + 2,
            seg = rawImageArray.slice(head, endPoint);
          segments.push(seg);
          head = endPoint;
        }
        if (head > rawImageArray.length) {
          break;
        }
      }

      return segments;
    };


    ExifRestorer.decode64 = function (input) {
      var chr1, chr2, chr3 = '',
        enc1, enc2, enc3, enc4 = '',
        i = 0,
        buf = [];

      // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
      var base64test = /[^A-Za-z0-9\+\/\=]/g;
      if (base64test.exec(input)) {
        console.log('There were invalid base64 characters in the input text.\n' +
          'Valid base64 characters are A-Z, a-z, 0-9, ' + ', ' / ',and "="\n' +
          'Expect errors in decoding.');
      }
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

      do {
        enc1 = this.KEY_STR.indexOf(input.charAt(i++));
        enc2 = this.KEY_STR.indexOf(input.charAt(i++));
        enc3 = this.KEY_STR.indexOf(input.charAt(i++));
        enc4 = this.KEY_STR.indexOf(input.charAt(i++));

        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;

        buf.push(chr1);

        if (enc3 !== 64) {
          buf.push(chr2);
        }
        if (enc4 !== 64) {
          buf.push(chr3);
        }

        chr1 = chr2 = chr3 = '';
        enc1 = enc2 = enc3 = enc4 = '';

      } while (i < input.length);

      return buf;
    };

    return ExifRestorer.restore(orig, resized);  //<= EXIF
  };

  return upload;
}]);



/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(116); // required here or implicit ??

'use strict';

angular.module('app.myProfile.myProfileDirective', ['app.myProfile.myProfileController' // required here or implicit ??
]).directive('myProfile', [function () {
  return {
    restrict: 'EA',
    templateUrl: 'components/myProfile/myProfileDirectiveView.html',
    controller: 'app.myProfile.myProfileController',
    params: { username: null }
  };
}]);

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(368);

"use strict";

angular.module('app.myProfile.subscriptionHistory', ['app.myProfile.subscriptionHistory.subscriptionHistoryDirective']);

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(369);

"use strict";

angular.module('app.myProfile.subscriptionHistory.subscriptionHistoryDirective', ['app.myProfile.subscriptionHistory.subscriptionHistoryController']).directive('subscriptionHistory', [function () {
    return {
        restrict: 'EA',
        templateUrl: 'components/myProfile/subscriptionHistory/subscriptionHistoryView.html',
        controller: 'subscriptionHistoryController',
        scope: true
    };
}]);

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(370);

angular.module('app.myProfile.subscriptionHistory.subscriptionHistoryController', ['app.myProfile.subscriptionHistory.subscriptionHistoryService']).controller('subscriptionHistoryController', ['$scope', 'subscriptionHistoryService', function ($scope, subscriptionHistory) {
  "use strict";

  $scope.subscriptionHistory = subscriptionHistory;

  $scope.pager = {
    current_page: 1,
    page_size: 10,
    items: [],
    pageChanged: function pageChanged() {
      if (Array.isArray(subscriptionHistory.list)) {
        var start_index = ($scope.pager.current_page - 1) * $scope.pager.page_size;
        var stop_index = start_index + $scope.pager.page_size;
        $scope.pager.items = subscriptionHistory.list.slice(start_index, stop_index);
      }
    }
  };

  $scope.plan_total = function (subscription) {
    if (subscription && subscription.plan) {
      var currency = subscription.currency;
      var plan_totals = subscription.plan.total_amount_in_cents;

      if (typeof plan_totals[currency] !== 'undefined') {
        return plan_totals[currency] / 100;
      }
    }
    return '???';
  };

  var init = function init() {
    subscriptionHistory.retrieve();
  };

  $scope.$watch(function () {
    return subscriptionHistory.list;
  }, function () {
    $scope.pager.current_page = 1;
    $scope.pager.pageChanged();
  });

  init();
}]);

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.myProfile.subscriptionHistory.subscriptionHistoryService', []).factory('subscriptionHistoryService', ['$http', function ($http) {
  "use strict";

  var service = {
    list: null,
    error: null,
    retrieve: function retrieve() {
      return $http.get(window.location.api('my_account/data/subscriptions')).then(
      /**
       * @param {HttpResponse} response
       */
      function (response) {
        /**
         * @type {{subscriptions: Subscription[], error: *}}
         */
        var data = response.data;

        service.error = null;
        if (data.error) {
          service.error = data.error;
        } else if (data.subscriptions) {
          service.list = data.subscriptions;
        } else {
          service.error = 'Failed to retrieve subscription history.';
        }
      });
    }
  };

  return service;
}]);

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(372);

"use strict";

angular.module('app.myProfile.transactionHistory', ['app.myProfile.transactionHistory.transactionHistoryDirective']);

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(373);

"use strict";

angular.module('app.myProfile.transactionHistory.transactionHistoryDirective', ['app.myProfile.transactionHistory.transactionHistoryController']).directive('transactionHistory', [function () {
    return {
        restrict: 'EA',
        templateUrl: 'components/myProfile/transactionHistory/transactionHistoryView.html',
        controller: 'transactionHistoryController',
        scope: true
    };
}]);

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(374);

angular.module('app.myProfile.transactionHistory.transactionHistoryController', ['app.myProfile.transactionHistory.transactionHistoryService']).controller('transactionHistoryController', ['$scope', 'transactionHistoryService', function ($scope, transactionHistory) {
  "use strict";

  $scope.transactionHistory = transactionHistory;

  $scope.pager = {
    current_page: 1,
    page_size: 10,
    items: [],
    pageChanged: function pageChanged() {
      if (Array.isArray(transactionHistory.list)) {
        var start_index = ($scope.pager.current_page - 1) * $scope.pager.page_size;
        var stop_index = start_index + $scope.pager.page_size;
        $scope.pager.items = transactionHistory.list.slice(start_index, stop_index);
      }
    }
  };

  var init = function init() {
    transactionHistory.retrieve();
  };

  $scope.transaction_amount = function (transaction) {
    var unit_amount = parseFloat(transaction.unit_amount_in_cents) / 100;
    var quantity = parseFloat(transaction.quantity);
    var tax = parseFloat(transaction.tax_in_cents) / 100;

    return quantity * unit_amount + tax;
  };

  $scope.transaction_discount = function (transaction) {
    return parseFloat(transaction.discount_in_cents) / 100;
  };

  $scope.transaction_total = function (transaction) {
    return $scope.transaction_amount(transaction) + $scope.transaction_discount(transaction);
  };

  $scope.$watch(function () {
    return transactionHistory.list;
  }, function () {
    $scope.pager.current_page = 1;
    $scope.pager.pageChanged();
  });

  init();
}]);

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.myProfile.transactionHistory.transactionHistoryService', []).factory('transactionHistoryService', ['$http', function ($http) {
  "use strict";

  var service = {
    list: null,
    error: null,
    retrieve: function retrieve() {
      return $http.get(window.location.api('my_account/data/transactions')).then(function (response) {
        var data = response.data;

        service.error = null;
        if (data.error) {
          service.error = data.error;
        } else if (data.transactions) {
          service.list = data.transactions;
        } else {
          service.error = 'Failed to retrieve transaction history.';
        }
      });
    }
  };

  return service;
}]);

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(376);
__webpack_require__(378);

__webpack_require__(381);
__webpack_require__(384);
__webpack_require__(390);
__webpack_require__(391);
__webpack_require__(392);
__webpack_require__(398);

"use strict";

angular.module('app.myHockeyTv', ['app.myHockeyTv.myHockeyTvController', 'app.collegeCommitments.collegeCommitmentsDirective', 'app.myHockeyTv.followersFollowing', 'app.myHockeyTv.myFeed', 'app.myHockeyTv.myGames', 'app.myHockeyTv.upcomingSchedule', 'app.myHockeyTv.watchClips', 'app.myHockeyTv.manageReminders']).config(['$stateProvider', 'PRODUCT', function ($stateProvider, product) {
    $stateProvider.state('app.myHockeyTv', {
        abstract: true,
        url: '/my_' + product.Name.toLowerCase(),
        templateUrl: 'components/myHockeyTv/myHockeyTvView.html',
        controller: 'app.myHockeyTv.myHockeyTvController',
        title: 'My ' + product.Name
    }).state('app.myHockeyTv.collegeCommitments', {
        url: '/college_commitments',
        template: '<college-commitments></college-commitments>',
        subTitle: 'College Commitments',
        isChildState: true
    });
}]);

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(377);

'use strict';

angular.module('app.myHockeyTv.myHockeyTvController', ['app.currentUser', 'app.shared.inactiveSubscriptionOverlay.inactiveSubscriptionOverlayDirective']).controller('app.myHockeyTv.myHockeyTvController', ['$scope', '$state', 'currentUser', function ($scope, $state, currentUser) {
    $scope.state = $state;
    if (currentUser.has_access() || currentUser.is_pass_holder()) {
        $scope.has_access = true;
    }
}]);

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.shared.inactiveSubscriptionOverlay.inactiveSubscriptionOverlayDirective', []).directive('inactiveSubscriptionOverlay', [function () {
    return {
        restrict: 'E',
        templateUrl: 'components/shared/inactiveSubscriptionOverlay/inactiveSubscriptionOverlayView.html'
    };
}]);

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(379);

"use strict";

angular.module('app.collegeCommitments.collegeCommitmentsDirective', ['app.collegeCommitments.collegeCommitmentsController']).directive('collegeCommitments', [function () {
    return {
        restrict: 'E',
        templateUrl: 'components/collegeCommitments/collegeCommitmentsView.html',
        controller: 'app.collegeCommitments.collegeCommitmentsController'
    };
}]);

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(380);

"use strict";

angular.module('app.collegeCommitments.collegeCommitmentsController', ['app.collegeCommitments.collegeCommitmentsList']).controller('app.collegeCommitments.collegeCommitmentsController', ['$scope', 'app.collegeCommitments.collegeCommitmentsList', '$anchorScroll', function ($scope, collegeCommitmentsList, $anchorScroll) {

  $scope.sortData = {
    sortTypeSelected: 'commitDateReverse',
    sortingInprog: true,
    initialSortRun: false
  };
  $scope.collegeCommitmentsList = collegeCommitmentsList;
  $scope.players = null;
  $scope.isInitialized = false;

  $scope.pager = {
    items: [],
    pageSize: 50,
    currentPage: 1,
    pageChanged: function pageChanged() {
      if (Array.isArray($scope.players)) {
        var start = (this.currentPage - 1) * this.pageSize;
        var end = start + this.pageSize;

        this.items = $scope.players.slice(start, end);
      }

      if ($scope.isInitialized) {
        $anchorScroll('scrollToTop');
      }
    },
    reset: function reset() {
      this.currentPage = 1;
      this.pageChanged();
    }
  };

  /**
   *
   * @param {CollegeCommPlayer[]} players
   * @returns {*}
   */
  var updateGridData = function updateGridData(players) {

    var returnVal = null;

    if (players !== null && typeof players !== 'undefined') {
      if (players.length > 0) {

        var tempArray = [];

        for (var i = 0; i < players.length; i++) {

          // fix missing long name fields
          if (players[i].current_team === null || typeof players[i].current_team === 'undefined') {
            players[i].current_team = {
              long_name: ""
            };
          }

          // generate year string
          var tempYearString = "";
          if (players[i].comm_year !== null && typeof players[i].comm_year !== 'undefined') {

            tempYearString = moment(players[i].comm_year).year();
          }

          // generate date string
          var tempDateString = "";
          if (players[i].comm_date !== null && typeof players[i].comm_date !== 'undefined') {
            tempDateString = moment(players[i].comm_date).format('MM/DD/YYYY');
          }

          //generate date string year-order first
          var tempDateStringYearOrder = "";
          if (players[i].comm_date !== null && typeof players[i].comm_date !== 'undefined') {
            tempDateStringYearOrder = moment(players[i].comm_date).format('YYYY/MM/DD');
          }

          var tempObject = {
            "name": players[i].first_name + ' ' + players[i].last_name,
            "nameLastFirst": players[i].last_name + ", " + players[i].first_name,
            "position": players[i].position,
            "commitTeam": players[i].comm_team.long_name,
            "commitDate": tempDateString,
            "commitDateYearOrder": tempDateStringYearOrder,
            "commitYear": tempYearString,
            "currentTeam": players[i].current_team.long_name
          };

          tempArray.push(tempObject);
        }

        returnVal = tempArray;
      }
    }

    return returnVal;
  };

  var sortPlayers = function sortPlayers() {

    $scope.sortData.sortingInprog = true;

    window.setTimeout(function () {

      var tempPlayers = $scope.players.slice(0);

      if ($scope.sortData.sortTypeSelected === "name") {
        tempPlayers.sort(function (a, b) {
          return compare(a["nameLastFirst"], b["nameLastFirst"]);
        });
      } else if ($scope.sortData.sortTypeSelected === "commitDate") {
        tempPlayers.sort(function (a, b) {
          return compare(a["commitDateYearOrder"], b["commitDateYearOrder"]);
        });
      } else if ($scope.sortData.sortTypeSelected === "nameReverse") {
        tempPlayers.sort(function (a, b) {
          return compare(a["nameLastFirst"], b["nameLastFirst"]);
        });
        tempPlayers.reverse();
      } else if ($scope.sortData.sortTypeSelected === "positionReverse") {
        tempPlayers.sort(function (a, b) {
          return compare(a["position"], b["position"]);
        });
        tempPlayers.reverse();
      } else if ($scope.sortData.sortTypeSelected === "commitTeamReverse") {
        tempPlayers.sort(function (a, b) {
          return compare(a["commitTeam"], b["commitTeam"]);
        });
        tempPlayers.reverse();
      } else if ($scope.sortData.sortTypeSelected === "commitYearReverse") {
        tempPlayers.sort(function (a, b) {
          return compare(a["commitYear"], b["commitYear"]);
        });
        tempPlayers.reverse();
      } else if ($scope.sortData.sortTypeSelected === "commitDateReverse") {
        tempPlayers.sort(function (a, b) {
          return compare(a["commitDateYearOrder"], b["commitDateYearOrder"]);
        });
        tempPlayers.reverse();
      } else if ($scope.sortData.sortTypeSelected === "currentTeamReverse") {
        tempPlayers.sort(function (a, b) {
          return compare(a["currentTeam"], b["currentTeam"]);
        });
        tempPlayers.reverse();
      } else {
        tempPlayers.sort(function (a, b) {
          return compare(a[$scope.sortData.sortTypeSelected], b[$scope.sortData.sortTypeSelected]);
        });
      }

      $scope.players = tempPlayers;

      $scope.pager.reset();

      $scope.sortData.sortingInprog = false;
      $scope.$digest();

      $scope.sortData.initialSortRun = true;
    }, 100);
  };

  var init = function init() {
    if (!collegeCommitmentsList.players) {
      collegeCommitmentsList.retrieve();
    }

    $scope.isInitialized = true;
  };

  $scope.$watch(function () {
    return $scope.sortData.sortTypeSelected;
  }, function () {

    if ($scope.players && $scope.sortData.initialSortRun) {
      sortPlayers();
    }
  });

  $scope.$watch(function () {
    return collegeCommitmentsList.players;
  }, function () {

    $scope.players = updateGridData(collegeCommitmentsList.players);

    if ($scope.players) {
      sortPlayers();
    }
  });

  init();
}]);

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.collegeCommitments.collegeCommitmentsList', []).factory('app.collegeCommitments.collegeCommitmentsList', ['$http', function ($http) {
  var commits = void 0;

  return commits = {
    players: null,
    loading: false,
    error: null,
    retrieve: function retrieve() {
      commits.loading = true;
      return $http.get(window.location.api('college_commitments')).then(function (response) {
        var data = response.data ? response.data.results : {};

        if (data.players) {
          commits.players = data.players;
        }
        if (data.error) {
          commits.error = data.error;
        }
        return commits.loading = false;
      }, function () {
        if (data.error) {
          commits.error = data.error;
        }
        return commits.loading = false;
      });
    }
  };
}]);

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(382);
__webpack_require__(118);

"use strict";

angular.module('app.myHockeyTv.followersFollowing', ['app.myHockeyTv.followersFollowing.followersFollowingController']).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.myHockeyTv.followersFollowing', {
        url: '/followers_following',
        templateUrl: 'components/myHockeyTv/followersFollowing/followersFollowingView.html',
        controller: 'app.myHockeyTv.followersFollowing.followersFollowingController',
        subTitle: 'Find New Profiles',
        isChildState: true
    });
}]);

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(383);
__webpack_require__(117);

"use strict";

angular.module('app.myHockeyTv.followersFollowing.followersFollowingController', ['app.myHockeyTv.profileSearch.profileListService', 'app.shared.profileService']).controller('app.myHockeyTv.followersFollowing.followersFollowingController', ['$scope', 'app.myHockeyTv.profileSearch.profileListService', 'app.shared.profileService', function ($scope, profileListService, profileService) {
  var search = null;

  $scope.searching = false;
  $scope.followFilter = 'ifollow';
  $scope.profileService = profileService;

  /**
   * @param {UserProfile} user
   * @returns {boolean}
   */
  $scope.showUser = function (user) {
    switch ($scope.followFilter) {
      case 'ifollow':
        return !!user.is_follower;
      case 'followme':
        return !!user.is_following;
      case 'all':
        return !!user.is_following || !!user.is_follower;
    }
  };

  $scope.noFollowMessage = function () {
    if (!$scope.users || !$scope.users.length) {
      switch ($scope.followFilter) {
        case 'ifollow':
          return 'You currently are not following anybody';
        case 'followme':
          return 'You currently have no followers';
        case 'all':
          return 'You have no followers, neither are you following anybody';
      }
    }

    return null;
  };

  $scope.clearSearch = function () {
    $scope.search = null;
    $scope.searchResult = null;
  };

  $scope.$watch('search', _.debounce(function (val) {
    var canceler = void 0;
    if (val && val.length > 1) {
      $scope.searching = true;
      if (search) {
        canceler = search.deferred;
      } else {
        canceler = null;
      }
      search = profileListService.search($scope.search, canceler);
      search.promise.then(function (response) {
        var data = response.data;
        $scope.searchResult = data && data.results;
        $scope.searching = false;
      });
    }
  }), 300);

  profileListService.retrieve().then(function (response) {
    $scope.users = response.data.feed;
  });
}]);

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.myHockeyTv.profileSearch.profileListService', []).factory('app.myHockeyTv.profileSearch.profileListService', ['$http', '$q', function ($http, $q) {
  var profiles = void 0;
  return profiles = {
    list: null,
    error: null,
    retrieve: function retrieve() {
      return $http.get(window.location.api('user_profiles/follow_all')).then(function (response) {

        var data = response.data;
        var i = void 0,
            len = void 0,
            profile = void 0,
            ref = void 0,
            results = void 0;
        if (data.feed) {
          profiles.list = {};
          ref = data.feed;
          results = [];
          for (i = 0, len = ref.length; i < len; i++) {
            profile = ref[i];
            results.push(profiles.list[profile.iuserid] = profile);
          }
        }
        return response;
      });
    },
    search: function search(term, canceler) {
      var search = void 0;
      if (canceler) {
        canceler.resolve();
      }
      if (term) {
        canceler = $q.defer();
        search = $http.get(window.location.api('user_profiles/search?term=' + term), {
          timeout: canceler.promise
        });
        return {
          promise: search,
          deferred: canceler
        };
      }
    }
  };
}]);

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(385);
__webpack_require__(386);

"use strict";

angular.module('app.myHockeyTv.myFeed', ['app.myHockeyTv.myFeed.myFeedController', 'app.shared.userFeed.userFeedDirective']).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.myHockeyTv.myFeed', {
        url: '/my_feed?:type',
        templateUrl: 'components/myHockeyTv/myFeed/myFeedView.html',
        controller: 'app.myHockeyTv.myFeed.myFeedController',
        subTitle: 'My Feed',
        isChildState: true
    }).state('app.myHockeyTv.myClips', {
        url: '/my_clips',
        templateUrl: 'components/myHockeyTv/myFeed/myFeedView.html',
        controller: 'app.myHockeyTv.myFeed.myFeedController',
        subTitle: 'My Clips',
        isChildState: true,
        params: {
            type: 'clips'
        }
    });
}]);

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1);

'use strict';

angular.module('app.myHockeyTv.myFeed.myFeedController', ['app.currentUser']).controller('app.myHockeyTv.myFeed.myFeedController', ['$scope', 'currentUser', '$stateParams', function ($scope, currentUser, $stateParams) {
    $scope.currentUser = currentUser;
    $scope.feed_type = $stateParams.type;
}]);

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(387);

'use strict';

angular.module('app.shared.userFeed.userFeedDirective', ['app.shared.userFeed.userFeedController', 'app.shared.userPhoto.userPhotoDirective']).directive('userFeed', [function () {
    return {
        restrict: 'EA',
        templateUrl: 'components/shared/userFeed/userFeedView.html',
        controller: 'app.shared.userFeed.userFeedController',
        scope: {
            userId: '<',
            feedType: '<',
            limitFavorites: '<',
            hideControls: '<',
            strictFeed: '<',
            notEditable: '<',
            noFeedText: '@'
        }
    };
}]);

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(388);
__webpack_require__(389);
__webpack_require__(4);
__webpack_require__(14);
__webpack_require__(8);

"use strict";

angular.module('app.shared.userFeed.userFeedController', ['app.shared.userFeed.userFeedService', 'app.shared.userFeed.userFeedSortService', 'app.shared.singleClipService', 'app.favorites.favoritesService', 'app.shared.clipCategoryService']).controller('app.shared.userFeed.userFeedController', ['$scope', 'app.shared.userFeed.userFeedService', '$filter', 'app.shared.userFeed.userFeedSortService', 'app.shared.singleClipService', 'app.favorites.favoritesService', 'app.shared.clipCategoryService', function ($scope, userFeed, $filter, userFeedSort, singleClip, favorites, clipCategoryService) {
  $scope.userFeed = userFeed.new();
  $scope.userFeedSort = userFeedSort;
  $scope.userId = $scope.userId || null;
  $scope.favorites = favorites;
  $scope.limitFavorites = $scope.limitFavorites || false;
  $scope.feed = [];
  $scope.feedType = $scope.feedType || null;
  $scope.groupingCount = 5;

  $scope.pager = {
    items: [],
    pageSize: 50,
    currentPage: 1,
    pageChanged: function pageChanged() {
      var _this = this;

      if (Array.isArray($scope.feed)) {
        var start = (this.currentPage - 1) * this.pageSize;
        var end = start + this.pageSize;

        if (!$scope.feedType) {
          var items = $scope.feed.slice(start, end);
          this.items = [];

          var last_type = null,
              item_group = null;
          var item_count = items.length;
          _.each(items, function (item, index) {
            var reset = item.type != last_type;

            if (reset || index >= item_count - 1) {
              _this.items.push(item_group);
            }

            if (reset) {
              last_type = item.type;
              item_group = {
                type: item.type,
                items: [],
                expanded: false
              };
            }
            item_group.items.push(item);
          });
        } else {
          this.items = $scope.feed.slice(start, end);
        }
      }
    },
    reset: function reset() {
      this.currentPage = 1;
      this.pageChanged();
    },
    max_grouping: 5
  };

  $scope.show_type_filter = !$scope.feedType;
  $scope.item_types = {};
  $scope.clip_categories = {};

  $scope.formatDate = function (start, end) {
    var start_date = moment(start),
        end_date = moment(end);

    return start_date.format('MMMM DD-') + end_date.format('DD, YYYY');
  };

  $scope.filters = {
    type: null,
    clip: {
      category: null
    },
    sort_option: userFeedSort.default_option
  };

  var init = function init() {
    clipCategoryService.getCategories().then(function (response) {
      $scope.clip_categories = response.data;
    });

    $scope.feedType = $filter('singularize')($filter('dasherize')($scope.feedType));
    retrieveFeed();
  };

  var retrieveFeed = function retrieveFeed() {
    var params = null;

    var overrideLimitFavorites = Array.isArray(favorites.selected) && favorites.selected.length === 1 && favorites.selected[0] === 10;

    if (!overrideLimitFavorites && $scope.limitFavorites) {
      params = {
        favorites: favorites.selected
      };
    }
    var type = $filter('pluralize')($scope.feedType);
    $scope.userFeed.retrieve($scope.userId, type, params).then(function () {
      $scope.error = null;
    }).catch();
  };

  $scope.getFilterType = function () {
    if ($scope.feedType) {
      return $scope.feedType;
    } else {
      return $scope.filters.type;
    }
  };

  $scope.sort_feed = function () {
    $scope.feed = userFeedSort.sort($scope.userFeed.items, $scope.filters.sort_option, $scope.getFilterType());
    $scope.pager.reset();
  };

  $scope.isFilterVisible = function (filter) {
    switch (filter) {
      case 'type':
        return $scope.show_type_filter;
      case 'clip_category':
        if ($scope.getFilterType() !== 'clip') {
          return false;
        }
    }
    return true;
  };

  $scope.is_visible = function (item) {
    var filterType = $scope.getFilterType();
    if (filterType) {
      if (filterType !== item.type) {
        return false;
      }
      if ($scope.isFilterVisible('clip_category') && $scope.filters.clip.category) {
        if (parseInt($scope.filters.clip.category) !== item.clip_category.iclipcategoryid) {
          return false;
        }
      }
    }
    return true;
  };

  $scope.toggleLike = function (item) {
    switch (item.type) {
      case 'clip':
        singleClip.toggle_like(item.iclipid).then(function (response) {
          var data = response.data;

          var likes = parseInt(data.likes);
          if (isNaN(likes)) {
            likes = 0;
          }

          item.likes = likes;
          item.i_like = data.i_like;

          var item_index = $scope.feed.findIndex(function (i) {
            return i.type === 'clip' && i.iclipid === item.iclipid;
          });
          if (item_index > -1) {
            $scope.feed[item_index] = item;
          }

          item_index = $scope.userFeed.items.findIndex(function (i) {
            return i.type === 'clip' && i.iclipid === item.iclipid;
          });
          if (item_index > -1) {
            $scope.userFeed.items[item_index] = item;
          }
        });
        break;
    }
  };

  $scope.remove = function (item) {
    switch (item.type) {
      case 'clip':
        var remove = confirm("Are you sure you want to delete this clip?");
        if (remove) {
          singleClip.delete(item.iclipid).then(function (response) {
            if (response.status === 204) {
              var index = $scope.feed.indexOf(item);
              if (index !== -1) {
                $scope.feed.splice(index, 1);
              }

              index = $scope.userFeed.items.indexOf(item);
              if (index !== -1) {
                $scope.feed.splice(index, 1);
              }

              $scope.pager.pageChanged();
            } else if (response.data && response.data.error) {
              alert(response.data.error);
            }
          });
        }
    }
  };

  //convert API values for use by UI
  var convertTempItemValues = function convertTempItemValues(item) {

    item.iispublic = item.iispublic ? "1" : "0";
    item.iperiod = item.iperiod ? item.iperiod.toString() : "0";

    return item;
  };

  $scope.lockRange = function (obj, ref, min, max) {

    var returnVal = true;

    if (obj) {
      if (obj[ref] < min || !obj[ref]) {
        obj[ref] = min;
      } else if (obj[ref] > max) {
        obj[ref] = max;
      }
    } else {
      returnVal = false;
    }

    return returnVal;
  };

  $scope.editClip = function (item) {

    var tempItem = JSON.parse(JSON.stringify(item));

    if (!item.meta) {
      item.meta = {};
    }

    if (tempItem.meta) {
      delete tempItem.meta;
    }

    item.meta.hasError = false;

    tempItem = convertTempItemValues(tempItem);

    item.meta.tempItem = tempItem;
    item.meta.isEditing = true;
  };

  $scope.saveEditClip = function (item) {

    var fieldsToUpdate = {
      "strclipname": item.meta.tempItem.strclipname,
      "dteclipdate": item.meta.tempItem.dteclipdate,
      "strsourceduration": item.meta.tempItem.strsourceduration,
      "iispublic": item.meta.tempItem.iispublic == "1",
      "iperiod": parseInt(item.meta.tempItem.iperiod),
      "itimeinseconds": item.meta.tempItem.clockTime ? item.meta.tempItem.clockTime.minute * 60 + item.meta.tempItem.clockTime.second : 0,
      "strsourcestart": item.meta.tempItem.startClockTime ? item.meta.tempItem.startClockTime.hour * 60 * 60 + item.meta.tempItem.startClockTime.minute * 60 + item.meta.tempItem.startClockTime.second : 0,
      "iclipcategoryid_fk": item.meta.tempItem.iclipcategoryid_fk,
      "ihlw": item.meta.tempItem.ihlw,
      "ihc": item.meta.tempItem.ihc,
      "ihrw": item.meta.tempItem.ihrw,
      "ihld": item.meta.tempItem.ihld,
      "ihrd": item.meta.tempItem.ihrd,
      "ialw": item.meta.tempItem.ialw,
      "iac": item.meta.tempItem.iac,
      "iarw": item.meta.tempItem.iarw,
      "iald": item.meta.tempItem.iald,
      "iard": item.meta.tempItem.iard
    };

    var clockFields = {
      "clockTime": item.meta.tempItem.clockTime,
      "startClockTime": item.meta.tempItem.startClockTime
    };

    singleClip.updateClip(item.meta.tempItem.iclipid, fieldsToUpdate).then(function (response) {
      var data = response.data;

      if (data.error) {
        alert(data.error);
      } else {
        fieldsToUpdate = $.extend(fieldsToUpdate, clockFields);

        for (var prop in fieldsToUpdate) {
          item[prop] = fieldsToUpdate[prop];
        }
        item.iispublic = fieldsToUpdate.iispublic ? "1" : "0";
      }
    });

    item.meta.isEditing = false;
  };

  $scope.collegeCommitmentTeamName = function (item, type) {
    if (item[type]) {
      return item[type].strteamname + ' ' + item[type].strteammascot;
    } else {
      return item[type + '_name'];
    }
  };

  $scope.commitmentYear = function (item) {
    var year = moment(item.comm_year).year();
    return year + '-' + (year + 1).toString().substring(2);
  };

  $scope.close_game_eval = function (item) {
    if (item.type === 'favorite-game' && item.overlay && item.overlay.strperiod.charAt(0) === '3') {
      if (Math.abs(item.overlay.iawayscore - item.overlay.ihomescore) <= 1) {
        item.is_close_game = true;
        return true;
      }
    }

    return false;
  };

  $scope.$watch(function () {
    return $scope.userId;
  }, function () {
    return init();
  });

  $scope.$watch(function () {
    return $scope.userFeed.items;
  }, function () {
    return $scope.sort_feed();
  });

  $scope.$on('favorites_selected', function () {
    if ($scope.limitFavorites) {
      retrieveFeed();
    }
  });

  $scope.$on('favorites_updated', function () {
    if ($scope.limitFavorites) {
      retrieveFeed();
    }
  });
}]);

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1);
__webpack_require__(2);
__webpack_require__(12);

'use strict';

angular.module('app.shared.userFeed.userFeedService', ['app.currentUser', 'app.shared.singleGameService', 'app.shared.dataTransformers.clipTransformer']).factory('app.shared.userFeed.userFeedService', ['$http', 'currentUser', '$rootScope', '$q', '$timeout', '$httpParamSerializerJQLike', 'app.shared.singleGameService', 'app.shared.dataTransformers.clipTransformer', function ($http, currentUser, $rootScope, $q, $timeout, $httpParamSerializerJQLike, singleGame, clipTransformer) {
  return {
    "new": function _new() {
      var feed = {
        user_id: null,
        user: null,
        items: null,
        count: 0,
        error: null,
        _debounceRetrieve: _.debounce(function (deferred, user_id, type, params) {
          if (user_id) {
            feed.user_id = user_id;
          }
          if (feed.user_id) {
            var processResponse = function processResponse(response) {
              var data = response.data;

              if (data.feed) {
                feed.items = _.forEach(data.feed, function (item) {
                  if (item.game && item.game.dtegametimefixed) {
                    var gameTime = moment(item.game.dtegametimefixed);

                    item.game.gametimeday = gameTime.format('ddd');
                    item.game.dtegametimefixed = gameTime.toDate();
                  }

                  if (item.sort_date) {
                    item.sort_date = moment(item.sort_date).toDate();
                  }

                  if (item.iclipid) {
                    item = clipTransformer.transformToUi(item);
                  }

                  if (item.igameid) {
                    item = singleGame.transform(item);
                  }

                  return item;
                });

                //feed.count = data.feed.count;
              }
              if (data.user) {
                feed.user = data.user;
              }
              if (data.error) {
                feed.error = data.error;
              }
              $rootScope.$broadcast('user_feed_changed', {
                user_id: user_id
              });
            };

            feed.error = null;
            params = $httpParamSerializerJQLike(params);
            $http.get(window.location.api('users/' + feed.user_id + '/feed' + (type ? '/' + type : '') + '?' + params), {
              timeout: deferred.promise
            }).then(function (response) {
              processResponse(response);
            }).catch(function (response) {
              processResponse(response);
            });
          }
        }, 300),
        retrieve: function retrieve(user_id, type, params) {
          var deferred = $q.defer();

          feed._debounceRetrieve(deferred, user_id, type, params);

          return deferred.promise;
        },
        title: function title() {
          if (feed.user) {
            if (feed.user.iuserid === currentUser.data.iuserid) {
              return "My Feed";
            } else {
              return feed.user.first_name + "'s Feed";
            }
          }
          return "User Feed";
        }
      };

      return feed;
    }
  };
}]);

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.shared.userFeed.userFeedSortService', []).factory('app.shared.userFeed.userFeedSortService', [function () {
  "use strict";

  var sorter = void 0;
  sorter = {
    options: {
      date_default_asc: {
        label: 'Date default sort (oldest - newest)',
        belongs_to: ['all']
      },
      date_default_desc: {
        label: 'Date default sort (newest - oldest)',
        belongs_to: ['all']
      },
      likes_desc: {
        label: 'Likes (most - least)',
        belongs_to: ['clip']
      },
      likes_asc: {
        label: 'Likes (least - most)',
        belongs_to: ['clip']
      },
      views_desc: {
        label: 'Views (most - least)',
        belongs_to: ['clip']
      },
      views_asc: {
        label: 'Views (least - most)',
        belongs_to: ['clip']
      },
      date_game_added_asc: {
        label: 'Date game added (newest - oldest)',
        belongs_to: ['favorite-game']
      },
      date_game_added_desc: {
        label: 'Date game added (oldest - newest)',
        belongs_to: ['favorite-game']
      }
    },
    default_option: 'date_default_desc',
    option_set_allowed: function option_set_allowed(option, option_set) {
      if (!(option && option.belongs_to)) {
        option = sorter.options[option];
      }
      return option && (option.belongs_to.indexOf('all') !== -1 || option.belongs_to.indexOf(option_set) !== -1);
    },
    sort: function sort(feed, option_name, option_set) {
      if (feed) {
        var option = void 0;
        feed = angular.copy(feed);
        if (!option_name) {
          option = sorter.default_option;
        } else {
          option = sorter.options[option_name];
        }
        if (Array.isArray(feed) && option && sorter.option_set_allowed(option, option_set)) {
          feed.sort(function (a, b) {
            switch (option_name) {
              case 'date_default_asc':
                return compare(a.sort_date, b.sort_date);
              case 'date_default_desc':
                return compare(b.sort_date, a.sort_date);
              case 'likes_asc':
                return compare(a.likes, b.likes, 'number');
              case 'likes_desc':
                return compare(b.likes, a.likes, 'number');
              case 'views_asc':
                return compare(a.watch_count, b.watch_count, 'number');
              case 'views_desc':
                return compare(b.watch_count, a.watch_count, 'number');
              case 'date_game_added_asc':
                return compare(a.dtegametimefixed, b.dtegametimefixed);
              case 'date_game_added_desc':
                return compare(b.dtegametimefixed, a.dtegametimefixed);
            }
          });
        }
      }
      return feed;
    }
  };
  return sorter;
}]);

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(107);

"use strict";

angular.module('app.myHockeyTv.myGames', ['app.shared.teamLineup.teamLineupDirective']).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.myHockeyTv.myGames', {
        url: '/my_games',
        templateUrl: 'components/myHockeyTv/myGames/myGamesView.html',
        subTitle: 'My Games',
        isChildState: true
    });
}]);

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(14);

"use strict";

angular.module('app.myHockeyTv.upcomingSchedule', ['app.favorites.favoritesService']).config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('app.myHockeyTv.upcomingSchedule', {
    url: '/upcoming_schedule',
    templateUrl: 'components/myHockeyTv/upcomingSchedule/upcomingScheduleView.html',
    subTitle: 'Upcoming Schedule (Favorites)',
    isChildState: true,
    controller: ['$scope', 'app.favorites.favoritesService', function ($scope, favoritesService) {
      var oldFavorites = favoritesService.selected;

      $scope.$on('$destroy', function () {
        favoritesService.selected = oldFavorites;
      });
    }]
  });
}]);

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(393);
__webpack_require__(118);
__webpack_require__(395);
__webpack_require__(24);

"use strict";

angular.module('app.myHockeyTv.watchClips', ['app.myHockeyTv.watchClips.watchClipsController', 'app.shared.infiniteCarousel.infiniteCarouselDirective']).config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('app.myHockeyTv.watchClips', {
    url: '/watch_clips',
    templateUrl: 'components/myHockeyTv/watchClips/watchClipsView.html',
    controller: 'app.myHockeyTv.watchClips.watchClipsController',
    controllerAs: 'watchClipsController',
    subTitle: 'Watch Clips',
    isChildState: true
  });
}]);

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(2);
__webpack_require__(4);
__webpack_require__(394);

angular.module('app.myHockeyTv.watchClips.watchClipsController', ['app.myHockeyTv.watchClips.watchClipsService', 'app.myHockeyTv.profileSearch.profileListService', 'app.shared.profileService', 'app.shared.singleGameService', 'app.shared.singleClipService']).controller('app.myHockeyTv.watchClips.watchClipsController', ['$rootScope', '$scope', 'app.myHockeyTv.watchClips.watchClipsService', 'app.shared.singleGameService', 'app.shared.singleClipService', 'CLIP_EVENTS', function ($rootScope, $scope, watchClipsService, singleGame, singleClip, CLIP_EVENTS) {
  "use strict";

  var eventListeners = [];

  $scope.type = "clip";
  $scope.clipsWidth = 150;
  $scope.clipsTemplateDir = 'components/myHockeyTv/watchClips/clipsList.html';
  $scope.clip = singleClip;
  $scope.game = singleGame;
  $scope.loading = false;

  $scope.loadVideo = function (clip) {
    singleClip.retrieve(clip.iclipid).then(function (response) {
      $scope.currentGame = response.data;
      $scope.currentClip = clip;
      singleGame.load(response.data.game);
    });
  };

  $scope.loading = true;
  watchClipsService.retrieve().then(function (data) {
    var currentClip = null;

    if (Array.isArray(data.most_popular) && data.most_popular.length) {
      currentClip = data.most_popular[0];
    } else if (Array.isArray(data.most_recent) && data.most_recent.length) {
      currentClip = data.most_recent[0];
    }

    $scope.loading = false;

    _.forEach(data, function (group) {
      _.forEach(group, function (clip) {
        var away = void 0,
            home = void 0;

        if (clip.game.awayteam.strteamnickname) {
          away = clip.game.awayteam.strteamnickname;
        } else {
          away = clip.game.awayteam.strteamname.substring(0, 3);
        }

        if (clip.game.hometeam.strteamnickname) {
          home = clip.game.hometeam.strteamnickname;
        } else {
          home = clip.game.hometeam.strteamname.substring(0, 3);
        }

        var nickname = '(' + away + '@' + home + ')';

        var long = clip.game.league.strleaguenickname + ' ' + nickname + ' ' + clip.strclipname;
        clip.title = long.substring(0, 30);
        if (clip.title !== long) {
          clip.title += '...';
        }
      });
    });

    $scope.most_popular = data.most_popular;
    $scope.most_recent = data.most_recent;
    $scope.loadVideo(currentClip);
    $scope.currentClip = currentClip;
  });

  eventListeners.push($rootScope.$on(CLIP_EVENTS.FLAGGED_AS_INAPPROPRIATE, function (e, id) {
    var listIndexes = {
      popular: _.findIndex($scope.most_popular, { iclipid: id }),
      recent: _.findIndex($scope.most_recent, { iclipid: id })
    },
        listName = listIndexes.popular !== -1 ? 'popular' : 'recent';

    $scope['most_' + listName].splice(listIndexes[listName], 1);

    if ($scope['most_' + listName].length) {
      $scope.loadVideo($scope['most_' + listName][0]);
    }
    alert('This video clip has been submitted for review.');
  }));

  // Event listeners cleanup
  $scope.$on('$destroy', function () {
    _.invokeMap(eventListeners, _.call);
  });
}]);

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.myHockeyTv.watchClips.watchClipsService', []).factory('app.myHockeyTv.watchClips.watchClipsService', ['$http', function ($http) {
  'use strict';

  return {
    retrieve: function retrieve() {
      return $http.get(window.location.api('clips_features')).then(function (response) {
        return response.data;
      });
    }
  };
}]);

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(396);
__webpack_require__(397);

"use strict";

angular.module('app.shared.infiniteCarousel.infiniteCarouselDirective', ['app.shared.infiniteCarousel.infiniteCarouselController', 'app.shared.resize.resizeDirective']).directive('infiniteCarousel', [function () {
    return {
        restrict: 'E',
        templateUrl: 'components/shared/infiniteCarousel/infiniteCarouselView.html',
        controller: 'app.shared.infiniteCarousel.infiniteCarouselController',
        scope: {
            listTemplate: '=',
            items: '=',
            itemWidth: '=',
            onItemClick: '=?'
        }
    };
}]);

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(76);
__webpack_require__(119);

angular.module('app.shared.infiniteCarousel.infiniteCarouselController', ['app.shared.resize.resizeService', 'app.shared.resize.RESIZE_CONFIG']).controller('app.shared.infiniteCarousel.infiniteCarouselController', ['$scope', '$element', 'app.shared.resize.resizeService', 'RESIZE_CONFIG', function ($scope, $element, resizeService, RESIZE_CONFIG) {
  "use strict";

  var pages = void 0,
      eventListeners = void 0,
      itemsPerPage = void 0,
      currentPageIndex = 0;

  function getItemsPerPage(itemWidth, pageWidth) {
    return Math.floor(pageWidth / itemWidth);
  }

  $scope.nextPage = function () {
    $element.removeClass('backwards').addClass('forward');
    currentPageIndex++;
    currentPageIndex = currentPageIndex > pages.length - 1 ? 0 : currentPageIndex % (pages ? pages.length : 0);
    $scope.currentPage = pages ? pages[currentPageIndex] : [];
  };

  $scope.prevPage = function () {
    $element.removeClass('forward').addClass('backwards');
    currentPageIndex--;
    currentPageIndex = currentPageIndex > -1 ? currentPageIndex % (pages ? pages.length : 0) : pages.length - 1;
    $scope.currentPage = pages ? pages[currentPageIndex] : [];
  };

  eventListeners = [$scope.$on(RESIZE_CONFIG.EVENT_NAME,
  /**
   * @param e
   * @param {*} size
   */
  function (e, size) {
    $element.removeClass('backwards').removeClass('forward');
    itemsPerPage = getItemsPerPage($scope.itemWidth, size.width);
    pages = _.chunk($scope.items, itemsPerPage);
    currentPageIndex = Math.floor(currentPageIndex * itemsPerPage / itemsPerPage);
    $scope.currentPage = pages[currentPageIndex];
  })];

  $scope.$watchCollection('items', function (items) {
    if (items) {
      itemsPerPage = getItemsPerPage($scope.itemWidth, resizeService.getSize($element).width);
      pages = _.chunk(items, itemsPerPage);
      $scope.currentPage = pages[0];
    }
  });

  // Remove Event Listeners
  $scope.$on('$destroy', function () {
    _.invokeMap(eventListeners, _.call);
  });
}]);

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(76);
__webpack_require__(119);

/**
 * @ngdoc directive
 * @name app.shared.resize.resizeDirective:resize
 * @description
 * # Emits and event on the scope when the window is resized
 */
angular.module('app.shared.resize.resizeDirective', ['app.shared.resize.resizeService', 'app.shared.resize.RESIZE_CONFIG']).directive('resize', ['$window', 'app.shared.resize.resizeService', 'RESIZE_CONFIG', function ($window, sizeService, RESIZE_CONFIG) {
  "use strict";

  return {
    restrict: 'A',
    link: function link(scope, element) {
      var resizeHandler = _.debounce(function () {
        scope.$broadcast(RESIZE_CONFIG.EVENT_NAME, sizeService.getSize(element));
      }, RESIZE_CONFIG.DEBOUNCE_MILLIS);

      angular.element($window).bind('resize', resizeHandler);

      // Cleanup  event listener when directive is destroyed
      scope.$on('$destroy', function () {
        angular.element($window).unbind('resize', resizeHandler);
      });
    }
  };
}]);

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(399);

"use strict";

angular.module('app.myHockeyTv.manageReminders', ['app.myHockeyTv.manageReminders.manageRemindersController']).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.myHockeyTv.manageReminders', {
        url: '/reminders?:event',
        templateUrl: 'components/myHockeyTv/manageReminders/manageRemindersView.html',
        controller: 'app.myHockeyTv.manageReminders.manageRemindersController',
        resolve: {
            defaultOptions: ['$stateParams', function ($stateParams) {
                return {
                    icalid_fk: parseInt($stateParams.event)
                };
            }]
        },
        subTitle: 'Manage Reminders',
        isChildState: true
    });
}]);

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(103);
__webpack_require__(400);
__webpack_require__(401);
__webpack_require__(27);
__webpack_require__(120);

"use strict";

angular.module('app.myHockeyTv.manageReminders.manageRemindersController', ['app.coverage.events.eventsService', 'app.myHockeyTv.manageReminders.manageRemindersService', 'app.myHockeyTv.manageReminders.reminderFrequencyListService', 'app.mainErrorService', 'app.myHockeyTv.manageReminders.remindersListService']).controller('app.myHockeyTv.manageReminders.manageRemindersController', ['$scope', 'app.coverage.events.eventsService', 'app.myHockeyTv.manageReminders.manageRemindersService', 'app.myHockeyTv.manageReminders.reminderFrequencyListService', 'mainError', 'app.myHockeyTv.manageReminders.remindersListService', 'defaultOptions', function ($scope, events, manageReminder, reminderFrequencyList, mainError, remindersList, defaultOptions) {
  var init = void 0,
      retrieveEvents = void 0;

  $scope.reminder = null;
  $scope.events = events;
  $scope.remindersList = remindersList;
  $scope.reminderFrequencyList = reminderFrequencyList;
  $scope.manageReminder = manageReminder;
  $scope.event_teams = null;
  $scope.hours_before = [{ value: 1, description: '1 hour before' }, { value: 6, description: '6 hours before' }, { value: 12, description: '12 hours before' }, { value: 24, description: '24 hours before' }];

  init = function init() {
    $scope.clear();
    retrieveEvents(defaultOptions.icalid_fk);
    reminderFrequencyList.retrieve();
    return remindersList.retrieve();
  };
  retrieveEvents = function retrieveEvents(icalid) {
    var event_list_params = void 0;
    if (icalid) {
      event_list_params = {
        include: icalid
      };
    } else {
      event_list_params = null;
    }
    return events.retrieve(event_list_params);
  };
  $scope.save = function () {
    return manageReminder.save($scope.reminder).then(function (response) {
      var data = response.data;

      if (data.error) {
        return mainError.set(data.error);
      } else {
        return $scope.clear();
      }
    },
    /**
     * @param {HttpResponse} response
     * @returns {*}
     */
    function (response) {
      var data = response.data;
      var message = void 0;
      if (data.error) {
        message = data.error;
      } else {
        message = 'Failed to save reminder';
      }
      return mainError.set(message);
    });
  };
  $scope.clear = function () {
    return $scope.reminder = manageReminder["new"](defaultOptions);
  };
  $scope.edit = function (reminderId) {
    var event = void 0;

    $scope.reminder = angular.copy(_.find($scope.remindersList.list, {
      ireminderid: reminderId
    }));

    event = _.find($scope.events.list, {
      calid: $scope.reminder.icalid_fk
    });
    if (!event) {
      retrieveEvents($scope.reminder.icalid_fk);
    }
  };
  $scope.$watch(function () {
    return $scope.reminder.icalid_fk;
  }, function () {
    var promise = events.get_teams_for($scope.reminder.icalid_fk);
    if (promise) {
      promise.then(function (response) {
        var data = response.data;

        if (data.results) {
          return $scope.event_teams = data.results;
        }
      });
    }
  });
  $scope.$on('current_user_changed', function () {
    return retrieveEvents();
  });
  return init();
}]);

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(120);

angular.module('app.myHockeyTv.manageReminders.manageRemindersService', ['app.myHockeyTv.manageReminders.remindersListService']).factory('app.myHockeyTv.manageReminders.manageRemindersService', ['$http', 'app.myHockeyTv.manageReminders.remindersListService', function ($http, remindersList) {
  "use strict";

  return {
    "new": function _new(defaults) {
      if (!defaults) {
        defaults = {};
      }
      return {
        icalid_fk: defaults.icalid_fk || null,
        iremindertypeid_fk: defaults.iremindertypeid_fk || null,
        iteamid_fk: defaults.iteamid_fk || null,
        ireminderfrequencyid_fk: defaults.ireminderfrequencyid_fk || null,
        ireminderhours: defaults.ireminderhours || null,
        strremindername: defaults.strremindername || null
      };
    },
    save: function save(reminder) {
      var reminderId = reminder ? reminder.ireminderid : null;
      reminder = {
        strremindername: reminder.strremindername,
        icalid_fk: reminder.icalid_fk,
        iremindertypeid_fk: reminder.iremindertypeid_fk,
        ireminderfrequencyid_fk: reminder.ireminderfrequencyid_fk,
        iteamid_fk: reminder.iteamid_fk,
        ireminderhours: reminder.ireminderhours
      };

      if (reminderId) {
        return $http.put(window.location.api('reminders/' + reminderId), reminder).then(function (response) {
          remindersList.retrieve();
          return response;
        });
      } else {
        return $http.post(window.location.api('reminders'), reminder).then(function (response) {
          remindersList.retrieve();
          return response;
        });
      }
    },
    delete: function _delete(reminder_id) {
      return $http["delete"](window.location.api('reminders/' + reminder_id)).then(function (response) {
        remindersList.retrieve();
        return response;
      });
    }
  };
}]);

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.myHockeyTv.manageReminders.reminderFrequencyListService', []).factory('app.myHockeyTv.manageReminders.reminderFrequencyListService', ['$http', function ($http) {
  var frequencies = {
    list: null,
    error: null,
    retrieve: function retrieve() {
      return $http.get(window.location.api('reminders_frequencies')).then(
      /**
       * @param {HttpResponse} response
       */
      function (response) {
        var data = response.data;
        if (data.results) {
          frequencies.list = data.results;
        }
        if (data.error) {
          return frequencies.error = data.error;
        }
      },
      /**
       * @param {HttpResponse} response
       */
      function (response) {
        var data = response.data;
        if (data.error) {
          return frequencies.error = data.error;
        }
      });
    }
  };
  return frequencies;
}]);

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(403);
__webpack_require__(405);

"use strict";

angular.module('app.userProfile', ['app.userProfile.userProfileDirective', 'app.userProfile.userProfileController']).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.userProfile', {
        url: '/profiles/:username',
        abstract: true,
        templateUrl: 'components/userProfile/userProfileView.html',
        controller: 'app.userProfile.userProfileController',
        title: 'User Profile',
        resolve: {
            username: ['$stateParams', function ($stateParams) {
                return $stateParams.username;
            }]
        }
    }).state('app.userProfile.feed', {
        url: '',
        underTitle: 'User Clips', //not using subtitle here, main frame applies full-width class, which breaks view in this case.
        isChildState: true,
        templateUrl: 'components/userProfile/userProfileFeedView.html'
    });
}]);

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(404);

"use strict";

angular.module('app.userProfile.userProfileDirective', ['app.userProfile.userProfileDirective.userProfileDirectiveController']).directive('userProfile', [function () {
    return {
        restrict: 'EA',
        templateUrl: 'components/userProfile/userProfileDirective/userProfileDirectiveView.html',
        controller: 'app.userProfile.userProfileDirective.userProfileDirectiveController',
        scope: {
            username: '<'
        }
    };
}]);

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(121);

"use strict";

angular.module('app.userProfile.userProfileDirective.userProfileDirectiveController', ['app.userProfile.userProfileService']).controller('app.userProfile.userProfileDirective.userProfileDirectiveController', ['$scope', 'app.userProfile.userProfileService', 'DEFAULT_PROFILE_IMAGE', function ($scope, userProfile, DEFAULT_PROFILE_IMAGE) {
  $scope.username = $scope.username || null;
  $scope.profile = null;
  $scope.default_profile_image = DEFAULT_PROFILE_IMAGE;

  $scope.games_watched_count = function () {
    var count = void 0;
    if ($scope.profile) {
      count = $scope.profile.live_watched_count + $scope.profile.archived_watched_count;
    } else {
      count = 0;
    }
    if (isNaN(count)) {
      count = 0;
    }
    return count;
  };

  $scope.toggle_follow = function () {
    userProfile.toggleFollow($scope.profile);
  };

  var init = function init() {
    var promise = void 0;
    promise = userProfile.retrieve($scope.username);
    if (promise) {
      return promise.then(function (response) {
        var data = response.data;

        if (data.user) {
          return $scope.profile = data.user;
        }
      });
    }
  };

  return init();
}]);

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(121);
__webpack_require__(1);

"use strict";

angular.module('app.userProfile.userProfileController', ['app.currentUser', 'app.userProfile.userProfileService']).controller('app.userProfile.userProfileController', ['$scope', 'username', '$state', 'currentUser', 'app.userProfile.userProfileService', function ($scope, username, $state, currentUser, userProfile) {
    $scope.state = $state;
    $scope.username = username;
    $scope.enableFollowUser = currentUser.data.username !== username;

    userProfile.getFollow().then(function (users) {
        var user = _.find(users, { username: username });
        $scope.ifollow = !!user.is_follower;
    });

    $scope.onToggleFollow = function (userId) {
        userProfile.toggleFollow(userId).then(function (data) {
            $scope.ifollow = data.following;
        });
    };

    if ($state.is('app.userProfile')) {
        $state.go('app.userProfile.feed');
    }
}]);

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.favorites', []).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.favorites', {
        url: '/favorites',
        templateUrl: 'components/favorites/favoritesView.html',
        fullWidth: true
    });
}]);

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(408);
__webpack_require__(410);

"use strict";

angular.module('app.gamesOfTheWeek', ['app.gamesOfTheWeek.gamesOfTheWeekController', 'app.gamesOfTheWeek.gameCard.gameCardDirective']).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.gotw', {
        url: '/gotw',
        templateUrl: 'components/gamesOfTheWeek/gamesOfTheWeekView.html',
        controller: 'app.gamesOfTheWeek.gamesOfTheWeekController',
        title: 'Games of the Week'
    });
}]);

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1);
__webpack_require__(409);

angular.module('app.gamesOfTheWeek.gamesOfTheWeekController', ['app.currentUser', 'app.gamesOfTheWeek.gamesOfTheWeekService']).controller('app.gamesOfTheWeek.gamesOfTheWeekController', ['$scope', 'currentUser', 'app.gamesOfTheWeek.gamesOfTheWeekService', function ($scope, currentUser, gotw) {
  "use strict";

  $scope.currentUser = currentUser;
  $scope.gotw = gotw;

  var init = function init() {
    gotw.retrieve();
  };

  init();
}]);

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.gamesOfTheWeek.gamesOfTheWeekService', []).factory('app.gamesOfTheWeek.gamesOfTheWeekService', ['$http', function ($http) {
  "use strict";

  var service = {
    list: null,
    date: null,
    error: null,
    retrieve: function retrieve() {
      return $http.get(window.location.api('schedule/games_of_the_week')).then(function (response) {
        var data = response.data;

        service.list = null;
        service.error = null;

        if (data.error) {
          service.error = data.error;
        } else {
          service.list = data.games;
          service.date = {
            start: new Date(data.date.start),
            end: new Date(data.date.end)
          };
        }
      });
    }
  };

  return service;
}]);

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(411);
__webpack_require__(105);

"use strict";

angular.module('app.gamesOfTheWeek.gameCard.gameCardDirective', ['app.gamesOfTheWeek.gameCard.gameCardController', 'app.schedule.scheduleGame.scheduleGameDirective']).directive('gameCard', [function () {
    return {
        restrict: 'E',
        templateUrl: 'components/gamesOfTheWeek/gameCard/gameCardView.html',
        controller: 'app.gamesOfTheWeek.gameCard.gameCardController',
        scope: {
            game: '='
        }
    };
}]);

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1);
__webpack_require__(122);

"use strict";

angular.module('app.gamesOfTheWeek.gameCard.gameCardController', ['app.currentUser', 'app.shared.gameInfo.gameInfoDirective']).controller('app.gamesOfTheWeek.gameCard.gameCardController', ['$scope', 'currentUser', '$state', function ($scope, currentUser, $state) {
    $scope.game = $scope.game || null;
    $scope.currentUser = currentUser;

    $scope.clicked = function () {
        if (currentUser.is_logged_in() && $scope.game.can_play) {
            $state.go('app.play', { type: 'game', id: $scope.game.igameid });
        } else if (currentUser.is_logged_in() && !$scope.game.can_play) {
            $state.go('app.pricing', null, { inherit: false, reload: true });
        } else {
            $state.go('app.login');
        }
    };
}]);

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(413);
__webpack_require__(414);
__webpack_require__(415);
__webpack_require__(115);

"use strict";

angular.module('app.passwordReset', ['app.passwordReset.passwordResetController', 'app.passwordReset.passwordResetSent.passwordResetSentController', 'app.passwordReset.passwordResetSave.passwordResetSaveController', 'app.shared.password.passwordDirective']).config(['$stateProvider', 'PRODUCT', function ($stateProvider, product) {

  var resetTemplate = 'components/passwordReset/passwordResetView.html';
  var sentTemplate = 'components/passwordReset/passwordResetSent/passwordResetSentView.html';
  var saveTemplate = 'components/passwordReset/passwordResetSave/passwordResetSaveView.html';

  if (product.Code != 'htv') {
    resetTemplate = 'assets/templates/' + product.Code + '/passwordReset/passwordResetView.html';
    sentTemplate = 'assets/templates/' + product.Code + '/passwordReset/passwordResetSent/passwordResetSentView.html';
    saveTemplate = 'assets/templates/' + product.Code + '/passwordReset/passwordResetSave/passwordResetSaveView.html';
  }

  $stateProvider.state('app.passwordReset', {
    url: '/password_reset',
    template: '<ui-view></ui-view>',
    controller: ['$state', '$stateParams', function ($state, $stateParams) {
      if ($state.is('app.passwordReset')) {
        $state.go('app.passwordReset.request', $stateParams);
      }
    }]
  }).state('app.passwordReset.request', {
    url: '/request',
    templateUrl: resetTemplate,
    controller: 'app.passwordReset.passwordResetController',
    params: {
      message: null
    },
    title: 'Password Reset',
    noSidebar: true,
    noTitleBar: true
  }).state('app.passwordReset.sent', {
    url: '/sent',
    templateUrl: sentTemplate,
    controller: 'app.passwordReset.passwordResetSent.passwordResetSentController',
    params: {
      email: null
    },
    title: 'Password Reset Request Sent',
    noSidebar: true,
    noTitleBar: true
  }).state('app.passwordReset.save', {
    url: '/save/:token',
    templateUrl: saveTemplate,
    controller: 'app.passwordReset.passwordResetSave.passwordResetSaveController',
    title: 'Save New Password',
    noSidebar: true,
    noTitleBar: true
  });
}]);

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(123);

"use strict";

angular.module('app.passwordReset.passwordResetController', ['app.passwordReset.passwordResetService']).controller('app.passwordReset.passwordResetController', ['$scope', 'app.passwordReset.passwordResetService', '$state', '$stateParams', function ($scope, passwordReset, $state, $stateParams) {
  $scope.email = null;
  $scope.error = null;
  $scope.message = $stateParams.message;

  var processResetRequestResponse = function processResetRequestResponse(data) {
    if (data.error) {
      $scope.error = data.error;
    } else {
      $state.go('app.passwordReset.sent', { email: $scope.email });
    }
  };

  $scope.sendResetRequest = function () {
    passwordReset.sendResetRequest($scope.email).then(
    /**
     * @param {HttpResponse} response
     */
    function (response) {
      processResetRequestResponse(response.data);
    },
    /**
     * @param {HttpResponse} response
     */
    function (response) {
      processResetRequestResponse(response.data);
    });
  };
}]);

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.passwordReset.passwordResetSent.passwordResetSentController', []).controller('app.passwordReset.passwordResetSent.passwordResetSentController', ['$scope', '$stateParams', function ($scope, $stateParams) {
    $scope.email = $stateParams.email;
}]);

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(123);

angular.module('app.passwordReset.passwordResetSave.passwordResetSaveController', ['app.passwordReset.passwordResetService']).controller('app.passwordReset.passwordResetSave.passwordResetSaveController', ['$scope', '$stateParams', 'app.passwordReset.passwordResetService', '$state', function ($scope, $stateParams, passwordReset, $state) {
  "use strict";

  $scope.user = null;
  $scope.new_password = null;
  $scope.confirm_password = null;
  $scope.error = null;
  $scope.passwordPass = false;

  var init = function init() {
    passwordReset.getUserByToken($stateParams.token).then(function (response) {
      $scope.user = response.data;
    });
  };

  $scope.savePassword = function () {
    if ($scope.new_password === $scope.confirm_password) {
      if ($scope.passwordPass) {
        passwordReset.savePassword($scope.user.login_name, $scope.new_password, $stateParams.token).then(function (response) {
          var data = response.data;
          if (data.error) {
            $scope.error = data.error;
          } else {
            $state.go('app.login');
          }
        });
      } else {
        $scope.error = 'Password is too easy to guess';
      }
    } else {
      $scope.error = 'Passwords do not match';
    }
  };

  init();
}]);

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(417);
__webpack_require__(420);
__webpack_require__(113);

"use strict";

angular.module('app.purchase.billingInfo', ['app.purchase.billingInfo.billingInfoController', 'app.purchase.results']).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.purchase.billingInfo', {
        url: '/purchase/billing_info',
        templateUrl: 'components/purchase/billingInfo/billingInfoView.html',
        controller: 'app.purchase.billingInfo.billingInfoController',
        params: {
            plan: null,
            team: null,
            upgrade: false,
            uuid: null
        },
        title: 'Billing Information'
    });
}]);

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(418);
__webpack_require__(419);
__webpack_require__(1);
__webpack_require__(109);

"use strict";

angular.module('app.purchase.billingInfo.billingInfoController', ['app.purchase.billingInfo.billingInfoService', 'app.shared.countryListService', 'app.currentUser', 'app.purchase.purchasePlanService']).controller('app.purchase.billingInfo.billingInfoController', ['$scope', '$stateParams', 'app.purchase.billingInfo.billingInfoService', 'app.shared.countryListService', 'currentUser', '$state', '$q', 'app.purchase.purchasePlanService', '$uibModal', function ($scope, $stateParams, billingInfo, countryList, currentUser, $state, $q, purchasePlan, $uibModal) {
  $scope.countries = countryList.countries;

  $scope.currentUser = currentUser;
  $scope.state = $state;

  $scope.plan = $stateParams.plan;
  $scope.team = $stateParams.team;
  $scope.upgrade = $stateParams.upgrade;
  $scope.uuid = $stateParams.uuid;

  $scope.billingInfo = billingInfo;

  $scope.selectedCurrency = $scope.plan ? $scope.plan.currency : null;
  $scope.hasError = {};
  $scope.billing_error_message = null;
  $scope.submitted = false;
  $scope.purchasing_plan = false;

  var billingModal = null;

  $scope.months = [];
  for (var i = 0; i < 12; i++) {
    $scope.months.push({
      number: i + 1,
      name: moment().month(i).format('MMMM')
    });
  }

  $scope.years = [];
  for (var _i = 0; _i < 20; _i++) {
    $scope.years.push(moment().year() + _i);
  }

  var init = function init() {
    billingInfo.retrieve();

    if ($scope.plan) {
      $scope.purchasing_plan = true;
    }

    if ($scope.upgrade && !$scope.uuid) {
      alert("The id of the subscription to upgrade is missing. Please try again.");
      $state.go('app.pricing', null, { inherit: false, reload: true });
    }
  };

  var modalOpen = function modalOpen() {
    billingModal = $uibModal.open({
      templateUrl: 'billing-info-modal-id.html',
      backdrop: 'static',
      windowClass: 'billing-info-modal',
      backdropClass: 'billing-info-modal-backdrop'
    });
  };

  var modalCancel = function modalCancel() {
    if (billingModal) {
      window.setTimeout(function () {
        billingModal.close();
      }, 1000);
    }
  };

  /*$scope.changeCurrency = (args) => {
    billingInfo.getPlan($scope.plan.plan_code, args)
      .then((response) => {
        let data = response.data;
         if (data.error) {
          alert(data.error);
        }
        else if (data.plan) {
          $scope.plan = data.plan;
        }
        else {
          alert('Failed to retrieve plan.');
        }
      })
  };*/

  $scope.saveBilling = function () {
    modalOpen();
    $scope.submitted = true;
    // We have received errors after enabling the Avalara plugin in Recurly for
    // users that enter "Québec" (with the accent on the e) as part of their address.
    // Passing over "QC" will just "Quebec" will avoid the error.
    if (billingInfo.data.state.trim().toLowerCase() === "québec") {
      billingInfo.data.state = "QC";
    }

    billingInfo.validate(document.getElementById('billing_form')).then(function (token) {
      if ($scope.plan) {
        purchasePlan.purchase($scope.plan, token, $scope.team, $scope.upgrade, $scope.uuid).then(function (data) {
          modalCancel();
          if (data.error) {
            $scope.billing_error_message = data.error;
          } else {
            currentUser.get_current_subscriptions('recurly').then(function () {
              currentUser.update();
              $state.go('app.pricing', {});
            });
          }
        }, function (response) {
          var data = response.data;

          modalCancel();
          if (data.error) {
            $scope.billing_error_message = data.error;
          } else {
            $scope.billing_error_message = 'Failed to validate billing information.';
          }
        });
      } else {
        billingInfo.save(token).then(function (result) {
          modalCancel();
          currentUser.update();
          if (result.data.error) {
            $state.go('app.purchase.results', { result: 'error', message: result.data.error });
          } else {
            if ($scope.billing_error_message !== null) {
              $scope.billing_error_message = null;
            }

            $state.go('app.purchase.results', { result: 'success' });
          }
        });
      }
    },
    /**
     * @param {{fields: Array}} err
     */
    function (err) {
      modalCancel();
      $scope.hasError = {};
      $scope.billing_error_message = err.message + ' (' + err.fields.join(', ') + ')';

      angular.forEach(err.fields, function (field) {
        $scope.hasError[field] = { error: true };
      });
    });
  };

  init();
}]);

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.purchase.billingInfo.billingInfoService', ['app.shared.selectWithDisabledOption.selectWithDisabledOptionDirective']).factory('app.purchase.billingInfo.billingInfoService', ['$http', '$q', function ($http, $q) {
  "use strict";

  /**
   * @typedef {{expiry: Date, currency_code: string, country_code: string}} BillingData
   */

  /**
   * @type {{data: BillingData, error: null, retrieve: retrieve, release: release, validate: validate, save: save, calcDate: calcDate, getPlan: ((p1:*, p2:*))}}
   */

  var billing = {
    data: null,
    error: null,
    retrieve: function retrieve() {
      return $http.get(window.location.api('my_account/billing_info')).then(function (response) {
        var data = response.data;
        if (data.billing_info) {
          billing.data = data.billing_info;
        }
        if (data.error) {
          return billing.error = data.error;
        } else {
          return billing.error = null;
        }
      });
    },
    release: function release() {
      return billing.data = null;
    },
    validate: function validate(form) {
      var deferred = $q.defer();

      recurly.token(form, function (err, token) {
        if (err) {
          deferred.reject(err);
        } else {
          deferred.resolve(token);
        }
      });

      return deferred.promise;
    },
    save: function save(token) {
      return $http.put(window.location.api('my_account/billing_info'), {
        token_id: token.id
      });
    },
    calcDate: function calcDate() {
      if (billing.data) {
        var date = moment(billing.data.expiry);
        if (date.isValid()) {
          billing.data.expiry_month = date.month();
          billing.data.expiry_year = date.year();
        }
      }
    },
    getPlan: function getPlan(plan_code, args) {
      var query = '';
      if (args.currency_code) {
        query += 'currency=' + args.currency_code;
      } else if (args.country_code) {
        query += 'country=' + args.country_code;
      }

      return $http.get(window.location.api('subscriptions/plans/' + plan_code + '?' + query));
    }
  };

  return billing;
}]);

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.shared.countryListService', []).service('app.shared.countryListService', [function () {
  return {
    countries: [{
      abbr: "US",
      name: "United States"
    }, {
      abbr: "CA",
      name: "Canada"
    }, {
      abbr: "AL",
      name: "Albania"
    }, {
      abbr: "AR",
      name: "Argentina"
    }, {
      abbr: "AU",
      name: "Australia"
    }, {
      abbr: "AT",
      name: "Austria"
    }, {
      abbr: "BR",
      name: "Brazil"
    }, {
      abbr: "BS",
      name: "Bahamas"
    }, {
      abbr: "BY",
      name: "Belarus"
    }, {
      abbr: "BE",
      name: "Belgium"
    }, {
      abbr: "KY",
      name: "Cayman Islands"
    }, {
      abbr: "CZ",
      name: "Czech Republic"
    }, {
      abbr: "DK",
      name: "Denmark"
    }, {
      abbr: "EE",
      name: "Estonia"
    }, {
      abbr: "FK",
      name: "Falkland Islands"
    }, {
      abbr: "FI",
      name: "Finland"
    }, {
      abbr: "FR",
      name: "France"
    }, {
      abbr: "DE",
      name: "Germany"
    }, {
      abbr: "GE",
      name: "Georgia"
    }, {
      abbr: "GR",
      name: "Greece"
    }, {
      abbr: "HK",
      name: "Hong Kong"
    }, {
      abbr: "HU",
      name: "Hungary"
    }, {
      abbr: "IN",
      name: "India"
    }, {
      abbr: "IS",
      name: "Iceland"
    }, {
      abbr: "IE",
      name: "Ireland"
    }, {
      abbr: "IL",
      name: "Israel"
    }, {
      abbr: "IT",
      name: "Italy"
    }, {
      abbr: "JP",
      name: "Japan"
    }, {
      abbr: "KZ",
      name: "Kazakhstan"
    }, {
      abbr: "LV",
      name: "Latvia"
    }, {
      abbr: "LT",
      name: "Lithuania"
    }, {
      abbr: "LU",
      name: "Luxembourg"
    }, {
      abbr: "MX",
      name: "Mexico"
    }, {
      abbr: "MM",
      name: "Myanmar"
    }, {
      abbr: "NL",
      name: "Netherlands"
    }, {
      abbr: "NZ",
      name: "New Zealand"
    }, {
      abbr: "NO",
      name: "Norway"
    }, {
      abbr: "PL",
      name: "Poland"
    }, {
      abbr: "RU",
      name: "Russian Federation"
    }, {
      abbr: "RO",
      name: "Romania"
    }, {
      abbr: "SG",
      name: "Singapore"
    }, {
      abbr: "SK",
      name: "Slovakia"
    }, {
      abbr: "SI",
      name: "Slovenia"
    }, {
      abbr: "ZA",
      name: "South Africa"
    }, {
      abbr: "ES",
      name: "Spain"
    }, {
      abbr: "SE",
      name: "Sweden"
    }, {
      abbr: "CH",
      name: "Switzerland"
    }, {
      abbr: "UA",
      name: "Ukraine"
    }, {
      abbr: "GB",
      name: "United Kingdom"
    }]
  };
}]);

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(421);

"use strict";

angular.module('app.purchase.results', ['app.purchase.results.resultsController']).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.purchase.results', {
        url: '/purchase/billing_info/:result',
        templateUrl: 'components/purchase/results/resultsView.html',
        controller: 'app.purchase.results.resultsController',
        title: 'Billing Information',
        params: {
            message: null
        }
    });
}]);

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



angular.module('app.purchase.results.resultsController', []).controller('app.purchase.results.resultsController', ['$scope', '$state', '$stateParams', function ($scope, $state, $stateParams) {
  $scope.result = $stateParams.result;
  $scope.message = $stateParams.message;
}]);

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(423);
__webpack_require__(111);

"use strict";

angular.module('app.accountSettings', ['app.accountSettings.accountSettingsController', 'app.currentUser.subscriptionStatus.subscriptionStatusDirective']).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.accountSettings', {
        url: '/account',
        templateUrl: 'components/accountSettings/accountSettingsView.html',
        controller: 'app.accountSettings.accountSettingsController',
        title: 'Account Settings',
        params: {
            redirect_url: null,
            redirect_params: null
        }
    });
}]);

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1);
__webpack_require__(424);
__webpack_require__(425);
__webpack_require__(112);

"use strict";

angular.module('app.accountSettings.accountSettingsController', ['app.currentUser', 'app.accountSettings.subscriptionsListService', 'app.accountSettings.transactionsListService', 'app.shared.dobSelectorService']).controller('app.accountSettings.accountSettingsController', ['$scope', '$timeout', 'currentUser', 'app.accountSettings.subscriptionsListService', 'app.accountSettings.transactionsListService', 'app.shared.dobSelectorService', '$state', '$stateParams', 'PRODUCT', function ($scope, $timeout, currentUser, subscriptionList, transactionsList, dobSelectorService, $state, $stateParams, PRODUCT) {
  $scope.currentUser = currentUser;
  $scope.subscriptionList = subscriptionList;
  $scope.transactionsList = transactionsList;

  $scope.hasSubscription = false;
  $scope.accountError = null;

  $scope.edit = {
    name: false,
    username: false,
    email: false,
    password: false,
    strgender: false,
    phone_number: false,
    mob: false
  };

  $scope.product = PRODUCT;

  $scope.beginEdit = function (field) {
    switch (field) {
      case 'name':
        $scope.edit.name = [{
          field: 'first_name',
          value: currentUser.data.first_name
        }, {
          field: 'last_name',
          value: currentUser.data.last_name
        }];
        break;
      case 'password':
        $scope.edit.password = true;
        currentUser.reset_password(currentUser.data.login_name);
        $timeout(function () {
          $scope.edit.password = false;
        }, 3000);
        break;
      case 'mob':
        $scope.edit[field] = [{
          field: field,
          date: dobSelectorService.new()
        }];

        if (currentUser.data.mob) {
          $scope.edit[field][0].date.month = currentUser.data.mob.getMonth() + 1;
          $scope.edit[field][0].date.day = currentUser.data.mob.getDate();
          $scope.edit[field][0].date.year = currentUser.data.mob.getFullYear();
        }
        break;
      default:
        $scope.edit[field] = [{
          field: field,
          value: currentUser.data[field]
        }];
        break;
    }
  };

  $scope.save = function (field) {
    var data = {};
    for (var i = 0; i < $scope.edit[field].length; i++) {
      var item = $scope.edit[field][i];

      if (item.field === 'mob') {
        data[item.field] = item.date.getDate().format('YYYY-MM');
      } else {
        data[item.field] = item.value;
      }
    }
    currentUser.save(data).then(function (response) {
      var data = response.data;

      if (data.error) {
        $scope.accountError = data.error;
      }
    });

    $scope.edit[field] = false;
  };

  $scope.cancel = function (field) {
    $scope.edit[field] = false;
  };

  subscriptionList.retrieve();
  transactionsList.retrieve();

  $scope.$watch(function () {
    return currentUser.data.has_all_acc_info;
  }, function () {
    if (currentUser.data.has_all_acc_info && typeof $stateParams.redirect_url === 'string' && PRODUCT.Code === 'htv') {
      var params = null;

      if ($stateParams.redirect_params) {
        params = $stateParams.redirect_params;
      }

      $timeout(function () {
        $state.go($stateParams.redirect_url, params);
      }, 500);
    }
  });
}]);

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.accountSettings.subscriptionsListService', []).factory('app.accountSettings.subscriptionsListService', ['$http', function ($http) {
    var service = {
        list: null,
        error: null,
        retrieve: function retrieve() {
            return $http.get(window.location.api('my_account/data/subscriptions')).then(function (response) {
                var data = response.data;
                service.list = null;

                if (data.error) {
                    service.error = data.error;
                }

                if (data.subscriptions) {
                    service.list = data.subscriptions;
                }
            }, function (response) {
                var data = response.data;

                if (data && data.error) {
                    service.error = data.error;
                } else {
                    service.error = 'Failed to retrieve subscription history.';
                }
            });
        }
    };

    return service;
}]);

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.accountSettings.transactionsListService', []).factory('app.accountSettings.transactionsListService', ['$http', function ($http) {
  "use strict";

  var service = {
    list: null,
    error: null,
    retrieve: function retrieve() {
      return $http.get(window.location.api('my_account/data/transactions')).then(function (response) {
        var data = response.data;
        service.list = null;

        if (data.error) {
          service.error = data.error;
        }

        if (data.transactions) {
          service.list = data.transactions;

          for (var i = 0; i < service.list.length; i++) {
            service.list[i].created_at = moment(service.list[i].created_at).toDate();
          }
        }
      }, function (response) {
        var data = response.data;

        if (data && data.error) {
          service.error = data.error;
        } else {
          service.error = 'Failed to retrieve transaction history.';
        }
      });
    }
  };

  return service;
}]);

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.accessDenied', []).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.accessDenied', {
        templateUrl: 'components/accessDenied/accessDeniedView.html',
        controller: ['$scope', '$stateParams', function ($scope, $stateParams) {
            $scope.message = $stateParams.message;
            $scope.template = $stateParams.template;
        }],
        title: 'Access Denied',
        noSidebar: true,
        noTopControls: true,
        params: {
            message: null,
            template: null
        }
    });
}]);

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(428);
__webpack_require__(431);
__webpack_require__(434);
__webpack_require__(437);
__webpack_require__(440);
__webpack_require__(449);
__webpack_require__(452);

"use strict";

angular.module('app.admin', ['app.admin.adGenerator', 'app.admin.passManager', 'app.admin.rosters', 'app.admin.teamInfoManager', 'app.admin.broadcastManager', 'app.admin.reports', 'app.admin.videoAnalysis']).config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('app.admin', {
    abstract: true,
    url: '/admin',
    template: '<div ui-view class="admin"></div>'
  });
}]);

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(429);

"use strict";

angular.module('app.admin.adGenerator', ['app.admin.adGenerator.adGeneratorController']).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.admin.adGenerator', {
        url: '/ad_generator',
        controller: 'app.admin.adGenerator.adGeneratorController',
        templateUrl: 'components/admin/adGenerator/adGeneratorView.html',
        title: 'Intelligent Ad Generator'
    });
}]);

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(430);

"use strict";

angular.module('app.admin.adGenerator.adGeneratorController', ['app.admin.adGenerator.adGeneratorService']).controller('app.admin.adGenerator.adGeneratorController', ['$scope', 'app.admin.adGenerator.adGeneratorService', '$sce', function ($scope, adGeneratorService, $sce) {
  $scope.sizes = null;
  $scope.leagues = null;
  $scope.teams = null;

  $scope.selectedSize = null;
  $scope.selectedLeague = null;
  $scope.selectedTeam = null;
  $scope.code = null;

  $scope.getCode = function () {
    var id = void 0,
        type = void 0;

    var size = $scope.selectedSize;

    if ($scope.selectedTeam) {
      id = $scope.selectedTeam;
      type = 'team';
    } else if ($scope.selectedLeague) {
      id = $scope.selectedLeague;
      type = 'league';
    }

    if (id && type && size) {
      adGeneratorService.getAd(type, id, size).then(function (response) {
        $scope.code = $sce.trustAsHtml(response.data);
      });
    }
  };

  $scope.getTeams = function () {
    adGeneratorService.getTeams($scope.selectedLeague).then(function (response) {
      var data = response.data;

      if (data.error) {
        alert(data.error);
      } else {
        $scope.teams = data;
      }
    });
  };

  adGeneratorService.getSizes().then(function (response) {
    var data = response.data;

    if (data.error) {
      alert(data.error);
    } else {
      $scope.sizes = data;
    }
  });

  adGeneratorService.getLeagues().then(function (response) {
    var data = response.data;

    if (data.error) {
      alert(data.error);
    } else {
      $scope.leagues = data;
    }
  });
}]);

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(73);

angular.module('app.admin.adGenerator.adGeneratorService', ['app.shared.leaguesService']).factory('app.admin.adGenerator.adGeneratorService', ['$http', '$q', 'app.shared.leaguesService', function ($http, $q, leaguesService) {
  "use strict";

  return {
    getLeagues: function getLeagues() {
      return leaguesService.getList();
    },
    getTeams: function getTeams(league_id) {
      return leaguesService.getTeams(league_id);
    },
    getSizes: function getSizes() {
      var deferred = $q.defer();

      deferred.resolve({
        data: ['728x90', '300x250']
      });

      return deferred.promise;
    },
    getAd: function getAd(type, id, size) {
      if (type && id && size) {
        return $http.get(window.location.api('ad_builder/' + type + '?id=' + id + '&size=' + size));
      }
    }
  };
}]);

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(432);

"use strict";

angular.module('app.admin.passManager', ['app.admin.passManager.passManagerController']).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.admin.passManager', {
        url: '/pass_manager/:teamId',
        controller: 'app.admin.passManager.passManagerController',
        templateUrl: 'components/admin/passManager/passManagerView.html',
        title: 'Pass Manager'
    });
}]);

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(433);
__webpack_require__(61);

"use strict";

angular.module('app.admin.passManager.passManagerController', ['app.admin.passManager.passManagerService', 'app.shared.teamService']).filter('accessScopeMaxCount', function () {
  return function (access_scopes, auth_counts, userAccess) {
    return _.filter(access_scopes,
    /**
     * @param {UserAccessScope} scope
     * @returns {boolean}
     */
    function (scope) {
      var counts = auth_counts[scope.iaccessscopeid][userAccess.iaccessfunctionid_fk];
      if (counts && counts.max) {
        return true;
      }
    });
  };
}).controller('app.admin.passManager.passManagerController', ['$scope', '$q', '$stateParams', 'app.admin.passManager.passManagerService', 'app.shared.teamService', function ($scope, $q, $stateParams, passManagerService, teamService) {

  var newAccessMap = {},
      USER_AFFILIATION_TYPE_ID = 2;

  $scope.usedScopes = [];

  var updateAccess = function updateAccess(user, access, newAccess) {
    var userIndex = _.indexOf($scope.users, user),
        accessIndex = _.indexOf($scope.users[userIndex], access);
    $scope.users[userIndex].access[accessIndex] = newAccess.data;
  };

  $scope.lookupUser = function (user) {
    passManagerService.getUserByEmail($stateParams.teamId, user.login_name).then(function (response) {
      var index = _.indexOf($scope.users, user);
      $scope.users[index] = response.data;
    });
  };

  $scope.addUser = function () {
    $scope.users.push({});
  };

  $scope.addAccess = function (user) {
    if (!user.access) {
      user.access = [];
    }

    user.access.push({
      iisactive: 1,
      iuserid_fk: user.iuserid,
      iuseraffiliationtypeid_fk: USER_AFFILIATION_TYPE_ID,
      iuseraffiliationkeyid_fk: Number($stateParams.teamId)
    });

    if (!newAccessMap[user.iuserid]) {
      newAccessMap[user.iuserid] = [];
    }
    newAccessMap[user.iuserid].push(user.access.length - 1);
  };

  $scope.save = function () {
    var promiseList = [];
    $scope.savingAll = true;
    _.forEach($scope.users, function (user, i) {
      promiseList.push($scope.saveUser(user, i));
    });

    $q.all(_.flatten(promiseList)).then(function () {
      $scope.savingAll = false;
    });
  };

  $scope.saveUser = function (user, userIndex) {
    var promises = [];
    _.forEach(user.access, function (access, i) {
      var promise = void 0,
          method = void 0;
      if (_.includes(newAccessMap[user.iuserid], i)) {
        _.remove(newAccessMap[user.iuserid], function (el) {
          return el === i;
        });
        method = 'createAccess';
      } else {
        method = 'updateAccess';
      }
      promise = passManagerService[method](access).then(function (response) {
        var data = response.data;

        if (data.error) {
          alert(data.error, user.login_name);
        }

        if (data.access) {
          $scope.users[userIndex].access[i] = data.access;
        }

        if (data.counts) {
          $scope.auth_counts = data.counts;
        }
      });

      promises.push(promise);
    });
    return promises;
  };

  $q.all(teamService.getTeam($stateParams.teamId).then(
  /**
   * @param {HttpResponse} response
   */
  function (response) {
    /**
     * @type {Team}
     */
    var team = response.data;
    $scope.team_name = team.strteamname + ' ' + team.strteammascot;
  }), passManagerService.getAuthCounts($stateParams.teamId).then(function (response) {
    $scope.auth_counts = response.data.counts;
    $scope.users = _.map(response.data.users, function (user) {
      return user;
    });
  }), passManagerService.getUserRoles().then(function (response) {
    $scope.user_roles = response.data;
  }), passManagerService.getAccessFunctions().then(function (response) {
    $scope.access_functions = response.data;
  }), passManagerService.getAccessScopes().then(function (response) {
    if (Array.isArray(response.data)) {
      var scopes = [];
      _.forEach([3, 2, 1, 99], function (scope_id) {
        _.forEach(response.data, function (scope) {
          if (scope.iaccessscopeid === scope_id) {
            scopes.push(scope);
            return false;
          }
        });
      });
      $scope.access_scopes = scopes;
    } else {
      $scope.access_scopes = null;
    }
  })).then(function () {
    $scope.$applyAsync(function () {
      $scope.showTable = true;
    });
  });
}]);

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(9);

angular.module('app.admin.passManager.passManagerService', ['app.transformResource']).factory('app.admin.passManager.passManagerService', ['$http', '$q', 'app.transformResource', function ($http, $q, transformResource) {

  return {
    createAccess: function createAccess(access) {

      return $http.post(window.location.api('security/access'), {
        iaccessscopeid_fk: access.iaccessscopeid_fk,
        iuseraffiliationtypeid_fk: access.iuseraffiliationtypeid_fk,
        iuseraffiliationkeyid_fk: access.iuseraffiliationkeyid_fk,
        iaccessfunctionid_fk: access.iaccessfunctionid_fk,
        iaccessroleid_fk: access.iaccessroleid_fk,
        iuserid_fk: access.iuserid_fk,
        iisactive: access.iisactive,
        strnotes: access.strnotes
      });
    },
    /**
     * @param {UserAccess} access
     * @returns {Promise}
     */
    updateAccess: function updateAccess(access) {
      return $http.put(window.location.api('security/access/' + access.iuseraccessid), {
        iaccessscopeid_fk: access.iaccessscopeid_fk,
        iaccessfunctionid_fk: access.iaccessfunctionid_fk,
        iaccessroleid_fk: access.iaccessroleid_fk,
        iisactive: access.iisactive,
        strnotes: access.strnotes
      });
    },
    getAuthCounts: function getAuthCounts(teamId) {
      return $http.get(window.location.api('security/auth_counts/team/' + teamId));
    },
    getUserByEmail: function getUserByEmail(affiliation_key, email) {
      return $http.get(window.location.api('security/lookup_user?email=' + email + '&affiliation_key=' + affiliation_key + '&affiliation_type=3'));
    },
    getUserRoles: function getUserRoles() {
      return $http.get(window.location.api('security/user_roles/'));
    },
    getAccessFunctions: function getAccessFunctions() {
      return $http.get(window.location.api('security/access_functions/'));
    },
    getAccessScopes: function getAccessScopes() {
      return $http({
        method: 'GET',
        url: window.location.api('security/access_scopes/'),
        transformResponse: transformResource.onResponse(function (data) {
          return _.orderBy(data,
          /**
           * @param {UserAccessScope} data
           * @returns {number}
           */
          function (data) {
            switch (data.straccessscopedesc) {
              case 'Team':
                return 1;
              case 'League':
                return 2;
              case 'Platform':
                return 3;
              case 'All Access':
                return 4;
              default:
                return 5;
            }
          });
        })
      });
    }
  };
}]);

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(435);

"use strict";

angular.module('app.admin.rosters', ['app.admin.rosters.rostersController']).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.admin.rosters', {
        url: '/rosters',
        controller: 'app.admin.rosters.rostersController',
        templateUrl: 'components/admin/rosters/rostersView.html',
        title: 'Roster Manager'
    });
}]);

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(436);

angular.module('app.admin.rosters.rostersController', ['app.admin.rosters.rosterService']).controller('app.admin.rosters.rostersController', ['$scope', 'app.admin.rosters.rosterService', function ($scope, roster) {
  "use strict";

  $scope.leagues = null;
  $scope.teams = null;
  $scope.roster = null;

  $scope.selectedLeague = null;
  $scope.selectedTeam = null;

  $scope.getRoster = function () {
    roster.getRoster($scope.selectedTeam).then(function (response) {
      $scope.roster = response.data.roster;
    });
  };

  $scope.getTeams = function () {
    roster.getTeams($scope.selectedLeague).then(function (response) {
      $scope.teams = response.data;

      if (Array.isArray($scope.teams)) {
        if ($scope.teams.length === 1) {
          $scope.selectedTeam = $scope.teams[0].iteamid;
          $scope.getRoster();
        }
      }
    });
  };

  $scope.toggle = function (player, field, value) {
    var params = {};
    params[field] = value;
    roster.updateRoster(player.irosterid, params).then(function (response) {
      var data = response.data;

      if (data.error) {
        if (data.roster) {
          player[field] = data.roster[field];
        }
        alert(data.error);
      } else {
        player[field] = data[field];
      }
    });
  };

  roster.getLeagues().then(function (response) {
    $scope.leagues = response.data;

    if (Array.isArray($scope.leagues)) {
      if ($scope.leagues.length === 1) {
        $scope.selectedLeague = $scope.leagues[0].ileagueid;
        $scope.getTeams();
      }
    }
  });
}]);

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(9);

angular.module('app.admin.rosters.rosterService', ['app.transformResource']).factory('app.admin.rosters.rosterService', ['$http', 'app.transformResource', function ($http, transformResource) {
  "use strict";

  var transformRoster = function transformRoster(roster) {
    roster.iisstarter = !!roster.iisstarter;
    roster.iisinactive = !!roster.iisinactive;

    return roster;
  };

  return {
    getLeagues: function getLeagues() {
      return $http.get(window.location.api('rosters_leagues'));
    },
    getTeams: function getTeams(league_id) {
      return $http.get(window.location.api('rosters_leagues/' + league_id));
    },
    getRoster: function getRoster(team_id) {
      return $http({
        url: window.location.api('teams/' + team_id + '/roster'),
        method: 'GET',
        transformResponse: transformResource.onResponse(function (data) {
          if (Array.isArray(data.roster)) {
            for (var i in data.roster) {
              if (data.roster.hasOwnProperty(i)) {
                data.roster[i] = transformRoster(data.roster[i]);
              }
            }
          }
          return data;
        })
      });
    },
    updateRoster: function updateRoster(roster_id, data) {
      return $http({
        url: window.location.api('rosters/' + roster_id),
        method: 'PUT',
        data: data,
        transformResponse: transformResource.onResponse(function (data) {
          data = transformRoster(data);
          return data;
        })
      });
    }
  };
}]);

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(438);

"use strict";

angular.module('app.admin.teamInfoManager', ['angular-click-outside', 'app.admin.teamInfoManager.teamInfoManagerController']).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.admin.teamInfoManager', {
        url: '/team_info_manager',
        controller: 'app.admin.teamInfoManager.teamInfoManagerController',
        templateUrl: 'components/admin/teamInfoManager/teamInfoManagerView.html',
        title: 'Team Info Manager'
    });
}]);

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(439);

"use strict";

angular.module('app.admin.teamInfoManager.teamInfoManagerController', ['app.admin.teamInfoManager.teamInfoManagerService']).controller('app.admin.teamInfoManager.teamInfoManagerController', ['$scope', '$state', 'app.admin.teamInfoManager.teamInfoManagerService', function ($scope, $state, teamInfoManagerService) {
  $scope.teamInfo = null;
  $scope.boolSelector = [{
    label: '-- Select One --',
    value: ''
  }, {
    label: 'No',
    value: 0
  }, {
    label: 'Yes',
    value: 1
  }];
  $scope.inetTypes = [{
    label: '-- Select One --',
    value: ''
  }, {
    label: 'Fibre',
    value: 'Fibre'
  }, {
    label: 'Cable',
    value: 'Cable'
  }, {
    label: 'T1/Bonded T1',
    value: 'T1/Bonded T1'
  }, {
    label: 'DSL',
    value: 'DSL'
  }, {
    label: 'Unknown',
    value: 'Unknown'
  }];

  var init = function init() {
    teamInfoManagerService.getTeams().then(function (response) {
      var data = response.data;

      if (data.error) {
        alert(data.error);
      } else {
        $scope.teams = data;
      }
    });
  };

  $scope.loadTeamInfo = function () {
    teamInfoManagerService.retrieve($scope.selectedTeam).then(function (response) {
      var data = response.data;

      if (data.error) {
        alert(data.error);
      } else {
        $scope.teamInfo = data;
      }
    });
  };

  $scope.goToPassManager = function () {
    $state.go('app.admin.passManager', { teamId: $scope.selectedTeam });
  };

  $scope.saveContact = function (index) {
    teamInfoManagerService.saveContact($scope.teamInfo.fh_team_id_c, $scope.teamInfo.contacts[index]).then(function (response) {
      var data = response.data;

      if (data.error) {
        alert(data.error);
      } else {
        $scope.teamInfo.contacts[index] = data;
      }
    });
  };

  $scope.saveAccount = function () {
    teamInfoManagerService.saveAccount($scope.teamInfo.fh_team_id_c, $scope.teamInfo.account).then(function (response) {
      var data = response.data;

      if (data.error) {
        alert(data.error);
      } else {
        $scope.teamInfo.account = data;
      }
    });
  };

  $scope.saveAccountCstm = function () {
    var teamInfo = _.clone($scope.teamInfo);
    _.unset(teamInfo, 'account');
    _.unset(teamInfo, 'contacts');

    teamInfoManagerService.saveAccountCstm(teamInfo).then(function (response) {
      var data = response.data;

      if (data.error) {
        alert(data.error);
      } else {
        var contacts = angular.copy($scope.teamInfo.contacts);
        var account = angular.copy($scope.teamInfo.account);

        $scope.teamInfo = data;
        $scope.teamInfo.contacts = contacts;
        $scope.teamInfo.account = account;
      }
    });
  };

  init();
}]);

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(61);

angular.module('app.admin.teamInfoManager.teamInfoManagerService', ['app.shared.teamService']).factory('app.admin.teamInfoManager.teamInfoManagerService', ['$http', 'app.shared.teamService', function ($http, teamService) {
  return {
    retrieve: function retrieve(id) {
      return $http.get(window.location.api('teams/' + id + '/info'));
    },
    saveContact: function saveContact(team_id, contact) {
      return $http.put(window.location.api('teams/' + team_id + '/info/contact/' + contact.id), contact);
    },
    saveAccount: function saveAccount(team_id, account) {
      return $http.put(window.location.api('teams/' + team_id + '/info/account/' + account.id), account);
    },
    saveAccountCstm: function saveAccountCstm(account) {
      account = angular.copy(account);
      delete account.contacts;

      return $http.put(window.location.api('teams/' + account.fh_team_id_c + '/info/account_cstm/' + account.id_c), account);
    },
    getTeams: function getTeams() {
      return $http.get(window.location.api('teams_admin_user'));
    }
  };
}]);

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(441);
__webpack_require__(104);
__webpack_require__(447);
__webpack_require__(122);

'use strict';

angular.module('app.admin.broadcastManager', ['app.admin.broadcastManager.broadcastManagerController', 'app.shared.graphicOverlay.graphicOverlayDirective', 'app.shared.gameInfo.gameInfoDirective']).config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('app.admin.broadcastManager', {
    url: '/broadcast_manager?:gameId',
    templateUrl: 'components/admin/broadcastManager/broadcastManagerView.html',
    controller: 'app.admin.broadcastManager.broadcastManagerController',
    title: 'Broadcast Manager'
  });
}]);

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

__webpack_require__(124);
__webpack_require__(15);
__webpack_require__(442);
__webpack_require__(1);
__webpack_require__(443);
__webpack_require__(444);
__webpack_require__(445);
__webpack_require__(446);
__webpack_require__(124);

"use strict";

var WatermarkImages = exports.WatermarkImages = function WatermarkImages(obj) {
  _classCallCheck(this, WatermarkImages);

  this.leagueImages200x100 = obj && obj.leagueImages200x100 || [];
  this.productImages200x100 = obj && obj.productImages200x100 || [];
};

angular.module('app.admin.broadcastManager.broadcastManagerController', ['app.admin.broadcastManager.broadcastManagerService', 'app.shared.dataTransformers.clockTimeTransformer', 'liveScoreFirebaseService', 'app.admin.broadcastManager.singularOverlayService', 'singularOverlaysFirebaseService', 'app.currentUser', 'app.shared.guidService']).controller('app.admin.broadcastManager.broadcastManagerController', ['$scope', '$stateParams', 'app.admin.broadcastManager.broadcastManagerService', '$interval', 'app.shared.dataTransformers.clockTimeTransformer', 'PRODUCT', '$state', 'FIREBASE_CREDS', 'liveScoreFirebaseService', 'app.admin.broadcastManager.singularOverlayService', 'singularOverlaysFirebaseService', 'currentUser', 'app.shared.guidService', '$q', '$uibModal', function ($scope, $stateParams, broadcastManager, $interval, clockTimeTransformer, product, $state, fbCreds, liveScoreFb, singularOverlayService, singularFb, currentUser, guidService, $q, $uibModal) {
  var scoreboardClockInterval = null;
  var overlaysInterval = null;

  $scope.OVERLAY_MODIFIER_SCOREBAR_TEXT = 1;
  $scope.OVERLAY_MODIFIER_TEAM_TEXT = 2;

  $scope.scoreboardRef = null;
  $scope.livescoreDisabled = false;

  $scope.productId = product.Id;
  $scope.scoringProviderId = null;
  $scope.layouts = null;
  $scope.gameId = $stateParams.gameId;
  $scope.game = null;
  $scope.scoringProviders = null;
  $scope.isSaving = false;

  $scope.selectedStream = null;
  $scope.selectedSreamIndex = null;

  $scope.overlayModifiers = [];

  $scope.scoreboard = { time: '20:00', period: 'PRE', 'visScore': 0, 'homeScore': 0 };
  $scope.scoreboardOptions = {
    isScoreboardClockRunning: false,
    scoreboardPeriods: ['PRE', 'INT', '1st', '2nd', '3rd', 'OT', 'SO'],
    useLiveScoring: true
  };

  $scope.userOwnsScoreboard = false;
  $scope.scoreboardOwned = false;
  $scope.enablePowerPlayClock = false;

  $scope.currentUser = currentUser;

  var OVERLAY_TYPE_HEAD_TO_HEAD = "HEAD_TO_HEAD";
  var OVERLAY_TYPE_THREE_STARS = "THREE_STARS";
  var OVERLAY_TYPE_TEAM_LINEUP = "TEAM_LINEUPS";
  var OVERLAY_TYPE_TEAM_SCHEDULE = "TEAM_UPCOMING_SCHEDULE";
  var OVERLAY_TYPE_LEAGUE_SCHEDULE = "LEAGUE_UPCOMING_SCHEDULE";
  var OVERLAY_TYPE_UPCOMING_CALENDAR = "UPCOMING_CALENDAR";

  var OVERLAY_TYPE_MODIFIER_HEAD_TO_HEAD = "MODIFIER_HEAD_TO_HEAD";
  var OVERLAY_TYPE_MODIFIER_POWER_PLAY_EFFICIENCY_HOME = "MODIFIER_POWER_PLAY_EFFICIENCY_HOME";
  var OVERLAY_TYPE_MODIFIER_POWER_PLAY_EFFICIENCY_VISITOR = "MODIFIER_POWER_PLAY_EFFICIENCY_VISITOR";
  var OVERLAY_TYPE_MODIFIER_OVERALL_TEAM_RECORD = "MODIFIER_OVERALL_TEAM_RECORD";

  var CLEAR_OVERLAY_LOCK_AFTER_SECONDS = 10000;

  $scope.singularOverlaysLoaded = false;
  var overlayChangeCallback = null;
  var overlaysUnlockSubscription = null;
  $scope.streamId = null;
  $scope.adminControl = false;
  $scope.watermarkImages = [];
  $scope.sponsorImages = [];
  var imageModal = null;
  $scope.loading = false;

  var init = function init() {
    // Setup for ownership of HockeyTV scoreboard
    if (sessionStorage.getItem("userUid") === null) {
      sessionStorage.userUid = guidService.newGuid();
    }

    broadcastManager.getLeagues().then(function (response) {
      var data = response.data;
      if (data.error) {
        alert(data.error);
      } else {
        $scope.leagues = data;
      }
    });

    if ($scope.gameId) {
      // get the game
      broadcastManager.retrieveGame($scope.gameId).then(function (response) {
        var data = response.data;
        if (data.error) {
          alert(data.error);
        } else {
          $scope.game = data;
          $scope.selectedLeague = $scope.game.ileagueid_fk;
          $scope.scoringProviderId = $scope.game.iscoringproviderid_fk;
          $scope.initializeGame();
        }
      }).then(function () {
        // get the teams for the league
        broadcastManager.getTeams($scope.game.ileagueid_fk).then(function (response) {
          if (response.data.error) {
            alert(response.data.error);
          } else {
            $scope.teams = response.data;
            var teamIds = $scope.teams.map(function (t) {
              return t.iteamid;
            });
            // Update the team selection based on the users access
            if (teamIds.includes($scope.game.hometeam.iteamid)) {
              $scope.selectedTeam = $scope.game.hometeam.iteamid;
            } else if (teamIds.includes($scope.game.awayteam.iteamid)) {
              $scope.selectedTeam = $scope.game.awayteam.iteamid;
            }
          }
        });
      }).then(function () {
        // get the games for the team
        broadcastManager.getGames($scope.game.hometeam.iteamid) // <team_id>
        .then(function (response) {
          // let data = response.data;
          if (response.data.error) {
            alert(response.data.error);
          } else {
            $scope.games = response.data;
            $scope.selectedGame = $scope.game.igameid;
          }
        });
      });
    }

    broadcastManager.retrieveScoringProviders().then(function (response) {
      var data = response.data;

      if (data.error) {
        alert(data.error);
      } else {
        $scope.scoringProviders = data;
      }
    });
  };

  var initScoreboard = function initScoreboard() {
    if ($scope.game && $scope.game.igameid) {
      if ($scope.game.iscoringproviderid === 0) {
        $scope.livescoreDisabled = false;
        // hook up to firebase
        if (!currentUser.jwt) {
          var jwtPromise = currentUser.getFbJwt($scope.game.igameid).then(function () {
            liveScoreFb.authenticate(fbCreds.livescore.firebaseUrl, fbCreds.livescore.firebaseApiKey, currentUser.jwt).then(function () {
              $scope.scoreboardRef = liveScoreFb.getGameRef($scope.game.igameid);
              $scope.watchFirebaseScoreboard();
              // push up initial data to firebase so the node is populated
              $scope.updateFbScoreboard();
              liveScoreFb.setTime($scope.scoreboard.time);
            });
          }).catch(function (e) {
            $scope.livescoreDisabled = true;
            $scope.scoreboardOptions.useLiveScoring = false;
            alert(e.msg);
          });
        } else {
          $scope.scoreboardRef = liveScoreFb.getGameRef($scope.game.igameid);
          $scope.watchFirebaseScoreboard();
          // push up initial data to firebase so the node is populated
          $scope.updateFbScoreboard();
          liveScoreFb.setTime($scope.scoreboard.time);
        }
      } else if ($scope.game.iscoringproviderid && $scope.game.iscoringproviderid !== 0) {
        // disconnect from firebase
        if ($scope.scoreboardRef) {
          $scope.scoreboardRef.off();
        }
      }
    } else {
      $scope.userOwnsScoreboard = true; // nobody 'owns' control of the scoreboard
    }
  };

  $scope.watchFirebaseScoreboard = function () {
    $scope.scoreboardRef.on('value', function (snapshot) {
      var fbSb = snapshot.val();

      if (fbSb) {
        // Check if there is a value in the owner property and see if it's a different user
        if (fbSb.hasOwnProperty("owner")) {
          $scope.scoreboardOwned = true;
          $scope.userOwnsScoreboard = fbSb.owner == sessionStorage.userUid;
          if (!$scope.userOwnsScoreboard && scoreboardClockInterval) {
            $scope.stopClock();
          }
        } else {
          $scope.userOwnsScoreboard = true; // really no owner
          $scope.scoreboardOwned = false;
        }

        if (fbSb.hasOwnProperty("running")) {
          $scope.scoreboardOptions.isScoreboardClockRunning = fbSb.running;
        }

        if (fbSb.hasOwnProperty("useLiveScoring")) {
          $scope.scoreboardOptions.useLiveScoring = fbSb.useLiveScoring;
        }

        if (fbSb.hasOwnProperty("time")) {
          $scope.scoreboard.time = fbSb.time;
        }

        if (fbSb.hasOwnProperty("homeScore") && fbSb.hasOwnProperty("visScore") && fbSb.hasOwnProperty("period")) {
          $scope.scoreboard.homeScore = fbSb.homeScore;
          $scope.scoreboard.visScore = fbSb.visScore;
          $scope.scoreboard.period = fbSb.period;
        }
      } else {
        console.warn("Missing scoreboard data in firebase node: ", fbSb);
        $scope.userOwnsScoreboard = true;
        $scope.scoreboardOwned = false;
      }

      setTimeout(function () {
        $scope.$apply();
      }, 0);
    });
  };

  $scope.updateFbScoreboard = function () {
    var sbData = {
      homeScore: $scope.scoreboard.homeScore,
      period: $scope.scoreboard.period,
      visScore: $scope.scoreboard.visScore,
      owner: sessionStorage.getItem("userUid"),
      lastUpdated: Date.now()
    };

    liveScoreFb.update(sbData);
  };

  $scope.takeoverScoreboard = function () {
    var confirmed = confirm("The scoreboard is currently controlled by another user. Are you sure you want to takeover control?");
    if (confirmed === true) {
      var uuid = sessionStorage.getItem("userUid");
      if (!uuid) {
        sessionStorage.userUid = guidService.newGuid();
      }

      liveScoreFb.setOwner(sessionStorage.getItem("userUid"));
    }
  };

  $scope.loadTeams = function (league_id) {
    if (league_id != null) {
      broadcastManager.getTeams(league_id).then(function (response) {
        var data = response.data;
        if (data.error) {
          alert(data.error);
        } else {
          $scope.teams = data;
        }
      });
    }
  };

  $scope.loadGames = function (team_id) {
    if (team_id != null) {
      broadcastManager.getGames(team_id).then(function (response) {
        var data = response.data;
        if (data.error) {
          alert(data.error);
        } else {
          $scope.games = data;
        }
      });
    }
  };

  $scope.selectGame = function (game_id) {
    if (game_id != null) {
      broadcastManager.retrieveGame(game_id).then(function (response) {
        if (response.data.error) {
          alert(response.data.error);
        } else {
          // If switching games and the scoreboard was already bound to a different game, unbind it
          if (game_id != $scope.game.igameid) {
            if ($scope.scoreboardRef) {
              $scope.scoreboardRef.off();
              $scope.scoreboardRef = null;
            }
          }

          var newUrl = window.location.href.replace('gameId=' + $scope.gameId, 'gameId=' + game_id);
          if (newUrl) {
            window.history.pushState(null, null, newUrl);
          }
          $scope.gameId = game_id;
          $scope.game = response.data;
          $scope.initializeGame();
        }
      });
    }
  };

  $scope.playGame = function () {
    var params = {
      type: 'game',
      id: $scope.game.igameid,
      audio: null
    };

    if ($scope.game.pixellot_only) {
      params.audio = 4;
    }

    $state.go('app.play', params);
  };

  $scope.initializeGame = function () {
    $scope.scoreboard = $scope.game.scoreboard;
    $scope.scoreboard.period = $scope.game.scoreboard.strperiod;
    $scope.scoreboard.time = $scope.game.scoreboard.strtime;
    $scope.scoreboard.visScore = $scope.game.scoreboard.iawayscore;
    $scope.scoreboard.homeScore = $scope.game.scoreboard.ihomescore;

    $scope.scoreboardOptions.useLiveScoring = $scope.game.scoreboard.uselivescoring;

    initScoreboard();

    if ($scope.selectedSreamIndex) {
      $scope.onBroadcastSelect($scope.selectedSreamIndex);
    }

    if ($scope.game.use_singular_overlays) {
      singularFb.init(fbCreds.singular.firebaseUrl, fbCreds.singular.firebaseApiKey, $scope.currentUser.data, $scope.game.igameid).then(function () {
        broadcastManager.getLeagueWatermarkImages($scope.game.ileagueid_fk).then(function (response) {
          $scope.watermarkImages = new WatermarkImages(response.data);
        }, function (error) {
          alert("Failed to load watermark images. Please try again later.");
        });
      }, function (error) {
        alert("There was an error connecting to Firebase. Please try again later.");
      });
    }
  };

  $scope.onBroadcastSelect = function (stream_idx) {
    if (stream_idx) {
      // update the audio stream team id appropriately, default to home
      $scope.audioStreamTeamId = $scope.game.hometeam.iteamid;

      if (!$scope.game.use_singular_overlays) {
        $scope.selectedStream = $scope.game.overlays[stream_idx];
        $scope.selectedStreamIndex = stream_idx;
        $scope.streamId = $scope.selectedStream.iaudiostreamid_fk;
        if ($scope.streamId == 2) {
          // away
          $scope.audioStreamTeamId = $scope.game.awayteam.iteamid;
        }

        broadcastManager.retrieveLayouts($scope.gameId, $scope.game.overlays[stream_idx].iaudiostreamid_fk).then(function (response) {
          var data = response.data;

          if (data.error) {
            alert(data.error);
          } else {
            var dt = new Date();
            var ts = dt.getTime();
            angular.forEach(data, function (item) {
              item.overlayimageurl = item.overlayimageurl + "?" + ts;
            });
            $scope.layouts = data;

            // update game data in case game overlays have been updated by modifiers
            broadcastManager.retrieveGame($scope.gameId).then(function (response) {
              var data = response.data;
              if (data.error) {
                alert(data.error);
              } else {
                $scope.game = data;
                $scope.getOverlayModifiers(stream_idx);
              }
            });
          }
        });

        $scope.enablePowerPlayClock = $scope.game.overlays[stream_idx].enablepowerplayclock;

        $scope.setRefresh();
      } else {
        $scope.streamId = $scope.game.singular_overlays[stream_idx].audio_stream.AudioId;
        if ($scope.streamId == 2) {
          // away
          $scope.audioStreamTeamId = $scope.game.awayteam.iteamid;
        }

        broadcastManager.getTeamSponsorImages($scope.audioStreamTeamId).then(function (response) {
          $scope.sponsorImages = response.data;
          initializeSingularOverlayHandlers();
        });
      }
    }
  };

  $scope.getOverlayModifiers = function (stream_idx) {
    broadcastManager.getOverlayModifiers($scope.gameId, $scope.game.overlays[stream_idx].iaudiostreamid_fk).then(function (response) {
      $scope.overlayModifiers = [];

      if (response.data.error) {
        console.log("broadcast-manager.component.ts getOverlayModifiers() - Failed to change get modifiers");
        alert("There was an error loading overlay modifiers");
      } else {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = response.data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var modifier = _step.value;

            modifier.selected = false;
            if ($scope.game.overlays[$scope.game.overlays[stream_idx].iaudiostreamid_fk - 1].scorebartextmodifierid) {
              if (modifier.modifier_type === $scope.OVERLAY_MODIFIER_SCOREBAR_TEXT && $scope.game.overlays[$scope.game.overlays[stream_idx].iaudiostreamid_fk - 1].scorebartextmodifierid === modifier.id) {
                modifier.selected = true;
              }
            }
            if ($scope.game.overlays[$scope.game.overlays[stream_idx].iaudiostreamid_fk - 1].teamtextmodifierid) {
              if (modifier.modifier_type === $scope.OVERLAY_MODIFIER_TEAM_TEXT && $scope.game.overlays[$scope.game.overlays[stream_idx].iaudiostreamid_fk - 1].teamtextmodifierid === modifier.id) {
                modifier.selected = true;
              }
            }

            $scope.overlayModifiers.push(modifier);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    });
  };

  $scope.toggleOverlayModifier = function (modifier) {
    if (!$scope.isSaving && $scope.game && $scope.selectedStream) {
      $scope.isSaving = true;
      modifier.isOn = !modifier.selected;

      broadcastManager.setGameStreamOverlayModifier($scope.gameId, $scope.game.overlays[$scope.selectedSreamIndex].iaudiostreamid_fk, modifier).then(function (response) {
        $scope.isSaving = false;
        if (response.data.error) {
          console.log("broadcast-manager.component.ts toggleOverlayModifier() - Failed to change overlay modifier", error);
          alert("There was an error changing the overlay modifier");
        } else {
          var overlay = response.data;
          //If turning on modifier, turn off the others of the same modifier type
          if (modifier.isOn) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = $scope.overlayModifiers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var om = _step2.value;

                if (modifier.modifier_type === om.modifier_type) {
                  om.selected = false;
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
          modifier.selected = modifier.modifier_type === $scope.OVERLAY_MODIFIER_SCOREBAR_TEXT && overlay.scorebartextmodifierid !== null || modifier.modifier_type === $scope.OVERLAY_MODIFIER_TEAM_TEXT && overlay.teamtextmodifierid !== null;
        }
      });
    }
  };

  $scope.togglePowerPlayClock = function () {
    if (!$scope.isSaving && $scope.game && $scope.selectedStream) {
      $scope.isSaving = true;
      var powerPlayClockIsOn = !$scope.enablePowerPlayClock;
      broadcastManager.setGameStreamPowerPlayClock($scope.gameId, $scope.game.overlays[$scope.selectedSreamIndex].iaudiostreamid_fk, powerPlayClockIsOn).then(function (response) {
        $scope.isSaving = false;
        if (response.data.error) {
          var errorMessage = 'Failed to change PowerPlay Clock: ' + response.data.error;
          console.log("broadcast-manager.component.ts togglePowerPlayClock() - " + errorMessage);
          alert(errorMessage);
        } else {
          // Update the enablePowerPlayClock value with whatever it's opposite is since the
          // API request was successful
          $scope.enablePowerPlayClock = !$scope.enablePowerPlayClock;
        }
      });
    }
  };

  $scope.toggleClassSelected = function (layout) {
    if (layout.active) {
      return 'btn btn-primary';
    } else {
      return 'btn btn--unselected';
    }
  };

  $scope.backgroundSelected = function (layout) {
    if (layout.active) {
      return 'background--active';
    }
  };

  $scope.toggleActive = function (layout_id, enable, sponsor_id) {
    layout_id = parseInt(layout_id);

    if ($scope.game && $scope.selectedStream) {
      var selectedStreamiOverlayFormat = $scope.selectedStream.ioverlayformatid_fk;
      $scope.selectedStream.ioverlayformatid_fk = layout_id;

      broadcastManager.toggleOverlay($scope.game, $scope.selectedStream, enable, sponsor_id).then(function (response) {
        var data = response.data;
        if (data.error) {
          $scope.selectedStream.ioverlayformatid_fk = selectedStreamiOverlayFormat;
          alert(data.error);
        } else {
          $scope.selectedStream = data;
        }
      });
    }
  };

  $scope.isOverlayOn = function (layout_id, sponsor_id) {
    if ($scope.game && $scope.selectedStream) {
      if ($scope.selectedStream.ioverlayformatid_fk === layout_id) {
        // If there is an overlay sponsor id, use that in the comparison
        if (sponsor_id) {
          if ($scope.selectedStream.ioverlaysponsorid === sponsor_id) {
            return !!$scope.selectedStream.ioverlayon;
          }
        } else {
          if (!$scope.selectedStream.ioverlaysponsorid) {
            return !!$scope.selectedStream.ioverlayon;
          }
        }
      }
    }
    return false;
  };

  $scope.saveProvider = function () {
    $scope.isSaving = true;
    broadcastManager.saveProvider($scope.game).then(function (response) {
      var data = response.data;

      if (data.error) {
        alert(data.error);
      } else {
        $scope.game.overlay = data;
      }
      $scope.isSaving = false;
    });
  };

  $scope.startClock = function () {
    if (!$scope.scoreboardOwned) {
      liveScoreFb.setOwner(sessionStorage.getItem("userUid"));
    }
    scoreboardClockInterval = $interval(function () {
      var currentTime = clockTimeTransformer.stringToSeconds($scope.scoreboard.time);
      if (currentTime) {
        currentTime -= 1;
        $scope.scoreboard.time = clockTimeTransformer.secondsToString(currentTime, 'mm:ss');
      }
      // Check for ownership, as this could have changed from someone taking over the clock
      if ($scope.userOwnsScoreboard) {
        liveScoreFb.setTime($scope.scoreboard.time);
      }
    }, 1000);
    $scope.scoreboardOptions.isScoreboardClockRunning = true;
    liveScoreFb.setRunning($scope.scoreboardOptions.isScoreboardClockRunning);
  };

  $scope.stopClock = function () {
    $interval.cancel(scoreboardClockInterval);
    scoreboardClockInterval = null;
    $scope.scoreboardOptions.isScoreboardClockRunning = false;
    liveScoreFb.setRunning($scope.scoreboardOptions.isScoreboardClockRunning);
  };

  $scope.setClock = function () {
    if (!$scope.scoreboardOwned) {
      liveScoreFb.setOwner(sessionStorage.getItem("userUid"));
    }
    liveScoreFb.setTime($scope.scoreboard.time);
  };

  $scope.scoringProviderChanged = function () {
    if ($scope.scoreboardOptions.isScoreboardClockRunning) {
      $scope.stopClock();
    }

    if ($scope.game && $scope.selectedStream) {
      $scope.selectedStream.ioverlayformatid_fk = parseInt($scope.selectedStream.ioverlayformatid_fk);

      if ($scope.selectedStream.ioverlayformatid_fk === 0) {
        $scope.game.iscoringprovidergameid = $scope.game.igameid;
      }

      initScoreboard();

      $scope.setRefresh();
    }
  };

  $scope.publishScoreboard = function () {
    broadcastManager.publishScoreboard($scope.game.igameid, $scope.scoreboard);
  };

  /////// Singular Overlay Management

  var initializeSingularOverlayHandlers = function initializeSingularOverlayHandlers() {
    overlayChangeCallback = function overlayChangeCallback(data) {
      if (data && data.gameId && data.gameId == $scope.game.igameid && data.audioId && data.audioId == $scope.streamId) {
        $scope.loading = true;

        // If overlays have not yet been loaded and the last forced update was more than 10 seconds ago force an update
        var currentDateTime = Date.now();
        if (!$scope.singularOverlaysLoaded) {
          if (currentDateTime / 1000 - data.forceSingularDataSync / 1000 > 10) {
            var fbParams = {
              forceSingularDataSync: currentDateTime
            };
            singularFb.updateSingularOverlays($scope.game.igameid, $scope.streamId, fbParams);
          }

          // Setup a timeout function to enable overlays within X seconds if a callback from firebase doesn't happen
          overlaysUnlockSubscription = $interval(function () {
            $scope.loading = false;
            $interval.cancel(overlaysUnlockSubscription);
            overlaysUnlockSubscription = null;
          }, CLEAR_OVERLAY_LOCK_AFTER_SECONDS);

          $scope.overlayLayers = data.singularState;
          setTimeout(function () {
            $scope.$apply();
          }, 0);
          $scope.singularOverlaysLoaded = true;
        } else {
          // Since overlays are now loaded we need to keep track of when changes are made and lock overlay changes during that
          // time and unlock them once the changes have been completed. Only update data when the lock has been lifted
          if (data.forceSingularDataSync <= data.previousSingularDataSync && data.lastOverlayLockTime <= data.lastOverlayUpdateTime) {
            $scope.loading = false;
            if (overlaysUnlockSubscription !== null) {
              $interval.cancel(overlaysUnlockSubscription);
            }
            $scope.overlayLayers = data.singularState;
            setTimeout(function () {
              $scope.$apply();
            }, 0);
          } else if (data.forceSingularDataSync > data.previousSingularDataSync || data.lastOverlayLockTime > data.lastOverlayUpdateTime) {
            $scope.loading = true;

            overlaysUnlockSubscription = $interval(function () {
              $scope.loading = false;
              $interval.cancel(overlaysUnlockSubscription);
              overlaysUnlockSubscription = null;
            }, CLEAR_OVERLAY_LOCK_AFTER_SECONDS);
          }
        }
      }
    };

    singularFb.subscribeToSingularOverlays($scope.game.igameid, $scope.streamId, overlayChangeCallback);
  };

  var initiateOverlayToggle = function initiateOverlayToggle(gameId, audioStreamId, overlay, active) {
    var deferred = $q.defer();

    if (active && overlay && overlay.overlayType && overlay.overlayType !== '') {
      switch (overlay.overlayType) {
        case OVERLAY_TYPE_TEAM_LINEUP:
          singularOverlayService.bindOverlayTeamLineupData(gameId, audioStreamId).then(function (data) {
            deferred.resolve(data);
          }, function (error) {
            deferred.reject(error);
          });
          break;
        case OVERLAY_TYPE_TEAM_SCHEDULE:
          singularOverlayService.bindOverlayTeamScheduleData(gameId, audioStreamId, $scope.audioStreamTeamId, overlay.name).then(function (data) {
            deferred.resolve(data);
          }, function (error) {
            deferred.reject(error);
          });
          break;
        case OVERLAY_TYPE_LEAGUE_SCHEDULE:
          singularOverlayService.bindOverlayLeagueScheduleData(gameId, audioStreamId, overlay.name).then(function (data) {
            deferred.resolve(data);
          }, function (error) {
            deferred.reject(error);
          });
          break;
        case OVERLAY_TYPE_HEAD_TO_HEAD:
          singularOverlayService.bindOverlayHeadToHeadData(gameId, audioStreamId).then(function (data) {
            deferred.resolve(data);
          }, function (error) {
            deferred.reject(error);
          });
          break;
        case OVERLAY_TYPE_MODIFIER_HEAD_TO_HEAD:
          singularOverlayService.bindModifierHeadToHeadData(gameId, audioStreamId).then(function (data) {
            deferred.resolve(data);
          }, function (error) {
            deferred.reject(error);
          });
          break;
        case OVERLAY_TYPE_MODIFIER_POWER_PLAY_EFFICIENCY_HOME:
          singularOverlayService.bindModifierPowerPlayEfficiency(gameId, audioStreamId, true).then(function (data) {
            deferred.resolve(data);
          }, function (error) {
            deferred.reject(error);
          });
          break;
        case OVERLAY_TYPE_MODIFIER_POWER_PLAY_EFFICIENCY_VISITOR:
          singularOverlayService.bindModifierPowerPlayEfficiency(gameId, audioStreamId, false).then(function (data) {
            deferred.resolve(data);
          }, function (error) {
            deferred.reject(error);
          });
          break;
        case OVERLAY_TYPE_THREE_STARS:
          singularOverlayService.bindOverlayThreeStarsData(gameId, audioStreamId).then(function (data) {
            deferred.resolve(data);
          }, function (error) {
            deferred.reject(error);
          });
          break;
        case OVERLAY_TYPE_UPCOMING_CALENDAR:
          singularOverlayService.bindOverlayUpcomingCalendarData(gameId, audioStreamId).then(function (data) {
            deferred.resolve(data);
          }, function (error) {
            deferred.reject(error);
          });
          break;
        case OVERLAY_TYPE_MODIFIER_OVERALL_TEAM_RECORD:
          singularOverlayService.bindModifierOverallTeamRecord(gameId, audioStreamId).then(function (data) {
            deferred.resolve(data);
          }, function (error) {
            deferred.reject(error);
          });
          break;
        default:
          deferred.resolve(null);
      }
    } else {
      deferred.resolve(null);
    }

    return deferred.promise;
  };

  $scope.toggleOverlay = function (active, layerName, toggledOverlay) {
    setFbOverlayLockTime();
    var allOverlays = [toggledOverlay.name];

    // If we are turning on an overlay we need to also make sure to turn on all it's sub layers as well that are currently active
    if (active) {
      var layer = $scope.overlayLayers[layerName];
      if (layer) {
        for (var overlayKey in layer.subCompositions) {
          var overlay = layer.subCompositions[overlayKey];
          if (overlay.name === toggledOverlay.name) {
            for (var subLayerKey in overlay.subLayers) {
              var subLayer = overlay.subLayers[subLayerKey];
              for (var subOverlayKey in subLayer.subCompositions) {
                var subOverlay = subLayer.subCompositions[subOverlayKey];
                if (subOverlay.active) {
                  allOverlays.push(subOverlay.name);
                }
              }
            }
          }
        }
      }
    }

    initiateOverlayToggle($scope.gameId, $scope.streamId, toggledOverlay, active).then(function (_) {
      singularOverlayService.toggleOverlays($scope.gameId, $scope.streamId, active, allOverlays).then(function (_) {
        var layer = $scope.overlayLayers[layerName];
        if (layer) {
          for (var _overlayKey in layer.subCompositions) {
            var _overlay = layer.subCompositions[_overlayKey];
            if (_overlay.name === toggledOverlay.name) {
              _overlay.active = active;
            } else {
              _overlay.active = false;
            }
          }
        }
        updateFbSingularState();
        singularFb.logUserAction($scope.gameId, "Changing overlay " + layerName + "/" + toggledOverlay.name + " active state to " + active, "broadcastManagerController::toggleOverlay");
      }, function (error) {
        alert("There was an error toggling the overlay. Please try again later.");
      });
    });
  };

  $scope.toggleSubOverlay = function (parentLayerActive, active, layerName, overlayName, subLayerName, toggledOverlay) {
    setFbOverlayLockTime();
    if (!parentLayerActive) {
      updateSubOverlayState(active, layerName, overlayName, subLayerName, toggledOverlay.name);
      updateFbSingularState();
      singularFb.logUserAction($scope.game.igameid, "Changing sub overlay " + layerName + "/" + overlayName + "/" + subLayerName + "/" + toggledOverlay.name + " active state to " + active, "broadcastManagerController::toggleSubOverlay");
      return;
    }

    initiateOverlayToggle($scope.game.igameid, $scope.streamId, toggledOverlay, active).then(function (_) {
      singularOverlayService.toggleOverlays($scope.game.igameid, $scope.streamId, active, [toggledOverlay.name]).then(function (_) {
        updateSubOverlayState(active, layerName, overlayName, subLayerName, toggledOverlay.name);
        updateFbSingularState();
        singularFb.logUserAction($scope.game.igameid, "Changing sub overlay " + layerName + "/" + overlayName + "/" + subLayerName + "/" + toggledOverlay.name + " active state to " + active, "broadcastManagerController::toggleSubOverlay");
      }, function (error) {
        alert("There was an error toggling the overlay. Please try again later.");
      });
    }).catch(function (err) {
      return console.log("There was an error initiating overlay toggle. Please try again later.");
    });
  };

  var updateSubOverlayState = function updateSubOverlayState(active, layerName, overlayName, subLayerName, subOverlayName) {
    if ($scope.overlayLayers[layerName]) {
      for (var overlayKey in $scope.overlayLayers[layerName].subCompositions) {
        var overlay = $scope.overlayLayers[layerName].subCompositions[overlayKey];
        if (overlay.name === overlayName) {
          var subLayer = overlay.subLayers[subLayerName];
          if (subLayer) {
            for (var subLayerKey in subLayer.subCompositions) {
              var subOverlay = subLayer.subCompositions[subLayerKey];
              if (subOverlay.name === subOverlayName) {
                subOverlay.active = active;
              } else {
                subOverlay.active = false;
              }
            };
          }
        }
      };
    }
  };

  var setFbOverlayLockTime = function setFbOverlayLockTime() {
    if ($scope.game.igameid && $scope.streamId) {
      $scope.loading = true;
      var fbParams = {
        lastOverlayLockTime: Date.now()
      };
      singularFb.updateSingularOverlays($scope.game.igameid, $scope.streamId, fbParams);
    }
  };

  var updateFbSingularState = function updateFbSingularState() {
    if ($scope.game.igameid && $scope.streamId) {
      var fbParams = {
        lastOverlayUpdateTime: Date.now(),
        singularState: $scope.overlayLayers
      };
      singularFb.updateSingularOverlays($scope.gameId, $scope.streamId, fbParams);
    }
  };

  $scope.allowPowerPlayChange = function (layerName, overlayName, overlayProperty, allowPowerPlay) {
    setFbOverlayLockTime();
    singularOverlayService.updateOverlay($scope.game.igameid, $scope.streamId, overlayName, overlayProperty.key, allowPowerPlay.toString()).then(function (_) {
      $scope.overlayLayers[layerName]['subCompositions'][overlayName]['allowPowerPlay']['value'] = allowPowerPlay.toString();
      updateFbSingularState();
    }, function (error) {
      alert("There was an error updating the overlay. Please try again later.");
    });
  };

  var modalOpen = function modalOpen(overlayName, overlayProperty, _images) {
    imageModal = $uibModal.open({
      template: '<div class="imagesContainer">\n                        <div class="topModal">\n                          <h2>Select an Image</h2>\n                          <button class="imageButton" ng-click="$ctrl.selectImage(\'\')">Remove Image</button>\n                        </div>\n                        <div class="imagesBlock">\n                            <div ng-repeat="image in $ctrl.images track by $index">\n                                <div class="imageBlock">\n                                    <a ng-click="$ctrl.selectImage(image)"><img ng-src={{image}} alt="Image"></a>\n                                </div>\n                            </div>\n                        </div>\n                      </div>',
      controller: "imageDialogController",
      controllerAs: '$ctrl',
      windowClass: 'overlays-image-modal',
      resolve: {
        images: function images() {
          return _images;
        }
      }
    }).result.then(function (result) {
      if (result != null) {
        setFbOverlayLockTime();
        singularOverlayService.updateOverlay($scope.game.igameid, $scope.streamId, overlayName, overlayProperty.key, result).then(function (data) {
          overlayProperty.value = result;
          updateFbSingularState();
          singularFb.logUserAction($scope.game.igameid, "Changing overlay " + overlayName + " image value " + overlayProperty.key + "=" + overlayProperty.value, "broadcastManagerController::changeImageDialog");
        }, function (error) {
          alert("There was an error updating the overlay. Please try again later.");
        });
      }
    });
  };

  $scope.changeImageDialog = function (overlayName, overlayProperty, images) {
    modalOpen(overlayName, overlayProperty, images);
  };

  /////// End of Singular Overlay Management

  $scope.$on('$destroy', function () {
    if ($scope.scoreboardOptions.isScoreboardClockRunning) {
      $scope.stopClock();
    }
    if (scoreboardClockInterval) {
      $interval.cancel(scoreboardClockInterval);
    }
    if (overlaysInterval) {
      $interval.cancel(overlaysInterval);
    }

    // terminate firebase listener
    if ($scope.scoreboardRef) {
      $scope.scoreboardRef.off();
    }

    if (overlayChangeCallback !== null) {
      singularFb.unsubscribeFromSingularOverlays($scope.game.igameid, $scope.streamId, overlayChangeCallback);
    }

    // liveScoreFb.signOut();
  });

  $scope.setRefresh = function () {
    if (overlaysInterval) {
      $interval.cancel(overlaysInterval);
    }

    // We want to periodically refresh the game/overlay info so that if multiple people
    // are in broadcast manager, they're seeing changes made by others. However, this
    // should not be done if it's the HockeyTV scoring provider, as that resets the
    // manually managed scoreboard
    if ($scope.game.iscoringproviderid !== 0) {
      overlaysInterval = $interval(function () {
        $scope.selectGame($scope.game.igameid);
      }, 30000);
    }
  };

  $scope.$watch(function () {
    return $scope.scoreboardOptions.useLiveScoring;
  }, function () {
    if ($scope.scoreboardOptions.useLiveScoring) {
      initScoreboard();
      if ($scope.scoreboardRef) {
        liveScoreFb.setUseLiveScore(true);
      }
    } else {
      if ($scope.scoreboardOptions.isScoreboardClockRunning) {
        $scope.stopClock();
      }
      if ($scope.scoreboardRef) {
        liveScoreFb.setUseLiveScore(false);
      }
    }

    if ($scope.game) {
      broadcastManager.toggleLiveScoring($scope.game.igameid, $scope.scoreboardOptions.useLiveScoring).then(function (response) {
        var data = response.data;

        if (data.error) {
          alert(data.error);
        } else {
          $scope.scoreboard = data;
        }
      });
    }
  });

  init();
}]);

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('liveScoreFirebaseService', []).factory('liveScoreFirebaseService', ['$q', function ($q) {
    var databaseUrl = void 0;
    var gameRef = void 0;

    // this can be really helpful when you're stuck.
    // firebase.database.enableLogging(true);

    var authenticate = function authenticate(fbDatabase, fbApiKey, fbJwt) {
        var deferred = $q.defer();

        databaseUrl = fbDatabase;
        firebase.initializeApp({
            apiKey: fbApiKey,
            databaseURL: fbDatabase
        });

        // Existing and future Auth states are now persisted in the current session
        // only. Closing the window would clear any existing state even if a user
        // forgets to sign out. New sign-in will be persisted with session persistence.
        firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION).then(function () {
            // Once I have the 'token', the clientside JS authenticates here...
            return firebase.auth().signInWithCustomToken(fbJwt).then(function () {
                deferred.resolve();
            }).catch(function (error) {
                // Handle Errors here.
                var errorCode = error.code;
                var errorMessage = error.message;
                console.warn("ERROR: Firebase failed to authenticate", errorCode, errorMessage);
            });
        }).catch(function (error) {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            console.warn("ERROR: Firebase failed to authenticate", errorCode, errorMessage);
        });

        return deferred.promise;
    };

    var signOut = function signOut() {
        return firebase.auth().signOut();
    };

    var getGameRef = function getGameRef(gameId) {
        if (!databaseUrl) console.warn("ERROR: database url is undefined in firebaseRef::getGameRef");
        if (!gameId) console.warn("ERROR: gameId is undefined in firebaseRef::getGameRef");
        if (!databaseUrl || !gameId) {
            return;
        }

        gameRef = firebase.database().ref().child("/game/" + gameId);

        return gameRef;
    };

    // Sets the owner property of the game node
    var setOwner = function setOwner(ownerUid) {
        gameRef.child('owner').set(ownerUid);
    };

    // Sets the running property of the game node
    var setRunning = function setRunning(isRunning) {
        gameRef.child('running').set(isRunning);
    };

    // Sets the time property of the game node
    var setTime = function setTime(time) {
        gameRef.child('time').set(time);
    };

    // Sets the useLiveScoring property of the game node
    var setUseLiveScore = function setUseLiveScore(useLiveScore) {
        gameRef.child('useLiveScoring').set(useLiveScore);
    };

    // Will update the game node with whatever data is passed in
    var update = function update(scoreboardData) {
        gameRef.update(scoreboardData);
    };

    return {
        authenticate: authenticate,
        signOut: signOut,
        getGameRef: getGameRef,
        setOwner: setOwner,
        setRunning: setRunning,
        setTime: setTime,
        setUseLiveScore: setUseLiveScore,
        update: update
    };
}]);

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.shared.guidService', []).factory('app.shared.guidService', [function () {
	var newGuid = function newGuid() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
			var r = Math.random() * 16 | 0,
			    v = c == 'x' ? r : r & 0x3 | 0x8;
			return v.toString(16);
		});
	};

	return {
		newGuid: newGuid
	};
}]);

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.admin.broadcastManager.singularOverlayService', []).factory('app.admin.broadcastManager.singularOverlayService', ['$http', function ($http) {
  return {
    getOverlays: function getOverlays(gameId, audioStreamId) {
      var queryUrl = window.location.api("/broadcastManager/game/" + gameId + "/singular/overlays?audio_stream_id=" + audioStreamId);

      return $http.get(queryUrl).then(function (response) {
        var overlayLayers = [];

        Object.keys(response).forEach(function (key) {
          overlayLayers.push(new SingularOverlayLayer({ name: key, subCompositions: response[key].subCompositions }));
        });

        return overlayLayers;
      });
    },

    updateOverlay: function updateOverlay(gameId, audioStreamId, overlayName, key, value) {
      var queryUrl = window.location.api("/broadcastManager/game/" + gameId + "/singular/overlays");

      var values = {};
      values[key] = value;

      var overlay = {
        overlayName: overlayName,
        values: values
      };

      var payload = {
        audioStreamId: audioStreamId,
        overlays: [overlay]
      };

      return $http.put(queryUrl, payload);
    },

    toggleOverlays: function toggleOverlays(gameId, audioStreamId, active, names) {
      var queryUrl = window.location.api("/broadcastManager/game/" + gameId + "/singular/overlays/toggle");

      var payload = {
        audioStreamId: audioStreamId,
        active: active,
        overlayNames: names
      };

      return $http.post(queryUrl, payload);
    },

    bindOverlayHeadToHeadData: function bindOverlayHeadToHeadData(gameId, audioStreamId) {
      var queryUrl = window.location.api("/broadcastManager/game/" + gameId + "/singular/overlay/head_to_head?audio_stream_id=" + audioStreamId);
      return $http.put(queryUrl, {});
    },

    bindModifierHeadToHeadData: function bindModifierHeadToHeadData(gameId, audioStreamId) {
      var queryUrl = window.location.api("/broadcastManager/game/" + gameId + "/singular/modifier/head_to_head?audio_stream_id=" + audioStreamId);
      return $http.put(queryUrl, {});
    },

    bindOverlayTeamScheduleData: function bindOverlayTeamScheduleData(gameId, audioStreamId, teamId, overlayName) {
      var queryUrl = window.location.api("/broadcastManager/game/" + gameId + "/singular/overlay/team_upcoming_schedule?audio_stream_id=" + audioStreamId + "&team_id=" + teamId + "&overlay_name=" + overlayName);
      return $http.put(queryUrl, {});
    },

    bindOverlayLeagueScheduleData: function bindOverlayLeagueScheduleData(gameId, audioStreamId, overlayName) {
      var queryUrl = window.location.api("/broadcastManager/game/" + gameId + "/singular/overlay/league_upcoming_schedule?audio_stream_id=" + audioStreamId + "&overlay_name=" + overlayName);
      return $http.put(queryUrl, {});
    },

    bindOverlayTeamLineupData: function bindOverlayTeamLineupData(gameId, audioStreamId) {
      var queryUrl = window.location.api("/broadcastManager/game/" + gameId + "/singular/overlay/team_lineup?audio_stream_id=" + audioStreamId);
      return $http.put(queryUrl, {});
    },

    bindModifierPowerPlayEfficiency: function bindModifierPowerPlayEfficiency(gameId, audioStreamId, homePowerPlay) {
      var queryUrl = window.location.api("/broadcastManager/game/" + gameId + "/singular/modifier/power_play_efficiency?audio_stream_id=" + audioStreamId + "&home_power_play=" + homePowerPlay);
      return $http.put(queryUrl, {});
    },

    bindOverlayThreeStarsData: function bindOverlayThreeStarsData(gameId, audioStreamId) {
      var queryUrl = window.location.api("/broadcastManager/game/" + gameId + "/singular/overlay/three_stars?audio_stream_id=" + audioStreamId);
      return $http.put(queryUrl, {});
    },

    bindOverlayUpcomingCalendarData: function bindOverlayUpcomingCalendarData(gameId, audioStreamId) {
      var queryUrl = window.location.api("/broadcastManager/game/" + gameId + "/singular/overlay/upcoming_calendar?audio_stream_id=" + audioStreamId);
      return $http.put(queryUrl, {});
    },

    bindModifierOverallTeamRecord: function bindModifierOverallTeamRecord(gameId, audioStreamId) {
      var queryUrl = window.location.api("/broadcastManager/game/" + gameId + "/singular/modifier/overall_team_record?audio_stream_id=" + audioStreamId);
      return $http.put(queryUrl, {});
    }

  };
}]);

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScoringProvider = exports.ScoringProvider = {
  HockeyTV: 0,
  Leaguestat: 7,
  Sportzcast: 8
};

var SingularOverlay = exports.SingularOverlay = function () {
  function SingularOverlay(obj) {
    var _this = this;

    _classCallCheck(this, SingularOverlay);

    this.name = obj && obj.name || "";
    this.cleanName = obj && obj.cleanName || this.name.substring(this.name.indexOf('-') + 1);
    this.active = obj && obj.active || false;
    this.overlayType = obj && obj.overlayType || "";
    this.availability = obj && obj.availability && new SingularOverlayAvailability(obj.availability) || new SingularOverlayAvailability();
    this.watermarkImage200x100 = obj && obj.watermarkImage200x100 && new SingularOverlayKeyValue(obj.watermarkImage200x100) || null;
    this.sponsorImage200x100 = obj && obj.sponsorImage200x100 && new SingularOverlayKeyValue(obj.sponsorImage200x100) || null;
    this.sponsorImage1328x100 = obj && obj.sponsorImage1328x100 && new SingularOverlayKeyValue(obj.sponsorImage1328x100) || null;
    this.sponsorImage1920x1080 = obj && obj.sponsorImage1920x1080 && new SingularOverlayKeyValue(obj.sponsorImage1920x1080) || null;
    this.allowPowerPlay = obj && obj.allowPowerPlay && new SingularOverlayKeyValue(obj.allowPowerPlay) || null;

    this.subLayers = {};
    if (obj && obj.subLayers) {
      Object.keys(obj.subLayers).forEach(function (key) {
        _this.subLayers[key] = new SingularOverlayLayer({ name: key, subCompositions: obj.subLayers[key].subCompositions });
      });
    }
  }

  _createClass(SingularOverlay, [{
    key: "AvailableForScoring",
    value: function AvailableForScoring(scoringProviderId) {
      var isAdmin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.availability.hidden && !isAdmin) {
        return false;
      } else if (scoringProviderId == ScoringProvider.HockeyTV && this.availability.hockeyTVScoring) {
        return true;
      } else if (scoringProviderId == ScoringProvider.Leaguestat && this.availability.leaguestatScoring) {
        return true;
      } else if (scoringProviderId == ScoringProvider.Sportzcast && this.availability.sportzcastScoring) {
        return true;
      } else {
        return false;
      }
    }
  }]);

  return SingularOverlay;
}();

var SingularOverlayAvailability = exports.SingularOverlayAvailability = function SingularOverlayAvailability(obj) {
  _classCallCheck(this, SingularOverlayAvailability);

  this.hidden = obj && obj.hidden || false;
  this.locked = obj && obj.locked || false;
  this.hockeyTVScoring = obj && obj.hockeyTVScoring || false;
  this.leaguestatScoring = obj && obj.leaguestatScoring || false;
  this.sportzcastScoring = obj && obj.sportzcastScoring || false;
};

var SingularOverlayKeyValue = exports.SingularOverlayKeyValue = function SingularOverlayKeyValue(obj) {
  _classCallCheck(this, SingularOverlayKeyValue);

  this.key = obj && obj.key || "";
  this.value = obj && obj.value || "";
};

var SingularOverlayLayer = exports.SingularOverlayLayer = function () {
  function SingularOverlayLayer(obj) {
    var _this2 = this;

    _classCallCheck(this, SingularOverlayLayer);

    this.name = obj && obj.name || "";
    this.cleanName = obj && obj.cleanName || this.name.substring(this.name.indexOf('-') + 1);

    this.subCompositions = {};
    if (obj && obj.subCompositions) {
      Object.keys(obj.subCompositions).forEach(function (key) {
        _this2.subCompositions[key] = new SingularOverlay(obj.subCompositions[key]);
      });
    }
  }

  _createClass(SingularOverlayLayer, [{
    key: "HasAvailableOverlaysForScoring",
    value: function HasAvailableOverlaysForScoring(scoringProviderId) {
      var isAdmin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      for (var key in this.subCompositions) {
        if (this.subCompositions[key].AvailableForScoring(scoringProviderId, isAdmin)) {
          return true;
        }
      }

      return false;
    }
  }]);

  return SingularOverlayLayer;
}();

angular.module('singularOverlaysFirebaseService', []).factory('singularOverlaysFirebaseService', ['$http', 'ADMIN_API_URL', '$q', function ($http, ADMIN_API_URL, $q) {
  var databaseRef = void 0;
  var tokensByGame = {};
  var singularOverlaysCallbacks = {};
  var userInfo = null;
  var os = null;
  var browser = null;

  var getFbToken = function getFbToken(gameId) {
    var deferred = $q.defer();

    if (!tokensByGame[gameId]) {
      var queryUrl = ADMIN_API_URL + "/broadcastManager/fbjwt/" + gameId;

      $http.get(queryUrl).then(function (response) {
        tokensByGame[gameId] = response.data.jwt;
        deferred.resolve();
      }, function (error) {
        deferred.reject();
      });
    } else {
      deferred.resolve();
    }

    return deferred.promise;
  };

  var init = function init(fbDatabase, fbApiKey, userData, gameId) {
    var deferred = $q.defer();

    // Set info for logging
    userInfo = userData;
    os = window.navigator.platform;
    browser = window.navigator.userAgent;

    setTimeout(function (_) {
      firebase.initializeApp({
        apiKey: fbApiKey,
        databaseURL: fbDatabase
      });
    }, 0);

    getFbToken(gameId).then(function (_) {
      // Existing and future Auth states are now persisted in the current session
      // only. Closing the window would clear any existing state even if a user
      // forgets to sign out. New sign-in will be persisted with session persistence.
      firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION).then(function () {
        // Once I have the 'token', the clientside JS authenticates here...
        return firebase.auth().signInWithCustomToken(tokensByGame[gameId]).then(function () {
          databaseRef = firebase.database().ref();
          deferred.resolve();
        }).catch(function (error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          console.warn("ERROR: Firebase failed to authenticate", errorCode, errorMessage);
        });
      }).catch(function (error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        console.warn("ERROR: Firebase failed to authenticate", errorCode, errorMessage);
      });
    });

    return deferred.promise;
  };

  var logUserAction = function logUserAction(gameId, action, method) {
    var data = {
      action: action,
      method: method,
      timestamp: Date.now(),
      userInfo: {
        userId: userInfo.iuserid,
        firstName: userInfo.first_name,
        lastName: userInfo.last_name,
        email: userInfo.login_name,
        os: os,
        browser: browser
      }
    };

    var fbPath = "game/" + gameId + "/useractions";
    var useractionsRef = databaseRef.child(fbPath);

    useractionsRef.push(data).catch(function (error) {
      console.warn(error.message);
    });
  };

  var addToSingularOverlaysCallbacks = function addToSingularOverlaysCallbacks(gameId, audioId, listenerCallback) {
    var gameUid = getGameLookupString(gameId, audioId);

    if (!singularOverlaysCallbacks[gameUid]) {
      singularOverlaysCallbacks[gameUid] = {
        listenerCallbacks: []
      };
    }

    singularOverlaysCallbacks[gameUid].listenerCallbacks.push(listenerCallback);
  };

  var getGameLookupString = function getGameLookupString(gameId, audioId) {
    if (!gameId) {
      console.log("ERROR: svfFb::createGameUid saw an invalid gameId - ", gameId);
      return undefined;
    }
    if (!audioId) {
      console.log("ERROR: svfFb::createGameUid saw an invalid langId - ", langId);
      return undefined;
    }

    return gameId + '-' + audioId;
  };

  var updateSingularOverlays = function updateSingularOverlays(gameId, audioId, data) {
    var fbPath = "game/" + gameId + "/" + audioId + "/overlays";
    var overlaysRef = databaseRef.child(fbPath);

    overlaysRef.update(data).catch(function (error) {
      console.warn(error.message);
    });
  };

  var singularOverlaysCallbacksEmpty = function singularOverlaysCallbacksEmpty(gameId, audioId) {
    if (!gameId) {
      console.error("ERROR: svfFb::singularOverlaysCallbacksEmpty got an invalid gameId param - ", gameId);
    }
    if (!audioId) {
      console.error("ERROR: svfFb::singularOverlaysCallbacksEmpty got an invalid audioId param - ", audioId);
    }

    if (!singularOverlaysCallbacks[getGameLookupString(gameId, audioId)]) return true;

    if (!singularOverlaysCallbacks[getGameLookupString(gameId, audioId)].listenerCallbacks) return true;

    if (!singularOverlaysCallbacks[getGameLookupString(gameId, audioId)].listenerCallbacks.length) return true;

    return false;
  };

  var handleSingularOverlaysUpdate = function handleSingularOverlaysUpdate(snapshot) {
    var splitUrl = snapshot.ref.path.toString().split("/");
    var gameId = parseInt(splitUrl[2]);
    var audioId = parseInt(splitUrl[3]);
    var snapshotVal = snapshot.val();

    if (snapshotVal != null) {
      var overlayLayers = {};
      if (snapshotVal.singularState) {
        Object.keys(snapshotVal.singularState).forEach(function (key) {
          overlayLayers[key] = new SingularOverlayLayer({ name: key, subCompositions: snapshotVal.singularState[key].subCompositions });
        });
      }

      snapshotVal.gameId = gameId;
      snapshotVal.audioId = audioId;
      snapshotVal.singularState = overlayLayers;
    }

    singularOverlaysCallbacks[getGameLookupString(gameId, audioId)].overlayData = snapshotVal;

    notifySingularOverlaysListeners(gameId, audioId);
  };

  var notifySingularOverlaysListeners = function notifySingularOverlaysListeners(gameId, audioId) {
    if (!singularOverlaysCallbacksEmpty(gameId, audioId)) {
      angular.forEach(singularOverlaysCallbacks[getGameLookupString(gameId, audioId)].listenerCallbacks, function (listenerCallback) {
        listenerCallback(singularOverlaysCallbacks[getGameLookupString(gameId, audioId)].overlayData);
      });
    }
  };

  var removeFromSingularOverlaysCallbacks = function removeFromSingularOverlaysCallbacks(gameId, audioId, listenerCallback) {
    var gameUid = getGameLookupString(gameId, audioId);

    if (!singularOverlaysCallbacks[gameUid]) {
      console.log("ERROR: removeFromSingularOverlaysCallbacks called on callback that is not in our collection of callbacks (place 1)", singularOverlaysCallbacksEmpty, gameUid);
      return;
    }

    if (!singularOverlaysCallbacks[gameUid].listenerCallbacks) {
      console.log("ERROR: removeFromSingularOverlaysCallbacks called on callback that is not in our collection of callbacks (place 2)", singularOverlaysCallbacksEmpty, gameUid);
      return;
    }

    if (!singularOverlaysCallbacks[gameUid].listenerCallbacks.length) {
      console.log("ERROR: removeFromSingularOverlaysCallbacks called on callback that is not in our collection of callbacks (place 3)", singularOverlaysCallbacksEmpty, gameUid);
      return;
    }

    for (var i = 0; i < singularOverlaysCallbacks[gameUid].listenerCallbacks.length; i++) {
      if (singularOverlaysCallbacks[gameUid].listenerCallbacks[i] == listenerCallback) {
        singularOverlaysCallbacks[gameUid].listenerCallbacks.splice(i, 1);
        return;
      }
    }

    console.log("ERROR: removeFromSingularOverlaysCallbacks called on callback that is not in our collection of callbacks (place 4)", singularOverlaysCallbacksEmpty, gameUid);
  };

  var subscribeToSingularOverlays = function subscribeToSingularOverlays(gameId, audioId, listenerCallback) {
    if (!gameId) console.log("ERROR: svfFb::subscribeToSingularOverlays saw an invalid gameId ", gameId);
    if (!audioId) console.log("ERROR: svfFb::subscribeToSingularOverlays saw an invalid audioId param ", audioId);
    if (!listenerCallback) console.log("ERROR: svfFb::subscribeToSingularOverlays saw an invalid listenerCallback param ", listenerCallback);

    var subscribeToFb = false;

    if (singularOverlaysCallbacksEmpty(gameId, audioId)) {
      // Determine if this is the first subscription.
      subscribeToFb = true;
    }

    addToSingularOverlaysCallbacks(gameId, audioId, listenerCallback);
    if (singularOverlaysCallbacksEmpty(gameId, audioId)) {
      console.log("ERROR: svfFb::subscribeToSingularOverlays saw an inconsistency where the callbacks are empty after adding to the callbacks", gameId, audioId, listenerCallback);
    }

    if (subscribeToFb) {
      var fbPath = "game/" + gameId + "/" + audioId + "/overlays";
      databaseRef.child(fbPath).on('value', handleSingularOverlaysUpdate);
    }

    return;
  };

  var unsubscribeFromSingularOverlays = function unsubscribeFromSingularOverlays(gameId, audioId, listenerCallback) {

    removeFromSingularOverlaysCallbacks(gameId, audioId, listenerCallback);

    if (singularOverlaysCallbacksEmpty(gameId, audioId)) {
      // Close down the firebase listeners
      var fbPath = "game/" + gameId + "/" + audioId + "/overlays";
      databaseRef.child(fbPath).on('value', handleSingularOverlaysUpdate);
    }
  };

  return {
    init: init,
    subscribeToSingularOverlays: subscribeToSingularOverlays,
    unsubscribeFromSingularOverlays: unsubscribeFromSingularOverlays,
    updateSingularOverlays: updateSingularOverlays,
    logUserAction: logUserAction
  };
}]);

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.admin.broadcastManager.broadcastManagerService').controller('imageDialogController', ['$uibModalInstance', 'images', function ($uibModalInstance, images) {
    var $ctrl = this;
    $ctrl.images = images;

    $ctrl.selectImage = function (img) {
        $uibModalInstance.close(img);
    };
}]);

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(448);

"use strict";

angular.module('app.shared.graphicOverlay.graphicOverlayDirective', ['app.shared.graphicOverlay.graphicOverlayController']).directive('graphicOverlay', [function () {
  return {
    restrict: 'E',
    templateUrl: 'components/shared/graphicOverlay/graphicOverlayView.html',
    controller: 'app.shared.graphicOverlay.graphicOverlayController',
    scope: {
      game: '=',
      layout: '<',
      save: '&?'
    }
  };
}]);

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(2);

angular.module('app.shared.graphicOverlay.graphicOverlayController', ['app.shared.singleGameService']).controller('app.shared.graphicOverlay.graphicOverlayController', ['$scope', 'app.shared.singleGameService', function ($scope, singleGame) {
  "use strict";

  $scope.game = $scope.game || null;
  $scope.layout = $scope.layout || null;
  $scope.save = $scope.save || null;

  var init = function init() {
    $scope.game = singleGame.transform($scope.game);
  };

  $scope.splitText = function () {
    if ($scope.game && $scope.game.overlay) {
      $scope.game.overlay.splitText = singleGame.splitOverlayText($scope.game.overlay.stroverlayoverride);
    }
  };

  $scope.mergeText = function () {
    if ($scope.game && $scope.game.overlay) {
      $scope.game.overlay.stroverlayoverride = $scope.game.overlay.splitText.join(';');
    }
  };

  $scope.$watch(function () {
    if ($scope.game) {
      return $scope.game.igameid;
    }
    return null;
  }, function () {
    init();
  });

  init();
}]);

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(450);

'use strict';

angular.module('app.admin.reports', ['app.admin.reports.reportsController']).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.admin.reports', {
        url: '/reporting',
        templateUrl: 'components/admin/reports/reportsView.html',
        controller: 'app.admin.reports.reportsController',
        title: 'Reporting'
    });
}]);

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(451);
__webpack_require__(125);

"use strict";

angular.module('app.admin.reports.reportsController', ['app.admin.reports.reportService', 'app.shared.dateService']).controller('app.admin.reports.reportsController', ['$scope', 'app.admin.reports.reportService', 'app.shared.dateService', 'PRODUCT', function ($scope, reportService, dateService, PRODUCT) {
  $scope.season = null;
  $scope.dataLoading = false;
  $scope.fileLoading = false;
  $scope.reportsMap = null;
  $scope.heatmap = null;
  $scope.prevSelection = null;
  $scope.type = null;

  $scope.report = reportService;
  $scope.seasonList = [];
  $scope.availableTypes = {
    league: null,
    team: null,
    event: null
  };

  $scope.product = PRODUCT;

  var league_team = null;

  var init = function init() {
    $scope.report.clear();

    switch (PRODUCT.Code) {
      case "ahl":
        $scope.seasonList = dateService.generateSeasonList(29, '2018/2019');
        break;
      case "htv":
      default:
        $scope.seasonList = dateService.generateSeasonList(25, '2014/2015');
        break;
    }

    if ($scope.seasonList.length === 1) {
      $scope.season = $scope.seasonList[0];
    }

    $scope.report.getSelections().then(function () {
      if ($scope.report.list) {
        if ($scope.report.list.leagues.length === 1) {
          $scope.selectedOption($scope.report.list.leagues[0]);
        } else if ($scope.report.list.teams.length === 1) {
          $scope.selectedOption($scope.report.list.teams[0]);
        }
      }
    });

    var mapOptions = {
      zoom: 4,
      center: new google.maps.LatLng(40.0000, -98.0000),
      mapTypeId: google.maps.MapTypeId.SATELLITE
    };

    var mapElem = $(".report").find("#reportsMap")[0];

    $scope.reportsMap = new google.maps.Map(mapElem, mapOptions);
  };

  $scope.selectedOption = function (type) {
    if ($scope.season && type) {

      $scope.dataLoading = true;
      $scope.type = type;

      if ($scope.heatmap) {
        $scope.heatmap.setMap(null);
        $scope.heatmap = null;
      }

      reportService.clear();

      var selection = $scope.typeSelected(type);
      selection.season_id = $scope.season.id;
      $scope.prevSelection = $scope.season.id;

      reportService.retrieve(selection);
    }
  };

  $scope.getReportFile = function (fileType) {
    $scope.fileLoading = true;
    var selection = $scope.typeSelected($scope.type);
    selection.season_id = $scope.season.id;

    var filename = "";
    if ($scope.type.ileagueid) {
      filename = $scope.type.strleaguename.replace(" ", "_") + "_" + $scope.season.year.replace("/", "-");
    } else if ($scope.type.iteamid) {
      filename = $scope.type.strteamname + "_" + $scope.type.strteammascot + "_" + $scope.season.year.replace("/", "-");
    } else {
      filename = "event";
    }

    var fileParams = {
      type: fileType,
      filename: filename
    };

    reportService.getReportFile(fileParams, selection);
  };

  $scope.assignReportSelection = function (aggregate) {
    if (aggregate.iteamid !== undefined) {
      league_team = aggregate;
      $scope.selectedOption(aggregate);
    }
  };

  $scope.typeSelected = function (type) {
    var selection = null;

    switch (true) {
      case type.ileagueid !== undefined:
        selection = {
          type: 'league',
          select_id: type.ileagueid
        };
        break;
      case type.iteamid !== undefined:
        selection = {
          type: 'team',
          select_id: type.iteamid
        };
        break;
      case type.calid !== undefined:
        selection = {
          type: 'event',
          select_id: type.calid
        };
        break;
      default:
        return null;
    }

    $scope.selection = selection;

    clearTypes(selection.type);
    return selection;
  };

  var clearTypes = function clearTypes(type) {
    if (type === 'all') {
      _.each($scope.availableTypes, function (type) {
        type = null;
      });
    } else {
      _.each(Object.getOwnPropertyNames($scope.availableTypes), function (property) {
        if (property !== type) {
          $scope.availableTypes[property] = null;
        }
      });
    }
  };

  $scope.isTypesEmpty = function () {
    return !$scope.availableTypes.team && !$scope.availableTypes.league && !$scope.availableTypes.event && !league_team;
  };

  $scope.seasonUpdated = function () {
    if ($scope.season && PRODUCT.Code === 'htv') {
      if ($scope.season.id !== $scope.prevSelection) {

        var selectedType = null;

        _.each($scope.availableTypes, function (type) {
          if (angular.isObject(type)) {
            selectedType = type;
          }
        });

        if (selectedType && selectedType.hasOwnProperty('calid')) {
          clearTypes('all');
        } else if (selectedType && !selectedType.hasOwnProperty('calid')) {
          if (league_team) {
            league_team = null;
          }

          $scope.selectedOption(selectedType);
        }

        $scope.report.clear();

        if ($scope.heatmap) {
          $scope.heatmap.setMap(null);
          $scope.heatmap = null;
        }
      }
      reportService.getEvents($scope.season.id);
    }
  };

  $scope.prepHeatMap = function (map) {
    if ($scope.report.points) {
      $scope.heatmap = new google.maps.visualization.HeatmapLayer({
        data: $scope.report.points,
        map: map
      });
    }
  };

  $scope.$watch('report.viewerships', function () {
    if ($scope.report.viewerships) {
      $scope.dataLoading = false;
    }
    $scope.prepHeatMap($scope.reportsMap);
  });

  $scope.$watch('report.loading', function () {
    if (!$scope.report.loading) {
      $scope.fileLoading = false;
    }
  });

  init();
}]);

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.admin.reports.reportService', []).factory('app.admin.reports.reportService', ['$http', '$q', '$httpParamSerializerJQLike', function ($http, $q, $httpParamSerializerJQLike) {
  /**
   * @type {ReportService}
   */
  var service = {
    viewerships: null,
    loading: false,
    points: [],
    list: null,
    eventslist: null,
    error: null,
    _debounceRetrieve: _.debounce(function (deferred, params, callback) {
      "use strict";
      /**
       * @param {*} data
       */

      var processData = function processData(data) {
        if (data.error) {
          service.error = data.error;
        } else if (data) {
          service.viewerships = data;

          angular.forEach(service.viewerships.aggregates, function (aggregate) {
            if (aggregate.dtegametimefixed) {
              aggregate.dtegametimefixed = moment.unix(aggregate.dtegametimefixed).format('MMM DD, YYYY :: hh:mm A');
            }
          });

          angular.forEach(service.viewerships.data, function (datum) {
            var point = new google.maps.LatLng(Number(datum.latitude), Number(datum.longitude));
            service.points.push(point);
          });
        }

        if (typeof callback !== 'undefined') {
          callback();
        }
      };

      $http.get(window.location.api('/admin/reporting/viewerships/?' + params)).then(
      /**
       * @param {HttpResponse} response
       */
      function (response) {
        processData(response.data);
        deferred.resolve(response);
      },
      /**
       * @param {HttpResponse} response
       */
      function (response) {
        processData(response.data);
        deferred.resolve(response);
      });
    }, 200),

    retrieve: function retrieve(params, callback) {
      service.loading = true;
      params = $httpParamSerializerJQLike(params);
      var deferred = $q.defer();
      service._debounceRetrieve(deferred, params, callback);
      return deferred.promise;
    },

    _debounceRetrieveFile: _.debounce(function (fileParams, deferred, params, callback) {
      "use strict";
      /**
       * @param {*} data
       */

      var processData = function processData(data) {
        if (data.error) {
          service.error = data.error;
        } else if (data) {
          var blob = service.base64toBlob(data.data, data.mimetype);

          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          service.loading = false;
          link.download = fileParams.filename + "." + fileParams.type;
          link.click();
        }

        if (typeof callback !== 'undefined') {
          callback();
        }
      };

      var reportRoute = "";
      if (fileParams.type === "pdf") {
        reportRoute = "/admin/reporting/viewerships_pdf/?" + params;
      } else if (fileParams.type === "csv") {
        reportRoute = "/admin/reporting/viewerships_csv/?" + params;
      } else {
        alert('Invalid report type requested');
      }

      $http.get(window.location.api(reportRoute)).then(
      /**
       * @param {HttpResponse} response
       */
      function (response) {
        processData(response.data);
        service.loading = false;
        deferred.resolve(response);
      },
      /**
       * @param {HttpResponse} response
       */
      function (response) {
        processData(response.data);
        service.loading = false;
        deferred.resolve(response);
      });
    }, 200),

    getReportFile: function getReportFile(fileParams, params, callback) {
      service.loading = true;
      params = $httpParamSerializerJQLike(params);
      var deferred = $q.defer();
      service._debounceRetrieveFile(fileParams, deferred, params, callback);
      return deferred.promise;
    },

    base64toBlob: function base64toBlob(b64Data) {
      var contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var sliceSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },

    getSelections: function getSelections() {
      return $http.get(window.location.api('/admin/reporting/selections')).then(function (response) {
        service.list = response.data;

        service.list.teams.sort(function (a, b) {
          var nameA = a.leaguenickname.toUpperCase(); // ignore upper and lowercase
          var nameB = b.leaguenickname.toUpperCase(); // ignore upper and lowercase

          if (nameA < nameB) {
            return -1;
          } else if (nameA > nameB) {
            return 1;
          } else if (nameA === nameB) {
            var _nameA = a.label.toUpperCase(); // ignore upper and lowercase
            var _nameB = b.label.toUpperCase(); // ignore upper and lowercase

            if (_nameA < _nameB) {
              return -1;
            } else if (_nameA > _nameB) {
              return 1;
            }
          }

          // names must be equal
          return 0;
        });
      });
    },

    getEvents: function getEvents(params) {
      //params = $httpParamSerializerJQLike(params);
      return $http.get(window.location.api('/admin/reporting/events/' + params)).then(function (response) {
        service.eventslist = response.data;
      });
    },

    clear: function clear() {
      service.viewerships = null;
      service.points.length = 0;
    }
  };

  return service;
}]);

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(460);

angular.module('app.admin.videoAnalysis', ['app.admin.videoAnalysis.videoAnalysisController', 'app.admin.videoAnalysis.tabs.myClips', 'app.admin.videoAnalysis.tabs.filterForm']).config(['$stateProvider', function ($stateProvider) {
  "use strict";

  $stateProvider.state('app.admin.videoAnalysis', {
    abstract: true,
    url: '/video-analysis',
    templateUrl: 'components/admin/videoAnalysis/videoAnalysisView.html',
    controller: 'app.admin.videoAnalysis.videoAnalysisController',
    title: 'Video Analysis'
  });
}]);

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.admin.videoAnalysis.videoAnalysisController', []).controller('app.admin.videoAnalysis.videoAnalysisController', ['$scope', '$transitions', function ($scope, $transitions) {
  "use strict";

  $scope.filterData = {
    filters: {},
    labels: {},
    preset: null
  };

  $scope.filterCleared = false; // determines when user clears filters on my clips view

  $scope.cachedFilterData = {};

  $transitions.onStart({}, function ($transition) {
    var toState = $transition.$to();
    var fromState = $transition.$from();

    var params = $transition.params();

    if (toState.name === 'app.admin.videoAnalysis.filterForm') {
      if (!angular.equals({}, $scope.filterData.filters)) {
        $scope.cachedFilterData.filters = $scope.cachedFilterData.hasOwnProperty('filters') ? $scope.cachedFilterData.filters : JSON.stringify($scope.filterData.filters);

        $scope.cachedFilterData.preset = $scope.cachedFilterData.hasOwnProperty('preset') ? $scope.cachedFilterData.preset : null;
      } else {
        if ($scope.cachedFilterData.hasOwnProperty('filters') && !angular.equals({}, $scope.cachedFilterData.filters) && !$scope.filterCleared) {

          //toState.params.filter = $scope.cachedFilterData.filters;
        } else {
          $scope.cachedFilterData.filters = JSON.stringify(angular.copy($scope.filterData.filters));
          $scope.cachedFilterData.preset = JSON.stringify(angular.copy($scope.filterData.preset));
          //toState.params.filter = $scope.cachedFilterData.filters;

          if ($scope.filterCleared) {
            $scope.filterCleared = false;
          }
        }
      }
    }

    if (fromState.name === 'app.admin.videoAnalysis.filterForm' && params && angular.isDefined(params.filter)) {

      if (params.submitted) {
        $scope.filterData.filters = params.filter;
        $scope.filterData.preset = params.preset;

        $scope.cachedFilterData = angular.copy($scope.filterData);
      } else {
        $scope.cachedFilterData.filters = params.filter;
        $scope.cachedFilterData.preset = params.preset;
      }
    }
  });
}]);

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(455);
__webpack_require__(458);

angular.module('app.admin.videoAnalysis.tabs.myClips', ['app.admin.videoAnalysis.tabs.myClips.myClipsController', 'app.shared.clipSearch.filterDirective']).config(['$stateProvider', function ($stateProvider) {
  "use strict";

  $stateProvider.state('app.admin.videoAnalysis.myClips', {
    url: '/my-clips?:filter',
    templateUrl: 'components/admin/videoAnalysis/tabs/myClips/myClipsView.html',
    controller: 'app.admin.videoAnalysis.tabs.myClips.myClipsController',
    isChildState: true,
    tabName: 'myClips',
    params: {
      preset: null,
      submitted: null
      //selected_clip: null
    }
  }).state('app.admin.videoAnalysis.starredClips', {
    url: '/starred-clips?:filter',
    templateUrl: 'components/admin/videoAnalysis/tabs/myClips/myClipsView.html',
    controller: 'app.admin.videoAnalysis.tabs.myClips.myClipsController',
    isChildState: true,
    tabName: 'starredClips',
    filterOverride: { starred: 'starred' },
    params: {
      preset: null,
      submitted: null
    }
  });
}]);

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(77);
__webpack_require__(4);
__webpack_require__(456);
__webpack_require__(457);

angular.module('app.admin.videoAnalysis.tabs.myClips.myClipsController', ['app.shared.clipSearchService', 'app.shared.singleClipService', 'app.admin.videoAnalysis.customHeaderService', 'app.shared.clipSortService']).controller('app.admin.videoAnalysis.tabs.myClips.myClipsController', ['$scope', 'app.shared.clipSearchService', '$filter', '$stateParams', 'app.shared.singleClipService', '$window', '$sce', '$state', 'app.admin.videoAnalysis.customHeaderService', 'app.shared.clipSortService', '$anchorScroll', function ($scope, clipSearchService, $filter, $stateParams, singleClipService, $window, $sce, $state, customHeaderService, clipSortService, $anchorScroll) {
  "use strict";

  $scope.clipResults = null;
  $scope.positions = ['LW', 'RW', 'C', 'LD', 'RD', 'G'];
  $scope.checkedClips = [];
  $scope.loadingClips = true;
  $scope.show_table_data = true;
  $scope.dashIcon = '<i class="fa fa-minus"><i>';
  $scope.customHeaders = customHeaderService;
  $scope.sorter = clipSortService;

  $scope.filterData = $scope.$parent.filterData ? $scope.$parent.filterData : {
    filters: {},
    labels: {},
    preset: null
  };

  $scope.emptyFilterTemplate = {
    message: '', //$sce.trustAsHtml('Use the <i class="fa fa-plus-square" style="margin-left: 5px; margin-right: 5px;"></i> icon on the right to filter category, opponent, date range, and/or player'),
    buttonTemplate: 'admin.videoAnalysis.myClips.emptyFilterButtons.html',
    buttonClass: 'clip-search-filter__buttons--no-margin clip-search-filter__buttons--align-right'
  };

  $scope.filterTemplate = {
    buttonTemplate: 'admin.videoAnalysis.myClips.filterButtons.html',
    buttonClass: 'clip-search-filter__buttons--no-margin clip-search-filter__buttons--row-layout',
    clear: function clear() {
      if (angular.isObject($scope.filterData.filters)) {
        for (var i in $scope.filterData.filters) {
          if ($scope.filterData.filters.hasOwnProperty(i)) {
            delete $scope.filterData.filters[i];
          }
        }
      }

      if (angular.isObject($scope.filterData.preset)) {
        delete $scope.filterData.preset;
      }

      $scope.$parent.filterCleared = true;
    }
  };

  $scope.pager = {
    pageSize: 50,
    offset: 0,
    currentPage: 1,
    pageChanged: function pageChanged() {
      $scope.pager.offset = ($scope.pager.currentPage - 1) * $scope.pager.pageSize;
      getClips();
      $anchorScroll('clipTableTop');
      /*if($stateParams.selected_clip) {
        $scope.toggleChecked(JSON.parse($stateParams.selected_clip.iclipid));
      }*/
    },
    show: function show() {
      return $scope.clipResults && $scope.clipResults.count > $scope.pager.pageSize;
    },
    displayString: function displayString() {
      var totalCount = $scope.clipResults ? $scope.clipResults.count : 0;
      var start = $scope.pager.offset + 1;
      var stop = $scope.pager.offset + $scope.pager.pageSize;

      if (stop > totalCount) {
        stop = totalCount;
      }

      return 'Total: ' + totalCount + ' Displaying: ' + start + ' - ' + stop;
    }
  };

  var tdStyleHelper = function tdStyleHelper(e, tr) {
    //fixes style issue of td cells not displaying correct while item is being dragged.
    var $originals = tr.children();
    var $helper = tr.clone();
    $helper.children().each(function (index) {
      $(this).width($originals.eq(index).width());
      $(this).height($originals.eq(index).height());
    });
    return $helper;
  };

  $scope.sortableOptions = {
    helper: tdStyleHelper,
    cancel: ".deselected_header"
  };

  var init = function init() {
    if ($stateParams.filter) {
      $scope.filterData.filters = JSON.parse($stateParams.filter);
    }

    $scope.defaultValue = angular.equals($scope.filterData.filters, { seasons: [28] }) || angular.equals($scope.filterData.filters, { end_date: null, seasons: [28], start_date: null });

    $scope.customHeaders.assignSelectedHeaders();
  };

  var getClips = function getClips() {
    if (!angular.isObject($scope.filterData.filters)) {
      $scope.filterData.filters = {};
    }

    var filters = angular.copy($scope.filterData.filters);
    filters.offset = $scope.pager.offset;
    filters.limit = $scope.pager.pageSize;

    if (angular.isObject($state.current.filterOverride)) {
      for (var i in $state.current.filterOverride) {
        if ($state.current.filterOverride.hasOwnProperty(i)) {
          filters[i] = $state.current.filterOverride[i];
        }
      }
    }
    //console.log(filters);

    return clipSearchService.retrieve(filters).then(function (response) {
      var data = response.data;

      if (data.error) {
        alert(data.error);
      } else {
        $scope.clipResults = data;
        $scope.filterData.labels = $scope.clipResults.filter_data.labels;

        $scope.sortClips();

        if (angular.isDefined($state.current.filterOverride) && $state.current.filterOverride['starred']) {
          delete $scope.filterData.labels['starred-1'];
        }

        $scope.checkedClips = [];
      }

      $scope.loadingClips = false;
    });
  };

  $scope.sortClips = function (header) {
    if (angular.isDefined(header)) {
      $scope.sorter.set_sort_type(header);
    }

    if ($scope.clipResults && $scope.clipResults.clips.length > 0) {
      $scope.clipResults.clips = $scope.sorter.sort_clips($scope.clipResults.clips);
    }
  };

  $scope.getClipDatum = function (clip_datum, clip) {
    switch (clip_datum) {
      case 'clip_name':
        return clip.strclipname;

      case 'game_date':
        return $filter('date')(clip.game.dtegametimefixed, 'MMM. dd, yyyy');

      case 'matchup':
        return clip.game.league.strleaguenickname + ': ' + clip.game.awayteam.abbrev + ' @ ' + clip.game.hometeam.abbrev;

      case 'category':
        return clip.clip_category.strclipcategory;

      case 'subcategory':
        return clip.clip_subcategory;

      case 'clip_time':
        return $filter('left_pad')(clip.startClockTime.hour, 2) + ':' + $filter('left_pad')(clip.startClockTime.minute, 2) + ':' + $filter('left_pad')(clip.startClockTime.second, 2);

      case 'duration':
        return $filter('left_pad')(clip.clockTime.minute, 2) + ':' + $filter('left_pad')(clip.clockTime.second, 2);

      case 'clock_time':
        return clip.game_clocktime;

      case 'period':
        return clip.iperiod;
    }
  };

  $scope.getLineup = function (clip, position) {
    position = position.toLowerCase();
    return clip.lineup[position];
  };

  $scope.saveXeditable = function (id, clip) {
    var tempClip = clip;

    delete tempClip.is_collapsed;

    singleClipService.updateClip(id, tempClip).then(function (response) {
      var data = response.data;
      if (data.error) {
        $scope.error = data.error;
      }
    });
  };

  $scope.toggleForm = function (form) {
    if (form.$visible) {
      form.$submit();
    } else {
      form.$show();
    }
  };

  $scope.toggleStarred = function (clip) {
    singleClipService.toggleStarred(clip.iclipid).then(function (response) {
      var data = response.data;

      if (data.error) {
        alert(data.error);
      }
      if (typeof data.status !== 'undefined') {
        clip.is_starred = data.status;
      }
    });
  };

  $scope.playClip = function (clip) {
    $window.open('/popup/player/#/clip/' + clip.iclipid, 'popupClip_' + clip.iclipid, "height=700,width=640");
  };

  $scope.syndicateClip = function (clip) {
    singleClipService.syndicate(clip.iclipid).then(function (response) {
      var data = response.data;

      if (data.error) {
        alert(data.error);
      } else {
        alert('Your clip is being prepared. We will email you the clip when it is ready.');
      }
    });
  };

  $scope.editClip = function (clip) {
    $state.go('app.play', { type: 'clip', id: clip.iclipid, clip_edit: true });
  };

  $scope.toggleChecked = function (clip_id) {
    var index = $scope.checkedClips.indexOf(clip_id);

    if (index > -1) {
      do {
        $scope.checkedClips.splice(index, 1);
        index = $scope.checkedClips.indexOf(clip_id);
      } while (index > -1);
    } else {
      $scope.checkedClips.push(clip_id);
    }
  };

  $scope.deleteClip = function (clip) {
    var confirmed = confirm('Really delete ' + clip.strclipname + '?');
    if (confirmed) {
      singleClipService.delete(clip.iclipid).then(function (response) {
        var data = response.data;
        if (data.error) {
          alert(data.error);
        } else {
          var clipIndex = $scope.clipResults.clips.indexOf(clip);
          if (clipIndex > -1) {
            $scope.clipResults.clips.splice($scope.clipResults.clips.indexOf(clip), 1);
          }
        }
      });
    }
  };

  $scope.deleteCheckedClips = function () {
    var confirmed = confirm('Really delete ' + $scope.checkedClips.length + ' clips?');
    if (confirmed) {
      singleClipService.bulkDelete($scope.checkedClips).then(function () {
        getClips();
      });
    }
  };

  $scope.clearCheckedClips = function () {
    $scope.checkedClips = [];
  };

  $scope.showOrHideTableData = function () {
    $scope.show_table_data = !$scope.show_table_data;

    if (!$scope.show_table_data) {
      $scope.customHeaders.sortColumnHeaders();
    }
  };

  $scope.submitSelectedHeaders = function () {
    $scope.customHeaders.assignSelectedHeaders();
    $scope.customHeaders.calcEmptyWidth('#header-scroll-container');
    $scope.showOrHideTableData();
  };

  $scope.$watch(function () {
    return $scope.filterData.filters;
  }, function () {
    getClips();
  }, true);

  init();
}]);

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.shared.clipSortService', []).factory('app.shared.clipSortService', [function () {
  "use strict";

  var sorter = void 0;
  sorter = {

    sort_type: 'game_date',

    sort_direction: -1,

    set_sort_type: function set_sort_type(type) {
      sorter.sort_type = type;
      sorter.sort_direction = sorter.sort_direction * -1;
    },

    get_sort_order: function get_sort_order() {
      var sort_order = void 0;

      sort_order = sorter.sort_type + (sorter.sort_direction === 1 ? '_asc' : '_desc');

      return sort_order;
    },

    sort_clips: function sort_clips(feed) {
      if (feed) {
        feed = angular.copy(feed);

        if (Array.isArray(feed)) {
          var a_cliptime = void 0;
          var b_cliptime = void 0;

          feed.sort(function (a, b) {
            switch (sorter.get_sort_order()) {
              case 'game_date_asc':
                return compare(a.game.dtegametimefixed, b.game.dtegametimefixed);
              case 'game_date_desc':
                return compare(b.game.dtegametimefixed, a.game.dtegametimefixed);
              case 'clip_name_asc':
                return compare(a.strclipname.toUpperCase(), b.strclipname.toUpperCase());
              case 'clip_name_desc':
                return compare(b.strclipname.toUpperCase(), a.strclipname.toUpperCase());
              case 'matchup_asc':
                return compare(a.game.league.strleaguenickname, b.game.league.strleaguenickname);
              case 'matchup_desc':
                return compare(b.game.league.strleaguenickname, a.game.league.strleaguenickname);
              case 'category_asc':
                return compare(a.clip_category.strclipcategory, b.clip_category.strclipcategory);
              case 'category_desc':
                return compare(b.clip_category.strclipcategory, a.clip_category.strclipcategory);
              case 'subcategory_asc':
                return compare(a.clip_subcategory, b.clip_subcategory);
              case 'subcategory_desc':
                return compare(b.clip_subcategory, a.clip_subcategory);
              case 'clip_time_asc':
                a_cliptime = parseInt(a.strsourcestart);
                b_cliptime = parseInt(b.strsourcestart);
                return compare(a_cliptime, b_cliptime, 'number');
              case 'clip_time_desc':
                a_cliptime = parseInt(a.strsourcestart);
                b_cliptime = parseInt(b.strsourcestart);
                return compare(b_cliptime, a_cliptime, 'number');
              case 'clock_time_asc':
                return compare(a.game_clocktime, b.game_clocktime);
              case 'clock_time_desc':
                return compare(b.game_clocktime, a.game_clocktime);
              case 'duration_asc':
                return compare(a.strsourceduration, b.strsourceduration);
              case 'duration_desc':
                return compare(b.strsourceduration, a.strsourceduration);
              case 'starred_asc':
                return compare(a.is_starred, b.is_starred);
              case 'starred_desc':
                return compare(b.is_starred, a.is_starred);
              case 'period_asc':
                return compare(parseInt(a.iperiod), parseInt(b.iperiod), 'number');
              case 'period_desc':
                return compare(parseInt(b.iperiod), parseInt(a.iperiod), 'number');
            }
          });
        }
      }
      return feed;
    }
  };
  return sorter;
}]);

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.admin.videoAnalysis.customHeaderService', []).factory('app.admin.videoAnalysis.customHeaderService', ['$filter', function ($filter) {
  "use strict";

  var service = {
    columnHeaders: [{
      header_title: 'Clip Name',
      sorting_column: 'clip_name',
      class: 'clip-name',
      selected: true
    }, {
      header_title: 'Game Date',
      sorting_column: 'game_date',
      class: 'game-date',
      selected: true
    }, {
      header_title: 'Match-up',
      sorting_column: 'matchup',
      class: 'match-up',
      selected: true
    }, {
      header_title: 'Category',
      sorting_column: 'category',
      class: 'category',
      selected: true
    }, {
      header_title: 'Clip Time',
      sorting_column: 'clip_time',
      class: 'clip-time',
      selected: true
    }, {
      header_title: 'Period',
      sorting_column: 'period',
      class: 'period',
      selected: false
    }, {
      header_title: 'Clock Time',
      sorting_column: 'clock_time',
      class: 'clock-time',
      selected: false
    }, {
      header_title: 'Duration',
      sorting_column: 'duration',
      class: 'duration',
      selected: false
    }, {
      header_title: 'Subcategory',
      sorting_column: 'subcategory',
      class: 'subcategory',
      selected: false
    }],

    activeHeaders: [],

    table_width: 837,
    remainingWidth: 0,

    addRemoveHeader: function addRemoveHeader(index) {
      service.columnHeaders[index].selected = !service.columnHeaders[index].selected;

      var currentHeader = service.columnHeaders[index];
      service.columnHeaders.splice(index, 1);

      if (!currentHeader.selected) {
        service.columnHeaders.push(currentHeader);
      } else {
        var no_header_selected = service.columnHeaders.every(function (header) {
          return !header.selected;
        });

        if (!no_header_selected) {
          for (var i = service.columnHeaders.length - 1; i >= 0; i--) {
            if (service.columnHeaders[i].selected) {
              service.columnHeaders.splice(i + 1, 0, currentHeader);
              break;
            }
          }
        } else {
          service.columnHeaders.splice(0, 0, currentHeader);
        }
      }
    },

    assignSelectedHeaders: function assignSelectedHeaders() {
      service.activeHeaders = $filter('filter')(service.columnHeaders, { selected: true });
    },

    calcEmptyWidth: function calcEmptyWidth(element) {
      var baseClass = '.video-analysis__my-clips__grid__cell--';
      var totalColumnWidth = 0;

      _.forEach(service.activeHeaders, function (header) {
        totalColumnWidth += $(baseClass + header.class).width();
      });

      service.table_width = $(element).clientWidth;

      service.remainingWidth = service.table_width - totalColumnWidth;
    },

    emptySpaceExists: function emptySpaceExists() {
      return 0 < service.remainingWidth < service.table_width;
    },

    getEmptySpaceWidth: function getEmptySpaceWidth() {
      return service.remainingWidth;
    },

    sortColumnHeaders: function sortColumnHeaders() {
      return service.columnHeaders.sort(function (a, b) {
        if (a.selected > b.selected) {
          return -1;
        }
        if (a.selected < b.selected) {
          return 1;
        }

        return 0;
      });
    }

  };

  return service;
}]);

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(459);

angular.module('app.shared.clipSearch.filterDirective', ['app.shared.clipSearch.filterDirective.filterController']).directive('clipSearchFilter', [function () {
  "use strict";

  return {
    templateUrl: 'components/shared/clipSearch/filterDirective/filterDirectiveView.html',
    controller: 'app.shared.clipSearch.filterDirective.filterController',
    scope: {
      filterData: '=',
      cachedFilterData: '=?',
      button: '<?',
      filterTemplate: '<?',
      emptyFilterTemplate: '<?',
      hideFilterActions: '=?',
      canUpdatePresets: '=?',
      hideClipCount: '=?',
      defaultValue: '=?'
    }
  };
}]);

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(78);
__webpack_require__(77);

angular.module('app.shared.clipSearch.filterDirective.filterController', ['app.shared.clipSearch.clipFilterService', 'app.shared.clipSearchService']).controller('app.shared.clipSearch.filterDirective.filterController', ['$scope', 'app.shared.clipSearch.clipFilterService', '$rootScope', 'app.shared.clipSearchService', function ($scope, clipFilterService, $rootScope, clipSearchService) {
  "use strict";

  if (!$scope.filterData) {
    $scope.filterData = {
      filters: {},
      labels: {},
      preset: null
    };
  }

  $scope.cachedFilterData = $scope.cachedFilterData || null;

  $scope.filterCount = 0;

  $scope.hideFilterActions = $scope.hideFilterActions || null;

  $scope.canUpdatePresets = $scope.canUpdatePresets || false;

  $scope.hideClipCount = $scope.hideClipCount || false;

  $scope.defaultValue = $scope.defaultValue || false;

  $scope.clipCount = null;

  if (!$scope.button) {
    $scope.button = {
      class: 'btn-light',
      text: 'Clear Filter',
      click: function click() {
        if (angular.isObject($scope.filterData.filters)) {
          for (var i in $scope.filterData.filters) {
            if ($scope.filterData.filters.hasOwnProperty(i)) {
              delete $scope.filterData.filters[i];
            }
          }
        }
      }
    };
  }

  var init = function init() {
    countLabels();

    if (!$scope.filterCount || !$scope.defaultValue) {
      clipFilterService.getFilterLabels($scope.filterData.filters).then(function (response) {
        var data = response.data;

        if (data.error) {
          alert(data.error);
        } else {
          if (angular.isObject(data) && !Array.isArray(data)) {
            $scope.filterData.labels = data;
          } else {
            $scope.filterData.labels = {};
          }
        }
      });
    }
  };

  var countLabels = function countLabels() {
    var count = 0;
    for (var i in $scope.filterData.labels) {
      if ($scope.filterData.labels.hasOwnProperty(i)) {
        if ($scope.filterData.labels[i]) {
          count += 1;
        }
      }
    }

    $scope.filterCount = count;
    $rootScope.$broadcast('forward_filter_count', { filterCount: $scope.filterCount });
  };

  var getClipCount = function getClipCount() {
    var filters = angular.copy($scope.filterData.filters);

    clipSearchService.retrieve(filters).then(function (response) {
      var data = response.data;

      if (data.error) {
        alert(data.error);
      } else {
        $scope.clipCount = parseInt(data.count);
        $rootScope.$broadcast('forward_clip_count', { clipCount: $scope.clipCount, filterCount: $scope.filterCount });
      }
    });
  };

  $scope.removeFilter = function (label_id) {
    var parts = label_id.split('-');

    if (angular.isObject($scope.filterData.filters) && (typeof $scope.filterData.filters[parts[0]] !== 'undefined' || $scope.filterData.preset)) {
      switch (parts[0]) {
        case 'starred':
          $scope.filterData.filters[parts[0]] = null;
          break;
        case 'opponent_league':
          delete $scope.filterData.filters[parts[0]];

          if (angular.isDefined($scope.filterData.filters['opponent_team'])) {
            delete $scope.filterData.filters['opponent_team'];
          }

          if (angular.isDefined($scope.filterData.filters['opponents'])) {
            delete $scope.filterData.filters['opponents'];
          }

          for (var i in $scope.filterData.labels) {
            if ($scope.filterData.labels.hasOwnProperty(i)) {
              if (i.match(/^opponent_team/)) {
                delete $scope.filterData.labels[i];
              }

              if (i.match(/^opponents/)) {
                delete $scope.filterData.labels[i];
              }
            }
          }
          break;
        case 'opponent_team':
          delete $scope.filterData.filters[parts[0]];

          if (angular.isDefined($scope.filterData.filters['opponents'])) {
            delete $scope.filterData.filters['opponents'];
          }

          for (var _i in $scope.filterData.labels) {
            if ($scope.filterData.labels.hasOwnProperty(_i)) {
              if (_i.match(/^opponents/)) {
                delete $scope.filterData.labels[_i];
              }
            }
          }
          break;
        case 'preset':
          delete $scope.filterData.filters[parts[0]];
          delete $scope.filterData.labels[parts[0]];
          $rootScope.$broadcast('clear_selected_preset');
          break;
        case 'my_teams':
        case 'categories':
        case 'subcategories':
        case 'strengths':
        case 'opponents':
        case 'opponent_players':
        case 'players':
        case 'seasons':
          var list = null;
          if (Array.isArray($scope.filterData.filters[parts[0]])) {
            list = $scope.filterData.filters[parts[0]];
          } else {
            list = $scope.filterData.filters[parts[0]].split(',');
          }

          var index = list.indexOf(parseInt(parts[1]));
          if (index > -1) {
            if (parts[0] === 'opponent_players') {
              $rootScope.$broadcast('remove_player_opp_team', { player_id: parseInt(parts[1]) });
            }

            list.splice(index, 1);
          }

          if ($scope.filterData.filters[parts[0]].length === 0) {
            delete $scope.filterData.filters[parts[0]];

            if (parts[0] === 'opponent_players') {
              delete $scope.filterData.filters['opponent_player_teams'];
            }
          }

          break;
      }
    } else if (parts[0] === 'date') {
      $scope.filterData.filters.start_date = null;
      $scope.filterData.filters.end_date = null;
    }

    delete $scope.filterData.labels[label_id];

    if ($scope.cachedFilterData && $scope.cachedFilterData.hasOwnProperty('filters')) {
      $scope.cachedFilterData.filters = JSON.stringify($scope.filterData.filters);
    }
  };

  $scope.buttonsClass = function () {
    var ngClass = {};

    if ($scope.emptyFilterTemplate && $scope.emptyFilterTemplate.buttonClass) {
      ngClass[$scope.emptyFilterTemplate.buttonClass] = !$scope.filterCount;
    }

    if ($scope.filterTemplate && $scope.filterTemplate.buttonClass) {
      ngClass[$scope.filterTemplate.buttonClass] = $scope.filterCount;
    }

    return ngClass;
  };

  $scope.getLabelType = function (label_id) {
    switch (label_id) {
      case 'preset':
      case 'preset-1':
        return label_id;
    }
    return null;
  };

  $scope.$on('update_preset_success', function (event, data) {
    $scope.canUpdatePresets = data.canUpdatePresets;
  });

  $scope.$watch(function () {
    return $scope.filterData.labels;
  }, function (newValue, oldValue) {
    countLabels();
    getClipCount();

    if ($scope.filterData.labels.hasOwnProperty('preset')) {
      $scope.canUpdatePresets = oldValue.preset === newValue.preset && !angular.equals(oldValue, newValue);
    }
  }, true);

  init();
}]);

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(461);
__webpack_require__(462);

angular.module('app.admin.videoAnalysis.tabs.filterForm', ['app.admin.videoAnalysis.tabs.filterForm.filterFormController', 'app.shared.clipSearch.filterFormDirective']).config(['$stateProvider', function ($stateProvider) {
  "use strict";

  $stateProvider.state('app.admin.videoAnalysis.filterForm', {
    url: '/filter?:filter',
    templateUrl: 'components/admin/videoAnalysis/tabs/filterForm/filterFormView.html',
    controller: 'app.admin.videoAnalysis.tabs.filterForm.filterFormController',
    isChildState: true,
    params: {
      preset: null
    }
  });
}]);

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(78);

angular.module('app.admin.videoAnalysis.tabs.filterForm.filterFormController', ['app.shared.clipSearch.clipFilterService']).controller('app.admin.videoAnalysis.tabs.filterForm.filterFormController', ['$scope', '$stateParams', '$sce', '$state', 'app.shared.clipSearch.clipFilterService', '$rootScope', function ($scope, $stateParams, $sce, $state, clipFilterService, $rootScope) {
  "use strict";

  $scope.filterFormData = {
    filters: {},
    labels: {},
    preset: null
  };

  $scope.showPresetActions = false;

  $scope.canUpdatePresets = false;

  $scope.filterTemplate = {
    buttonTemplate: 'admin.videoAnalysis.filterForm.filterButtons.html',
    buttonClass: 'clip-actions__buttons--row-layout-multiple',
    submit: function submit() {
      $state.go('app.admin.videoAnalysis.myClips', {
        filter: JSON.stringify($scope.filterFormData.filters),
        preset: JSON.stringify($scope.filterFormData.preset), submitted: true
      });
    },

    cancel: function cancel() {
      $scope.filterFormData.filters = {};
      $scope.filterFormData.labels = {};

      $scope.$broadcast('clear_dates');
      $scope.$broadcast('clear_selected_preset');

      if (angular.isObject($scope.filterFormData.preset)) {
        $scope.filterFormData.preset = null;
      }
    },

    showPresets: function showPresets() {
      $scope.showPresetActions = true;
    },

    updatePreset: function updatePreset() {
      $rootScope.$broadcast('update_preset');
    },

    deletePreset: function deletePreset() {
      $rootScope.$broadcast('delete_preset');
    }
  };

  $scope.emptyFilterTemplate = {
    message: $sce.trustAsHtml('Use the filters below to filter category, opponent, date range, and/or player'),
    buttonTemplate: 'admin.videoAnalysis.filterForm.emptyFilterButtons.html',
    buttonClass: 'clip-actions__buttons--row-layout',
    goToPrevTab: function goToPrevTab() {
      $state.go('app.admin.videoAnalysis.myClips', {
        filter: JSON.stringify($scope.filterFormData.filters),
        preset: JSON.stringify($scope.filterFormData.preset),
        submitted: false
      });
    }

  };

  var init = function init() {
    buildLabels();
  };

  var buildLabels = function buildLabels() {
    $scope.filterFormData.filters = angular.isDefined($scope.cachedFilterData.filters) ? JSON.parse($scope.cachedFilterData.filters) : {};

    $scope.filterFormData.preset = angular.isDefined($scope.cachedFilterData.preset) ? JSON.parse($scope.cachedFilterData.preset) : null;
  };

  init();
}]);

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(463);
__webpack_require__(464);
__webpack_require__(110);

angular.module('app.shared.clipSearch.filterFormDirective', ['app.shared.clipSearch.filterFormDirective.filterFormController', 'app.shared.datePickerPopup.datePickerPopupDirective', 'app.shared.searchdDropDown.searchDropDownDirective']).directive('clipSearchFilterForm', [function () {
  "use strict";

  return {
    restrict: 'E',
    templateUrl: 'components/shared/clipSearch/filterFormDirective/filterFormDirectiveView.html',
    controller: 'app.shared.clipSearch.filterFormDirective.filterFormController',
    scope: {
      filterData: '=',
      showPresetActions: '=?',
      defaultValue: '=?'
    }
  };
}]);

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(77);
__webpack_require__(8);
__webpack_require__(125);
__webpack_require__(73);
__webpack_require__(61);
__webpack_require__(78);

angular.module('app.shared.clipSearch.filterFormDirective.filterFormController', ['app.shared.clipSearchService', 'app.shared.clipCategoryService', 'app.shared.dateService', 'app.shared.leaguesService', 'app.shared.teamService', 'app.shared.clipSearch.clipFilterService']).controller('app.shared.clipSearch.filterFormDirective.filterFormController', ['$scope', 'app.shared.clipSearchService', 'app.shared.clipCategoryService', 'app.shared.dateService', 'app.shared.leaguesService', 'app.shared.teamService', '$q', 'app.shared.clipSearch.clipFilterService', '$filter', '$rootScope', function ($scope, clipSearchService, clipCategoryService, dateService, leaguesService, teamService, $q, clipFilterService, $filter, $rootScope) {
  "use strict";

  if (!$scope.filterData) {
    $scope.filterData = {
      filters: {},
      labels: {},
      preset: null
    };
  }
  $scope.showPresetActions = $scope.showPresetActions ? $scope.showPresetActions : null;
  $scope.defaultValue = $scope.defaultValue ? $scope.defaultValue : false;
  $scope.presetFilters = null;
  $scope.selectedPreset = null;
  $scope.categories = null;
  $scope.subcategories = null;
  $scope.strengths = null;
  $scope.seasons = null;
  $scope.leagues = null;
  $scope.opponentTeams = null;
  $scope.opponents = null;
  $scope.playerTeams = null;
  $scope.players = null;
  $scope.opponentPlayers = null;
  $scope.presetName = null;
  $scope.showPresetForm = false;
  $scope.deleteSelectedPreset = false;
  $scope.assignPresetFilters = true;
  $scope.filterCount = 0;
  $scope.clipCount = 0;
  $scope.disableSelections = false;

  $scope.getFilterTypeId = function (type) {
    switch (type) {
      case 'players':
        return 'id';
      case 'teams':
        return 'iteamid';
      case 'categories':
        return 'iclipcategoryid';
      case 'seasons':
        return 'id';
      case 'subcategories':
        return 'id';
      case 'strengths':
        return 'id';
      default:
        return 'id';
    }
  };

  $scope.customDataDisplay = function (type, datum) {
    switch (type) {
      case 'player':
        return '#' + datum.jersey_number + ' - ' + datum.team_abbrev + ' - ' + datum.label + ' (' + datum.season + ')';
      case 'preset':
        return 'QUICK FILTER: ' + datum.name;
      case 'season':
        return datum.year + ' Season';
    }
  };

  $scope.getSelectedFilters = function (filterArray, selectedIdsArray, type_id, is_grouped) {
    var ObjArray = [];

    if (!filterArray || !angular.isDefined(selectedIdsArray)) {
      return ObjArray;
    }

    if (is_grouped) {
      var temp = [];
      _.forEach(filterArray, function (array) {
        _.forEach(array, function (object) {
          temp.push(object);
        });
      });

      filterArray = temp;
    }

    _.forEach(selectedIdsArray, function (id) {
      var selectedObj = filterArray.find(function (obj) {
        return obj[type_id] === id;
      });

      if (selectedObj) {
        ObjArray.push(selectedObj);
      }
    });

    return ObjArray;
  };

  $scope.setFilterProperty = function (name, value) {
    switch (name) {
      case 'preset':
        $scope.selectedPreset = angular.copy(value);
        break;
      case 'date':
        $scope.filterData.filters.start_date = null;
        $scope.filterData.filters.end_date = null;
        delete $scope.filterData.labels['date-1'];
        break;
      case 'start_date':
      case 'end_date':
        $scope.filterData.filters[name] = value;
        break;
      case 'seasons':
        if (value === 'clear') {
          $scope.filterData.filters.seasons = [];

          for (var i in $scope.filterData.labels) {
            if ($scope.filterData.labels.hasOwnProperty(i)) {
              if (i.match(/^seasons-/)) {
                delete $scope.filterData.labels[i];
              }
            }
          }
        } else {
          var season_id = value.id;
          var label = $scope.customDataDisplay('season', value);

          if (!Array.isArray($scope.filterData.filters.seasons)) {
            $scope.filterData.filters.seasons = [];
          }

          var season_index = $scope.filterData.filters.seasons.indexOf(season_id);
          if (season_index > -1) {
            $scope.filterData.filters.seasons.splice(season_index, 1);
            delete $scope.filterData.labels['seasons-' + season_id];
          } else {
            $scope.filterData.filters.seasons.push(season_id);
            $scope.filterData.labels['seasons-' + season_id] = label;
          }
        }
        break;
      case 'players':
        if (value === 'clear') {
          $scope.filterData.filters.players = [];

          for (var _i in $scope.filterData.labels) {
            if ($scope.filterData.labels.hasOwnProperty(_i)) {
              if (_i.match(/^players-/)) {
                delete $scope.filterData.labels[_i];
              }
            }
          }
        } else {
          var player_id = value.id;
          var _label = $scope.customDataDisplay('player', value);

          if (!Array.isArray($scope.filterData.filters.players)) {
            $scope.filterData.filters.players = [];
          }

          var player_index = $scope.filterData.filters.players.indexOf(player_id);
          if (player_index > -1) {
            $scope.filterData.filters.players.splice(player_index, 1);
            delete $scope.filterData.labels['players-' + player_id];
          } else {
            $scope.filterData.filters.players.push(player_id);
            $scope.filterData.labels['players-' + player_id] = _label;
          }
        }
        break;

      case 'opponent_players':
        var player_found = false;
        if (value === 'clear') {
          $scope.filterData.filters.opponent_players = [];
          $scope.filterData.filters.opponent_player_teams = [];

          for (var _i2 in $scope.filterData.labels) {
            if ($scope.filterData.labels.hasOwnProperty(_i2)) {
              if (_i2.match(/^opponent_players-/)) {
                delete $scope.filterData.labels[_i2];
              }
            }
          }
        } else {
          var _player_id = value.id;
          var _label2 = $scope.customDataDisplay('player', value);
          var team_id = value.team_id;

          if (!Array.isArray($scope.filterData.filters.opponent_players)) {
            $scope.filterData.filters.opponent_players = [];
            $scope.filterData.filters.opponent_player_teams = [];
          }

          var team_index = $scope.filterData.filters.opponent_player_teams.indexOf(team_id);

          var _player_index = $scope.filterData.filters.opponent_players.indexOf(_player_id);
          if (_player_index > -1) {
            $scope.filterData.filters.opponent_players.splice(_player_index, 1);
            delete $scope.filterData.labels['opponent_players-' + _player_id];

            var players = $filter('filter')($scope.opponentPlayers.list, { team_id: team_id });

            _.forEach($scope.filterData.filters.opponent_players, function (player_id) {
              _.forEach(players, function (player) {
                if (player.id === player_id) {
                  player_found = true;
                }
              });
            });

            if (!player_found) {
              $scope.filterData.filters.opponent_player_teams.splice(team_index, 1);
            }
          } else {
            $scope.filterData.filters.opponent_players.push(_player_id);
            $scope.filterData.labels['opponent_players-' + _player_id] = _label2;

            if (team_index === -1) {
              $scope.filterData.filters.opponent_player_teams.push(team_id);
            }
          }
        }
        break;
      case 'categories':
        if (value === 'clear') {
          $scope.filterData.filters.categories = [];
          for (var _i3 in $scope.filterData.labels) {
            if ($scope.filterData.labels.hasOwnProperty(_i3)) {
              if (_i3.match(/^categories-/)) {
                delete $scope.filterData.labels[_i3];
              }
            }
          }
        } else {
          var category_id = value.iclipcategoryid;
          var _label3 = value.strclipcategory;

          if (!Array.isArray($scope.filterData.filters.categories)) {
            $scope.filterData.filters.categories = [];
          }

          var category_index = $scope.filterData.filters.categories.indexOf(category_id);
          if (category_index > -1) {
            $scope.filterData.filters.categories.splice(category_index, 1);
            delete $scope.filterData.labels['categories-' + category_id];
          } else {
            $scope.filterData.filters.categories.push(category_id);
            $scope.filterData.labels['categories-' + category_id] = _label3;
          }
        }
        break;

      case 'subcategories':
        if (value === 'clear') {
          $scope.filterData.filters.subcategories = [];
          for (var _i4 in $scope.filterData.labels) {
            if ($scope.filterData.labels.hasOwnProperty(_i4)) {
              if (_i4.match(/^subcategories-/)) {
                delete $scope.filterData.labels[_i4];
              }
            }
          }
        } else {
          var subcategory_id = value.id;
          var _label4 = value.subcategory;

          if (!Array.isArray($scope.filterData.filters.subcategories)) {
            $scope.filterData.filters.subcategories = [];
          }

          var subcategory_index = $scope.filterData.filters.subcategories.indexOf(subcategory_id);
          if (subcategory_index > -1) {
            $scope.filterData.filters.subcategories.splice(subcategory_index, 1);
            delete $scope.filterData.labels['subcategories-' + subcategory_id];
          } else {
            $scope.filterData.filters.subcategories.push(subcategory_id);
            $scope.filterData.labels['subcategories-' + subcategory_id] = _label4;
          }
        }
        break;

      case 'strengths':
        if (value === 'clear') {
          $scope.filterData.filters.strengths = [];
          for (var _i5 in $scope.filterData.labels) {
            if ($scope.filterData.labels.hasOwnProperty(_i5)) {
              if (_i5.match(/^strengths-/)) {
                delete $scope.filterData.labels[_i5];
              }
            }
          }
        } else {
          var strength_id = value.id;
          var _label5 = value.strength;

          if (!Array.isArray($scope.filterData.filters.strengths)) {
            $scope.filterData.filters.strengths = [];
          }

          var strength_index = $scope.filterData.filters.strengths.indexOf(strength_id);
          if (strength_index > -1) {
            $scope.filterData.filters.strengths.splice(strength_index, 1);
            delete $scope.filterData.labels['strengths-' + strength_id];
          } else {
            $scope.filterData.filters.strengths.push(strength_id);
            $scope.filterData.labels['strengths-' + strength_id] = _label5;
          }
        }
        break;
      case 'opponent_teams':
        if (value === 'clear') {
          $scope.filterData.filters.opponents = [];

          for (var _i6 in $scope.filterData.labels) {
            if ($scope.filterData.labels.hasOwnProperty(_i6)) {
              if (_i6.match(/^opponents-/)) {
                delete $scope.filterData.labels[_i6];
              }
            }
          }
        } else {
          var opponent_id = value.iteamid;
          var _label6 = value.label;

          if (!Array.isArray($scope.filterData.filters.opponents)) {
            $scope.filterData.filters.opponents = [];
          }

          var opponent_index = $scope.filterData.filters.opponents.indexOf(opponent_id);
          if (opponent_index > -1) {
            $scope.filterData.filters.opponents.splice(opponent_index, 1);
            delete $scope.filterData.labels['opponents-' + opponent_id];
          } else {
            $scope.filterData.filters.opponents.push(opponent_id);
            $scope.filterData.labels['opponents-' + opponent_id] = _label6;
          }
        }
        break;

      case 'my_teams':
        if (value === 'clear') {
          $scope.filterData.filters.my_teams = [];

          for (var _i7 in $scope.filterData.labels) {
            if ($scope.filterData.labels.hasOwnProperty(_i7)) {
              if (_i7.match(/^my_teams-/)) {
                delete $scope.filterData.labels[_i7];
              }
            }
          }
        } else {
          var my_team_id = value.iteamid;
          var _label7 = value.label;

          if (!Array.isArray($scope.filterData.filters.my_teams)) {
            $scope.filterData.filters.my_teams = [];
          }

          var my_team_index = $scope.filterData.filters.my_teams.indexOf(my_team_id);
          if (my_team_index > -1) {
            $scope.filterData.filters.my_teams.splice(my_team_index, 1);
            delete $scope.filterData.labels['my_teams-' + my_team_id];
          } else {
            $scope.filterData.filters.my_teams.push(my_team_id);
            $scope.filterData.labels['my_teams-' + my_team_id] = _label7;
          }
        }
        break;
    }

    switch (name) {
      case 'start_date':
      case 'end_date':
        var _label8 = '';
        var dateFormat = 'MMM. D, YYYY';

        if ($scope.filterData.filters.start_date) {
          _label8 += moment($scope.filterData.filters.start_date).format(dateFormat);
        }

        if ($scope.filterData.filters.end_date) {
          if ($scope.filterData.filters.start_date && !moment($scope.filterData.filters.start_date).isBefore(moment($scope.filterData.filters.end_date))) {
            alert("Start date filter must fall before selected end date.");
            $scope.filterData.filters.start_date = null;
          } else {
            if (_label8) {
              _label8 += ' - ';
            }
            _label8 += moment($scope.filterData.filters.end_date).format(dateFormat);
          }
        }

        $scope.filterData.labels['date-1'] = _label8;
        break;
    }
  };

  $scope.getTeams = function () {
    var deferred = $q.defer();

    teamService.getByAccess({ restrict_by_clips: true }).then(function (response) {
      var data = response.data;

      if (data.error) {
        alert(data.error);
        deferred.reject();
      } else {
        $scope.playerTeams = data;

        if (Array.isArray($scope.playerTeams) && $scope.playerTeams.length === 1) {
          $scope.setFilterProperty('my_teams', $scope.playerTeams[0]);
        }

        deferred.resolve();
      }
    });

    return deferred.promise;
  };

  $scope.getTeamOpponents = function () {
    var team_ids = $scope.filterData.filters.my_teams;
    var options = { filter_by: 'my-clips' };

    if (team_ids) {
      options.teams = team_ids.toString();
    }

    teamService.getTeamsOpponents(options).then(function (response) {
      var data = response.data;

      if (data.error) {
        alert(data.error);
        $scope.opponents = null;
      } else {
        $scope.opponents = {};
        if (Array.isArray(data) && data.length === 0) {
          $scope.opponents['message'] = 'No Opponents Found';
        } else {
          $scope.opponents = data;
        }
      }
    });
  };

  $scope.getTeamPlayers = function (group) {
    var team_ids = $scope.filterData.filters.my_teams;
    var season_ids = $scope.filterData.filters.seasons;
    var options = { filter_by: 'my-clips' };

    switch (group) {
      case 'opponent_player':
        //team_ids = $scope.filterData.filters.opponents;
        options.player_type = 'opponent';
        $scope.opponentPlayers = null;
        break;
      case 'player':
        options.player_type = 'my-player';
        $scope.players = null;
        break;
    }

    if (team_ids) {
      options.teams = team_ids.toString();
    }

    if (season_ids) {
      options.season_ids = season_ids.toString();
    }

    teamService.getTeamsPlayers(options).then(function (response) {
      var data = response.data;

      if (data.error) {
        alert(data.error);

        switch (group) {
          case 'opponent_player':
            $scope.opponentPlayers = null;
            break;
          case 'player':
            $scope.players = null;
            break;
        }
      } else {
        switch (group) {
          case 'opponent_player':
            $scope.opponentPlayers = {};
            if (Array.isArray(data) && data.length === 0) {
              $scope.opponentPlayers['message'] = 'No Players Found';
            } else {
              $scope.opponentPlayers = data;
              angular.forEach($scope.opponentPlayers, function (player) {
                player['playerbrief'] = player.jersey_number + ' ' + player.team_abbrev + ' ' + player.label + ' ' + player.season;
              });
            }
            break;
          case 'player':
            $scope.players = {};
            if (Array.isArray(data) && data.length === 0) {
              $scope.players['message'] = 'No Players Found';
            } else {
              $scope.players = data;
              angular.forEach($scope.players, function (player) {
                player['playerbrief'] = player.jersey_number + ' ' + player.team_abbrev + ' ' + player.label + ' ' + player.season;
              });
            }
            break;
        }
      }
    });
  };

  $scope.getStrengths = function () {
    var options = {
      filter_by: 'my-clips'
    };

    var category_ids = Array.isArray($scope.filterData.filters.categories) && $scope.filterData.filters.categories.length ? $scope.filterData.filters.categories : null;

    var subcategory_ids = Array.isArray($scope.filterData.filters.subcategories) && $scope.filterData.filters.subcategories.length ? $scope.filterData.filters.subcategories : null;

    if (category_ids) {
      options.categories = category_ids.toString();
    }

    if (subcategory_ids) {
      options.subcategories = subcategory_ids.toString();
    }

    if (options.hasOwnProperty('categories') || options.hasOwnProperty('subcategories')) {
      clipCategoryService.getSubcategoryStrengths(options).then(function (response) {
        var data = response.data;

        if (data.error) {
          alert(data.error);
          $scope.strengths = null;
        } else {
          $scope.strengths = {};
          if (Array.isArray(data) && data.length === 0) {
            $scope.strengths['message'] = 'No Strengths Found';
          } else {
            $scope.strengths['list'] = data;
          }
        }
      });
    } else {
      $scope.strengths = null;
    }
  };

  $scope.createPreset = function () {
    clipFilterService.createFilter($scope.presetName, $scope.filterData.filters).then(function (response) {
      var data = response.data;

      if (data.error) {
        alert(data.error);
      } else {
        getFilters(data);
        alert('Filter preset \'' + data.name + '\' saved!');
      }
    });

    $scope.presetName = null;
    $scope.togglePresetForm(false);
  };

  $scope.updatePreset = function () {
    if ($scope.selectedPreset) {
      $scope.selectedPreset.filters = angular.copy($scope.filterData.filters);
      $scope.selectedPreset.labels = angular.copy($scope.filterData.labels);

      if ($scope.selectedPreset.filters.hasOwnProperty('preset')) {
        delete $scope.selectedPreset.filters['preset'];
        delete $scope.selectedPreset.labels['preset'];
      }

      clipFilterService.updateFilter($scope.selectedPreset).then(function (response) {
        var data = response.data;

        if (data.error) {
          alert(data.error);
        } else {
          alert('Filter preset \'' + data.name + '\' updated!');
          $rootScope.$broadcast('update_preset_success', { canUpdatePresets: false });
          getFilters();
        }
      });
    }
  };

  $scope.deletePreset = function () {
    if ($scope.selectedPreset) {
      var r = confirm('Are you sure you want to delete the quick filter \'' + $scope.selectedPreset.name + '\'?');
      if (r === true) {
        clipFilterService.deleteFilter($scope.selectedPreset.id).then(function (response) {
          var data = response.data;

          if (data.error) {
            alert(data.error);
          } else {
            $scope.selectedPreset = null;
            if ($scope.filterData.filters.hasOwnProperty('preset')) {
              delete $scope.filterData.filters['preset'];
              delete $scope.filterData.labels['preset'];
            }
            getFilters();
          }
        });
      }
    }
  };

  $scope.cancelPreset = function () {
    $scope.presetName = null;
    $scope.togglePresetForm(false);
    //$scope.showPresetActions = false;
  };

  $scope.togglePresetForm = function (toggleOn) {
    if ($scope.filterCount) {
      if (typeof toggleOn === 'undefined') {
        $scope.showPresetActions = !$scope.showPresetActions;
      } else {
        $scope.showPresetActions = toggleOn;
      }

      if ($scope.selectedPreset) {
        $scope.selectedPreset = null;
      }
    }
  };

  var getFilters = function getFilters(assignSelectedPreset) {
    clipSearchService.retrieveFilters().then(function (response) {
      var data = response.data;

      if (data.error) {
        alert(data.error);
      } else {
        if (data) {
          $scope.presetFilters = data;

          if (assignSelectedPreset) {
            assignSelectedPreset = angular.isObject(assignSelectedPreset) ? assignSelectedPreset.id : assignSelectedPreset;
            _.forEach($scope.presetFilters, function (preset) {
              if (assignSelectedPreset === preset.id) {
                $scope.selectedPreset = preset;
              }
            });
          }
        } else {
          $scope.presetFilters = {};
        }
      }
    });
  };

  var init = function init() {
    if ($scope.filterData.filters.hasOwnProperty('preset')) {
      $scope.assignPresetFilters = false;
    }

    getFilters($scope.filterData.filters.hasOwnProperty('preset') ? $scope.filterData.filters.preset : null);

    clipCategoryService.getCategories({ filter_by: 'my-clips' }).then(function (response) {
      var data = response.data;

      if (data.error) {
        alert(data.error);
      } else {
        $scope.categories = data;
      }
    });

    clipCategoryService.getSubcategories({ filter_by: 'my-clips' }).then(function (response) {
      var data = response.data;

      if (data.error) {
        alert(data.error);
      } else {
        $scope.subcategories = data;
      }
    });

    if (dateService.seasonList.length) {
      dateService.clearList();
    }

    $scope.seasons = dateService.generateSeasonList(20, '2009-2010', 28);
    $scope.seasons.reverse();
    $scope.getTeams();
  };

  $scope.showPresetButtonSet = function (setName) {
    switch (setName) {
      case 'presetForm':
        return $scope.showPresetForm;
      case 'presetSelected':
        return !$scope.showPresetForm && $scope.selectedPreset && !$scope.deleteSelectedPreset;
      case 'deletePreset':
        return !$scope.showPresetForm && $scope.selectedPreset && $scope.deleteSelectedPreset;
      default:
        return !$scope.showPresetForm && !$scope.selectedPreset;
    }
  };

  $scope.buttonSetSize = function () {
    var x2 = $scope.showPresetButtonSet('presetForm') || $scope.showPresetButtonSet('presetSelected') || $scope.showPresetButtonSet('deletePreset');
    if (x2) {
      return '2x';
    } else {
      return '1x';
    }
  };

  $scope.$on('forward_filter_count', function (event, data) {
    $scope.filterCount = data.filterCount;
  });

  $scope.$on('forward_clip_count', function (event, data) {
    $scope.clipCount = data.clipCount;
    $scope.filterCount = data.filterCount;

    $scope.disableSelections = !$scope.clipCount && $scope.filterCount && !$scope.defaultValue;
  });

  $scope.$on('update_preset', function () {
    $scope.updatePreset();
  });

  $scope.$on('delete_preset', function () {
    $scope.deletePreset();
  });

  $scope.$on('clear_selected_preset', function () {
    $scope.selectedPreset = null;
  });

  $scope.$on('remove_player_opp_team', function (event, data) {
    var removed_player = $filter('filter')($scope.opponentPlayers.list, { id: data.player_id });
    var players = $filter('filter')($scope.opponentPlayers.list, { team_id: removed_player[0].team_id });
    var player_found = false;

    _.forEach($scope.filterData.filters.opponent_players, function (player_id) {
      _.forEach(players, function (player) {
        if (player.id === player_id) {
          player_found = true;
        }
      });
    });

    var team_index = $scope.filterData.filters.opponent_player_teams.indexOf(removed_player[0].team_id);

    if (!player_found) {
      $scope.filterData.filters.opponent_player_teams.splice(team_index, 1);
    }
  });

  $scope.$watch('selectedPreset', function () {
    if ($scope.filterData && $scope.selectedPreset && $scope.assignPresetFilters) {
      var tempFilter = {
        filters: { 'preset': $scope.selectedPreset.id },
        labels: { 'preset': $scope.customDataDisplay('preset', $scope.selectedPreset) }
      };

      tempFilter.filters = _.merge(tempFilter.filters, $scope.selectedPreset.filters);
      tempFilter.labels = _.merge(tempFilter.labels, $scope.selectedPreset.labels);

      $scope.filterData.filters = tempFilter.filters;
      $scope.filterData.labels = tempFilter.labels;
    }

    if ($scope.selectedPreset) {

      if (!$scope.assignPresetFilters) {
        $scope.assignPresetFilters = true;
      }
    } else {
      if ($scope.filterData.filters.hasOwnProperty('preset')) delete $scope.filterData.filters.preset;
      delete $scope.filterData.labels.preset;
    }
  });

  /*$scope.$watch(
    () => {
      return $scope.filterData.filters.opponents;
    },
    () => {
      $scope.getTeamPlayers('opponent_player');
    },
    true
  );*/

  $scope.$watch(function () {
    return $scope.filterData.filters.my_teams;
  }, function () {
    $scope.getTeamOpponents();

    if (angular.isDefined($scope.filterData.filters.my_teams) && $scope.filterData.filters.my_teams !== null && $scope.filterData.filters.my_teams.length) {
      $scope.getTeamPlayers('player');
      $scope.getTeamPlayers('opponent_player');
    } else {
      $scope.players = null;
      $scope.opponentPlayers = null;
    }
  }, true);

  $scope.$watch(function () {
    return $scope.filterData.filters.seasons;
  }, function () {

    if (angular.isDefined($scope.filterData.filters.my_teams) && $scope.filterData.filters.my_teams !== null && $scope.filterData.filters.my_teams.length) {
      $scope.getTeamPlayers('player');
      $scope.getTeamPlayers('opponent_player');
    }
  }, true);

  $scope.$watch(function () {
    return $scope.filterData.filters.categories;
  }, function () {

    if (angular.isDefined($scope.filterData.filters.categories) && $scope.filterData.filters.categories !== null && $scope.filterData.filters.categories.length) {
      $scope.getStrengths();
    } else {
      $scope.strengths = null;
    }
  }, true);

  $scope.$watch(function () {
    return $scope.filterData.filters.subcategories;
  }, function () {

    if (angular.isDefined($scope.filterData.filters.subcategories) && $scope.filterData.filters.subcategories !== null && $scope.filterData.filters.subcategories.length) {
      $scope.getStrengths();
    } else {
      $scope.strengths = null;
    }
  }, true);

  init();
}]);

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(465);

"use strict";

angular.module('app.shared.datePickerPopup.datePickerPopupDirective', ['app.shared.datePickerPopup.datePickerPopupController']).directive('datePickerPopup', [function () {
    return {
        restrict: 'AE',
        templateUrl: 'components/shared/datePickerPopup/datePickerPopupView.html',
        controller: 'app.shared.datePickerPopup.datePickerPopupController',
        controllerAs: 'vm',
        bindToController: {
            callback: '&',
            rangeStart: '@?',
            rangeEnd: '@?'
        },
        link: postLink,
        scope: {
            givenDate: '=?',
            startDate: '=?',
            disablePopup: '=?'
        }
    };

    function postLink(scope, iElement, iAttrs, vm) {
        scope.$watch(function () {
            return scope.dt;
        }, function (newValue) {
            if (angular.isDefined(newValue) && typeof vm.callback === 'function') {
                vm.callback({ $value: newValue });
            }
        }, true);
    }
}]);

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.shared.datePickerPopup.datePickerPopupController', []).controller('app.shared.datePickerPopup.datePickerPopupController', ['$scope', function ($scope) {
  $scope.rangeStart = $scope.rangeStart || null;
  $scope.rangeEnd = $scope.rangeEnd || null;
  $scope.givenDate = $scope.givenDate || null;
  $scope.startDate = $scope.startDate || null;
  $scope.disablePopup = $scope.disablePopup || null;
  $scope.dt = null;

  $scope.today = function () {
    $scope.dt = new Date();
  };

  $scope.clear = function () {
    $scope.dt = null;
  };

  $scope.dateOptions = {
    //dateDisabled: disabled,
    formatYear: 'yy',
    maxDate: $scope.rangeEnd !== null ? new Date($scope.rangeEnd) : new Date(2020, 11, 31),
    minDate: $scope.rangeStart !== null ? new Date($scope.rangeStart) : new Date(2008, 12, 1),
    startingDay: 1,
    showWeeks: false
  };

  // Disable weekend selection
  function disabled(data) {
    var date = data.date,
        mode = data.mode;
    return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
  }

  $scope.open1 = function () {
    $scope.popup1.opened = true;
  };

  /*$scope.setDate = function (year, month, day) {
    $scope.dt = month+'/'+day+'/'+year;//new Date(year, month, day);
  };*/

  $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
  $scope.format = $scope.formats[0];
  $scope.altInputFormats = ['M!/d!/yyyy', 'M!/d!/!yyyy'];

  $scope.popup1 = {
    opened: false
  };

  $scope.$on('clear_dates', function () {
    $scope.clear();
  });

  $scope.$watch(function () {
    return $scope.startDate;
  }, function () {
    $scope.dateOptions.initDate = $scope.startDate ? new Date($scope.startDate) : null;
  });

  $scope.$watch(function () {
    return $scope.givenDate;
  }, function () {
    if (typeof $scope.givenDate !== 'undefined') {
      $scope.clear();
      if (typeof $scope.givenDate === 'string') {
        $scope.givenDate = moment($scope.givenDate).toDate();
      }
      $scope.dt = $scope.givenDate;
    }
  });
}]);

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(467);

'use strict';

angular.module('app.rokuConnect', ['app.rokuConnect.rokuConnectController']).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.rokuConnect', {
        url: '/roku',
        templateUrl: 'components/rokuConnect/rokuConnectView.html',
        controller: 'app.rokuConnect.rokuConnectController',
        fullWidth: true
    });
}]);

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(468);

"use strict";

angular.module('app.rokuConnect.rokuConnectController', ['app.rokuConnect.rokuConnectService']).controller('app.rokuConnect.rokuConnectController', ['$scope', 'app.rokuConnect.rokuConnectService', function ($scope, rokuConnect) {
    $scope.error = null;
    $scope.message = null;
    $scope.rokuPin = null;

    $scope.link = function () {
        $scope.error = null;
        $scope.message = null;

        rokuConnect.validatePin($scope.rokuPin).then(function (response) {
            if (response.data.error) {
                $scope.error = response.data.error;
            }

            if (response.status === 204) {
                $scope.rokuPin = null;
                $scope.message = 'Roku connected successfully';
            }
        });
    };
}]);

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.rokuConnect.rokuConnectService', []).factory('app.rokuConnect.rokuConnectService', ['$http', function ($http) {
    return {
        validatePin: function validatePin(pin) {
            return $http.put(window.location.api('roku'), { pin: pin });
        }
    };
}]);

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.brand', []).config(['$stateProvider', function ($stateProvider) {
  return $stateProvider.state('app.brand', {

    templateUrl: 'components/brand/brandView.html',

    controller: ['$scope', '$window', function ($scope, $window) {
      $scope.logoEpsDownload = function (url) {
        $window.open(url);
      };
    }],

    url: '/corporate-brand',
    title: 'Logo Usage Guidelines',
    noSidebar: true,
    noTopControls: true,
    params: { obj: null }
  });
}]);

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(471);
__webpack_require__(472);

angular.module('app.changeEmail', ['app.changeEmail.changeEmailController', 'app.changeEmail.changeEmailVerifyController']).config(['$stateProvider', function ($stateProvider) {
  "use strict";

  $stateProvider.state('app.changeEmail', {
    url: '/change_email',
    template: '<ui-view></ui-view>',
    controller: ['$state', '$stateParams', function ($state, $stateParams) {
      if ($state.is('app.changeEmail')) {
        $state.go('app.changeEmail.request', $stateParams);
      }
    }]
  }).state('app.changeEmail.request', {
    url: '/request',
    templateUrl: 'components/changeEmail/changeEmailView.html',
    controller: 'app.changeEmail.changeEmailController'
  }).state('app.changeEmail.sent', {
    url: '/sent',
    params: {
      email: null
    },
    templateUrl: 'components/changeEmail/changeEmailSent/changeEmailSentView.html',
    controller: ['$scope', '$stateParams', function ($scope, $stateParams) {
      $scope.email = $stateParams.email;
    }]
  }).state('app.changeEmail.verify', {
    url: '/verify/:hash',
    templateUrl: 'components/changeEmail/changeEmailVerify/changeEmailVerifyView.html',
    controller: 'app.changeEmail.changeEmailVerifyController'
  });
}]);

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1);

angular.module('app.changeEmail.changeEmailController', ['app.currentUser']).controller('app.changeEmail.changeEmailController', ['$scope', 'currentUser', '$state', 'appMetaService', function ($scope, currentUser, $state, appMeta) {
  "use strict";

  $scope.old_email = null;
  $scope.new_email = null;
  $scope.current_password = null;
  $scope.error = null;
  $scope.appMeta = appMeta;

  $scope.submitRequest = function () {
    currentUser.change_email($scope.old_email, $scope.new_email, $scope.current_password).then(function (response) {
      var data = response.data;

      if (data.error) {
        $scope.error = data.error;
      }
      if (data.email) {
        $state.go('app.changeEmail.sent', { email: data.email });
      }
    });
  };
}]);

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(473);
__webpack_require__(1);

angular.module('app.changeEmail.changeEmailVerifyController', ['app.changeEmail.changeEmailService', 'app.currentUser']).controller('app.changeEmail.changeEmailVerifyController', ['$scope', '$stateParams', 'app.changeEmail.changeEmailService', '$state', 'currentUser', function ($scope, $stateParams, changeEmailService, $state, currentUser) {
  "use strict";

  $scope.old_email = null;
  $scope.new_email = null;
  $scope.current_password = null;
  $scope.error = null;

  var init = function init() {
    changeEmailService.getFromHash($stateParams.hash).then(function (response) {
      var data = response.data;

      if (data.error) {
        alert(data.error);
      }

      if (data.email) {
        $scope.new_email = data.email;
      }
    });
  };

  $scope.submitRequest = function () {
    changeEmailService.confirmChange($stateParams.hash, $scope.old_email, $scope.current_password, $scope.new_email).then(function (response) {
      var data = response.data;

      if (data.error) {
        $scope.error = data.error;
      }

      if (data.email) {
        currentUser.logout();
        $state.go('app.login', {
          autoLogin: true,
          login_name: data.email,
          password: $scope.current_password,
          redirect: 'app.home'
        });
      }
    });
  };

  init();
}]);

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1);

angular.module('app.changeEmail.changeEmailService', ['app.currentUser']).factory('app.changeEmail.changeEmailService', ['$http', 'currentUser', function ($http) {
  "use strict";

  return {
    confirmChange: function confirmChange(hash, old_email, current_password, new_email) {
      return $http.put(window.location.api('sessions/change_email_confirmed'), {
        hash: hash,
        old_email: old_email,
        current_password: current_password,
        new_email: new_email
      });
    },
    getFromHash: function getFromHash(hash) {
      return $http.get(window.location.api('sessions/change_email/' + hash));
    }
  };
}]);

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.sessionTimeout', []).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('app.sessionTimeout', {
        templateUrl: 'components/sessionTimeout/sessionTimeoutView.html',
        controller: ['$stateParams', '$scope', '$location', function ($stateParams, $scope, $location) {
            $scope.stateParams = $stateParams;
            $scope.openUrl = function (url) {
                $location.url(url);
            };
        }],

        title: 'Session Timeout',
        noSidebar: true,
        noTopControls: true
    });
}]);

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(476);

"use strict";

angular.module('app.broadcastStatus', ['app.broadcastStatus.broadcastStatusController']).config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state('app.broadcastStatus', {
    url: '/status',
    templateUrl: 'components/broadcastStatus/broadcastStatusView.html',
    controller: 'app.broadcastStatus.broadcastStatusController',
    title: 'Broadcast Status'
  });
}]);

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(477);

"use strict";

angular.module('app.broadcastStatus.broadcastStatusController', ['app.broadcastStatus.broadcastStatusListService']).controller('app.broadcastStatus.broadcastStatusController', ['$scope', 'app.broadcastStatus.broadcastStatusListService', 'PRODUCT', function ($scope, broadcastStatusList, product) {

    $scope.productName = product.Name;

    $scope.broadcastStatusList = broadcastStatusList;

    broadcastStatusList.retrieve();
}]);

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.broadcastStatus.broadcastStatusListService', []).factory('app.broadcastStatus.broadcastStatusListService', ['$http', function ($http) {
  "use strict";

  var service = {
    list: null,
    error: null,
    isLoading: true,

    retrieve: function retrieve() {

      service.list = null;
      service.error = null;
      service.isLoading = true;

      return $http.get(window.location.api('games_status')).then(function (response) {

        var data = response.data;
        service.list = null;

        if (data.error) {
          service.error = data.error;
        }

        if (data.length) {
          service.list = data;
        }

        service.isLoading = false;
      },
      /**
       * @param {HttpResponse} response
       */
      function (response) {
        var data = response.data;

        if (data && data.error) {
          service.error = data.error;
        } else {
          service.error = 'Failed to retrieve broadcast status listing.';
        }

        service.isLoading = false;
      });
    }
  };

  return service;
}]);

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.howToWatch', []).config(['$stateProvider', 'PRODUCT', function ($stateProvider, product) {

  var logTemplate = 'components/howToWatch/howToWatchView.html';
  if (product.Code != 'htv') {
    logTemplate = 'assets/templates/' + product.Code + '/howToWatch/howToWatchView.html';
  }

  $stateProvider.state('app.howToWatch', {
    url: '/how-to-watch',
    templateUrl: logTemplate,
    title: 'How to Watch'
  });
}]);

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(480);

"use strict";

angular.module('app.promo', ['app.promo.promoController']).config(['$stateProvider', 'PRODUCT', function ($stateProvider, product) {

  var logTemplate = 'components/promo/promoView.html';

  $stateProvider.state('app.promo', {
    url: '/under-the-tree',
    templateUrl: logTemplate,
    controller: 'app.promo.promoController',
    title: 'HockeyTV Under The Tree',
    noSidebar: true,
    noTitleBar: true
  });
}]);

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(10);

"use strict";

angular.module('app.promo.promoController', ['app.appMetaService']).controller('app.promo.promoController', ['$scope', '$http', 'STRIPE_PUBLIC_KEY', 'appMetaService', function ($scope, $http, stripePublicKey, appMeta) {
  $scope.appMeta = appMeta;

  //true to show offer and false for successful payment
  $scope.showOffer = true;

  //turn off Buy button on Dec 24th at 2pm
  $scope.showPromoBtn = function () {
    var showBuyBtn = false;
    var today = new Date();
    var endDate = new Date('2018-12-24T14:00:00');
    if (today <= endDate) {
      showBuyBtn = true;
    }
    return showBuyBtn;
  };

  var handler = StripeCheckout.configure({
    key: stripePublicKey,
    image: 'https://stripe.com/img/documentation/checkout/marketplace.png',
    locale: 'auto',
    token: function token(_token) {
      var postData = {
        "stripeToken": _token.id,
        "stripeEmail": _token.email,
        "stripeName": _token.card.name
      };

      // Make the call to the API to make the payment
      $http.post(window.location.api('subscriptions/stripe'), postData).then(
      // success callback
      function (response) {
        if (response.status >= 200 && response.status <= 299) {
          $scope.showOffer = false;
        } else {
          alert("Something went wrong with your payment. Please refresh this page and try again later.");
        }
      },
      // error callback
      function (response) {
        alert("Something went wrong with your payment. Please refresh this page and try again later.");
      });
    }
  });

  $scope.openStripeHandler = function ($event) {
    // Open Checkout with further options:
    handler.open({
      name: 'HockeyTech USA LLC',
      description: 'HockeyTV Christmas Gift Subscription',
      amount: 5999,
      billingAddress: true,
      zipCode: true
    });
    $event.preventDefault();
  };

  // Close Checkout on page navigation:
  window.addEventListener('popstate', function () {
    handler.close();
  });
}]);

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(482);

"use strict";

angular.module('app.redeemPromo', ['app.redeemPromo.redeemPromoController']).config(['$stateProvider', 'PRODUCT', function ($stateProvider, product) {

  var redeemPromoTemplate = 'components/promo/redeemPromoView.html';

  $stateProvider.state('app.redeemPromo', {
    url: '/redeem-promo',
    templateUrl: redeemPromoTemplate,
    controller: 'app.redeemPromo.redeemPromoController',
    title: 'Redeem Promotion Code',
    noSidebar: false,
    noTitleBar: false
  });
}]);

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1);
__webpack_require__(483);

"use strict";

angular.module('app.redeemPromo.redeemPromoController', ['app.currentUser', 'app.redeemPromo.redeemPromoService', 'app.productService']).controller('app.redeemPromo.redeemPromoController', ['$scope', '$state', 'currentUser', 'app.redeemPromo.redeemPromoService', 'app.productService', 'app.shared.teamService', function ($scope, $state, currentUser, redeemPromoService, productService, teamService) {
  $scope.has_active_subscription = currentUser.has_active_subscription();
  $scope.teamChecked = false;
  $scope.useTeamSelect = false;
  $scope.planTeams = [];
  $scope.planTeam = { team: null };
  $scope.promoPlan = null;

  var init = function init() {
    if (!currentUser.is_logged_in()) {
      $scope.showAuthButtons = true;
    }
  };

  $scope.getPromoPlan = function () {
    redeemPromoService.retrievePlanFromPromo($scope.promo_code).then(function (data) {
      $scope.promoPlan = data.plan;

      if (productService.planUsesTeams($scope.promoPlan) && !$scope.promoPlan.promotion.team_id) {
        teamService.getTeams().then(function (response) {
          var data = response.data;

          if (data) {
            if (data.error) {
              alert(data.error);
            } else {
              $scope.planTeams = data;
              $scope.useTeamSelect = true;
              $scope.apply();
            }
          }
        });
      } else {
        $scope.useTeamSelect = false;
        $scope.planTeams = [];
        $scope.planTeam = { team: null };
      }
    });
  };

  $scope.redeem = function () {

    if (currentUser.is_logged_in()) {
      var params = { plan: $scope.promoPlan };

      if ($scope.promoPlan.promotion && $scope.promoPlan.promotion.team_id) {
        params.team = $scope.promoPlan.promotion.team_id;
      } else if ($scope.useTeamSelect) {
        params.team = $scope.planTeam.team.iteamid;
      }

      var redirect_info = {
        redirect_url: 'app.purchase.billingInfo',
        redirect_params: params
      };

      if (!currentUser.checkUserInfo(redirect_info)) {
        $state.go('app.purchase.billingInfo', params);
      }
    }
  };

  init();
}]);

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1);

angular.module('app.redeemPromo.redeemPromoService', ['app.currentUser']).factory('app.redeemPromo.redeemPromoService', ['$http', '$httpParamSerializerJQLike', '$q', 'currentUser', '$rootScope', function ($http, $httpParamSerializerJQLike, $q, currentUser, $rootScope) {
  'use strict';

  var promotion = {
    plan: null,
    error: null,
    retrievePlanFromPromo: function retrievePlanFromPromo(promo_code) {
      if (promotion.plan) {
        promotion.plan = null;
      }

      var deferred = $q.defer();

      $http.get(window.location.api('promotions/plan_by_promo_code/' + promo_code)).then(function (response) {
        var data = response.data;
        data.status = response.status;
        var resolve_now = true;

        if (data) {
          promotion.plan = data;

          if (currentUser.subscriptions.recurly) {
            for (var i = 0; i < promotion.plan.length; i++) {
              if (currentUser.subscriptions.recurly.plan_code === promotion.plan[i].plan_code) {
                promotion.plan.splice(i, 1);
              }
            }
          }

          if (data.error) {
            resolve_now = false;

            promotion.error = data.error;
            deferred.reject(data);
          } else {
            promotion.error = null;
          }
        }

        if (resolve_now) {
          deferred.resolve(data);
        }
      });

      return deferred.promise;
    }
  };
  return promotion;
}]);

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.stickyHeightDirective', []).directive('stickyHeight', function () {
  return {
    restrict: 'AE',
    link: function link(scope, element) {
      scope.$watch(function () {
        element.css('min-height', Math.max(25, element.height()));
      });
    }
  };
});

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('app.doubleHorizontalScrollDirective', []).directive('doubleHorizontalScroll', ['$timeout', function ($timeout) {
  return {
    restrict: 'A',

    scope: {
      controlledScroll: '@',
      verticalScrollContainer: '@',
      clipsBodyContainer: '@'
    },

    link: function link($scope, iElm, iAttrs, controller) {
      iElm.scroll(function () {
        $($scope.controlledScroll).scrollLeft(iElm.scrollLeft());
      });

      $($scope.controlledScroll).scroll(function () {
        iElm.scrollLeft($($scope.controlledScroll).scrollLeft());
      });

      $timeout(function () {
        if (angular.isDefined($scope.verticalScrollContainer)) {
          var showScrollBar = $($scope.clipsBodyContainer).height() > $($scope.verticalScrollContainer).height();
          $($scope.verticalScrollContainer).css({
            'height': showScrollBar ? '700px' : 'auto',
            'margin-right': showScrollBar ? '-25px' : '0'
          });
        }
      }, 3000);
    }
  };
}]);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.bundle.917ae4714aa9022b89af.js